export const QUESTIONS = [
    {
       "id":1,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"How many broadcast domains are present in the network in the following exhibit?<img src='/question_assets/ccna/1_image1.png'></img>",
       "choice_a":"One broadcast domain",
       "choice_b":"Two broadcast domains",
       "choice_c":"Three broadcast domains",
       "choice_d":"Seven broadcast domains",
       "correct_answer":"A",
       "explanation":"In the exhibit, only one broadcast domain exists because a PC on the left hub can send an ARP request and the PC on the right hub can hear it. If you wanted to create multiple broadcast domains, you would need to create VLANs and route them. Two, three, and seven broadcast domains could be achieved by creating additional VLANs and router on a stick with the router between the VLANs."
    },
    {
       "id":2,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"How many potential collision domains are present in the network in the following exhibit? <img src='/question_assets/ccna/1_image2.png'></img>",
       "choice_a":"One collision domain",
       "choice_b":"Two collision domains",
       "choice_c":"Three collision domains",
       "choice_d":"Seven collision domains",
       "correct_answer":"C",
       "explanation":"In the exhibit, there are three collision domains present. Keep in mind that a collision domain is a network segment in which a collision can occur and the colliding frame is created. A switch will create collision segmentation as seen in the exhibit. There is one giant broadcast domain, but this is not going to affect collisions. You could argue that only two collision domains exist on both of the hubs. However, you would assume that the router and switch were configured full-duplex, avoiding collisions. So it always assumed that half-duplex communications is in operation, because it is possible. Seven collision domains is a wrong answer. <img src='/question_assets/ccna/1_image3.png'></img>"
    },
    {
       "id":3,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"Which statement is true about collision domains?",
       "choice_a":"All computers in the collision domain have the potential to have a frame collision.",
       "choice_b":"All computers in the collision domain have the potential to receive layer 2 broadcast messages.",
       "choice_c":"All computers in the collision domain have the potential to receive layer 3 broadcast messages.",
       "choice_d":"All computers in the collision domain are set to 10 Mb/s full-duplex.",
       "correct_answer":"A",
       "explanation":"A collision domain is defined as a group of computers that can potentially have a frame collision. Adding switches that can negotiate full-duplex and forward/filter fixes these issues. The potential of receiving layer 2 and layer 3 broadcast messages can increase the number of collisions. Layer 2 and layer 3 broadcasts do not create collision domains since unicast messages can also cause collisions. It is more common to see computers in collision domains set to 10 Mb/s half-duplex, not full-duplex."
    },
    {
       "id":4,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":4,
       "question":"In the following exhibit, which would be true if the hub was replaced with a switch? <img src='/question_assets/ccna/1_image4.png'></img>",
       "choice_a":"The number of collision domains would increase.",
       "choice_b":"The number of collision domains would decrease.",
       "choice_c":"The number of broadcast domains would increase.",
       "choice_d":"The number of broadcast domains would decrease.",
       "correct_answer":"A",
       "explanation":"Currently all of the computers are within one giant collision domain. Replacing the hub with a switch will create four separate potential collision domains. Switches create micro-segmentation, which increases the number of collision domains and increases bandwidth. The number of collision domains would only decrease if you swapped a switch for a hub, thus creating one collision domain. The number of broadcast domains would be unaffected using either a switch or a hub unless a router was used for routing between VLANs."
    },
    {
       "id":5,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":5,
       "question":"Considering the following exhibit, which of the following is a correct statement? <img src='/question_assets/ccna/1_image5.png'></img>",
       "choice_a":"One collision domain exists with one broadcast domain.",
       "choice_b":"Two collision domains exist with one broadcast domain.",
       "choice_c":"Three collision domains exist with two broadcast domains",
       "choice_d":"Seven collision domains exist with two broadcast domains.",
       "correct_answer":"C",
       "explanation":"In the exhibit there are two broadcast domains, VLAN 1 and VLAN 2. In each of the broadcast domains there exists a single collision domain, along with the collision domain between the switch and router. Therefore, three collision domains exist with two broadcast domains. One collision domain with one broadcast domain would only be true if the switch was replaced with a hub and VLANs were not used. Two collision domains with one broadcast domain would only be true if the hubs were directly connected together and VLAN routing was not in use. Seven collision domains existing with two broadcast domains would only be true if the hubs were swapped out for switches. <img src='/question_assets/ccna/1_image6.png'></img>"
    },
    {
       "id":6,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"Which component acts as a distribution switch for the physical data center?",
       "choice_a":"Top of Rack switch",
       "choice_b":"End of Row switch",
       "choice_c":"Core switch",
       "choice_d":"Virtual switch",
       "correct_answer":"B",
       "explanation":"The End of Row (EoR) switch acts as a distribution switch for the Top of Rack (ToR) switches. A ToR switch will sit at the top of the rack and create an access method for all the equipment in the rack. <italic>Core switch</italic> is a term used for the aggregation and core switching functions of all the distribution switches. <italic>Virtual switch</italic> is a term used for switching inside of a hypervisor, in which software switching occurs."
    },
    {
       "id":7,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"Which advantage(s) are gained using switches?",
       "choice_a":"Low latency",
       "choice_b":"Software switching",
       "choice_c":"High cost",
       "choice_d":"All of the above",
       "correct_answer":"A",
       "explanation":"Switches allow for low latency because frames are forwarded with ASIC hardware-based switching and have low cost. Software switching is only used by legacy bridges and virtual switches. Software switching can actually create latency. Using a switch lowers the cost (latency); it does not raise the cost."
    },
    {
       "id":8,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"Which is a correct statement when hubs are replaced with switches?",
       "choice_a":"The replacement increases collision domains.",
       "choice_b":"The replacement decreases collision domains.",
       "choice_c":"The replacement increases broadcast domains.",
       "choice_d":"The replacement decreases broadcast domains.",
       "correct_answer":"A",
       "explanation":"The replacement of hubs with switches increases collision domains and effectively increases bandwidth. The replacement of switches with hubs can decrease the number of collision domains, creating a much larger collision domain. The replacement of hubs with switches has no effect on broadcast domains. Broadcast domains would only be affected if a router was introduced."
    },
    {
       "id":9,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":4,
       "question":"Which is a function of a layer 2 switch?",
       "choice_a":"Forwarding the data based upon logical addressing",
       "choice_b":"Repeating the electrical signal to all ports",
       "choice_c":"Learning the MAC address by examining the destination MAC addresses",
       "choice_d":"Determining the forwarding interfaces based upon the destination MAC address and tables",
       "correct_answer":"D",
       "explanation":"Switches learn MAC addresses based upon incoming ports and examination of the source MAC address. It will build a MAC address table for future lookups. It then determines forwarding interfaces based upon the destination MAC address contained in the frame. Forwarding of data is based upon physical addresses \u0022burned\u0022 into the network interface card (NIC) called MAC addresses. Repeating electrical signals to all ports describes how a dumb hub would operate. MAC addresses are learned by the source MAC address on incoming frames to the switch, not the destination frames."
    },
    {
       "id":10,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":5,
       "question":"What is a reason a network administrator would segment a network with a switch?",
       "choice_a":"Create more broadcast domains",
       "choice_b":"Create isolation of ARP messages",
       "choice_c":"Create less collision domains",
       "choice_d":"Isolate traffic between segments",
       "correct_answer":"D",
       "explanation":"A switch creates micro-segmentation, which in turns isolates traffic between two talking computers from other computers that are not part of the communications. This in turn increases bandwidth for the computers that are not part of the communications between the two talking computers. The creation of broadcast domains can only be achieved with the addition of VLANs and a router. The isolation of ARP messages can only be achieved by the creation of broadcast domains. Segmentation with a switch will create more collision domains, not fewer collision domains."
    },
    {
       "id":11,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"What is the maximum wire speed of a single port on a 48-port Gigabit Ethernet switch?",
       "choice_a":"1,000 Mb/s",
       "choice_b":"2 Gb/s",
       "choice_c":"48 Gb/s",
       "choice_d":"96 Gb/s",
       "correct_answer":"A",
       "explanation":"Wire speed of a single port on a 48-port gigabit switch would be 1 Gb/s, or 1,000 Mb/s. Theoretically, a port can transmit and receive simultaneously 1 Gb/s, but wire speed refers to a single direction. The wire speed of the entire switch (backplane) could be 48 Gb/s for a 48-port Gigabit Ethernet switch, although the backplane is usually oversubscribed on access layer switching."
    },
    {
       "id":12,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"Which statement describes the micro-segmentation that a switch provides?",
       "choice_a":"All of the ports on the switch create a single collision domain",
       "choice_b":"Each port on the switch segments broadcasts",
       "choice_c":"Each port on the switch creates its own collision domain",
       "choice_d":"Each port on the switch creates an isolation for layer 2 broadcasts.",
       "correct_answer":"C",
       "explanation":"Each port on a switch creates its own collision domain. An increase in collision domains raises bandwidth since each port creates its own segment (micro-segmentation) and isolates possible collisions on other ports. All the ports on a hub will create a single collision domain, in which a signal from one computer can and will collide with another. Each port on the switch will not segment broadcasts unless each port is assigned a different VLAN, which is not common practice. Although each port on a switch will create a collision domain, it does not stop layer 2 broadcasts from being forwarded to all ports."
    },
    {
       "id":13,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"Given the information in the following exhibit, which statement is true when Computer A needs to communicate with Computer F? <img src='/question_assets/ccna/1_image7.png'></img>",
       "choice_a":"Switch A and Switch B will flood the frame across all ports",
       "choice_b":"Only Switch A will flood the frame across all ports",
       "choice_c":"Only Switch B will flood the frame across all ports",
       "choice_d":"Switch A will flood the frame across all ports, Switch B will forward traffic only to Computer F\u0027s port",
       "correct_answer":"B",
       "explanation":"Since the MAC address table is empty on Switch A, Switch A will flood the frame to all ports on the switch. This will include the router attached to interface Fa0/3. However, a router does not perform forward/filter decisions, so the frame will not be flooded any further on Router A. Switch A will forward the frame to all ports, but the router will not forward the frame onto the segment where Switch B is located. Switch B will never see the frame from Switch A because Router A segments the two networks."
    },
    {
       "id":14,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":1,
       "question":"When firewalls are placed in a network, which zone contains Internet-facing services?",
       "choice_a":"Outside zone",
       "choice_b":"Enterprise network zone",
       "choice_c":"Demilitarized zone",
       "choice_d":"Inside zone",
       "correct_answer":"C",
       "explanation":"The demilitarized zone (DMZ) is where Internet-facing servers/services are placed. The outside zone is where the public Internet connection is connected and it is the least trusted. The enterprise network zone is considered the inside zone. The inside zone is considered to be the highest trusted network because it is the internal network that you control."
    },
    {
       "id":15,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"According to best practices, what is the proper placement of a firewall?",
       "choice_a":"Only between the internal network and the Internet",
       "choice_b":"At key security boundaries",
       "choice_c":"In the DMZ",
       "choice_d":"Only between the DMZ and the Internet",
       "correct_answer":"B",
       "explanation":"Firewalls should always be placed at key security boundaries, which can be the Internet and your internal network. However, proper placement is not exclusive to the boundaries of the Internet and internal networks. For example, it could be placed between two internal networks, such as R&D and guest networks. The demilitarized zone (DMZ) is a segment of a firewall where Internet-facing services are placed. Firewalls are normally not placed only between the DMZ and the Internet because most networks have an internal network."
    },
    {
       "id":16,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":4,
       "question":"Which is a false statement about firewalls?",
       "choice_a":"Firewalls can protect a network from external attacks",
       "choice_b":"Firewalls are commonly deployed to protect a network from internal attacks",
       "choice_c":"Firewalls can provide stateful packet inspection",
       "choice_d":"Firewalls can control application traffic",
       "correct_answer":"B",
       "explanation":"Firewalls are not commonly deployed to provide protection from internal attacks on internal resources. They are designed to protect networks from external attacks or attacks emanating from the outside or directed toward the Internet. Firewalls normally provide stateful packet inspection. Firewalls can also control application traffic by port number and higher-layer attributes."
    },
    {
       "id":17,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":5,
       "question":"Which of the following statements does not represent the logical  management of a firewall?",
       "choice_a":"All physical access to the firewall should be tightly controlled.",
       "choice_b":"All firewall policies should be documented",
       "choice_c":"Firewall logs should be regularly monitored",
       "choice_d":"Firewalls should allow traffic by default and deny traffic explicitly.",
       "correct_answer":"A",
       "explanation":"All physical access to a firewall should be controlled tightly so that it is not tampered with, which could allow external threats to enter the network. This control should include vendors and approved administrators. Physical access to the firewall is a security principle and therefore not a consideration for the management of a firewall. All firewall policies should be documented as a part of the firewall management processes. Firewall logs should be regularly monitored for suspicious activity as part of the firewall management processes. Firewalls can allow or deny traffic by default; this is a consideration when managing a firewall."
    },
    {
       "id":18,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"What is the reason firewalls are considered stateful?",
       "choice_a":"Firewalls keep track of the zone states.",
       "choice_b":"Firewalls keep accounting on the state of packets",
       "choice_c":"Firewalls track the state of a TCP conversation",
       "choice_d":"Firewalls transition between defense states",
       "correct_answer":"C",
       "explanation":"Firewalls keep track of the TCP conversation before and after the three-way handshake. This is done so that a an attack on the TCP/UDP flow is not executed; in addition, DoS attacks can be thwarted, such as a SYN flood. <italic>Zone state</italic> is terminology that is used with firewalls; therefore, it is an incorrect answer. Firewalls do not protect by keeping statistics or accounting information for the state of packets. Firewalls do not transition between defense states."
    },
    {
       "id":19,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"You have an Adaptive Security Appliance (ASA) and two separate Internet connections via different providers. How could you apply the same policies to both connections?",
       "choice_a":"Place both connections into the same zone",
       "choice_b":"Place each connection into an ISP zone.",
       "choice_c":"Apply the same ACL to both of the interfaces",
       "choice_d":"Each connection must be managed separately",
       "correct_answer":"A",
       "explanation":"ASA allow for zones to be created and the connections applied to the zones. This methodology allows for security rules to be applied uniformly to the outside zone. There is no such thing as an ISP zone. You can apply an ACL to the zone but not directly to the interface. Each connection can be managed by a group once it is added to the same zone."
    },
    {
       "id":20,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"Why should servers be placed in the DMZ?",
       "choice_a":"To allow unrestricted access by Internet clients",
       "choice_b":"To allow access to the Internet and the internal network",
       "choice_c":"To allow the server to access the Internet",
       "choice_d":"To restrict the server to the Internet",
       "correct_answer":"B",
       "explanation":"Servers should be placed in the DMZ so they can access both the inside zone and outside zone. This will allow a server such as a web server to allow client access from the Web (outside). Rules could also be applied so that the server (for example, a database server) could allow access to data from within the internal network (inside). By placing the servers into the DMZ, it will give you the flexibility to apply rules for external access on the Internet and rules for internal access on the internal network."
    },
    {
       "id":21,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":4,
       "question":"Which type of device will detect but not prevent unauthorized access?",
       "choice_a":"Firewall",
       "choice_b":"IPS",
       "choice_c":"IDS",
       "choice_d":"Honeypots",
       "correct_answer":"C",
       "explanation":"An IDS, or intrusion detection system, will detect unauthorized access. However, it will not prevent unauthorized access. It is a form of audit control in a network. A firewall will protect your network from attack by placing rules on connection as to how people can connect as well as which traffic can pass. An intrusion protection system (IPS) will detect the presence of an intrusion and alert an administrator. A honey pot will attract a malicious user so that their tactics can be observed. It performs this function by diverting the malicious user from production systems to the honey pot, which is a sacrificial system."
    },
    {
       "id":22,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":5,
       "question":"Which term describes what it is called when more than one wireless access point (WAP) covers the same SSID?",
       "choice_a":"Broadcast domain",
       "choice_b":"Basic service set",
       "choice_c":"Extended server set",
       "choice_d":"Wireless mesh",
       "correct_answer":"C",
       "explanation":"When more than one WAP covers the same SSID, it is called an extended service set (ESS). A wireless LAN (WLAN) controller coordinates the cell or coverage area so the same SSID is on two different channels. A broadcast domain is one single layer 3 broadcast network in which layer 3 broadcasts will traverse. A basic service set (BSS) is used when a WAP covers a single SSID, such as wireless in your home. A wireless mesh is used when an Ethernet cable cannot be run to each WAP. The WAPs will use one frequency to connect to each other for the backhaul of the data while using another frequency to serve clients."
    },
    {
       "id":23,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"Which protocol allows a Lightweight AP (LWAP) to forward data to the wired LAN?",
       "choice_a":"Spanning Tree Protocol (STP)",
       "choice_b":"Bridge Protocol Data Units (BPDUs)",
       "choice_c":"Orthogonal Frequency Division Multiplexing (OFDM)",
       "choice_d":"Control and Provisioning of Wireless Access Points (CAPWAP)",
       "correct_answer":"D",
       "explanation":"Control and Provisioning of Wireless Access Points is a protocol that\u0027s responsible for provisioning of LWAPs and forwarding of data to the wireless LAN controller. The Spanning Tree Protocol (STP) is used to stop switching loops when redundant connections in a LAN are present. Bridge Protocol Data Units (BPDUs) are frames used by STP to define the root bridge and learn the switching topology for a network. Orthogonal Frequency Division Multiplexing (OFDM) is a wireless modulation method introduced with 802.11a."
    },
    {
       "id":24,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"Which component allows wireless clients to roam between access points and maintain authentication?",
       "choice_a":"Basic service set",
       "choice_b":"Extended service set",
       "choice_c":"Wireless LAN controller",
       "choice_d":"Service set ID",
       "correct_answer":"C",
       "explanation":"The wireless LAN controller (WLC) is responsible for centralized authentication of users and/or computers on a wireless network. When a wireless device is roaming, the WLC is responsible for maintaining the authentication between access points. A basic service set (BSS) is normally served by a single WAP for a single SSID. An extended service set (ESS) is used when two or more WAPs provide coverage for one or more SSIDs. The service set ID (SSID) is a friendly name beaconed to wireless clients so that the client can be configured to associate and/or authenticate."
    },
    {
       "id":25,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":4,
       "question":"Why would you use Multiprotocol Label Switching (MPLS) as a connectivity option?",
       "choice_a":"You need support for multicast packets",
       "choice_b":"You need support for both IPv4 and IPv6 packets",
       "choice_c":"You need a high amount of bandwidth",
       "choice_d":"You require encryption",
       "correct_answer":"B",
       "explanation":"The requirement for multiple protocols is a compelling reason to use MPLS. The protocols moving across MPLS nodes are irrelevant to the technology. This is because layer 3 information is not examined to route packets. The use of MPLS can be configured to support multicast packets, but this is not a primary driver in selecting MPLS. The use of MPLS does not give you any higher bandwidth than you would have with any other technology. MPLS supports encryption, just as any other WAN technology supports encryption."
    },
    {
       "id":26,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":5,
       "question":"What is a service-level agreement (SLA) for network connectivity?",
       "choice_a":"It is an agreement of bandwidth between the ISP and the customer.",
       "choice_b":"It is a quality of service agreement between the ISP and the customer.",
       "choice_c":"It is an agreement of uptime between the ISP and the customer.",
       "choice_d":"All of the above",
       "correct_answer":"D",
       "explanation":"A service-level agreement (SLA) is a contracted agreement between the Internet service provider (ISP) and the customer. This agreement defines the level of service. SLAs are based on uptime, quality of service, bandwidth, and any other stipulations the customer might deem necessary. Uptime is usually the most important when shopping for a provider. SLAs are not exclusive to ISPs and their customers; anywhere there is a service that requires uptime an SLA can be found."
    },
    {
       "id":27,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"Which is a valid reason to implement a wireless LAN controller?",
       "choice_a":"Centralized authentication",
       "choice_b":"The use of autonomous WAPs",
       "choice_c":"Multiple SSIDs",
       "choice_d":"Multiple VLANs",
       "correct_answer":"A",
       "explanation":"Centralized authentication of clients is a valid reason to implement a WLC. Although a WLC makes it easier to implement multiple SSIDs and VLANs, this task can be performed with autonomous WAPs, each performing its own authentication. The use of autonomous WAPs negates the reasons you would use a WLC because each WAP would be independently managed and no coordination would exist between the autonomous WAPs. The use of multiple SSIDs can be achieved with an autonomous WAP without a WLC. Multiple VLANs can also be used with an autonomous WAP without a WLC."
    },
    {
       "id":28,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"Which allows for seamless wireless roaming between access points?",
       "choice_a":"Single SSID",
       "choice_b":"Single service set",
       "choice_c":"802.11ac",
       "choice_d":"Wireless LAN controller",
       "correct_answer":"D",
       "explanation":"A wireless LAN controller keeps track of which LWAP a client has associated to and centrally forwards the packets to the LWAP that\u0027s appropriate for a client to access while roaming. A single SSID by itself will not support seamless roaming between access points. A single service set such as a basic service set will not support seamless roaming of wireless clients. 802.11ac is a wireless modulation specification and by itself does not support the seamless roaming of clients."
    },
    {
       "id":29,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":"",
       "question":"Which is one of the critical functions that a wireless LAN controller performs?",
       "choice_a":"Allows autonomous WAPs",
       "choice_b":"Synchronizes the WAPs with the same IOS",
       "choice_c":"Triangulates users for location lookups",
       "choice_d":"Allows for the use of all frequency channels",
       "correct_answer":"B",
       "explanation":"When WAPs are introduced to the wireless LAN controller, the WLC is responsible for synchronizing the WAPs to a standardized IOS. This allows for uniform support and features of the wireless system and is dependent on the model of WAP. WLCs can allow for autonomous WAPs to coexist; however, a WLC\u0027s main purpose is to manage lightweight access points. WLCs can be configured to work with Connected Mobile Experiences (CMX) for user triangulation, but a WLC cannot provide this service by itself. A WLC will manage the frequencies and channels for wireless clients, but using a WLC will not allow you to use all the wireless frequencies and channels."
    },
    {
       "id":30,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":4,
       "question":"Which should only be performed at the core layer?",
       "choice_a":"Routing",
       "choice_b":"Supporting clients",
       "choice_c":"Configuring ACLs",
       "choice_d":"Switching",
       "correct_answer":"D",
       "explanation":"Only switching between campus (distribution) switches should be performed at the core layer. Nothing should be done to slow down forwarding of traffic, such as using ACLs, supporting clients, or routing between VLANs. Routing of data should be performed at the distribution layer of the Cisco three-tier model. Supporting clients should be done at the access layer of the Cisco three-tier model. The configuration of access control lists (ACLs) should be performed at the distribution layer of the Cisco three-tier model."
    },
    {
       "id":31,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":5,
       "question":"Which network topology design has a centralized switch connecting all of the devices?",
       "choice_a":"Star topology",
       "choice_b":"Full mesh topology",
       "choice_c":"Partial mesh topology",
       "choice_d":"Hybrid topology",
       "correct_answer":"A",
       "explanation":"A star topology has a centralized switch connecting all of the devices outward like a star. A full mesh topology allows for a decentralized switching design, where any link failure will not affect switching. A partial mesh topology is normally performed between the layers of core, distribution, and access to allow for a single link failure while maintaining switching services. A hybrid topology is where several different topologies are employed, such as star and mesh."
    },
    {
       "id":32,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Which is a direct benefit of a full mesh topology?",
       "choice_a":"Increased bandwidth",
       "choice_b":"Increased redundancy",
       "choice_c":"Decreased switch count",
       "choice_d":"Increased complexity",
       "correct_answer":"B",
       "explanation":"Increased redundancy of connections is a direct benefit of a full mesh topology. Although bandwidth will increase because of multiple paths, additional dynamic routing protocols will need to be implemented to achieve this. A full mesh topology will not decrease the switch count and can even require more switching equipment because of the number of connections. When a full mesh topology is employed, it increases complexity, but this is not considered a benefit."
    },
    {
       "id":33,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Where is the hybrid topology most commonly seen in the three-tier design model?",
       "choice_a":"Core layer",
       "choice_b":"Distribution layer",
       "choice_c":"Access layer",
       "choice_d":"Routing layer",
       "correct_answer":"C",
       "explanation":"The hybrid topology is most often seen at the access layer. The devices are connected in a star topology and the access layer switches are partially meshed to the distribution layer switches. The distribution layer is normally connected with a full mesh topology. <italic>Routing layer</italic> is not terminology used to describe one of the three layers in the Cisco three-tier design model."
    },
    {
       "id":34,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Where is the full mesh topology commonly seen in the three-tier design model?",
       "choice_a":"Core layer",
       "choice_b":"Distribution layer",
       "choice_c":"Access layer",
       "choice_d":"Routing layer",
       "correct_answer":"B",
       "explanation":"Distribution layer switches are fully meshed for redundancy. The number of links can be calculated with the formula of N(N – 1). So if you had four distribution switches, the ports required for a full mesh would be 4(4 – 1) = 4 × 3 = 12 ports among the four switches. The formula of N (N – 1) / 2 would give you the number of links (connected ports): 4(4 – 1) / 2 = 4 × 3 / 2 = 6 links. The core layer is normally implemented with a star topology. The access layer is normally implemented with a partial mesh topology or hybrid topology. <italic>Routing layer</italic> is not a valid term in the Cisco three-tier design model."
    },
    {
       "id":35,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Where is the star topology most commonly seen in the three-tier design model?",
       "choice_a":"Core layer",
       "choice_b":"Distribution layer",
       "choice_c":"Access layer",
       "choice_d":"Routing layer",
       "correct_answer":"A",
       "explanation":"Core layer switches are commonly set up in a star topology. This is because core layer switches connect multiple campuses via distribution layer switches. The distribution layer is normally implemented with a full mesh topology. The access layer is normally implemented with a hybrid topology. <italic>Routing layer</italic> is not a valid term in the Cisco three-tier design model."
    },
    {
       "id":36,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":4,
       "question":"Which topology does the collapsed core layer switch use in a two-tier design model?",
       "choice_a":"Star topology",
       "choice_b":"Full mesh topology",
       "choice_c":"Partial mesh topology",
       "choice_d":"Hybrid topology",
       "correct_answer":"A",
       "explanation":"The collapsed core layer switch uses a star topology connecting outward to the access layer switches. This design is often found in small enterprise and single campus design. The full mesh topology is normally found at the distribution layer in the Cisco three-tier design model. The partial mesh or hybrid topology is often found at the access layer in the Cisco three-tier design."
    },
    {
       "id":37,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":5,
       "question":"The two-tier design model contains which layer switches?",
       "choice_a":"Core, distribution, and access",
       "choice_b":"Core and distribution",
       "choice_c":"Distribution and access",
       "choice_d":"Internet, core, distribution, and access",
       "correct_answer":"C",
       "explanation":"The two-tier, or collapsed core, model contains only the distribution and access layer switches. The three-tier design model contains the core, distribution, and access layer switches. The core and distribution layer switches are found in the upper two layers of the Cisco three-tier design model. There is no such thing as the Internet layer in any of the design models."
    },
    {
       "id":38,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"You have one campus, which contains 2,000 PCs, and each edge switch will contain 25 to 40 PCs. Based on this layout, which design model should be used?",
       "choice_a":"Collapsed core model",
       "choice_b":"Three-tier model",
       "choice_c":"DOD model",
       "choice_d":"Access model",
       "correct_answer":"A",
       "explanation":"Based on the layout of your network, the collapsed core model is the most appropriate model to design. If at a later time other campuses are joined to the network, the core layer can be added. The three-tier model is better situated for a network with multiple campuses. <italic>DOD model</italic> is a term used when referring to the layers of the OSI model in a macro model. <italic>Access model</italic> is not a term used with switching and routing design."
    },
    {
       "id":39,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Which is an accurate statement about the collapsed core design concept?",
       "choice_a":"It is best suited for large-scale networks",
       "choice_b":"It allows for better bandwidth",
       "choice_c":"It is best suited for small enterprises",
       "choice_d":"It bottlenecks bandwidth",
       "correct_answer":"C",
       "explanation":"The collapsed core design model is best suited for small enterprises. It can later be expanded out to a three-tier model as an enterprise grows in size. It has no effect on bandwidth if designed right. The collapsed core design does not and should not bottleneck bandwidth."
    },
    {
       "id":40,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":4,
       "question":"Access layer switches in the three-tier design model perform which task?",
       "choice_a":"Connect to other switches for redundancy",
       "choice_b":"Connect to users",
       "choice_c":"Connect campuses",
       "choice_d":"Connect to the Internet",
       "correct_answer":"B",
       "explanation":"Access layer switches connect to users and are edge network devices. The distribution layer connects other switches for redundancy. The core layer connects campuses together. Both the distribution and the core layer can connect the Internet to the network."
    },
    {
       "id":41,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":5,
       "question":"Distribution layer switches in the three-tier design model perform which task?",
       "choice_a":"Connect to other switches for redundancy",
       "choice_b":"Connect to users",
       "choice_c":"Connect campuses",
       "choice_d":"Connect to the Internet",
       "correct_answer":"A",
       "explanation":"Distribution layer switches connect to access layer switches and core switches to provide redundancy. Access layer switches connect to users and are edge network devices. The core layer connects campuses together. Both the distribution and the core layer can connect the Internet to the network."
    },
    {
       "id":42,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Core layer switches in the three-tier design model perform which task?",
       "choice_a":"Connect to other switches for redundancy",
       "choice_b":"Connect to users",
       "choice_c":"Connect campuses",
       "choice_d":"Connect to the Internet",
       "correct_answer":"C",
       "explanation":"Core layer switches connect campuses together via the distribution layer switches. Distribution layer switches connect to access layer switches and core switches to provide redundancy. Access layer switches connect to users and are edge network devices. Both the distribution and the core layer can connect the Internet to the network."
    },
    {
       "id":43,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"You have four campuses, each containing 500 PCs, and each edge switch will contain 20 to 30 PCs. Based on this layout, which design model should be used?",
       "choice_a":"Collapsed core model",
       "choice_b":"Three-tier model",
       "choice_c":"DoD model",
       "choice_d":"Access model",
       "correct_answer":"B",
       "explanation":"Based on the layout of your network, the three-tier model is the most appropriate model to design. Since there are four campuses, the core layer is recommended for connectivity between the campuses. The collapsed core model is best suited to a single campus. <italic>DoD model</italic> is a term used when referring to the layers of the OSI model in a macro model. <italic>Access model</italic> is not a term used with switching and routing design."
    },
    {
       "id":44,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Which layer in the three-tier model is where redistribution of routing protocols should be performed?",
       "choice_a":"Core layer",
       "choice_b":"Distribution layer",
       "choice_c":"Access layer",
       "choice_d":"Routing layer",
       "correct_answer":"B",
       "explanation":"The distribution layer is where redistribution of routing protocols should be performed. It should never be performed at the core or access layer. The core layer is where basic routing and switching is performed without slowing down any of the backbone communications. The access layer is where clients and end-user devices are supplied with network connectivity, allowing them to \u0022access\u0022 the network. <italic>Routing layer</italic> is not terminology used to describe one of the three layers in the Cisco three-tier design model."
    },
    {
       "id":45,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Which layer in the three-tier model is where collision domains should be created?",
       "choice_a":"Core layer",
       "choice_b":"Distribution layer",
       "choice_c":"Access layer",
       "choice_d":"Routing layer",
       "correct_answer":"C",
       "explanation":"The access layer is where collision domains should be created. This is called network segmentation. The core layer is where basic routing and switching is performed without slowing down any of the backbone communications. The distribution layer is where redistribution of routing protocols should be performed. <italic>Routing layer</italic> is not terminology used to describe one of the three layers in the Cisco three-tier design model."
    },
    {
       "id":46,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":4,
       "question":"In Cisco\u0027s three-tier architecture, the links between the distribution layer switches indicate what kind of topology?",
       "choice_a":"Full mesh topology",
       "choice_b":"Partial mesh topology",
       "choice_c":"Star topology",
       "choice_d":"Ring topology",
       "correct_answer":"B",
       "explanation":"The distribution layer is a partial mesh topology. Links between the distribution switches and core switches are multi-homed to each device for redundancy. Also, the links between the distribution switches and access switches are multi-homed to each device for redundancy. Although, this might seems to be a full mesh topology, the distribution switches are not connected to each other. A full mesh topology can often be found between the distribution and core layers. The core layer uses a star topology in a collapsed core design to connect lower layer switches. The ring topology is a legacy LAN topology and often used in WAN communications."
    },
    {
       "id":47,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Which technology provides for a hub-and-spoke design?",
       "choice_a":"E-Tree services",
       "choice_b":"Wireless WAN",
       "choice_c":"E-Line services",
       "choice_d":"E-LAN services",
       "correct_answer":"A",
       "explanation":"The E-Tree services of Metro Ethernet allow for a root to be established to serve the remote sites or leaf endpoints. The root can communicate to the leaf endpoints and the leaf endpoints can communicate to the root. However, the leaf endpoints cannot communicate with each other. Wireless WAN provides connectivity by using a star topology. E-Line and E-LAN services provide services in a point-to-point or point-to-multipoint topology."
    },
    {
       "id":48,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Which is a typical use case for hub-and-spoke WAN design?",
       "choice_a":"Connections for an enterprise spread over a metropolitan area",
       "choice_b":"Connections for an Internet service provider to its customers",
       "choice_c":"Connections between two or more corporate locations",
       "choice_d":"Connection internally inside of a service provider\u0027s network",
       "correct_answer":"B",
       "explanation":"The most common hub-and-spoke WAN design is the way an Internet service provider is connected to its customers. The Internet connection is centrally located in a common physical location of the Internet provider called the point of presence or meet-me room. All lines connect out from this point in a hub-and-spoke design. Connections for an enterprise spread over a metropolitan area can connect in a number of different topologies, depending on what is available. Connections between two or more corporate locations are often a point-to-point or point-to-multipoint topology. An internal connection inside of a service provider\u0027s network can be made a number of different ways using several different topologies."
    },
    {
       "id":49,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":5,
       "question":"Which WAN connectivity technology is always configured in a hub-and-spoke topology?",
       "choice_a":"IPsec",
       "choice_b":"MPLS",
       "choice_c":"DMVPN",
       "choice_d":"Metro Ethernet",
       "correct_answer":"C",
       "explanation":"The Cisco Dynamic Multipoint Virtual Private Network (DMVPN) is always configured in a hub-and-spoke topology. The central router creates a multiport GRE connection between all of the branch routers. IPsec uses a point-to-point topology for connectivity. MPLS and Metro Ethernet use a point-to-point or point-to-multipoint topology for connectivity."
    },
    {
       "id":50,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Which sub-protocol inside of the PPP suite is responsible for authentication?",
       "choice_a":"MPLS",
       "choice_b":"NCP",
       "choice_c":"LCP",
       "choice_d":"ACP",
       "correct_answer":"C",
       "explanation":"The Link Control Protocol (LCP) provides the authentication phase of a PPP connection. Multiprotocol Label Switching (MPLS) is a WAN connectivity protocol and connection method. The Network Control Protocol (NCP) allows for multiple upper-layer protocols to be used with PPP. There is no such protocol called ACP; therefore, it is an invalid answer."
    },
    {
       "id":51,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Which encapsulation protocol is used with PPP to transmit data over serial links?",
       "choice_a":"PPPoE",
       "choice_b":"HDLC",
       "choice_c":"MPLS",
       "choice_d":"X.25",
       "correct_answer":"B",
       "explanation":"The High-Level Data Link Control protocol is used as the encapsulation method for serial links. This protocol is the open standard HDLC compared to the native Cisco proprietary version. The Point-to-Point Protocol over Ethernet is widely used with digital subscriber lines (DSLs) and WiMax wireless services. Multiprotocol Label Switching (MPLS) is a WAN connectivity method. X.25 is a legacy WAN protocol used to transmit data."
    },
    {
       "id":52,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Which authentication method used with PPP uses a nonce (random number) to hash the password and prevent replay attacks?",
       "choice_a":"PAP",
       "choice_b":"PSAP",
       "choice_c":"CHAP",
       "choice_d":"LDAP",
       "correct_answer":"C",
       "explanation":"The Challenge Handshake Authentication Protocol (CHAP) works by sending a random number called the challenge. This challenge is received by the authenticating router and used to hash the password. The password is transferred to the challenging router and authenticates the authenticating router. The Password Authentication Protocol (PAP) transmits the username and password in clear text. There is no protocol called PSAP; therefore, it is an invalid answer. The Lightweight Directory Access Protocol (LDAP) is a protocol used to look up data, and it is used primarily with Active Directory. It does not provide encryption by itself but can be used with SSL to provide encryption."
    },
    {
       "id":53,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":4,
       "question":"Which sub-protocol inside of the PPP suite facilitates multilink connections?",
       "choice_a":"MPLS",
       "choice_b":"NCP",
       "choice_c":"LCP",
       "choice_d":"ACP",
       "correct_answer":"C",
       "explanation":"The Link Control Protocol provides the facility for multilink connections. Multiprotocol Label Switching (MPLS) is a WAN connectivity protocol and connection method. The Network Control Protocol (NCP) allows for multiple upper-layer protocols to be used with PPP. There is no protocol called ACP; therefore, it is an invalid answer."
    },
    {
       "id":54,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":5,
       "question":"Which is a benefit of using MLPPP?",
       "choice_a":"Simplified layer 3 configuration",
       "choice_b":"Does not require routing protocols",
       "choice_c":"Does not require authentication protocols",
       "choice_d":"Provides end-to-end encryption",
       "correct_answer":"A",
       "explanation":"MultiLink PPP simplifies layer 3 configuration. It does this by bundling the connections together at layer 2. It provides a pseudo interface representing the individual interface where all layer 3 configuration is applied. You can use routing protocols with MLPPP, and in larger networks, it is recommended and required. MLPPP should be used with authentication protocols to authenticate the incoming connections. The MLPPP protocol does not provide end-to-end encryption."
    },
    {
       "id":55,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Which configuration will create the multilink interface for an MLPPP connection to an adjoining router?",
       "choice_a":"<code>RouterA(config)#interface multilink 1</code><br><code>RouterA(config-if)#encapsulation ppp</code><br><code>RouterA(config-if)#ppp multilink</code><br><code>RouterA(config-if)#ip address 192.168.1.1 255.255.255.0</code><br><code>RouterA(config-if)#ppp multilink group 1</code>",
       "choice_b":"<code>RouterA(config)#interface multilink 1</code><br><code>RouterA(config-if)#ppp multilink</code><br><code>RouterA(config-if)#ip address 192.168.1.1 255.255.255.0</code>",
       "choice_c":"<code>RouterA(config)#interface multilink 1</code><br><code>RouterA(config-if)#encapsulation ppp multilink</code>",
       "choice_d":"<code>RouterA(config)#interface multilink 1</code><br><code>RouterA(config-if)#ip address 192.168.1.1 255.255.255.0</code><br><code>RouterA(config-if)#ppp multilink group 1</code>",
       "correct_answer":"A",
       "explanation":"The pseudo interface must be created first with the command <code>interface multilink 1</code>. Then the encapsulation must be set to PPP with <code>encapsulation ppp</code>. The <code>ppp multilink</code> command configures the ability to use multilink for the encapsulation of PPP. Then the IP address is configured. Last, the <code>ppp multilink group 1</code> command associates the interface multilink 1 with the multilink group to be used for bundling. All of the other options are incorrect."
    },
    {
       "id":56,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"You need to set up PPP authentication for RouterA. The adjoining router is named RouterB, and both routers will have a matching password of <italic>cisco</italic>. Which commands will achieve this?",
       "choice_a":"<code>RouterA(config)#username RouterA password cisco</code><br><code>RouterA(config)#interface serial 0/1/0</code><br><code>RouterA(config-if)#ppp authentication chap pap</code>",
       "choice_b":"<code>RouterA(config)#username RouterB password cisco</code><br><code>RouterA(config)#interface serial 0/1/0</code><br><code>RouterA(config-if)#ppp authentication chap pap</code>",
       "choice_c":"<code>RouterA(config)#username RouterA cisco</code><br><code>RouterA(config)#interface serial 0/1/0</code><br><code>RouterA(config-if)#ppp authentication chap pap</code>",
       "choice_d":"<code>RouterA(config)#username RouterA password cisco</code> <br><code>RouterA(config)#interface serial 0/1/0</code><br><code>RouterA(config-if)#authentication chap pap</code>",
       "correct_answer":"B",
       "explanation":"The first step is to set the username of RouterB to use for authentication via <code>username RouterB password cisco</code>. Then enter the interface, in this case using the <code>interface serial 0/1/0</code> command, and configure authentication with the command <code>ppp authentication chap pap</code>. All of the other options are incorrect."
    },
    {
       "id":57,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"In the following exhibit, what does the line <code>LCP closed</code> mean?<img src='/question_assets/ccna/1_image8.png'></img>",
       "choice_a":"The LCP process has completed",
       "choice_b":"The router does not have an IP address configured",
       "choice_c":"The serial line is disconnected",
       "choice_d":"The LCP process has not completed",
       "correct_answer":"D",
       "explanation":"The <code>LCP closed</code> line states that the LCP process has not completed. This could be due to numerous reasons, such as conflicting options or authentication failure. When the LCP process has completed, it will be in an \u0022open\u0022 state when reviewing the interface. The router does not need to have an IP address configured, since this is a layer 2 communication process. If the serial line was disconnected, the interface would show as down with a line protocol of down."
    },
    {
       "id":58,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"You have obtained an ADSL circuit at a remote office for central office connectivity. What will you need to configure on the remote office router?",
       "choice_a":"Metro Ethernet",
       "choice_b":"PPPoE",
       "choice_c":"PPP",
       "choice_d":"MPLS",
       "correct_answer":"B",
       "explanation":"Asymmetrical Digital Subscriber Line (ADSL) connectivity typically uses PPPoE to authenticate subscribers. The subscriber\u0027s credentials are often relayed to a RADIUS server for subscription checks. Metro Ethernet is a WAN connectivity method and not a protocol that is used with ADSL. PPP does not need to be configured for use over an ADSL connection, but the authentication portion of PPPoE must be configured. MPLS is a WAN connectivity method and not a protocol that is used with ADSL."
    },
    {
       "id":59,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":4,
       "question":"Amazon Web Services (AWS) and Microsoft Azure are examples of what?",
       "choice_a":"Public cloud providers",
       "choice_b":"Private cloud providers",
       "choice_c":"Hybrid cloud providers",
       "choice_d":"Dynamic cloud providers",
       "correct_answer":"A",
       "explanation":"AWS and Microsoft Azure are examples of public cloud providers. Private clouds are internally created, and hybrid clouds are a combination of services between your private cloud and the public cloud. Private clouds are purchased and maintained by a private entity and not available for public use, usually on your internal network. Hybrid clouds are a mixture of private and public clouds, usually where your infrastructure exists partially in the public cloud and partially in your private cloud. There is no such thing as dynamic cloud providers since all cloud providers must have a level of elasticity for their clients."
    },
    {
       "id":60,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":5,
       "question":"You are looking to create a fault tolerant colocation site for your servers at a cloud provider. Which type of cloud provider would you be searching for?",
       "choice_a":"PaaS",
       "choice_b":"IaaS",
       "choice_c":"SaaS",
       "choice_d":"BaaS",
       "correct_answer":"B",
       "explanation":"If you were looking to create a fault tolerant colocation site as a cloud provider, you would be searching for an Infrastructure as a Service provider. This would allow you to install your own operation system and applications. A Platform as a Service (PaaS) solution is similar to running applications in the cloud, where the platform supports some level of programming language, such as Python, Ruby, or Visual Basic. Software as a Service (SaaS) is probably the most common, since services such as email, contract management, and many others are hosted by SaaS providers. Backup as a Service is popular today because it can allow for the long-term storage of data offline after a backup has completed."
    },
    {
       "id":61,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Which is not a NIST criterion for cloud computing?",
       "choice_a":"Resource pooling",
       "choice_b":"Rapid elasticity",
       "choice_c":"Automated billing",
       "choice_d":"Measured service",
       "correct_answer":"C",
       "explanation":"Automated billing is not a NIST criteria for cloud computing. It is essential for the cloud computing vendor but is not relevant if you are hosting your own private cloud. The five NIST criteria for cloud computing are on-demand self-service, broad network access, resource pooling, rapid elasticity, and measured service."
    },
    {
       "id":62,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Which term describes the type of cloud an internal IT department hosting virtualization for a company would host?",
       "choice_a":"Public cloud",
       "choice_b":"Elastic cloud",
       "choice_c":"Private cloud",
       "choice_d":"Internal cloud",
       "correct_answer":"C",
       "explanation":"When an internal IT department hosts the virtualization for a company, they are hosting a private cloud. A public cloud is virtualization infrastructure that is open to the public. An elastic cloud is a cloud that has elasticity. Rapid elasticity is one of the five characteristic that NIST defines as a characteristic of cloud computing. <italic>Internal cloud</italic> is not a term that describes virtualization; therefore, it is an invalid answer."
    },
    {
       "id":63,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"What is the role of a cloud services catalog?",
       "choice_a":"It defines the capabilities for the cloud.",
       "choice_b":"It defines the available VMs for creation in the cloud",
       "choice_c":"It defines the available VMs running in the cloud.",
       "choice_d":"It defines the drivers for VMs in the cloud",
       "correct_answer":"B",
       "explanation":"A cloud services catalog satisfies the self-service aspect of cloud computing. It does this by listing all of the available virtual machines (VMs) that can be created in the cloud environment, such as web servers, application server, databases, and so on. The cloud services catalog does not define the capabilities for the cloud since the capabilities could be much more expansive than the cloud services catalog. The cloud services catalog does not define the available VMs currently running in the cloud. The cloud services catalog also does not define the drivers for VMs in the cloud; this would be the agent or services file required for VMs running in the cloud."
    },
    {
       "id":64,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"A hosted medical records service is an example of which cloud model?",
       "choice_a":"PaaS",
       "choice_b":"IaaS",
       "choice_c":"SaaS",
       "choice_d":"BaaS",
       "correct_answer":"C",
       "explanation":"A hosted medical records service is an example of the SaaS, or Software as a Service, model. The customer cannot choose variables such as vCPU or RAM. The cloud provider is responsible for the delivery of the software, maintenance of the OS, and maintenance of the hardware. An example of Platform as a Service (PaaS) would be Google App Engine or Microsoft Azure, where code could be executed on a virtual stack of equipment (programming platform). An example of Infrastructure as a Service (IaaS) is Amazon Web Services (AWS) Elastic Compute (EC2), where a VM can be started up with virtual network services with only a credit card and you are billed periodically. An example of Backup as a Service (BaaS) is Microsoft Azure cloud backup or Google Drive, just to name a couple."
    },
    {
       "id":65,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":4,
       "question":"A hosted environment that allows you to write and run programs is an example of which cloud model?",
       "choice_a":"PaaS",
       "choice_b":"IaaS",
       "choice_c":"SaaS",
       "choice_d":"BaaS",
       "correct_answer":"A",
       "explanation":"A hosted service that allows you to develop upon it is an example of the Platform as a Service (PaaS) model. The cloud provider is responsible for the delivery of APIs that developers can use to create programs. An example of Infrastructure as a Service (IaaS) is Amazon Web Services (AWS) Elastic Compute (EC2), where a VM can be started up with virtual network services with only a credit card and you are billed periodically. An example of Software as a Service (SaaS) is your email provider or a customer relation management (CRM) company such as Salesforce. An example of Backup as a Service (BaaS) is Microsoft Azure cloud backup or Google Drive, just to name a couple."
    },
    {
       "id":66,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":5,
       "question":"Which cloud connectivity method allows for seamless transition between public clouds?",
       "choice_a":"MPLS VPN",
       "choice_b":"Internet VPN",
       "choice_c":"Inter cloud exchange",
       "choice_d":"Private WAN",
       "correct_answer":"C",
       "explanation":"An inter cloud exchange is a service that connects multiple public clouds through a common private WAN connection. This allows a network engineer to configure the private WAN once and be able to transition between the public clouds on the service side without reconfiguration of the private WAN. A Multiprotocol Label Switching (MPLS) VPN is a VPN connection that is built over an MPLS network (private connection). An Internet VPN is a VPN connection that is built over the public Internet (public connection). A private wide area network (WAN) is one or more network connections between your facilities using public WAN connectivity methods."
    },
    {
       "id":67,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":1,
       "question":"Which option is not a consideration when converting to an email SaaS application if the majority of users are internal? <br><ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Internal bandwidth usage</li></ol> <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> External bandwidth usage</li></ol> <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Location of the users</li></ol> <ol style='margin-left: 25px; list-style-type: upper-alpha;'><li> Branch office connectivity to the Internet</li></ol>",
       "choice_a":"A, B",
       "choice_b":"B, C",
       "choice_c":"C, D",
       "choice_d":"A, D",
       "correct_answer":"D",
       "explanation":"Internal bandwidth usage is not a consideration after conversion to an SaaS application. External bandwidth should be considered since internal users will access the application through the Internet. Location of the users should also be a deciding factor in moving to an SaaS model."
    },
    {
       "id":68,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"You purchase a VM on a public cloud and plan to create a VPN tunnel to the cloud provider. Your IP network is 172.16.0.0/12, and the provider has assigned an IP address in the 10.0.0.0/8 network. What virtual network function (VNF) will you need from the provider to communicate with the VM?",
       "choice_a":"Virtual switch",
       "choice_b":"Virtual firewall",
       "choice_c":"Virtual router",
       "choice_d":"Another IP scheme at the provider",
       "correct_answer":"C",
       "explanation":"You will need a virtual router running static NAT to translate the two different IP networks. This type of service is called a virtual network function, or VNF. A virtual switch is built into just about every virtualization platform since layer 2 communications is normally required. A virtual firewall is a piece of software that allows you to protect your virtualization infrastructure, just like their hardware counterparts. Another IP scheme at the provider could help, but a router would still be required for connectivity."
    },
    {
       "id":69,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":"",
       "question":"Which protocol would you use to synchronize the VM in the public cloud with an internal time source at your premises?",
       "choice_a":"DNS",
       "choice_b":"rsync",
       "choice_c":"NTP",
       "choice_d":"VPN",
       "correct_answer":"C",
       "explanation":"Network Time Protocol (NTP) is a standardized protocol for network time synchronization. Domain Name System (DNS) is a service that is used to translate a fully qualified domain name (FQDN) to an IP address. The rsync utility is a Linux/Unix utility used to synchronize (copy) a number of files to a remote system. A virtual private network (VPN) is a private encrypted tunnel that is normally created over a public Internet connection."
    },
    {
       "id":70,
       "topic_id":1,
       "sub_domain":"1.3 Compare physical interface and cabling types",
       "practice_test_id":"",
       "question":"Which cable type would you use to connect a switch to a switch?",
       "choice_a":"Straight-through cable",
       "choice_b":"Crossover cable",
       "choice_c":"Rolled cable",
       "choice_d":"Shielded cable",
       "correct_answer":"B",
       "explanation":"You would use a crossover cable because a switch is a data communications equipment (DCE) Ethernet device. When connecting a DCE Ethernet device to another DCE Ethernet device, you would need to cross the connection with a crossover cable. Newer switches have medium dependent interface - crossover (MDI-X) capabilities to detect the need for a crossover cable and will automatically switch the cable over if a straight-through cable is used. A straight-through cable is used to connect a DCE Ethernet device such as a switch to data terminal equipment (DTE) such as a host. A rolled cable is used for serial communication between a router or switch and a modem or serial adapter for configuration. A shielded cable has either a metal webbed shield or foil shield to filter out electrical magnetic interference (EMI)."
    },
    {
       "id":71,
       "topic_id":1,
       "sub_domain":"1.3 Compare physical interface and cabling types",
       "practice_test_id":"",
       "question":"Which fiber optic standard utilizes a 50 micron core?",
       "choice_a":"UTP",
       "choice_b":"Multi-mode",
       "choice_c":"Single-mode",
       "choice_d":"STP",
       "correct_answer":"B",
       "explanation":"Multi-mode fiber can be either 50 microns or 62.5 microns at its core. The maximum distance for a 50-micron fiber is 550 meters utilizing the 1000Base-LX specification. Unshielded twisted pair (UTP) is used in copper Ethernet cabling of hosts and network equipment. Single-mode fiber-optic cable is around 7 microns thick and is used for long-distance communications. Shielded twisted pair (STP) is used in industrial settings when there is the potential for electrical magnetic interference (EMI)."
    },
    {
       "id":72,
       "topic_id":1,
       "sub_domain":"1.3 Compare physical interface and cabling types",
       "practice_test_id":"",
       "question":"Which type of cable would be used to connect a computer to a switch for management of the switch?",
       "choice_a":"Straight-through cable",
       "choice_b":"Crossover cable",
       "choice_c":"Rolled cable",
       "choice_d":"Shielded cable",
       "correct_answer":"C",
       "explanation":"Although operation of computers connected to a switch uses a straight-through cable, management via the console port requires a rolled cable and an EIA/TIA 232 adapter. A straight-through cable is used to connect a data communications equipment (DCE) Ethernet device such as a switch to data terminal equipment (DTE) such as a host. You would use a crossover cable when connecting a DCE Ethernet device to another DCE Ethernet device; you would need to cross the connection with a crossover cable. Newer switches have medium dependent interface - crossover (MDI-X) capabilities to detect the need for a crossover cable and will automatically switch the cable over if a straight-through cable is used. A shielded cable has either a metal webbed shield or foil shield to filter out electrical magnetic interference (EMI)."
    },
    {
       "id":73,
       "topic_id":1,
       "sub_domain":"1.3 Compare physical interface and cabling types",
       "practice_test_id":4,
       "question":"Which specification for connectivity is currently used in data centers for lower cost and simplicity?",
       "choice_a":"10GBase-T",
       "choice_b":"40GBase-T",
       "choice_c":"10GBase-CX",
       "choice_d":"100GBase-TX",
       "correct_answer":"C",
       "explanation":"10GBase-CX is commonly used in data centers. It is referred to by its nickname of Twinax. It is a fixed, balanced coaxial pair that can be run up to 25 meters. 10GBase-T is usually category 6 cable that is nominally run up to 55 meters in length to achieve 10 Gb/s speeds. 40GBase-T is usually category 8 cable that is nominally run up to 30 meters to provide 40 Gb/s speeds. 100GBase-TX is not a valid specification for Ethernet connectivity. 100Base-TX is standard 100 Mb/s connectivity that supports full-duplex communications."
    },
    {
       "id":74,
       "topic_id":1,
       "sub_domain":"1.3 Compare physical interface and cabling types",
       "practice_test_id":5,
       "question":"If you had an existing installation of Cat5e on your campus, what is the highest speed you could run?",
       "choice_a":"10 Mb/s",
       "choice_b":"100 Mb/s",
       "choice_c":"1 Gb/s",
       "choice_d":"10 Gb/s",
       "correct_answer":"C",
       "explanation":"Cat5e can support up to 1 Gb/s via the 1000Base-T specification. Since 10Base-T, 100Base-T, and 1000Base-T can be run up to 100 meters in length, it allows for interchangeability with speeds. It was very common when Cat5e came out 20 years ago for installers to future-proof wiring installations with it. 10 Gb/s requires Category 6 or 6a cable to operate at speeds of 10 Gb/s. All other answers are incorrect."
    },
    {
       "id":75,
       "topic_id":1,
       "sub_domain":"1.3 Compare physical interface and cabling types",
       "practice_test_id":"",
       "question":"Which statement is correct about straight-through cables and crossover cables?",
       "choice_a":"Crossover cables are wired with pins 1 through 8 on one side and 8 through 1 on the other side",
       "choice_b":"Crossover cables are wired with the 568B specification on both sides",
       "choice_c":"Straight-through cables are wired with the 568B specification on one side and the 568A specification on the other side",
       "choice_d":"Crossover cables are wired with the 568B specification on one side and the 568A specification on the other side",
       "correct_answer":"D",
       "explanation":"Crossover cables are wired with the 568B specification on one side, and on the other side, the 568A specification is used. This change in wiring delivers the TX pair on pins 3 and 6 to the RX pair on pins 1 and 2. Straight-through cables are wired with the 568B specification on both sides."
    },
    {
       "id":76,
       "topic_id":1,
       "sub_domain":"1.3 Compare physical interface and cabling types",
       "practice_test_id":"",
       "question":"In the following exhibit, PPP is negotiating the username and password for the adjacent router. You are debugging PPP on the local router. What needs to be done to fix the problem? <img src='/question_assets/ccna/1_image9.png'></img>",
       "choice_a":"Configure PAP on this router",
       "choice_b":"Configure PPP encapsulation on this router",
       "choice_c":"Verify that the local username matches the adjacent router\u0027s hostname and the passwords match",
       "choice_d":"Verify that the remote username matches the adjacent router\u0027s hostname and the passwords match.",
       "correct_answer":"C",
       "explanation":"The exhibit shows an example of a debug of outgoing packets, and therefore, the configuration problem is on this router. This router\u0027s username must match the adjacent router\u0027s hostname and both passwords must match. PAP is already configured on this router, as seen in the exhibit. PPP is also already configured on this router, as seen in the exhibit. This local router will not verify the remote username matches on the adjacent router; the adjacent router will verify when this router transmits its locally configured username and password."
    },
    {
       "id":77,
       "topic_id":1,
       "sub_domain":"1.3 Compare physical interface and cabling types",
       "practice_test_id":4,
       "question":"Which device is responsible for adding the label to a packet?",
       "choice_a":"Customer edge (CE) router",
       "choice_b":"Provider edge (PE) router",
       "choice_c":"Customer premise switch",
       "choice_d":"Label switch routers (LSR)",
       "correct_answer":"B",
       "explanation":"The provider edge (PE) router is responsible for adding the MPLS label to a packet. The customer edge (CE) router is passed the MPLS packet with the label striped off. The customer premise switch is the customer\u0027s local switching device and has no relation to MPLS. The term <italic>label switch router (LSR)</italic> is used to describe the internal switching of the MPLS network."
    },
    {
       "id":78,
       "topic_id":1,
       "sub_domain":"1.3 Compare physical interface and cabling types",
       "practice_test_id":5,
       "question":"What is the term that defines the end of the provider\u0027s responsibility and the beginning of the customer\u0027s responsibility?",
       "choice_a":"CPE",
       "choice_b":"CO",
       "choice_c":"Local loop",
       "choice_d":"Demarc",
       "correct_answer":"D",
       "explanation":"The demarc, or demarcation point, is the end of the provider\u0027s responsibility for the connection and the point where the customer\u0027s responsibility begins. This point is often a physical location where the provider can test their connection and hand off the service to the customer. Customer premises equipment (CPE) is the router or ancillary equipment used to facilitate the connection to the wide area network (WAN). The central office (CO) is a physical location where all of the customer connections on the local loop meet up and WAN services are delivered. The CO is also sometimes referred to as the point of presence (POP)."
    },
    {
       "id":79,
       "topic_id":1,
       "sub_domain":"1.3 Compare physical interface and cabling types",
       "practice_test_id":4,
       "question":"What is the speed of a DS1 connection in North America?",
       "choice_a":"2.048 Mb/s",
       "choice_b":"44.736 Mb/s",
       "choice_c":"1.544 Mb/s",
       "choice_d":"622.08 Mb/s",
       "correct_answer":"C",
       "explanation":"The speed of a DS1 connection is 1.544 Mb/s; it is also referred to as a T1 connection. The speed of a European DS1 called an E1 is 2.048 Mb/s. The speed of DS3 line is 44.736 Mb/s, and this line is also referred to as a T3. The speed of an optical carrier (OC-12) WAN connection is 622.08 Mb/s."
    },
    {
       "id":80,
       "topic_id":1,
       "sub_domain":"1.4 Identify interface and cable issues (collisions, errors, mismatch duplex, and/or speed)",
       "practice_test_id":5,
       "question":"Which command would you run to diagnose a possible line speed or duplex issue?",
       "choice_a":"<code>Switch#show speed</code>",
       "choice_b":"<code>Switch#show duplex</code>",
       "choice_c":"<code>Switch#show interface status</code>",
       "choice_d":"<code>Switch#show diagnostics</code>",
       "correct_answer":"C",
       "explanation":"When you\u0027re checking for speed and/or duplex issues, the <code>show interface status</code> command will detail all of the ports with their negotiated speed and duplex. The command <code>show speed</code> is incorrect. The command <code>show duplex</code> is incorrect. The command <code>show diagnostics</code> is incorrect."
    },
    {
       "id":81,
       "topic_id":1,
       "sub_domain":"1.4 Identify interface and cable issues (collisions, errors, mismatch duplex, and/or speed)",
       "practice_test_id":"",
       "question":"In the following exhibit, what can you conclude about the interface or node? <img src='/question_assets/ccna/1_image10.png'></img>",
       "choice_a":"The interface is shut down",
       "choice_b":"The interface is negotiated at half-duplex",
       "choice_c":"There is a duplex mismatch on the interface",
       "choice_d":"The cabling is shorted on the interface",
       "correct_answer":"C",
       "explanation":"Although cabling could create an issue similar to this, it would not disable the interface. The most probable cause is that there is a duplex mismatch since there are a large number of late collisions. The most probable scenario is that the far end is set to half-duplex and the interface is set to full-duplex, or the opposite might also be true. The interface is not shut down because the exhibit would state that the interface was administratively disabled. There is no evidence in the exhibit that the interface has negotiated at half-duplex. The exhibit also shows no evidence that the cable is shorted on the interface."
    },
    {
       "id":82,
       "topic_id":1,
       "sub_domain":"1.4 Identify interface and cable issues (collisions, errors, mismatch duplex, and/or speed)",
       "practice_test_id":4,
       "question":"In the following exhibit, what can you conclude about the interface or node? <img src='/question_assets/ccna/1_image11.png'></img>",
       "choice_a":"The interface is shut down",
       "choice_b":"The interface is negotiated at half-duplex.",
       "choice_c":"There is a duplex mismatch on the interface",
       "choice_d":"The cabling is shorted on the interface",
       "correct_answer":"A",
       "explanation":"The interface has been administratively down, which means that the interface has been placed into a shutdown state To resolve the problem, a <code>no shutdown</code> command must be configured on the interface. There is no evidence in the exhibit that the interface has negotiated at half-duplex. The exhibit does not show any evidence that the duplex is mismatched on the interface, because the interface states it is administratively disabled. The exhibit also shows no evidence that the cable is shorted on the interface."
    },
    {
       "id":83,
       "topic_id":1,
       "sub_domain":"1.4 Identify interface and cable issues (collisions, errors, mismatch duplex, and/or speed)",
       "practice_test_id":5,
       "question":"You have just resolved a problem and now need to monitor the problem on the interface. How would you reset the error counts for a single interface?",
       "choice_a":"<code>Switch#reset counters interface fast 0/1</code>",
       "choice_b":"<code>Switch#clear interface fast 0/1</code>",
       "choice_c":"<code>Switch#clear counters interface fast 0/1</code>",
       "choice_d":"<code>Switch#clear statistics interface fast 0/1</code>",
       "correct_answer":"C",
       "explanation":"In order to clear the counters for a single interface, you would use the command <code>clear counters interface fast 0/1</code>. After it\u0027s entered, you will need to confirm clearing of the counters. Then you can monitor the solution provided on the interface. The command <code>reset counters interface fast 0/1</code> is incorrect. The command <code>clear interface fast 0/1</code> is incorrect. The command <code>clear statistics interface fast 0/1</code> is incorrect."
    },
    {
       "id":84,
       "topic_id":1,
       "sub_domain":"1.4 Identify interface and cable issues (collisions, errors, mismatch duplex, and/or speed)",
       "practice_test_id":"",
       "question":"In the following exhibit, what can you conclude about the interface or node? <img src='/question_assets/ccna/1_image12.png'></img>",
       "choice_a":"The interface is shut down",
       "choice_b":"The interface is negotiated at half-duplex",
       "choice_c":"The interface is operating normally",
       "choice_d":"The cable is disconnected for the node",
       "correct_answer":"D",
       "explanation":"The counters on this interface are all nominal, but the interface and line protocol are down/down. This most likely suggestion is that the cable is disconnected. If the interface was shut down, it would state in the exhibit that the interface was administratively shut down. There is no evidence in the exhibit that the interface is negotiated at half-duplex. The interface is not operating nominally because it is in a down state."
    },
    {
       "id":85,
       "topic_id":1,
       "sub_domain":"1.4 Identify interface and cable issues (collisions, errors, mismatch duplex, and/or speed)",
       "practice_test_id":"",
       "question":"A router is connected to the switch via a Fast Ethernet interface. Intermittently you experience an outage. What should be done first to remedy the problem? Refer to the following exhibit. <img src='/question_assets/ccna/1_image13.png'></img>",
       "choice_a":"The speed and duplex should be set statically",
       "choice_b":"Change the VLAN to a less crowded VLAN",
       "choice_c":"Change the switchport mode to a trunk",
       "choice_d":"Set the switchport to auto-negotiate",
       "correct_answer":"A",
       "explanation":"It is recommended to set all servers and networking hardware statically for speed and duplex. If a network interface flaps (transitions between up and down), auto-negotiation of speed and duplex will be performed again, which could create a service outage. Changing the VLAN to another VLAN will not have any effect on interface resets and disconnects. Changing the switchport mode to a trunk is only applicable if the other side of the link is another switch that is configured as a trunk. Setting the switchport to auto-negotiate will turn on the Dynamic Trunking Protocol (DTP) and allow the switchport to become a trunk if plugged into another switch with DTP."
    },
    {
       "id":86,
       "topic_id":1,
       "sub_domain":"1.4 Identify interface and cable issues (collisions, errors, mismatch duplex, and/or speed)",
       "practice_test_id":4,
       "question":"In the following exhibit, what can you conclude about the interface or node? <img src='/question_assets/ccna/1_image14.png'></img>",
       "choice_a":"There are no problems with the interface",
       "choice_b":"The interface is auto-negotiating speed and duplex",
       "choice_c":"There are a large number of broadcasts",
       "choice_d":"The node needs a faster network interface",
       "correct_answer":"D",
       "explanation":"The txload and rxload counters are extremely high. This depicts that the interface is not fast enough for the data being transferred. The speed and duplex currently is 10 Mb/s and full-duplex. However, the interface on the switch is capable of 100 Mb/s. It is recommended to upgrade the node\u0027s NIC. Although there are no major problems with the interface, the counters depict congestion on the interface. The exhibit shows no evidence that the interface is auto-negotiating speed and duplex. Although there are a large number of broadcasts, this is not a problem compared to the load on the interface."
    },
    {
       "id":87,
       "topic_id":1,
       "sub_domain":"1.4 Identify interface and cable issues (collisions, errors, mismatch duplex, and/or speed)",
       "practice_test_id":5,
       "question":"You have statically set an interface to 100 Mb/s full-duplex. However, the device you are plugging in will not work. Which command would you use to set speed and duplex back to auto-negotiate?",
       "choice_a":"<code>Switch(config-if)#speed auto</code><br><code>Switch(config-if)#duplex auto</code>",
       "choice_b":"<code>Switch(config-if)#speed autonegotiate</code><br><code>Switch(config-if)#duplex autonegotiate</code>",
       "choice_c":"<code>Switch(config-if)#switchport autonegotiate</code>",
       "choice_d":"<code>Switch(config-if)#interface autonegotiate</code>",
       "correct_answer":"A",
       "explanation":"The commands to set the port back to auto-negotiation are <code>speed auto</code> and <code>duplex auto</code>. You can also negate the command with <code>no speed</code> and <code>no duplex</code> commands. Both methods will set auto-negotiation back on the port. The commands <code>speed autonegotiate</code> and <code>duplex autonegotiate</code> are incorrect. The command <code>switchport autonegotiate</code> is incorrect. The command <code>interface autonegotiate</code> is incorrect."
    },
    {
       "id":88,
       "topic_id":1,
       "sub_domain":"1.4 Identify interface and cable issues (collisions, errors, mismatch duplex, and/or speed)",
       "practice_test_id":"",
       "question":"You have auto-negotiation turned off on the node, but it is turned on at the switch\u0027s interface connecting the node. The interface is a 10/100/1000 Mb/s interface and the node is 100 Mb/s full-duplex. What will the outcome be when you plug in the node?",
       "choice_a":"The switch interface will be set to the 100 Mb/s full-duplex",
       "choice_b":"The switch interface will be set to the 100 Mb/s half-duplex",
       "choice_c":"The switch interface will be set to the 10 Mb/s full-duplex",
       "choice_d":"The switch interface will be set to the 10 Mb/s half-duplex",
       "correct_answer":"B",
       "explanation":"Cisco switches can auto-detect speed, so the speed sensed will be 100 Mb/s. However, if the switch cannot detect the speed, then it will fall back to 10 Mb/s. Duplex is decided-upon by bandwidth when IEEE auto-negotiation is turned off. If the speed is 10 Mb/s or 100 Mb/s, then the duplex will be half-duplex; otherwise it will be full-duplex on 1000 Mb/s links."
    },
    {
       "id":89,
       "topic_id":1,
       "sub_domain":"1.4 Identify interface and cable issues (collisions, errors, mismatch duplex, and/or speed)",
       "practice_test_id":4,
       "question":"You plug a 100 Mb/s hub into a switch. What is the expected outcome?",
       "choice_a":"The switch interface will be set to the 100 Mb/s full-duplex",
       "choice_b":"The switch interface will be set to the 100 Mb/s half-duplex",
       "choice_c":"The switch interface will be set to the 10 Mb/s full-duplex",
       "choice_d":"The switch interface will be set to the 10 Mb/s half-duplex",
       "correct_answer":"B",
       "explanation":"Hubs do not participate in IEEE negotiation, and therefore the speed will be detected. However, since duplex cannot be negotiated, 10 Mb/s and 100 Mb/s connections will be half-duplex and 1000 Mb/s connections will be full-duplex. Therefore the switch interface will be set to 100 Mb/s half-duplex."
    },
    {
       "id":90,
       "topic_id":1,
       "sub_domain":"1.4 Identify interface and cable issues (collisions, errors, mismatch duplex, and/or speed)",
       "practice_test_id":5,
       "question":"You want to see the status of all speed and duplex negotiations for all interfaces. Which command would you use?",
       "choice_a":"<code>Switch#show run</code>",
       "choice_b":"<code>Switch#show interfaces counters</code>",
       "choice_c":"<code>Switch#show interfaces status</code>",
       "choice_d":"<code>Switch#show counters interfaces</code>",
       "correct_answer":"C",
       "explanation":"The <code>show interfaces status</code> command will display the port number, description, connected status, VLAN, duplex, speed, and type of interface. The command <code>show run</code> is incorrect. The command <code>show interfaces counters</code> is incorrect. The command <code>show counters interfaces</code> is incorrect."
    },
    {
       "id":91,
       "topic_id":1,
       "sub_domain":"1.5 Compare TCP to UDP",
       "practice_test_id":"",
       "question":"Flow control can be found at which layer of the OSI?",
       "choice_a":"Transport layer",
       "choice_b":"Network layer",
       "choice_c":"Data Link layer",
       "choice_d":"Session layer",
       "correct_answer":"A",
       "explanation":"The Transport layer is responsible for flow control via the TCP/IP protocols of TCP and UDP. The Network layer is responsible for logical addressing of network nodes. The Data Link layer is responsible for the framing of data and the physical addressing of local nodes. The Session layer is responsible for the setup of the dialog between two hosts."
    },
    {
       "id":92,
       "topic_id":1,
       "sub_domain":"1.5 Compare TCP to UDP",
       "practice_test_id":4,
       "question":"Which protocol requires the programmer to deal with lost segments?",
       "choice_a":"SSL",
       "choice_b":"TCP",
       "choice_c":"UDP",
       "choice_d":"NMS",
       "correct_answer":"C",
       "explanation":"User Datagram Protocol (UDP) does not guarantee segments are delivered. Therefore, the programmer must account for segments that are never received or out of order. Secure Sockets Layer (SSL) is a protocol used to encrypt a network transmission. Transmission Control Protocol (TCP) allows for the network to automatically deal with lost segments because TCP guarantees segments are delivered. <italic>Network management station (NMS)</italic> is a term used with Simple Network Management Protocol (SNMP) to describe the collecting host for SNMP messages."
    },
    {
       "id":93,
       "topic_id":1,
       "sub_domain":"1.5 Compare TCP to UDP",
       "practice_test_id":5,
       "question":"Which is a correct statement about the Transmission Control Protocol (TCP)?",
       "choice_a":"TCP is a connectionless protocol",
       "choice_b":"TCP allows for error correction",
       "choice_c":"TCP is faster than UDP",
       "choice_d":"TCP allows for retransmission of lost segments",
       "correct_answer":"D",
       "explanation":"TCP is a connection-based protocol via the three-way handshake. It is not faster than UDP. However, it allows for the retransmission of lost segments because of sequences and acknowledgments. TCP does not allow or account for error correction, only the detection of errors and lost or missing segments."
    },
    {
       "id":94,
       "topic_id":1,
       "sub_domain":"1.5 Compare TCP to UDP",
       "practice_test_id":"",
       "question":"Which statement correctly describes what happens when a web browser initiates a request to a web server?",
       "choice_a":"The sender allocates a port dynamically above 1024 and associates it with the request",
       "choice_b":"The receiver allocates a port dynamically above 1024 and associates it with the request",
       "choice_c":"The sender allocates a port dynamically below 1024 and associates it with the request",
       "choice_d":"The receiver allocates a port dynamically below 1024 and associates it with the request",
       "correct_answer":"A",
       "explanation":"The sender allocates a port dynamically above 1024 and associates it with the request through a process called a handle. This way, if a web browser creates three requests for three different web pages, the pages are loaded to their respective windows. The receiver will respond back to the requesting port dynamically allocated to the request (over 1024); these ports are also known as ephemeral ports. Dynamic allocation is always over 1024, not below 1024, and it is always the responsibility of the sender, not the receiver."
    },
    {
       "id":95,
       "topic_id":1,
       "sub_domain":"1.5 Compare TCP to UDP",
       "practice_test_id":"",
       "question":"Which protocol and port number is associated with SMTP?",
       "choice_a":"UDP/69",
       "choice_b":"VUDP/68",
       "choice_c":"UDP/53",
       "choice_d":"TCP/25",
       "correct_answer":"D",
       "explanation":"The Simple Mail Transfer Protocol (SMTP) uses TCP port 25 to send mail. The Trivial File Transfer Protocol (TFTP) uses UDP/69 for communications. The Dynamic Host Configuration Protocol (DHCP) uses UDP/68 for communications. The Domain Name System (DNS) protocol uses UDP/53 for communications."
    },
    {
       "id":96,
       "topic_id":1,
       "sub_domain":"1.5 Compare TCP to UDP",
       "practice_test_id":"",
       "question":"How does TCP guarantee delivery of segments to the receiver?",
       "choice_a":"Via the destination port",
       "choice_b":"TCP checksums",
       "choice_c":"Window size",
       "choice_d":"Sequence and acknowledgment numbers",
       "correct_answer":"D",
       "explanation":"TCP guarantees delivery of segments with sequence and acknowledgment numbers. At the Transport layer, each segment is given a sequence number that is acknowledged by the receiver. The source and destination ports are used for the delivery of segments, but they do not guarantee delivery. TCP checksums are used to detect errors in segments but do not guarantee delivery. Window size is used to adjust buffer size on the sending and receiving hosts."
    },
    {
       "id":97,
       "topic_id":1,
       "sub_domain":"1.5 Compare TCP to UDP",
       "practice_test_id":4,
       "question":"When a programmer decides to use UDP as a transport protocol, what is a decision factor?",
       "choice_a":"Redundancy of acknowledgment is not needed",
       "choice_b":"Guaranteed delivery of segments is required",
       "choice_c":"Windowing flow control is required",
       "choice_d":"A virtual circuit is required",
       "correct_answer":"A",
       "explanation":"When a programmer decides to use UDP, it is normally because the programmer is sequencing and acknowledging datagrams already. The redundancy of acknowledgments at the Transport layer is not needed. Guaranteed delivery of segments is not a function of UDP. UDP does not provide windowing flow control because acknowledgement is not a function of UDP. A virtual circuit can only be created with a setup and teardown of communications, such as TCP offers."
    },
    {
       "id":98,
       "topic_id":1,
       "sub_domain":"1.5 Compare TCP to UDP",
       "practice_test_id":5,
       "question":"Which mechanism allows for programs running on a server (daemons) to listen for requests through the process called binding?",
       "choice_a":"Headers",
       "choice_b":"Port numbers",
       "choice_c":"MAC address",
       "choice_d":"Checksums",
       "correct_answer":"B",
       "explanation":"When a daemon or server process starts, it binds to a port number on which to listen for a request. An example is a web server binding to the port number of TCP/80. A port is communicated in the header of TCP and UDP segments, but the header does not listen for requests or bind. MAC addresses are physical locations on a local area network (LAN) that are used to transmit framed data. Checksums are used to verify that data are not erroneously modified in transit."
    },
    {
       "id":99,
       "topic_id":1,
       "sub_domain":"1.5 Compare TCP to UDP",
       "practice_test_id":1,
       "question":"Which is a correct statement about sliding windows used with TCP?",
       "choice_a":"The window size is established during the three-way handshake.",
       "choice_b":"Sliding windows allow for data of different lengths to be padded.",
       "choice_c":"It allows TCP to indicate which upper-layer protocol created the request.",
       "choice_d":"It allows the router to see the segment as urgent data",
       "correct_answer":"A",
       "explanation":"The window size, which is a buffer, is established and agreed upon by the sender and receiver during the three-way handshake. Sliding windows does not allow for data of different lengths to be padded; it is used for fixed-length data segments. Port binding is used by TCP and UDP to indicate which upper-layer protocol (application) created the request. Routers only examine layer 3 information by default, so they can make decisive routing decisions."
    },
    {
       "id":100,
       "topic_id":1,
       "sub_domain":"1.5 Compare TCP to UDP",
       "practice_test_id":"",
       "question":"Why does DNS use UDP for queries?",
       "choice_a":"DNS requires acknowledgment of the request for auditing",
       "choice_b":"The requests require flow control of UDP",
       "choice_c":"DNS requests are usually small and do not require connections setup",
       "choice_d":"DNS requires a temporary virtual circuit",
       "correct_answer":"C",
       "explanation":"DNS requests are usually small and do not require the overhead of sequence and acknowledgment of TCP. If a segment is dropped, the DNS protocol will ask again. Acknowledgement of data is not a function of UDP. Flow control is not a function of UDP since UDP does not offer flow control of data other than a stop/go action. UDP does not build temporary virtual circuits; this is a function of TCP."
    },
    {
       "id":101,
       "topic_id":1,
       "sub_domain":"1.5 Compare TCP to UDP",
       "practice_test_id":"",
       "question":"What is required before TCP can begin sending segments?",
       "choice_a":"Three-way handshake",
       "choice_b":"Port agreement",
       "choice_c":"Sequencing of segments",
       "choice_d":"Acknowledgment of segments",
       "correct_answer":"A",
       "explanation":"A three-way handshake is required between sender and receiver before TCP can begin sending traffic. During this three-way handshake, the sender\u0027s window buffer size is synchronized with the receiver\u0027s window buffer size. Ports are not agreed upon; they are used for the addressing of traffic at the Transport layer. The sequencing and acknowledgment of segments is a function of the TCP protocol."
    },
    {
       "id":102,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":"",
       "question":"Which class is the IP address 172.23.23.2?",
       "choice_a":"Class A",
       "choice_b":"Class B",
       "choice_c":"Class C",
       "choice_d":"Class D",
       "correct_answer":"B",
       "explanation":"The IP address 172.23.23.2 is a Class B address. All of the other options are incorrect."
    },
    {
       "id":103,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":"",
       "question":"Which is the default subnet mask for a Class A address?",
       "choice_a":"255.0.0.0",
       "choice_b":"255.255.0.0",
       "choice_c":"255.255.255.0",
       "choice_d":"255.255.255.255",
       "correct_answer":"A",
       "explanation":"The default subnet mask of a Class A address is 255.0.0.0. The default subnet mask of a Class B address is 255.255.0.0. The default subnet mask of a Class C address is 255.255.255.0. The mask 255.255.255.255 is reserved to define a specific IP address and not part of classful addressing."
    },
    {
       "id":104,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":"",
       "question":"Which address is a multicast IP address?",
       "choice_a":"221.22.20.2",
       "choice_b":"223.3.40.2",
       "choice_c":"238.20.80.4",
       "choice_d":"240.34.22.12",
       "correct_answer":"C",
       "explanation":"The multicast range begins with 224 and ends with 239 in the first octet. Therefore, only the IP address 238.20.80.4 is correct. All of the other options are incorrect."
    },
    {
       "id":105,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":"",
       "question":"Which is true of the IP address 135.20.255.255?",
       "choice_a":"It is a Class A address",
       "choice_b":"It is a broadcast address",
       "choice_c":"It is the default gateway address",
       "choice_d":"It has a default mask of 255.0.0.0",
       "correct_answer":"B",
       "explanation":"The IP address 135.20.255.255 is a Class B broadcast address. It is not a Class A address, nor is it the default gateway address. The default mask of a Class B address is 255.255.0.0."
    },
    {
       "id":106,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":"",
       "question":"What is the CIDR notation for a subnet mask of 255.255.240.0?",
       "choice_a":"/19",
       "choice_b":"/20",
       "choice_c":"/22",
       "choice_d":"/28",
       "correct_answer":"B",
       "explanation":"The CIDR notation for 255.255.240.0 is /20. The first two subnets are 8 bits (8 × 2 = 16), and the 240 is 4 more bits (16 + 4 = 20). All of the other options are incorrect."
    },
    {
       "id":107,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":"",
       "question":"You have been given an IP address network of 203.23.23.0. You are asked to subnet it for two hosts per network. What is the subnet mask you will need to use to maximize networks?",
       "choice_a":"255.255.255.252",
       "choice_b":"255.255.255.248",
       "choice_c":"255.255.255.240",
       "choice_d":"255.255.255.224",
       "correct_answer":"A",
       "explanation":"The mask you will need to use is 255.255.255.252. This will allow for two hosts per network for a total of 64 networks. The formula for solving for hosts is 2X – 2 is equal to or greater than 2(hosts), which in this case is (22 – 2) = (4 – 2) = 2. So 2 bits are used for the host side, leaving 6 bits for the subnet side. 6 bits + 24 bits (original subnet mask) = /30, or 255.255.255.252. All of the other options are incorrect."
    },
    {
       "id":108,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":"",
       "question":"You have been given an IP address network of 213.43.53.0. You are asked to subnet it for 22 hosts per network. What is the subnet mask you will need to use to maximize networks?",
       "choice_a":"255.255.255.252",
       "choice_b":"255.255.255.248",
       "choice_c":"255.255.255.240",
       "choice_d":"255.255.255.224",
       "correct_answer":"D",
       "explanation":"The mask you will need to use is 255.255.255.224. This will allow for 30 hosts per network for a total of eight networks. The formula for solving for hosts is 2X – 2 is equal to or greater than 22 hosts, which in this case is (25 – 2) = (32 – 2) = 30. So 5 bits are used for the host side, leaving 3 bits for the subnet side. 3 bits + 24 bits (original subnet mask) = /27, or 255.255.255.224. All of the other options are incorrect."
    },
    {
       "id":109,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":"",
       "question":"Which valid IP is in the same network as 192.168.32.61/26?",
       "choice_a":"192.168.32.59",
       "choice_b":"192.168.32.63",
       "choice_c":"192.168.32.64",
       "choice_d":"192.168.32.72",
       "correct_answer":"A",
       "explanation":"The valid IP address range for the 192.168.32.0/26 network is 192.168.32.1 to 192.168.32.62, 192.168.32.65 to 192.168.32.126, etc. Therefore, 192.168.32.59 is within the valid IP range of 192.168.32.61/26. 192.168.32.63 is the broadcast address for the 192.168.32.0/26 network. 192.168.32.64 is the network ID for the 192.168.32.64/26 network. 192.168.32.72 is a valid IP address in the 192.168.32.64/26 network."
    },
    {
       "id":110,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":"",
       "question":"You are setting up a network in which you need 15 subnetworks. You have been given a network address of 153.20.0.0, and you need to maximize the number of hosts in each network. Which subnet mask will you use?",
       "choice_a":"255.255.224.0",
       "choice_b":"255.255.240.0",
       "choice_c":"255.255.248.0",
       "choice_d":"255.255.252.0",
       "correct_answer":"B",
       "explanation":"The subnet mask will be 255.255.240.0. Since you need to solve for the number of networks, the equation is as follows: 2X is equal to or greater than 15 networks. 24 = 16 completed the equation; the 4 bits represent the subnet side; you add the 4 bits to the 16 bits of the class B subnet mandated by the IETF. 16 + 4 = /20 = 255.255.240.0. All of the other options are incorrect."
    },
    {
       "id":111,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":"",
       "question":"An ISP gives you an IP address of 209.183.160.45/30 to configure your end of the serial connection. Which IP address will be on the side at the ISP?",
       "choice_a":"209.183.160.43/30",
       "choice_b":"209.183.160.44/30",
       "choice_c":"209.183.160.46/30",
       "choice_d":"209.183.160.47/30",
       "correct_answer":"C",
       "explanation":"The valid IP address range for 209.183.160.45/30 is 209.183.160.45–209.183.160.46. Both IP addresses are part of the 209.183.160.44/30 network. The IP address 209.183.160.47/30 is the broadcast address for the 209.182.160.44/30 network. The IP address 209.183.160.43/30 is the broadcast IP address for the 209.183.160.40/30 network."
    },
    {
       "id":112,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":"",
       "question":"In the following exhibit, what needs to be changed for Computer A to successfully communicate with Computer B (assume the least amount of effort to fix the problem)? <img src='/question_assets/ccna/1_image15.png'></img>",
       "choice_a":"Computer A needs to have its IP address changed",
       "choice_b":"Computer B needs to have its IP address changed",
       "choice_c":"The default gateway IP address for Computer A needs to be changed.",
       "choice_d":"The default gateway IP address for Computer B needs to be changed",
       "correct_answer":"C",
       "explanation":"The default gateway address for Computer A is 192.168.1.63. The IP address on the router (default gateway) is the broadcast address for the 192.168.1.0/26 network and cannot be used as that network\u0027s gateway. If you were to change Computer A\u0027s IP address, it would still not be able to communicate with Computer B because of the incorrect gateway address. Computer B\u0027s IP address and default gateway are fine, and both will function properly."
    },
    {
       "id":113,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":"",
       "question":"In the following exhibit, what needs to be changed for Computer A to successfully communicate with Computer B (assume the least amount of effort to fix the problem)? <img src='/question_assets/ccna/1_image16.png'></img>",
       "choice_a":"Computer A needs to have its IP address changed",
       "choice_b":"Computer B needs to have its IP address changed",
       "choice_c":"The default gateway IP address for Computer A needs to be changed",
       "choice_d":"The default gateway IP address for Computer B needs to be changed",
       "correct_answer":"A",
       "explanation":"Computer A needs to have its IP address changed to align with the network that its gateway is in. Computer A is in the 192.168.1.32/27 network, while its gateway address is in the 192.168.1.0/27 network. Although changing the gateway address would work, the solution needs to be the one with the least amount of effort. Changing the gateway address, which is a valid IP address, would create more work for other clients. Computer B\u0027s IP address and default gateway are fine, and both will function properly."
    },
    {
       "id":114,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":"",
       "question":"Which subnet does host 131.50.39.23/21 belong to?",
       "choice_a":"131.50.39.0/21",
       "choice_b":"131.50.32.0/21",
       "choice_c":"131.50.16.0/21",
       "choice_d":"131.50.8.0/21",
       "correct_answer":"B",
       "explanation":"The /21 subnet mask has subnets in multiples of 8. So the networks would be 131.50.8.0/21, 131.50.16.0/21, 131.50.24.0/21, 131.50.32.0/21, and 131.50.40.0/21. The IP address of 131.50.39.23/21 would belong to the 131.50.32.0/21 network with a valid range of 131.50.32.1 to 131.50.39.254. Therefore, the network 131.50.39.0/21 cannot be a network ID because it belongs to the 131.50.32.0/21 network. Both the 131.50.16.0/21 and 131.50.8.0/21 network IDs are outside of the range for the host used in this question."
    },
    {
       "id":115,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":"",
       "question":"A computer has an IP address of 145.50.23.1/22. What is the broadcast address for that computer?",
       "choice_a":"145.50.254.255",
       "choice_b":"145.50.255.255",
       "choice_c":"145.50.22.255",
       "choice_d":"145.50.23.255",
       "correct_answer":"D",
       "explanation":"The network for the computer with an IP address of 145.50.23.1/22 is 145.50.20.0/22. Its valid range is 145.50.20.1 to 145.50.23.254; the broadcast address for the range is 145.50.23.255. All of the other options are incorrect."
    },
    {
       "id":116,
       "topic_id":1,
       "sub_domain":"1.7 Describe the need for private IPv4 addressing",
       "practice_test_id":"",
       "question":"Which RFC defines private IP addresses?",
       "choice_a":"RFC 1819",
       "choice_b":"RFC 1911",
       "choice_c":"RFC 1918",
       "choice_d":"RFC 3030",
       "correct_answer":"C",
       "explanation":"RFC 1918 defines three private address ranges, which are not routable on the Internet. Although RFC 1819, 1911, and 3030 are real requests for comments, they are all irrelevant to IP addressing."
    },
    {
       "id":117,
       "topic_id":1,
       "sub_domain":"1.7 Describe the need for private IPv4 addressing",
       "practice_test_id":"",
       "question":"What is a major reason to use private IP addressing?",
       "choice_a":"It allows for the conservation of public IP addresses",
       "choice_b":"Since private IP addresses are non-routable on the Internet, they are secure",
       "choice_c":"It keeps communications private",
       "choice_d":"It allows easier setup than public IP addresses",
       "correct_answer":"A",
       "explanation":"The private IP address space was created to preserve the number of public IP addresses. Private IP addresses are non-routable on the Internet, but this does not make them secure. Private IP addresses do not keep communications private, as their name implies. Private IP addresses are not publically addressable for communications. Private IP addresses do not allow for an easier setup than public IP addresses."
    },
    {
       "id":118,
       "topic_id":1,
       "sub_domain":"1.7 Describe the need for private IPv4 addressing",
       "practice_test_id":"",
       "question":"What is required when using private IP addresses to communicate with Internet hosts?",
       "choice_a":"Internet router",
       "choice_b":"IPv4 tunnel",
       "choice_c":"VPN tunnel",
       "choice_d":"Network Address Translation",
       "correct_answer":"D",
       "explanation":"Network Address Translation (NAT) is required to communicate over the Internet with private IP addresses. Although Internet routers are required for routing, by default they will not route private IP addresses to public IP addresses. An IPv4 tunnel or VPN tunnel is not required for communications on the Internet with private IP addresses."
    },
    {
       "id":119,
       "topic_id":1,
       "sub_domain":"1.7 Describe the need for private IPv4 addressing",
       "practice_test_id":1,
       "question":"Which is the Class A private IP address range?",
       "choice_a":"10.0.0.0/8",
       "choice_b":"10.0.0.0/12",
       "choice_c":"172.16.0.0/12",
       "choice_d":"10.0.0.0/10",
       "correct_answer":"A",
       "explanation":"The Class A private IP address range is defined as 10.0.0.0/8. The address range is 10.0.0.0 to 10.255.255.255. The network IDs 10.0.0.0/10 and 10.0.0.0/12 are wrong because the network mask is incorrect. The network ID 172.16.0.0/12 is the private IP address range for a Class B network."
    },
    {
       "id":120,
       "topic_id":1,
       "sub_domain":"1.7 Describe the need for private IPv4 addressing",
       "practice_test_id":"",
       "question":"Which is the Class B private IP address range?",
       "choice_a":"10.0.0.0/8",
       "choice_b":"10.0.0.0/12",
       "choice_c":"172.16.0.0/12",
       "choice_d":"10.0.0.0/10",
       "correct_answer":"C",
       "explanation":"The Class B private IP address range is defined as 172.16.0.0/12. The address range is 172.16.0.0 to 172.31.255.255. The network ID 10.0.0.0/8 defines a Class A private IP address range. Both the 10.0.0.0/12 and 10.0.0.0/10 network IDs are incorrect."
    },
    {
       "id":121,
       "topic_id":1,
       "sub_domain":"1.7 Describe the need for private IPv4 addressing",
       "practice_test_id":"",
       "question":"Which is the Class C private IP address range?",
       "choice_a":"192.168.1.0/24",
       "choice_b":"192.168.0.0/24",
       "choice_c":"192.168.0.0/16",
       "choice_d":"192.168.0.0/12",
       "correct_answer":"C",
       "explanation":"Although a Class C address has a classful subnet mask of 255.255.255.0, the private IP address range put aside for Class C addresses is 192.168.0.0 to 192.168.255.255, written in CIDR notation as 192.168.0.0/16. All of the other options are incorrect."
    },
    {
       "id":122,
       "topic_id":1,
       "sub_domain":"1.7 Describe the need for private IPv4 addressing",
       "practice_test_id":"",
       "question":"You plug a laptop into a network jack. When you examine the IP address, you see 169.254.23.43. What can you conclude?",
       "choice_a":"The network jack is not working",
       "choice_b":"Your laptop has a static IP address configured",
       "choice_c":"The network is configured properly",
       "choice_d":"The DHCP server is down",
       "correct_answer":"D",
       "explanation":"Any address in the range of 169.254.0.0/16 is a link-local address. It means that the computer has sensed that a network connection is present, but no DHCP is present. The network only allows local communications and no routing. Microsoft refers to this as an Automatic Private IP Addressing (APIPA) address. If the network jack was not working, then the computer would not sense a connection. Although it is possible to have a 169.254.0.0/16 address configured on the laptop, it is not probable because it is an automatic address. The conclusion that the network is configured properly is incorrect because there is no server or device serving DHCP."
    },
    {
       "id":123,
       "topic_id":1,
       "sub_domain":"1.7 Describe the need for private IPv4 addressing",
       "practice_test_id":"",
       "question":"You want to put a web server online for public use. Which IP address would you use?",
       "choice_a":"192.168.34.34",
       "choice_b":"172.31.54.3",
       "choice_c":"10.55.33.32",
       "choice_d":"198.168.55.45",
       "correct_answer":"D",
       "explanation":"198.168.55.45 is a valid IPv4 public address. All of the other addresses are RFC 1918 compliant and thus non-routable on the Internet."
    },
    {
       "id":124,
       "topic_id":1,
       "sub_domain":"1.7 Describe the need for private IPv4 addressing",
       "practice_test_id":"",
       "question":"Who is the governing body that distributes public IP addresses?",
       "choice_a":"IANA",
       "choice_b":"RFC",
       "choice_c":"IAB",
       "choice_d":"IETF",
       "correct_answer":"A",
       "explanation":"IANA, or the Internet Assigned Numbers Authority, is the governing body that distributes public IP addresses and registers them to ISPs. A Request for Comments (RFC) is an academic paper that is published to the Internet Advisory Board (IAB). The RFC is then voted upon and can become a standard or informational or deemed a best current practice, just to name a few. The Internet Engineering Task Force is a group of engineers that have helped form protocols used on networks as well as aspects of the Internet."
    },
    {
       "id":125,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":"",
       "question":"Which protocol allows multicast switches to join computers to the multicast group?",
       "choice_a":"ICMP",
       "choice_b":"IGMP",
       "choice_c":"IPMI",
       "choice_d":"IPGRP",
       "correct_answer":"B",
       "explanation":"IGMP, or Internet Group Messaging Protocol, allows switches to join computers to the multicast group table. This allows the selective process of snooping to occur when a transmission is sent. Internet Control Message Protocol (ICMP) is used by IP utilities such as traceroute and ping for diagnostics and troubleshooting. Intelligent Platform Management Interface (IPMI) allows systems to be monitored and managed at the hardware level, independent of the CPU, memory, BIOS, and operating system. IPGRP is not a protocol that defines a standard, and therefore, it is an incorrect answer."
    },
    {
       "id":126,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":"",
       "question":"Why is IPv6 needed in the world today?",
       "choice_a":"It does not require NAT to operate",
       "choice_b":"The IPv4 address space is exhausted",
       "choice_c":"IPv4 is considered legacy, and IPv6 is the replacement",
       "choice_d":"IPv6 does not support subnetting",
       "correct_answer":"B",
       "explanation":"IPv4 allows for 232 = 4.3 billion addresses. However, only 3.7 billion are usable because of reservations and classful addressing. The current IPv4 address space is exhausted, and IPv6 allows for 2128 = 3.4 × 1038 addresses. IPv6 still requires NAT for backward compatibility with IPv4. Although IPv4 is slowly being replaced with IPv6, IPv4 is still dominant in networks and the Internet. IPv6 does not need to be subnetted like IPv4 by borrowing bits from the network mask; there are 16 bits dedicated for subnets."
    },
    {
       "id":127,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":"",
       "question":"How many bits is an IPv6 address?",
       "choice_a":"32 bits",
       "choice_b":"64 bits",
       "choice_c":"128 bits",
       "choice_d":"256 bits",
       "correct_answer":"C",
       "explanation":"An IPv6 address is 128 bits: 64 bits is the network ID, and 64 bits is the host ID. All of the other options are incorrect."
    },
    {
       "id":128,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":"",
       "question":"You have two facilities and both use IPv6 addressing internally. However, both facilities are connected to the Internet via IPv4. What is one recommended method you can use to communicate between the facilities over the Internet?",
       "choice_a":"Dedicated leased line",
       "choice_b":"Frame Relay",
       "choice_c":"Dual stack",
       "choice_d":"6to4 tunnel",
       "correct_answer":"D",
       "explanation":"A 6to4 tunnel can be achieved between the routers. This encapsulates the IPv6 header in an IPv4 header so that it can be routed across the Internet. A dedicated leased line and Frame Relay are wide area network (WAN) connectivity methods. Dual stack means that a host or router will have both IPv4 and IPv6 configured, but it will not allow both facilities to communicate over the Internet."
    },
    {
       "id":129,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":"",
       "question":"Which command is required on a router to support IPv6 static addressing?",
       "choice_a":"<code>Router(config)#ipv6 address</code>",
       "choice_b":"<code>Router(config)#ipv6 routing</code>",
       "choice_c":"<code>Router(config)#ipv6 enable</code>",
       "choice_d":"<code>Router(config)#ipv6 unicast-routing</code>",
       "correct_answer":"D",
       "explanation":"In order to enable IPv6 on a router, you must globally configure the router with the command <code>ipv6 unicast-routing</code>. Although <code>ipv6 enable</code> will work, it will allow only link-local addressing. The command <code>ipv6 address</code> is incorrect. The command <code>ipv6 routing</code> is incorrect."
    },
    {
       "id":130,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":"",
       "question":"Which command would you use on an interface to set the IPv6 address?",
       "choice_a":"Router(config-if)# <code>ip address</code><br><code>2001:0db8:85aa:0000:0000:8a2e:1343:1337</code>",
       "choice_b":"Router(config-if)# <code>ipv6 address</code><br><code>2001:0db8:85aa:0000:0000:8a2e:1343:1337</code>",
       "choice_c":"Router(config-if)# <code>ip address</code><br><code>2001:0db8:85aa:0000:0000:8a2e:1343:1337/64</code>",
       "choice_d":"Router(config-if)# <code>ipv6 address</code><br><code>2001:0db8:85aa:0000:0000:8a2e:1343:1337/64</code>",
       "correct_answer":"D",
       "explanation":"When you configure routers, always use the rule of major/minor. The major protocol is <code>ipv6</code>, and the minor command is <code>address</code>. So the correct command is <code>ipv6 address 2001:0db8:85aa:0000:0000:8a2e:1343:1337/64</code>. The additional rule is to specify the network portion with a /64. The command <code>ip address 2001:0db8:85aa:0000:0000:8a2e:1343:1337</code> is incorrect. The command <code>ipv6 address 2001:0db8:85aa:0000:0000:8a2e:1343:1337</code> is incorrect. The command <code>ip address 2001:0db8:85aa:0000:0000:8a2e:1343:1337/64</code> is incorrect."
    },
    {
       "id":131,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":"",
       "question":"Which field of the IPv6 header allows for a dual stack host to decide which stack to process the packet in?",
       "choice_a":"Version field",
       "choice_b":"Flow label",
       "choice_c":"Source address",
       "choice_d":"Destination address",
       "correct_answer":"A",
       "explanation":"The first 4 bits of an IPv6 header contain the version number. In an IPv4 packet, this is set to 0100, but in an IPv6 packet, this number is set to 0110. This allows for the host to decide which stack to process the packet in. Flow labels in IPv6 explain to a router how to handle packets and route them; they do not contain a version number. The source and destination addresses in IPv6 packets will be IPv6 addresses, but this is not how a dual stack machine decides which protocol to use."
    },
    {
       "id":132,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":"",
       "question":"You want to see all of the interfaces on a router configured with IPv6. Which command would you use?",
       "choice_a":"Router#<code>show ipv6 interfaces brief</code>",
       "choice_b":"Router#<code>show ip interfaces brief</code>",
       "choice_c":"Router#<code>show interfaces status</code>",
       "choice_d":"Router#<code>show ip addresses</code>",
       "correct_answer":"A",
       "explanation":"When you use a show command, always follow it with the major protocol and then the parameters. The <code>show ipv6 interfaces brief</code> command would show all of the interfaces configured with an IPv6 address. The command <code>show ip interfaces brief</code> is incorrect. The command <code>show interfaces status</code> is incorrect. The command <code>show ip addresses</code> is incorrect."
    },
    {
       "id":133,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":1,
       "question":"Which is a valid shortened IPv6 address for 2001:0db8:0000:0000:0000:8a2e:0000:1337?",
       "choice_a":"2001:db8:0000::8a2e::1337",
       "choice_b":"2001:db8:::8a2e:0000:1337",
       "choice_c":"2001:db8::8a2e::1337",
       "choice_d":"2001:db8::8a2e:0:1337",
       "correct_answer":"D",
       "explanation":"You can remove leading 0s in the quartet, and you can condense four zeros to one zero. However, you can use the :: to remove zeros only once. Therefore, 2001:db8:0000::8a2e::1337 and 2001:db8::8a2e::1337 are invalid notations. The address 2001:db8:::8a2e:0000:1337 contains three colons, and therefore, it is an invalid notation."
    },
    {
       "id":134,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":"",
       "question":"Which is the correct expansion for the IPv6 address 2001::456:0:ada4?",
       "choice_a":"2001:0000:0000:0456:0000:ada4",
       "choice_b":"2001:0000:0000:0000:456:0000:ada4",
       "choice_c":"2001:0000:0000:0000:0000:0456:0000:ada4",
       "choice_d":"2001:0000:0000:0000:0456:0000:0000:ada4",
       "correct_answer":"C",
       "explanation":"Expanding out the IP of 2001::0456:0:ada4, you first expand the :0: to four zeros. Then expand the remainder of the quartets to 0s to make a 32-digit (128-bit) number again. All other options are incorrect."
    },
    {
       "id":135,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":"",
       "question":"In the IPv6 address 2001.0db8:1234:0016:0023:8080:2345:88ab/64, what is the subnet quartet?",
       "choice_a":1234,
       "choice_b":16,
       "choice_c":23,
       "choice_d":8080,
       "correct_answer":"B",
       "explanation":"The first 48 bits of an IPv6 address are the global prefix; the next 16 bits are the subnet portion of the IPv6 address. 48 bits + 16 bits = 64 bits for the network ID. 1234 is the site ID, which is a portion of the network ID. 0023 is the first 16 bits of the interface ID. 8080 is the second 16 bits of the interface ID."
    },
    {
       "id":136,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":"",
       "question":"What is the network prefix for the IPv6 address 2001.db8::8080:2345:88ab/64?",
       "choice_a":"2001:db8::/64",
       "choice_b":"2001:0db8:8080:2345/64",
       "choice_c":"2001:0db8:0000:8080/64",
       "choice_d":"2001:0db8:0000:2345/64",
       "correct_answer":"A",
       "explanation":"The network prefix is 2001:db8::/64. Expanded, it is written as 2001:0db8:0000:0000/64. However, the condensed version written in the answer is valid. All of the other options are incorrect."
    },
    {
       "id":137,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":"",
       "question":"You need to verify connectivity to the IPv6 address fc00:0000:0000:0000:0000:0000:0000:0004. Which command would you use?",
       "choice_a":"<code>Router#ping fc00::4</code>",
       "choice_b":"<code>Router#ping fc::4</code>",
       "choice_c":"<code>Router#ping ipv6 fc00::4</code>",
       "choice_d":"<code>Router#ping ipv6 fc::4</code>",
       "correct_answer":"C",
       "explanation":"The command to ping an IPv6 address is <code>ping ipv6</code>. The valid condensed address for fc00:0000:0000:0000:0000:0000:0000:0004 is fc00::4. You cannot condense trailing zeros such as fc00. You can only condense leading zeros. The command <code>ping</code> in options A and B is incorrect; the proper command is <code>ping ipv6</code> for IPv6 addresses. Although the command <code>ping ipv6</code> is correct, the IP address in option D is incorrect."
    },
    {
       "id":138,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"Which method is used to direct communications to a single host?",
       "choice_a":"Unicast",
       "choice_b":"Broadcast",
       "choice_c":"Multicast",
       "choice_d":"Anycast",
       "correct_answer":"A",
       "explanation":"A unicast address is a single valid IP address for direct communications purposes between two hosts. A broadcast is a single address that is sent to a network of hosts. A multicast address is a single address that is selectively sent to a multicast group of hosts. An anycast address is a single IP address that is selectively routed to depending on the location of the originating host."
    },
    {
       "id":139,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"Which protocol uses broadcasting at layer 3?",
       "choice_a":"ARP",
       "choice_b":"DHCP",
       "choice_c":"IGMP",
       "choice_d":"SNMP",
       "correct_answer":"B",
       "explanation":"DHCP uses a packet called a Discover packet. This packet is addressed to 255.255.255.255. Although ARP uses a broadcast, it is a layer 2 broadcast, not a layer 3 broadcast. IGMP is a layer 3 protocol that uses unicast to register members of a multicast group. SNMP is a layer 3 management protocol that uses unicasts for messaging."
    },
    {
       "id":140,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"Which method is used to direct communications to all computers in a subnet?",
       "choice_a":"Unicast",
       "choice_b":"Broadcast",
       "choice_c":"Multicast",
       "choice_d":"Anycast",
       "correct_answer":"B",
       "explanation":"A broadcast will forward a message to all computers in the same subnet. A unicast address is a single valid IP address for direct communications purposes between two hosts. A multicast address is a single address that is selectively sent to a multicast group of hosts. An anycast address is a single IP address that is selectively routed to depending on the location of the originating host."
    },
    {
       "id":141,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"You work for an ISP. The American Registry for Internet Numbers (ARIN) has given you the 2001:0db8:8/34 IP address block. How many /48 blocks can you assign to your customers?",
       "choice_a":"32,768",
       "choice_b":"16,384",
       "choice_c":"8,192",
       "choice_d":"4,096",
       "correct_answer":"B",
       "explanation":"The answer is 16,384 networks. You subtract 34 bits from 48 bits = 14 bits, then 214 = 16,384. All of the other options are incorrect."
    },
    {
       "id":142,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"What protocol/process in IPv6 replaces the IPv4 ARP process?",
       "choice_a":"NDP (NS/NA)",
       "choice_b":"DAD (NS/NA)",
       "choice_c":"SLAAC (RS/RA)",
       "choice_d":"ARPv6 (NS/NA)",
       "correct_answer":"A",
       "explanation":"The Neighbor Discovery Protocol (NDP) uses Neighbor Solicitation (NS) and Neighbor Advertisement (NA) messages to look up an IP address from a MAC address through the use of multicast messages. Duplicate Address Detection (DAD) uses Neighbor Solicitation (NS) and Neighbor Advertisement (NA) messages to check if another host has the same IPv6 address. Stateless Address Autoconfiguration (SLAAC) uses Router Solicitation (RS) and Router Advertisement (RA) to assign a network ID to a host. The ARP protocol is completely removed from IPv6; therefore ARPv6 is not a valid answer."
    },
    {
       "id":143,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"Which address is a global unicast address?",
       "choice_a":"fe80:db80:db01:ada0:1112::1",
       "choice_b":"2005:acd:234:1132::43",
       "choice_c":"fd00:ac34:34b:8064:234a::7",
       "choice_d":"ff00:101:4ab0:3b3e::10",
       "correct_answer":"B",
       "explanation":"The global unicast address is defined as 2000::/3. This provides a valid range of 2000:: to 3fff::. An address with a network prefix of fe80::/10 is a link-local address. An address with a network prefix of fc00::/7 is a unique local unicast address. An address with a network prefix of ff00::/8 is a multicast address."
    },
    {
       "id":144,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"For global unicast addresses, which part of the address is allotted by the regional Internet registry (RIR) for the corresponding region?",
       "choice_a":"First 23 bits",
       "choice_b":"First 32 bits",
       "choice_c":"First 48 bits",
       "choice_d":"First 64 bits",
       "correct_answer":"A",
       "explanation":"The first 23 bits are allotted to the ISP by the RIR for the region of the world for which the ISP is requesting the prefix. All of the other options are incorrect."
    },
    {
       "id":145,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"Which address is a unique local address?",
       "choice_a":"fe80:db80:db01:ada0:1112::1",
       "choice_b":"2005:acd:234:1132::43",
       "choice_c":"fd00:ac34:34b:8064:234a::7",
       "choice_d":"ff00::10",
       "correct_answer":"C",
       "explanation":"The unique local address is defined as fc00::/7. Unique local addresses have replaced site-local addresses as of 2004 and are non-routable. The valid IPv6 range is fc00:: to fd00:: despite IANA reserving fc00::/7 as the fc00:: range. The range should not be used since the 8th bit is considered the \u0022local bit\u0022 and is required to be a 1, as in, for example, 1111 1101 = fd. An address with a network prefix of fe80::/10 is a link-local address. An address with a network prefix of 2000::/3 is a unique local unicast address. An address with a network prefix of ff00::/8 is a multicast address."
    },
    {
       "id":146,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"Which IPv6 address type is similar to IPv4 RFC 1918 addresses?",
       "choice_a":"Link-local addresses",
       "choice_b":"Global unicast addresses",
       "choice_c":"EUI-64 addresses",
       "choice_d":"Anycast addresses",
       "correct_answer":"A",
       "explanation":"IPv4 RFC 1918 addresses are defined as private non-routable IP addresses. In IPv6, link-local addresses are the equivalent to RFC 1918 addresses and are non-routable. Global unicast addresses are similar to IPv4 public IP addresses. An EUI-64 address is the host interface portion of the IPv6 address when it is configured using the host\u0027s MAC address. Anycast addresses are IPv6 addresses that are applied to multiple hosts and routed to the hosts based upon proximity; root DNS servers use anycast in this manner."
    },
    {
       "id":147,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"Which address is a link-local address?",
       "choice_a":"fe80:db80:db01:ada0:1112::1",
       "choice_b":"2005:acd:234:1132::43",
       "choice_c":"fd00:ac34:34b:8064:234a::7",
       "choice_d":"ff00:101:4ab0:3b3e::10",
       "correct_answer":"A",
       "explanation":"The link-local address is defined as fe80::/10. Any address starting with fe80 is non-routable. A global unicast address is defined as 2000::/3. This provides a valid range of 2000:: to 3fff::. An address with a network prefix of fc00::/7 is a unique local unicast address. The network address of fd00 would be part of the fc00::/7 network range. An address with a network prefix of ff00::/8 is a multicast address."
    },
    {
       "id":148,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"Which method is used to direct communications to the IP address that is closest to the source?",
       "choice_a":"Unicast",
       "choice_b":"Broadcast",
       "choice_c":"Multicast",
       "choice_d":"Anycast",
       "correct_answer":"D",
       "explanation":"Anycast is a way of allowing the same IP address on multiple machines in different geographical areas. The routing protocol is used to advertise in routing tables the closest IP by the use of metrics. Currently this is how DNS root servers work. A unicast address is a single valid IP address for direct communications purposes between two hosts. A broadcast will forward a message to all computers in the same subnet. A multicast address is a single address that is selectively sent to a multicast group of hosts."
    },
    {
       "id":149,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"Which command would configure a single anycast address on a router\u0027s interface?",
       "choice_a":"<code>Router(config-if)#ip address</code><br><code>2001:db8:1:1:1::12/64</code>",
       "choice_b":"<code>Router(config-if)#ipv6 address</code><br><code>2001:db8:1:1:1::12/64 anycast</code>",
       "choice_c":"<code>Router(config-if)#ipv6 anycast</code><br><code>address 2001:db8:1:1:1::12/128</code>",
       "choice_d":"<code>Router(config-if)#ipv6 address</code><br><code>2001:db8:1:1:1::12/128 anycast</code>",
       "correct_answer":"D",
       "explanation":"The command to configure an anycast address on an interface would be <code>ipv6 address 2001:db8:1:1:1::12/128 anycast</code>. The /128 defines a single IP address to advertise in routing tables. The command <code>ip address 2001:db8:1:1:1::12/64</code> is incorrect. The command <code>ipv6 address 2001:db8:1:1:1::12/64 anycast</code> is incorrect. The command <code>ipv6 anycast address 2001:db8:1:1:1::12/128</code> is incorrect."
    },
    {
       "id":150,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"Which method is used to direct communications to a group of computers that subscribe to the transmission?",
       "choice_a":"Unicast",
       "choice_b":"Broadcast",
       "choice_c":"Multicast",
       "choice_d":"Anycast",
       "correct_answer":"C",
       "explanation":"Multicast is used to allow computers to opt into a transmission. Examples of uses for multicast are video, routing protocols, and imaging of computers to name a few. A unicast address is a single valid IP address for direct communications purposes between two hosts. A broadcast will forward a message to all computers in the same subnet. A multicast address is a single address that is selectively sent to a multicast group of hosts. Anycast is a way of allowing the same IP address on multiple machines in different geographical areas. The routing protocol is used to advertise in routing tables the closest IP by the use of metrics."
    },
    {
       "id":151,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"Which address is a multicast address?",
       "choice_a":"fe80:db80:db01:ada0:1112::1",
       "choice_b":"2005:acd:234:1132::43",
       "choice_c":"fd00:ac34:34b:8064:234a::7",
       "choice_d":"ff00::10",
       "correct_answer":"D",
       "explanation":"The multicast address is defined as ff00::/8. Multicast addresses always start with ff. The link-local address is defined as fe80::/10. Any address starting with fe80 is non-routable. A global unicast address is defined as 2000::/3. This provides a valid range of 2000:: to 3fff::. An address with a network prefix of fc00::/7 is a unique local unicast address. The network address fd00 would be part of the fc00::/7 network range."
    },
    {
       "id":152,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"You are using the EUI-64 method of allocating the host portion of the IPv6 addresses. The MAC address of the host is f423:5634:5623. Which is the correct IP address that will be calculated for a network ID of fd00:1:1::?",
       "choice_a":"fd00:0001:0001:0000:f623:56ff:fe34:5623/64",
       "choice_b":"fd00:0001:0001:0000:f423:56ff:fe34:5623/64",
       "choice_c":"fd00:0001:0001:0000:fffe:f623:5634:5623/64",
       "choice_d":"fd00:0001:0001:0000:f623:56ff:ff34:5623/64",
       "correct_answer":"A",
       "explanation":"When converting a MAC address to an EUI-64 host address, the first step is to split the MAC address into 6-byte sections of f42356 and 345623 and place fffe in between them, f423:56ff:fe34:5623. This gives you a 64-bit value comprised of a 48-bit MAC address and a 16-bit filler. You must then invert \u0022flip\u0022 the 7th bit. Example: f4 = 1111 0100 = flipped = 1111 0110 = f6. All of the other options are incorrect."
    },
    {
       "id":153,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":1,
       "question":"Which address is a EUI-64 generated address?",
       "choice_a":"2001:db8:33::f629:58fe:ff35:5893/64",
       "choice_b":"fd00:4:33::f680:45ca:ac3b:5a73/64",
       "choice_c":"2001:db8:aa::f654:56ff:fe34:a633/64",
       "choice_d":"2001:db8:17:fffe:f623::ff34:5623/64",
       "correct_answer":"C",
       "explanation":"The EUI-64 address can always be found by looking at the last 64 bits. In between the last 64 bits of the address, you will always find fffe. For example, the last 64 bits of the address of 2001:db8:aa::f654:56ff:fe34:a633 is f654:56ff:fe34:a633. All other options are incorrect."
    },
    {
       "id":154,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":"",
       "question":"Which command would use the MAC address for the host portion of the IPv6 address on a router interface?",
       "choice_a":"<code>Router(config-if)#ip address eui-64</code><br><code>2001:db8:1234::/64</code>",
       "choice_b":"<code>Router(config-if)#ip address</code><br><code>2001:db8:1234::/64 mac-address</code>",
       "choice_c":"<code>Router(config-if)#ipv6 address</code><br><code>2001:db8:1234::/64 eui-64</code>",
       "choice_d":"<code>Router(config-if)#ipv6 address</code><br><code>2001:db8:1234::/64 mac</code>",
       "correct_answer":"C",
       "explanation":"The command to set an EUI-64 address for the host portion of the IPv6 address on an interface is <code>ipv6 address 2001:db8:1234::/64 eui-64</code>. The command <code>ip address eui-64 2001:db8:1234::/64</code> is incorrect. The command <code>ip address 2001:db8:1234::/64 mac-address</code> is incorrect. The command <code>ipv6 address 2001:db8:1234::/64 mac</code> is incorrect."
    },
    {
       "id":155,
       "topic_id":1,
       "sub_domain":"1.10 Verify IP parameters for Client OS (Windows, Mac OS, Linux)",
       "practice_test_id":"",
       "question":"Which command on Windows will allow you to verify your IP address, subnet mask, default gateway, and MAC address?",
       "choice_a":"<code>C:\\>ipconfig</code>",
       "choice_b":"<code>C:\\>ipstatus</code>",
       "choice_c":"<code>C:\\>ipconfig /all</code>",
       "choice_d":"<code>C:\\>hostname</code>",
       "correct_answer":"C",
       "explanation":"The command <code>ipconfig /all</code> will help you verify the IP address, subnet mask, default gateway, and MAC address of your computer. The command <code>ipconfig</code> doesn\u0027t show the MAC address. The <code>ipconfig</code> command will give brief information about the interfaces on the Windows host. The command <code>ipstatus</code> is not a valid command. The command <code>hostname</code> will display the name of the Windows host."
    },
    {
       "id":156,
       "topic_id":1,
       "sub_domain":"1.10 Verify IP parameters for Client OS (Windows, Mac OS, Linux)",
       "practice_test_id":"",
       "question":"Which command on Windows will allow you to verify the path a packet gets routed through on the network?",
       "choice_a":"<code>C:\\>tracert 198.78.34.2</code>",
       "choice_b":"<code>C:\\>ping 198.78.34.2</code>",
       "choice_c":"<code>C:\\>traceroute 198.78.34.2</code>",
       "choice_d":"<code>C:\\>route print</code>",
       "correct_answer":"A",
       "explanation":"The Windows command for tracing a route is <code>tracert</code>. The command <code>ping 198.78.34.2</code> will send ICMP packets to the destination host of 198.78.34.2 and report the round-trip time. The command <code>traceroute 198.78.34.2</code> is a Linux/Unix command for verifying the path a packet is routed. The command <code>route print</code> is used to view the routing table on a Windows host."
    },
    {
       "id":157,
       "topic_id":1,
       "sub_domain":"1.10 Verify IP parameters for Client OS (Windows, Mac OS, Linux)",
       "practice_test_id":"",
       "question":"Your DNS administrator has changed the DNS entry for RouterB. You clear the DNS cache on RouterA and ping <code>routerb.sybex.com</code> from RouterA, but you still ping the original address prior to the change. All other DNS addresses work fine and the entry resolves correctly on your laptop. What is the problem?",
       "choice_a":"The router is configured to the wrong DNS server",
       "choice_b":"RouterA has a host entry configured",
       "choice_c":"The DNS administrator made an error",
       "choice_d":"The domain name of the router is incorrect.",
       "correct_answer":"B",
       "explanation":"If the cache is cleared after the change has been made to DNS and you still get the same IP address, the reason is most likely that there is a host entry configured. The command <code>show running-config</code> will show you if there is an entry. The router is not likely to be configured to the wrong DNS server because the authoritative domain of sybex.com is used. The DNS administrator could have made an error, but it resolves correctly on your laptop. The domain name is not the problem because it resolves correctly on your laptop."
    },
    {
       "id":158,
       "topic_id":1,
       "sub_domain":"1.10 Verify IP parameters for Client OS (Windows, Mac OS, Linux)",
       "practice_test_id":1,
       "question":"You have configured a router to point to the DNS server with the IP address 10.2.2.2 and configured the domain name of sybex.com. However, you cannot resolve the host <code>routerb.sybex.com.</code> Which Windows command will help you verify DNS name resolution?",
       "choice_a":"<code>C:\\>ping routerb.sybex.com</code>",
       "choice_b":"<code>C:\\>tracert routerb.sybex.com</code>",
       "choice_c":"<code>C:\\>nslookup routerb.sybex.com</code>",
       "choice_d":"<code>C:\\>dig routerb.sybex.com</code>",
       "correct_answer":"C",
       "explanation":"The command <code>nslookup routerb.sybex.com</code> will allow you to positively verify name resolution. The <code>ping</code> command should not be used because the failure of ICMP echo will make the command fail, giving you a false result. The <code>tracert</code> command is used for tracing the route a packet takes, and like <code>ping</code> it can give a false positive if the host is unreachable. The <code>dig</code> command is a great tool to use in place of <code>nslookup</code> for verifying DNS, but it is not installed on Windows by default."
    },
    {
       "id":159,
       "topic_id":1,
       "sub_domain":"1.10 Verify IP parameters for Client OS (Windows, Mac OS, Linux)",
       "practice_test_id":"",
       "question":"Which Windows command will allow you to see the DHCP server that has configured the client computer with an IP address?",
       "choice_a":"<code>C:\\>ipconfig</code>",
       "choice_b":"<code>C:\\>ipconfig /all</code>",
       "choice_c":"<code>C:\\>ipconfig /showclassid</code>",
       "choice_d":"<code>C:\\>ipstatus</code>",
       "correct_answer":"B",
       "explanation":"The command <code>ipconfig /all</code> will display the generic information of IP, subnet mask, and gateway. It will also display the DHCP server that configured the client with an IP address. The standard <code>ipconfig</code> command will give you brief information, but not the DHCP server. The <code>ipconfig /showclassid</code> command will display the class information reported to the DHCP server. The <code>ipstatus</code> command is not a valid command, and therefore, it is not the correct answer."
    },
    {
       "id":160,
       "topic_id":1,
       "sub_domain":"1.10 Verify IP parameters for Client OS (Windows, Mac OS, Linux)",
       "practice_test_id":"",
       "question":"You have configured a DHCP server on a router interface. You test a Windows client and receive the address 169.254.24.56. What can you conclude?",
       "choice_a":"You have successfully configured the scope of 169.254.24.0/24",
       "choice_b":"The client had a static IP address of 169.254.24.0/24 configured",
       "choice_c":"The DHCP server is not configured properly and the client has configured itself with a link-local address",
       "choice_d":"The DHCP server is configured for APIPA",
       "correct_answer":"C",
       "explanation":"The DHCP server is not configured properly. When a Windows client configures itself with an IP address of 169.254. <italic>x.x</italic>, it is using APIPA, or Automatic Private IP Addressing (link-local addressing). It is highly unlikely that anyone would configure an APIPA scope since it is used in absence of a DHCP server. It is also highly unlikely that you would configure a client with a static IP address in the APIPA range. DHCP servers cannot be configured for APIPA."
    },
    {
       "id":161,
       "topic_id":1,
       "sub_domain":"1.11 Describe wireless principles",
       "practice_test_id":"",
       "question":"Which is the contention method 802.11 wireless uses?",
       "choice_a":"CSMA/CA",
       "choice_b":"CSMA/CD",
       "choice_c":"DSSS",
       "choice_d":"OFDM",
       "correct_answer":"A",
       "explanation":"802.11 uses a contention method of Carrier Sense Multiple Access/Collision Avoidance. 802.11 implements a Request-to-Send/Clear-to-Send mechanism that avoids collisions. Ethernet uses a contention method of Carrier Sense Multiple Access/Collision Detection. Both Direct-Sequence Spread Spectrum (DSSS) and Orthogonal Frequency Division Multiplexing (OFDM) are wireless modulations used to transmit data."
    },
    {
       "id":162,
       "topic_id":1,
       "sub_domain":"1.11 Describe wireless principles",
       "practice_test_id":"",
       "question":"In the 2.4 GHz spectrum for 802.11, which channels are non-overlapping?",
       "choice_a":"Channels 1, 3, and 11",
       "choice_b":"Channels 1, 3, and 6",
       "choice_c":"Channels 1, 6, and 11",
       "choice_d":"Channels 1 through 6",
       "correct_answer":"C",
       "explanation":"In the 2.4 GHz spectrum for 802.11, there are three non-overlapping channels: 1, 6, and 11, each of which is 22 MHz wide. Although channel 14 technically is non-overlapping, it is only allowed in Japan. All of the other options are incorrect."
    },
    {
       "id":163,
       "topic_id":1,
       "sub_domain":"1.11 Describe wireless principles",
       "practice_test_id":"",
       "question":"You are designing a wireless network for an office building. The building has a large number of tenants that utilize wireless already. Which protocol will least likely overlap with wireless channels the tenants are currently using?",
       "choice_a":"802.11b",
       "choice_b":"802.11g",
       "choice_c":"802.11n",
       "choice_d":"802.11ac",
       "correct_answer":"D",
       "explanation":"The 802.11ac protocol will be least likely to overlap the wireless channels the tenants are using. The 802.11ac protocol uses the 5 GHz wireless frequency spectrum. The 5 GHz spectrum defines 24 non-overlapping wireless channels. The 2.4 GHz spectrum defines 11 channels, but only 3 of them are non-overlapping. Although 802.11n operates on 2.4 GHz and 5 GHz, 802.11ac only operates on 5 GHz. Therefore, 802.11ac will have the least likely overlap of current channels. 802.11b and 802.11g operate solely on the 2.4 GHz spectrum."
    },
    {
       "id":164,
       "topic_id":1,
       "sub_domain":"1.11 Describe wireless principles",
       "practice_test_id":"",
       "question":"Which wireless encryption protocol uses a 24-bit initialization vector?",
       "choice_a":"WPA",
       "choice_b":"WEP",
       "choice_c":"WPA2",
       "choice_d":"WPA3",
       "correct_answer":"B",
       "explanation":"Wired Equivalent Privacy (WEP) uses either 40- or 104-bit encryption; it also uses a 24-bit initialization vector (IV) to randomize each session. The encryption and IV combined, WEP advertises encryption strength of 64-bit or 128-bit. All Wi-Fi Protected Access (WPA) variants use a variety of other mechanisms, but they do not use initialization vectors."
    },
    {
       "id":165,
       "topic_id":1,
       "sub_domain":"1.11 Describe wireless principles",
       "practice_test_id":"",
       "question":"Which wireless standard does not use a pre-shared key for authentication?",
       "choice_a":"WPA",
       "choice_b":"WPA2",
       "choice_c":"WEP",
       "choice_d":"WPA2 Enterprise",
       "correct_answer":"D",
       "explanation":"WPA2 Enterprise does not use a pre-shared key (PSK) for authentication. In lieu of a PSK, WPA2 Enterprise uses certificates to authentication users. WPA, WPA2, and WEP use a pre-shared key for authentication."
    },
    {
       "id":166,
       "topic_id":1,
       "sub_domain":"1.11 Describe wireless principles",
       "practice_test_id":"",
       "question":"When designing a wireless network, which would be a compelling reason to use 5 GHz?",
       "choice_a":"5 GHz can go further",
       "choice_b":"5 GHz allows for more clients",
       "choice_c":"There are 24 non-overlapping channels",
       "choice_d":"There is less interference on 5 GHz",
       "correct_answer":"C",
       "explanation":"The 5 GHz band for 802.11 a/n/ac has 24 non-overlapping channels. The 2.4 GHz band for 802.11 b/g/n has only 3 non-overlapping channels. If the clients are compatible with 802.11 a/n/ac, it is desirable to use 5 GHz. 2.4 GHz goes further than 5 GHz; therefore, 5 GHz should not be used when distance is a concern. 5 GHz will not allow more clients to join the wireless access point (WAP). There is the same amount of interference on both 2.4 GHz and 5 GHz."
    },
    {
       "id":167,
       "topic_id":1,
       "sub_domain":"1.11 Describe wireless principles",
       "practice_test_id":"",
       "question":"Which wireless frequency spectrum is shared with Bluetooth?",
       "choice_a":"900 MHz",
       "choice_b":"2.4 GHz",
       "choice_c":"5 GHz",
       "choice_d":"All of the above",
       "correct_answer":"B",
       "explanation":"The 2.4 GHz frequency spectrum is where Bluetooth operates, and the frequency is also shared with 802.11. 900 MHz is used by Zigbee, which is an Internet of Things (IoT) communication technology. 5 GHz is shared with some radar systems, mainly on the upper channels of the frequency spectrum."
    },
    {
       "id":168,
       "topic_id":1,
       "sub_domain":"1.11 Describe wireless principles",
       "practice_test_id":"",
       "question":"Which 802.11 standard functions strictly on 2.4 GHz?",
       "choice_a":"802.11g",
       "choice_b":"802.11n",
       "choice_c":"802.11a",
       "choice_d":"802.11ac",
       "correct_answer":"A",
       "explanation":"The 802.11g wireless standard operates strictly on 2.4 GHz. The 802.11n wireless standard operates on both 2.4 GHz and 5 GHz. Both the 802.11a and 802.11ac wireless standards operate on 5 GHz."
    },
    {
       "id":169,
       "topic_id":1,
       "sub_domain":"1.12 Explain virtualization fundamentals (virtual machines)",
       "practice_test_id":"",
       "question":"Which allows for the distribution of compute resources such as CPU and RAM to be distributed over several operating systems?",
       "choice_a":"Physical server",
       "choice_b":"Hypervisor",
       "choice_c":"Virtual machine",
       "choice_d":"Virtual network",
       "correct_answer":"B",
       "explanation":"The hypervisor allows for multiple operating systems to share CPUs, RAM, network, and storage of a physical server. A physical server alone will not distribute resources over several operating systems. A virtual machine is what runs on top of the hypervisor. A virtual network is a resource that is shared on a hypervisor to the running virtual machines."
    },
    {
       "id":170,
       "topic_id":1,
       "sub_domain":"1.12 Explain virtualization fundamentals (virtual machines)",
       "practice_test_id":"",
       "question":"Which option describes a VM best?",
       "choice_a":"An operating system that is running directly on hardware",
       "choice_b":"An operating system that is running with dedicated hardware",
       "choice_c":"An operating system that is running on reduced hardware features",
       "choice_d":"An operating system that is decoupled from the hardware",
       "correct_answer":"D",
       "explanation":"A virtual machine, or VM, is an operating system that is running on hardware but is not directly attached to the hardware. It is decoupled from the hardware through the use of a hypervisor. The hypervisor creates an abstraction layer between the hardware and the operating system. An operating system that runs directly on hardware is not classified as a virtual machine since it monopolizes the hardware. An operating system that is running with dedicated hardware is not classified as a virtual machine because it has dedicated hardware. An operating system that is running on reduced hardware features is not classified as a virtual machine because it still runs directly on the hardware."
    },
    {
       "id":171,
       "topic_id":1,
       "sub_domain":"1.12 Explain virtualization fundamentals (virtual machines)",
       "practice_test_id":"",
       "question":"What is the physical hardware used in virtualization called?",
       "choice_a":"Host",
       "choice_b":"VM",
       "choice_c":"Hypervisor",
       "choice_d":"Guest",
       "correct_answer":"A",
       "explanation":"The physical hardware (such as a server) used in virtualization is the host. The virtual machine (VM) runs on top of the hypervisor and allows for an operating system to be virtually installed. The hypervisor is installed on the host to allow multiple virtual machines to share the physical hardware. The guest is another name for virtual machines, since they are guests to the hardware via the hypervisor."
    },
    {
       "id":172,
       "topic_id":1,
       "sub_domain":"1.12 Explain virtualization fundamentals (virtual machines)",
       "practice_test_id":1,
       "question":"Which component connects the VM NIC to the physical network?",
       "choice_a":"vNIC",
       "choice_b":"Trunk",
       "choice_c":"Virtual switch",
       "choice_d":"NX-OS",
       "correct_answer":"C",
       "explanation":"A virtual switch connects the virtual machine NIC to the physical network. The virtual network interface card (vNIC) is the virtualized network card presented to the virtual machine. A trunk is a mode for a switchport or virtual switch that allows multiple VLANs to be tagged over a single virtual or physical link. NX-OS is a Cisco operating system that runs on the line of Nexus data center switches."
    },
    {
       "id":173,
       "topic_id":1,
       "sub_domain":"1.12 Explain virtualization fundamentals (virtual machines)",
       "practice_test_id":"",
       "question":"Which of the following is a virtual network function (VNF) device?",
       "choice_a":"Virtual switch",
       "choice_b":"Virtual firewall",
       "choice_c":"Database server",
       "choice_d":"File server",
       "correct_answer":"B",
       "explanation":"A virtual firewall or virtual router is an example of a VNF. These devices are typically network functions that are found in internal networks such as firewalls and routers. These devices perform basic network functionality and run as virtual machines or virtual instances. A virtual switch is not considered a VNF because it is an elemental part of the hypervisor, used for communications. A database server and file server are not functions of a network; they are roles found on servers."
    },
    {
       "id":174,
       "topic_id":1,
       "sub_domain":"1.12 Explain virtualization fundamentals (virtual machines)",
       "practice_test_id":"",
       "question":"You need to scale out some web servers to accommodate load. Which method would you use?",
       "choice_a":"Add vCPUs",
       "choice_b":"Add vRAM",
       "choice_c":"Add DNS",
       "choice_d":"Add SLBaaS",
       "correct_answer":"D",
       "explanation":"If you wanted to scale a web server out to several other web servers, you would use Server Load Balancing as a Server (SLBaaS) from your cloud provider. Adding resources such as vCPUs and vRAM is an example of scaling a server up, not out. Adding DNS will not offset or accommodate the additional load on the web servers."
    },
    {
       "id":175,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Which is a correct statement about MAC addresses?",
       "choice_a":"Organizationally unique identifiers (OUIs) create a unique MAC address",
       "choice_b":"The first 24 bits of a MAC address are specified by the vendor",
       "choice_c":"The IEEE is responsible for MAC address uniqueness",
       "choice_d":"If the I/G bit is set to 1, then the frame identifies a broadcast or multicast",
       "correct_answer":"D",
       "explanation":"When the Individual/Group (I/G) high order bit is set to 1, the frame is a broadcast or a multicast transmission. The OUI assigned by the IEEE is only partially responsible for MAC uniqueness. The vendor is responsible for the last 24 bits of a MAC address."
    },
    {
       "id":176,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Which command would you use to diagnose a problem with frames that are not getting forwarded to the destination node on a switch?",
       "choice_a":"<code>Switch</code>#<code>show route</code>",
       "choice_b":"<code>Switch</code>#<code>show mac address-table</code>",
       "choice_c":"<code>Switch</code>#<code>show mac table</code>",
       "choice_d":"<code>Switch</code>#<code>show interface</code>",
       "correct_answer":"B",
       "explanation":"When you\u0027re diagnosing frame forwarding on a switch, the MAC address table needs to be inspected to see if the switch has learned the destination MAC address. You can use the command <code>show mac address-table</code> to inspect the MAC address table. The command <code>show route</code> is incorrect; it only displays layer 3 route decision information. The command <code>show mac table</code> is incorrect. The command <code>show interface</code> is incorrect; it will not display information on how the switch will make forward/filter decisions."
    },
    {
       "id":177,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Which mechanism does a switch employ to stop switching loops?",
       "choice_a":"Port channels",
       "choice_b":"Spanning Tree Protocol (STP)",
       "choice_c":"Ether channels",
       "choice_d":"Trunks",
       "correct_answer":"B",
       "explanation":"The mechanism that switches use for loop avoidance is STP, or Spanning Tree Protocol. Port channels are used to aggregate bandwidth between two switches. <italic>Ether channels</italic> is a Cisco-centric term for port channels. Trunk is a switchport mode that allows multiple VLANs to traverse over a single link by tagging each frame with the respective VLAN."
    },
    {
       "id":178,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Which is a consequence of not using loop avoidance with layer 2 switching?",
       "choice_a":"Duplicate unicast frames",
       "choice_b":"Broadcast storms",
       "choice_c":"MAC address thrashing",
       "choice_d":"All of the above",
       "correct_answer":"D",
       "explanation":"When loop avoidance such as STP is not employed and loops exist, you will get duplicate unicast frames and broadcast storms. This will inevitably thrash the MAC address table and degrade bandwidth to nothing."
    },
    {
       "id":179,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Which switching method checks the CRC as the frame is received by the switch?",
       "choice_a":"Cut-through mode",
       "choice_b":"Frag-free mode",
       "choice_c":"Store-and-forward mode",
       "choice_d":"Fast switching",
       "correct_answer":"C",
       "explanation":"Store-and-forward mode is the default mode for mode edge switching equipment. Store-and-forward receives the frame, calculates the CRC, and then makes a forwarding decision. Cut-through mode allows the switch to make a forward/filter decision immediately after the destination MAC address is received. Frag-free mode inspects the first 64 bytes of an incoming frame, before a forward/filter decision is made. Fast switching is a method in which a caching table is created for MAC addresses received so that switching can be made faster."
    },
    {
       "id":180,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Which switch mode operation reads only the first 64 bytes before making a switching decision?",
       "choice_a":"Cut-through mode",
       "choice_b":"Fragment-free mode",
       "choice_c":"Store-and-forward mode",
       "choice_d":"Fast switching",
       "correct_answer":"B",
       "explanation":"Fragment-free mode reads the first 64 bytes and deems the frame intact and forwardable. This is because most collisions that would create frame fragments happen within the first 64 bytes of a frame. This method of switching is often found on SOHO switching equipment. Store-and-forward mode is the default mode for mode edge switching equipment. Store-and-forward receives the frame, calculates the CRC, and then makes a forwarding decision. Cut-through mode allows the switch to make a forward/filter decision immediately after the destination MAC address is received. Fast switching is a method in which a caching table is created for MAC addresses received so that switching can be made faster."
    },
    {
       "id":181,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"A user is complaining of extremely long logon times. Using the following exhibit, what can you conclude? <img src='/question_assets/ccna/1_image17.png'></img>",
       "choice_a":"The connection to the computer needs to be upgraded to 100 Mb/s.",
       "choice_b":"The connection to the computer has wiring issues",
       "choice_c":"The NIC in the attached computer is going bad and needs replacement",
       "choice_d":"The interface or computer is running at half-duplex",
       "correct_answer":"D",
       "explanation":"The  interface shows a high number of collisions. In a full-duplex network connection, there should be no collisions. This would suggest that the port on the switch or the NIC in the computer is set to half-duplex. Half-duplex causes collisions, which can degrade bandwidth by 40% to 60%. Upgrading the computer to 100 Mb/s will not solve the high collision rate; it will just allow more collisions to happen more quickly. You cannot conclude there is a wiring issue from the details of the interface. Although it is always possible a NIC is going bad, the NIC is still passing traffic, and there are not enough details in the output of the interface."
    },
    {
       "id":182,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"How are MAC addresses learned and associated with the port?",
       "choice_a":"Destination MAC address learning",
       "choice_b":"Source MAC address learning",
       "choice_c":"Port listen/learning",
       "choice_d":"Frame type learning",
       "correct_answer":"B",
       "explanation":"Switches learn MAC addresses by inspecting the frame\u0027s source MAC address on the incoming port. They then associate the source MAC address with the port it came in on. The destination MAC address is what the forward/filter decisions are based upon. Spanning Tree Protocol (STP) listens and learns Bridge Protocol Data Units (BPDUs) so it can detect loops or potential loops. Frame type learning is not a real concept; therefore, it is an invalid answer."
    },
    {
       "id":183,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"In the following exhibit, what will happen if the computers on ports Fa0/1 (Computer A) and Fa0/4 (Computer B) are swapped? <img src='/question_assets/ccna/1_image18.png'></img>",
       "choice_a":"Computer A\u0027s frames will only be forwarded to port Fa0/1",
       "choice_b":"Computer A\u0027s frames will be forwarded to ports Fa0/1 and Fa0/4.",
       "choice_c":"Computer A\u0027s frames will only be forwarded to port Fa0/4",
       "choice_d":"Computer B\u0027s frames will be forwarded to all ports",
       "correct_answer":"A",
       "explanation":"Computer A will no longer forward traffic because the static entry will override a dynamic entry. Computer A\u0027s frames will not be forwarded to port Fa0/4, only Fa0/1, because of the static entry. Computer B\u0027s frames will not be forwarded to all ports because computer B\u0027s MAC address will be learned on Fa0/1 along with the static entry."
    },
    {
       "id":184,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"In the following exhibit, what will happen if the computers on ports Fa0/2 (Computer A) and Fa0/3 (Computer B) are swapped? <img src='/question_assets/ccna/1_image19.png'></img>",
       "choice_a":"Computer A\u0027s frames will only be forwarded to port Fa0/2",
       "choice_b":"Computer A\u0027s frames will be forwarded to port Fa0/2 and Fa0/3",
       "choice_c":"Computer A\u0027s frames will only be forwarded to port Fa0/3",
       "choice_d":"Computer B\u0027s frames will be forwarded to all ports",
       "correct_answer":"C",
       "explanation":"Computer A\u0027s frames will be forwarded to its new port of Fa0/3 since the entries will be cleared out when the cables are disconnected and relearned. When Computer A is disconnected from Fa0/2, the MAC address entries for that port will be cleared from the table. Therefore, frames will no longer be forwarded to Fa0/2 on behalf of Computer A, only to Computer A\u0027s new port of Fa0/3. Frames are only forwarded to all active ports when the destination MAC address in a frame is not in the MAC address table."
    },
    {
       "id":185,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":1,
       "question":"What is the default MAC address aging time for dynamic entries on most switches?",
       "choice_a":"30 seconds",
       "choice_b":"60 seconds",
       "choice_c":"300 seconds",
       "choice_d":"500 seconds",
       "correct_answer":"C",
       "explanation":"The default MAC address aging time for dynamic entries is 300 seconds, or 5 minutes. All of the other options are incorrect."
    },
    {
       "id":186,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Refer to the following exhibit. Which statement is true about the computer with a MAC address of 0001.6c58.24ae? <img src='/question_assets/ccna/1_image20.png'></img>",
       "choice_a":"The computer is directly connected to Gi0/1",
       "choice_b":"The computer is directly connected to Fa0/1",
       "choice_c":"The computer is connected to another switch on Gi0/1",
       "choice_d":"The MAC address table is thrashed due to a loop",
       "correct_answer":"C",
       "explanation":"The computer is connected to either another switch or another hub on Gi0/1 since there are multiple MAC address entries on Gi0/1. The computer is not likely directly connected because of the multiple entries for Gi0/1, unless it was acting as a bridge for other computers. The computer cannot be connected to Fa0/1 since an entry is not present for the computer. There is no evidence in the exhibit that there is a loop and the MAC address table is thrashed."
    },
    {
       "id":187,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"What information is added to the MAC address table when a frame is received on an interface?",
       "choice_a":"Destination MAC address of the frame and incoming port number",
       "choice_b":"Source MAC address of the frame and incoming port number",
       "choice_c":"Destination MAC address of the frame and outgoing port number",
       "choice_d":"Source MAC address of the frame and outgoing port number",
       "correct_answer":"B",
       "explanation":"When a frame is received on an incoming port, both the incoming port and the source MAC address are added to the MAC address table and set with an aging timer. The destination MAC address in the incoming frame is used for forward/filter decisions only. The destination is never used to populate the table; the aging timer will only be updated when a frame is seen on the port and the source address is read. The source MAC address and the outgoing port number have no relationship."
    },
    {
       "id":188,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"You need to change the default MAC address aging time on a switch to 400 seconds. Which command would you use?",
       "choice_a":"<code>Switch#set mac aging 400</code>",
       "choice_b":"<code>Switch#mac aging-time 400 seconds</code>",
       "choice_c":"<code>Switch#mac-address-table aging-time 400</code>",
       "choice_d":"<code>Switch#mac address-aging 400</code>",
       "correct_answer":"C",
       "explanation":"MAC address aging time can be configured via the command <code>mac-address-table aging-time 400</code>. You can additionally specify a VLAN ID. The command <code>set mac aging 400</code> is incorrect. The command <code>mac aging-time 400 seconds</code> is incorrect. The command <code>mac address-aging 400</code> is incorrect."
    },
    {
       "id":189,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"How do switches forward frames only to the destination computer?",
       "choice_a":"Forward/filter decisions based on the MAC address table",
       "choice_b":"Forward/filter decisions based on the routing table",
       "choice_c":"Flooding ports for the destination MAC address",
       "choice_d":"Broadcasting for the MAC address",
       "correct_answer":"A",
       "explanation":"Switches make forward/filter decisions based upon the MAC address to port association in the MAC address table. Forward/filter decisions are layer 2 switching decisions and not layer 3 routing decisions; therefore, the routing table is irrelevant. A frame is only flooded to all active ports on a switch under two conditions: the destination MAC address is unknown or the MAC address table is full. Broadcasting for the MAC address is not a function of switching and, therefore, an incorrect answer."
    },
    {
       "id":190,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Referring to the following exhibit, what will happen when a frame destined for 0001.6c58.486f enters the switch? <img src='/question_assets/ccna/1_image21.png'></img>",
       "choice_a":"The frame will be forwarded to the uplink port",
       "choice_b":"The frame will be forwarded to all active ports",
       "choice_c":"The frame will be dropped",
       "choice_d":"The frame will be forwarded to a MAC address of ffff.ffff.ffff.",
       "correct_answer":"B",
       "explanation":"When a MAC address is unknown by the switch, the switch will forward the frame to all ports; this is also called flooding the frame. When the destination system acts upon it, the switch learns its MAC address through source MAC address learning. The uplink port will receive a copy of the flooded frame, but it will receive this copy along with all other active ports. Switches never drop frames unless the CRC for the frame is incorrect. The frame will never be forwarded to a broadcast MAC address of ffff.ffff.ffff unless that is the intended destination."
    },
    {
       "id":191,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Given the information in the following exhibit, which statement is true when Computer A needs to communicate with Computer C? <img src='/question_assets/ccna/1_image22.png'></img>",
       "choice_a":"Switch A and Switch B will flood the frame across all ports",
       "choice_b":"Only Switch A will flood the frame across all ports",
       "choice_c":"Only Switch B will flood the frame across all ports",
       "choice_d":"Switch A will forward traffic only to Computer C\u0027s port",
       "correct_answer":"A",
       "explanation":"Since there is nothing in the current MAC address tables or either switch, the incoming frame on Switch A will be flooded to all ports. This will include the port connecting Switch B. Switch B in turn will flood the frame to all ports. However, nothing will respond on Switch B since the host is on Switch A. Although this is wasted traffic, it is minimal since it is only the initial communications. Switch A solely flooding traffic would happen under two specific conditions: the interface of Fa0/3 on Switch A was down or Switch B has an entry for the destination host. Neither of these conditions exists in the exhibit; therefore, both switches will flood the frame out all active ports. Switch A cannot switch the frame to Fa0/2 (Computer C) because the MAC address table is empty for that port."
    },
    {
       "id":192,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Given the information in the following exhibit, which statement is true when Computer A needs to communicate with Computer F? <img src='/question_assets/ccna/1_image23.png'></img>",
       "choice_a":"Switch A and Switch B will flood the frame across all ports",
       "choice_b":"Only Switch A will flood the frame across all ports",
       "choice_c":"Only Switch B will flood the frame across all ports",
       "choice_d":"Switch A will flood the frame across all ports. Switch B will forward traffic only to Computer F\u0027s port",
       "correct_answer":"A",
       "explanation":"Since there is nothing in the current MAC address tables or either switch, the incoming frame on Switch A will be flooded to all ports. This will include the port connecting Switch B. Switch B in turn will flood the frame to all ports. Switch A solely flooding traffic would happen under two specific conditions: the interface of Fa0/3 on Switch A was down or Switch B has an entry for the destination host. Neither of these conditions exists in the exhibit; therefore, both switches will flood the frame out all active ports. Both switches will flood the frame because both of their MAC address tables are empty. Switch B cannot switch the frame to Fa0/3 (Computer F) because the MAC address table is empty for that port."
    },
    {
       "id":193,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Under which circumstance will a switch drop a frame?",
       "choice_a":"If the destination MAC address of the frame is unknown in the MAC address table",
       "choice_b":"If the source MAC address of the frame is unknown in the MAC address table",
       "choice_c":"If the frame is deemed to be corrupt via the CRC",
       "choice_d":"If the destination MAC address exists in another switch\u0027s MAC address table",
       "correct_answer":"C",
       "explanation":"The only time a frame is dropped is when the cyclic redundancy check (CRC) calculated against the frame\u0027s payload deems the frame corrupt. If the destination MAC address is not known, it will be flooded to all active ports on the switch, but it will not be dropped. If the source MAC address of the frame is unknown in the MAC address table, the source MAC address will be learned on the incoming port. If the destination MAC address exists in another switch\u0027s MAC address table, then it will either be forward to that switch or flooded to that switch if the current switch has an empty MAC address table for the entry."
    },
    {
       "id":194,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Which switch function reads the frame and uses the MAC address table to decide the egress interface for the frame?",
       "choice_a":"Forward/filter",
       "choice_b":"Address learning",
       "choice_c":"Loop avoidance",
       "choice_d":"Frame flooding",
       "correct_answer":"A",
       "explanation":"The forward/filter function of a switch is used to look up the destination MAC address in a MAC address table and decide the egress interface for the frame. If the MAC address is not in the table, the frame is forwarded out all of the interfaces. When the client responds, its source MAC address will be recorded in the MAC address table for future lookup. Address learning is performed when frames enter into the interface; the source address is written to the port it is observed on. Loop avoidance employs Spanning Tree Protocol (STP) to block redundant links to prevent loops. Frame flooding is a default action of the forward/filter process when a destination frame is unknown."
    },
    {
       "id":195,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"In the following exhibit, what will happen first at the switch when Computer A wants to send Computer B a message? <img src='/question_assets/ccna/1_image24.png'></img>",
       "choice_a":"The switch will forward the frame to all ports on the switch",
       "choice_b":"The switch will direct communication to port Fa0/1",
       "choice_c":"The switch will record Computer A\u0027s MAC address on port Fa0/0.",
       "choice_d":"The switch will record Computer B\u0027s MAC address on port Fa0/1",
       "correct_answer":"C",
       "explanation":"Computer A will create an ARP (broadcast) request. When that request is received on port Fa0/0, the switch will record Computer A\u0027s MAC address on Fa0/0. Then it will forward the message to all ports because the initial ARP packet/frame is a layer 2 broadcast. The switch will not directly communicate with Fa0/1 because the MAC address table is empty and the initial ARP packet/frame is a broadcast. The switch will only record Computer B\u0027s MAC address on port Fa0/1 when Computer B responds to the initial ARP packet/frame with a frame containing the source MAC address."
    },
    {
       "id":196,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"In the following exhibit, what will happen first when Computer A wants to sends Computer B a message? <img src='/question_assets/ccna/1_image25.png'></img>",
       "choice_a":"The switch will forward the frame to all ports on the switch",
       "choice_b":"The switch will direct communication to port Fa0/1",
       "choice_c":"The switch will record computer A\u0027s MAC address on port Fa0/0.",
       "choice_d":"The switch will record computer B\u0027s MAC address on port Fa0/1.",
       "correct_answer":"B",
       "explanation":"Since the MAC address table has the MAC address for Computer B, the switch will direct the frame to port Fa0/1 only. The switch will only forward the frame to all active ports if the MAC address table didn\u0027t contain the destination MAC address for Computer B. The switch will only record Computer A\u0027s MAC address on port Fa0/0 if the MAC address was not already populated in the table for that specific port. Likewise the switch will only record Computer B\u0027s MAC address on port Fa0/1 if the MAC address was not already populated in the table for that specific port."
    },
    {
       "id":197,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Which statement is true of an ARP request entering into a switch?",
       "choice_a":"The source MAC address of the frame will be all fs",
       "choice_b":"The destination MAC address of the frame will be all fs",
       "choice_c":"The switch will only forward the ARP request to the port for the destination computer",
       "choice_d":"The switch will respond directly back with an ARP reply",
       "correct_answer":"B",
       "explanation":"The destination MAC address for broadcasts are always all fs, such as ffff.ffff.ffff. The source MAC address of the frame will be the specific MAC address of the host. The switch will broadcast the frame to all ports and not just the individual port the ARP request is trying to discover. The switch will not respond directly back with an ARP reply because switches do not process ARP requests; only routers can respond when configured as an ARP proxy, which is very rare."
    },
    {
       "id":198,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Under what circumstance will a switch flood a frame to all ports on the switch?",
       "choice_a":"When the source MAC address is unknown by the switch",
       "choice_b":"When the destination MAC address is a multicast address",
       "choice_c":"When the destination MAC address is unknown by the switch",
       "choice_d":"When the destination MAC address is 0000.0000.0000",
       "correct_answer":"C",
       "explanation":"When the destination MAC address is not in the MAC address table, the switch will flood the frame to all ports on the switch. When the computer or device responds, the switch will record the source MAC address with the port on which it sees the traffic. When the source MAC address is unknown by the switch, it is recorded in the MAC address table as previously described. When a multicast address is seen by the switch, it is selectively switched to specific ports. A MAC address is never set to 0000.0000.0000, as it is an invalid format for a MAC address."
    },
    {
       "id":199,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Where are MAC address tables stored?",
       "choice_a":"Flash",
       "choice_b":"CPU registers",
       "choice_c":"RAM",
       "choice_d":"NVRAM",
       "correct_answer":"C",
       "explanation":"MAC address tables, also called CAM tables, are always built and stored temporarily in RAM. When the switch is turned off or the <code>clear</code> command is issued, the table no longer exists. Flash is used to store the Internetwork Operating System (IOS) for the switch or router. The CPU registers, also called the configuration registers, explain to the switch how to boot. The non-volatile random access memory (NVRAM) is where the configuration is stored; it is similar to flash and usually much smaller."
    },
    {
       "id":200,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Which command will allow you to see the MAC address table?",
       "choice_a":"<code>Switch#show mac</code>",
       "choice_b":"<code>Switch#show mac address-table</code>",
       "choice_c":"<code>Switch#show cam table</code>",
       "choice_d":"<code>Switch#show mac table</code>",
       "correct_answer":"B",
       "explanation":"The command to see the MAC address table is <code>show mac address-table</code>. However, on some 4000 and 6500 series switches, the command <code>show cam dynamic</code> will perform the same function. The command show mac is incorrect. The command <code>show cam table</code> is incorrect. The command <code>show mac table</code> is incorrect."
    },
    {
       "id":201,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":"",
       "question":"Which command will display all connected ports on a switch and include descriptions?",
       "choice_a":"<code>Switch#show ports</code>",
       "choice_b":"<code>Switch#show counters interfaces</code>",
       "choice_c":"<code>Switch#show interfaces counters</code>",
       "choice_d":"<code>Switch#show interfaces status</code>",
       "correct_answer":"D",
       "explanation":"The <code>show interfaces status</code> command will display the port number, connected status, VLAN, duplex, speed, and type of interface. The command <code>show ports</code> is incorrect. The command <code>show counters interfaces</code> is incorrect. The command <code>show interfaces counters</code> is incorrect."
    },
    {
       "id":202,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"You are trying to reprovision a switch in a different part of your network. However, you still see the old VLANs configured from the old network. How can you rectify the problem?",
       "choice_a":"Upgrade the IOS.",
       "choice_b":"Type <code>erase startup-config</code>, confirm it, and reload.",
       "choice_c":"Type <code>clear vlan</code>, confirm it, and reload.",
       "choice_d":"Delete the <code>vlan.dat</code>, confirm it, and reload.",
       "correct_answer":"D",
       "explanation":"The <code>vlan.dat</code> is the database for VLANs configured on a switch either manually or through VTP. It is persistent even if <code>config.text</code> (startup-configuration) is deleted. You must manually delete the <code>vlan.dat</code>. Upgrading the IOS will not delete the <code>vlan.dat</code>. Typing <code>erase startup-config</code>, confirming it, and reloading will not remove the current <code>vlan.dat.</code> Typing <code>clear vlan</code> will not remove the current <code>vlan.dat</code>."
    },
    {
       "id":203,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"What is the normal range for VLANs before you must use extended VLAN IDs?",
       "choice_a":"VLAN 1 through 1001",
       "choice_b":"VLAN 1 through 1002",
       "choice_c":"VLAN 1 through 1005",
       "choice_d":"VLAN 2 through 1002",
       "correct_answer":"A",
       "explanation":"The normal usable VLAN range for Cisco is 1 through 1001. VLANS 1002 to 1005 are reserved for Fiber Distributed Data Interface (FDDI), and Token Ring and cannot be deleted. The extended VLAN range is 1006 to 4096 used for Ethernet VLANs only."
    },
    {
       "id":204,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"Which is a benefit to converting a network from a flat layer 2 network to a routed layer 3 VLAN-enabled network?",
       "choice_a":"Increased collision domains for increased bandwidth",
       "choice_b":"Reduced complexity of design and operations",
       "choice_c":"Flexibility of user management and design",
       "choice_d":"Decreased number of broadcast domains for increased bandwidth",
       "correct_answer":"C",
       "explanation":"The flexibility of design for workgroups of clients, servers, services, etc. and the ongoing management of moving and adding people is a benefit of a routed VLAN-enabled networks. Migrating from a flat layer 2 network to a routed layer 3 network will not increase collision domains for increased bandwidth. When you add a layer 3 routed infrastructure to your flat layer 2 network, the network complexity of design and operation will increase. You will increase the number of broadcast domains for increased bandwidth when you add multiple routed VLANs."
    },
    {
       "id":205,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"You have configured a new VLAN 9 and applied it to the interface. However, you find that the computer still remains in VLAN 1. What is the problem? Refer to the following exhibit. <img src='/question_assets/ccna/2_image1.png'></img>",
       "choice_a":"The switch port is configured with <code>switchport nonegotiate</code>.",
       "choice_b":"The switch port is configured as a trunk and dot1q trunking is intervening.",
       "choice_c":"The switch port is configured as a trunk and the native VLAN is VLAN 1.",
       "choice_d":"Spanning-tree PortFast is configured and defaulting to VLAN 1.",
       "correct_answer":"C",
       "explanation":"The switch port is configured as a trunk, but since the computer was originally in VLAN 1 and the native VLAN of the interface is VLAN 1 by default, all traffic untagged was directed to the native VLAN. The command <code>switchport nonegotiate</code> will prevent the switch port from generating Dynamic Trunking Protocol (DTP) packets but will not prevent it from statically being assigned as a trunk link. The switch port will not form a trunk because the client is not configured to tag packets with 802.1q VLANs. Spanning-tree prevents switching loops and does not assist in tagging packets or directing data onto VLANs."
    },
    {
       "id":206,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"What is the extended VLAN range?",
       "choice_a":"VLAN 1002 to 4096",
       "choice_b":"VLAN 1006 to 4096",
       "choice_c":"VLAN 1006 to 4094",
       "choice_d":"VLAN 1006 to 4092",
       "correct_answer":"C",
       "explanation":"The extended VLAN range is VLAN 1006 to 4094. The normal usable VLAN range for Cisco is 1 through 1001. VLANS 1002 to 1005 are reserved for Fiber Distributed Data Interface (FDDI) and Token Ring and cannot be deleted."
    },
    {
       "id":207,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"Which command(s) will delete a VLAN?",
       "choice_a":"<code>Switch(config)#vlan database</code><br><code>Switch(config-vlan)#no vlan 9</code>",
       "choice_b":"<code>Switch(config)#vlan database</code><br><code>Switch(config-vlan)#delete vlan 9</code>",
       "choice_c":"<code>Switch(config)#no vlan 9</code>",
       "choice_d":"<code>Switch(config)#vlan 9 delete</code>",
       "correct_answer":"C",
       "explanation":"The command to delete VLAN 9 is <code>no vlan 9</code> configured from a global configuration prompt. The command <code>no vlan 9</code> configured from a VLAN prompt is incorrect. The command <code>delete vlan 9</code> is incorrect. The command <code>vlan 9 delete</code> is incorrect."
    },
    {
       "id":208,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"Which is a correct statement about frames and VLANs?",
       "choice_a":"Broadcast frames are sent to ports that are configured in different VLANs.",
       "choice_b":"Unicast frames that are not in the MAC address table are flooded to all ports in all VLANs.",
       "choice_c":"The ports that link switches together must be access links.",
       "choice_d":"Frames with a destination MAC that are not in the MAC address table are flooded to only ports in the respective VLAN.",
       "correct_answer":"D",
       "explanation":"Frames with MAC addresses that are not in the MAC address table are flooded only to the ports in the respective VLAN. Broadcast frames will not be sent outside of the VLAN they originate from because they cannot traverse a router. Unicast frames are not flooded to all ports in all VLANs; they are only flooded to all ports in the VLAN the frame has originated from. The ports that link switches together are usually trunk links so that multiple VLANs can traverse the connection."
    },
    {
       "id":209,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"What is the normal range of VLANs that can be modified on a Cisco switch with default configuration?",
       "choice_a":"VLAN 1 to 1002",
       "choice_b":"VLAN 1 to 1001",
       "choice_c":"VLAN 2 to 1002",
       "choice_d":"VLAN 2 to 1001",
       "correct_answer":"D",
       "explanation":"The normal range of VLANs on a default Cisco switch is VLAN 1 to 1001. However, VLAN 1 cannot be modified, so option D is the correct answer. All other options are incorrect."
    },
    {
       "id":210,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"Static VLANs are being used on a switch\u0027s interface. Which of the following statements is correct?",
       "choice_a":"Nodes use a VLAN policy server.",
       "choice_b":"Nodes are assigned VLANs based on their MAC address.",
       "choice_c":"Nodes are unaware of the VLAN in which they are configured.",
       "choice_d":"All nodes are in the same VLAN.",
       "correct_answer":"C",
       "explanation":"Static VLANs are VLANs that have been manually configured vs. dynamic VLANs that are configured via a VLAN Membership Policy Server (VMPS). A node will not know which VLAN it is assigned to when it is statically set via the command <code>switchport access vlan 3</code>. Nodes use a VLAN Membership Policy Server (VMPS) if the VLAN is dynamically configured. Nodes are not assigned VLANs based on their MAC address when they are statically configured. All nodes are not necessarily in the same VLAN when static VLANs are being used."
    },
    {
       "id":211,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"A switch is configured with a single VLAN of 12 for all interfaces. All nodes auto-negotiate at 100 Mb/s full-duplex. What is true if you add an additional VLAN to the switch?",
       "choice_a":"The switch will decrease its bandwidth due to overhead.",
       "choice_b":"The switch will increase its count of collision domains.",
       "choice_c":"The switch will now require a router.",
       "choice_d":"The switch will increase its bandwidth due to broadcast domains.",
       "correct_answer":"D",
       "explanation":"The addition of another VLAN will increase the effective bandwidth by adding additional broadcast domains. A router is required to route between VLANs. However, it will not be required if you are logically partitioning the switch via VLANs. The switch will not necessarily increase the count of collision domains."
    },
    {
       "id":212,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"What is a direct benefit of adding VLANs?",
       "choice_a":"An increase of broadcast domains while decreasing collision domains",
       "choice_b":"An increase of broadcast domains while increasing collision domains",
       "choice_c":"A decrease of broadcast domains while decreasing collision domains",
       "choice_d":"A decrease of broadcast domains while increasing collisions domains",
       "correct_answer":"B",
       "explanation":"When adding VLANs, you immediately increase the number of broadcast domains. At the same time, you increase collision domains. If a switch had 12 ports and they all negotiated at 100 Mb/s half-duplex (one collision domain), when a VLAN is added you will automatically create two collision domains while adding an additional broadcast domain."
    },
    {
       "id":213,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"Which statement describes dynamic VLANs?",
       "choice_a":"The access port is switched into the respective VLAN based upon user credentials.",
       "choice_b":"The access port is switched into the respective VLAN based upon the computer\u0027s IP address.",
       "choice_c":"The access port is switched into the respective VLAN based upon the computer\u0027s MAC address.",
       "choice_d":"The access port is switched into the respective VLAN based upon security ACLs.",
       "correct_answer":"C",
       "explanation":"Dynamic VLANs are deprecated, but you may still see them in operations. A switch configured with dynamic VLANs checks a VLAN Management Policy Server (VMPS) when clients plug in. The VMPS has a list of MAC addresses to their respective VLANs. It is now recommended that dynamic VLAN installations are converted to 802.1x. The access port cannot be controlled with a VMPS based upon user credentials. The access port is also not switched into the respective VLAN based upon the computer\u0027s IP address, because the IP address is normally associated based upon the VLAN. The access port cannot be switched into a respective VLAN based upon ACLs since ACLs are used to restrict layer 3 traffic and not layer 2 traffic."
    },
    {
       "id":214,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"You have changed the name of VLAN 3, and you now want to check your change. Which command will you enter to verify the name change?",
       "choice_a":"<code>Switch#show vlans</code>",
       "choice_b":"<code>Switch#show interface vlan 3</code>",
       "choice_c":"<code>Switch#show run</code>",
       "choice_d":"<code>Switch#show vlan id 3</code>",
       "correct_answer":"D",
       "explanation":"To verify a VLAN name change, you would use the command <code>show vlan id 3</code>. This would only show you the one VLAN configured in the database. The command <code>show vlans</code> is incorrect because the command is not plural; it is singular, <code>show vlan.</code> It will give you a complete listing of all VLANs. Performing a <code>show interface vlan 3</code> would not display the friendly name. The command <code>show run</code> will not display the VLAN database, unless the switch is configured in transparent mode."
    },
    {
       "id":215,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"Which of the following is a true statement if you have changed the MTU on a VLAN to support jumbo frames?",
       "choice_a":"If a normal MTU of 1528 is used, the switch will not forward the traffic.",
       "choice_b":"Once jumbo frames are configured, nothing more needs to be done. Clients will auto-detect the new MTU and use jumbo frames.",
       "choice_c":"Changing the MTU is an easy and effective method for raising speed.",
       "choice_d":"For jumbo frames to be effective, all devices on the VLAN, including switches, must support them.",
       "correct_answer":"D",
       "explanation":"When the MTU is changed on the VLAN, it has little consequence to normal MTU communications. However, if you are going to utilize the new MTU for something like iSCSI, it must be supported end to end or it can actually decrease performance. All switching equipment between the two end devices must support jumbo frames. Clients will not auto-detect the new MTU in IPv4 and use jumbo frames; the client normally must be configured to use the new MTU. Configuring the MTU can be difficult because you must make sure that all devices end to end support the new MTU."
    },
    {
       "id":216,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":4,
       "question":"Which is a benefit of implementing VLANs with a layer 3 router?",
       "choice_a":"VLANs can span multiple switches.",
       "choice_b":"Implementing routed VLANs will decrease the broadcast domains.",
       "choice_c":"ACLs can be employed to secure VLANs.",
       "choice_d":"All of the above.",
       "correct_answer":"C",
       "explanation":"When layer 3 (routed VLANs) is implemented, it allows for a more secure network with the use of ACLs applied to the VLAN interface. A single VLAN spanning multiple switches is a benefit of implementing VLANs and not routed VLANs. When you implement VLANs, you will increase the number of broadcast domains."
    },
    {
       "id":217,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":5,
       "question":"You have created a VLAN for the Research department. Now you need to configure an interface on the switch for the newly created VLAN. Which command will configure the interface for the respective VLAN?",
       "choice_a":"<code>Switch(config-if)#switchport vlan research</code>",
       "choice_b":"<code>Switch(config-if)#switchport access vlan research</code>",
       "choice_c":"<code>Switch(config-if)#switchport access vlan 9</code>",
       "choice_d":"<code>Switch(config-if)#switchport vlan 9</code>",
       "correct_answer":"C",
       "explanation":"The correct command is <code>switchport access vlan 9</code>. This command entered into the interface configuration prompt for the respective interface will place that interface in VLAN 9. When you\u0027re configuring an interface for a VLAN, only the VLAN number can be used; therefore, the commands <code>switchport vlan research</code> and <code>switchport access vlan research</code> are incorrect. The command <code>switchport vlan 9</code> is incorrect."
    },
    {
       "id":218,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"You are installing a VoIP phone on the same interface as an existing computer. Which command will allow the VoIP phone to switch traffic onto its respective VLAN?",
       "choice_a":"<code>Switch(config-if)#switchport voice vlan 4</code>",
       "choice_b":"<code>Switch(config-if)#switchport vlan voice 4</code>",
       "choice_c":"<code>Switch(config-if)#switchport voip vlan 4</code>",
       "choice_d":"<code>Switch(config-if)#switchport access vlan 4 voice</code>",
       "correct_answer":"A",
       "explanation":"The <code>switchport voice vlan 4</code> command will configure the interface to switch traffic with a CoS value of 5 (set by the phone) to the voice VLAN of 4. The command <code>switchport vlan voice 4</code> is incorrect. The command <code>switchport voip vlan 4</code> is incorrect. The command <code>switchport access vlan 4 voice</code> is incorrect."
    },
    {
       "id":219,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":1,
       "question":"Which type of port removes the VLAN ID from the frame before it egresses the interface?",
       "choice_a":"Access port",
       "choice_b":"Trunk port",
       "choice_c":"Voice port",
       "choice_d":"Native port",
       "correct_answer":"A",
       "explanation":"All VLAN tagging is removed from the frame before it egresses an access port to the end device. Trunk ports carry the VLAN tagging from end to end. Voice ports tag packets only when the CoS value is modified from the default. Native ports are used when frames arrive on a trunk and do not contain any tagging information."
    },
    {
       "id":220,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"Which of the following is a true statement about static access ports?",
       "choice_a":"An access port can carry VLANs via tagging.",
       "choice_b":"A client computer can request the VLAN to be placed in",
       "choice_c":"A client computer cannot see any VLAN tagging information.",
       "choice_d":"A client computer can see the VLAN tagging information.",
       "correct_answer":"C",
       "explanation":"The client computer connected to an access port cannot see any VLAN tagging information. It is removed before the frame egresses the interface. An access port cannot carry VLAN tagging information because it is stripped. The client computer cannot request the VLAN that it wants to operate in. The administrator must manually configure the VLAN. A client computer cannot see the VLAN tagging information because it is stripped out as it egresses an access port."
    },
    {
       "id":221,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"You have been tasked to configure an interface with a VLAN ID of 8 and support a VoIP phone on VLAN 6. Which commands would achieve the goal?",
       "choice_a":"<code>Switch(config-if)#switchport vlan 8</code><br><code>Switch(config-if)#switchport vlan 6 voip</code>",
       "choice_b":"<code>Switch(config-if)#switchport mode access vlan 8</code><br><code>Switch(config-if)#switchport voice vlan 6</code>",
       "choice_c":"<code>Switch(config-if)#switchport access vlan 8</code><br><code>Switch(config-if)#switchport voice vlan 6</code>",
       "choice_d":"<code>Switch(config-if)#switchport access vlan 8 voice 6</code>",
       "correct_answer":"C",
       "explanation":"The command used to configure an access port for VLAN 8 is <code>switchport access vlan 8</code>, and the command to configure the VOIP phone is <code>switchport voice vlan 6</code>. The command combination of <code>switchport vlan 8</code> and <code>switchport vlan 6 voip</code> is incorrect. The command combination of <code>switchport mode access vlan 8</code> and <code>switchport voice vlan 6</code> is incorrect. The command <code>switchport access vlan 8 voice 6</code> is incorrect."
    },
    {
       "id":222,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"In the following exhibit, you have configured a port for a phone on an existing port for a computer. However, after you are done, only the phone works. What might be the problem? <img src='/question_assets/ccna/2_image2.png'></img>",
       "choice_a":"The phone is misconfigured.",
       "choice_b":"The computer is misconfigured.",
       "choice_c":"The <code>switchport nonegotiate</code> a command is stopping the computer from negotiating connection.",
       "choice_d":"The switch port mode needs to be configured as an access port.",
       "correct_answer":"D",
       "explanation":"The port is set up as a trunk. The phone is not misconfigured since the phone is normally configured for 801.Q tagging of CoS values, and it will work for this example. The computer is also not misconfigured; computers normally do not tag traffic for data. In this example, the communications will be directed to the native VLAN on the configured trunk. Configuring the command <code>switchport nonegotiate</code> will only prevent the port from participating in Dynamic Trunking Protocol (DTP), but either way, the port will remain a trunk because it is manually configured as one."
    },
    {
       "id":223,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"When you are protecting an interface with port security, to which mode should you set the switch port?",
       "choice_a":"Access mode",
       "choice_b":"Dynamic mode",
       "choice_c":"Trunk mode",
       "choice_d":"Voice mode",
       "correct_answer":"A",
       "explanation":"When you are configuring port security on an interface, the switch port should have a mode of access configured. This will also protect the switch from transitioning into a trunk if another switch is connected. There is no such mode as dynamic mode. If the interface is configured in trunk mode, port security will not be effective since many different MAC addresses can traverse the link. Voice mode is not a mode; it is a function of an access port that tags traffic when a CoS value is detected."
    },
    {
       "id":224,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"Which VLAN is the default VLAN used to configure all switches from the factory?",
       "choice_a":"VLAN 999",
       "choice_b":"VLAN 1002",
       "choice_c":"VLAN 1005",
       "choice_d":"VLAN 1",
       "correct_answer":"D",
       "explanation":"All switches are configured by default with all interfaces in VLAN 1. This simplifies configuration if the switch is to be used as a direct replacement for a hub since nothing needs to be configured. All of the other options are incorrect."
    },
    {
       "id":225,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"You want to delete VLAN 1 for security reasons. However, the switch will not let you. What is the reason you cannot delete VLAN 1?",
       "choice_a":"The VLAN is still configured on a port.",
       "choice_b":"The VLAN serves as the switch\u0027s main management IP.",
       "choice_c":"The VLAN is protected from deletion.",
       "choice_d":"The VLAN is still configured as a native VLAN on a trunk.",
       "correct_answer":"C",
       "explanation":"VLANs 1 and 1002 through 1005 are protected by the IOS and cannot be changed, renamed, or deleted. VLAN 1 cannot be deleted, regardless of whether it is still configured on a port. The VLAN that serves as the switch\u0027s main management IP can be changed to any other VLAN; it only defaults to VLAN 1 from the factory. VLAN 1 cannot be deleted regardless of whether it is configured as a native VLAN on a trunk."
    },
    {
       "id":226,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"Why is it recommended that you do not use VLAN 1?",
       "choice_a":"It is not a production VLAN.",
       "choice_b":"It cannot be routed via an SVI.",
       "choice_c":"It cannot participate in VTP transfers.",
       "choice_d":"It shouldn\u0027t be used for security reasons.",
       "correct_answer":"D",
       "explanation":"For security concerns, it should not be used in production. It is the default VLAN configured on all switches. Potentially, a computer can be plugged into an interface defaulted to VLAN 1 and expose resources such as the switch management network. VLAN 1 can be used as a production VLAN, and by default, all switches are configured to use VLAN 1 right out of the box. VLAN 1 can also be routed the same as any other VLAN via an SVI. VLAN 1 can also participate in VTP transfers, although its name cannot be modified."
    },
    {
       "id":227,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"You attempt to configure a VLAN with a new name. You receive the error <code>Default VLAN 1 may not have its name changed</code>. What is wrong?",
       "choice_a":"The VLAN is used on interfaces currently.",
       "choice_b":"The VLAN is protected from any changes.",
       "choice_c":"The VLAN is being referenced by its name in interface configuration.",
       "choice_d":"You are not in the VLAN database when committing the change.",
       "correct_answer":"B",
       "explanation":"VLAN 1 is the default VLAN and it is not permitted by the IOS to change the VLAN in any way. This includes name changes. VLAN 1 cannot be renamed regardless of whether it is used on another interface currently. All VLANs are configured numerically in Cisco IOS; a friendly name can be attached after it is configured. VLAN 1 cannot be renamed regardless of which configuration prompt you are in."
    },
    {
       "id":228,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"You have configured a new VLAN 12 and applied it to the interface. However, you find that the computer still remains in VLAN 1. Which command will fix the issue? Refer to the following exhibit. <img src='/question_assets/ccna/2_image3.png'></img>",
       "choice_a":"<code>Switch(config-if)#switchport native vlan 12</code>",
       "choice_b":"<code>Switch(config-if)#no switchport nonegotiate</code>",
       "choice_c":"<code>Switch(config-if)#switchport mode access</code>",
       "choice_d":"<code>Switch(config-if)#no spanning-tree portfast</code>",
       "correct_answer":"C",
       "explanation":"The port needs to be changed from trunk mode to access mode via the command <code>switchport mode access</code>. Although <code>switchport native vlan 12</code> would remedy the problem, it would be an improper configuration since you are expecting tagged traffic and directing untagged traffic to VLAN 12. Removing switch port nonegotiate mode would only allow the computer to negotiate a trunking protocol via DTP. Configuring the command <code>no spanning-tree portfast</code> would prevent the port from forwarding traffic right away."
    },
    {
       "id":229,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"What is the command to verify a VLAN and the port(s) it is associated with?",
       "choice_a":"<code>Switch#show vlans</code>",
       "choice_b":"<code>Switch#show vlan</code>",
       "choice_c":"<code>Switch#show access vlan</code>",
       "choice_d":"<code>Switch#show vlan database</code>",
       "correct_answer":"B",
       "explanation":"The command to verify that a VLAN is created and the port(s) it is associated with is <code>show vlan. The command show vlans</code> is incorrect as it should be singular. The command <code>show access vlan</code> is incorrect because it is not a valid command. The command <code>show vlan database</code> is incorrect because it is not a valid command."
    },
    {
       "id":230,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"You are configuring a Catalyst 9200 switch, a VLAN is not configured yet, and you mistakenly configure it on an interface with the command <code>switch access vlan 12</code>. What will happen?",
       "choice_a":"The command will error.",
       "choice_b":"The command will complete and update the VLAN database.",
       "choice_c":"The command will complete, but before forwarding can happen, the VLAN must be manually created.",
       "choice_d":"The command will need to be negated and performed after the VLAN is manually created.",
       "correct_answer":"B",
       "explanation":"When the command is invoked inside of the interface, it will create the VLAN automatically. The command will not error, but if you are consoled into the device or you are monitoring the terminal, you can see the VLAN get automatically created. When the VLAN is auto-created, traffic will forward without the need of any other configuration. The original command of <code>switch access vlan 12</code> will be accepted, and the VLAN will be auto-created."
    },
    {
       "id":231,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"You have been asked to segment the network for an R&D workgroup. The requirement is to allow the R&D group access to the existing servers, but no other VLANs should be able to access R&D. How can this be achieved with maximum flexibility?",
       "choice_a":"Create a new VLAN, configure a routed SVI interface, and apply ACLs to the VLAN.",
       "choice_b":"Create a new VLAN, configure a routed SVI interface, and apply extended ACLs to the R&D switch ports.",
       "choice_c":"Create a new VLAN, and install a new R&D server in the new VLAN.",
       "choice_d":"Create a new VLAN, and trunk the existing file server for both the production and R&D networks.",
       "correct_answer":"A",
       "explanation":"Creating the new VLAN will logically segment this work group. Creating a Switched Virtual Interface (SVI) will allow routing on the layer 3 switch. The ACLs should only be applied to VLAN interfaces. Although the other solutions achieve a similar goal, they do not provide flexibility. Extended ACLs cannot be applied to the R&D switch ports since they are layer 2 ports and extended ACLs are layer 3 entries. Creating a new VLAN for R&D and placing the R&D server in the VLAN will not accomplish the goal of restricting the server. Creating a new VLAN and using a trunk to connect the production and R&D network will not accomplish the task."
    },
    {
       "id":232,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"You have just installed a Cisco VoIP phone and it will not provision. Referring to the following exhibit, what needs to be changed? <img src='/question_assets/ccna/2_image4.png'></img>",
       "choice_a":"CDP needs to be enabled.",
       "choice_b":"Spanning-tree PortFast needs to be removed.",
       "choice_c":"The interface is configured with <code>switchport nonegotiate.</code>",
       "choice_d":"The interface needs to be configured as a trunk.",
       "correct_answer":"A",
       "explanation":"The Cisco Discovery Protocol (CDP) is required for Cisco VoIP phones. It allows the switch to learn capabilities and power requirements. The command <code>spanning-tree portfast</code> allows the interface on the switch to forward frames as it recalculates the switching topology. The command <code>switchport nonegotiate</code> stops the switch from participating in Dynamic Trunking Protocol (DTP) negotiation. The interface does not need to be configured as a trunk port for a VoIP phone to work; an access port is recommended."
    },
    {
       "id":233,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"You need to verify that an interface is in the proper VLAN. Which command will display the status of the interface, the VLAN configured, and the operational mode?",
       "choice_a":"<code>Switch#show vlan</code>",
       "choice_b":"<code>Switch#show running-config</code>",
       "choice_c":"<code>Switch#show interfaces</code>",
       "choice_d":"<code>Switch#show interfaces switchport</code>",
       "correct_answer":"D",
       "explanation":"The command <code>show interfaces switchport</code> will display a detail of all ports in respect to VLAN operational status. The command will show the operational mode of the interface, such as trunk or access mode. The command <code>show vlan</code> will show all VLANs configured on the switch. Although the command <code>show running-config</code> will display the running configuration of the port, it will not display the status of the interface. The command <code>show interfaces</code> will not display the VLAN configured on the port."
    },
    {
       "id":234,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":4,
       "question":"You configured VLAN on an interface, but it is not working. After looking at the VLAN database, you find it has been disabled. Which command will enable the VLAN?",
       "choice_a":"<code>Switch#enable vlan 3</code>",
       "choice_b":"<code>Switch(config)#enable vlan 3</code>",
       "choice_c":"<code>Switch#no shutdown vlan 3</code>",
       "choice_d":"<code>Switch(config)#vlan 3</code><br><code>Switch(config-vlan)#no shutdown</code>",
       "correct_answer":"D",
       "explanation":"The proper way to enable a VLAN to forward traffic is to first enter the VLAN database for ID 3 and then issue the <code>no shutdown</code> command. On some IOS versions, this can also be done via the command <code>no shutdown vlan 3</code> from global config mode. The command <code>enable vlan 3</code> configured in privilege exec mode is not a valid command. The command <code>enable vlan 3</code> configured in global configuration is not a valid command. Although the command <code>no shutdown vlan 3</code> is valid on some IOS versions, it must be configured from global configuration mode."
    },
    {
       "id":235,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":5,
       "question":"Which command will show the operational mode of only Fa0/3?",
       "choice_a":"<code>Switch#show interfaces</code>",
       "choice_b":"<code>Switch#show interfaces switchport</code>",
       "choice_c":"<code>Switch#show interfaces FastEthernet 0/3 switchport</code>",
       "choice_d":"<code>Switch#show interfaces status | i 0/3</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show interfaces FastEthernet 0/3 switchport</code> will show the switch port details for only Fa0/3, to include its operational mode. This command is similar to <code>show interfaces switchport</code>, which will show all ports. The command <code>show interfaces</code> will not show the operation mode of only Fa0/3. The command <code>show interfaces status | i 0/3</code> will filter the results and only display the line with the matching text of 0/3. These lines will not give you the operational mode of the interface."
    },
    {
       "id":236,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"The guest VLAN is not allowing traffic to be routed. What is the cause of the problem? Refer to the following exhibit. <img src='/question_assets/ccna/2_image5.png'></img>",
       "choice_a":"The VLAN interface is shut down.",
       "choice_b":"The VLAN is disabled.",
       "choice_c":"The guest ports are not in the proper VLAN.",
       "choice_d":"There is a problem elsewhere.",
       "correct_answer":"B",
       "explanation":"The VLAN is disabled from forwarding traffic as shown in the VLAN database. The <code>no shutdown vlan 5</code> must be performed in global config. The VLAN interface being shut down would have no effect on traffic being forwarded on the VLAN, only routed. If the guest ports are associated with the proper VLAN in the exhibit, routing will function as normal. There could be a problem elsewhere, but the exhibit shows the VLAN as shut down."
    },
    {
       "id":237,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"You need to create a new VLAN 5 called office and apply it to interface Fa0/4. Which commands will you need to enter?",
       "choice_a":"<code>Switch(config)#vlan 5</code><br><code>Switch(config-vlan)#name office</code><br><code>Switch(config-vlan)#exit</code><br><code>Switch(config)#interface fast 0/4</code><br><code>Switch(config-if)#switchport access vlan 5</code>",
       "choice_b":"<code>Switch(config)#vlan 5</code><br><code>Switch(config-vlan)#name office</code><br><code>Switch(config-vlan)#exit</code><br><code>Switch(config)#interface fast 0/4</code><br><code>Switch(config-if)#switchport access vlan office</code>",
       "choice_c":"<code>Switch(config)#vlan 5 office</code><br><code>Switch(config)#interface fast 0/4</code><br><code>Switch(config-if)#switchport access vlan 5</code>",
       "choice_d":"<code>Switch(config)#vlan 5 name office</code><br><code>Switch(config)#interface fast 0/4</code><br><code>Switch(config-if)#switchport access vlan 5</code>",
       "correct_answer":"A",
       "explanation":"You should first create the VLAN in the VLAN database and add its name. These actions should be performed on the VTP server, when multiple switches are installed in the network. Then you need to enter the interface and configure the port for the VLAN. All other answers are incorrect."
    },
    {
       "id":238,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"In the following exhibit, what is wrong with VLAN 4? <img src='/question_assets/ccna/2_image6.png'></img>",
       "choice_a":"The VLAN is shut down.",
       "choice_b":"The VLAN is unnamed.",
       "choice_c":"The VLAN was created on a non-Cisco switch.",
       "choice_d":"The VLAN is suspended.",
       "correct_answer":"B",
       "explanation":"VLAN 4 is an active VLAN. However, it has not been given a name, so the default name is VLAN0004. The VLAN is not shut down as it has a status of active. The VLAN could have been created on a non-Cisco switch. However, the exhibit is from a Cisco switch, and the friendly name is not configured. VLANs cannot be suspended, only shut down, which is clearly not the problem in the exhibit."
    },
    {
       "id":239,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"A VLAN was created on another non-Cisco switch. You look at the current VLAN database, but the VLAN is not in the VLAN database. What must be done to correct the issue?",
       "choice_a":"Set the correct trunking protocol between the switches.",
       "choice_b":"Create the VLAN manually.",
       "choice_c":"Configure VTP on both switches.",
       "choice_d":"Assign the VLAN to an interface on the other switch.",
       "correct_answer":"B",
       "explanation":"You must manually configure the VLAN on the Cisco switch(s). VTP is a protocol that allows for VLAN autoconfiguration in the VLAN database. However, only Cisco switches support it. Setting the correct trunking protocol between the switches will help guarantee VLANs can traverse between switches. Configuring VTP is only possible on Cisco switches because it is a proprietary protocol. Assigning the VLAN to an interface on the other switch will not fix the problem."
    },
    {
       "id":240,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"You have just configured the network in the following exhibit. The commands you have entered configured the VLAN database and assigned the VLAN IDs to the interfaces. You cannot communicate between VLAN 2 and VLAN 4, but communication within VLAN 4 works. What is wrong? <img src='/question_assets/ccna/2_image7.png'></img>",
       "choice_a":"The VLANs must be enabled via the command <code>no shutdown</code>",
       "choice_b":"The network requires routing between the VLANs.",
       "choice_c":"The VLANs require VTP to be configured.",
       "choice_d":"The interfaces are administratively shut down by default and need to be enabled via <code>no shutdown.</code>",
       "correct_answer":"B",
       "explanation":"When a VLAN is created, so is a broadcast domain. The broadcast domain/VLAN requires its own unique IP network addressing and a router to route between the networks. Therefore, you need a router for inter-VLAN communications. The VLANs will automatically be in a no shutdown mode when they are configured initially. The VLANs do not require VTP to be configured, although it is helpful. The interfaces associated with VLANs are automatically in a no shutdown mode."
    },
    {
       "id":241,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"An administrator calls you and states that they believe an interface is down on a router you maintain. Which command will show only the interface, the IP address configured, and the status of the interface?",
       "choice_a":"<code>Router#show ip interface</code>",
       "choice_b":"<code>Router#show interface</code>",
       "choice_c":"<code>Router#show ip interface brief</code>",
       "choice_d":"<code>Router#show interface brief</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show ip interface brief</code> will display only the necessary information of interface, IP, and status to aid in the diagnostic process. The command <code>show ip interface</code> is incorrect. The command <code>show interface</code> is incorrect. The command <code>show interface brief</code> is incorrect."
    },
    {
       "id":242,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":"",
       "question":"Which statement is true about the following exhibit? <img src='/question_assets/ccna/2_image8.png'></img>",
       "choice_a":"Switch A interface Gi0/1 is configured as an access switch port to Switch B interface Gi0/1.",
       "choice_b":"Switch A interface Gi0/1 and Switch B interface Gi0/1 are both configured as trunk switch ports.",
       "choice_c":"Switch B interface Fa0/1 is misconfigured with a duplicate VLAN ID.",
       "choice_d":"Switch A interface Fa0/3 is misconfigured with a duplicate VLAN ID.",
       "correct_answer":"B",
       "explanation":"Switch A and Switch B are participating in VLAN tagging. Therefore, Switch A interface Gi0/1 and Switch B interface Gi0/1 are both configured as trunk switch ports. This will allow VLAN tagging across the trunk link. Switch A interface Gi0/1 cannot be configured as an access switch port because tagging of VLANs between switches would not occur. Switch B interface Fa0/1 shows no sign of being configured with a duplicate VLAN ID. Switch A interface Fa0/3 shows no sign of being configured with a duplicate VLAN ID."
    },
    {
       "id":243,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"You have connected a Dell switch to the Cisco switch you are configuring and you cannot get a trunk between the two. What must be changed?",
       "choice_a":"The Dell switch must be configured to use ISL.",
       "choice_b":"The Cisco switch must be configured to use 802.1Q.",
       "choice_c":"Both switches need to have duplicated VLAN configurations.",
       "choice_d":"VTP needs to be configured on each of the switches.",
       "correct_answer":"B",
       "explanation":"Since the Dell switch cannot support the proprietary protocol of ISL, both switches need to be set up to use 802.1Q. Although both switches need to have duplicate VLAN configurations, that will not prevent them from creating a trunk between themselves. VTP cannot be configured on both of the switches because VTP is a Cisco proprietary protocol."
    },
    {
       "id":244,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"You need to view all of the trunks on a switch and verify that they have the proper trunking protocols configured. Which command will display the information?",
       "choice_a":"<code>Switch#show interfaces brief</code>",
       "choice_b":"<code>Switch#show interfaces trunk</code>",
       "choice_c":"<code>Switch#show switchport trunk</code>",
       "choice_d":"<code>Switch#show switchport brief</code>",
       "correct_answer":"B",
       "explanation":"The command <code>show interfaces trunk</code> will display all of the configured trunks on the switch. The command <code>show interfaces brief</code> is incorrect. The command <code>show switchport trunk</code> is incorrect. The command <code>show switchport brief</code> is incorrect."
    },
    {
       "id":245,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":4,
       "question":"What is the default VTP mode all switches are configured as by default?",
       "choice_a":"Server",
       "choice_b":"Client",
       "choice_c":"Transparent",
       "choice_d":"Master",
       "correct_answer":"A",
       "explanation":"All switches are configured by default as a VTP server. A switch configured as a client will receive and process VTP packets from a VTP server. A switch configured as transparent will not participate in VTP but will allow VTP to be forwarded to other switches. There is no such mode as master with VTP."
    },
    {
       "id":246,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":5,
       "question":"You need to verify the VTP mode on a switch. Which command will display the information?",
       "choice_a":"<code>Switch#show vtp</code>",
       "choice_b":"<code>Switch#show vtp status</code>",
       "choice_c":"<code>Switch#show vtp counters</code>",
       "choice_d":"<code>Switch#show running-config</code>",
       "correct_answer":"B",
       "explanation":"The command to display the mode settings for VTP is <code>show vtp status</code>. The command <code>show vtp</code> is incorrect. The command <code>show vtp counters</code> is incorrect. The command <code>show running-config</code> is incorrect."
    },
    {
       "id":247,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"Which commands would you enter on a new switch joining your existing network to configure VTP?",
       "choice_a":"<code>Switch(config)#vtp mode transparent</code><br><code>Switch(config)#vtp domain corpname</code>",
       "choice_b":"<code>Switch(config)#vtp mode client</code><br><code>Switch(config)#vtp domain corpname</code>",
       "choice_c":"<code>Switch(config)#vtp domain corpname</code>",
       "choice_d":"<code>Switch(config)#vtp client</code><br><code>Switch(config)#vtp corpname</code>",
       "correct_answer":"B",
       "explanation":"When setting up VTP on a new switch connected to your existing VTP infrastructure, you need to change the mode of the switch. Then you must configure the VTP domain that is serving the VTP information. The transparent mode for VTP will not allow the switch to participate in VTP processing. Setting the VTP domain alone with not allow the switch to participate in VTP because it must be switched to the mode of client as well. The command <code>vtp corpname</code> is not a valid command."
    },
    {
       "id":248,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"You need to remove VLANs 2 through 4 from the allowed list on a trunk interface. Which command will remove only these VLANs without interruption to the network?",
       "choice_a":"<code>Switch(config-if)#switchport trunk remove vlan 2-4</code>",
       "choice_b":"<code>Switch(config-if)#switchport remove vlan 2-4</code>",
       "choice_c":"<code>Switch(config-if)#switchport trunk allowed vlan remove 2-4</code>",
       "choice_d":"<code>Switch(config-if)#switchport trunk allowed remove vlan 2-4</code>",
       "correct_answer":"C",
       "explanation":"The command <code>switchport trunk allowed vlan remove 2-4</code> will remove VLANs 2 through 4 from the trunk. The command <code>switchport trunk remove vlan 2-4</code> is incorrect. The command <code>switchport remove vlan 2-4</code> is incorrect. The command <code>switchport trunk allowed remove vlan 2-4</code> is incorrect."
    },
    {
       "id":249,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"You have a list of allowed VLANs over an existing trunk. You need to set the allowed list back to default. Which command will perform this without interruption? Refer to the following exhibit. <img src='/question_assets/ccna/2_image9.png'></img>",
       "choice_a":"<code>Switch(config-if)#no switchport trunk allowed</code>",
       "choice_b":"<code>Switch(config-if)#no switchport trunk allowed all</code>",
       "choice_c":"<code>Switch(config-if)#no switchport trunk allowed 1-4096</code>",
       "choice_d":"<code>Switch(config-if)#switchport trunk allowed vlan all</code>",
       "correct_answer":"D",
       "explanation":"The command <code>switchport trunk allowed vlan all</code> will restore the allowed VLAN list back to default. The command <code>no switchport trunk allowed</code> is incorrect. The command <code>no switchport trunk allowed all</code> is incorrect. The command <code>no switchport trunk allowed 1-4096</code> is incorrect."
    },
    {
       "id":250,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"You need to add VLAN 4 to the allowed list on a trunk interface. Currently VLANs 5 through 8 are allowed. Which command will add only this VLAN without interruption to the network?",
       "choice_a":"<code>Switch(config-if)#switchport trunk allowed vlan add 4</code>",
       "choice_b":"<code>Switch(config-if)#add allowed vlan 4</code>",
       "choice_c":"<code>Switch(config-if)#switchport trunk add vlan 4</code>",
       "choice_d":"<code>Switch(config-if)#switchport trunk allowed add vlan 4</code>",
       "correct_answer":"A",
       "explanation":"The command <code>switchport trunk allowed vlan add 4</code> will add VLAN 4 to the existing list of VLANs already allowed on the interface. The command <code>add allowed vlan 4</code> is incorrect. The command <code>switchport trunk add vlan 4</code> is incorrect. The command <code>switchport trunk allowed add vlan 4</code> is incorrect."
    },
    {
       "id":251,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":1,
       "question":"You try to configure the command</code>switchport mode trunk</code> on an interface. However, you see the error message <code>Command rejected: An interface whose trunk encapsulation is Auto cannot be configured to trunk mode.</code> What command will fix the issue?",
       "choice_a":"<code>Switch(config-if)#switchport mode trunk manual</code>",
       "choice_b":"<code>Switch(config-if)#no switchport mode dynamic auto</code>",
       "choice_c":"<code>Switch(config-if)#switchport trunk encapsulation dot1q</code>",
       "choice_d":"<code>Switch(config-if)#no switchport trunk encapsulation auto</code>",
       "correct_answer":"C",
       "explanation":"The command will not complete because the interface is set to dynamic auto, which implies the trunk protocol will be negotiated. You cannot configure it with <code>switchport mode trunk</code> until you statically set the encapsulation via the command <code>switchport trunk encapsulation dot1q.</code> The command <code>switchport mode trunk manual</code> is incorrect. The command <code>no switchport mode dynamic auto</code> is incorrect. The command <code>no switchport trunk encapsulation auto</code> is incorrect."
    },
    {
       "id":252,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"What is the function of the VTP?",
       "choice_a":"VTP allows for dynamic trunking between links.",
       "choice_b":"VTP allows for propagation of the VLAN database.",
       "choice_c":"VTP detects trunk encapsulation and negotiates trunks.",
       "choice_d":"VTP allows for propagation of the trunking database.",
       "correct_answer":"B",
       "explanation":"VLAN Trunking Protocol, or VTP, propagates the VLAN database from an initial master copy on the \u0022server\u0022 to all of the \u0022clients.\u0022 VTP does not help facilitate the dynamic trunking between links. VTP does not detect trunk encapsulation and negotiate trunks. VTP allows for the propagation of the VLAN database, not the trunking database."
    },
    {
       "id":253,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"Which VTP mode will not allow the switch to participate in VTP traffic but will forward VTP traffic?",
       "choice_a":"Server mode",
       "choice_b":"Transparent mode",
       "choice_c":"Proxy mode",
       "choice_d":"Client mode",
       "correct_answer":"B",
       "explanation":"A switch in VTP transparent mode will not participate in VTP. However, if the VTP is v2, the switch will forward and receive VTP advertisements. The VTP server mode allows the switch to act as a master for the VTP domain. VTP proxy mode is not a real mode; therefore, it is incorrect. The VTP client mode allows the switch to act as a slave to the master server."
    },
    {
       "id":254,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"You have just configured a trunk between two switches, Switch A and Switch B. The trunk operates as normal. However, there are minor issues with some of the switch traffic. What might be the problem? Refer to the following exhibit. <img src='/question_assets/ccna/2_image10.png'></img>",
       "choice_a":"Switch A is pruning all VLANs except for VLAN 1.",
       "choice_b":"The switches are on incompatible links.",
       "choice_c":"Switch B has an inactive native VLAN.",
       "choice_d":"Both switches have a native VLAN mismatch.",
       "correct_answer":"D",
       "explanation":"Both switches have a native VLAN mismatch. Since Switch B has an inactive VLAN, it would be recommended to change the native VLAN back to 1 on Switch B. When VLAN pruning is enabled, it will not affect traffic between switches. Both switches show that a link has been enabled with 802.1Q; therefore, there are no incompatibility issues."
    },
    {
       "id":255,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"What significance does VTP VLAN pruning provide?",
       "choice_a":"VLAN pruning removes VLANs from the databases of other switches that they are not configured on.",
       "choice_b":"VLAN pruning removes VLAN traffic from other switches that are not configured for the respective VLAN.",
       "choice_c":"VLAN pruning automatically changes the allowed VLANs on all interfaces.",
       "choice_d":"All of the above.",
       "correct_answer":"B",
       "explanation":"VTP VLAN pruning removes forwarding traffic for VLANs that are not configured on remote switches. This saves bandwidth on trunks because if the remote switch does not have the VLAN configured on it, the frame destined for the VLAN will not traverse the trunk. VTP VLAN pruning does not remove VLANs from the database of other switches. VTP VLAN pruning also does not automatically change the allowed VLANs on interfaces."
    },
    {
       "id":256,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"Which command enables VTP pruning?",
       "choice_a":"<code>Switch(config)#vtp mode pruning</code>",
       "choice_b":"<code>Switch(config)#vtp pruning</code>",
       "choice_c":"<code>Switch(config)#vtp vlan pruning</code>",
       "choice_d":"<code>Switch(config-vlan)#enable pruning</code>",
       "correct_answer":"B",
       "explanation":"The command <code>vtp pruning</code> in global configuration mode will enable VTP VLAN pruning. The command <code>vtp mode pruning</code> is an incorrect command. The command <code>vtp vlan pruning</code> is an incorrect command. The command <code>enable pruning</code> is an incorrect command when it is configured in a VLAN configuration prompt."
    },
    {
       "id":257,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"When enabling VTP pruning, where does it need to be configured?",
       "choice_a":"VTP pruning needs to be configured only on the VTP server.",
       "choice_b":"VTP pruning needs to be configured only on the VTP client.",
       "choice_c":"VTP pruning needs to be configured only on the VTP transparent.",
       "choice_d":"VTP pruning needs to be configured on all VTP clients and the server.",
       "correct_answer":"A",
       "explanation":"VTP pruning needs to be configured only on the VTP server. The clients will receive the update and turn on VTP pruning automatically. If VTP pruning is turned on at the VTP client, the setting will be ignored since the client is a slave to the master server. If the VTP pruning is configured on a VTP transparent, the configuration will be ignored since VTP transparent switches do not participate in VTP with other switches. VTP pruning only needs to be configured on the VTP server; all clients will receive the necessary configuration from the VTP server."
    },
    {
       "id":258,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"You configure a new VLAN of 22 on Switch A. You have configured a few access links with the new VLAN and they work as normal. They do not forward traffic to ports configured in the same VLAN on Switch B. All other VLANs function fine between the switches. What is the problem? Refer to the following exhibit. <img src='/question_assets/ccna/2_image11.png'></img>",
       "choice_a":"The native VLAN must be changed.",
       "choice_b":"The VLAN is not allowed over the trunk.",
       "choice_c":"The trunk encapsulation is wrong.",
       "choice_d":"VTP is not set up on the remote switch.",
       "correct_answer":"B",
       "explanation":"The VLAN is not allowed over the trunk because of the <code>switchport trunk allowed vlan 4,6,12,15</code> command. The native VLAN is used when frames are not tagged, and the problem states that traffic in the same VLAN is not being forwarded. The trunk encapsulation is set to 802.1Q, which is the default for many switches. Also, if encapsulation was not set properly, no traffic would be forwarded. VTP is not required for switching operation, although it is helpful."
    },
    {
       "id":259,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"Which command will turn off Dynamic Trunking Protocol (DTP) on an interface?",
       "choice_a":"<code>Switch(config-if)#no dtp</code>",
       "choice_b":"<code>Switch(config-if)#no switchport dtp enable</code>",
       "choice_c":"<code>Switch(config-if)#switchport dtp disable</code>",
       "choice_d":"<code>Switch(config-if)#switchport nonegotiate</code>",
       "correct_answer":"D",
       "explanation":"The Dynamic Trunking Protocol can be turned off with the command <code>switchport nonegotiate,</code> which when configured states not to negotiate trunks via DTP. The command <code>no dtp</code> is incorrect. The command <code>no switchport dtp enable</code> is incorrect. The command <code>switchport dtp disable</code> is incorrect."
    },
    {
       "id":260,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"You are trunking Switch A and Switch B together. On Switch A you have the default of <code>switchport mode dynamic auto</code>. On Switch B, which command will you need to configure to allow trunking?",
       "choice_a":"<code>SwitchB(config-if)#switchport mode trunk</code>",
       "choice_b":"<code>SwitchB(config-if)#switchport mode dynamic trunk</code>",
       "choice_c":"<code>SwitchB(config-if)#switchport mode dynamic auto</code>",
       "choice_d":"<code>SwitchB(config-if)#switchport nonegotiate</code>",
       "correct_answer":"A",
       "explanation":"Switch B will need to have its interface set to either <code>switchport mode trunk</code> or <code>switchport mode dynamic desirable</code> for Switch A to turn its interface into a trunk. The command <code>switchport mode dynamic trunk</code> is incorrect. The command <code>switchport mode dynamic auto</code> is incorrect. The command <code>switchport nonegotiate</code> is incorrect as it will never negotiate a trunking protocol."
    },
    {
       "id":261,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":4,
       "question":"You are having an issue with a trunk between two switches. Examining the following exhibit, what can you conclude? <img src='/question_assets/ccna/2_image12.png'></img>",
       "choice_a":"The interfaces on both switches need to be set to trunk mode.",
       "choice_b":"DTP is not running on Switch A.",
       "choice_c":"All VLANs need to be allowed first.",
       "choice_d":"There is a trunking protocol mismatch.",
       "correct_answer":"D",
       "explanation":"On Switch A, DTP is turned on and the encapsulation is set to 802.1Q. However, on Switch B, DTP is turned off and ISL encapsulation is manually set. Switch B will need to have 802.1Q configured in order to have trunking complete. Both Switch A and Switch B have their interfaces set to trunk mode already. DTP is running on Switch A, since the mode is set to auto in the exhibit. All VLANs do not need to be allowed first for trunking to happen."
    },
    {
       "id":262,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":5,
       "question":"Which protocol is a Cisco proprietary protocol used for trunking switches?",
       "choice_a":"ISL",
       "choice_b":"802.1Q",
       "choice_c":"VTP",
       "choice_d":"CDP",
       "correct_answer":"A",
       "explanation":"Inter-Switch Link, or ISL, is a proprietary protocol used for trunking of switches. If you need to connect non-Cisco switches to a Cisco switch, you must use 802.1Q, the IEEE standard. VTP is not a trunking protocol; it assists in populating VLANs across Cisco switches for conformity and ease of configuration. Cisco Discovery Protocol (CDP) is not a trunking protocol either; it negotiates power by communicating its capabilities with neighboring devices. It also allows for neighbor discovery, but CDP is proprietary to Cisco, so only Cisco devices can communicate."
    },
    {
       "id":263,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"How does IEEE 802.1Q tag frames?",
       "choice_a":"802.1Q adds a 32-bit header to the frame with the VLAN tagging information.",
       "choice_b":"802.1Q adds a 32-bit header to the packet with the VLAN tagging information.",
       "choice_c":"802.1Q inserts a 32-bit field between the source MAC address and the type field.",
       "choice_d":"802.1Q inserts a 32-bit field between the destination MAC address and the type field.",
       "correct_answer":"C",
       "explanation":"802.1Q inserts a field containing the 16-bit Tag Protocol ID of 0x8100, a 3-bit COS field, a 1-bit drop-eligible indicator (used with COS), and the 12=bit VLAN ID, which equals 32 bits, or 4 bytes. All of the other options are incorrect."
    },
    {
       "id":264,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"Which commands will allow a trunk with another switch configured as mode desirable auto?",
       "choice_a":"<code>SwitchB(config-if)#switchport trunk encapsulation dot1q</code><br><code>SwitchB(config-if)#switchport mode trunk</code>",
       "choice_b":"<code>SwitchB(config-if)#switchport mode dynamic auto</code><br><code>SwitchB(config-if)#switchport mode encapsulation dot1q</code>",
       "choice_c":"<code>SwitchB(config-if)#switchport nonegotiate</code>",
       "choice_d":"<code>SwitchB(config-if)#switchport encapsulation dot1q</code><br><code>SwitchB(config-if)#switchport mode trunk</code>",
       "correct_answer":"A",
       "explanation":"You must first set the encapsulation to 802.1Q, then you can statically set the mode to trunk. An alternative would be to set the port to dynamic desirable via the command <code>switchport mode dynamic desirable</code>. However, it is recommended to statically configure the link to trunk on one or both sides if possible. Configuring both sides with <code>switchport mode dynamic auto</code> will result in the negotiation of an access link. Turning DTP off by using the command <code>switchport nonegotiate</code> will result in an access link. The correct command to set encapsulation is <code>switchport trunk encapsulation dot1q,</code> not <code>switchport encapsulation dot1q.</code>"
    },
    {
       "id":265,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"Which statement is correct about native VLANs?",
       "choice_a":"Any traffic tagged will be placed on the native VLAN.",
       "choice_b":"Any traffic that is not allowed over the trunk will be placed on the native VLAN.",
       "choice_c":"Any traffic not tagged will be placed on the native VLAN.",
       "choice_d":"Any traffic that is tagged with ISL on an 802.1Q trunk will be placed on the native VLAN.",
       "correct_answer":"C",
       "explanation":"Native VLANs are only used for traffic that is not tagged, in which untagged frames are placed on a trunk link. A common use for native VLANs is management traffic between switches, before both sides are configured as a trunk. Traffic that is tagged will traverse the trunk link and not use the native VLAN. Native VLANs are not used for disallowed VLANs on a trunk link. Any traffic that is tagged with ISL on an 802.1Q trunk will not be distinguishable on the either side since the frame will be mismatched."
    },
    {
       "id":266,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"You are setting up a switch. When you perform a <code>show run</code>, you notice that the VLANs are in the running-config. What could be concluded? Refer to the following exhibit. <img src='/question_assets/ccna/2_image13.png'></img>",
       "choice_a":"Nothing; the VLANs are normally stored in the running-config.",
       "choice_b":"The switch is set up with a VTP mode of client.",
       "choice_c":"The switch is set up with a VTP mode of server.",
       "choice_d":"The switch is set up with a VTP mode of transparent.",
       "correct_answer":"D",
       "explanation":"The switch is set up with a VTP mode of transparent. When a switch is set up with a mode of transparent, the VLAN information is stored in the running-config in lieu of the <code>vlan.dat</code> file. This is not the default mode of a switch;, out of the box it is configured as a VTP server. The switch is not set up as a VTP client or server since the VLAN configuration is visible in the running-config."
    },
    {
       "id":267,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"You have configured <code>switchport nonegotiate</code> on an interface with a default configuration. What effect will it have on the neighboring interface when the other switch is plugged in with its interface in default configuration?",
       "choice_a":"The switch port will transition to a trunk port.",
       "choice_b":"The switch port will remain an access port.",
       "choice_c":"The interface will remain shut down.",
       "choice_d":"The interface will enter an err-disable state.",
       "correct_answer":"B",
       "explanation":"If you issue the command <code>switchport nonegotiate, <code>the switch will not send Dynamic Trunking Protocol (DTP) frames for trunk negotiation. The default configuration for a port is the mode of access, so the port will remain in an access port. This means the switch port will not transition to a trunk port, and it will remain an access port. The interface will not shut down, but it will be mismatched and not carry any tagged VLANs. The switch port will not enter an err-disable state."
    },
    {
       "id":268,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"Switch A has default configuration on its interface. You need to configure Switch A for VLAN 5. Which command will configure the interface to become a member of VLAN 5?",
       "choice_a":"<code>SwitchA(config-if)#switchport mode access</code><br><code>SwitchA(config-if)#switchport access vlan 5</code>",
       "choice_b":"<code>SwitchA(config-if)#switchport trunk</code><br><code>SwitchA(config-if)#switchport native vlan 5</code>",
       "choice_c":"<code>SwitchA(config-if)#switchport access</code><br><code>SwitchA(config-if)#switchport access vlan 5</code>",
       "choice_d":"<code>SwitchA(config-if)#switchport mode trunk</code><br><code>SwitchA(config-if)#switchport native vlan 5</code>",
       "correct_answer":"A",
       "explanation":"Switch A must change its interface to an access port with the <code>switchport mode access</code> command, which will force Switch A\u0027s interface to remain an access port. Then you configure the access VLAN of 5 on Switch A with the <code>switchport access vlan 5</code> command. Configuring the port with the mode of a trunk on either switch will prevent the port from performing as an access port for VLAN 5. If you tried to configure this with a native VLAN, it would result in a native VLAN mismatch and improper configuration."
    },
    {
       "id":269,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"Switch A is configured with the command of <code>switchport mode dynamic desirable</code> on its interface. Which command would you need to configure on Switch B to create a trunk between them?",
       "choice_a":"<code>SwitchB(config-if)#switchport mode dynamic auto</code>",
       "choice_b":"<code>SwitchB(config-if)#switchport mode dynamic desirable</code>",
       "choice_c":"<code>SwitchB(config-if)#switchport mode trunk</code>",
       "choice_d":"All of the above",
       "correct_answer":"D",
       "explanation":"The command <code>switchport mode dynamic desirable</code> is similar to <code>switchport mode dynamic auto</code> with the exception that it is desirable to become a trunk. So if the neighboring port is set to auto, desirable, or trunk, it becomes a trunk."
    },
    {
       "id":270,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"Which statement is correct about the command <code>switchport mode dynamic auto?</code>",
       "choice_a":"The interface will become a trunk if requested on the neighboring port.",
       "choice_b":"The interface will become a trunk if the neighboring port is configured the same.",
       "choice_c":"The interface will remain an access link if the neighboring port is configured as a trunk.",
       "choice_d":"The interface will remain an access link if the native VLAN is changed.",
       "correct_answer":"A",
       "explanation":"The command <code>switchport mode dynamic auto</code> will cause the port to remain an access port if the neighboring port is configured the same. If both sides are configured with <code>switchport mode dynamic auto,</code> then the port will become an access link. If you configure the neighboring port as a trunk, it will become a trunk. If the native VLAN is changed, it will have no effect over the selection of switch port mode."
    },
    {
       "id":271,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"Which command is similar to <code>show interfaces trunk</code> but will show greater detail?",
       "choice_a":"<code>Switch#show interfaces trunk detail</code>",
       "choice_b":"<code>Switch#show switchport</code>",
       "choice_c":"<code>Switch#show interfaces switchport</code>",
       "choice_d":"<code>Switch#show running-config</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show interfaces switchport</code> will show greater detail about the trunk than the command <code>show interfaces trunk</code>. Alternatively, you can specify a single port using the command <code>show interfaces Fa 0/5 switchport</code>, for example. The command <code>show interfaces trunk detail</code> is not similar. The command <code>show switchport</code> is not similar. The command <code>show running-config</code> is not similar."
    },
    {
       "id":272,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"On a switch you enter the commands <code>switchport mode access and switchport nonegotiate</code>. Which statement is true about the interface you\u0027ve configured?",
       "choice_a":"The interface will become a trunk switch port if a switch is plugged in and DTP is turned on for the other switch.",
       "choice_b":"The interface will always remain an access switch port, regardless of whether another switch is plugged in.",
       "choice_c":"The interface will become a trunk switch port if a switch is plugged in and the other switch is set statically to a trunk switch port.",
       "choice_d":"The interface will become a trunk switch port if a non-Cisco switch is plugged in and statically configured as a trunk switch port.",
       "correct_answer":"B",
       "explanation":"When you configure the switch port to a mode of access, you are statically configuring the interface to remain an access switch port. When you configure the switch port to nonegotiate, you are turning off Dynamic Trunking Protocol (DTP). The switch will never negotiate its switch port. If the interface mode is specifically set with the command <code>switchport mode access</code>, it will never become a trunk. Regardless of what is plugged into the interface, the command <code>switchport mode access</code> will configure it as an access port."
    },
    {
       "id":273,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"You need to configure a trunk interface to support the protocol of 802.1Q. Which command will achieve this?",
       "choice_a":"<code>Switch(config-if)#switchport mode trunk 802.1q</code>",
       "choice_b":"<code>Switch(config-if)#switchport trunk encapsulation 802.1q</code>",
       "choice_c":"<code>Switch(config-if)#switchport 802.1q</code>",
       "choice_d":"<code>Switch(config-if)#switchport encapsulation trunk 802.1q</code>",
       "correct_answer":"B",
       "explanation":"The command to specify 802.1Q encapsulation on a trunk interface is <code>switchport trunk encapsulation 802.1q</code>. The command <code>switchport mode trunk 802.1q</code> is incorrect. The command <code>switchport 802.1q</code> is incorrect. The command <code>switchport encapsulation trunk 802.1q</code> is incorrect."
    },
    {
       "id":274,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"You are trying to configure a trunk port on an interface for 802.1Q encapsulation. However, after entering the proper command, you receive the error <code>% Invalid input detected at '^' marker</code>. What is wrong?",
       "choice_a":"802.1Q is not supported on the switch you are configuring this on.",
       "choice_b":"The interface will not allow configuration of 802.1Q.",
       "choice_c":"The switch only supports the ISL trunking protocol.",
       "choice_d":"The switch only supports the 802.1Q trunking protocol.",
       "correct_answer":"D",
       "explanation":"This error is very common when configuring Cisco switches since many switches only support 802.1Q and configuration is not necessary. The ISL trunking protocol is not supported on certain platforms, such as the older 2900 series switches. It is safe to assume that Cisco switches at minimum will support 802.1Q encapsulation, but ISL trunking protocol is usually a feature that must be added or purchased."
    },
    {
       "id":275,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"When a frame is not tagged with 802.1Q VLAN identifying information, what happens when it traverses a trunk port?",
       "choice_a":"The frame is dropped to the bit bucket.",
       "choice_b":"The frame is forwarded to the default VLAN.",
       "choice_c":"The frame is forwarded to the native VLAN.",
       "choice_d":"The frame is sent to the first VLAN ID configured on the trunk.",
       "correct_answer":"C",
       "explanation":"When a frame traverses a trunk and does not have VLAN tagging information in the 802.1Q encapsulation format (untagged), it is sent to the native VLAN configured on the trunk. This behavior is to prevent the untagged frame from being dropped. The terminology of <italic>default VLAN</italic> does not pertain to trunks. The default VLAN is the default VLAN configured on an access port. An untagged frame is only sent to the native VLAN and not the first VLAN ID configured on the trunk."
    },
    {
       "id":276,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"Which protocol is an open standard trunking protocol?",
       "choice_a":"ISL",
       "choice_b":"VTP",
       "choice_c":"802.1Q",
       "choice_d":"802.1X",
       "correct_answer":"C",
       "explanation":"The 802.1Q protocol is supported by all switches\u0027 vendors for trunking. It is an open standard that was developed by the IEEE. Cisco Inter-Switch Link (ISL) is a proprietary protocol for trunking. VLAN Trunk Protocol (VTP) helps reduce configuration and maintenance of VLANs on Cisco switches. 802.1X is a security protocol used per port to allow and deny traffic based on credentials."
    },
    {
       "id":277,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"You have several VLANs and need to route between them. You configure a trunk between your router and switch. What will you need to configure on the router to support each VLAN for routing?",
       "choice_a":"Virtual interface",
       "choice_b":"Switched virtual interface",
       "choice_c":"Subinterface",
       "choice_d":"VLAN database",
       "correct_answer":"C",
       "explanation":"When implementing router on a stick (ROAS), you must first create a trunk to the router. Once the trunk is created, you must create subinterfaces for each VLAN to be routed and specify the IP address and 802.1Q encapsulation. A virtual interface is an interface that is configured inside of the IOS software and does not have a physical presence, such as a loopback interface. A switched virtual interface is a type of virtual interface inside of the IOS that allows for configuration of the traffic in the respective VLAN. The VLAN database is only kept on the switches and the router does not receive a copy."
    },
    {
       "id":278,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"How many bytes are used in an 802.1Q frame for tagging of VLANs?",
       "choice_a":"2 bytes",
       "choice_b":"4 bytes",
       "choice_c":"8 bytes",
       "choice_d":"16 bytes",
       "correct_answer":"B",
       "explanation":"An 802.1Q frame is a modified Ethernet frame. The type field is relocated after the 4 bytes used for 802.1Q tagging. Two of the bytes are used for tagging the frame, and two of the bytes are used for controls such as Class of Service (CoS). All of the other options are incorrect."
    },
    {
       "id":279,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":4,
       "question":"What is the difference between a default VLAN and a native VLAN?",
       "choice_a":"A default VLAN is configured on all access ports of the switch from the factory.",
       "choice_b":"A native VLAN is configured on all access ports of the switch from the factory.",
       "choice_c":"A default VLAN is configured on all trunks for tagged frames.",
       "choice_d":"A native VLAN is configured on all trunks for tagged frames.",
       "correct_answer":"A",
       "explanation":"The default VLAN for all switches is VLAN 1. It is the default configuration for all access ports from the factory. A native VLAN is the VLAN that untagged frames are switched onto if the frames are received on a trunk. A default VLAN is not configured on all trunks for tagged frames. A native VLAN is not configured on all trunks for tagged frames."
    },
    {
       "id":280,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":5,
       "question":"Which command will show you the native VLAN for only Fa0/15?",
       "choice_a":"<code>Switch#show running-config</code>",
       "choice_b":"<code>Switch#show interface fastethernet 0/15</code>",
       "choice_c":"<code>Switch#show interface fastethernet 0/15 switchport</code>",
       "choice_d":"<code>Switch#show switchport fastethernet 0/15</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show interface fastethernet 0/15 switchport</code> will show the operational mode, and if configured as a trunk, it will show the native VLAN. The command <code>show running-config</code> is incorrect, as it will show all the interfaces. The command <code>show interface fastethernet 0/15</code> is incorrect as it will not show the native VLAN information. The command <code>show switchport fastethernet 0/15</code> is incorrect."
    },
    {
       "id":281,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"You need to change the native VLAN for interface Fa0/23 from VLAN 1 to VLAN 999. Which command would you use?",
       "choice_a":"<code>Switch(config-if)#switchport trunk native vlan 999</code>",
       "choice_b":"<code>Switch(config-if)#native vlan 999</code>",
       "choice_c":"<code>Switch(config-if)#switchport native vlan 999</code>",
       "choice_d":"<code>Switch(config-if)#no switchport native vlan 1</code><br><code>Switch(config-if)#switchport native vlan 999</code>",
       "correct_answer":"A",
       "explanation":"The command to change the native VLAN of a trunk to VLAN 999 is <code>switchport trunk native vlan 999</code>. The command <code>native vlan 999</code> is incorrect. The command <code>switchport native vlan 999</code> is incorrect. Negating the command with <code>no switchport native vlan 1</code> and then configuring <code>switchport native vlan 999</code> is incorrect."
    },
    {
       "id":282,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"When you change the native VLAN of a trunk from VLAN 1 to VLAN 999 and you receive the error <code>%CDP-4-NATIVE_VLAN_MISMATCH: Native VLAN mismatch ­discovered….</code>What is the possible problem?",
       "choice_a":"CDP is not running on the other interface, causing a mismatch.",
       "choice_b":"The interface is the first to be changed.",
       "choice_c":"The interface is running ISL.",
       "choice_d":"The version of CDP is wrong on the other switch.",
       "correct_answer":"B",
       "explanation":"This error is normal if it is the first interface to be changed over to the new native VLAN since the other interface has not been changed yet. However, if the other interface was changed already and you received this error, then CDP is letting you know that the other side is mismatched. CDP must be running on both sides of the trunk; therefore, you would not see this error if it was disabled on either side. If the interfaces where running mismatch trunking protocols, a different error would be seen. The version of CDP on the other switch will not prompt the error of native VLAN mismatch."
    },
    {
       "id":283,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"Switch A and Switch B have a trunk. On Switch A, the native VLAN is set to VLAN 10 on Switch B and the native VLAN is defaulted. What problems will occur?",
       "choice_a":"CDP will not function.",
       "choice_b":"VTP will not function.",
       "choice_c":"All broadcasts will be forwarded to Switch B.",
       "choice_d":"Any traffic not tagged on Switch B when traversing the trunk will be switched onto VLAN 10.",
       "correct_answer":"D",
       "explanation":"The problems will not be apparent since the trunk will still function for tagged traffic. However, any traffic that is not tagged will be directed to the opposite side\u0027s native VLAN. So traffic expected for VLAN 1 will be directed to VLAN 10, and VLAN 10 traffic will be directed to VLAN 1 when the traffic is not tagged. Both CDP and VTP will continue to function over the trunk link. The misconfiguration will not allow any more broadcasts than normal over the trunk to Switch B."
    },
    {
       "id":284,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":"",
       "question":"When you have a native VLAN mismatch on a configured trunk, which protocol will alert you to the issue?",
       "choice_a":"VTP",
       "choice_b":"CDP",
       "choice_c":"802.1Q",
       "choice_d":"ISL",
       "correct_answer":"B",
       "explanation":"Cisco Discovery Protocol (CDP) will alert you to a native VLAN mismatch. You will receive the error <code>%CDP-4-NATIVE_VLAN_MISMATCH: Native VLAN mismatch discovered….</code> When a trunk is configured, the native VLAN is always used for CDP exchanges. VLAN Trunk Protocol (VTP) helps reduce configuration and maintenance of VLANs on Cisco switches. Cisco Inter-Switch Link (ISL) is a proprietary protocol for trunking. The 802.1Q protocol is a trunking protocol developed by the IEEE."
    },
    {
       "id":285,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":4,
       "question":"You are trying to change the native VLAN from VLAN 1 to VLAN 1002. You have configured both sides with <code>switchport native vlan 1002</code>. However, the native VLAN traffic keeps failing. What is wrong?",
       "choice_a":"The native VLAN must be VLAN 1.",
       "choice_b":"The native VLAN cannot be an extended VLAN.",
       "choice_c":"VLAN 1002 is not allowed for Ethernet traffic.",
       "choice_d":"The problem is not the native VLAN; everything is configured properly.",
       "correct_answer":"C",
       "explanation":"VLAN 1002 is reserved for use with an FDDI VLAN and not allowed for Ethernet traffic. All Ethernet traffic must be a VLAN between 1 to 1001. You cannot use 1002 to 1005 because they are used for legacy applications. The native VLAN does not need to be VLAN 1. The native VLAN can be an extended VLAN; however, this is not the problem."
    },
    {
       "id":286,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":5,
       "question":"Which protocol is an IEEE standard that collects information from neighboring devices on their identity and capabilities?",
       "choice_a":"CDP",
       "choice_b":"LLDP",
       "choice_c":"802.1b",
       "choice_d":"802.1a",
       "correct_answer":"B",
       "explanation":"Link Layer Discovery Protocol is an IEEE standard of 802.1ab. Most Cisco devices can perform LLDP, but it must be configured. The Cisco Discovery Protocol (CDP) is a proprietary protocol used to communicate neighbor devices\u0027 identities and capabilities. The IEEE 802.1a and 802.1b protocols are defunct protocols used for LAN management."
    },
    {
       "id":287,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":"",
       "question":"You want to turn off CDP on a switch. Which command would you enter?",
       "choice_a":"<code>Switch(config)#cdp disable</code>",
       "choice_b":"<code>Switch(config-if)#no cdp enable</code>",
       "choice_c":"<code>Switch(config)#no cdp</code>",
       "choice_d":"<code>Switch(config-if)#no cdp run</code>",
       "correct_answer":"D",
       "explanation":"The command to turn off CDP globally on a switch is <code>no cdp run</code>. The command <code>cdp disable</code> is incorrect. The command <code>no cdp enable</code> is incorrect. The command <code>no cdp</code> is incorrect."
    },
    {
       "id":288,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":"",
       "question":"How often are CDP frames sent out of the device by default?",
       "choice_a":"Every 30 seconds",
       "choice_b":"Every 60 seconds",
       "choice_c":"Every 90 seconds",
       "choice_d":"Every 180 seconds",
       "correct_answer":"B",
       "explanation":"CDP frames are sent out all active interfaces every 60 seconds. All of the other options are incorrect."
    },
    {
       "id":289,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":"",
       "question":"Which Cisco proprietary protocol collects information from neighboring devices about their identity and capabilities?",
       "choice_a":"802.1ab",
       "choice_b":"LLDP",
       "choice_c":"CDP",
       "choice_d":"802.1a",
       "correct_answer":"C",
       "explanation":"Cisco Discovery Protocol, or CDP, is a Cisco proprietary protocol used for gathering information from neighboring switches and routers. Link Layer Discovery Protocol is also called 802.1ab, which is an IEEE standard and performs identical functionality to CDP. 802.1a is a defunct IEEE protocol used for LAN management."
    },
    {
       "id":290,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":"",
       "question":"What is the default value of the CDP holddown timer for CDP entries?",
       "choice_a":"30 seconds",
       "choice_b":"60 seconds",
       "choice_c":"90 seconds",
       "choice_d":"180 seconds",
       "correct_answer":"D",
       "explanation":"The default holddown timer for CDP entries is three times the advertisement timer of 60 seconds. So entries have a holddown timer value of 180 seconds. All of the other options are incorrect."
    },
    {
       "id":291,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":1,
       "question":"You want to turn off CDP on a single interface. Which command would you enter?",
       "choice_a":"<code>Switch(config)#cdp disable</code>",
       "choice_b":"<code>Switch(config-if)#no cdp enable</code>",
       "choice_c":"<code>Switch(config)#no cdp</code>",
       "choice_d":"<code>Switch(config-if)#no cdp run</code>",
       "correct_answer":"B",
       "explanation":"To turn off or suppress CDP advertisements on a single interface, you would enter the interface and enter the command <code>no cdp enable</code>. The command <code>cdp disable</code> is incorrect. The command <code>no cdp</code> is incorrect. The command <code>no cdp run</code> is incorrect."
    },
    {
       "id":292,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":"",
       "question":"Which command gives information that\u0027s identical to the output of the <code>show cdp neighbors detail</code> command?",
       "choice_a":"<code>Switch#sh cdp neighbors all</code>",
       "choice_b":"<code>Switch#sh cdp neighbors *</code>",
       "choice_c":"<code>Switch#sh cdp entries all</code>",
       "choice_d":"<code>Switch#sh cdp entry *</code>",
       "correct_answer":"D",
       "explanation":"The <code>sh cdp entry *</code> command will give output that\u0027s identical to that of the <code>show cdp neighbors detail</code> command. The command <code>sh cdp neighbors all</code> is incorrect. The command <code>sh cdp neighbors *</code> is incorrect. The command <code>sh cdp entries all</code> is incorrect."
    },
    {
       "id":293,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":4,
       "question":"You have several non-Cisco IP phones and you want to allow automatic power adjustments on the Cisco Power over an Ethernet (PoE) switch. Which command will allow you to achieve this?",
       "choice_a":"<code>Switch#lldp run</code>",
       "choice_b":"<code>Switch(config)#lldp run</code>",
       "choice_c":"<code>Switch(config)#lldp enable</code>",
       "choice_d":"<code>Switch#lldp enable</code>",
       "correct_answer":"B",
       "explanation":"The command <code>lldp run</code> entered in global config mode will enable LLDP on all interfaces. When enabled, LLDP-MED, or LLDP for Media, will read capabilities on the phone such as name and power level. The command in option A <code>lldp run</code> is incorrect as it needs to be configured in global configuration mode. The command <code>lldp enable</code> is incorrect, regardless of where it is configured."
    },
    {
       "id":294,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":5,
       "question":"Which command will allow you to see LLDP devices connected to a switch?",
       "choice_a":"<code>Switch#show lldp</code>",
       "choice_b":"<code>Switch#show lldp devices</code>",
       "choice_c":"<code>Switch#show lldp neighbor detail</code>",
       "choice_d":"<code>Switch#show cdp neighbor detail</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show lldp neighbor detail</code> will show output similar to the output of <code>show cdp neighbor detail</code>, but it will only include LLDP neighbors. The command <code>show lldp</code> is incorrect. The command <code>show lldp devices</code> is incorrect. The command <code>show cdp neighbor detail</code> is incorrect."
    },
    {
       "id":295,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":"",
       "question":"What is the default LLDP advertisement interval?",
       "choice_a":"30 seconds",
       "choice_b":"60 seconds",
       "choice_c":"90 seconds",
       "choice_d":"120 seconds",
       "correct_answer":"A",
       "explanation":"The default LLDP advertisement interval is 30 seconds. When turned on, it will advertise out all active interfaces every 30 seconds. All of the other options are incorrect."
    },
    {
       "id":296,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":"",
       "question":"You want to disable LLDP from sending advertisements on a single interface. Which command will you use?",
       "choice_a":"<code>Switch(config-if)#no lldp</code>",
       "choice_b":"<code>Switch(config-if)#no lldp transmit</code>",
       "choice_c":"<code>Switch(config-if)#no lldp receive</code>",
       "choice_d":"<code>Switch(config-if)#no lldp enable</code>",
       "correct_answer":"B",
       "explanation":"When you use the command <code>no lldp transmit</code>, it will suppress LLDP messages from exiting the interface it is configured on. The command <code>no lldp</code> is incorrect. The command <code>no lldp receive</code> is incorrect. The command <code>no lldp enable</code> is incorrect."
    },
    {
       "id":297,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":"",
       "question":"What is the default value of the LLDP holddown timer for entries?",
       "choice_a":"30 seconds",
       "choice_b":"60 seconds",
       "choice_c":"90 seconds",
       "choice_d":"120 seconds",
       "correct_answer":"D",
       "explanation":"The default value of the LLDP holddown timer for entries is 120 seconds. This holddown timer is set every time the switch hears an advertisement for a device. The holddown is four times the advertisement interval. All of the other options are incorrect."
    },
    {
       "id":298,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":"",
       "question":"The following exhibit shows the output of the CDP details. Which statement is correct about what is displayed? <img src='/question_assets/ccna/2_image14.png'></img>",
       "choice_a":"The advertisement was seen 162 seconds ago.",
       "choice_b":"Switch B interface Gi0/1 connects to Switch A.",
       "choice_c":"Switch B interface Gi0/2 connects to Switch A.",
       "choice_d":"The IP address of Switch B is 192.168.1.1.",
       "correct_answer":"C",
       "explanation":"Switch B is connected to Switch A via Gi0/2. Switch A Gi0/1 is the adjacent interface connecting the two switches. The holddown timer for this entry is at 162 seconds; it was not last seen 162 seconds ago. The IP address of Switch A is 192.168.1.1."
    },
    {
       "id":299,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":"",
       "question":"You have a layer 2 connection to your ISP. You want to make sure that you do not send information on the capabilities of your switch, but you don\u0027t want to affect the use of CDP. Which command will you configure?",
       "choice_a":"<code>Switch(config)#cdp disable</code>",
       "choice_b":"<code>Switch(config-if)#no cdp</code>",
       "choice_c":"<code>Switch(config-if)#no cdp disable</code>",
       "choice_d":"<code>Switch(config-if)#no cdp enable</code>",
       "correct_answer":"D",
       "explanation":"The command <code>no cdp enable</code> will turn off CDP advertisements on the interface that you configure it on. The command <code>cdp disable</code> is incorrect. The command <code>no cdp</code> is incorrect. The command <code>no cdp disable</code> is incorrect."
    },
    {
       "id":300,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":"",
       "question":"Which command will show the interfaces that CDP is advertising on?",
       "choice_a":"<code>Switch#show cdp</code>",
       "choice_b":"<code>Switch#show cdp interface</code>",
       "choice_c":"<code>Switch#show interface</code>",
       "choice_d":"<code>Switch#show interface cdp</code>",
       "correct_answer":"B",
       "explanation":"The command <code>show cdp interface</code> will display all of the interfaces CDP is enabled on along with their advertisement intervals. The command <code>show cdp</code> is incorrect as it will only show the timers for CDP. The command <code>show interface</code> is incorrect. The command <code>show interface cdp</code> is incorrect."
    },
    {
       "id":301,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":"",
       "question":"What is the maximum number of interfaces that can be aggregated with Ether Channel and PAgP?",
       "choice_a":"2 interfaces",
       "choice_b":"8 interfaces",
       "choice_c":"16 interfaces",
       "choice_d":"4 interfaces",
       "correct_answer":"B",
       "explanation":"Ether Channel can aggregate 2 interfaces to 8 interfaces together on a single switch when using PAgP. All of the other options are incorrect."
    },
    {
       "id":302,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":"",
       "question":"Which is a true statement about EtherChannel?",
       "choice_a":"EtherChannel works with 802.1Q to block the redundant links.",
       "choice_b":"EtherChannel can aggregate multiple links with varying speed.",
       "choice_c":"EtherChannel can aggregate interfaces across multiple stand-alone switches.",
       "choice_d":"When configured, EtherChannel acts as a single layer 2 connection.",
       "correct_answer":"D",
       "explanation":"When EtherChannel bonds interfaces together, they act as a single Ethernet link. Therefore, layer 2 and layer 3 sees it as a single link. EtherChannel works independently of 802.1Q and does not block redundant links. EtherChannel can aggregate multiple links, but the links must have the same speed. EtherChannel cannot aggregate interfaces across multiple stand-alone switches."
    },
    {
       "id":303,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":4,
       "question":"You have a switch with 2 gigabit interface ports and 48 FastEthernet ports and are using PAgP. What is the highest bandwidth you can achieve?",
       "choice_a":"2 Gb/s",
       "choice_b":"2.2 Gb/s",
       "choice_c":"400 Mb/s",
       "choice_d":"2.6 Gb/s",
       "correct_answer":"A",
       "explanation":"The highest configurable bandwidth is going to be 2 Gb/s. This is because you cannot mix speeds and duplex. Therefore, 2.6 Gb/s is not possible, but 400 Mb/s is possible using four 100 Mb/s FastEthernet ports."
    },
    {
       "id":304,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":5,
       "question":"Which aggregation protocol is an IEEE standard?",
       "choice_a":"LACP",
       "choice_b":"802.1Q",
       "choice_c":"PAgP",
       "choice_d":"802.1X",
       "correct_answer":"A",
       "explanation":"The Link Aggregation Control Protocol (LACP) is the IEEE standard 802.3ad. 802.1Q is an IEEE standard for VLAN trunking. Port Aggregation Protocol (PAgP) is a Cisco proprietary protocol used for port aggregation. 802.1X is a security protocol used with Ethernet ports."
    },
    {
       "id":305,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":"",
       "question":"You need to form an EtherChannel between a VMware ESXi host and the switch. Which negotiation protocol will you choose?",
       "choice_a":"EtherChannel",
       "choice_b":"LACP",
       "choice_c":"Channel Group",
       "choice_d":"PAgP",
       "correct_answer":"B",
       "explanation":"LACP is an IEEE standard that is supported by non-Cisco devices to create aggregation links and negotiate the configuration. EtherChannel is a proprietary aggregation protocol that is also called PAgP. <italic>Channel Group</italic> is a configuration term used with Cisco for port aggregation."
    },
    {
       "id":306,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":"",
       "question":"What is the maximum number of interfaces that can be aggregated with EtherChannel and LACP?",
       "choice_a":"2 interfaces",
       "choice_b":"8 interfaces",
       "choice_c":"16 interfaces",
       "choice_d":"4 interfaces",
       "correct_answer":"C",
       "explanation":"EtherChannel can aggregate 2 interfaces to 16 interfaces together on a single switch when using LACP. Only eight ports can be used at any one time; the others are placed in standby mode. All of the other options are incorrect."
    },
    {
       "id":307,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":"",
       "question":"Which mode forces the aggregation of links without the use of a control protocol?",
       "choice_a":"LACP off mode",
       "choice_b":"PAgP off mode",
       "choice_c":"On mode",
       "choice_d":"802.3ad mode",
       "correct_answer":"C",
       "explanation":"If you configure the EtherChannel to on mode, it forces the aggregation of links together without the use of a control protocol. All of the other options are incorrect configurations."
    },
    {
       "id":308,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":"",
       "question":"Which is a correct statement about aggregating ports together?",
       "choice_a":"The term <italic>EtherChannel</italic> is a Cisco proprietary term for port channeling.",
       "choice_b":"PAgP can be used with non-Cisco products.",
       "choice_c":"LACP can only be used with other Cisco switches.",
       "choice_d":"PAgP can bundle several different links with varying speeds and duplexes together.",
       "correct_answer":"A",
       "explanation":"The term <italic>EtherChannel</italic> is a Cisco-centric term. Most vendors will not recognize the term. PAgP is a Cisco proprietary protocol used for port aggregation. LACP is an open standard for port aggregation. PAgP and LACP cannot bundle links with varying speeds and duplexes together."
    },
    {
       "id":309,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":1,
       "question":"Which negotiation protocol is a Cisco proprietary standard?",
       "choice_a":"LACP",
       "choice_b":"802.1Q",
       "choice_c":"PAgP",
       "choice_d":"802.1ab",
       "correct_answer":"C",
       "explanation":"Port Aggregation Protocol (PAgP) is a Cisco proprietary control negotiation protocol. LACP is an open standard for port aggregation. 802.1Q is an IEEE standard for VLAN trunking. 802.1ab is an IEEE standard that defines LLDP."
    },
    {
       "id":310,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":"",
       "question":"How often does PAgP send messages to control the status of the links in the bundle?",
       "choice_a":"Every 30 seconds",
       "choice_b":"Every 60 seconds",
       "choice_c":"Every 90 seconds",
       "choice_d":"Every 120 seconds",
       "correct_answer":"A",
       "explanation":"PAgP sends control notifications every 30 seconds to the adjacent switch. All of the other options are incorrect."
    },
    {
       "id":311,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":"",
       "question":"You want to configure two switches so that LACP is used between the switches. Which mode should you use on both sides to force LACP?",
       "choice_a":"Active mode on both sides",
       "choice_b":"Passive mode on both sides",
       "choice_c":"Auto mode on both sides",
       "choice_d":"Desirable mode on both sides",
       "correct_answer":"A",
       "explanation":"Using active mode on both sides assures us that the switches will start negotiation with only Link Aggregation Control Protocol (LACP). A configuration of passive mode on both sides will not form an LACP aggregation. Auto and desirable mode only pertain to PAgP."
    },
    {
       "id":312,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":"",
       "question":"What is the effect of configuring a port channel with one side set to passive mode and the other side set to active mode?",
       "choice_a":"The channel group will use PAgP.",
       "choice_b":"The channel group will not be formed.",
       "choice_c":"The channel group will use LACP.",
       "choice_d":"The channel group will use EtherChannel.",
       "correct_answer":"C",
       "explanation":"When you use passive on one side and active on the other side of a port channel, the result is that Link Aggregation Control Protocol (LACP) will be used. <italic>Passive</italic> and <italic>active</italic> are synonymous with LACP configuration; therefore, PAgP is not configured with this terminology. <italic>EtherChannel</italic> is a Cisco term related to PAgP."
    },
    {
       "id":313,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":"",
       "question":"Which command is used to verify the negotiation protocol for a port channel?",
       "choice_a":"<code>Switch#show etherchannel</code>",
       "choice_b":"<code>Switch#show port-channel</code>",
       "choice_c":"<code>Switch#show interface</code>",
       "choice_d":"<code>Switch#show run</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show etherchannel</code> will display all EtherChannels on the switch along with their negotiated protocols. The command <code>show port-channel</code> is incorrect. The command <code>show interface</code> is incorrect; it will show interface statistics. The command <code>show run</code> is incorrect; it will show the running configuration."
    },
    {
       "id":314,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":"",
       "question":"What is the effect of configuring a port channel with one side set to passive mode and the other side set to passive mode?",
       "choice_a":"The channel group will use PAgP.",
       "choice_b":"The channel group will not be formed.",
       "choice_c":"The channel group will use LACP.",
       "choice_d":"An unconditional port channel will be formed.",
       "correct_answer":"B",
       "explanation":"Since both interfaces are set to passive mode, neither side will initiate the LACP control notifications. Although the port channel is configured on the switch, it is not communicated between the switches. <italic>Passive</italic> and <italic>active</italic> are synonymous with LACP configuration; therefore, PAgP is not configured with this terminology. A port channel will not be unconditionally formed because both sides are set to passive and will not communicate LACP."
    },
    {
       "id":315,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":"",
       "question":"What is the effect of configuring a port channel with one side set to on mode and the other side set to on mode?",
       "choice_a":"The channel group will use PAgP.",
       "choice_b":"The channel group will not be formed.",
       "choice_c":"The channel group will use LACP.",
       "choice_d":"An unconditional port channel will be formed.",
       "correct_answer":"D",
       "explanation":"When both sides of the port channel are configured with the on mode, an unconditional port channel is created. This means there is no control protocol assisting the port channel. The on mode is configured when you do not want to use a control protocol; therefore, PAgP and LACP will not be used."
    },
    {
       "id":316,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"What is the IEEE specification for Spanning Tree Protocol (STP)?",
       "choice_a":"802.1X",
       "choice_b":"802.1w",
       "choice_c":"802.1D",
       "choice_d":"802.1s",
       "correct_answer":"C",
       "explanation":"The original version of STP was created by Digital Equipment Corporation (DEC). The IEEE ratified the specification of STP as 802.1D in 1990. 802.1X is the IEEE standard for port security that requires end devices authenticate before traffic will be allowed to pass. 802.1w is the IEEE standard for Rapid Spanning Tree Protocol (RSTP). 802.1s is the IEEE standard for Multiple Spanning Tree Protocol (MST)."
    },
    {
       "id":317,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Which statement is correct about STP?",
       "choice_a":"STP runs on a central switch by creating a topology database.",
       "choice_b":"STP runs as a distributed process on each switch and creates a topology database.",
       "choice_c":"STP uses routing protocols to check for network loops.",
       "choice_d":"STP uses the MAC address table to check for switching loops.",
       "correct_answer":"B",
       "explanation":"Spanning Tree Protocol runs as a distributed process on each switch. Each switch creates and maintains its own topology database referencing and electing the root bridge. STP does not use routing protocols because it is a layer 2 protocol. STP uses Bridge Protocol Data Unit (BPDU) frames to check for switching loops."
    },
    {
       "id":318,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"How does STP detect and monitor loops in networks?",
       "choice_a":"STP detects and monitors BPDUs being received on multiple interfaces.",
       "choice_b":"STP detects and monitors normal traffic frames being received on multiple interfaces.",
       "choice_c":"STP detects and monitors CDP frames being received on multiple interfaces.",
       "choice_d":"STP detects and monitors access ports in the same VLAN.",
       "correct_answer":"A",
       "explanation":"STP monitors all interfaces for BPDUs, which carry switches\u0027 identities. When it sees the same switch ID in BPDUs on multiple interfaces, a redundant link is detected. STP will not listen to normal traffic frames or CDP on multiple interface. The STP protocol is only concerned with BPDUs since they are only generated by switches that can cause loops. STP can run independently on several different VLANs."
    },
    {
       "id":319,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"What is the IEEE specification for Rapid Spanning Tree Protocol (RSTP)?",
       "choice_a":"802.1X",
       "choice_b":"802.1w",
       "choice_c":"802.1D",
       "choice_d":"802.1s",
       "correct_answer":"B",
       "explanation":"The original STP specification was revamped in 2004 with RSTP 802.1w. This revamping of STP was to fix problems with the original specification. 802.1X is the IEEE standard for port security that requires end devices authenticate before traffic will be allowed to pass. 802.1s is the IEEE standard for Multiple Spanning Tree Protocol (MST). The original version of STP is the 802.1D IEEE specification."
    },
    {
       "id":320,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":4,
       "question":"What is the link cost with respect to STP?",
       "choice_a":"Link cost is the latency of a frame traversing across the link.",
       "choice_b":"Link cost is the calculation of all the ports in the path to the root bridge.",
       "choice_c":"Link cost is the monetary cost to traverse a link.",
       "choice_d":"Link cost is a numeric value associated with the speed of a link.",
       "correct_answer":"D",
       "explanation":"The link cost is a numeric value that represents the cost in speed of a link. The higher the numbers, the lower the speed of the link, thus a higher cost. The link cost is not related to the latency of the frame traversing the link. The link cost is not a calculation of all the ports in the path to the root bridge; this is considered the path cost, not the link cost. There is also no monetary cost associated with a link because it pertains to STP link cost."
    },
    {
       "id":321,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":5,
       "question":"What is the path cost with respect to RSTP?",
       "choice_a":"Path cost is the latency of a frame traversing across the link.",
       "choice_b":"Path cost is the calculation of all the ports in the path to the root bridge.",
       "choice_c":"Path cost is the monetary cost to traverse a link.",
       "choice_d":"Path cost is a numeric value associated with the speed of a link.",
       "correct_answer":"B",
       "explanation":"The RSTP path cost is the calculation of all of the link costs that lead back to the root bridge. The link cost is a numeric value that signifies the speed. The lower the cost, the higher the speed of the link. The path cost is not related to the latency of the frame traversing the link. There is also no monetary cost associated with a link because it pertains to STP link cost. The path cost is not a numeric value associated with the speed of a link; this would be the link cost, not the path cost."
    },
    {
       "id":322,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Which protocol is a Cisco proprietary enhancement for 802.1D that allows separate spanning-tree instances for each VLAN?",
       "choice_a":"IEEE 802.1w",
       "choice_b":"PVST+",
       "choice_c":"CST",
       "choice_d":"RSTP",
       "correct_answer":"B",
       "explanation":"Per-VLAN Spanning Tree+ elects a root bridge for each VLAN and creates a topology table for each VLAN. It is a Cisco proprietary protocol due to the bridge ID calculation it must perform for each VLAN. The IEEE 802.1w specification details Rapid Spanning Tree Protocol (RSTP). The Common Spanning Tree (CST) protocol assumes one spanning tree instance for all VLANs. RSTP is the Spanning Tree Protocol that has superseded the original Spanning Tree Protocol."
    },
    {
       "id":323,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Which protocol is a Cisco proprietary enhancement for 802.1W that allows separate spanning-tree instances for each VLAN?",
       "choice_a":"Rapid PVST+",
       "choice_b":"PVST+",
       "choice_c":"CST",
       "choice_d":"RSTP+",
       "correct_answer":"A",
       "explanation":"Rapid Per-VLAN Spanning Tree+ elects a root bridge for each VLAN. It allows for fast convergence times and logical placement of the root bridge. However, it requires the most CPU and RAM of all implementations. Per-VLAN Spanning Tree + (PVST+) operates similar to PVST+; however, it transmits 802.1D BPDUs. The Common Spanning Tree (CST) protocol assumes one spanning tree instance for all VLANs. There is no protocol called the RSTP+ protocol; therefore, it is an invalid answer."
    },
    {
       "id":324,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Which statement is correct about the Common Spanning Tree (CST)?",
       "choice_a":"CST elects a root bridge for each VLAN.",
       "choice_b":"CST elects a single root bridge for the entire physical network.",
       "choice_c":"CST has an immediate convergence because it elects a single root bridge.",
       "choice_d":"CST is best implemented for really large networks because it scales efficiently.",
       "correct_answer":"B",
       "explanation":"Common Spanning Tree elects a single root bridge for the entire network and all of the VLANs. This creates a problem when the center of your network may vary upon VLAN placement. CST is a variant of STP; therefore, it has slower convergence times. CST should not be used in really large networks because the root switch for the various VLANs may be in different locations on the network. CST elects only one root bridge for all VLANs, which could cause a problem."
    },
    {
       "id":325,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Which statement is correct about RSTP?",
       "choice_a":"RSTP allows for multiple root bridges.",
       "choice_b":"RSTP is backward compatible with STP.",
       "choice_c":"RSTP has a convergence time of around 50 seconds.",
       "choice_d":"RSTP has five port states to which the interfaces could possibly transition.",
       "correct_answer":"B",
       "explanation":"RSTP has three transition modes and converges faster than STP, which is 50 seconds. It is, however, backward compatible with STP 802.1D. RSTP by itself does not allow for multiple root bridges; however, the extension of Rapid Per-VLAN Spanning Tree+ (Rapid PVST+) will allow for multiple root bridges. RSTP has an extremely fast convergence time, and STP has a convergence time of 50 seconds. STP has five port states to which an interface could possibly transition; RTSP has only three port states."
    },
    {
       "id":326,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"How do switches participating in an STP network become aware of topology changes?",
       "choice_a":"The root bridge is responsible for sensing the change and sending Topology Change Notification BPDUs.",
       "choice_b":"Each switch is responsible for sensing the change and sending Topology Change Notification BPDUs.",
       "choice_c":"The root bridge polls each switch participating in STP for changes.",
       "choice_d":"The switches participating in STP poll the root bridge for changes.",
       "correct_answer":"B",
       "explanation":"Each switch is responsible for sensing changes to the topology; it is not the sole responsibility of the root bridge. Whenever the topology changes, a Topology Change Notification (TCN) is sent out all root ports and an acknowledgment is sent back. This happens until the root bridge sends back a notification. The root bridge does not poll each switch participating in STP for changes, and the switches participating in STP do not poll the root bridge for changes."
    },
    {
       "id":327,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":1,
       "question":"Which of the following standards is an IEEE standard that replaces Rapid PVST+?",
       "choice_a":"802.1X",
       "choice_b":"802.1w",
       "choice_c":"802.1D",
       "choice_d":"802.1s",
       "correct_answer":"B",
       "explanation":"802.1s, which is called Multiple Spanning Tree (MST), is a standard based upon PVST+. It is an open standard created by the IEEE that will allow Per-VLAN Spanning Tree in multi-vendor switched networks. 802.1X is the IEEE standard for port security that requires end devices authenticate before traffic will be allowed to pass. The original IEEE specification of STP (802.1D) was revamped in 2004 with RSTP 802.1w. This revamping of STP was to fix problems with the original specification."
    },
    {
       "id":328,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"You have a network consisting of four switches, all configured with the same bridge priority. Which switch will be elected the root bridge?",
       "choice_a":"0081.023a.b433",
       "choice_b":"0011.03ae.d8aa",
       "choice_c":"0041.0611.1112",
       "choice_d":"0021.02fa.bdfc",
       "correct_answer":"B",
       "explanation":"The switch with the MAC address of 0011.03ae.d8aa will become the root bridge. Its MAC address is the lowest out of the four switches. All of the other options are incorrect."
    },
    {
       "id":329,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":4,
       "question":"What is the default STP mode all Cisco switches run?",
       "choice_a":"802.1D",
       "choice_b":"802.1w",
       "choice_c":"PVST+",
       "choice_d":"Rapid PVST+",
       "correct_answer":"D",
       "explanation":"All Cisco switches are defaulted to the Cisco proprietary STP protocol extension of Rapid-PVST+. 802.1D is the original IEEE specification for STP. 802.1w is the IEEE specification for RSTP. PVST+ is the Cisco proprietary protocol extension for STP."
    },
    {
       "id":330,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":5,
       "question":"Which option is a correct statement about alternate ports in RSTP?",
       "choice_a":"An alternate port receives BPDUs from another port on the same switch and therefore can replace the designated port if it fails.",
       "choice_b":"An alternate port receives BPDUs from another switch and therefore can replace the designated port if it fails.",
       "choice_c":"An alternate port is always placed in a forwarding state.",
       "choice_d":"An alternate port receives BPDUs from another switch and therefore can replace the root port if it fails.",
       "correct_answer":"D",
       "explanation":"An alternate port is a port that is in a discarding state. If the root port fails on the switch with the alternate port, then the alternate port becomes the root port for that switch. An alternate port is used only if the root bridge fails; it will not allow for an alternate path on a non-root bridge. An alternate port cannot replace a designated port if it fails. An alternate port is never placed in a forwarding state. <img src='/question_assets/ccna/2_image15.png'></img>"
    },
    {
       "id":331,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"How is the root bridge in STP elected?",
       "choice_a":"The root bridge is the switch with the highest IP address and priority",
       "choice_b":"The root bridge is the switch with the lowest IP address and priority.",
       "choice_c":"The root bridge is the switch with the lowest MAC address and priority.",
       "choice_d":"The root bridge is the switch with the highest MAC address and priority.",
       "correct_answer":"C",
       "explanation":"The root bridge is elected by all of the switches and has the lowest MAC address and priority of all the switches in the network. The root bridge is not elected based upon a high or low IP address. Spanning Tree can function without an IP address, since it is a layer 2 loop avoidance."
    },
    {
       "id":332,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Why is a root bridge elected for STP to function properly?",
       "choice_a":"The root bridge is the logical center of the STP topology.",
       "choice_b":"The root bridge allows all forwarding decisions of frames.",
       "choice_c":"The root bridge calculates the port cost for the rest of the network.",
       "choice_d":"The root bridge calculates the fastest path for the rest of the network.",
       "correct_answer":"A",
       "explanation":"The root bridge is a point of perspective for the rest of the STP network. It is important to have a point of perspective to calculate which ports are blocked and which remain in a forwarding mode. The root bridge has no influence on the forwarding decisions of frames. Each switch is responsible for its own calculation of STP; only the root bridge election is the consensus of all switches in the network."
    },
    {
       "id":333,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"How does a switch calculate the bridge ID?",
       "choice_a":"The bridge ID is a 6-byte number containing a 2-byte bridge priority and 4-byte IP address.",
       "choice_b":"The bridge ID is an 8-byte number containing a 4-byte bridge priority and 4-byte IP address.",
       "choice_c":"The bridge ID is an 8-byte number containing a 2-byte bridge priority and 6-byte MAC address.",
       "choice_d":"The bridge ID is a 10-byte number containing a 4-byte bridge priority and 6-byte MAC address.",
       "correct_answer":"C",
       "explanation":"The bridge ID is made up of a 2-byte bridge priority and a 6-byte MAC address for a total of 8 bytes. All of the other options are incorrect."
    },
    {
       "id":334,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"What is the definition of a designated port?",
       "choice_a":"A port that is determined to have the lowest cost and placed in a forwarding state for a network segment",
       "choice_b":"A port that is determined to have the highest cost and placed in a forwarding state for a network segment",
       "choice_c":"A port that is determined to have the lowest path cost to the root bridge and placed in a forwarding state for a network segment",
       "choice_d":"A port that is determined to have the highest path cost to the root bridge and placed in a blocking state for a network segment",
       "correct_answer":"A",
       "explanation":"A designated port is a port that has the lowest cost compared to the higher cost of the redundant ports. It is placed into a forwarding state for a network segment. A designated port is determined to have the lowest cost, and not the highest cost, when it is placed into a forwarding state. A port that has the lowest cost to the root bridge is a root port and not a designated port. A port that has the highest cost to the root bridge is placed into a blocking state."
    },
    {
       "id":335,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Which is a correct statement about bridge port roles in STP?",
       "choice_a":"Every switch, excluding the root bridge, must have at least one root port.",
       "choice_b":"Every switch, including the root bridge, must have at least one designated port.",
       "choice_c":"Every switch, excluding the root bridge, must have at least one alternate port.",
       "choice_d":"Every switch, including the root bridge, must have at least one backup port.",
       "correct_answer":"A",
       "explanation":"Every switch in the network segment must have at least one root port. This is the port that leads back to the root bridge. The root bridge will have a designated port on the adjacent link. Every switch will have an active link back to the root bridge; however, those ports leading back the root bridge are called root ports. A network may not have any alternate ports, depending on the topology and layout of the network. A network may not have any backup ports for the same reasons."
    },
    {
       "id":336,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":4,
       "question":"What is the definition of an STP root port?",
       "choice_a":"A port that is determined to have the lowest cost to the network segment and placed in a forwarding state",
       "choice_b":"A port that is determined to have the highest cost to the network segment and placed in a forwarding state",
       "choice_c":"A port that is determined to have the lowest path cost to the root bridge and placed in a forwarding state for a network segment",
       "choice_d":"A port that is determined to have the highest path cost to the root bridge and placed in a blocking state for a network segment",
       "correct_answer":"C",
       "explanation":"The root port is the port that leads back to the root bridge on the adjacent switch. It has the lowest cost of the redundant ports. A root port is determined to have the lowest cost to the root bridge, not a network segment. Root ports are always determined to have the lowest cost, not the highest cost."
    },
    {
       "id":337,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":5,
       "question":"What is the definition of an STP designated port?",
       "choice_a":"A port that is determined to have the lowest cost to the network segment and placed in a forwarding state",
       "choice_b":"A port that is determined to have the lowest path cost to the root bridge and placed in a forwarding state for a network segment",
       "choice_c":"A port that is determined to have the highest path cost to the root bridge and placed in a blocking state for a network segment",
       "choice_d":"A port that is determined to have the highest cost to the network segment and placed in a forwarding state",
       "correct_answer":"A",
       "explanation":"The designated port is the port with the lowest cost of the redundant links to the network segment. The adjacent port is normally the root port leading back to the root bridge. A port that is determined to have the lowest cost or path cost to the root bridge is called the root port and not a designated port. The designated port will always have the lowest cost to a network segment, not the highest cost."
    },
    {
       "id":338,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"How is the bridge ID calculated for PVST+?",
       "choice_a":"The bridge ID is a 4-byte bridge priority, a 12-byte sys-id-ext, and a 6-byte MAC address.",
       "choice_b":"The bridge ID is a 4-byte bridge priority and sys-id-ext and a 6-byte MAC address.",
       "choice_c":"The bridge ID is a 4-bit bridge priority, a 12-bit sys-id-ext, and a 6-byte MAC address.",
       "choice_d":"The bridge ID is a 4-bit bridge priority, a 12-bit sys-id-ext, and an 8-byte IP address.",
       "correct_answer":"C",
       "explanation":"The PVST+ bridge ID comprises a 4-bit bridge priority calculated in blocks of 4096, a 12-bit sys-ext-id that is the VLAN ID for the segment, and a 6-byte MAC address for the switch. All of the other options are incorrect."
    },
    {
       "id":339,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"What is the default bridge priority for all STP switches?",
       "choice_a":"Bridge priority of 8,192",
       "choice_b":"Bridge priority of 16,384",
       "choice_c":"Bridge priority of 32,768",
       "choice_d":"Bridge priority of 65,526",
       "correct_answer":"C",
       "explanation":"The default bridge priority for STP is 32,768. All of the other options are incorrect."
    },
    {
       "id":340,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Which is a correct statement about bridge port roles in STP?",
       "choice_a":"A designated port is always in a blocking state.",
       "choice_b":"Every switch, including the root bridge, must have at least one designated port.",
       "choice_c":"Every switch, excluding the root bridge, must have at least one non-designated port.",
       "choice_d":"All ports on the root bridge are in a designated port state.",
       "correct_answer":"D",
       "explanation":"The root bridge always has all of its ports in a designated mode or forwarding mode. If there are redundant links, the adjacent switch to the designated port on the root bridge must be a non-designated or blocking state. A designated port is always in a forwarding state. Every switch will not have at least one designated port; it is safe to say that every switch will have at least one port in a forwarding mode. Every switch will not have at least one non-designated port since a switch might only have one link back to the root bridge."
    },
    {
       "id":341,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Which is a correct statement about backup ports in RSTP?",
       "choice_a":"A backup port receives BPDUs from another port on the same switch and therefore can replace the designated port if it fails.",
       "choice_b":"A backup port receives BPDUs from another switch and therefore can replace the designated port if it fails",
       "choice_c":"A backup port is always placed in a forwarding state.",
       "choice_d":"A backup port receives BPDUs from another switch and therefore can replace the root port if it fails.",
       "correct_answer":"A",
       "explanation":"A backup port is a port in a discarding state. It receives BPDUs from another port on the same switch. If the forwarding port fails, then the backup port will become designated so that connectivity to the segment can be restored. A backup port is another port on the same switch that receives BPDUs from itself. A backup port is placed into a blocking state and not a forwarding state. <img src='/question_assets/ccna/2_image16.png'></img>"
    },
    {
       "id":342,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":4,
       "question":"What is the default wait time for STP convergence to complete?",
       "choice_a":"Convergence takes 60 seconds to complete.",
       "choice_b":"Convergence takes 5 seconds to complete.",
       "choice_c":"Convergence takes 30 seconds to complete.",
       "choice_d":"Convergence takes 50 seconds to complete.",
       "correct_answer":"D",
       "explanation":"802.1D STP convergence takes 50 seconds to complete before the port is put into a state of forwarding or blocking. This is dependent on the STA, or spanning-tree algorithm. All of the other options are incorrect."
    },
    {
       "id":343,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":5,
       "question":"When a computer is connected to an interface with STP enabled in default mode, which is the correct order of the port transitions?",
       "choice_a":"Listening, learning, blocking, forwarding",
       "choice_b":"Forwarding, listening, learning, blocking",
       "choice_c":"Blocking, listening, learning, forwarding",
       "choice_d":"Blocking, learning, listening, forwarding",
       "correct_answer":"C",
       "explanation":"When a computer is connected to an STP-enabled interface, the port will transition between blocking, listening, learning, and forwarding. The time between the states of blocking and forwarding is called the convergence and is 50 seconds. Spanning Tree PortFast operates in a forwarding, listening, learning, and then possibly blocking state. All of the other options are incorrect."
    },
    {
       "id":344,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Which statement describes an STP port that is placed into a blocking state?",
       "choice_a":"When a port is placed into a blocking state, it blocks all frames, including BPDUs.",
       "choice_b":"When a port is placed into a blocking state, it blocks redundant frames, excluding BPDUs.",
       "choice_c":"When a port is placed into a blocking state, it blocks all frames, excluding BPDUs.",
       "choice_d":"When a port is placed into a blocking state, it blocks redundant frames, including BPDUs.",
       "correct_answer":"C",
       "explanation":"An STP blocked port will block all frames from being forwarded. The blocking excludes BPDUs, which it will continue to listen for and calculate future topology decisions. When a port is in a blocking state, it will block all frames regardless if they are redundant, excluding BPDUs."
    },
    {
       "id":345,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"When a computer is connected to an interface with RSTP enabled in default mode, which is the correct order of the port transitions?",
       "choice_a":"Discarding, learning, blocking, forwarding",
       "choice_b":"Discarding, listening, forwarding",
       "choice_c":"Blocking, listening, learning, forwarding",
       "choice_d":"Discarding, learning, forwarding",
       "correct_answer":"D",
       "explanation":"RSTP has three transitions when a computer is plugged in (no loops). The transitions are discarding, learning, and forwarding, which allow for rapid convergence times. All of the other options are incorrect."
    },
    {
       "id":346,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"In RSTP, which port mode replaces the blocking and listening port states?",
       "choice_a":"Discarding",
       "choice_b":"Learning",
       "choice_c":"Forwarding",
       "choice_d":"Backup",
       "correct_answer":"A",
       "explanation":"RSTP has three port states: discarding, learning, and forwarding. Blocking and listening are both mapped to discarding in RSTP. When a port is in a state of discarding, it means the interface is discarding all frames except for BPDUs. A port in a learning state will learn incoming BPDUs to calculate redundant links. A port in a forwarding state will forward all packets as expected. A backup port is a port on the same network segment as another port on the same switch; this allows communication from the network segment if the designated port fails."
    },
    {
       "id":347,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Which new port state does RTSP have compared to STP?",
       "choice_a":"Learning",
       "choice_b":"Forwarding",
       "choice_c":"Blocking",
       "choice_d":"Discarding",
       "correct_answer":"D",
       "explanation":"The new port state that RTSP has is discarding, which replaces the blocking state of STP. Learning in RSTP is the same as the learning state in STP. The forwarding state in RSTP is the same as the forwarding state in STP. The blocking state is not found in RSTP; it is found in STP."
    },
    {
       "id":348,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"You receive a call that when computers boot up, they display an error message stating that they cannot reach a domain controller. However, after a few tries, the problem goes away, and the domain controller can be reached. Which command would you enter into the interface if you suspect spanning-tree convergence problems?",
       "choice_a":"<code>SwitchA(config-if)#no switchport spanning-tree</code>",
       "choice_b":"<code>SwitchA(config)#switchport spanning-tree portfast</code>",
       "choice_c":"<code>SwitchA(config)#spanning-tree portfast default</code>",
       "choice_d":"<code>SwitchA(config-if)#spanning-tree portfast</code>",
       "correct_answer":"D",
       "explanation":"The command <code>spanning-tree portfast</code> entered into the interface will turn on PortFast mode. This will allow the interface to forward first. The command <code>no switchport spanning-tree</code> is incorrect. The command <code>switchport spanning-tree portfast</code> is incorrect. The command <code>spanning-tree portfast default</code> is incorrect."
    },
    {
       "id":349,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":4,
       "question":"On which types of ports should you configure PortFast mode?",
       "choice_a":"Trunk ports",
       "choice_b":"Access ports",
       "choice_c":"Voice ports",
       "choice_d":"Designated ports",
       "correct_answer":"B",
       "explanation":"PortFast should only be configured on access links where end devices are plugged in because these devices will not typically create loops in the switch topology. If PortFast is configured on a trunk port, you have a very high risk of creating a loop if there is a misconfiguration on the switch being introduced. Voice ports have a lower probability of a network loop, but voice ports are usually connected to VoIP phones with built-in switches that can be looped. Designated ports are ports that are adjacent to a root port on the opposite switch that leads back to the root port."
    },
    {
       "id":350,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":5,
       "question":"What will the command <code>spanning-tree portfast default</code> entered in global configuration mode do?",
       "choice_a":"Turn on PortFast mode for all ports",
       "choice_b":"Turn on PortFast mode for all access ports only",
       "choice_c":"Turn off spanning tree on all ports",
       "choice_d":"Turn off spanning tree on all access ports only",
       "correct_answer":"B",
       "explanation":"This command turns on PortFast globally for only access ports on the switch. This command should be used on access switches because end devices are connected at this level in the hierarchy. The command <code>spanning-tree portfast default</code> is used to configure PortFast globally. This command does not turn off Spanning Tree for any ports."
    },
    {
       "id":351,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"What will happen if you plug a hub into two ports on the same switch configured with PortFast on all the interfaces?",
       "choice_a":"You will create a temporary switching loop.",
       "choice_b":"You will create a permanent switching loop.",
       "choice_c":"Both ports will sense the switch and err-disable.",
       "choice_d":"One of the links will disable via Spanning Tree.",
       "correct_answer":"A",
       "explanation":"You will create a temporary switching loop until the BPDUs are heard from each interface over the hub. However, during this period you will have a switching loop and degrade traffic over the entire switching topology until convergence happens. This is risky because the CPU could spike to 100% and not be able to detect the BPDUs and the loops will continue. With PortFast configured, the ports will not enter an err-disable state; they will forward traffic until the network connection is fully saturated with bandwidth. The port will not disable itself via Spanning Tree since the port transitions between forwarding, listening, learning, and then possibly changing into a blocking mode."
    },
    {
       "id":352,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Which feature will protect a switch immediately if it sees another switch\u0027s advertisement?",
       "choice_a":"BPDU Guard",
       "choice_b":"BPDU Detection",
       "choice_c":"Voice ports",
       "choice_d":"UplinkFast",
       "correct_answer":"A",
       "explanation":"BPDU Guard will turn the interface to err-disable as soon as a BPDU is heard on the interface. This feature should be enabled on access switches when configuring PortFast. There is no such feature called BPDU Detection. Loop Guard is used in conjunction with BPDU Guard for additional protection by monitoring and tracking BPDUs. UplinkFast is a Cisco proprietary feature that improves convergence times for Spanning Tree."
    },
    {
       "id":353,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"What is the transition of states when PortFast is configured?",
       "choice_a":"Forwarding, listening, learning, blocking",
       "choice_b":"Listening, forwarding, learning, blocking",
       "choice_c":"Listening, learning, forwarding, blocking",
       "choice_d":"Blocking, listening, learning, forwarding",
       "correct_answer":"A",
       "explanation":"PortFast mode allows an interface to bypass the blocking state and begin forwarding immediately. It then listens and learns of BPDUs on the interface and can make a decision to continue to forward frames or enter into a blocking state. All of the other options are incorrect."
    },
    {
       "id":354,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Which command would you use to configure BPDU Guard on an interface?",
       "choice_a":"<code>SwitchA(config-if)#switchport mode bpduguard</code>",
       "choice_b":"<code>SwitchA(config-if)#switchport bpduguard enable</code>",
       "choice_c":"<code>SwitchA(config-if)#spanning-tree bpduguard enable</code>",
       "choice_d":"<code>SwitchA(config-if)#spanning-tree bpduguard</code>",
       "correct_answer":"C",
       "explanation":"The correct command to configure BPDU Guard on a single interface is <code>spanning-tree bpduguard enabled</code> entered into the interface you want to turn it on for. The command <code>switchport mode bpduguard</code> is incorrect. The command <code>switchport bpduguard enable</code> is incorrect. The command <code>spanning-tree bpduguard</code> is incorrect."
    },
    {
       "id":355,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":4,
       "question":"After you configure an access switch on your network, you receive a call that the users have lost connectivity. You examine the trunk interface with the command <code>show interfaces Gi 0/1</code>. What might be the problem? <img src='/question_assets/ccna/2_image17.png'></img>",
       "choice_a":"A Spanning Tree loop has been detected.",
       "choice_b":"The switch uplink cable is bad.",
       "choice_c":"BPDU Guard was configured on a trunk.",
       "choice_d":"Flow control is turned off.",
       "correct_answer":"C",
       "explanation":"BPDU Guard was turned on the trunk link. When the BPDU of the adjacent switch was seen, the switch turned the port into err-disabled mode. A Spanning Tree loop will not err-disable an interface; it will simply block the offending port. A switch uplink cable that is bad will not place the interface into an err-disable state. Flow control will not have any effect in placing an interface into an err-disable state."
    },
    {
       "id":356,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":5,
       "question":"Which option is a best practice when configuring links on an access switch?",
       "choice_a":"Never configure spanning-tree PortFast mode on an access link.",
       "choice_b":"Always configure BPDU Guard along with PortFast.",
       "choice_c":"Always configure BPDU Guard on trunks.",
       "choice_d":"Always configure BPDU Guard along with UplinkFast.",
       "correct_answer":"B",
       "explanation":"Configuring BPDU Guard along with PortFast ensures that the end device will always be forwarding. BPDU Guard ensures that in the event a BPDU is heard on the interface, the interface will enter into an err-disable mode. You should only configure PortFast mode on access links. BPDU Guard should never be configured on a trunk line since it will place the interface into an err-disable state when a BPDU is seen. BPDU Guard and UplinkFast perform similar functions, such as preventing network loops."
    },
    {
       "id":357,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Which command will show you if a port has been configured for PortFast mode?",
       "choice_a":"<code>Switch#show portfast</code>",
       "choice_b":"<code>Switch#show interface fa 0/1</code>",
       "choice_c":"<code>Switch#show spanning-tree</code>",
       "choice_d":"<code>Switch#show spanning-tree interface fa 0/1</code>",
       "correct_answer":"D",
       "explanation":"Using the command <code>show spanning-tree interface fa 0/1</code> will show the spanning tree configuration for an interface. If PortFast has been configured, the last line will display <code>The port is in the PortFast mode</code>. The command <code>show portfast</code> is incorrect. The command <code>show interface fa 0/1</code> is incorrect. The command <code>show spanning-tree</code> is incorrect."
    },
    {
       "id":358,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Which command would you use to remove BPDU Guard from an interface?",
       "choice_a":"<code>Switch(config-if)#switchport bdpugaurd disable</code>",
       "choice_b":"<code>Switch(config-if)#spanning-tree bpduguard delete</code>",
       "choice_c":"<code>Switch(config-if)#no switchport bpduguard</code>",
       "choice_d":"<code>Switch(config-if)#spanning-tree bpduguard disable</code>",
       "correct_answer":"D",
       "explanation":"One way to disable BDPU Guard is to enter the command <code>spanning-tree bpduguard disable</code>. Another way is to negate the command with <code>no spanning-tree bpduguard.</code> The command <code>switchport bdpugaurd disable</code> is incorrect. The command <code>spanning-tree bpduguard delete</code> is incorrect. The command <code>no switchport bpduguard</code> is incorrect."
    },
    {
       "id":359,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"You have BPDU Guard configured on an interface. What happens if a BPDU is advertised on the interface?",
       "choice_a":"The interface will become administratively disabled.",
       "choice_b":"The interface will become disabled.",
       "choice_c":"The interface will become err-disabled.",
       "choice_d":"A small switching loop will happen until convergence.",
       "correct_answer":"C",
       "explanation":"The switch\u0027s interface will become err-disabled immediately. Once it is in err-disable mode, an administrator is required to reset the interface. When an interface is administratively disabled, it has been done so by an administrator manually. The interface will not become disabled if a BPDU is advertised with BPDU Guard enabled; it will be err-disabled. Fortunately, a small switching loop will be averted as the interface will be placed into an err-disable mode."
    },
    {
       "id":360,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"Which command will show you if BPDU Guard is enabled by default?",
       "choice_a":"<code>Switch#show interface gi 0/1</code>",
       "choice_b":"<code>Switch#show spanning-tree summary</code>",
       "choice_c":"<code>Switch#show spanning-tree vlan 2</code>",
       "choice_d":"<code>Switch#show spanning-tree</code>",
       "correct_answer":"B",
       "explanation":"The <code>show spanning-tree summary</code> command will show you which features are turned on globally or by default. The command <code>show interface gi 0/1</code> is incorrect. The command <code>show spanning-tree vlan 2</code> is incorrect. The command <code>show spanning-tree</code> is incorrect."
    },
    {
       "id":361,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":"",
       "question":"You are configuring an edge switch and want to make sure that someone does not plug a switch in accidentally. Which feature will you configure?",
       "choice_a":"PortFast",
       "choice_b":"UplinkFast",
       "choice_c":"BackboneFast",
       "choice_d":"BPDU Guard",
       "correct_answer":"D",
       "explanation":"BPDU Guard will protect the edge switch from someone accidentally plugging in another switch to a port dedicated for end devices. Spanning Tree PortFast will allow the interface to enter into a forwarding mode as it listens and learns BPDUs converging. UplinkFast helps faster convergence when an uplink fails between switches. BackboneFast is a Cisco proprietary protocol that improves convergence in the event an uplink fails."
    },
    {
       "id":362,
       "topic_id":2,
       "sub_domain":"2.6 Compare Cisco Wireless Architectures and AP modes",
       "practice_test_id":4,
       "question":"You require a density of 100 wireless clients in a relatively small area. Which design would be optimal?",
       "choice_a":"Autonomous WAPs with a WLC",
       "choice_b":"Lightweight WAPs with a WLC",
       "choice_c":"Autonomous WAPs without a WLC",
       "choice_d":"Lightweight WAPs without a WLC",
       "correct_answer":"B",
       "explanation":"To achieve density and/or bandwidth in a relatively small area, you will need to deploy lightweight WAPs with a wireless LAN controller (WLC). Although autonomous WAPs without a WLC would work, it would be problematic due to frequency coordination and roaming. Lightweight WAPs do not function without a WLC."
    },
    {
       "id":363,
       "topic_id":2,
       "sub_domain":"2.6 Compare Cisco Wireless Architectures and AP modes",
       "practice_test_id":5,
       "question":"Which mode will allow a Cisco AP to detect interference of Bluetooth devices?",
       "choice_a":"BT mode",
       "choice_b":"Sniffing mode",
       "choice_c":"Analysis mode",
       "choice_d":"Monitor mode",
       "correct_answer":"D",
       "explanation":"Cisco wireless access points can be placed into one of two modes: data serving mode or monitoring mode. In data serving mode, the AP will serve data and act as a normal wireless access point. When the AP is switched into monitor mode, the AP can scan the wireless spectrum and report on interference. It is important to note that when in monitoring mode, the AP will not serve data. The AP can be configured for both modes at the same time, with an impact on performance. All of the other options are incorrect."
    },
    {
       "id":364,
       "topic_id":2,
       "sub_domain":"2.6 Compare Cisco Wireless Architectures and AP modes",
       "practice_test_id":"",
       "question":"Which wireless mode allows for a network connection without a wireless infrastructure in place?",
       "choice_a":"BSS",
       "choice_b":"ESS",
       "choice_c":"IBSS",
       "choice_d":"DS",
       "correct_answer":"C",
       "explanation":"An independent basic service set (IBSS), also known as an ad hoc network, does not require any wireless infrastructure. Clients connect directly to each other over the 802.11 wireless spectrum. A basic service set (BSS) is a small area with wireless coverage and is served by a single WAP. An extended service set (ESS) is a scaled out BSS, where many WAPs support client roaming between the WAPs and channel selection. The distribution system (DS) is the connection between the wireless network and the wired network."
    },
    {
       "id":365,
       "topic_id":2,
       "sub_domain":"2.6 Compare Cisco Wireless Architectures and AP modes",
       "practice_test_id":"",
       "question":"Which statement is correct about root and non-root wireless devices?",
       "choice_a":"Non-root devices can connect to other non-root devices.",
       "choice_b":"Non-root devices can connect to root devices.",
       "choice_c":"Root devices can connect to other root devices.",
       "choice_d":"Repeaters are considered root devices.",
       "correct_answer":"B",
       "explanation":"Non-root devices such as clients and repeaters connect to root devices such as wireless access points (WAPs). Non-root devices cannot connect to other non-root devices in normal situations such as a network with infrastructure. Root devices do not connect to other root devices; they do connect to wired infrastructure. Repeaters are considered non-root devices."
    },
    {
       "id":366,
       "topic_id":2,
       "sub_domain":"2.6 Compare Cisco Wireless Architectures and AP modes",
       "practice_test_id":1,
       "question":"Which type of WAP can operate independently?",
       "choice_a":"Lightweight WAP",
       "choice_b":"WLC",
       "choice_c":"Mesh",
       "choice_d":"Autonomous WAP",
       "correct_answer":"D",
       "explanation":"An autonomous WAP has a full operating system and controls its own functions independently. A lightweight WAP requires a wireless LAN controller (WLC) to function. A mesh wireless access point communicates with other wireless access points to extend distance and signal."
    },
    {
       "id":367,
       "topic_id":2,
       "sub_domain":"2.6 Compare Cisco Wireless Architectures and AP modes",
       "practice_test_id":4,
       "question":"You have three buildings that are separated by a number of public roads but have a relatively close proximity to each other. You need to network them together to a central point. Which type of wireless technology should you deploy?",
       "choice_a":"Point-to-point wireless bridge",
       "choice_b":"Mesh wireless network",
       "choice_c":"Point-to-multipoint wireless bridge",
       "choice_d":"Autonomous wireless network",
       "correct_answer":"C",
       "explanation":"A point-to-multipoint wireless bridge will allow you to connect all three buildings together, tying them back to a central location. A mesh network is usually designed for endpoints (clients) and not the interconnection of buildings. Point-to-point bridges would allow all the building to connect to each other, but it would not network them together to a central point. Autonomous wireless access points are used for endpoint connectivity and not building-to-building connectivity."
    },
    {
       "id":368,
       "topic_id":2,
       "sub_domain":"2.6 Compare Cisco Wireless Architectures and AP modes",
       "practice_test_id":5,
       "question":"What is the maximum length of an SSID?",
       "choice_a":"16 characters",
       "choice_b":"32 characters",
       "choice_c":"48 characters",
       "choice_d":"64 characters",
       "correct_answer":"B",
       "explanation":"A service set identifier (SSID) can be a maximum of 32 characters in length. The wireless access point will associate a MAC address to the SSID so clients can associate to the SSID. All of the other options are incorrect."
    },
    {
       "id":369,
       "topic_id":2,
       "sub_domain":"2.6 Compare Cisco Wireless Architectures and AP modes",
       "practice_test_id":"",
       "question":"A customer complains that their wireless network drops signal when they are performing inventory in the back of their warehouse. The customer wants to cover the small area for as little money as possible. What would you recommend?",
       "choice_a":"Wireless bridging",
       "choice_b":"Mesh wireless system",
       "choice_c":"Addition of a wireless LAN controller",
       "choice_d":"Wireless repeater",
       "correct_answer":"D",
       "explanation":"The cheapest and most effective solution you could recommend is to install a wireless repeater. A wireless repeater will do just that; it will repeat the current wireless signal and allow for extra distance. A wireless bridging system is used for connecting buildings or locations where running wire is just not possible. A mesh wireless system is probably the most expensive option, since it requires infrastructure such as a controller and lightweight WAPs. Adding just a wireless LAN controller will not add any benefit."
    },
    {
       "id":370,
       "topic_id":2,
       "sub_domain":"2.6 Compare Cisco Wireless Architectures and AP modes",
       "practice_test_id":"",
       "question":"Which type of WAP requires a wireless controller?",
       "choice_a":"Lightweight WAP",
       "choice_b":"BSS",
       "choice_c":"Bridges",
       "choice_d":"Autonomous WAP",
       "correct_answer":"A",
       "explanation":"A lightweight WAP requires a wireless LAN controller (WLC) to function because all data forwarding is controlled by the WLC. A basic service set (BSS) is not a type of wireless access point; it is a deployment of wireless. Wireless bridges allow for buildings or locations where running cable is not possible to bridge the locations. An autonomous WAP is a WAP that can act independently without a WLC."
    },
    {
       "id":371,
       "topic_id":2,
       "sub_domain":"2.6 Compare Cisco Wireless Architectures and AP modes",
       "practice_test_id":"",
       "question":"You need to cover a large public area with high speed wireless coverage. Many of the areas are too far away from the wired switching equipment. What should you implement?",
       "choice_a":"Mesh wireless network",
       "choice_b":"Autonomous wireless network",
       "choice_c":"Point-to-multipoint wireless bridges",
       "choice_d":"Wireless repeaters",
       "correct_answer":"A",
       "explanation":"A mesh wireless network will allow for coverage of the large area. A mesh network will provide the highest bandwidth possible. An autonomous wireless network is composed of several wireless access point, but they require direct connection to the wired network. A point-to-multipoint wireless bridge is used for connecting buildings together to a central point. Wireless repeaters could possibly achieve the coverage, but they would do so at the cost of bandwidth."
    },
    {
       "id":372,
       "topic_id":2,
       "sub_domain":"2.7 Describe physical infrastructure connections of WLAN components (AP, WLC, access/trunk ports, and LAG)",
       "practice_test_id":4,
       "question":"You are running WLC for a WLAN. You want to allow for guests to be segmented to the guest VLAN. What is the simplest implementation you can configure on the WLC?",
       "choice_a":"Access control lists for one SSID",
       "choice_b":"Two SSIDs, one configured to the production VLAN and another configured to the guest VLAN",
       "choice_c":"Dynamic VLANs for the SSID",
       "choice_d":"Access control lists for two SSIDs",
       "correct_answer":"B",
       "explanation":"Wireless LAN controllers allow trunks to be used so that multiple VLANs can be used. Once the VLANs are accessible to the WLC, you need to create one SSID tied to the VLAN configured for production and another SSID tied to the VLAN configured for guests. Access control lists won\u0027t work because they are implemented at layer 3 and wireless signaling operates at layer 2. Dynamic VLANs are VLANs that are associated with a host dynamically based upon authentication. Although this option would satisfy the segmentation of traffic, it is not the simplest solution to the problem."
    },
    {
       "id":373,
       "topic_id":2,
       "sub_domain":"2.7 Describe physical infrastructure connections of WLAN components (AP, WLC, access/trunk ports, and LAG)",
       "practice_test_id":5,
       "question":"You need more bandwidth to your wireless controller from the router. Currently you have one Gigabit Ethernet connection in use and both your router and wireless controller have another available Gigabit Ethernet connection. What can you do to get more bandwidth?",
       "choice_a":"Nothing. Routers cannot aggregate bandwidth from multiple connections.",
       "choice_b":"Use RIP to balance the bandwidth.",
       "choice_c":"Bundle both Gigabit Ethernet connections in an EtherChannel.",
       "choice_d":"Use the wireless controller to perform inter-VLAN routing.",
       "correct_answer":"C",
       "explanation":"You can build an EtherChannel between routers and wireless controllers to obtain more bandwidth when using router on a stick (ROAS). It is supported on certain models of routers, such as 4000 series routers. RIP will not balance bandwidth between the wireless controller and the router. Wireless controllers will not perform inter-VLAN routing; this job requires a router or firewall with routing capabilities."
    },
    {
       "id":374,
       "topic_id":2,
       "sub_domain":"2.7 Describe physical infrastructure connections of WLAN components (AP, WLC, access/trunk ports, and LAG)",
       "practice_test_id":"",
       "question":"You are connecting a WLC to the network and anticipate requiring several different network segments for voice and data. Which type of port should you configure on the switch?",
       "choice_a":"Access port",
       "choice_b":"Trunk port",
       "choice_c":"Voice port",
       "choice_d":"Routed switch port",
       "correct_answer":"B",
       "explanation":"You should configure a trunk port on the switch so that several different VLANs can be tagged and carried over the link. This will allow the forwarding of both voice and data, with expansion for other applications in the future. An access port will only allow one VLAN of traffic and you would need a separate access port for each type of traffic, eventually running out of physical ports. Although this setup sounds like a voice port would fit the application, a WLC does not have the ability to use a voice port. A routed switch port is nothing more than an interface on the switch with an IP address for routing purposes."
    },
    {
       "id":375,
       "topic_id":2,
       "sub_domain":"2.7 Describe physical infrastructure connections of WLAN components (AP, WLC, access/trunk ports, and LAG)",
       "practice_test_id":"",
       "question":"You are connecting a Cisco WLC to a non-Cisco switch and need to aggregate two ports between the two devices. Which type of link should you research on the non-Cisco device?",
       "choice_a":"LACP",
       "choice_b":"PAgP",
       "choice_c":"LAG",
       "choice_d":"PortChannel",
       "correct_answer":"C",
       "explanation":"Link Aggregation (LAG) must be used between the WLC and the switch, regardless of the brand. Wireless LAN controllers do not support the use of LACP or PAgP; they only support vanilla EtherChannel configurations, also known as LAG. <italic>PortChannel</italic> is a term synonymous with Cisco devices only."
    },
    {
       "id":376,
       "topic_id":2,
       "sub_domain":"2.7 Describe physical infrastructure connections of WLAN components (AP, WLC, access/trunk ports, and LAG)",
       "practice_test_id":"",
       "question":"How is traffic load-balanced from a WLC to a switch using LAG?",
       "choice_a":"Round robin",
       "choice_b":"Hash based",
       "choice_c":"First in, first out (FIFO)",
       "choice_d":"Spill and fill",
       "correct_answer":"B",
       "explanation":"When a LAG is created between a switch and a WLC, the method of load balancing used is hash-based, using layer 4 source and destination ports. Round robin load balancing cannot be configured on the WLC or switch side of a LAG. First in, first out (FIFO) is a buffer mechanism used to send data out as it comes in, and it is not used in load balancing scenarios. Spill and fill is a method of saturating one link before the other link is used; it is not used in load balancing scenarios."
    },
    {
       "id":377,
       "topic_id":2,
       "sub_domain":"2.7 Describe physical infrastructure connections of WLAN components (AP, WLC, access/trunk ports, and LAG)",
       "practice_test_id":"",
       "question":"What is the maximum number of ports you can bundle in a LAG between a WLC and a switch?",
       "choice_a":16,
       "choice_b":8,
       "choice_c":4,
       "choice_d":2,
       "correct_answer":"B",
       "explanation":"The maximum number of ports that can be bundled in a LAG is 8 ports. All of the other options are incorrect."
    },
    {
       "id":378,
       "topic_id":2,
       "sub_domain":"2.7 Describe physical infrastructure connections of WLAN components (AP, WLC, access/trunk ports, and LAG)",
       "practice_test_id":"",
       "question":"You company has been contracted to implement a 802.11 wireless system for a small town. Which type of implementation is this considered?",
       "choice_a":"WMAN",
       "choice_b":"WPAN",
       "choice_c":"WLAN",
       "choice_d":"WWAN",
       "correct_answer":"A",
       "explanation":"When a wireless system spans a town, city, or large metropolitan area, it is considered a wireless metro area network (WMAN). These can be found in many cities today but are not limited to public use. Many wireless systems are used by municipalities to facilitate connectivity to cameras and traffic monitoring systems. A wireless personal area network (WPAN) is a wireless network designed for personal use, usually for personal connectivity to the Internet through a hot spot. <italic>Wireless LAN (WLAN)</italic> is a term used to describe a wireless network that extends a wired network to wireless. The term is used to describe a campus-sized wireless network and not a wireless network that spans a public area. <italic>Wireless wide area network (WWAN)</italic> is a term used to describe cellular networks and not typical 802.11 wireless."
    },
    {
       "id":379,
       "topic_id":2,
       "sub_domain":"2.7 Describe physical infrastructure connections of WLAN components (AP, WLC, access/trunk ports, and LAG)",
       "practice_test_id":1,
       "question":"You currently have a WLC with only two physical access ports. One port is used for guest network access and the other port is used for your business communications. You need to add several other networks to the WLC for your manufacturing and quality control departments. What is the simplest and best way to achieve this?",
       "choice_a":"Upgrade the WLC to accommodate more ports.",
       "choice_b":"Convert the current access ports to LAGs.",
       "choice_c":"Convert one of the current access ports to a trunk.",
       "choice_d":"Add a second WLC to accommodate the new departments.",
       "correct_answer":"C",
       "explanation":"The simplest and cheapest way to accommodate this new requirement is to convert one of the current access ports to a trunk. This will allow several VLANs to be carried across the one port to the switching equipment. Upgrading is always an option that could get you more ports, but at some point, you will hit the end of the line and run out of money in the process. Converting the current access ports to LAGs will only load-balance the traffic across one network, and it will not accommodate the new requirements. Adding a second WLC to accommodate the new departments can become an expensive endeavor in money and time, since you will have two systems to administer."
    },
    {
       "id":380,
       "topic_id":2,
       "sub_domain":"2.7 Describe physical infrastructure connections of WLAN components (AP, WLC, access/trunk ports, and LAG)",
       "practice_test_id":"",
       "question":"What is the term for a small wireless network that does not extend past 30 feet?",
       "choice_a":"WPAN",
       "choice_b":"WLAN",
       "choice_c":"WMAN",
       "choice_d":"WWAN",
       "correct_answer":"A",
       "explanation":"A wireless personal area network (WPAN) is a small wireless network that usually has a maximum distance of 30 feet. It is used for personal wireless connectivity to the Internet via wireless. Wireless LANs (WLANs) are traditional wireless networks that we use to connect to our home and work networks. Bluetooth is a common WPAN; it allows for hands-free calling, monitoring of your pulse with wearable devices, and many other services we have come to rely on. Wireless metro area networks (WMANs) are wireless networks that span a fairly large geographic area like a city or suburban area. A wireless wide area network (WWAN) is used for Internet connectivity and usually delivered over cellular networks."
    },
    {
       "id":381,
       "topic_id":2,
       "sub_domain":"2.7 Describe physical infrastructure connections of WLAN components (AP, WLC, access/trunk ports, and LAG)",
       "practice_test_id":"",
       "question":"You have been asked by your manager to configure a port for a new WAP to be installed for your WLC. How should you configure the port?",
       "choice_a":"Access port",
       "choice_b":"Wireless port",
       "choice_c":"Trunk port",
       "choice_d":"LAG port",
       "correct_answer":"C",
       "explanation":"When installing a wireless access point onto a WLC, the port should be configured as a trunk port. Configuring the port as a trunk port will allow management traffic and data traffic to be tagged. This type of configuration will also future proof the design for additional networks in the future. Wireless access points are configured with access ports when a controller is not being used and the AP is running in an autonomous mode. There is no such thing as a wireless port configuration. Configuring the port as a LAG port is not possible since APs normally only have one interface and LAGs require two or more for aggregation."
    },
    {
       "id":382,
       "topic_id":2,
       "sub_domain":"2.8 Describe AP and WLC management access connections (Telnet, SSH, HTTP, HTTPS, console, and TACACS+/RADIUS)",
       "practice_test_id":4,
       "question":"Which application provides terminal emulation over a network?",
       "choice_a":"SNMP",
       "choice_b":"Telnet",
       "choice_c":"HTTP",
       "choice_d":"TFTP",
       "correct_answer":"B",
       "explanation":"Telnet is used for terminal emulation over a network to a device expecting terminal emulation, such as a router, switch, or access point. Simple Network Management Protocol (SNMP) is a management protocol for sending and receiving network events and statistics. HyperText Transfer Protocol (HTTP) allows for web-based configuration of devices. Trivial File Transfer Protocol (TFTP) is a network utility that allows for file transfer, usually for the maintenance of devices such as uploading a new IOS."
    },
    {
       "id":383,
       "topic_id":2,
       "sub_domain":"2.8 Describe AP and WLC management access connections (Telnet, SSH, HTTP, HTTPS, console, and TACACS+/RADIUS)",
       "practice_test_id":5,
       "question":"You need to make a Telnet connection to a remote router from a router you are configuring. Which command will allow you to do this?",
       "choice_a":"<code>Router#198.56.33.3</code>",
       "choice_b":"<code>Router#connect 198.56.33.3</code>",
       "choice_c":"<code>Router#remote 198.56.33.3</code>",
       "choice_d":"<code>Router#vty 198.56.33.3</code>",
       "correct_answer":"A",
       "explanation":"The IP address or hostname entered in privileged exec mode will create a direct Telnet request. Alternatively, you can specify the command <code>telnet 198.56.33.3.</code> The command <code>connect 198.56.33.3</code> is incorrect. The command <code>remote 198.56.33.3</code> is incorrect. The command <code>vty 198.56.33.3</code> is incorrect."
    },
    {
       "id":384,
       "topic_id":2,
       "sub_domain":"2.8 Describe AP and WLC management access connections (Telnet, SSH, HTTP, HTTPS, console, and TACACS+/RADIUS)",
       "practice_test_id":"",
       "question":"Which port and protocol does TACACS+ use?",
       "choice_a":"UDP/69",
       "choice_b":"TCP/74",
       "choice_c":"UDP/47",
       "choice_d":"TCP/49",
       "correct_answer":"D",
       "explanation":"TACACS+ uses TCP and port 49 for communications between the switch or router and the AAA server. All of the other options are incorrect."
    },
    {
       "id":385,
       "topic_id":2,
       "sub_domain":"2.8 Describe AP and WLC management access connections (Telnet, SSH, HTTP, HTTPS, console, and TACACS+/RADIUS)",
       "practice_test_id":"",
       "question":"Which management access method should be configured on network devices for encryption of the session?",
       "choice_a":"RADIUS",
       "choice_b":"HTTP",
       "choice_c":"SSH",
       "choice_d":"SFTP",
       "correct_answer":"C",
       "explanation":"Secure Shell (SSH) is a secure console emulation method for the administration of network devices. It allows for both the sender and receiver to create an encrypted session, so data cannot be intercepted. Remote Authentication Dial-In User Service (RADIUS) is a protocol that authenticates users, and it does not provide encryption. HyperText Transfer Protocol (HTTP) is a method for relaying Hypertext Markup Language (HTML) from a server to a requesting host; it does not provide encryption. SSH File Transfer Protocol (SFTP) is a protocol that provides encryption for file transfers, but it does not provide management access."
    },
    {
       "id":386,
       "topic_id":2,
       "sub_domain":"2.8 Describe AP and WLC management access connections (Telnet, SSH, HTTP, HTTPS, console, and TACACS+/RADIUS)",
       "practice_test_id":"",
       "question":"Which technology is used to facilitate encryption for the SSH protocol?",
       "choice_a":"Symmetrical encryption",
       "choice_b":"Code block ciphers",
       "choice_c":"At-rest encryption",
       "choice_d":"Asymmetrical encryption",
       "correct_answer":"D",
       "explanation":"The Secure Shell (SSH) protocol uses asymmetrical encryption with the use of public and private key pairs. This not only provides encryption, it also provides authentication of clients. Symmetrical encryption means that the same key that encrypts the information also decrypts it, and this method is not commonly used with any remote technologies. Code block ciphers (CBCs) are used with wireless technology to encrypt the data several times. <italic>At-rest encryption</italic> is a term used to describe the protection of data stored and not data in transit."
    },
    {
       "id":387,
       "topic_id":2,
       "sub_domain":"2.8 Describe AP and WLC management access connections (Telnet, SSH, HTTP, HTTPS, console, and TACACS+/RADIUS)",
       "practice_test_id":"",
       "question":"When debugging a WAP, where is the debug information displayed by default?",
       "choice_a":"Console",
       "choice_b":"SSH",
       "choice_c":"Logging server",
       "choice_d":"Local storage",
       "correct_answer":"A",
       "explanation":"When a wireless access point is being debugged, the information is displayed by default to the console. This information can be extended to the remote SSH or Telnet session by using the command <code>terminal monitor</code>. Logging servers must be configured and are not created by default. Although on some higher-end switches local storage provides a method of storage for logging, it is not the default for wireless access points."
    },
    {
       "id":388,
       "topic_id":2,
       "sub_domain":"2.8 Describe AP and WLC management access connections (Telnet, SSH, HTTP, HTTPS, console, and TACACS+/RADIUS)",
       "practice_test_id":1,
       "question":"Which authentication system is an open standard originally proposed by the Internet Engineering Task Force (IETF)?",
       "choice_a":"RADIUS",
       "choice_b":"TACACS+",
       "choice_c":"Kerberos",
       "choice_d":"LDAP",
       "correct_answer":"A",
       "explanation":"Remote Authentication Dial-In User Service (RADIUS) was originally proposed by the IETF and became an open standard for authentication, often used with 802.1X. TACACS+ is a standard that was originally developed by Cisco. Kerberos is an authentication protocol used for Active Directory authentication and was originally created by MIT. Lightweight Directory Access Protocol (LDAP) is not an authentication protocol; it is a helper protocol used by authentication protocols to look up objects."
    },
    {
       "id":389,
       "topic_id":2,
       "sub_domain":"2.8 Describe AP and WLC management access connections (Telnet, SSH, HTTP, HTTPS, console, and TACACS+/RADIUS)",
       "practice_test_id":4,
       "question":"Which management method can use Advanced Encryption Standard (AES) encryption for encryption of user credentials and session data?",
       "choice_a":"SSH",
       "choice_b":"TACACS+",
       "choice_c":"HTTPS",
       "choice_d":"RADIUS",
       "correct_answer":"A",
       "explanation":"Secure Shell (SSH) can use a multitude of encryption protocols; one of the encryption protocols is Advanced Encryption Standard (AES). TACACS+ is used to authenticate users only and provides no encryption. Hypertext Transfer Protocol Secure (HTTPS) uses Secure Sockets Layer (SSL) to transmit data, but it does not provide AES encryption. Remote Authentication Dial-In User Service is similar to TACACS+; both provide authentication and do not provide encryption."
    },
    {
       "id":390,
       "topic_id":2,
       "sub_domain":"2.8 Describe AP and WLC management access connections (Telnet, SSH, HTTP, HTTPS, console, and TACACS+/RADIUS)",
       "practice_test_id":5,
       "question":"You are setting up an autonomous WAP for the first time. How must you connect to the device?",
       "choice_a":"HTTPS",
       "choice_b":"SSH",
       "choice_c":"Console",
       "choice_d":"Telnet",
       "correct_answer":"C",
       "explanation":"When setting up an autonomous wireless access point for the first time, you need to connect via the console port. The network services for management are not set up by default on a wireless access point right out of the box. Hypertext Transfer Protocol Secure (HTTPS) can be configured, but by default, it is not configured since the wireless access point does not have an IP address right out of the box. SSH and Telnet are also inaccessible for a wireless access point right out of the box."
    },
    {
       "id":391,
       "topic_id":2,
       "sub_domain":"2.8 Describe AP and WLC management access connections (Telnet, SSH, HTTP, HTTPS, console, and TACACS+/RADIUS)",
       "practice_test_id":"",
       "question":"What is the connection speed for console access to Cisco equipment?",
       "choice_a":"19.2 kb/s",
       "choice_b":"9600 kb/s",
       "choice_c":"9600 baud",
       "choice_d":"19200 baud",
       "correct_answer":"C",
       "explanation":"The universal console speed for all Cisco devices is 9600 baud. The connection for Cisco equipment should be set up as 9600 baud, 8 bits of data, no flow control, and 1 stop bit. This connection is also known as 96008N1 and should be committed to memory. All of the other options are incorrect."
    },
    {
       "id":392,
       "topic_id":2,
       "sub_domain":"2.9 Configure the components of a wireless LAN access for client connectivity using GUI only such as WLAN creation, security settings, QoS profiles, and advanced WLAN settings",
       "practice_test_id":"",
       "question":"What is the definition of a trust boundary in relation to QoS?",
       "choice_a":"A trust boundary is where the QoS markings are first configured.",
       "choice_b":"A trust boundary is where the QoS markings are stripped at the router.",
       "choice_c":"A trust boundary is where the network begins to trust the QoS markings from devices.",
       "choice_d":"A trust boundary is the separation of QoS queues based upon their priority.",
       "correct_answer":"C",
       "explanation":"A trust boundary is the point in the network where the QoS markings are trusted from the devices connected to it. A network administrator will create a trust boundary where a VoIP phone will placed. Since the VoIP phone will be trusted, the markings will be accepted and used for priority throughout the network. The trust boundary should always be placed closest to the IT-controlled equipment."
    },
    {
       "id":393,
       "topic_id":2,
       "sub_domain":"2.9 Configure the components of a wireless LAN access for client connectivity using GUI only such as WLAN creation, security settings, QoS profiles, and advanced WLAN settings",
       "practice_test_id":"",
       "question":"Which IEEE specification defines WLAN QoS for wireless data?",
       "choice_a":"802.11e",
       "choice_b":"802.11r",
       "choice_c":"802.1p",
       "choice_d":"802.11k",
       "correct_answer":"A",
       "explanation":"WLAN Quality of Service (QoS) is defined by IEEE 802.11e. The definitions align with the 802.1p, which is the wired equivalent called Architecture for Voice, Video and Integrated Data (AVVID). The IEEE 802.11r specification is used for BSS fast transition (FT) and does not pertain to QoS. The IEEE 802.11k specification is used for roaming clients to locate the closet WAP and does not pertain to QoS."
    },
    {
       "id":394,
       "topic_id":2,
       "sub_domain":"2.9 Configure the components of a wireless LAN access for client connectivity using GUI only such as WLAN creation, security settings, QoS profiles, and advanced WLAN settings",
       "practice_test_id":"",
       "question":"You are creating a WLAN in the GUI of the WLP. You need to make sure that only corporate hosts can connect to the newly formed WLAN. How can you achieve this?",
       "choice_a":"Disable SSID broadcasting",
       "choice_b":"Set a unique PSK",
       "choice_c":"Use MAC filtering",
       "choice_d":"Add an LDAP server",
       "correct_answer":"C",
       "explanation":"MAC-based filtering is the best way you can achieve the goal of only allowing corporate hosts to connect to the network. You would need to preload into the WLC all of the MAC address that you want to allow access. Disabling the SSID from broadcasting is security through obscurity and only a deterrent; a savvy user can manually create a connection to the hidden SSID. Setting a unique pre-shared key (PSK) is only as secure as the people that know it; unfortunately at some point, it will leak out to others. Adding an LDAP server is the first step in setting up the web portal for user authentication and will not prevent users from joining their personal devices."
    },
    {
       "id":395,
       "topic_id":2,
       "sub_domain":"2.9 Configure the components of a wireless LAN access for client connectivity using GUI only such as WLAN creation, security settings, QoS profiles, and advanced WLAN settings",
       "practice_test_id":"",
       "question":"Which protocol should be enabled on a WLAN to allow a client device to download a list of neighboring WAPs?",
       "choice_a":"802.11r",
       "choice_b":"802.11e",
       "choice_c":"802.11k",
       "choice_d":"802.11ac",
       "correct_answer":"C",
       "explanation":"802.11k should be enabled; this will allow client devices to download a list of neighboring wireless access points and their associated wireless bands. 802.11r is used for BSS fast transition (FT) by allowing authentication to be bypassed. 802.11e defines Quality of Service (QoS) for wireless communications. 802.11ac is a wireless standard for communication speed and equipment and does not pertain to neighboring WAP lists."
    },
    {
       "id":396,
       "topic_id":2,
       "sub_domain":"2.9 Configure the components of a wireless LAN access for client connectivity using GUI only such as WLAN creation, security settings, QoS profiles, and advanced WLAN settings",
       "practice_test_id":"",
       "question":"You are planning to implement wireless VoIP phones in your wireless network. Which QoS profile should you associate with the wireless network for the VoIP phones?",
       "choice_a":"Bronze",
       "choice_b":"Silver",
       "choice_c":"Gold",
       "choice_d":"Platinum",
       "correct_answer":"D",
       "explanation":"The QoS profile of Platinum should be associated with the wireless VoIP phones. The Platinum QoS profile is normally associated with network control traffic and highly sensitive protocols such as VoIP. The Bronze QoS profile should be used for bulk data transfer, such as file transfers. The Silver QoS profile should be associated with transactional traffic, such as basic user forms. The Gold QoS profile should be reserved for lower priority time-sensitive protocols such as interactive video."
    },
    {
       "id":397,
       "topic_id":2,
       "sub_domain":"2.9 Configure the components of a wireless LAN access for client connectivity using GUI only such as WLAN creation, security settings, QoS profiles, and advanced WLAN settings",
       "practice_test_id":"",
       "question":"You were just notified by your maintenance department that they lost all wireless connectivity. Earlier you had a contractor working on the WLC. You log into the WLC and click on the WLAN of MaintDept shown in the exhibit below. What can you do to correct the problem? <img src='/question_assets/ccna/2_image18.png'></img>",
       "choice_a":"Enable the status",
       "choice_b":"Change the radio policy",
       "choice_c":"Enable Multicast VLAN Feature",
       "choice_d":"Enable Broadcast SSID",
       "correct_answer":"A",
       "explanation":"The administrative status of the WLAN is disabled. This means that the WLAN will not allow associations. To fix the problem, it must be re-enabled and applied. Changing the Radio Policy value will not affect the solution because the WLAN is effectively administratively disabled. Enabling Multicast VLAN Feature will not correct the issue since many WLANs never need multicast support. Enabling the Broadcast SSID option would not accomplish anything because it could have been disabled already."
    },
    {
       "id":398,
       "topic_id":2,
       "sub_domain":"2.9 Configure the components of a wireless LAN access for client connectivity using GUI only such as WLAN creation, security settings, QoS profiles, and advanced WLAN settings",
       "practice_test_id":"",
       "question":"Which statement is true about the WLAN in the following exhibit? <img src='/question_assets/ccna/2_image19.png'></img>",
       "choice_a":"WPA is enabled.",
       "choice_b":"WPA2 enterprise is enabled.",
       "choice_c":"WPA2 personal is enabled.",
       "choice_d":"802.1X is enabled.",
       "correct_answer":"C",
       "explanation":"This WLAN is configured for WPA2 personal; you can see that because the Pre-Shared Key (PSK) option is enabled and is filled out. The original WPA is not enabled. WPA2 enterprise mode requires the use of certificates that cannot exist with PSK mode. 802.1X is not enabled, as you can see in the exhibit."
    },
    {
       "id":399,
       "topic_id":2,
       "sub_domain":"2.9 Configure the components of a wireless LAN access for client connectivity using GUI only such as WLAN creation, security settings, QoS profiles, and advanced WLAN settings",
       "practice_test_id":1,
       "question":"Which statement is correct about Flex Connect mode versus Local mode?",
       "choice_a":"Flex Connect mode creates a CAPWAP tunnel to the WLC to transport data.",
       "choice_b":"Local mode creates a CAPWAP tunnel to the WLC to transport data.",
       "choice_c":"Local mode allows for switching of VLANs at the WAP.",
       "choice_d":"Flex Connect mode allows for switching of VLANs at the WLC.",
       "correct_answer":"B",
       "explanation":"Local mode creates a CAPWAP tunnel to the wireless LAN controller to allow switching of VLANs local to the WLC. All traffic in Local mode must traverse back to the WLC to get switched into the respective VLANs. Flex Connect mode does not create a CAPWAP tunnel to mode data, only control information. Local mode allows for the switching of VLANs at the WLC only. Flex Connect mode is the opposite, where VLANs can be switched at the WAP."
    },
    {
       "id":400,
       "topic_id":2,
       "sub_domain":"2.9 Configure the components of a wireless LAN access for client connectivity using GUI only such as WLAN creation, security settings, QoS profiles, and advanced WLAN settings",
       "practice_test_id":4,
       "question":"You need to set up a WLAN for connectivity to send and receive large files to roaming clients. The WLAN will exist with other WLAN traffic. Which QoS profile should the new WLAN be associated with?",
       "choice_a":"Bronze",
       "choice_b":"Gold",
       "choice_c":"Platinum",
       "choice_d":"Silver",
       "correct_answer":"A",
       "explanation":"The Bronze QoS profile should be used for bulk data transfer, such as file transfers of this nature. The Gold QoS profile should be reserved for lower priority time-sensitive protocols such as interactive video. The QoS profile of Platinum should be associated with the wireless VoIP phones and time-sensitive protocols. The Silver QoS profile should be associated with transactional traffic, such as basic user forms."
    },
    {
       "id":401,
       "topic_id":2,
       "sub_domain":"2.9 Configure the components of a wireless LAN access for client connectivity using GUI only such as WLAN creation, security settings, QoS profiles, and advanced WLAN settings",
       "practice_test_id":5,
       "question":"Which type of security can be implemented on a WLAN that requires the host PC to present a certificate before being allowed onto the wireless network?",
       "choice_a":"MAC filtering",
       "choice_b":"802.1X",
       "choice_c":"WPA2 PSK",
       "choice_d":"Fast Transitioning",
       "correct_answer":"B",
       "explanation":"802.1X is a control protocol that can be configured on Cisco and non-Cisco wireless LAN controllers to allow only hosts that present a valid certificate on the network. The server that arbitrates the authentication is normally a Remote Authentication Dial-In User Service (RADIUS) server. MAC filtering is normally a manual process in which the MAC address of the client is entered into a database that the WLC checks before allowing access to the wireless network. WPA2 PSK (Pre-Shared Key) only uses a simple key that is punched into both the WLC and the client. Fast Transitioning (FT) allows a client to roam between access points without further authentication."
    },
    {
       "id":402,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"Which is a reason for using a dynamic routing protocol?",
       "choice_a":"You have a network with only a few routers and subnets per branch.",
       "choice_b":"You have a network with only a few VLANs and one router.",
       "choice_c":"You have a network with a large number of VLANs and only one router.",
       "choice_d":"You have a network with a few subnets and many routers.",
       "correct_answer":"D",
       "explanation":"The scalability of routes between routers should always be considered when choosing a static routing design vs. a dynamic routing design. A few subnets over many routers creates a lot of work when a new subnet is created and static routing is being used. However, when one router is being used, the administrative overhead is low."
    },
    {
       "id":403,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"How are routers managed with interior gateway protocols?",
       "choice_a":"Routers are grouped into autonomous systems.",
       "choice_b":"Routing protocols are redistributed between ASs.",
       "choice_c":"All routers use the same interior routing protocol.",
       "choice_d":"All network IDs are advertised with the same autonomous system number.",
       "correct_answer":"A",
       "explanation":"Routers are grouped into the same autonomous system (AS). When they are within the same AS, they can exchange information such as routes to destination networks and converge their routing tables. Routing protocols are not normally redistributed between ASs because the network is usually managed as one AS. All routers do not necessarily use the same routing protocols; many different portions of the network can use different protocols. All network IDs are not advertised with the same autonomous system number. Routers are normally grouped into one AS logically, such as an organization. Inside that organization (AS), many different autonomous system numbers can be used."
    },
    {
       "id":404,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":4,
       "question":"What is the maximum hop count for RIP?",
       "choice_a":"15 hops",
       "choice_b":"100 hops",
       "choice_c":"255 hops",
       "choice_d":"16 hops",
       "correct_answer":"A",
       "explanation":"The maximum hop count for RIP is 15. A hop count over 15 hops is considered unroutable or unreachable, so the other options are incorrect."
    },
    {
       "id":405,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":5,
       "question":"Which statement is true about RIPv2 advertisements?",
       "choice_a":"RIPv2 allows for neighborship through hello packets.",
       "choice_b":"RIPv2 broadcasts only updates on all active interfaces.",
       "choice_c":"RIPv2 multicasts the full routing table every 30 seconds.",
       "choice_d":"RIPv2 multicasts the full routing table every 60 seconds.",
       "correct_answer":"C",
       "explanation":"By default, RIPv2 multicasts the full routing table on all active interfaces every 30 seconds. RIPv2 does not allow for neighborship through hello packets, such as link-state and hybrid dynamic routing protocols. RIPv2 uses multicasts not broadcasts. RIPv2 multicasts the full routing table every 30 seconds, not every 60 seconds."
    },
    {
       "id":406,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"Which multicast address does RIPv2 use for advertising routes?",
       "choice_a":"224.0.0.5",
       "choice_b":"224.0.0.9",
       "choice_c":"224.0.0.6",
       "choice_d":"224.0.0.2",
       "correct_answer":"B",
       "explanation":"RIPv2 uses the multicast address 224.0.0.9 to advertise routes. The multicast address 224.0.0.5 is used by OSPF for hello messages. The multicast address 224.0.0.6 is also used by OSPF for hello messages for designated routers and backup designated routers. The multicast address 224.0.0.2 is a special multicast group for all routers and it is not used by any particular routing protocol."
    },
    {
       "id":407,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"In the following exhibit, a packet from network 192.168.1.0/24 is destined for 192.168.4.0/24. The route the packet will take will be Router A to Router B, determined by RIPv2. However, the bandwidth is only 64 Kb/s. How can you force packets to travel over the 1.544 Mb/s links? <img src='/question_assets/ccna/3_image1.png'></img><img src='/question_assets/ccna/3_image1_1.png'></img>",
       "choice_a":"<code>RouterA(config-router)#passive interface serial 0/3/0</code><br><code>RouterB(config-router)#passive interface serial 0/3/0</code>",
       "choice_b":"<code>RouterA(config)#ip route 192.168.4.0 255.255.255.0 serial 0/3/1</code><br><code>RouterB(config)#ip route 192.168.1.0 255.255.255.0 serial 0/3/1</code>",
       "choice_c":"<code>RouterA(config-router)#cost 2 serial 0/3/0</code><br><code>RouterB(config-router)#cost 2 serial 0/3/0</code>",
       "choice_d":"<code>RouterA(config-if)#metric 2 serial 0/3/0</code><br><code>RouterB(config-if)#metric 2 serial 0/3/0</code>",
       "correct_answer":"B",
       "explanation":"To route packets over the higher-speed link, you would need to configure a static route for both Router A and Router B. If these links would go down, then the lower-speed link would become active. This is due to administrative distance. Configuring passive interfaces on Router A and Router B will only restrict the two routers from trading their route tables between each other. Setting the cost on the interface will not affect the routing with RIPv2. You cannot set the metric of 2 for each of the routers; it is an invalid command."
    },
    {
       "id":408,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"Which routing protocol will not contain a topology of the network?",
       "choice_a":"EIGRP",
       "choice_b":"RIP",
       "choice_c":"OSPF",
       "choice_d":"BGP",
       "correct_answer":"B",
       "explanation":"Routing Information Protocol (RIP) does not contain a topology table. RIP compiles its table from multiple broadcasts or multicasts in the network from which it learns routes. However, it never has a full topological diagram of the network like OSPF, EIGRP, and BGP."
    },
    {
       "id":409,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"Which routing loop avoidance method is used by routers to prevent routing updates from exiting an interface in which they have been learned?",
       "choice_a":"Routing to infinity",
       "choice_b":"Route poisoning",
       "choice_c":"Holddowns",
       "choice_d":"Split horizon",
       "correct_answer":"D",
       "explanation":"The split horizon method prevents routing updates from exiting an interface in which they have been learned. This stops false information from propagating in the network, which can cause a routing loop. Routing to infinity is a way of advertising a downed route as unreachable because of the number of hops. Route poisoning is similar to routing to infinity as it advertises a downed route as over the routable hop count. Holddowns can help stabilize a network by holding off changes until a specific amount of time has passed."
    },
    {
       "id":410,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":1,
       "question":"You are examining a routing table and see a route marked with <code>S*</code>. Which type of route is this?",
       "choice_a":"Static route",
       "choice_b":"Default route",
       "choice_c":"Dynamic route",
       "choice_d":"OSPF route",
       "correct_answer":"B",
       "explanation":"Although this is a static route, it is a very special static route called a default route or gateway of last resort. The <code>S</code> signifies that it is static and the * signifies that it is the default route. Most all default routes are static, but default routes can also be populated with dynamic routing protocols. The <code>S</code> signifies that the route is a static route; therefore, it cannot be populated with a dynamic routing protocol such as OSPF."
    },
    {
       "id":411,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"You are examining a routing table and see the entry in the following exhibit. What does the 4 in the underlined number represent? <img src='/question_assets/ccna/3_image2.png'></img>",
       "choice_a":"The 4 represents the administrative distance.",
       "choice_b":"The 4 represents the protocol.",
       "choice_c":"The 4 represents the metric.",
       "choice_d":"The 4 represents the position in the routing table.",
       "correct_answer":"C",
       "explanation":"The 4 represents the metric for this route statement. Since this is a RIP entry, the metric is the number of hops for this particular route. The administrative distance is 120 in the exhibit. The protocol in the exhibit is RIP. The position in the routing table cannot be derived from a single statement in the routing table."
    },
    {
       "id":412,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":4,
       "question":"Which command will allow you to verify routes line by line in a subset of the general route statement?",
       "choice_a":"<code>Router#show ip route 160.45.23.0 255.255.255.0 longer-prefixes</code>",
       "choice_b":"<code>Router#show ip route 160.45.23.0 255.255.255.0</code>",
       "choice_c":"<code>Router#show ip route bgp</code>",
       "choice_d":"<code>Router#show ip route</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show ip route 160.45.23.0 255.255.255.0 longer-prefixes</code> will detail all of the specific routes contained in the route for 16.45.23.0/24. The command <code>show ip route 160.45.23.0 255.255.255.0</code> will show the specific route of 160.45.23.0/24. The command <code>show ip route bgp</code> is not a valid command. The command <code>show ip route</code> will show the entire route table."
    },
    {
       "id":413,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":5,
       "question":"Examining the <code>show ip route</code> statement in the exhibit, which will be the next hop for a destination address of 192.168.1.5? <img src='/question_assets/ccna/3_image3.png'></img>",
       "choice_a":"The gateway 172.16.1.200",
       "choice_b":"The exit interface Serial 0/0",
       "choice_c":"The gateway 172.16.1.100",
       "choice_d":"The exit interface Ethernet0",
       "correct_answer":"B",
       "explanation":"The network of 192.168.1.0/24 is directly connected via Serial 0/0. The packet will be delivered out the exit interface of Serial 0/0. The administrative distance is the lowest on directly connected routes. The gateway address of 172.16.1.200 would only be valid if the example in the exhibit was only using OSPF. The gateway of 172.16.1.100 would only be valid if the example in the exhibit was only using RIP. The exit interface of Ethernet0 is valid for OSPF and RIP routing."
    },
    {
       "id":414,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"Which route statement is configured when an IP address of 203.80.53.22/19 is configured on an interface?",
       "choice_a":"<code>S 203.80.16.0/19 is directly connected, Serial 0/0/0</code>",
       "choice_b":"<code>S 203.80.32.0/19 is directly connected, Serial 0/0/0</code>",
       "choice_c":"<code>S 203.80.48.0/19 is directly connected, Serial 0/0/0</code>",
       "choice_d":"<code>S 203.80.53.22/19 is directly connected, Serial 0/0/0</code>",
       "correct_answer":"B",
       "explanation":"The IP address of 203.80.53.22/19 belongs to the network of 203.80.32.0/19. No other answers are correct because they do not belong to the 203.80.32.0/19 network."
    },
    {
       "id":415,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"In the following exhibit, what does the top line of the output represent? <img src='/question_assets/ccna/3_image4.png'></img>",
       "choice_a":"The 10.0.0.0/8 is a route in the routing table.",
       "choice_b":"The 10.0.0.0/8 is a summarization of the routes in the table.",
       "choice_c":"The 10.0.0.0/8 is the router\u0027s network address.",
       "choice_d":"The 10.0.0.0/8 has been populated from another router.",
       "correct_answer":"B",
       "explanation":"The top line in the exhibit is the summarization of all three routes below. This is also called a supernet, since it is opposite of a subnet and groups networks together rather than dividing them. It groups the networks that are independently routable into one statement, summarizing them. The 10.0.0.0/8 is not a route in the routing table; the routes are grouped under this summarization. The 10.0.0.0/8 is a network address and therefore cannot be the router\u0027s network address. The 10.0.0.0/8 is not populated from another router directly; it is summarized from the routes learned from other routers."
    },
    {
       "id":416,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"You are examining a routing table and see the entry in the following exhibit. What does the underlined number represent? <img src='/question_assets/ccna/3_image5.png'></img>",
       "choice_a":"The number represents the current time.",
       "choice_b":"The number represents the delay in microseconds of the connection.",
       "choice_c":"The number represents the time the route has been in the routing table.",
       "choice_d":"The number represents the time the interface has been up.",
       "correct_answer":"C",
       "explanation":"The number represents the time the route had been in the routing table and signifies when the route had last been updated. This route is populated via a dynamic routing protocol; when the protocol updates the route, it will be reset to zero. The time represented in this exhibit is not the current time. The delay is not represented in the form of time; it is normally a component of the metric. The route statement will not display the amount of time an interface or route has been up."
    },
    {
       "id":417,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"In the following exhibit is a copy of the running-config. What is the next hop for a destination address of 192.168.4.85? <img src='/question_assets/ccna/3_image6.png'></img>",
       "choice_a":"Interface Serial 0/2/0",
       "choice_b":"IP address 192.168.4.2",
       "choice_c":"Interface Serial 0/0/1",
       "choice_d":"IP address 198.22.34.3",
       "correct_answer":"C",
       "explanation":"When routers select the next hop, the rule of most specific first is always used. Since there are three routes to 192.168.4.0/24 (including the gateway of last resort), the most specific of 192.168.4.0/24 via Serial 0/0/1 is selected. The interface Serial 0/2/0 would only be right if the destination address was not in the other route statements. The IP address of 192.168.4.2 would only be right if the destination address was in the 192.168.5.0/24 network. The IP address of 198.22.34.3 would only be right if the destination address was in the 192.168.0.0/16 network and no other specific routes existed."
    },
    {
       "id":418,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"Using the following exhibit, if traffic enters Router A for a destination address of 198.44.4.7, what must be configured to allow routing to the host? <img src='/question_assets/ccna/3_image7.png'></img>",
       "choice_a":"<code>RouterA(config)#ip route 198.44.4.0 255.255.255.0 198.44.4.5</code>",
       "choice_b":"<code>RouterA(config)#ip route 198.44.4.0 255.255.255.0 fast 0/1</code>",
       "choice_c":"<code>RouterA(config)#ip route 198.44.4.0/24 fast 0/1</code>",
       "choice_d":"Nothing needs to be done.",
       "correct_answer":"D",
       "explanation":"Nothing needs to be done since the IP address of 198.44.4.5/24 is configured on Fa0/1. This shows that the network of 198.44.4.0/24 is connected to Fa0/1. Configuring the command <code>ip route 198.44.4.0 255.255.255.0 198.44.4.5</code> would not achieve anything because the network is configured on the interface already. Configuring the command <code>ip route 198.44.4.0 255.255.255.0 fast 0/1</code> would not achieve anything because the interface already belongs to the network of 192.168.4.0/24. The command of <code>ip route 198.44.4.0/24 fast 0/1</code> is normally not a valid command because the network mask is expressed in dotted-decimal form."
    },
    {
       "id":419,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"You need to create a route for 205.34.54.85/29 with the next hop being 205.34.55.2. Which command would create this route?",
       "choice_a":"<code>Router(config)#ip route 205.34.54.85/24 205.34.55.2</code>",
       "choice_b":"<code>Router(config)#ip route 205.34.54.85 255.255.255.248 205.34.55.2</code>",
       "choice_c":"<code>Router(config)#ip route 205.34.54.85 255.255.255.240 205.34.55.2</code>",
       "choice_d":"<code>Router(config)#ip route 205.34.55.2 255.255.255.248 205.34.54.85</code>",
       "correct_answer":"B",
       "explanation":"The network of 205.34.54.85/29 is written out as 205.34.54.85 255.255.255.248. The next hop is 205.34.55.2, so the command would be <code>ip route 205.34.54.85 255.255.255.248 205.34.55.2</code>. The command <code>ip route 205.34.54.85/24 205.34.55.2</code> is invalid because it is not normally entered with a CIDR notation. The command <code>ip route 205.34.54.85 255.255.255.240 205.34.55.2</code> is invalid because the network mask is wrong when written out in dotted-decimal format. The command <code>ip route 205.34.55.2 255.255.255.248 205.34.54.85</code> is invalid because the next hop and the network are in the wrong place on the command."
    },
    {
       "id":420,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"When a static route is made, what is the default AD?",
       "choice_a":"AD of 1",
       "choice_b":"AD of 0",
       "choice_c":"AD of 2",
       "choice_d":"AD of 255",
       "correct_answer":"A",
       "explanation":"Static routes are highly trusted routes since an administrator created them. Therefore, they have the lowest administrative distance with a number of 1. The administrative distance of 0 is used for connected interfaces. The administrative distance of 2 is a wrong answer and does not map to a route source. The administrative distance of 255 is reserved for unknown sources and are entered into the route process."
    },
    {
       "id":421,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"What is the AD of RIP?",
       "choice_a":"AD of 90",
       "choice_b":"AD of 100",
       "choice_c":"AD of 110",
       "choice_d":"AD of 120",
       "correct_answer":"D",
       "explanation":"The administrative distance of the Routing Information Protocol (RIP) is 120. The administrative distance of 90 is used for internal Enhanced Interior Gateway Routing Protocol (EIGRP). The administrative distance of 100 is used for Interior Gateway Routing Protocol (IGRP). The administrative distance of 110 is used for Open Shortest Path First (OSPF)."
    },
    {
       "id":422,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"Why are ADs used with routing tables?",
       "choice_a":"ADs define protocol standards.",
       "choice_b":"ADs define reliability of routing protocols.",
       "choice_c":"ADs allow for the shortest distance between routes.",
       "choice_d":"ADs are programmed by the administrator for path selection.",
       "correct_answer":"B",
       "explanation":"Administrative distance is an order of reliability between dynamic routing protocols and static routes. Administrative distances do not define protocol standards; they only reference them. Administrative distances do not allow for the shortest distance between routers; they allow the router to choose the best path to the destination network. Although administrative distances are programmed into route statements by administrators, they do not calculate path selection."
    },
    {
       "id":423,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":4,
       "question":"What is the AD of a directly connected network?",
       "choice_a":"The AD is 0.",
       "choice_b":"The AD is 1.",
       "choice_c":"The AD is 5.",
       "choice_d":"Directly connected networks do not have an AD.",
       "correct_answer":"A",
       "explanation":"A directly connected network has an administrative distance of 0 and is the most highly reliable. The administrative distance of 1 is used for static entries. The administrative distance of 5 is used for Enhanced Interior Gateway Routing Protocol (EIGRP) summary routes. Directly connected networks have an AD of 0 that is trusted over all other router sources."
    },
    {
       "id":424,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":5,
       "question":"What is the AD of internal EIGRP?",
       "choice_a":90,
       "choice_b":100,
       "choice_c":110,
       "choice_d":120,
       "correct_answer":"A",
       "explanation":"Internal EIGRP has an administrative distance of 90. The administrative distance of 100 is used for Interior Gateway Routing Protocol (IGRP). The administrative distance of 110 is used for Open Shortest Path First (OSPF). The administrative distance of the Routing Information Protocol (RIP) is 120."
    },
    {
       "id":425,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"What is the definition of route statement administrative distance (AD)?",
       "choice_a":"The AD is a metric that routing protocols use to select the best route.",
       "choice_b":"The AD is a value assigned by network administrators for route selection.",
       "choice_c":"The AD is a rating of trust when multiple routes exist to the same destination.",
       "choice_d":"The AD is a value associated with the cost to the destination.",
       "correct_answer":"C",
       "explanation":"The administrative distance (AD) is a rating of trust between different routing protocols and route methods. This trust scale is important when multiple routes exist to the same destination. Directly connected routes have ADs with the highest level of trust. Route statements populated by the same dynamic routing protocol will be calculated for the best route upon their metric and not their administrative distance. The administrative distance is not assigned by the administrator for route selection. The administrative distance value is not associated with the cost to the destination, only the trust of a route statement."
    },
    {
       "id":426,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"Which must be configured so that EIGRP can calculate the best route?",
       "choice_a":"Bandwidth",
       "choice_b":"Delay",
       "choice_c":"Reliability",
       "choice_d":"Load",
       "correct_answer":"A",
       "explanation":"Enhanced Interior Gateway Routing Protocol (EIGRP) uses bandwidth and delay by default for calculating routes. The bandwidth should be set to the actual bandwidth of the link so that routing protocols such as EIGRP can calculate the best route. Delay cannot be set because it is a variable of the interface based upon the delay of a packet traversing the interface. Reliability cannot be set because it is a variable of the interface based upon the reliability of the link. Load cannot be set because it is also a variable of the interface, based upon the load of the interface."
    },
    {
       "id":427,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"You perform a <code>show ip route</code> on the router and see several routes with an AD of 90. Which routing protocol has generated these route statements?",
       "choice_a":"IGRP",
       "choice_b":"OSPF",
       "choice_c":"EIGRP",
       "choice_d":"RIP",
       "correct_answer":"C",
       "explanation":"The administrative distance (AD) of EIGRP is 90. The most common ADs are 90 for EIGRP, 100 for IGRP, 110 for OSPF, and 120 for RIP. The mnemonic of 90 Exotic Indian Oval Rubies will help you remember the order; then starting with EIGRP with a value of 90, increment the following values by 10."
    },
    {
       "id":428,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"Which statement is true when there are multiple route statements from different routing protocols for the same destination network?",
       "choice_a":"The route is chosen with the highest AD.",
       "choice_b":"The route chosen has the lowest metric.",
       "choice_c":"The route is chosen with the lowest AD.",
       "choice_d":"The route chosen has the highest metric.",
       "correct_answer":"C",
       "explanation":"The routing protocol with the lowest administrative distance is always chosen. Within that protocol, if there are multiple routes to the same network, then the lowest metric is chosen. The route is chosen with the lowest administrative distance, not the highest administrative distance. The route with the lowest metric will be selected as the best route, but only when within the same routing protocol. The route with the highest metric will not be selected as the best route."
    },
    {
       "id":429,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":4,
       "question":"You have a network with varied bandwidths and need to choose a dynamic routing protocol. Which would you choose for optimal performance?",
       "choice_a":"RIPv1",
       "choice_b":"RIPv2",
       "choice_c":"EIGRP",
       "choice_d":"BGP",
       "correct_answer":"C",
       "explanation":"EIGRP metrics are bandwidth, delay, load, reliability, and MTU, while RIP is a distance-vector protocol and only takes hop count into consideration for the metric. BGP is not suited for optimal performance since a large amount of resources need to be dedicated for the protocol."
    },
    {
       "id":430,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":5,
       "question":"What is the Cisco metric for OSPF?",
       "choice_a":"108/bandwidth",
       "choice_b":"Delay, bandwidth, reliability, load",
       "choice_c":"K metrics",
       "choice_d":"Bandwidth",
       "correct_answer":"A",
       "explanation":"Cisco uses a metric for OSPF that is calculated as 108/bandwidth. This cost value is of 100 Mb/s (reference bandwidth) divided by the interface bandwidth. Delay, bandwidth, reliability, and load are used as a composite metric with EIGRP. K metrics are used to weight the calculation of the composite metric used with EIGRP. Bandwidth is used by OSPF, but only when used with the formula of 108/bandwidth."
    },
    {
       "id":431,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"You enter a <code>show ip route</code> command and see the following line. What does the <code>[110/1]</code> identify?<br><code>O    192.168.3.0/24 [110/1] via 192.168.10.6, 00:58:55, Serial0/3/1</code>",
       "choice_a":"AD of 110 and a 100 Mb/s link",
       "choice_b":"AD of 110 and a 10 Mb/s link",
       "choice_c":"AD of 1 and a 110 Mb/s link",
       "choice_d":"AD of 110 and a 1 Gb/s link",
       "correct_answer":"A",
       "explanation":"It identifies the administrative distance of 110 for OSPF. The cost calculation is the reference bandwidth of 100 Mb/s divided by the link bandwidth. This calculation would result in a cost of 1. The calculation of the OSPF metric is 108/bandwidth, or 100,000,000/bandwidth. Therefore, a metric of 1 would equal 100,000,000/100,000,000, and all of the other answers are wrong."
    },
    {
       "id":432,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"What type of route is the destination of 0.0.0.0/0?",
       "choice_a":"Local route",
       "choice_b":"Dynamic route",
       "choice_c":"Default route",
       "choice_d":"Loopback route",
       "correct_answer":"C",
       "explanation":"The destination address of 0.0.0.0/0 is a special route called the default route or gateway of last resort. The 0.0.0.0/0 addresses are all hosts, and if a specific route is not matched in the routing table, then this route is the last resort. IOS and IOS-XR have local host routes; the routes provide a local routing path to an interface or internally configured IP address. Dynamic routes are routes that have been discovered by a dynamic routing protocol. There is no such thing as a loopback route."
    },
    {
       "id":433,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"What role does ICMP take in the routing of a packet?",
       "choice_a":"ICMP populates the routing table.",
       "choice_b":"ICMP is used when routes are not reachable.",
       "choice_c":"ICMP maintains the routing table.",
       "choice_d":"ICMP performs continuous diagnosis of the network paths.",
       "correct_answer":"B",
       "explanation":"ICMP notifies the sending host if there is no viable route to the destination. The ICMP message sent to the sending host is a destination unreachable message. ICMP is not used to populate routing tables. ICMP does not maintain the routing table; dynamic routing protocols populate and maintain the routing table. ICMP is used to diagnose problems with an internetwork, but ICMP does not continuously diagnosis network paths."
    },
    {
       "id":434,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"How is a route selected when the route table contains overlapping destination prefixes?",
       "choice_a":"The route with the lowest cost is selected.",
       "choice_b":"The route with the longest matching prefix is selected.",
       "choice_c":"The route with the highest AD is selected.",
       "choice_d":"The route with the lowest AD is selected.",
       "correct_answer":"B",
       "explanation":"When a route table contains overlapping destination prefixes such as 192.168.0.0/16 and 192.168.1.0/24, the route with the longest matching prefix is selected. The cost is not a consideration unless there are two routes with the same prefix length; then metrics are taken into consideration. The administrative distance is not a factor in deciding the destination path to be taken unless the routes have equal length prefixes with different route sources."
    },
    {
       "id":435,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":"",
       "question":"You are examining a router and discover that there is a static default route configured for a next hop of 192.168.1.2. You also notice that there is a default route being populated from RIP for a next hop of 192.168.2.2. Which default route will be selected?",
       "choice_a":"The route with the lowest AD",
       "choice_b":"The route with the highest AD",
       "choice_c":"The route with the lowest metric",
       "choice_d":"The route being populated from RIP",
       "correct_answer":"A",
       "explanation":"Since both routes are default routes, the route with the lowest administrative distance will be selected. The route with the highest administrative distance will never be selected first. The route with the lowest metric will only be used if two routes exist to the same destination network and have equal administrative distances. The RIP routing protocol has an administrative distance of 120; therefore, it has a higher administrative distance over a statically defined default route and will not be selected."
    },
    {
       "id":436,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":4,
       "question":"Which is true of a host route in the routing table?",
       "choice_a":"The host route is the route a packet will take if no other route matches in the routing table.",
       "choice_b":"The routing table creates host routers for the destination hosts it discovers.",
       "choice_c":"A host route is a specific route with a netmask of /32 for a specific host.",
       "choice_d":"The host route is populated from HSRP.",
       "correct_answer":"C",
       "explanation":"A host route is used when you need to route packets to a different next hop for a specific host. A host route is configured as a long prefix of /32 so that it is selected when network prefixes are overlapped. The route table will not create host routes; host routes must be manually configured by the administrator. Hot Standby Router Protocol (HSRP) is not used with host routes, and therefore, it is an incorrect answer."
    },
    {
       "id":437,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":5,
       "question":"Which element of a routing table will identify where the route was learned from?",
       "choice_a":"Prefix and network mask",
       "choice_b":"Routing protocol code",
       "choice_c":"Metric",
       "choice_d":"Next hop",
       "correct_answer":"B",
       "explanation":"The routing protocol code is in the form of a single letter at the beginning of each route statement. A legend that depicts each route source precedes the route table. The prefix and network mask are learned from the route source. The metric will not identify where a route was learned, such as its route source. The next hop will not identify where a route was learned, such as its route source."
    },
    {
       "id":438,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which criteria are routing decisions based upon?",
       "choice_a":"Source IP",
       "choice_b":"Destination IP address",
       "choice_c":"TTL",
       "choice_d":"Destination MAC address",
       "correct_answer":"B",
       "explanation":"All routing decisions are based upon the destination IP address. The router examines the IP address and routes the packet to the next closest hop for the network it belongs to. The source IP address is not used during the route process and will not change throughout the process. The time to live (TTL) is used to limit how many times a packet is routed throughout a network or the Internet. The TTL is decremented by 1 as it passes through a router; when it reaches 0, the packet will be dropped and no longer routable. The destination MAC address is not used for routing decisions."
    },
    {
       "id":439,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which type of routing requires network administrator intervention?",
       "choice_a":"Link-state routing",
       "choice_b":"Distance-vector routing",
       "choice_c":"Static routing",
       "choice_d":"Dynamic routing",
       "correct_answer":"C",
       "explanation":"Static routing requires a network administrator to intervene and create a route in the routing table. Dynamic routing is the opposite of static routing because routes are learned dynamically. Link-state and distance-vector routing are forms of dynamic routing protocols and do not require administrator intervention."
    },
    {
       "id":440,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which is a correct statement about the subnet mask?",
       "choice_a":"The subnet mask is used by the host to determine the destination network.",
       "choice_b":"The subnet mask is used in routing to determine the destination network.",
       "choice_c":"The router uses its subnet mask when routing a packet.",
       "choice_d":"The destination computer checks the subnet mask on the packet to verify that it\u0027s intended for that computer.",
       "correct_answer":"A",
       "explanation":"The subnet mask is used by the host to determine the immediate network and the destination network. It then decides to either route the packet or try to deliver the packet itself without the router\u0027s help. The subnet mask of the destination network is not used to determine routing decisions because the sending host does not know the destination subnet mask. The router does not use the network mask for routing decisions because it is not transmitted in the IP packet. The destination computer will check only the destination IP address in the packet because the network mask is not transmitted with the IP packet."
    },
    {
       "id":441,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"What protocol does the router or host use to find a MAC address for the frame when it determines that the packet is on the local network?",
       "choice_a":"IGMP",
       "choice_b":"RARP",
       "choice_c":"ARP",
       "choice_d":"ICMP",
       "correct_answer":"C",
       "explanation":"The Address Resolution Protocol (ARP) is employed by the host or router when a packet is determined to be local on one of its interfaces. The Internet Group Management Protocol (IGMP) is used to build multicast sessions for switches and routers. Reverse Address Resolution Protocol (RARP) is used to obtain an IP address assigned for a specific MAC address. RARP has been replaced with DHCP and is no longer used outside of networking theory. The Internet Control Message Protocol (ICMP) protocol is used with connectivity tools such as ping and tracert. ICMP is also used to notify a sender when the destination network is unreachable."
    },
    {
       "id":442,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":4,
       "question":"When a packet is determined to be remote from the network of the sending host, what happens?",
       "choice_a":"The destination IP address is changed to the router\u0027s IP address.",
       "choice_b":"The destination MAC address is changed to the destination host\u0027s MAC address.",
       "choice_c":"The destination MAC address is changed to the router\u0027s MAC address.",
       "choice_d":"The source IP address is changed to the router\u0027s IP address.",
       "correct_answer":"C",
       "explanation":"The destination MAC address is changed to the router\u0027s MAC address and the destination IP address is untouched. The destination IP address is not changed throughout the routing process. The destination MAC address is only changed to the destination host\u0027s MAC address if the traffic is deemed to be local. The source IP address is not changed throughout the routing process unless NAT is being used."
    },
    {
       "id":443,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":5,
       "question":"Which statement describes correctly what happens when a packet moves through a router?",
       "choice_a":"The destination IP address is changed to the original destination.",
       "choice_b":"The packet\u0027s TTL is decremented.",
       "choice_c":"The source MAC address is changed to the original source MAC address.",
       "choice_d":"All of the above.",
       "correct_answer":"B",
       "explanation":"The TTL, or time to live, is decremented usually by one. When the TTL reaches zero, a packet is considered unroutable. This prevents packets from eternally routing. The destination IP address is not changed throughout the normal routing process. The source MAC address in not changed since the originator of the frame has no need to forge the frame."
    },
    {
       "id":444,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":1,
       "question":"When a packet is determined to be on the local network, what happens?",
       "choice_a":"The destination IP address is changed to the router IP address.",
       "choice_b":"The destination MAC address is changed to the destination host\u0027s MAC address.",
       "choice_c":"The destination MAC address is changed to the router\u0027s MAC address.",
       "choice_d":"The source IP address is changed to the router\u0027s IP address.",
       "correct_answer":"B",
       "explanation":"When a packet is determined to be local to the sending host, ARP is used to resolve the MAC address for the IP address of the destination host, and the frame is sent directly to the host. The destination IP address is not changed throughout the network delivery process. The destination MAC address is only changed to the MAC address of the router if the packet is deemed to be remote from the immediate network. The source IP address is not changed throughout the routing process unless NAT is being used, and NAT is not used for local communications."
    },
    {
       "id":445,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"How does the sending host know if the destination is local or remote with respect to its immediate network?",
       "choice_a":"The host compares the IP address to its internal routing table.",
       "choice_b":"The host performs ANDing on its subnet mask and the destination IP address, comparing the result to its own network address.",
       "choice_c":"The host performs ANDing on the destination subnet mask and the destination IP address, comparing the result to its own network address.",
       "choice_d":"The IP address is verified to be local to its network via ICMP.",
       "correct_answer":"B",
       "explanation":"The sending host ANDs its subnet mask against the destination IP address, then against its IP address, and this give a frame of reference for where it needs to go and where it is. The host compares the remote IP to its internal routing table after the calculation of local versus remote is performed and the host is ready to route the packet. The host does not perform the ANDing process against the destination IP address and destination subnet mask because the destination subnet mask is often unknown and irrelevant to the calculation. ICMP is not used in the calculation of local versus remote networks."
    },
    {
       "id":446,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"What is the current method Cisco routers use for packet forwarding?",
       "choice_a":"Process switching",
       "choice_b":"Fast switching",
       "choice_c":"Intelligent packet forwarding",
       "choice_d":"Cisco Express Forwarding",
       "correct_answer":"D",
       "explanation":"The current method of packet forwarding used by Cisco routers is Cisco Express Forwarding (CEF). CEF creates several cache tables used for determining the best route for the destination network. Process switching is the original method used with routing packets and is no longer used. Fast switching is also an older method used with routing packets on Cisco devices, and it too is no longer used. Intelligent packet forwarding is not a packet forwarding method, and therefore, it is an invalid answer."
    },
    {
       "id":447,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":4,
       "question":"What is the process called at layer 2 when a packet hops from router to router and eventually to the host?",
       "choice_a":"IP routing",
       "choice_b":"Frame rewrite",
       "choice_c":"Packet hopping",
       "choice_d":"Packet switching",
       "correct_answer":"B",
       "explanation":"The layer 2 process is called frame rewrite. When a packet hops from router to router, the destination frame is rewritten for the next destination MAC address. IP routing is the process the router actually performs for the selection of a route or path to the destination. Packet hopping is not a valid process in the routing of packets, and therefore, it is an invalid answer. Packet switching is the concept of moving packets of data over a digital network, and therefore, it is an incorrect answer."
    },
    {
       "id":448,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":5,
       "question":"When a host sends an ARP request packet out, what is the destination address of the frame?",
       "choice_a":"The router\u0027s MAC address",
       "choice_b":"The host\u0027s MAC address",
       "choice_c":"The MAC address, in the form of a broadcast",
       "choice_d":"The MAC address, in the form of a multicast",
       "correct_answer":"C",
       "explanation":"When a MAC address is unknown for the destination IP address or the default gateway, the ARP request is sent in the form of a broadcast. If the destination MAC address was the router\u0027s MAC address, the router would be the only device to receive the ARP request frame. The host\u0027s MAC address is what we need to process the framing of data; therefore, it is the reason for the ARP request to all listening nodes. In IPv4, ARP uses broadcasts to forward the ARP request to all listening network devices. Multicast is used in IPv6 for node discover, but it does not use ARP."
    },
    {
       "id":449,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"What does every network device use to limit the number of ARP packets?",
       "choice_a":"ARP cache",
       "choice_b":"IP multicasting",
       "choice_c":"Frame casting",
       "choice_d":"IP cache",
       "correct_answer":"A",
       "explanation":"Every host contains an ARP cache. This cache allows for lookups of MAC addresses for destination IP addresses when the host frequently sends packets to the destination. Therefore, there are fewer ARP packets. IP multicasting is used with network discover (ND) packets in IPv6 and not ARP. There is no such thing as frame casting; therefore, it is an invalid answer. There is also no such thing as an IP cache; therefore, it is also an invalid answer."
    },
    {
       "id":450,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which statement describes what happens when a packet enters a router?",
       "choice_a":"The router accepts all incoming frames regardless of their destination MAC address.",
       "choice_b":"The router decapsulates the packet and inspects the destination IP address.",
       "choice_c":"Routers do not need to decapsulate packets to inspect the destination IP address.",
       "choice_d":"Routers make routing decisions first by examining the source MAC address.",
       "correct_answer":"B",
       "explanation":"After the frame is verified to be addressed to the router and the FCS has been checked, the router decapsulates the packet and strips off the frame. The router will only accept frames that are unicast directly to the router\u0027s MAC address, multicasted to the router multicast group, or broadcast to all devices. Routers must decapsulate packets to inspect the destination IP address. Routing decisions are never made by examining the source MAC address, since the source of the traffic is irrelevant to the destination."
    },
    {
       "id":451,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which command will display the router\u0027s ARP cache?",
       "choice_a":"<code>Router#show arp</code>",
       "choice_b":"<code>Router#show arp table</code>",
       "choice_c":"<code>Router#show arp cache</code>",
       "choice_d":"<code>Router#show ip arp</code>",
       "correct_answer":"D",
       "explanation":"The command to display the router\u0027s ARP cache is <code>show ip arp</code>. The commands <code>show arp, show arp table</code>, and <code>show arp cache</code> are incorrect."
    },
    {
       "id":452,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":4,
       "question":"What is the default time an entry will live in the ARP cache?",
       "choice_a":"180 seconds",
       "choice_b":"240 seconds",
       "choice_c":"300 seconds",
       "choice_d":"600 seconds",
       "correct_answer":"B",
       "explanation":"By default, all entries have a time to live, or TTL, of 240 seconds. They will be removed after that period if not used during the 240 seconds. All other answers are incorrect."
    },
    {
       "id":453,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":5,
       "question":"Which type of routing allows for routers to share their routing tables with other routers in the network?",
       "choice_a":"Default routing",
       "choice_b":"Stub routing",
       "choice_c":"Static routing",
       "choice_d":"Dynamic routing",
       "correct_answer":"D",
       "explanation":"Dynamic routing allows for the population of routing tables from advertisements of other routers. There are several dynamic routing protocols, such as, for example, EIGRP, RIP, and OSPF. Default routing forces all traffic that is unknown to a specific next hop. Stub routing is similar to default routing. Stub routing is often used to describe a default route on a stub network, where any remote network address is through a specific next hop. Static routing is the method of manually configuring route statements in router versus dynamic routing protocol processes."
    },
    {
       "id":454,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which statement describes what happens during the routing process?",
       "choice_a":"As a packet travels through the routers, the TTL of the packet will increase by one.",
       "choice_b":"When a route to the destination network is found, the router will attach the destination MAC address for the next hop to the packet.",
       "choice_c":"When a packet travels through the router, the transport information will be checked for the destination network.",
       "choice_d":"When a route to the destination network is found, the router will attach the destination IP address for the next hop to the packet.",
       "correct_answer":"B",
       "explanation":"When a route is found in the routing table, the router will find the gateway for the next hop and change the packet\u0027s destination MAC address for the next router. The packet\u0027s TTL will always be decremented by one as it passes through a router and not increased. When packets travel through a router, the layer 4 transport information is not inspected; only the layer 3 destination IP address is inspected. The packet is never changed throughout the routing process, such as adding the destination IP address of the next hop."
    },
    {
       "id":455,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which protocol allows for testing and connectivity of a route?",
       "choice_a":"IGMP",
       "choice_b":"RARP",
       "choice_c":"ARP",
       "choice_d":"ICMP",
       "correct_answer":"D",
       "explanation":"The Internet Control Message Protocol (ICMP) is a layer 3 protocol that allows for end-to-end testing with a command such as traceroute. The Internet Group Management Protocol (IGMP) is used to allow hosts to join a multicast group on a switch. The Reverse Address Resolution Protocol (RARP) is used to resolve an IP address from a MAC address; its operation closely resembles DHCP. Address Resolution Protocol (ARP) is used to resolve a MAC address from an IP address for the purpose of framing data."
    },
    {
       "id":456,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which routing protocol is a distance-vector routing protocol?",
       "choice_a":"OSPF",
       "choice_b":"RIP",
       "choice_c":"EIGRP",
       "choice_d":"BGP",
       "correct_answer":"B",
       "explanation":"The Routing Information Protocol (RIP) is a distance-vector protocol. Open Shortest Path First (OSPF) is a link-state protocol. Enhanced Interior Gateway Routing Protocol (EIGRP) is a hybrid protocol that more closely resembles a link-state protocol. Border Gateway Protocol (BGP) is a path-vector protocol used for Internet routing."
    },
    {
       "id":457,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"When an ICMP packet reaches a router for which it has no further route, what happens?",
       "choice_a":"The router will discard the packet without notification.",
       "choice_b":"The router will change the TTL of the packet to 0.",
       "choice_c":"The router will send the packet back to the originating host.",
       "choice_d":"The router will send back a destination unreachable message.",
       "correct_answer":"D",
       "explanation":"The last router will send an ICMP packet back to the originating host, which has the result code of destination unreachable. The router will discard the packet, but a notification is still sent back to the originating host. The router will not change the TTL of the packet; it will just drop the packet and notify the originating host. The router will not bother with sending the original packet back to the originating host."
    },
    {
       "id":458,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":4,
       "question":"Which statement accurately describes a routing loop?",
       "choice_a":"Packets are routed out one interface but come back on a different interface.",
       "choice_b":"Packets are transmitted within a series of routers and never reach the destination.",
       "choice_c":"Packets reach the expiry TTL before reaching the destination network.",
       "choice_d":"Packets are routed via an inefficient path.",
       "correct_answer":"B",
       "explanation":"A routing loop occurs when packets are routed between two or more routers and never make it to their destination. Routing loops can occur with more than two routers; it is in effect making the packet travel in a loop till its TTL expires. When packets are routed out one interface and come back in on a different interface, this is considered asynchronous routing and not typical of a routing loop. Packets reaching the expiry TTL could mean that there are too many hops to the destination network, but not that a routing loop is occurring. Packets being routed via an inefficient path is not a symptom of a routing loop."
    },
    {
       "id":459,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":5,
       "question":"Which routing protocol is a link-state routing protocol?",
       "choice_a":"OSPF",
       "choice_b":"RIP",
       "choice_c":"EIGRP",
       "choice_d":"IGRP",
       "correct_answer":"A",
       "explanation":"Open Shortest Path First (OSPF) is a link-state protocol. A link-state protocol tracks the state of a link between two routers and chooses the most efficient routes based upon the shortest path. EIGRP is an advanced distance-vector protocol. Routing Information Protocol (RIP) is a distance-vector protocol. Enhanced Interior Gateway Routing Protocol (EIGRP) is considered a hybrid protocol. Interior Gateway Routing Protocol (IGRP) is a distance-vector protocol."
    },
    {
       "id":460,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Where are dynamic routes stored in a router?",
       "choice_a":"RAM",
       "choice_b":"Flash",
       "choice_c":"Startup configuration",
       "choice_d":"Running configuration",
       "correct_answer":"A",
       "explanation":"Dynamic routes are stored in RAM. When the power is taken away from a router, all routes must be repopulated by neighboring routers. Flash is where the IOS of the router is stored. The startup configuration is stored in non-volatile random-access memory (NVRAM). The running configuration is stored in RAM along with tables such as dynamic routes."
    },
    {
       "id":461,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which is a correct statement about SVI inter-VLAN routing (IVR)?",
       "choice_a":"Latency is low with SVI IVR because of ASICs.",
       "choice_b":"Latency is high with SVI inter-VLAN routing because of resource use.",
       "choice_c":"SVI inter-VLAN routing is a cheaper alternative to ROAS.",
       "choice_d":"Bandwidth is limited compared to ROAS.",
       "correct_answer":"A",
       "explanation":"Latency is lower with SVI inter-VLAN routing because of the use of ASICs. This is usually why IVR switches are more expensive. Latency is not higher because the SVI inter-VLAN routing uses ASICs. SVI inter-VLAN routing is not always a cheaper alternative to router on a stick (ROAS) because of licensing and the requirement of a layer 3 switch. Bandwidth is not limited like ROAS and is usually substantially higher, which is one of the main motivations to use SVI inter-VLAN routing."
    },
    {
       "id":462,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which is a disadvantage of using router on a stick ROAS?",
       "choice_a":"The lack of ISL support for VLANs.",
       "choice_b":"The number of VLANs you can route is tied to the number of physical ports.",
       "choice_c":"Scalability of ROAS for the number of VLANs.",
       "choice_d":"The lack of dynamic routing protocol support.",
       "correct_answer":"C",
       "explanation":"The scalability of ROAS is a major disadvantage. It does not scale well when a large number of VLANs are configured. ROAS can be used with Inter-Switch Link (ISL) protocol for VLAN support. With 802.1Q or ISL trunking, you can tie several VLANs to a physical port. All dynamic routing protocols are supported with ROAS."
    },
    {
       "id":463,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which is a correct statement about IVR?",
       "choice_a":"Each VLAN requires a unique IP network.",
       "choice_b":"IVR reduces the number of broadcast domains.",
       "choice_c":"It does not support ACLs.",
       "choice_d":"IVR restricts the use of subnetting.",
       "correct_answer":"A",
       "explanation":"The use of VLANs requires a unique IP network for each VLAN. This is how broadcast domains are increased, since all VLANs are behind a router interface (default gateway). IVR does not reduce the number of broadcast domains; it increases the number of broadcast domains. You\u0027ll have several different VLANs in which you can broadcast as the scale of your network grows. IVR supports access control lists (ACLs) because you are creating network interfaces as you add VLANs. IVRs promote the use of subnetting because you need a unique IP network for each VLAN."
    },
    {
       "id":464,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"What is the method of using a single router interface to route between VLANs called?",
       "choice_a":"Interface routing",
       "choice_b":"ROAS routing",
       "choice_c":"SVI routing",
       "choice_d":"Bridge routing",
       "correct_answer":"B",
       "explanation":"When a router\u0027s interface is used to allow routing, the method is called router on a stick, or ROAS. Interface routing is used when an IP address is assigned to an interface and routing is enabled between the interfaces. Switched Virtual Interface (SVI) routing allows for the layer 3 router inside a switch to provide necessary routing between VLANs. There is no such thing as bridge routing; bridges are limited interface switches, and routing is a layer 3 function."
    },
    {
       "id":465,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"What is a disadvantage of routing between VLANs on a router\u0027s interface?",
       "choice_a":"Routers do not handle large amounts of traffic very well.",
       "choice_b":"When using ROAS, bandwidth problems are encountered.",
       "choice_c":"Security cannot be implemented with ROAS.",
       "choice_d":"Broadcast traffic is increased.",
       "correct_answer":"B",
       "explanation":"Bandwidth is often a consideration because everything you send to the router must come back on the same port for routing to work. Routing between two VLANs on a 1 Gb/s interface will allow for the bandwidth of 1 Gb/s up and 1 Gb/s down. When a third VLAN is introduced, they must all share the 1 Gb/s. Routers can handle large amounts of traffic, but the same interface used to receive is also used to send the traffic, thereby reducing the bandwidth by half. Security can be implemented with ROAS with the use of ACLs. Broadcast traffic is not increased by using a single router interface to route several VLANs."
    },
    {
       "id":466,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":4,
       "question":"What is the method of routing between VLANs on a layer 3 switch?",
       "choice_a":"Interface routing",
       "choice_b":"ROAS routing",
       "choice_c":"SVI routing",
       "choice_d":"Bridge routing",
       "correct_answer":"C",
       "explanation":"When you perform inter-VLAN routing on a layer 3 switch, it is called Switched Virtual Interface (SVI) VLAN routing. Interface routing is used when an IP address is assigned to an interface and routing is enabled between the interfaces. Routing on a Stick (ROAS) is used when a router only has one interface and you need to route multiple VLANs. There is no such thing as bridge routing; bridges are limited interface switches, and routing is a layer 3 function."
    },
    {
       "id":467,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":5,
       "question":"Which routing technique requires no administrator intervention when a route goes down?",
       "choice_a":"Dynamic routing",
       "choice_b":"Directly connected routes",
       "choice_c":"Default routing",
       "choice_d":"Static routing",
       "correct_answer":"A",
       "explanation":"Dynamic routing does not require any administrator intervention when routes go down. This is because dynamic routes send route notifications and recalculate the routing tables of all participating routers. Directly connected routes will require administrator intervention if the admin is relying upon the connected route as the route source and an interface goes down. Default routing requires administrator intervention if the default route goes down; the admin will need to pick a new default route and configure it. Static routing always requires an amount of administrator intervention for setup and maintenance of the routes since they are all done manually."
    },
    {
       "id":468,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which routing technique requires increased time for configuration as networks grow?",
       "choice_a":"RIP routing",
       "choice_b":"OSPF routing",
       "choice_c":"Static routing",
       "choice_d":"Default routing",
       "correct_answer":"C",
       "explanation":"Static routing requires increased time for configuration as networks grow in complexity. You will need to update routers that you add with all of the existing routes in the network. You will also need to update all of the existing routers with the new routes you add with the new router. RIP is a dynamic routing protocol and therefore requires less time as a network grows. OSPF is a dynamic routing protocol and therefore requires less time as a network grows. Default routing is used on stub networks and requires no additional time if the network remains as a stub network."
    },
    {
       "id":469,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which routing technique requires the lowest amount of router RAM consumption?",
       "choice_a":"RIP routing",
       "choice_b":"OSPF routing",
       "choice_c":"Static routing",
       "choice_d":"Default routing",
       "correct_answer":"D",
       "explanation":"Default routing requires the least amount of RAM consumption because one routing statement is required for all of the upstream networks. This type of routing technique is best used on stub network routers. RIP routing requires an amount of RAM to hold its learned routes. OSPF requires a substantial amount of RAM because it holds learned routes and calculates the shortest path to remote networks. Static routing requires RAM for each route configured manually compared to default routing, which only requires one static entry."
    },
    {
       "id":470,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which dynamic routing protocol has the lowest overhead?",
       "choice_a":"BGP",
       "choice_b":"OSPF",
       "choice_c":"RIP",
       "choice_d":"EIGRP",
       "correct_answer":"C",
       "explanation":"Routing Information Protocol (RIP) has the lowest overhead of all of the routing protocols. However, it is not very scalable; the maximum number of hops is 15. BGP has tremendous overhead because of the storage and calculations on best path. OSPF has a large overhead as well because of storage and calculations to shortest path. EIGRP is similar to OSPF in regard to storage and calculations for the next hop."
    },
    {
       "id":471,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which is an advantage of dynamic routing protocols?",
       "choice_a":"Resiliency when routes become unavailable",
       "choice_b":"Lower router RAM usage",
       "choice_c":"Lower router CPU usage",
       "choice_d":"Less bandwidth usage",
       "correct_answer":"A",
       "explanation":"The benefit of a dynamic routing protocol is that it creates resiliency when routes become unavailable. It does this by recalculating the best route in the network around the outage. When using dynamic routing protocols. there is a higher RAM usage because of the route tables collected. CPU usage is also higher with dynamic routing protocols because of calculations. Bandwidth usage is also higher with dynamic routing protocols because of the traffic involved learning the various routes."
    },
    {
       "id":472,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which routing protocol broadcasts updates for routes?",
       "choice_a":"RIP",
       "choice_b":"OSPF",
       "choice_c":"EIGRP",
       "choice_d":"BGP",
       "correct_answer":"A",
       "explanation":"The Routing Information Protocol version 1 (RIPv1) broadcasts updates for routing tables. OSPF exclusively uses multicast to send updates. EIGRP uses multicast to send updates as well and has a backup of direct unicast. BGP uses unicast to retrieve updates on network paths."
    },
    {
       "id":473,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"What is an advantage of dynamic routing protocols?",
       "choice_a":"Centralized routing tables",
       "choice_b":"Optimized route selection",
       "choice_c":"Ease of configuration",
       "choice_d":"Lower bandwidth utilization",
       "correct_answer":"B",
       "explanation":"Optimized route selection is a direct advantage of using dynamic routing protocols. A protocol such as OSPF uses the shortest path first algorithm for route selection. Routing tables will not be centralized since all routers participating in dynamic routing will contain their own routing table. Dynamic routing is not easier to configure due to the upfront planning and configuration. A portion of the available bandwidth will also be consumed for the dynamic routing protocol."
    },
    {
       "id":474,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":4,
       "question":"Which routing protocol has a maximum of 15 hops?",
       "choice_a":"RIP",
       "choice_b":"OSPF",
       "choice_c":"EIGRP",
       "choice_d":"BGP",
       "correct_answer":"A",
       "explanation":"The Routing Information Protocol (RIP) is a distance-vector routing protocol that has a maximum of 15 hops. OSPF is an extremely scalable routing protocol, and therefore, OSPF isn\u0027t limited to a hop count. EIGRP has a default hop count of 100 and can be configured for up to 255 hops. BGP is the routing protocol that routes the Internet; it does, however, have a maximum hop count of 255."
    },
    {
       "id":475,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":5,
       "question":"Which protocol is considered a hybrid protocol?",
       "choice_a":"RIP",
       "choice_b":"OSPF",
       "choice_c":"EIGRP",
       "choice_d":"BGP",
       "correct_answer":"C",
       "explanation":"The Enhanced Interior Gateway Routing Protocol (EIGRP) is a hybrid protocol. It has features of a vector-based protocol and a link-state protocol; hence it is considered a hybrid protocol. RIP is a distance-vector routing protocol that is used for small networks. OSPF is an extremely scalable link-state protocol. BGP is the routing protocol that is used to route packets on the Internet, and it is considered a path-vector protocol."
    },
    {
       "id":476,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"What is a characteristic of distance-vector protocols?",
       "choice_a":"They track the status of routes learned.",
       "choice_b":"They re-advertise routes learned.",
       "choice_c":"Each router keeps its own topology database.",
       "choice_d":"Each router checks the routes it learns.",
       "correct_answer":"B",
       "explanation":"Protocols such as RIP re-advertise routes learned. This can be problematic since it is the equivalent of gossiping about what they have heard. Routes learned through this method are never tracked for status or double-checked for validity. Distance-vector protocols do not keep a topology database; they just feed routes to the route table. Distance-vector protocols never check the routes they learn because of the method of routing through rumor."
    },
    {
       "id":477,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which type of network are distance-vector protocols best suited for?",
       "choice_a":"Networks containing fewer than 255 routes",
       "choice_b":"Networks containing fewer than 15 routers",
       "choice_c":"Networks containing more than 15 routers",
       "choice_d":"Networks containing more than 255 routers",
       "correct_answer":"B",
       "explanation":"RIP, which is a distance-vector protocol, is best suited for networks containing fewer than 15 routers. This is because RIP is limited to a 15 hop count. Any route that is more than 15 hops away is considered unreachable. All other answers are incorrect and describe networks that are best suited for a hybrid, link-state, or path-vector protocol."
    },
    {
       "id":478,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which problem could arise from use of a distance-vector routing protocol?",
       "choice_a":"Routing loops",
       "choice_b":"Router incompatibility",
       "choice_c":"Complexity of configuration",
       "choice_d":"Default route advertisement",
       "correct_answer":"A",
       "explanation":"Routing loops are the most common problem when you\u0027re using a distance-vector routing protocol. Although they can occur with any dynamic routing protocol, distance-vector protocols are most susceptible due to how they converge routes. RIP is extremely compatible with all router implementations, and it is a light protocol; therefore, it is found on many different routers. RIP is a very simple protocol to configure compared to other dynamic routing protocols. RIP also supports the advertisement of a default route."
    },
    {
       "id":479,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":4,
       "question":"Which dynamic routing protocol uses the Diffusing Update Algorithm as its routing algorithm?",
       "choice_a":"RIP",
       "choice_b":"EIGRP",
       "choice_c":"OSPF",
       "choice_d":"BGP",
       "correct_answer":"B",
       "explanation":"The diffusing update algorithm, or DUAL, is used by EIGRP to calculate the best route for the destination network. RIP uses the Bellman-Ford algorithm for calculations of routes. OSPF uses the Dijkstra algorithm to calculate the shortest path between two networks. BGP uses the best path algorithm that determines the best path between two networks."
    },
    {
       "id":480,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":5,
       "question":"Which is a disadvantage of distance-vector routing protocols?",
       "choice_a":"Router incompatibility for RIP",
       "choice_b":"Slow convergence of routing tables",
       "choice_c":"Resource usage of CPU and RAM",
       "choice_d":"The complexity of RIP design",
       "correct_answer":"B",
       "explanation":"Slow convergence of routing tables is a major disadvantage for distance-vector protocols like RIP. It could take several announcement cycles before the entire network registers a routing change. RIP is an extremely compatible and light protocol; therefore, it is found on many different routers. Because RIP is extremely lightweight as a routing protocol, it uses very little CPU and RAM. RIP is not best suited for complex networks, and therefore, it is very easy to configure."
    },
    {
       "id":481,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which dynamic routing protocol uses the Bellman-Ford routing algorithm?",
       "choice_a":"RIP",
       "choice_b":"EIGRP",
       "choice_c":"OSPF",
       "choice_d":"BGP",
       "correct_answer":"A",
       "explanation":"The Routing Information Protocol (RIP) uses the Bellman-Ford routing algorithm to calculate the shortest path based on distance. The distance is computed from the shortest number of hops. EIGRP uses the DUAL algorithm to calculate the best route for the destination network. OSPF uses the Dijkstra algorithm to calculate the shortest path between two networks. BGP uses the best path algorithm that determines the best path between two networks."
    },
    {
       "id":482,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which is a design concept used to stop routing loops with distance-vector dynamic routing protocols?",
       "choice_a":"Use of a topology database",
       "choice_b":"Use of holddown timers",
       "choice_c":"Use of anti-flapping ACLs",
       "choice_d":"Use of counting-to-infinity conditions",
       "correct_answer":"B",
       "explanation":"The use of holddown timers allows the convergence of the network routing tables. This is used to hold down changes to the routing table before convergence can happen and a routing decision is hastily made by RIP. Although the topology database helps stop routing loops, it is not a functional component of distance-vector protocols. There is no such thing as anti-flapping ACLs; therefore, it is an incorrect answer. Counting-to-infinity is another name for a routing loop, and therefore, it is not a design concept used to stop routing loops."
    },
    {
       "id":483,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which is an exterior gateway routing protocol?",
       "choice_a":"RIPv1",
       "choice_b":"OSPF",
       "choice_c":"EIGRP",
       "choice_d":"BGP",
       "correct_answer":"D",
       "explanation":"The Border Gateway Protocol (BGP) is an exterior gateway routing protocol, which is used on the exterior of your network. RIPv1 is an internal gateway routing protocol. OSPF is an internal gateway routing protocol. EIGRP is a Cisco proprietary internal gateway routing protocol."
    },
    {
       "id":484,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":4,
       "question":"Which protocol is a Cisco proprietary interior gateway protocol?",
       "choice_a":"RIPv1",
       "choice_b":"OSPF",
       "choice_c":"EIGRP",
       "choice_d":"BGP",
       "correct_answer":"C",
       "explanation":"Enhanced Interior Gateway Routing Protocol (EIGRP) is a Cisco proprietary interior gateway protocol. RIPv1 is an open-source interior gateway protocol. OSPF is also an open-source interior gateway protocol. BGP is an open-source interior or exterior gateway protocol."
    },
    {
       "id":485,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":5,
       "question":"Which statement is correct about interior gateway protocols (IGPs) vs. exterior gateway protocols (EGPs)?",
       "choice_a":"IGPs are used to exchange information between autonomous systems.",
       "choice_b":"EGPs are used to exchange information between routers within an autonomous system.",
       "choice_c":"IGPs are used to exchange information between routers within an autonomous system.",
       "choice_d":"EGPs are used in the core of an internal network.",
       "correct_answer":"C",
       "explanation":"Interior routing protocols are used internally inside of a network. The functional difference is that IGPs exchange information within an autonomous system, and EGPs exchange information between autonomous systems. Interior routing protocols are used to exchange information between routers within the same autonomous system. Exterior routing protocols can be used to exchange routing information between autonomous systems. Exterior routing protocols are used on the edge of a network, usually facing the Internet."
    },
    {
       "id":486,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which statement is correct about IGPs?",
       "choice_a":"IGPs require a small number of resources, such as CPU and RAM.",
       "choice_b":"IGPs function within an administrative domain.",
       "choice_c":"An EGP is an example of an IGP.",
       "choice_d":"IGPs use autonomous system numbers (ASNs) that have been assigned by ARIN.",
       "correct_answer":"B",
       "explanation":"Interior gateway protocols function within an administrative domain. This administrative domain is defined with a common autonomous system number or area ID. IGPs, like OSPF, can require a large amount of resources, such as CPU and RAM. An EGP is by definition an exterior gateway routing protocol and not an interior gateway routing protocol. EGPs use autonomous system numbers (ASN) that have been assigned by ARIN."
    },
    {
       "id":487,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Why would you need to use an EGP?",
       "choice_a":"You need to connect your company to the Internet.",
       "choice_b":"You have been delegated a large number of IP addresses.",
       "choice_c":"You want to achieve fast routing to the Internet.",
       "choice_d":"You are dual-homed with two different ISPs.",
       "correct_answer":"D",
       "explanation":"The only time you need to use an exterior gateway protocol such as Border Gateway Protocol (BGP) is when you have a dual-homed connection between two ISPs. An example of this would be routing between the Internet and Internet 2. You would need to know the fastest path to the destination network via the Internet connection. You don\u0027t need to use an exterior gateway protocol to connect to the Internet; default routing is normally used. When you are delegated a large number of IP addresses, conventional static routing can be used. Fast routing to the Internet does not require the use of an exterior gateway protocol; static routing can be used."
    },
    {
       "id":488,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":1,
       "question":"When RIP is configured on a router, what must be configured to allow for classless routing?",
       "choice_a":"<code>Router(config)#ip classless</code>",
       "choice_b":"<code>Router(config)#router rip v2</code>",
       "choice_c":"<code>Router(config-router)#ip classless</code>",
       "choice_d":"<code>Router(config-router)#version 2</code>",
       "correct_answer":"D",
       "explanation":"When you\u0027re configuring RIP on a router, the RIP process will default to RIPv1, which is classful. The command <code>version 2</code> must be configured in the router instance of RIP to allow for RIPv2. The command <code>ip classless</code> is incorrect, when configured in the global configuration prompt or the config-router prompt. The command <code>router rip v2</code> is incorrect."
    },
    {
       "id":489,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"You need to configure the advertisement of the network 192.168.1.0/24 for RIPv2. Which command will achieve this?",
       "choice_a":"<code>Router(config-router)#network 192.168.1.0</code>",
       "choice_b":"<code>Router(config-router)#network 192.168.1.0 0.0.0.255</code>",
       "choice_c":"<code>Router(config-router)#network 192.168.1.0/24</code>",
       "choice_d":"<code>Router(config-router)#network 192.168.1.0 255.255.255.0</code>",
       "correct_answer":"A",
       "explanation":"The command <code>network 192.168.1.0</code> will configure the RIPv2 route process to advertise the network 192.168.1.0. The command <code>network 192.168.1.0 0.0.0.255</code> is incorrect. The command <code>network 192.168.1.0/24</code> is incorrect. The command <code>network 192.168.1.0 255.255.255.0</code> is incorrect."
    },
    {
       "id":490,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":4,
       "question":"What is the entry for the IP address in the routing table called in IOS 15 code when an interface is configured?",
       "choice_a":"IP address route",
       "choice_b":"Local route",
       "choice_c":"Dynamic route",
       "choice_d":"Static route",
       "correct_answer":"B",
       "explanation":"When an IP address is configured on an interface, the entry in the routing table is called the local route. The local routes always have a prefix of /32. <italic>IP address route</italic> is not a valid term and therefore an invalid answer. A dynamic route is dynamically learned and not manually configured. A static route is manually configured, but it is a route to a remote network and not an IP address on the local router."
    },
    {
       "id":491,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":5,
       "question":"Which metric does RIPv2 use to calculate routes?",
       "choice_a":"Delay",
       "choice_b":"Bandwidth",
       "choice_c":"Hop count",
       "choice_d":"Bandwidth and delay",
       "correct_answer":"C",
       "explanation":"RIPv2 uses hop count to calculate routes. When a router sends its routing table, the next router adds a +1 to the metric for the entries in the table. Delay, bandwidth, and combinations are not used by RIPv2 to calculate routes. Minimum bandwidth, delay, load, reliability, and maximum transmission unit (MTU) are used to calculate routes with EIGRP."
    },
    {
       "id":492,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which command will allow you to inspect RIPv2 calculations for routes discovered?",
       "choice_a":"<code>Router#show ip protocols rip</code>",
       "choice_b":"<code>Router#show ip rip database</code>",
       "choice_c":"<code>Router#show ip interface</code>",
       "choice_d":"<code>Router#show ip rip topology</code>",
       "correct_answer":"B",
       "explanation":"The command <code>show ip rip database</code> will display all of the discovered routes and their calculated metrics. The command <code>show ip protocols rip</code> is incorrect. The command <code>show ip interface</code> is incorrect. The command <code>show ip rip topology</code> is incorrect."
    },
    {
       "id":493,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which command would allow you to see the next hop information for CEF?",
       "choice_a":"<code>Router#show cef</code>",
       "choice_b":"<code>Router#show ip cef</code>",
       "choice_c":"<code>Router#show cef nop</code>",
       "choice_d":"<code>Router#show cef route</code>",
       "correct_answer":"B",
       "explanation":"The command <code>show ip cef</code> will display all of the network prefixes and the next hop that Cisco Express Forwarding (CEF) has in the forwarding information base (FIB). The command will also display the exit interface for the next hop. The command <code>show cef</code> is incorrect. The command <code>show cef nop</code> is incorrect. The command <code>show cef route</code> is incorrect."
    },
    {
       "id":494,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"Which component of a network transmission changes during the routing process?",
       "choice_a":"Destination MAC address",
       "choice_b":"Destination IP address",
       "choice_c":"Source IP address",
       "choice_d":"Internal routes",
       "correct_answer":"A",
       "explanation":"The destination MAC address changes on the layer 2 frame, leaving the layer 3 packet intact; this process is known as packet switching. The destination IP address will not change throughout the entire routing process. The source IP address will not change throughout the entire routing process, as the destination will need the source IP address to respond back to answer the request. The internal routes of the router(s) will not change based upon the routed packet."
    },
    {
       "id":495,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"What will a router do if a matching route is not present in the router table?",
       "choice_a":"Flood the packet to all active interfaces",
       "choice_b":"Multicast the packet to other routers",
       "choice_c":"Drop the packet",
       "choice_d":"Send the original packet back to the source",
       "correct_answer":"C",
       "explanation":"The router will drop the packet if no matching route is present. The router will not flood all active interfaces; only switches perform flooding in an attempt to discover the destination MAC address. Routers will not multicast the packet if no route is known. The router will not send the original packet back to the originating host; it will, however, send an ICMP destination network unreachable packet to the originating host."
    },
    {
       "id":496,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":"",
       "question":"By default, which type of routing is used automatically on a router?",
       "choice_a":"Default routing",
       "choice_b":"Dynamic routes",
       "choice_c":"Static routes",
       "choice_d":"Connected routes",
       "correct_answer":"D",
       "explanation":"By default, directly connected routes are used automatically on routers to create routes in the route table. Default routing is a type of static routing, and it is not configured by default or automatically. Dynamic routing must be configured on routers, and therefore, it is not used automatically. Static routes must be configured on routers, and therefore, they are not used by default."
    },
    {
       "id":497,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which command would set the IPv6 default route for a router to interface s0/0?",
       "choice_a":"Router(config)# <code>ip route 0.0.0.0/0 s0/0</code>",
       "choice_b":"Router(config)# <code>ipv6 route 0.0.0.0/0 s0/0</code>",
       "choice_c":"Router(config)# <code>ipv6 unicast-route ::0/0 s0/0</code>",
       "choice_d":"Router(config)# <code>ipv6 route ::0/0 s0/0</code>",
       "correct_answer":"D",
       "explanation":"When you configure routers, always use the rule of major/minor. The major protocol is IPv6 and the minor command is <code>route</code>. So the correct command is <code>ipv6 route ::0/0 s0/0</code>, specifying the ::0/0 s0/0 to mean everything out of the existing interface of s0/0. The command <code>ip route 0.0.0.0/0 s0/0</code> is incorrect. The command <code>ipv6 route 0.0.0.0/0 s0/0</code> is incorrect. The command <code>ipv6 unicast-route ::0/0 s0/0</code> is incorrect."
    },
    {
       "id":498,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which dynamic routing protocol(s) can be used with IPv6?",
       "choice_a":"RIPng",
       "choice_b":"OSPFv3",
       "choice_c":"EIGRPv6",
       "choice_d":"All of the above",
       "correct_answer":"D",
       "explanation":"RIPng, OSPFv3, and EIGRPv6 are all dynamic routing protocols that work with IPv6."
    },
    {
       "id":499,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"You need to see all routes in the routing table for only IPv6. Which command will achieve this?",
       "choice_a":"Router#<code>show route</code>",
       "choice_b":"Router#<code>show ip route</code>",
       "choice_c":"Router#<code>show ipv6 route</code>",
       "choice_d":"Router#<code>show route ipv6</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show ipv6 route</code> will display only the IPv6 routes in the routing table. The command <code>show route</code> is incorrect. The command <code>show ip route</code> is incorrect. The command <code>show route ipv6</code> is incorrect."
    },
    {
       "id":500,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":4,
       "question":"What is the relevance of the default gateway address on a host that is transmitting to a destination for the first time?",
       "choice_a":"The destination IP address is replaced with the default gateway when the destination is remote.",
       "choice_b":"The host sends the default gateway packets that are deemed remote via a broadcast.",
       "choice_c":"The host sends an ARP packet for the default gateway when the destination is remote.",
       "choice_d":"The host creates a dedicated connection with the default gateway for remote traffic.",
       "correct_answer":"C",
       "explanation":"When traffic is remote to the immediate network, the host sends an ARP packet for the IP address of the default gateway. This determines the destination MAC address for the frame. The destination IP address is never replaced throughout the entire routing process. The host will not broadcast packets that are deemed remote; it will use the ARP process as described above. The host will not create a dedicated connection with the default gateway."
    },
    {
       "id":501,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":5,
       "question":"Which command will display the router\u0027s routing table?",
       "choice_a":"<code>Router#show ip route</code>",
       "choice_b":"<code>Router#show route</code>",
       "choice_c":"<code>Router#show route table</code>",
       "choice_d":"<code>Router#show routes</code>",
       "correct_answer":"A",
       "explanation":"The command to view the routing table is <code>show ip route.</code> The command <code>show route</code> is incorrect. The command <code>show route table</code> is incorrect. The command <code>show routes</code> is incorrect."
    },
    {
       "id":502,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which protocol is used by TCP/IP to help facilitate the routing of packets?",
       "choice_a":"IGMP",
       "choice_b":"RARP",
       "choice_c":"ARP",
       "choice_d":"ICMP",
       "correct_answer":"C",
       "explanation":"The Address Resolution Protocol (ARP) is used by TCP/IP to resolve a MAC address from a known IP address. This in turn allows TCP/IP to packet switch from router to router by sending the packet to the next destination MAC address. The Internet Group Management Protocol (IGMP) is used in conjunction with multicast to join clients to a multicast group. The Reverse Address Resolution Protocol (RARP) is a legacy protocol that maps an IP address from a MAC address, similar to DHCP. The Internet Control Message Protocol (ICMP) is a layer 3 protocol that allows for end-to-end testing with a command such as traceroute."
    },
    {
       "id":503,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"What uses ICMP to directly check the status of a router?",
       "choice_a":"SNMP traps",
       "choice_b":"Notifications",
       "choice_c":"Ping",
       "choice_d":"ARP",
       "correct_answer":"C",
       "explanation":"The <code>ping</code>command uses ICMP to check the status of a router. It also gives the round-trip time of the packet. Simple Network Management Protocol (SNMP) traps are alerts sent from an SNMP agent to an SNMP collector when a specific event is triggered.  SNMP trap notifications are messages that are sent to a network management station (NMS) and are defined with severity levels. The Address Resolution Protocol (ARP) helps map a MAC address to an IP address for the framing of data."
    },
    {
       "id":504,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"You have just used the <code>ping</code> command for a distant router. You received back five exclamation marks. What do these mean?",
       "choice_a":"The distant router is not responding.",
       "choice_b":"The distant router has a high response time.",
       "choice_c":"The distant router is responding.",
       "choice_d":"The distant router has a low response time.",
       "correct_answer":"C",
       "explanation":"When you\u0027re using the <code>ping</code> command, the exclamation marks signify that the ping was successful and the router is responding. If the distant router is not responding, you will see period marks. A high or low response time cannot be identified with the <code>ping</code> command."
    },
    {
       "id":505,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"You need to create a route for a network of 192.168.4.0/24 through the gateway of serial 0/1 on a 2621 router. Which is the proper command?",
       "choice_a":"<code>Router(config)#ip route 192.168.4.0/24 serial 0/1</code>",
       "choice_b":"<code>Router(config)#ip route 192.168.4.0 255.255.255.0 serial 0/1</code>",
       "choice_c":"<code>Router(config)#ip route 192.168.4.0/24 interface serial 0/1</code>",
       "choice_d":"<code>Router(config)#ip route Router(config-rtr)#192.168.4.0/24 serial 0/1</code>",
       "correct_answer":"B",
       "explanation":"The correct command sequence is <code>ip route</code> followed by the network ID, the subnet mask, and then the gateway. In this case, the gateway is a serial line. The command <code>ip route 192.168.4.0/24 serial 0/1</code> is incorrect. The command <code>ip route 192.168.4.0/24 interface serial 0/1</code> is incorrect. The command <code>ip route Router(config-rtr)#192.168.4.0/24 serial 0/1</code> is incorrect."
    },
    {
       "id":506,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"You type into the router <code>ip default-gateway 192.168.11.2.</code> Why will traffic not route out the default gateway?",
       "choice_a":"The <code>ip default-network</code> needs to be used in conjunction with <code>ip default-gateway 192.168.11.2.</code>",
       "choice_b":"The command is only used for the management plane of the router itself.",
       "choice_c":"The command is used for dynamic routing only.",
       "choice_d":"The specified gateway is wrong.",
       "correct_answer":"B",
       "explanation":"The command <code>ip default-gateway</code> allows the management plane of the router to egress the network in which the router is configured upon through a different gateway. The command of <code>ip default-gateway</code> is not used for dynamic routing; it is strictly used for the management traffic of the router. Although the specified gateway could be wrong, correcting it will not allow for the routing of data, only management traffic."
    },
    {
       "id":507,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"In the following exhibit, which route statement needs to be configured on Router A to allow routing to Network B? <img src='/question_assets/ccna/3_image8.png'></img>",
       "choice_a":"<code>RouterA(config)#ip route 192.168.3.0 255.255.255.0 serial 0/1</code>",
       "choice_b":"<code>RouterA(config)#ip route 192.168.3.0 255.255.255.0 192.168.2.1</code>",
       "choice_c":"<code>RouterA(config)#ip route 192.168.3.0 255.255.255.0 192.168.2.2</code>",
       "choice_d":"<code>RouterA(config)#ip route 192.168.3.0 255.255.255.0 192.168.3.1</code>",
       "correct_answer":"C",
       "explanation":"Router A needs to be pointed to the adjacent router\u0027s far IP address. Imagine a hall with two doors; one door leads to Network A and the other leads to Network B. To get to Network B, you need to get to the router\u0027s IP interface (door). The command <code>ip route 192.168.3.0 255.255.255.0 serial 0/1</code> is incorrect. The command <code>ip route 192.168.3.0 255.255.255.0 192.168.2.1</code> is incorrect. The command <code>ip route 192.168.3.0 255.255.255.0 192.168.3.1</code> is incorrect."
    },
    {
       "id":508,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"When you configure an IP address on a router interface, what happens to the routing table?",
       "choice_a":"The router creates a /32 route for the IP address.",
       "choice_b":"The router creates a summary address for the network.",
       "choice_c":"The router creates a routing update if dynamic routing is configured.",
       "choice_d":"All of the above.",
       "correct_answer":"D",
       "explanation":"When an IP address of 192.168.1.1/24 is configured, for example, the router will create a summary route for 192.168.1.0/24 as well as a route for 192.168.1.1/32. Both of these changes to the routing table will trigger an update depending on which dynamic routing protocol is being used."
    },
    {
       "id":509,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":4,
       "question":"You want to verify the IP addresses configured on the router. Which command will you use?",
       "choice_a":"<code>Router#show ip</code>",
       "choice_b":"<code>Router#show ip interfaces brief</code>",
       "choice_c":"<code>Router#show interfaces</code>",
       "choice_d":"<code>Router#show ip brief</code>",
       "correct_answer":"B",
       "explanation":"The command <code>show ip interfaces brief</code> will display all of the interfaces and their configured IP addresses. The command <code>show ip</code> is incorrect. The command show interfaces is incorrect. The command <code>show ip brief</code> is incorrect."
    },
    {
       "id":510,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":5,
       "question":"You configure a brand-new IP address on a new router\u0027s interface. However, when you look at the routing table, it does not show up. You see a link light on the interface. What is wrong?",
       "choice_a":"The interface is administratively shut down.",
       "choice_b":"The interface speed is incorrect.",
       "choice_c":"The interface bandwidth is not set.",
       "choice_d":"The route will not show up until you save the config.",
       "correct_answer":"A",
       "explanation":"A route for the interface will not be populated in the routing table until the interface is in an up/up status. If the link was disconnected, this would create the same symptoms. Although the speed could be incorrect, the route would still be populated in the route table. Setting the bandwidth on an interface will only help routing protocols such as EIGRP make better route decisions. Saving the configuration will have no effect on route entries in the route table."
    },
    {
       "id":511,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"What is a benefit of static routing?",
       "choice_a":"Adding networks is an easy task for network administrators.",
       "choice_b":"It is suited for large networks because changes will not disturb routing.",
       "choice_c":"It reduces bandwidth used by router-to-router communications.",
       "choice_d":"It allows for configuration by any network admin in the network.",
       "correct_answer":"C",
       "explanation":"Static routing is suited for small networks, where the central admin has a good understanding of the network layout. It does reduce router-to-router communications because the overhead of routing dynamic protocols will not use up bandwidth. Adding networks in a static routing environment can be a time-consuming task for a network administrator because of all the routers that will need to be updated. Static routing is best suited for small networks and not large networks. There is not an advantage of easy configuration or easier accessibility by any network admin with static routing."
    },
    {
       "id":512,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":1,
       "question":"Where are static routes stored?",
       "choice_a":"RAM",
       "choice_b":"Flash",
       "choice_c":"Startup configuration",
       "choice_d":"Routing database",
       "correct_answer":"C",
       "explanation":"When you configure a static route, it is temporarily stored in the running-configuration. After it is saved by using <code>copy running-config startup-config</code> it is stored in the startup configuration and can survive reboots. The startup configuration is located on the NVRAM. When a router loads, the IOS is loaded into RAM from the flash. The router will then load the startup configuration into RAM. The routing database is also held in RAM."
    },
    {
       "id":513,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"You want to route 192.168.1.0/24, 192.168.2.0/24 to a destination address of 198.43.23.2. How can you accomplish this with one route statement so that other networks are not affected?",
       "choice_a":"<code>Router(config)#ip route 192.168.0.0 255.255.0.0 198.43.23.2</code>",
       "choice_b":"<code>Router(config)#ip route 192.168.0.0 255.255.255.0 198.43.23.2</code>",
       "choice_c":"<code>Router(config)#ip route 192.168.0.0 255.255.240.0 198.43.23.2</code>",
       "choice_d":"<code>Router(config)#ip route 192.168.0.0 255.255.0.240 198.43.23.2</code>",
       "correct_answer":"C",
       "explanation":"The easiest way to accomplish this is to super-net the addresses together. The network of 192.168.0.0/30 or 255.255.240.0 would capture traffic for the range of 192.168.0.1 to 192.168.3.254. The command <code>ip route 192.168.0.0 255.255.0.0 198.43.23.2</code> is incorrect. The command <code>ip route 192.168.0.0 255.255.255.0 198.43.23.2</code> is incorrect. The command <code>ip route 192.168.0.0 255.255.0.240 198.43.23.2</code> is incorrect."
    },
    {
       "id":514,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Why would you create a second route statement to the same network using a different AD and different interface?",
       "choice_a":"If the first one fails to route to the destination, the second route will succeed.",
       "choice_b":"If the first interface goes down, the second route will become active.",
       "choice_c":"If there is a high amount of traffic on the first interface, the second route will become active.",
       "choice_d":"If there is a routing loop on the first interface, the second will overcome the loop.",
       "correct_answer":"B",
       "explanation":"Secondary routes with higher administrative distance are used for failover. If the physical interface fails, the route statement will be taken out of the routing table. Then the second route will become active. Route tables unfortunately do not adjust based upon the success or failure of a packet being routed. A router will not know to use a secondary route if the primary route fails to route a packet. If a dynamic protocol is used, such as OSPF or EIGRP, the routing protocol can sense high amounts of traffic and adjust route paths. However, statically configured routes are not managed by these dynamic routing protocols; therefore, the secondary route will not be used. A router will not be aware of routing loops; it will not respond with a change in the routing of packets."
    },
    {
       "id":515,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which route statement is configured when an IP address of 208.43.34.17/29 is configured on an interface?",
       "choice_a":"<code>S 208.43.34.17/32 is directly connected, Serial 0/0/0</code>",
       "choice_b":"<code>S 208.43.34.24/29 is directly connected, Serial 0/0/0</code>",
       "choice_c":"<code>S 208.43.34.8/29 is directly connected, Serial 0/0/0</code>",
       "choice_d":"<code>S 208.43.34.17/29 is directly connected, Serial 0/0/0</code>",
       "correct_answer":"A",
       "explanation":"The IP address of 208.43.34.17/29 belongs to the network of 208.43.34.16/29. In addition to the statement for the network that owns the IP address, the individual IP address will be configured as a local route with a /32. All other answers are incorrect."
    },
    {
       "id":516,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"In the following exhibit, which network is routable? <img src='/question_assets/ccna/3_image9.png'></img>",
       "choice_a":"The 172.30.0/16 network",
       "choice_b":"The 192.168.128.0/24 network",
       "choice_c":"The 192.168.0.0/16 network",
       "choice_d":"The 192.168.4.0/24 network",
       "correct_answer":"D",
       "explanation":"The 192.168.4.0/24 network is routable via the Serial 0/0/1 interface. There is not a route statement in the route table for the 172.30.0/16 network. There is not a route statement in the route table for the 192.168.128.0/24 network. There is not a route statement in the route table for the 192.168.0.0/16 network."
    },
    {
       "id":517,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"In the following exhibit, what must be configured on Router B to allow routing to Network A? <img src='/question_assets/ccna/3_image10.png'></img>",
       "choice_a":"<code>RouterB(config)#ip route 198.44.4.0/24 198.55.4.9</code>",
       "choice_b":"<code>RouterB(config)#ip route 198.44.4.0 255.255.255.0 198.55.4.10</code>",
       "choice_c":"<code>RouterB(config)#ip route 198.44.4.0 255.255.255.0 Serial 0/0</code>",
       "choice_d":"<code>RouterB(config)#ip route 198.44.4.0 255.255.255.0 Serial 0/1</code>",
       "correct_answer":"D",
       "explanation":"The route you will need should address the 198.44.4.0/24 network with the network mask of 255.255.255.0. The exit interface is Serial 0/1, which is directly connected to the other router. The command <code>ip route 198.44.4.0/24 198.55.4.9</code> is incorrect. The command <code>ip route 198.44.4.0 255.255.255.0 198.55.4.10</code> is incorrect. The command <code>ip route 198.44.4.0 255.255.255.0 Serial 0/0</code> is incorrect."
    },
    {
       "id":518,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which route statement is configured when an IP address of 194.22.34.54/28 is configured on an interface?",
       "choice_a":"<code>S 194.22.34.48/28 is directly connected, Serial 0/0/0</code>",
       "choice_b":"<code>S 194.22.34.64/28 is directly connected, Serial 0/0/0</code>",
       "choice_c":"<code>S 194.22.34.54/28 is directly connected, Serial 0/0/0</code>",
       "choice_d":"<code>S 194.22.34.32/28 is directly connected, Serial 0/0/0</code>",
       "correct_answer":"A",
       "explanation":"The IP address of 194.22.34.54/28 belongs to the network of 194.22.34.48/28. All other answers are incorrect."
    },
    {
       "id":519,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which command will create a default route through Serial 0/0 for IPv6?",
       "choice_a":"<code>Router(config)# ip route 0.0.0.0 0.0.0.0 serial 0/0</code>",
       "choice_b":"<code>Router(config)# ipv6 route 0.0.0.0 0.0.0.0 serial 0/0</code>",
       "choice_c":"<code>Router(config)# ipv6 route ::/0 serial 0/0</code>",
       "choice_d":"<code>Router(config)# ip route ::/0 serial 0/0</code>",
       "correct_answer":"C",
       "explanation":"When entering IPv6 routes. you must use the command ipv6 route. It is then followed by the IPv6 prefix and mask and then the gateway. The default route would be <code>ipv6 route ::/0 serial 0/0.</code> The command <code>ip route 0.0.0.0 0.0.0.0 serial 0/0</code> is incorrect because it\u0027s specific to IPv4. The command <code>ipv6 route 0.0.0.0 0.0.0.0 serial 0/0</code> is incorrect because it\u0027s a mix of IPv6 and IPv4. The command <code>ip route ::/0 serial 0/0</code> is incorrect because it\u0027s a mixture of IPv4 and IPv6."
    },
    {
       "id":520,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":4,
       "question":"Which command would configure the route for an IPv6 network of FC00:0:0:1 with the exit interface of serial 0/0/0?",
       "choice_a":"<code>Router(config)#ip route fc00:0:0:1 serial 0/0/0</code>",
       "choice_b":"<code>Router(config)#ipv6 route fc00:0:0:1/64 serial 0/0/0</code>",
       "choice_c":"<code>Router(config)#ip route fc00:0:0:1/64 serial 0/0</code>",
       "choice_d":"<code>Router(config)#ipv6 route fc00:0:0:1 serial 0/0/0</code>",
       "correct_answer":"B",
       "explanation":"When configuring an IPv6 route, you use the <code>ipv6 route</code> command. You then must specify the network and mask using CIDR notation. Last, you specify the exit interface or next hop of <code>serial 0/0/0.</code> The complete command will be <code>ipv6 route fc00:0:0:1/64 serial 0/0/0.</code> The command <code>ip route fc00:0:0:1 serial 0/0/0</code> is incorrect because it\u0027s a mixture of IPv4 and IPv6. The command <code>ip route fc00:0:0:1/64 serial 0/0</code> is incorrect because it\u0027s a mixture of IPv4 and IPv6. The command <code>ipv6 route fc00:0:0:1 serial 0/0/0</code> is incorrect because it is missing the subnet mask."
    },
    {
       "id":521,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":5,
       "question":"In the following exhibit, which interface or IP address will a packet be routed to with a destination address of 192.168.5.6? <img src='/question_assets/ccna/3_image11.png'></img>",
       "choice_a":"IP address of 192.168.4.2",
       "choice_b":"IP address of 192.168.4.5",
       "choice_c":"Interface Serial 0/0/1",
       "choice_d":"Interface Serial 0/2/0",
       "correct_answer":"A",
       "explanation":"The packet will be routed to the IP address of 192.168.4.2. This will occur because the administrative distance is lower than the route for the gateway of 192.168.4.5. Interface Serial 0/0/1 and Interface Serial 0/2/0 will not be used because no matching route exists in the route table."
    },
    {
       "id":522,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"What is the purpose of issuing the command <code>no switchport</code> on a layer 3 switch?",
       "choice_a":"It configures an SVI.",
       "choice_b":"It configures an access port.",
       "choice_c":"It configures a trunk port.",
       "choice_d":"It configures a port as a routed interface.",
       "correct_answer":"D",
       "explanation":"The command <code>no switchport</code> does the opposite of configuring a port as a switch port. It turns the port into a routed interface in which an IP address can be configured. A Switched Virtual Interface is created when a VLAN interface is created and it is not related to a switch port. An access port is configured with the <code>switchport mode access</code> command. A trunk port is configured with the <code>switchport mode trunk</code> command."
    },
    {
       "id":523,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"You need to configure a router that has three interfaces to route five VLANs. What is the best way to accomplish this task?",
       "choice_a":"Purchase another router with additional interfaces.",
       "choice_b":"Configure the router as a ROAS.",
       "choice_c":"Purchase a new router with five interfaces.",
       "choice_d":"Configure a dynamic routing protocol.",
       "correct_answer":"B",
       "explanation":"Router on a stick is created by configuring a trunk between the switch and the router. ROAS will receive tagged frames and route them, then send them back down the interface to the respective connected VLAN. Although you could purchase a router with additional interfaces, this would not be the most efficient method of completing the task. Configuring a dynamic routing protocol will not accomplish this task."
    },
    {
       "id":524,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":4,
       "question":"Which command do you need to enter on a switch to allow routing between VLANs?",
       "choice_a":"<code>Switch(config)#routing</code>",
       "choice_b":"<code>Switch(config)#ip router</code>",
       "choice_c":"<code>Switch(config)#ip routing</code>",
       "choice_d":"<code>Switch(config)#ip route</code>",
       "correct_answer":"C",
       "explanation":"The <code>ip routing</code> command must be entered in global config. When this command is entered, a routing table will be created and populated. The command <code>routing</code> is incorrect. The command <code>ip router</code> is incorrect. The command <code>ip route</code> is incorrect."
    },
    {
       "id":525,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":5,
       "question":"When routing between VLANs with a router\u0027s interface, which trunking protocol is always supported?",
       "choice_a":"802.1x",
       "choice_b":"802.1Q",
       "choice_c":"ISL",
       "choice_d":"VTP",
       "correct_answer":"B",
       "explanation":"802.1Q is the trunking protocol that should be used for tagging VLANs when you are routing between VLANs on a router. 802.1x is a protocol that authenticates layer 2 communications. Inter-Switch Link (ISL) is a Cisco proprietary protocol and it\u0027s not always supported. The VLAN Trunking Protocol (VTP) is a Cisco proprietary protocol that helps propagate VLAN configuration to other switches."
    },
    {
       "id":526,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which command would configure the interface on the ROAS configuration as the native VLAN?",
       "choice_a":"<code>Router(config-subif)#switchport native vlan 2</code>",
       "choice_b":"<code>Router(config-if)#interface gi 0/1.2 native</code>",
       "choice_c":"<code>Router(config-subif)#native vlan 2</code>",
       "choice_d":"<code>Router(config-subif)#encapsulation dot1q 2 native</code>",
       "correct_answer":"D",
       "explanation":"The command <code>encapsulation dot1q 2</code> will associate the subinterface with VLAN 2. If you specify the native tag after the command, it will make this subinterface the native VLAN for the trunk. The command <code>switchport native vlan 2</code> is incorrect. The command <code>interface gi 0/1.2 native</code> is incorrect. The command <code>native vlan 2</code> is incorrect."
    },
    {
       "id":527,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which commands would you use to configure an IP address on an SVI?",
       "choice_a":"<code>Switch(config)#interface vlan 10</code><br><code>Switch(config-if)#ip address 192.168.10.1 255.255.255.0</code><br><code>Switch(config-if)#no shutdown</code>",
       "choice_b":"<code>Switch(config)#interface vlan 10</code><br><code>Switch(config-if)#ip address 192.168.10.1/24</code>",
       "choice_c":"<code>Switch(config)#interface vlan 10</code><br><code>Switch(config-if)#ip address 192.168.10.1/24</code><br><code>Switch(config-if)#no shutdown</code>",
       "choice_d":"<code>Switch(config)#vlan 10</code><br><code>Switch(config-vlan)#ip address 192.168.10.1 255.255.255.0</code><br><code>Switch(config-vlan)#no shutdown</code>",
       "correct_answer":"A",
       "explanation":"When configuring an IP address on an SVI, you must enter the interface of the VLAN. Once in the pseudo interface, you enter the <code>ip address</code> command and then enter <code>no shutdown.</code> Entering the command <code>interface vlan 10</code> and then configuring <code>ip address 192.168.10.1/24</code> will not work because the commands are not followed by a <code>no shutdown</code> command. The IP address is also entered in CIDR format and not the proper dot-decimal notation. When entering <code>vlan 10</code>, you will be placed inside the VLAN configuration prompt and not the Switched Virtual Interface."
    },
    {
       "id":528,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"When configuring ROAS, which mode must be configured for the switch port on the switch?",
       "choice_a":"Trunk mode",
       "choice_b":"Access mode",
       "choice_c":"Routed mode",
       "choice_d":"Switched mode",
       "correct_answer":"A",
       "explanation":"When you are configuring a router on a stick, the switch port of the switch must be in trunk mode. This is so that traffic can be tagged as it gets sent to the router, which will see the tag and route it accordingly by the destination IP address. In an access mode, the VLAN information is stripped from the frame before it enters or leaves the interface. In routed mode, the interface performs as a routed interface. In switched mode, the interface can perform as an access mode or trunk mode switch port."
    },
    {
       "id":529,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"When configuring the sub interfaces on a router for ROAS, what is a best practice when naming the sub interface?",
       "choice_a":"Always name the sub interface the same as the VLAN name.",
       "choice_b":"Always name the sub interface the same as the VLAN number.",
       "choice_c":"Always name the sub interface the same as the default gateway address.",
       "choice_d":"Always name the sub interface the same as the switch\u0027s interface number.",
       "correct_answer":"B",
       "explanation":"A best practice is to always name the sub interface the same as the VLAN number you are going to route. An example is if you are connected to Fa0/1 on the router and you want to create an IP address on the sub interface for VLAN 2. Then you would name the sub interface Fa0/1.2. The sub interface will not allow you to name it with a friendly name, unlike Cisco switches that allow for a friendly name to be associated with VLANs. Although you can configure a sub interface from 1 through 65535 and higher with various IOS versions, the default gateway cannot be sensibly represented. Naming the sub interface the same as the switch\u0027s interface number is not very useful in identifying the VLAN."
    },
    {
       "id":530,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which command enables the routers to direct the frames for a particular VLAN to the subinterface?",
       "choice_a":"<code>Router(config-if)#interface gi 0/1.5</code>",
       "choice_b":"<code>Router(config-subif)#vlan 5</code>",
       "choice_c":"<code>Router(config-subif)#encapsulation dot1q 5</code>",
       "choice_d":"<code>Router(config-subif)#switchport access vlan 5</code>",
       "correct_answer":"C",
       "explanation":"The command <code>encapsulation dot1q 5</code>, when configured inside of the subinterface, will program the subinterface to accept frames for VLAN 5. The command <code>interface gi 0/1.5</code> is incorrect. The command <code>vlan 5</code> is incorrect. The command <code>switchport access vlan 5</code> is incorrect."
    },
    {
       "id":531,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which command must be entered on 2960-XR switches to enable IP routing?",
       "choice_a":"<code>Switch(config)#ip lanbase</code>",
       "choice_b":"<code>Switch(config)#sdm prefer lanbase-routing</code>",
       "choice_c":"<code>Switch(config)#sdm lanbase-routing</code>",
       "choice_d":"<code>Switch(config)#sdm routing</code>",
       "correct_answer":"B",
       "explanation":"On 2960-XR switches, you must enable the Switching Database Manager (SDM) for LAN Base routing to enable routing. The switch then requires a reload before you can configure routable SVIs. The command <code>ip lanbase</code> is incorrect. The command <code>sdm lanbase-routing</code> is incorrect. The command <code>sdm routing</code> is incorrect."
    },
    {
       "id":532,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"You want to verify the configured SVI VLAN interfaces. Which command will show you the configured IP addresses on each of the SVI VLAN interfaces?",
       "choice_a":"<code>Switch#show ip interface brief</code>",
       "choice_b":"<code>Switch#show interfaces status</code>",
       "choice_c":"<code>Switch#show svi</code>",
       "choice_d":"<code>Switch#show switchports ip</code>",
       "correct_answer":"A",
       "explanation":"The same command used to verify physical interfaces on a router is used to verify SVI interfaces on a switch. The command <code>show ip interface brief</code> will pull up the configured IP address on each VLAN interface. The command <code>show interfaces status</code> is incorrect. The command <code>show svi</code> is incorrect. The command <code>show switchports ip</code> is incorrect."
    },
    {
       "id":533,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"You enter the command <code>ip address 192.168.2.0 255.255.255.0</code> on interface VLAN 2. When you enter the command, you receive a \u0022Bad mask /24 for address\u0022 error. What is the problem?",
       "choice_a":"The subnet mask is incorrect.",
       "choice_b":"The subnet of 192.168.2.0 cannot be used for this interface.",
       "choice_c":"The IP address is invalid.",
       "choice_d":"The VLAN has not been configured yet.",
       "correct_answer":"C",
       "explanation":"The command <code>ip address 192.168.2.0 255.255.255.0</code> only defines the 192.168.2.0 network. Although the subnet is correct, the statement does not specify a valid host IP address for the SVI. Nothing prevents you from using the 192.168.2.0 subnet on the SVI, but a valid IP address contained in the network must be configured. The VLAN does not need to be configured first, but it is a good idea to configure it first. The VLAN will automatically be created when the VLAN interface is configured."
    },
    {
       "id":534,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":4,
       "question":"You have purchased a layer 3 switch with the LAN Base feature. When you enter <code>ip routing</code> in global configuration mode, you receive an \u0022Invalid input detected\u0022 error. What is the problem?",
       "choice_a":"There are no IP addresses configured on the switch.",
       "choice_b":"The SDM of LAN Base routing has not been enabled.",
       "choice_c":"There is not enough memory for routing tables.",
       "choice_d":"The IP Base feature is required.",
       "correct_answer":"B",
       "explanation":"The LAN Base feature supports IP routing between SVIs. However, it must be enabled first via the Switching Database Manager (SDM) by using the <code>sdm prefer lanbase-routing</code> command. There is no prerequisite of IP addresses preconfigured before configuring the <code>ip routing</code> command. If there is not enough memory for the routing table, you will not receive an \u0022Invalid input detected\u0022 error. The IP Base feature is not required; the base license will cover IP routing."
    },
    {
       "id":535,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":5,
       "question":"You have a 3560 switch that supports layer 3 routing. You need to configure a physical interface to route a subnet. Which command needs to be used?",
       "choice_a":"<code>Switch(config-if)#switchport routed</code>",
       "choice_b":"<code>Switch(config-if)#no ip-routing</code>",
       "choice_c":"<code>Switch(config-if)#no switchport</code>",
       "choice_d":"<code>Switch(config-if)#ip address 192.168.2.1 255.255.255.0</code>",
       "correct_answer":"C",
       "explanation":"The <code>no switchport</code> command will configure a physical port of a switch to act as a routed interface. Once the physical port is configured as a non-switch port, you will be able to configure an IP address directly on the interface. The command <code>switchport routed</code> is incorrect. The command <code>no ip-routing</code> is incorrect. The command <code>ip address 192.168.2.1 255.255.255.0</code> is incorrect."
    },
    {
       "id":536,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which command will allow you to examine a switch\u0027s port to see if it is routed or switched?",
       "choice_a":"<code>Switch#show interface gi 0/2 switchport</code>",
       "choice_b":"<code>Switch#show interface gi 0/2 state</code>",
       "choice_c":"<code>Switch#show switchport interface gi 0/2</code>",
       "choice_d":"<code>Switch#show status interface gi 0/2</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show interface gi 0/2 switchport</code> will show the state of a port. It will display if the port is switched or routed among several other attributes. The command <code>show interface gi 0/2 state</code> is incorrect. The command <code>show switchport interface gi 0/2</code> is incorrect. The command <code>show status interface gi 0/2</code> is incorrect."
    },
    {
       "id":537,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"You need to configure ROAS on a router\u0027s interface to route VLAN 5 with ISL. Which command will specify the encapsulation and achieve this?",
       "choice_a":"<code>Router(config-if)#encapsulation 5</code>",
       "choice_b":"<code>Router(config-if)#encapsulation isl 5</code>",
       "choice_c":"<code>Router(config-subif)#switchport encapsulation isl 5</code>",
       "choice_d":"<code>Router(config-subif)#encapsulation isl 5</code>",
       "correct_answer":"D",
       "explanation":"The command <code>encapsulation isl 5</code> configured in the subinterface will achieve this. It specifies the encapsulation as ISL and a VLAN of 5 that it will be tagged with. The command <code>encapsulation 5</code> configured in the interface is incorrect. The command <code>encapsulation isl 5</code> configured in the interface is also incorrect. Although the command <code>switchport encapsulation isl 5</code> is configured in the correct subinterface, the command itself is incorrect."
    },
    {
       "id":538,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"You have just configured a new VLAN and have configured the SVI with an IP address and <code>no shutdown</code> command on the interface. However, when you perform a <code>show ip route</code>, it does not show a valid directly connected route for the SVI. What is the problem?",
       "choice_a":"The VLAN is in a shutdown state.",
       "choice_b":"No interfaces have been configured with the new VLAN yet.",
       "choice_c":"The <code>show ip route</code> command will not display SVI directly connected routes.",
       "choice_d":"No dynamic routing protocols have been configured.",
       "correct_answer":"B",
       "explanation":"After configuring a VLAN and the respective SVI interface, a route will not show until at least one port is configured with the new VLAN and it is in an up status. The VLAN will be taken out of a shutdown state when the command <code>no shutdown</code> is configured. The <code>show ip route</code> command will not display the SVI as a directly connected route until an interface is configured with the VLAN. Dynamic routing protocols are not a prerequisite for configuring SVIs."
    },
    {
       "id":539,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which of the following is a correct statement about ROAS?",
       "choice_a":"Using a ROAS is a highly efficient alternative to routed SVIs.",
       "choice_b":"Using a ROAS is a cheaper alternative to inter-VLAN routing on a switch.",
       "choice_c":"A ROAS can only be used with 802.1Q.",
       "choice_d":"A ROAS is limited to a maximum of 16 routes.",
       "correct_answer":"B",
       "explanation":"Using router on a stick is a cheaper alternative to IVR if the current switch does not support layer 3 routing. Using a ROAS is highly inefficient because all traffic that is routed to the router must be routed back, diminishing the bandwidth of the link by 50 percent. A ROAS can be used with ISL or 802.1Q. A ROAS is not limited to a maximum of 16 routes."
    },
    {
       "id":540,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Before configuring ROAS, which command should be entered in the interface connecting to the switch?",
       "choice_a":"<code>Router(config-if)#ip routing</code>",
       "choice_b":"<code>Router(config-if)#no ip address</code>",
       "choice_c":"<code>Router(config-if)#ip encapsulation dot1q</code>",
       "choice_d":"<code>Router(config-if)#sdm routing</code>",
       "correct_answer":"B",
       "explanation":"When configuring ROAS on a router\u0027s interface, you should always issue the <code>no ip address</code> command. No IPs can be configured on the main interface. All IPs are configured on the subinterfaces. The command <code>ip routing</code> is incorrect. The command <code>ip encapsulation dot1q</code> is incorrect. The command <code>sdm routing</code> is incorrect."
    },
    {
       "id":541,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"You have configured a ROAS and set up the switch to connect to the router. However, you cannot route between VLANs. Which command would you use on the switch to verify operations?",
       "choice_a":"<code>Switch#show ip route</code>",
       "choice_b":"<code>Switch#show interface status</code>",
       "choice_c":"<code>Switch#show interface trunk</code>",
       "choice_d":"<code>Switch#show switchport</code>",
       "correct_answer":"C",
       "explanation":"Verifying the proper operation of the switch would start with verifying that the port is correctly set as a trunk to the router. If it is not set as a trunk, it would not be able to tag frames for the router to direct to the proper interfaces. The command <code>show ip route</code> is incorrect. The command <code>show interface status</code> is incorrect. The command <code>show switchport</code> is incorrect."
    },
    {
       "id":542,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"When configuring a router in a ROAS configuration, which command will enable the interface to accept frames tagged for VLAN 10?",
       "choice_a":"<code>Switch(config-subif)#encapsulation vlan 10 dot1q</code>",
       "choice_b":"<code>Switch(config-if)#interface Fa 0/0.10</code>",
       "choice_c":"<code>Switch(config-subif)#encapsulation dot1q 10</code>",
       "choice_d":"<code>Switch(config-subif)#ip address 192.168.10.1 255.255.255.0</code>",
       "correct_answer":"C",
       "explanation":"When you\u0027re configuring a router interface to accept VLAN tagging, the sub interface numbering does not matter. It is recommended that the sub interface match the VLAN for readability. However, <code>encapsulation dot1q 10</code> is the command that allows the sub interface to accept the frames for VLAN 10. The command <code>encapsulation vlan 10 dot1q</code> is incorrect. The command <code>interface Fa 0/0.10</code> is incorrect. The command <code>ip address 192.168.10.1 255.255.255.0</code> is incorrect."
    },
    {
       "id":543,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which statement is correct about ARP in relation to ROAS?",
       "choice_a":"Each physical interface has a unique MAC address, which responds to ARP requests.",
       "choice_b":"Each subinterface has a unique MAC address, which responds to ARP requests.",
       "choice_c":"Each IP address has a unique MAC address, which responds to ARP requests.",
       "choice_d":"All of the above.",
       "correct_answer":"A",
       "explanation":"When ROAS is implemented, only the physical interface has a unique MAC address. All ARP requests for the IP addresses configured on the subinterfaces respond with the same MAC address. They are not unique MAC addresses, but on each VLAN they are unique in the sense that no other machines on the VLAN share the same MAC address."
    },
    {
       "id":544,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which statement is correct about implementing ROAS?",
       "choice_a":"Each IP address is configured on the subinterface as the gateway for the VLAN.",
       "choice_b":"The main interface must be configured with the summary IP address for all VLANs.",
       "choice_c":"You must configure at least one native VLAN.",
       "choice_d":"All of the above.",
       "correct_answer":"A",
       "explanation":"Each IP address on a subinterface is the routed gateway for the VLAN on that subinterface. The main interface should be configured with the <code>no ip address</code> command when ROAS is configured. The default native VLAN of 1 is configured on the switch side only unless you explicitly configure a native VLAN on the router."
    },
    {
       "id":545,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":4,
       "question":"Which routing technique is a type of static routing?",
       "choice_a":"OSPF routing",
       "choice_b":"EIGRP routing",
       "choice_c":"Default routing",
       "choice_d":"RIP routing",
       "correct_answer":"C",
       "explanation":"Default routing is a form of static routing. It is used on the edge of a network to direct all traffic to the inner core of the network. OSPF routing is a dynamic routing protocol. EIGRP is a dynamic routing protocol. RIP is a dynamic routing protocol."
    },
    {
       "id":546,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":5,
       "question":"Which is an advantage of using static routing?",
       "choice_a":"There is less administrative overhead.",
       "choice_b":"It is extremely secure.",
       "choice_c":"It can create resiliency in a network.",
       "choice_d":"It is extremely scalable without issues.",
       "correct_answer":"B",
       "explanation":"Static routing is extremely secure because it does not need to broadcast or multicast routing updates. These updates can be intercepted or injected into a network to create problems. Static routing requires a higher degree of administrative overhead because all possible routes must be configured and maintained manually. All routing protocols have the potential to create resiliency on a network. Static routing is not scalable because it is all manually entered."
    },
    {
       "id":547,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which routing technique has the lowest bandwidth overhead?",
       "choice_a":"RIP routing",
       "choice_b":"OSPF routing",
       "choice_c":"EIGRP routing",
       "choice_d":"Static routing",
       "correct_answer":"D",
       "explanation":"Static routing has the lowest bandwidth overhead because there is no bandwidth required to maintain static routes. RIP routing has the highest bandwidth overhead because it uses either broadcasts or multicasts to transmit the entire routing table. OSPF and EIGRP routing both have higher bandwidth overhead than static routing."
    },
    {
       "id":548,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which type of routing technique allows for route summarization to be computed automatically by routers?",
       "choice_a":"Dynamic routing",
       "choice_b":"Directly connected routes",
       "choice_c":"Default routing",
       "choice_d":"Static routing",
       "correct_answer":"A",
       "explanation":"Most dynamic routing protocols will summarize routes. They do this for efficiency, so the least number of route statements will need to exist in the routing table. Directly connected routes do not perform auto-summarization. Default routing is a technique of sending all traffic that does not specifically match to a default router interface. Static routing requires manual intervention, and because of this, it does not auto-summarize."
    },
    {
       "id":549,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which routing technique requires administrator intervention when a route goes down?",
       "choice_a":"Dynamic routing",
       "choice_b":"Directly connected routes",
       "choice_c":"Default routing",
       "choice_d":"Static routing",
       "correct_answer":"D",
       "explanation":"Static routing requires administrator intervention when a route goes down. Dynamic routing will automatically update routes when a route goes down. Directly connected routes will be pulled out of the routing table if the link goes down. Default routing is generally used for stub networks where the only route out of the network is the default route."
    },
    {
       "id":550,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"You have several routes configured on a router. Which command will show only the static routes?",
       "choice_a":"<code>Router#show static routes</code>",
       "choice_b":"<code>Router#show ip static routes</code>",
       "choice_c":"<code>Router#show ip routes static</code>",
       "choice_d":"<code>Router#show ip routes</code>",
       "correct_answer":"C",
       "explanation":"The <code>show ip routes static</code> command will display all of the routes that are configured as static routes. The command <code>show static routes</code> is incorrect. The command <code>show ip static routes</code> is incorrect. The command <code>show ip routes</code> is incorrect."
    },
    {
       "id":551,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"On interface Serial 0/1, you type <code>ipv6 address 2000:db8:4400:2300::1234/64</code>. Which statement is true?",
       "choice_a":"The router will calculate a network ID of 2000:0db8::.",
       "choice_b":"The IPv6 address of 2000:0db8:4400:2300:1234:0000:0000:0000/128 will be assigned to Serial 0/0.",
       "choice_c":"The router will calculate a network ID of 2000:0db8:4400:2300::/64 for Serial 0/0.",
       "choice_d":"The router will calculate a network ID of 2000:db8:4400:2300:0000/64 for Serial 0/0.",
       "correct_answer":"C",
       "explanation":"The network ID of 2000:0db8:4400:2300::/64 will be calculated and assigned to the directly connected route of Serial 0/0. The network ID will not be shortened to 2000:0db8:: because there is a network of /64 defined. The IPv6 address of 2000:0db8:4400:2300:1234:0000:0000:0000/128 will not be assigned to Serial 0/0 because it is a network ID. The network ID should be 2000:0db8:4400:2300::/64; therefore, 2000:db8:4400:2300:0000/64 is a wrong answer."
    },
    {
       "id":552,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"When you check the IPv6 addresses configured on the interfaces, you find two IPv6 addresses: One address is a 2001:db8::/64 address, and the other is an ff80::/64 address. However, you do not see a route statement for the ff80::/64 address in the routing table. Why?",
       "choice_a":"Multicast addresses do not get added to the routing tables.",
       "choice_b":"Link-local addresses do not get added to the routing tables.",
       "choice_c":"Only one route statement can be in the routing table at a time for an interface.",
       "choice_d":"Broadcast addresses do not get added to the routing tables.",
       "correct_answer":"B",
       "explanation":"The second address on an interface with the prefix of ff80::/64 is the link-local address for Duplicate Address Detection (DAD) and Stateless Address Autoconfiguration (SLAAC). Link-local addresses are non-routable, so they will not get added to the routing table. Multicast addresses will not get added to the routing tables, but this would not explain why the statement does not appear in the route table. Multiple route statements can be active for a particular interface. Broadcast addresses will not get added to the routing tables, but this would not explain why the statement does not appear in the route table."
    },
    {
       "id":553,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"In the following exhibit, RIP is running on all of the routers. On Router A, you want to make sure that if Router B fails, a backup route is used through Router C to Network B. Which statement will achieve this? <img src='/question_assets/ccna/3_image12.png'></img>",
       "choice_a":"<code>RouterA(config)#ip route 192.168.2.8 255.255.255.252 192.168.2.6</code>",
       "choice_b":"<code>RouterA(config)#ip route 192.168.3.0 255.255.255.0 192.168.2.6 220</code>",
       "choice_c":"<code>RouterA(config)#ip route 192.168.3.0 255.255.255.0 192.168.2.6 90</code>",
       "choice_d":"<code>RouterA(config)#ip route 192.168.3.0 255.255.255.0 192.168.2.10</code>",
       "correct_answer":"B",
       "explanation":"The backup route to network 192.168.3.0/24 is though the gateway of 192.168.2.6. However, the administrative distance of a normal static route is 1. So the AD must be higher than RIP, which is 120. An AD of 220 is higher than 90, so the RIP route will be the main route and the static route will become the backup floating route. The command <code>ip route 192.168.2.8 255.255.255.252 192.168.2.6</code> is incorrect because the AD is not higher than 90. The command <code>ip route 192.168.3.0 255.255.255.0 192.168.2.6 90</code> is incorrect because the AD is 90. The command <code>ip route 192.168.3.0 255.255.255.0 192.168.2.10</code> is incorrect."
    },
    {
       "id":554,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":4,
       "question":"In the following exhibit, which command on Router B will allow hosts on Network B to reach the Internet? <img src='/question_assets/ccna/3_image13.png'></img>",
       "choice_a":"<code>RouterB(config-if )#ipv6 address default</code>",
       "choice_b":"<code>RouterB(config)#ip route ::/0 serial 0/3/0</code>",
       "choice_c":"<code>RouterB(config-if)#ipv6 address autoconfig default</code>",
       "choice_d":"<code>RouterB(config-if)#ipv6 address slaac</code>",
       "correct_answer":"C",
       "explanation":"The command <code>ipv6 address autoconfig default</code> configures the interface of Serial 0/3/0 with an IP address via SLAAC. When the default subcommand is used, it allows the router to inherit the default route discovered via NDP RS/RA messages. The command <code>ipv6 address default</code> is incorrect. The command <code>ip route ::/0 serial 0/3/0</code> is incorrect. The command <code>ipv6 address slaac</code> is incorrect."
    },
    {
       "id":555,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":5,
       "question":"You have RIPv2 configured on an Internet-facing router. Which command will propagate the default route to all other RIPv2 routers?",
       "choice_a":"<code>Router(config-router)#network 0.0.0.0</code>",
       "choice_b":"<code>Router(config-router)#default-route advertise</code>",
       "choice_c":"<code>Router(config-router)#network 0.0.0.0 default</code>",
       "choice_d":"<code>Router(config-router)#default-information originate</code>",
       "correct_answer":"D",
       "explanation":"The command <code>default-information originate</code> will advertise the default route to all other RIPv2 routers. The command <code>network 0.0.0.0</code> is incorrect. The command <code>default-route advertise</code> is incorrect. The command <code>network 0.0.0.0 default</code> is incorrect."
    },
    {
       "id":556,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"You need to implement default routing. Which command will help you achieve this?",
       "choice_a":"<code>RouterA(config)#ip default-network 192.168.2.6</code>",
       "choice_b":"<code>RouterA(config)#ip route default-gateway 192.168.2.6</code>",
       "choice_c":"<code>RouterA(config)#ip route 0.0.0.0 0.0.0.0 192.168.2.6</code>",
       "choice_d":"<code>RouterA(config)#ip route 0.0.0.0 255.255.255.255 192.168.2.6</code>",
       "correct_answer":"C",
       "explanation":"The correct command to implement a default route for routing is <code>ip route 0.0.0.0 0.0.0.0 192.168.2.6</code>. The command <code>ip default-network 192.168.2.6</code> is incorrect. The command <code>ip route default-gateway 192.168.2.6</code> is incorrect. The command <code>ip route 0.0.0.0 255.255.255.255 192.168.2.6</code> is incorrect."
    },
    {
       "id":557,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"You ping a distant router in your network and find that the TTL returned in 252. What can you conclude?",
       "choice_a":"The ping took 252 milliseconds.",
       "choice_b":"The ping has a delay of 252 milliseconds.",
       "choice_c":"The ping moved through 252 routers.",
       "choice_d":"The ping moved through 3 routers.",
       "correct_answer":"D",
       "explanation":"You can conclude the ping packet was routed through 3 routers, because the default TTL is 255. If the packet started with a TTL of 255 and a TTL of 252 was reported, 3 routers routed the ping packet (255 – 252 = 3). Time has nothing to do with TTL; therefore, the time and delay are not reported in the resultant TTL. The TTL decrements by one as the packet is routed by each router to its destination. Therefore, the answer of 252 routers is invalid."
    },
    {
       "id":558,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":"",
       "question":"Which command would you use so that you can view only the RIP route entries in the route table?",
       "choice_a":"<code>RouterA#show ip rip</code>",
       "choice_b":"<code>RouterA#show ip route</code>",
       "choice_c":"<code>RouterA#show ip rip route</code>",
       "choice_d":"<code>RouterA#show ip route rip</code>",
       "correct_answer":"D",
       "explanation":"The command <code>show ip route rip</code> will display only the route entries for the RIP protocol that exist in the route table. Always remember that the Cisco commands should be from left to right least specific to most specific; therefore, <code>show ip</code> pertains to the IPv4 stack, <code>route</code> pertains to the route table, and <code>rip</code> specifies only those entries in the table. The command <code>show ip rip</code> is incorrect. The command <code>show ip route</code> is incorrect. The command <code>show ip rip route</code> is incorrect."
    },
    {
       "id":559,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which protocol is a true link-state protocol?",
       "choice_a":"RIP",
       "choice_b":"OSPF",
       "choice_c":"EIGRP",
       "choice_d":"BGP",
       "correct_answer":"B",
       "explanation":"Open Shortest Path First (OSPF) is a true link-state protocol. Link-state protocols keep track of the state of the links as well as the bandwidth the links report. Routing Information Protocol (RIP) is a distance-vector routing protocol. Enhanced Interior Gateway Routing Protocol (EIGRP) is a hybrid routing protocol. Border Gateway Protocol (BGP) is a path-vector routing protocol."
    },
    {
       "id":560,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which dynamic routing protocol uses the Dijkstra routing algorithm?",
       "choice_a":"RIP",
       "choice_b":"EIGRP",
       "choice_c":"OSPF",
       "choice_d":"BGP",
       "correct_answer":"C",
       "explanation":"The Dijkstra algorithm is used by OSPF to calculate the shortest path based on a cost calculation of the bandwidth of the link vs. distance vector, which is based on hop count. RIP uses the Bellman-Ford algorithm to calculate distance. EIGRP uses the diffusing update algorithm (DUAL) to calculate a best route. BGP uses the best path algorithm to determine the best path for a packet."
    },
    {
       "id":561,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Why don\u0027t link-state protocols suffer from routing loops as a distance-vector protocols do?",
       "choice_a":"Link-state protocols require routers to maintain their own topology database of the network.",
       "choice_b":"Link-state protocols share the topology database among all routers.",
       "choice_c":"Link-state protocols allow routers to maintain a link-state database of all routers.",
       "choice_d":"Link-state protocols use multiple routes to the same destination.",
       "correct_answer":"A",
       "explanation":"Link-state protocols such as OSPF require all routers to maintain their own topology database of the network. This topology database is why routing loops are less likely to occur. Distance-vector protocols don\u0027t really have a topology of the network and thus suffer from routing loops. Each router is responsible for maintaining its own topology database and therefore does not share its topology. A router will only create a neighbor database for the neighboring routers, and OSPF will not track the state of all other routers as well. Link-state protocols can use multiple routes to the same destination, but by default, only one successive route will be entered in the route table."
    },
    {
       "id":562,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"What is an advantage of a link-state dynamic routing protocol?",
       "choice_a":"The only metric needed is hop count.",
       "choice_b":"Link-state dynamic routing protocols support CIDR and VLSM.",
       "choice_c":"OSPF requires only a small amount of resources such as CPU and RAM.",
       "choice_d":"Link-state dynamic routing protocols use triggered updates for recalculation of routing tables.",
       "correct_answer":"D",
       "explanation":"OSPF employs link-state advertisement (LSA) flooding and triggered updates. When these occur, every participating router will recalculate its routing tables. Link-state routing protocols do not use hop count as a metric. Link-state routing protocols support CIDR and VLSM, but all other routing protocols also support CIDR and VLSM; therefore, it is not an advantage. OSPF requires a rather large amount of CPU and RAM to calculate and retain databases."
    },
    {
       "id":563,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"What type of network is best suited for a link-state routing protocol such as OSPF?",
       "choice_a":"Extremely small networks of three routers",
       "choice_b":"Networks with routers that have a limited amount of RAM and CPU",
       "choice_c":"Large hierarchical networks like global networks",
       "choice_d":"Networks within organizations with limited training of network admins",
       "correct_answer":"C",
       "explanation":"Link-state protocols such as OSPF are best suited for large hierarchical networks such as global networks since they can separate out the participating routers with areas and border area routers. Extremely small networks do not warrant the planning and maintenance of OSPF and are best suited for static routing. Networks with routers that have a limited amount of RAM and CPU are best suited for static routing. OSPF requires a network admin with the knowledge of OSPF so it is properly configured."
    },
    {
       "id":564,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":4,
       "question":"Which is an example of an interior gateway protocol that is nonproprietary?",
       "choice_a":"EGP",
       "choice_b":"OSPF",
       "choice_c":"EIGRP",
       "choice_d":"BGP",
       "correct_answer":"B",
       "explanation":"Open Shortest Path First (OSPF) is an interior gateway protocol and a nonproprietary standard. Exterior gateway protocol (EGP) is a class of protocols used externally on an organization\u0027s network. Enhanced Interior Gateway Routing Protocol (EIGRP) is a Cisco proprietary protocol. Border Gateway Protocol (BGP) is an EGP."
    },
    {
       "id":565,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":5,
       "question":"You have several sites, each with a different administrative unit, in your company. Which routing protocol should you choose?",
       "choice_a":"BGP",
       "choice_b":"OSPF",
       "choice_c":"RIPv2",
       "choice_d":"EGP",
       "correct_answer":"B",
       "explanation":"Although you have different administrative units, all of the administrative units are in the same company. In this situation, it is recommended to use an interior gateway protocol that can segment each administrative unit. OSPF will perform this requirement with the use of area IDs. Border Gateway Protocol (BGP) is an EGP used to work with different autonomous routing organizations. RIP version 2 does not have the ability to segment administrative units. Exterior gateway protocol (EGP) is a class of protocols used externally on the organizations network."
    },
    {
       "id":566,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":1,
       "question":"Which area must be present when using the OSPF routing protocol with multiple areas?",
       "choice_a":"Area 0",
       "choice_b":"Area 1",
       "choice_c":"Area 10",
       "choice_d":"Area 4",
       "correct_answer":"A",
       "explanation":"Area 0 must be present in an OSPF network. It is the backbone area and all other areas must connect to it. All other answers are incorrect."
    },
    {
       "id":567,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"In the following exhibit, what is Router A called in OSPF terminology? <img src='/question_assets/ccna/3_image14.png'></img>",
       "choice_a":"Area border router",
       "choice_b":"Autonomous system router",
       "choice_c":"Autonomous system boundary router",
       "choice_d":"Area backup router",
       "correct_answer":"C",
       "explanation":"Router A is on the boundary of the autonomous system, which OSPF manages; therefore, it is an autonomous system boundary router, or ASBR. Area border routers are routers that sit between one or more OSPF areas. Autonomous system routers are routers that sit between one or more autonomous systems. Area backup routers is  not a type of router for OSPF."
    },
    {
       "id":568,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which multicast address is used by OSPF for neighbor discovery?",
       "choice_a":"224.0.0.9",
       "choice_b":"224.0.0.5",
       "choice_c":"224.0.0.6",
       "choice_d":"224.0.0.7",
       "correct_answer":"B",
       "explanation":"OSPF uses 224.0.0.5 for neighbor discovery via link-state advertisements (LSAs). RIP version 2 uses 224.0.0.9 for routing updates. OSPF uses 224.0.0.6 for designated routers and backup designated routers. EIGRP uses 224.0.0.7 for neighboring routers."
    },
    {
       "id":569,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"In the following exhibit, what are Routers C, D, and E called in OSPF terminology? <img src='/question_assets/ccna/3_image15.png'></img>",
       "choice_a":"Area border routers",
       "choice_b":"Autonomous system routers",
       "choice_c":"Autonomous system boundary routers",
       "choice_d":"Area backup routers",
       "correct_answer":"A",
       "explanation":"Routers C, D, and E are called area border routers, or ABRs. They border both the backbone area and areas 1, 2, and 3, respectively. Autonomous system routers are routers that sit between one or more autonomous systems. Router A is on the boundary of the autonomous system, which OSPF manages; therefore, it is an autonomous system boundary router, or ASBR. Area backup routers are routers that will take over for a router covering a routing area."
    },
    {
       "id":570,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which statement is true about OSPF?",
       "choice_a":"OSPF is a distance-vector protocol.",
       "choice_b":"OSPF performs default auto-summarization.",
       "choice_c":"OSPF broadcasts changes to the routing tables.",
       "choice_d":"OSPF updates are event triggered.",
       "correct_answer":"D",
       "explanation":"OSPF updates are event triggered. These events could be a neighbor router not responding or a route going down. OSPF is a link-state protocol and not a distance-vector protocol. OSPF does not perform auto-summarization of routes. OSPF multicasts changes to links, and each router calculates changes to its own routing table."
    },
    {
       "id":571,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":4,
       "question":"How do Cisco routers determine their router ID (RID)?",
       "choice_a":"The lowest IP address configured on the loopback interfaces",
       "choice_b":"The highest IP address configured on the router",
       "choice_c":"The lowest IP address configured on the router",
       "choice_d":"The highest MAC address configured on the router",
       "correct_answer":"B",
       "explanation":"The highest IP address configured on all of the loopback interfaces is chosen first. If a loopback is not configured, then the highest IP address on an active interface is chosen. However, if a RID is statically set via the OSPF process, it will override all of the above. The RID is always the highest IP address configured, not the lowest. The MAC address is not relevant to OSPF for the calculation of the RID."
    },
    {
       "id":572,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":5,
       "question":"What is the definition of an OSPF link?",
       "choice_a":"Two routers participating in OSPF routing",
       "choice_b":"Two routers that share the same area ID",
       "choice_c":"A routed interface added to the OSPF process",
       "choice_d":"Configure a dynamic routing protocol.",
       "correct_answer":"C",
       "explanation":"A link is a routed interface that is assigned to a network and participates in the OSPF process. This link will be tracked by the OSPF process for up/down information as well as the network it is associated with. Just because two routers are participating in OSPF does not mean they form a link. Routers sharing the same area ID does not dictate that they will form a link. Autonomous system (AS) numbers are not used with OSPF; therefore, this is an incorrect answer."
    },
    {
       "id":573,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which statement is correct about adjacency with OSPF on a broadcast network (LAN)?",
       "choice_a":"An adjacency is formed between routers on the same link.",
       "choice_b":"An adjacency is formed between the designated router (DR) and every neighbor router on the same area.",
       "choice_c":"An adjacency is formed between the DR and every router in the same autonomous system.",
       "choice_d":"An adjacency is formed between the DR and every router in the same OSPF area.",
       "correct_answer":"B",
       "explanation":"Adjacencies are formed between the DR and its neighbors on the same area. This is done to ensure that all neighbor routers have the same Link State Database (LSDB). Adjacencies are not formed between routers on the same link, same autonomous system, and same OSPF area unless one is the DR and they are connected on the same LAN."
    },
    {
       "id":574,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"How is a designated router elected for OSPF?",
       "choice_a":"The DR is elected by the highest priority and highest RID in the same autonomous system.",
       "choice_b":"The DR is elected by the lowest priority and highest RID in the same area.",
       "choice_c":"The DR is elected by the lowest priority and lowest RID.",
       "choice_d":"The DR is elected by the highest priority and highest RID in the same area.",
       "correct_answer":"D",
       "explanation":"The designated router is elected by the highest priority in the same area. If the priorities are all the same, then the highest RID becomes the tiebreaker. OSPF will elect a DR for each broadcast network, such as a LAN. This is to minimize the number of adjacencies formed. A DR is never elected by the lowest priority or lowest RID."
    },
    {
       "id":575,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"In which database can you see all of the routers discovered in the OSPF network in which hello packets were sent and acknowledged?",
       "choice_a":"The routing table database",
       "choice_b":"The neighborship database",
       "choice_c":"The topological database",
       "choice_d":"The link-state database",
       "correct_answer":"B",
       "explanation":"The neighborship database is where all of the routers can be found that have responded to hello packets. The neighborship database contains all of the routers by RID, and each router participating in OSPF manages its own neighborship database. The route table database is what the router\u0027s route decisions are based upon. The topological database is the link-state database in OSPF. The link-state database contains all the active links that have been learned."
    },
    {
       "id":576,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which is a correct statement about OSPF?",
       "choice_a":"OSPF uses autonomous systems for scalability.",
       "choice_b":"OSPF uses process IDs for scalability.",
       "choice_c":"OSPF uses areas for scalability.",
       "choice_d":"OSPF uses RID for scalability.",
       "correct_answer":"C",
       "explanation":"OSPF uses areas to create a hierarchal structure for routing. This structure begins with the backbone area of 0. All other areas connect to it to form a complete autonomous system. This enables scalability with OSPF, since each area works independently. OSPF operates within an autonomous system such as an organization. OSPF uses process IDs so that OSPF can be reset by clearing the process. OSPF uses router IDs (RIDs) so that a designated router can be elected."
    },
    {
       "id":577,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":4,
       "question":"Which is an example of a broadcast (multi-access) network?",
       "choice_a":"An X.25 network",
       "choice_b":"Frame Relay",
       "choice_c":"ATM network",
       "choice_d":"A LAN",
       "correct_answer":"D",
       "explanation":"A LAN is an example of a broadcast multi-access network. All nodes in a network segment can hear a broadcast and have common access to the local area network. In OSPF, a broadcast (multi-access) network requires a DR and BDR. An X.25 network is a legacy network connectivity method that can provide packet switching. Frame Relay by default is a nonbroadcast multi-access (NBMA) connectivity method. Asynchronous Transfer Mode (ATM) is a legacy network connectivity method that acts as an NBMA network."
    },
    {
       "id":578,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":5,
       "question":"Which multicast address is used by OSPF for communication between the DR and adjacencies formed?",
       "choice_a":"224.0.0.9",
       "choice_b":"224.0.0.5",
       "choice_c":"224.0.0.6",
       "choice_d":"224.0.0.7",
       "correct_answer":"C",
       "explanation":"The multicast address of 224.0.0.6 is used to communicate between the designated router and the adjacencies formed. This multicast address is used for LSA flooding on broadcast networks. RIP version 2 uses 224.0.0.9 for routing updates. OSPF uses 224.0.0.5 for neighbor discovery via link-state advertisements (LSAs). EIGRP uses 224.0.0.7 for neighboring routers."
    },
    {
       "id":579,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"What does the command <code>router ospf 20</code> configure?",
       "choice_a":"An OSPF router process ID of 20",
       "choice_b":"An OSPF router area of 20",
       "choice_c":"An OSPF router autonomous system of 20",
       "choice_d":"An OSPF cost of 20",
       "correct_answer":"A",
       "explanation":"The command <code>router ospf 20</code> configures a process ID of 20. This process identifies the databases for an OSPF process as well as its configuration. The process ID is only locally significant to the router on which it is configured. It can be an arbitrary number from 1 to 65535. The area for OSPF is set with the <code>network</code> command, such as <code>network 192.168.1.1 0.0.0.255 area 0</code>. Autonomous systems are not used with OSPF. Cost is not set with the <code>router ospf 20</code> command; it is set with the <code>ip ospf cost</code> command."
    },
    {
       "id":580,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which command will verify the bandwidth of an interface participating in OSPF?",
       "choice_a":"<code>Router#show ospf</code>",
       "choice_b":"<code>Router#show interface</code>",
       "choice_c":"<code>Router#show running-config</code>",
       "choice_d":"<code>Router#show ospf interface</code>",
       "correct_answer":"B",
       "explanation":"The command <code>show interface</code> will display the reported bandwidth or configured bandwidth of an interface. The command <code>show ospf interface</code> will only display the calculated cost. The command <code>show ospf</code> is incorrect. The command <code>show running-config</code> is incorrect."
    },
    {
       "id":581,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which command will tune the cost of the OSPF metrics for integration with non-Cisco routers to participate in OSPF?",
       "choice_a":"<code>Router(config-if)#ip cost 20000</code>",
       "choice_b":"<code>Router(config)#ip ospf cost 20000</code>",
       "choice_c":"<code>Router(config)#ip cost 20000</code>",
       "choice_d":"<code>Router(config-if)#ip ospf cost 20000</code>",
       "correct_answer":"D",
       "explanation":"When you\u0027re configuring Cisco routers to participate in OSPF with non-Cisco routers, each interface on the Cisco router needs to be configured. The <code>ip ospf cost</code> command can be tuned between 1 to 65,535 and will need to be matched with the other vendor. The command <code>ip cost 20000</code> is incorrect. The command <code>ip ospf cost 20000</code> is incorrect when configured in a global configuration prompt."
    },
    {
       "id":582,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which command will configure a network of 192.168.1.0/24 for OSPF area 0?",
       "choice_a":"<code>Router(config)#router ospf 0</code><br><code>Router(config-router)#network 192.168.1.0 0.0.0.255</code>",
       "choice_b":"<code>Router(config)#ospf 0</code><br><code>Router(config-router)#network 192.168.1.0 0.0.0.255</code>",
       "choice_c":"<code>Router(config)#router ospf 0</code><br><code>Router(config-router)#network 192.168.1.0 255.255.255.0</code>",
       "choice_d":"<code>Router(config)#router ospf 1</code><br><code>Router(config-router)#network 192.168.1.0 0.0.0.255 area 0</code>",
       "correct_answer":"D",
       "explanation":"The first command sets up the process ID of 1 via <code>router ospf 1</code>. The next command advertises the network of 192.168.1.0 with a wildcard-mask of 0.0.0.255 and specifies area 0 via <code>network 192.168.1.0 0.0.0.255 area 0</code>. The command <code>network 192.168.1.0 0.0.0.255</code> is incorrect as it should follow with an area number as the last argument. The <code>ospf 0</code> argument must follow after the <code>router</code> argument, such as <code>router ospf 0</code> ,which is why option B is incorrect. The command <code>network 192.168.1.0 255.255.255.0</code> is incorrect as it should follow with an area number."
    },
    {
       "id":583,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"What is the default number of equal-cost routes for OSPF on Cisco routers?",
       "choice_a":"4 routes",
       "choice_b":"8 routes",
       "choice_c":"16 routes",
       "choice_d":"32 routes",
       "correct_answer":"A",
       "explanation":"By default, Cisco routes will load-balance four equal-cost routes with OSPF. All other answers are incorrect."
    },
    {
       "id":584,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"You want to advertise a network of 131.40.32.0/27 with OSPF. Which wildcard mask will you need to use?",
       "choice_a":"255.255.224.0",
       "choice_b":"0.0.32.255",
       "choice_c":"0.0.0.31",
       "choice_d":"0.0.224.255",
       "correct_answer":"C",
       "explanation":"The wildcard mask is 0.0.0.31 for a network advertisement of 131.40.32.0/27. A wildcard mask is a bitwise calculation that matches the bits that change. The /27 has subnets with multiples of 32. The easiest way to calculate wildcard masks for configuration is to subtract 1 from the subnet you are trying to match; for example, matching a subnet of 32 in the third octet minus 1 equals 31, and you want to match all bits in the fourth octet with 255."
    },
    {
       "id":585,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which command will allow changing the number of equal-cost routes for OSPF?",
       "choice_a":"<code>Router(config)#ospf equal-cost 10</code>",
       "choice_b":"<code>Router(config-router)#ospf equal-cost 10</code>",
       "choice_c":"<code>Router(config)#ospf maximum-paths 10</code>",
       "choice_d":"<code>Router(config-router)#maximum-paths 10</code>",
       "correct_answer":"D",
       "explanation":"The command <code>maximum-paths 10</code> will configure a maximum of 10 routes of equal-cost for load balancing. This command must be entered under the OSPF router process. The command <code>ospf equal-cost 10</code> is incorrect when configured in both the global configuration prompt and the config-router prompt. The command <code>ospf maximum-paths 10</code> is incorrect when configured in a global configuration prompt."
    },
    {
       "id":586,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"What is the maximum number of equal-cost routes that can be configured for OSPF on Cisco routers?",
       "choice_a":"4 routes",
       "choice_b":"8 routes",
       "choice_c":"16 routes",
       "choice_d":"32 routes",
       "correct_answer":"D",
       "explanation":"The maximum number of equal-cost routes that can be configured for load balancing with OSPF on a Cisco router is 32. By default, Cisco routers will use 4 equal-cost routes."
    },
    {
       "id":587,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":4,
       "question":"Which command will allow you to verify the router\u0027s RID for OSPF?",
       "choice_a":"<code>Router#show ip ospf</code>",
       "choice_b":"<code>Router#show ip interface</code>",
       "choice_c":"<code>Router#show ip ospf rid</code>",
       "choice_d":"<code>Router#show ip ospf neighbor</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show ip ospf</code> will allow you to verify the currently configured router ID (RID) or the IP address acting as the router\u0027s RID. The command <code>show ip interface</code> is incorrect. The command <code>show ip ospf rid</code> is incorrect. The command <code>show ip ospf</code> neighbor is incorrect."
    },
    {
       "id":588,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":5,
       "question":"You want to advertise a network of 192.168.1.16/28 with OSPF. Which wildcard mask will you need to use?",
       "choice_a":"0.0.0.16",
       "choice_b":"255.255.255.240",
       "choice_c":"0.0.0.15",
       "choice_d":"0.0.0.240",
       "correct_answer":"C",
       "explanation":"The wildcard mask is 0.0.0.15 for a network advertisement of 192.168.1.16/28. A wildcard mask is a bitwise calculation that matches the bits that change. The /28 has subnets with multiples of 16. The easiest way to calculate wildcard masks for configuration is to subtract 1 from the subnet you are trying to match; for example, matching a subnet of 16 in the fourth octet minus 1 equals 15."
    },
    {
       "id":589,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which command will allow you to verify if a remote router has formed an adjacency with the current router?",
       "choice_a":"<code>Router#show ip ospf neighbor</code>",
       "choice_b":"<code>Router#show router adjacency</code>",
       "choice_c":"<code>Router#show ip ospf</code>",
       "choice_d":"<code>Router#show ip ospf router</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show ip ospf neighbor</code> will show all of the adjacencies formed as well as the routers discovered. The command <code>show router adjacency</code> is incorrect. The command <code>show ip ospf</code> is incorrect. The command <code>show ip ospf router</code> is incorrect."
    },
    {
       "id":590,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"What is the default OSPF hello interval in which hello packets are sent out on a broadcast (multi-access) network?",
       "choice_a":"5 seconds",
       "choice_b":"10 seconds",
       "choice_c":"30 seconds",
       "choice_d":"60 seconds",
       "correct_answer":"B",
       "explanation":"The default hello interval is 10 seconds for a broadcast (multi-access) network such as a LAN. All other answers are incorrect."
    },
    {
       "id":591,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"You are running OSPF on a router. One of the interfaces, Gi0/1, connects to your ISP. You want to make sure you do not forward any OSPF packets to your ISP. How can you achieve this?",
       "choice_a":"<code>Router(config-if)#passive-interface</code>",
       "choice_b":"<code>Router(config-router)#passive-interface gigabitethernet 0/1</code>",
       "choice_c":"<code>Router(config)#passive-interface gigabitethernet 0/1</code>",
       "choice_d":"<code>Router(config-if)#passive-interface default</code>",
       "correct_answer":"B",
       "explanation":"The command <code>passive-interface gigabitethernet 0/1</code> must be configured under the router process. This command will suppress hello packets from exiting the Gi0/1 interface. The command <code>passive-interface</code> is incorrect when it is configured inside of an interface. The command <code>passive-interface gigabitethernet 0/1</code> is incorrect when it is configured in global configuration mode. The command <code>passive-interface default</code> is incorrect."
    },
    {
       "id":592,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which command will allow you to verify the interfaces that hello packets are being sent out for OSPF?",
       "choice_a":"<code>Router#show interfaces</code>",
       "choice_b":"<code>Router#show ip routes</code>",
       "choice_c":"<code>Router#show ip ospf interface</code>",
       "choice_d":"<code>Router#show ip ospf brief</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show ip ospf interface</code> will show all interfaces in which OSPF is configured and sending hello packets. The command <code>show interfaces</code> is incorrect as it will only show the interface on the router. The command <code>show ip routes</code> is incorrect as it will show the route table. The command <code>show ip ospf brief</code> is an incorrect command."
    },
    {
       "id":593,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which command will statically set the RID for OSPF and override all others?",
       "choice_a":"<code>Router(config)#interface fa 0/1</code><br><code>Router(config-if)#ip address 192.168.1.5 255.255.255.0</code>",
       "choice_b":"<code>Router(config)#interface loopback 0</code><br><code>Router(config-if)#ip address 192.168.1.5 255.255.255.0</code>",
       "choice_c":"<code>Router(config-router)#rid 192.168.1.5</code>",
       "choice_d":"<code>Router(config-router)#router-id 192.168.1.5</code>",
       "correct_answer":"D",
       "explanation":"Although all of these are valid methods of possibly setting the router ID (RID) of the router for OSPF, the configuration of <code>router-id 192.168.1.5</code> will override all others. Entering <code>interface fa 0/1</code> and then <code>ip address 192.168.1.5 255.255.255.0</code> will configure an IP address on an interface. Entering <code>interface loopback 0</code> and then <code>ip address 192.168.1.5 255.255.255.0</code> will configure an IP address on the loopback interface 0. The command <code>rid 192.168.1.5</code> is incorrect."
    },
    {
       "id":594,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which command(s) will only allow interface Gi0/2 to send hello packets for OSPF?",
       "choice_a":"<code>Router(config-router)#active-interface gigabitethernet 0/2</code>",
       "choice_b":"<code>Router(config-router)#passive-interface default</code> <br><code>Router(config-router)#active-interface gigabitethernet 0/2</code>",
       "choice_c":"<code>Router(config-router)#passive-interface default</code> <br><code>Router(config-router)#no passive-interface gigabitethernet 0/2</code>",
       "choice_d":"<code>Router(config-router)#passive-interface gigabitethernet 0/2</code>",
       "correct_answer":"C",
       "explanation":"The command <code>passive-interface default</code> configured under the OSPF process will cease hello packets by default on all interfaces. The command <code>no passive-interface gigabitethernet 0/2</code> will allow hello packets to exit the interface and allow Gi0/2 to become a neighbor. The command <code>active-interface gigabitethernet 0/2</code> is an incorrect command. Therefore, any combination of <code>active-interface</code> is incorrect. If <code>passive-interface gigabitethernet 0/2</code> is configured, then gigabitethernet 0/2 will not send hello packets."
    },
    {
       "id":595,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"After changing the router\u0027s RID for OSPF, which command needs to be entered?",
       "choice_a":"<code>Router#clear ip ospf</code>",
       "choice_b":"<code>Router(config-router)#shutdown</code><br><code>Router(config-router)#no shutdown</code>",
       "choice_c":"<code>Router(config-router)#clear ip ospf</code>",
       "choice_d":"<code>Router#clear ospf</code>",
       "correct_answer":"A",
       "explanation":"After the OSPF configuration is changed, OSPF needs to be restarted. This is achieved at the privileged exec prompt by typing <code>clear ip ospf.</code> The router configuration prompt will not allow <code>shutdown</code> and <code>no shutdown</code> commands. The command <code>clear ip ospf</code> is incorrect. The command <code>clear ospf</code> is incorrect."
    },
    {
       "id":596,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which statement about OSPF area border routers is correct?",
       "choice_a":"ABRs sit between an autonomous system and OSPF.",
       "choice_b":"ABRs exchange Type 1 link-state advertisements between areas.",
       "choice_c":"ABRs exchange Type 2 link-state advertisements between areas.",
       "choice_d":"ABRs exchange Type 3 link-state advertisements between areas.",
       "correct_answer":"D",
       "explanation":"Type 3 link-state advertisements contain summary information about the networks on the other side of the area boarder router (ABR). These LSA announcements are called summary link advertisements, or SLAs. ABRs sit between areas within OSPF. ABRs listen to Type 1 link-state advertisements but do not exchange. ABRs listen to Type 2 link-state advertisements but do not exchange link state advertisement messages."
    },
    {
       "id":597,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"In the following exhibit, you have two areas in that you want OSPF to advertise routes for. Which command(s) will achieve this? <img src='/question_assets/ccna/3_image16.png'></img>",
       "choice_a":"<code>Router(config-router)#network 128.24.0.0/22 area 0</code><br><code>Router(config-router)#network 128.24.0.0/22 area 1</code>",
       "choice_b":"<code>Router(config-router)#network 128.24.0.0 0.0.252.255 area 0</code><br><code>Router(config-router)#network 128.24.0.0 0.0.252.255 area 1</code>",
       "choice_c":"<code>Router(config-router)#network 128.24.0.0 0.0.254.255 area 0</code><br><code>Router(config-router)#network 128.24.0.0 255.254.255 area 1</code>",
       "choice_d":"<code>Router(config-router)#network 128.24.0.0 0.0.255.255</code>",
       "correct_answer":"B",
       "explanation":"The network IDs of 128.24.0.0/24, 128.24.1.0/24, 128.24.2.0/24, and 128.24.3.0/24 can be summarized as 128.24.1.0/22. The wildcard-mask for /22 is 0.0.252.255. The commands <code>network 128.24.0.0/22 area 0</code> and <code>network 128.24.0.0/22 area 1</code> are incorrect because they requires a bitmask, not a CIDR notation. The commands <code>128.24.0.0 0.0.254.255 area 0</code> and <code>network 128.24.0.0 255.254.255 area 1</code> are incorrect because the bitmask is incorrect. The command <code>network 128.24.0.0 0.0.255.255</code> is incorrect because it does not specify the area."
    },
    {
       "id":598,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which command will allow you to see the summary of OSPF link-state advertisements?",
       "choice_a":"<code>Router#show ip ospf database</code>",
       "choice_b":"<code>Router#show ip ospf states</code>",
       "choice_c":"<code>Router#show ip ospf neighbors</code>",
       "choice_d":"<code>Router#show ip ospf topology</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show ip ospf database</code> will show you a summary count of all the LSAs in the database. The command <code>show ip ospf states</code> is incorrect. The command <code>show ip ospf neighbors</code> is incorrect. The command <code>show ip ospf topology</code> is incorrect."
    },
    {
       "id":599,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"You have configured OSPF on Router B. The network command entered was <code>network 197.234.3.0 0.0.0.63 area 0.</code> You find out that one of the interfaces is not participating in OSPF. Which interface is not participating? Refer to the following exhibit. <img src='/question_assets/ccna/3_image17.png'></img>",
       "choice_a":"Interface Serial 0/3/0",
       "choice_b":"Interface Serial 0/3/0.1",
       "choice_c":"Interface Serial 0/3/0.2",
       "choice_d":"Interface GigabitEthernet 0/0",
       "correct_answer":"D",
       "explanation":"Interface GigabitEthernet 0/0 is not participating because it is in a different network than what the wildcard mask is advertising. The wildcard mask of 0.0.0.63 is a /26 network mask with the range of 197.234.3.0 to 197.234.3.63. The interface Gi0/0 is in the 197.234.3.64/26 network and therefore will not participate."
    },
    {
       "id":600,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Two routers, called Router A and Router B, are configured in the same area and share a common LAN. However, they cannot form an adjacency. What could the problem be?",
       "choice_a":"There is a static route configured between the two routers.",
       "choice_b":"Router A is configured with multiple area IDs.",
       "choice_c":"Router A is configured with a hello timer of 30.",
       "choice_d":"Router B is configured with a hello timer of 10.",
       "correct_answer":"C",
       "explanation":"The default hello interval on a LAN is 10 seconds. If a router is configured with a hello timer of 30, the hello/dead interval will not match. In order to form an adjacency, the hello/dead intervals must match. Static routes configured between the two routers will not affect their ability to form an adjacency. Configuring routers with multiple area IDs will not affect their ability to form adjacencies."
    },
    {
       "id":601,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which is a direct benefit of a hierarchical OSPF design?",
       "choice_a":"Fast convergence",
       "choice_b":"Reduction of configuration complexity",
       "choice_c":"Increased bandwidth",
       "choice_d":"Better security",
       "correct_answer":"A",
       "explanation":"Fast convergence of the Link State Database (LSDB) that feeds the routing tables is a direct result of a hierarchical OSPF design. The use of areas allows for routers within an area to converge and send summary link advertisements to other areas. OSPF design is much more complex than static routing or other dynamic routing protocols such as RIP. Bandwidth will not be increased with the implementation of OSPF. Security does not improve with OSPF."
    },
    {
       "id":602,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"In the following exhibit, which router is the DR? <img src='/question_assets/ccna/3_image18.png'></img>",
       "choice_a":"Router C",
       "choice_b":"Router B",
       "choice_c":"Router D",
       "choice_d":"Router E",
       "correct_answer":"B",
       "explanation":"Designated routers are only elected on broadcast (multi-access) networks such as a LAN. The router with the highest IP address will become the designated router. Since Router B has IP addresses of 192.168.10.2/30, 192.168.10.5/30, and 192.168.2.1/24, it will become the DR. Router C is on a nonbroadcast multi-access (NBMA), and therefore, it will not be elected to be a designated router (DR). Router D and Router E have IP addresses of 192.168.2.2/24 and 192.168.2.3/24, respectively, which are lower than Router B\u0027s interfaces."
    },
    {
       "id":603,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"In the following exhibit, what is Router B called in this hierarchy? <img src='/question_assets/ccna/3_image19.png'></img>",
       "choice_a":"ASBR",
       "choice_b":"ABR",
       "choice_c":"DR",
       "choice_d":"BDR",
       "correct_answer":"B",
       "explanation":"Router B is called the area border router since it sits between the two areas of area 0 and area 1. An autonomous system boarder router (ASBR) is a router that sits between two or more autonomous systems, such as the Internet and an organization. A designated router (DR) is a router that is elected in a LAN to form neighborships with other routers. A backup designated router (BDR) is a router that is next in line if the DR was to fail."
    },
    {
       "id":604,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"You have configured a router with the following command. However, when you enter <code>show ip routes</code> you do not see any routes for OSPF. What is the problem? <br><code>Router(config)#router ospf 255</code><br><code>Router(config-router)#network 10.0.0.0 0.0.0.0 area 255</code>",
       "choice_a":"The process ID is incorrect.",
       "choice_b":"The area number is incorrect.",
       "choice_c":"The subnet mask is incorrect.",
       "choice_d":"The network ID is incorrect.",
       "correct_answer":"C",
       "explanation":"The subnet mask is incorrect because it should be at least 8 bits starting with 255.0.0.0 or a higher number of bits. The process ID would not affect the operation of OSPF. The area number will only affect a router if it is not participating with another bordering router or router within its area. The network ID is correct in this example, but the bitmask is incorrect."
    },
    {
       "id":605,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"In the following exhibit, Router A and Router B will not form an adjacency. What is the cause of the problem? <img src='/question_assets/ccna/3_image20.png'></img>",
       "choice_a":"The hello and dead timers do not match.",
       "choice_b":"The link is a point-to-point connection.",
       "choice_c":"The process IDs do not match.",
       "choice_d":"The area IP addresses do not match.",
       "correct_answer":"A",
       "explanation":"In order to form an adjacency, the area IDs must match as well as the hello and dead timers. If the hello timer is changed on one router, it must be changed on the other router to form an adjacency. Although the link is a point-to-point connection, the two routers will form an adjacency because it supports multicast/broadcasts. The process IDs do not need to match to form an adjacency. Areas are not configured with an IP address, therefore this is an incorrect answer."
    },
    {
       "id":606,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which state in the neighbor table indicates that the router has successfully downloaded the LSA information from a neighboring router?",
       "choice_a":"FULL state",
       "choice_b":"EXSTART state",
       "choice_c":"INIT state",
       "choice_d":"EXCHANGE state",
       "correct_answer":"A",
       "explanation":"The FULL state is only achieved after the router has created an adjacency with a neighbor router and downloaded the LSAs to form its topological database. The EXSTART state means that the DR and BDR routers have been elected and are awaiting the exchange of link state information. The INIT state is the first step in creation of an adjacency. The EXCHANGE state means that the exchange of the LSA information is in progress."
    },
    {
       "id":607,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":1,
       "question":"In the following exhibit, which is a correct statement about the neighbor ID of 192.168.2.2? <img src='/question_assets/ccna/3_image21.png'></img>",
       "choice_a":"The neighbor is having a problem forming an adjacency.",
       "choice_b":"The neighbor\u0027s OSPF process is recalculating cost.",
       "choice_c":"This router\u0027s OSPF process is recalculating cost.",
       "choice_d":"Both routers have formed an adjacency.",
       "correct_answer":"D",
       "explanation":"Both routers have formed an adjacency. However, the LSDB on each router has not yet been fully synchronized. Once the LSDBs have been synchronized, the state will become FULL and OSPF will calculate costs. The exhibit does not detail any information to conclude that the neighbors are having problems forming an adjacency. The neighbor or router OSPF recalculation of cost would not show in the <code>show ip ospf neighbor</code> output."
    },
    {
       "id":608,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"You have two links that enter the same OSPF router with the same bandwidth. You want to prefer one route over the other yet allow the second as a backup route. Which command would you use to achieve this?",
       "choice_a":"<code>Router(config-router)#ip ospf priority 25</code>",
       "choice_b":"<code>Router(config-if)#ip ospf route primary</code>",
       "choice_c":"<code>Router(config-if)#ip ospf cost 25</code>",
       "choice_d":"<code>Router(config-router)#passive interface gi 0/0</code>",
       "correct_answer":"C",
       "explanation":"The command <code>ip ospf cost 25</code> should be configured on the interface that will act as the backup route. This adjustment of cost will allow the router to prefer the other route first. The command <code>ip ospf priority 25</code> is incorrect. The command <code>ip ospf route primary</code> is incorrect. The command <code>passive interface gi 0/0</code> is incorrect."
    },
    {
       "id":609,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Referring to the following exhibit, which is a correct statement about router ID 192.168.2.2? <img src='/question_assets/ccna/3_image22.png'></img>",
       "choice_a":"It is in the process of forming an adjacency.",
       "choice_b":"It is the designated router.",
       "choice_c":"It is not participating in this OSPF area.",
       "choice_d":"It will only form an adjacency with the DR or BDR.",
       "correct_answer":"D",
       "explanation":"The router ID of 192.168.2.2 is neither a designated router nor a backup designated router. Since it is neither, it will only form an adjacency with the DR or BDR and will participate in future elections. The exhibit does not show any evidence that the router is in the process of forming an adjacency since all of the states show FULL. The DROTHER state means that the router is not a designated router or backup designated router. It is participating in OSPF because it shows up in the neighbor table for OSPF."
    },
    {
       "id":610,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Refer to the following exhibit. You want to make Router D the DR. Which command will assure that it becomes the DR? <img src='/question_assets/ccna/3_image23.png'></img>",
       "choice_a":"<code>RouterD(config-router)#ospf priority</code>",
       "choice_b":"<code>RouterD(config-if)#ip ospf priority 10</code>",
       "choice_c":"<code>RouterD(config-if)#ip address 192.168.5.2 255.255.255.0</code>",
       "choice_d":"<code>RouterD(config-if)#ip ospf cost 15</code>",
       "correct_answer":"B",
       "explanation":"The command <code>ip ospf priority 10</code> will change the interface\u0027s default priority of 1 to 10. This router will always become the designated router on the LAN. The command <code>ospf priority</code> is incorrect. The command <code>ip address 192.168.5.2 255.255.255.0</code> is incorrect. The command <code>ip ospf cost 15</code> is incorrect."
    },
    {
       "id":611,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which command will display the DR for a LAN?",
       "choice_a":"<code>Router#show ip ospf neighbor</code>",
       "choice_b":"<code>Router#show ip ospf database</code>",
       "choice_c":"<code>Router#show ip ospf dr</code>",
       "choice_d":"<code>Router#show ip ospf interface</code>",
       "correct_answer":"D",
       "explanation":"The command <code>show ip ospf interface</code> will display the interface details of each interface for OSPF. In this information, the DR and BDR router ID will be displayed. The command <code>show ip ospf neighbot</code> is incorrect. The command <code>show ip ospf database</code> is incorrect. The command <code>show ip ospf dr</code> is incorrect."
    },
    {
       "id":612,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"In the following exhibit, Router A will not form an adjacency with Router B. What is the problem? <img src='/question_assets/ccna/3_image24.png'></img>",
       "choice_a":"The hello and dead timers do not match.",
       "choice_b":"There is no designated router on the network.",
       "choice_c":"The process IDs do not match.",
       "choice_d":"The area IDs do not match.",
       "correct_answer":"D",
       "explanation":"In order to form an adjacency, the area IDs must match. In this exhibit, Router A has an area of 0 and Router B has an area of 1 configured. The hello and dead timers on both routers match at 10 seconds for the hello and 40 seconds for the dead timer. The existence of a designated router will not restrict the two routers from forming an adjacency. The process IDs do not need to match for the two routers to form an adjacency."
    },
    {
       "id":613,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"In the following exhibit, you have one OSPF area and want to populate the default route to all routers in the OSPF area. Which command would you use? <img src='/question_assets/ccna/3_image25.png'></img>",
       "choice_a":"<code>RouterA(config)#ip route 0.0.0.0 0.0.0.0 serial 0/0</code>",
       "choice_b":"<code>RouterA(config-router)#default-route originate</code>",
       "choice_c":"<code>RouterA(config-router)#default-information originate</code>",
       "choice_d":"<code>RouterA(config-router)#network 0.0.0.0 0.0.0.0 area 0</code>",
       "correct_answer":"C",
       "explanation":"The command <code>default-information originate</code> will propagate a default route originating from router 172.16.1.1. All OSPF routers will calculate their default routes back to this router. The command <code>ip route 0.0.0.0 0.0.0.0 serial 0/0</code> is incorrect. The command <code>default-route originate</code> is incorrect. The command <code>network 0.0.0.0 0.0.0.0 area 0</code> is incorrect."
    },
    {
       "id":614,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which command will set the bandwidth of an interface to 2.048 Mb/s?",
       "choice_a":"<code>Router(config-if)#bandwidth 2048</code>",
       "choice_b":"<code>Router(config-if)#bandwidth 2048000000</code>",
       "choice_c":"<code>Router(config-if)#bandwidth 2.048</code>",
       "choice_d":"<code>Router(config-if)#bandwidth 2048000</code>",
       "correct_answer":"A",
       "explanation":"Bandwidth is always specified in kilobits per second (Kb/s), so 2.048 Mb/s would be 2,048,000 bits per second, or 2,048 Kb/s. The command <code>bandwidth 2048000000</code> is incorrect because it is configured in Kb/s, not b/s, although this would be 2.048 gigabits. The command <code>bandwidth 2.048</code> is incorrect because it cannot be notated with a period. The command <code>bandwidth 2048000</code> is incorrect because it is configured in Kb/s, not b/s."
    },
    {
       "id":615,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which command would you use to make sure Router A never becomes a DR?",
       "choice_a":"<code>Router(config)#no ospf designated</code>",
       "choice_b":"<code>Router(config-router)#no ospf designated</code>",
       "choice_c":"<code>Router(config-router)#passive interface gi 0/0</code>",
       "choice_d":"<code>Router(config-if)#ip ospf priority 0</code>",
       "correct_answer":"D",
       "explanation":"All routers by default have an OSPF priority of 1. If you set the priority to 0, the router will never become a designated router. This command must be set in the interface. The command <code>no ospf designated</code> is incorrect regardless of which configuration prompt it is configured in. The command <code>passive interface gi 0/0</code> is incorrect."
    },
    {
       "id":616,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which command will configure a loopback interface with an address of 192.168.1.2/24?",
       "choice_a":"<code>Router(config)#interface loopback 0</code><br><code>Router(config-if)#ip address 192.168.1.2/24</code>",
       "choice_b":"<code>Router(config)#interface loopback 0</code><br><code>Router(config-if)#ip address 192.168.1.2 255.255.255.0</code>",
       "choice_c":"<code>Router(config)#interface loopback</code><br><code>Router(config-if)#ip address 192.168.1.2/24</code>",
       "choice_d":"<code>Router(config)#interface loopback</code><br><code>Router(config-if)#ip address 192.168.1.2 255.255.255.0</code>",
       "correct_answer":"B",
       "explanation":"The command <code>interface loopback 0</code> will configure and create a pseudo interface called loop-back 0. The loopback number must be specified, and the loopback should not overlap a loopback already configured. The command <code>ip address 192.168.1.2 255.255.255.0</code> will configure the IP address on the loopback interface. The command <code>ip address 192.168.1.2/24</code> is an incorrect command because you cannot configure CIDR notation in this prompt. When configuring loopback interfaces, you must supply a number between 0 and 1023."
    },
    {
       "id":617,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Which is a correct statement about support for OSPF on an MPLS network?",
       "choice_a":"The provider edge (PE) routers can only host area 0.",
       "choice_b":"The customer edge (CE) routers can only host area 0.",
       "choice_c":"The customer edge (CE) routers must use GRE for OSPF.",
       "choice_d":"Both the customer edge (CE) routers and the provider edge (PE) routers can participate in area 0.",
       "correct_answer":"D",
       "explanation":"Both the customer edge (CE) routers and the provider edge (PE) routers can host area 0. However, the service provider must support area 0, called the super backbone, on its PE routers since all areas must be connected to area 0. The customer chooses whether the CE participates in area 0. Although the PE and the CE can host area 0, they are not exclusively configured for area 0. The CE does not need Generic Routing Encapsulation (GRE) to support OSPF."
    },
    {
       "id":618,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"What is the default priority for Open Shortest Path First (OSPF) routers?",
       "choice_a":1,
       "choice_b":100,
       "choice_c":255,
       "choice_d":"32,768",
       "correct_answer":"A",
       "explanation":"The Open Shortest Path First (OSPF) priority for a router is a value of 1. This priority is used when electing a designated router (DR) and backup designated router (BDR). The higher the value, the higher the chances of the router becoming a DR or BDR. All other answers are incorrect."
    },
    {
       "id":619,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"You have changed the router\u0027s priority for OSPF to make the router the DR, but the router has not become a DR. What must be done to force the election?",
       "choice_a":"You must use the <code>shutdown</code> and <code>no shutdown</code> commands on the interface with the highest IP address.",
       "choice_b":"In global configuration mode, you must enter the command <code>ospf election force.</code>",
       "choice_c":"In privileged exec mode, you must enter the command <code>clear ip ospf process x.</code>",
       "choice_d":"In privileged exec mode on the DR, you must enter the command <code>clear ip ospf process x.</code>",
       "correct_answer":"D",
       "explanation":"When configuring OSPF for the designated router (DR), if you configure another router with a higher priority, the original DR will remain the current DR. OSPF does not allow for preemption, and therefore you must force the election by clearing the OSPF process on the DR. This will force the DR to relinquish its status. Using the shutdown command on the interface with the highest IP address will not restart the OSPF process. The command <code>ospf election force</code> is invalid; there is no such command. Executing the command <code>clear ip ospf process</code> on any router other than the DR will only restart the OSPF process on the router it is executed on."
    },
    {
       "id":620,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"Two routers, called Router A and Router B, are configured in the same area on Frame Relay. However, they cannot form an adjacency. What could the problem be?",
       "choice_a":"The two routers do not have the same hello timer of 30 seconds.",
       "choice_b":"Router A is configured with multiple area IDs.",
       "choice_c":"Router A is configured with a hello timer of 10.",
       "choice_d":"Router B is configured with a hello timer of 10.",
       "correct_answer":"A",
       "explanation":"In order to form an adjacency, the two neighbors must have the same hello timer of 30 seconds. The routers can be configured with multiple area IDs, and this will not affect their ability to form an adjacency. The default hello interval on a LAN is 10 seconds; for non-broadcast networks such as Frame Relay, the hello timer is 30 seconds. In order to form an adjacency, the hello and dead intervals must match."
    },
    {
       "id":621,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":"",
       "question":"What is the administrative distance for OSPF?",
       "choice_a":90,
       "choice_b":110,
       "choice_c":120,
       "choice_d":200,
       "correct_answer":"B",
       "explanation":"The administrative distance for OSPF is 110. Internal Enhanced Interior Gateway Routing Protocol (EIGRP) has an administrative distance of 90. RIP has an administrative distance of 120. Internal Boarder Gateway Protocol (BGP) has an administrative distance of 200."
    },
    {
       "id":622,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which protocol is an IEEE standard that is supported openly as a first hop redundancy protocol (FHRP)?",
       "choice_a":"Proxy ARP",
       "choice_b":"VRRP",
       "choice_c":"GLBP",
       "choice_d":"HSRP",
       "correct_answer":"B",
       "explanation":"Virtual Router Redundancy Protocol (VRRP) is an IEEE open standard that is supported freely on many router products. Proxy ARP is not considered a FHRP but is used in conjunction with FHRPs as a helper protocol. Gateway Load Balancing Protocol (GLBP) is a Cisco proprietary FHRP for load balancing multiple gateways. Hot Standby Router Protocol (HSRP) is also a Cisco Proprietary FHRP for highly available gateways."
    },
    {
       "id":623,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"In the MAC address 0000.0c07.ac0a, what is the well-known Hot Standby Router Protocol (HSRP) ID?",
       "choice_a":"0000.0c",
       "choice_b":"oc07",
       "choice_c":"0a",
       "choice_d":"07.ac",
       "correct_answer":"D",
       "explanation":"The well-known HSRP ID is 07.ac. Anytime you see the 07.ac in the second part of the MAC address along with the Cisco OUI, you can identify that HSRP is being employed. The first 24 bits of the MAC address, in this example 0000.0c, compose the default organizationally unique identifier (OUI) for Cisco. The oc07 in the MAC address is part of the OUI and part of the well-known HSRP ID. The 0a in the MAC address is the HSRP group number."
    },
    {
       "id":624,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which protocol is a Cisco Proprietary protocol for load-balancing routers?",
       "choice_a":"Proxy ARP",
       "choice_b":"VRRP",
       "choice_c":"GLBP",
       "choice_d":"HSRP",
       "correct_answer":"C",
       "explanation":"Gateway Load Balancing Protocol (GLBP) is a Cisco Proprietary protocol that supports redundancy and per-subnet load balancing. Proxy ARP is not considered a FHRP but is used in conjunction with FHRPs as a helper protocol. Virtual Router Redundancy Protocol (VRRP) is an IEEE open standard that is supported freely on many router products. Hot Standby Router Protocol (HSRP) is also a Cisco Proprietary FHRP for highly available gateways, but it does not support load balancing."
    },
    {
       "id":625,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"In the MAC address 0000.0c07.ac01, what is the HSRPv1 group number?",
       "choice_a":"0000.0c",
       "choice_b":"0c07",
       "choice_c":1,
       "choice_d":"07.ac",
       "correct_answer":"C",
       "explanation":"The HSRP group number in the MAC address 0000.0c07.ac01 is 01. After the Cisco OUI and well-known HSRP ID, the last two digits are the HSRP group identifier. The first 24 bits of the MAC address, in this example 0000.0c, compose the default organizationally unique identifier (OUI) for Cisco. The 0c07 in the MAC address is the part of the OUI and part of the well-known HSRP ID. The well-known HSRP ID is 07.ac. Anytime you see the 07.ac in the second part of the MAC address along with the Cisco OUI, you can identify that HSRP is being employed."
    },
    {
       "id":626,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"What is the default priority of HSRP?",
       "choice_a":100,
       "choice_b":110,
       "choice_c":200,
       "choice_d":10,
       "correct_answer":"A",
       "explanation":"The default priority of HSRP is 100. All other answers are incorrect."
    },
    {
       "id":627,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"What is the maximum number of HSRPv1 groups that can be created?",
       "choice_a":8,
       "choice_b":16,
       "choice_c":255,
       "choice_d":256,
       "correct_answer":"D",
       "explanation":"You can create up to 256 HSRP groups on a router. This would include group 0 to 255 for a total of 256 groups. All other answers are incorrect."
    },
    {
       "id":628,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which port and protocol are used by HSRP for communications?",
       "choice_a":"UDP/1935",
       "choice_b":"UDP/1985",
       "choice_c":"UDP/1895",
       "choice_d":"UCP/3222",
       "correct_answer":"B",
       "explanation":"HSRP routers communicate with each other on port 1985 using UDP. All other answers are incorrect."
    },
    {
       "id":629,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which statement is correct about HSRP?",
       "choice_a":"All routers in an HSRP group are active.",
       "choice_b":"Only one router in an HSRP group can be active.",
       "choice_c":"The virtual router sends hello packets to the HSRP group.",
       "choice_d":"HSRP allows for per-packet load balancing.",
       "correct_answer":"B",
       "explanation":"Only one router can be active at a time in an HSRP group. All other routers are standby routers, until the active router fails. There is only one active router in an HSRP group; all other routers in the HSRP group are in a standby mode. The virtual router does not send hello packets to the HSRP group; each HSRP member sends its own hello packets. HSRP does not allow for per-packet load balancing; GLBP can load balance on a per-packet basis."
    },
    {
       "id":630,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"What type of communication is used between HSRP members?",
       "choice_a":"Unicast",
       "choice_b":"Broadcast",
       "choice_c":"Multicast",
       "choice_d":"Layer 2 flooding",
       "correct_answer":"C",
       "explanation":"HSRP uses multicasting to communicate among HSRP group members. For HSRPv1, the address is 224.0.0.2, and for HSRPv2, the address is 224.0.0.102. Unicast is an incorrect answer, although most of the communication flowing through HSRP is unicast traffic. Broadcasts are dropped by routers, and HSRP is not different from this aspect. Layer 2 flooding is a technique used by switches to discover hosts, and it is not used by HSRP."
    },
    {
       "id":631,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"When a host sends an outgoing packet to an HSRP group, which router provides the destination address for the default gateway?",
       "choice_a":"Virtual router",
       "choice_b":"Active router",
       "choice_c":"Standby router",
       "choice_d":"Monitor router",
       "correct_answer":"A",
       "explanation":"The virtual router is responsible for host communications such as an ARP request for the host\u0027s default gateway. Technically, this is served by the active router since it is hosting the virtual router. However, it is the virtual router\u0027s IP address and MAC address that are used for outgoing packets. The standby router will not respond unless the active router is down; then the standby will become the active router. A monitor router is a router that is not participating in HSRP."
    },
    {
       "id":632,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which timer must expire for a standby router in an HSRP group to become the active router?",
       "choice_a":"Hello timer",
       "choice_b":"Standby timer",
       "choice_c":"Hold timer",
       "choice_d":"Virtual timer",
       "correct_answer":"C",
       "explanation":"The hold timer must expire for the standby router to become an active router. The hold timer is three times the hello timer, so three hello packets must be missed before the standby becomes active. The hello timer sets the time between hello packets outgoing to all other HSRP members. The standby timer is a timer on the standby router that expires in sync with the hello timer. There is no such timer as the virtual timer; therefore, this is a wrong answer."
    },
    {
       "id":633,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":1,
       "question":"Which port and protocol are used by Gateway Load Balancing Protocol (GLBP) for communications?",
       "choice_a":"UDP/1935",
       "choice_b":"UDP/1985",
       "choice_c":"UDP/1895",
       "choice_d":"UDP/3222",
       "correct_answer":"D",
       "explanation":"Gateway Load Balancing Protocol (GLBP) use the port number 3222 and the protocol UDP for router communications. All other answers are incorrect."
    },
    {
       "id":634,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which is a difference between HSRPv1 and HSRPv2?",
       "choice_a":"HSRPv2 does not use hello packets.",
       "choice_b":"HSRPv1 uses broadcasts, and HSRPv2 uses multicasts.",
       "choice_c":"HSRPv1 supports IPv6.",
       "choice_d":"HSRPv2 uses milliseconds.",
       "correct_answer":"D",
       "explanation":"HSRP version 2 allows for timers to be configured in milliseconds in lieu of seconds. This allows for quicker failover between active and standby routers. Both HSRPv1 and HSRPv2 use hello packets to maintain a health state among other HSRP members. HSRPv1 and HSRPv2 both use multicasts for management and hello packets. HSRPv1 does not support IPv6; only HSRPv2 supports IPv6."
    },
    {
       "id":635,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which statement is correct about GLBP?",
       "choice_a":"The active router is responsible for responding to clients with the virtual router\u0027s MAC address.",
       "choice_b":"The active virtual gateway will respond with a MAC address of the active router.",
       "choice_c":"The active virtual gateway will respond with a MAC address of an active virtual forwarder.",
       "choice_d":"The virtual router is responsible for responding to tracking requests.",
       "correct_answer":"C",
       "explanation":"The active virtual gateway (AVG) is responsible for responding to ARP requests from hosts. The AVG will reply with the MAC address of any one of the active virtual forwarders (AVFs). The active router is a concept used with Virtual Router Redundancy Protocol (VRRP) or Hot Standby Router Protocol (HSRP), and it does not apply to Gateway Load Balancing Protocol (GLBP). The active virtual gateway will respond with the MAC address of the next active virtual forwarder or router that is available. The virtual router is not responsible for tracking requests; the AVG is responsible."
    },
    {
       "id":636,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which router is elected to become the GLBP active virtual gateway?",
       "choice_a":"The router with the lowest priority",
       "choice_b":"The router with the highest priority",
       "choice_c":"The router with the lowest priority and lowest IP address",
       "choice_d":"The router with the highest priority and highest IP address",
       "correct_answer":"D",
       "explanation":"The router with the highest priority will become the AVG. However, if all routers have the same priority, then the router with the highest IP address configured becomes the tiebreaker. The router with the highest priority and highest IP address will become the AVG, not the one with the lowest priority and lowest IP address."
    },
    {
       "id":637,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"How many active virtual forwarders are supported per the GLBP group?",
       "choice_a":2,
       "choice_b":4,
       "choice_c":16,
       "choice_d":"1,024",
       "correct_answer":"B",
       "explanation":"Gateway Load Balancing Protocol (GLBP) supports up to four active virtual forwarders per GLBP group. All other answers are incorrect."
    },
    {
       "id":638,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which command will allow Router B to always become the active router for HSRP?",
       "choice_a":"<code>Router(config-if)#standby 1 priority 150</code>",
       "choice_b":"<code>Router(config-if)#standby 1 priority 70</code>",
       "choice_c":"<code>Router(config-if)#hsrp 1 priority 150</code>",
       "choice_d":"<code>Router(config-if)#hsrp 1 priority 90</code>",
       "correct_answer":"A",
       "explanation":"The command <code>standby 1 priority 150</code> will set the HSRP group of 1 on this router to a priority of 150. As long as all other routers are set to the default of 100, this router will become the default router on the next election. The command <code>standby 1 priority 70</code> is incorrect. The command <code>hsrp 1 priority 150</code> is incorrect. The command <code>hsrp 1 priority 90</code> is incorrect."
    },
    {
       "id":639,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"What is the maximum number of HSRPv2 groups that can be created?",
       "choice_a":255,
       "choice_b":256,
       "choice_c":"1,024",
       "choice_d":"4,096",
       "correct_answer":"D",
       "explanation":"You can create up to 4,096 HSRP groups on a router with HSRPv2. This would include group 0 to 4095 for a total of 4,096 groups. HSRPv1 is limited to 256 HSRP groups. All other answers are incorrect."
    },
    {
       "id":640,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Your company is running a FHRP. You notice that the MAC address of the default gateway is 0000.0c9f.f123. Which FHRP is being employed?",
       "choice_a":"HSRPv1",
       "choice_b":"GLBP",
       "choice_c":"HSRPv2",
       "choice_d":"VRRP",
       "correct_answer":"C",
       "explanation":"Hot Standby Router Protocol version 2 (HSRPv2) is being employed. It uses an OUI of 0000.0c and a well-known identifier of 9f.f, and the last three digits identify the HSRP group, which has been expanded from two digits in version 1. HSRPv1 has a well-known identifier of 07.ac. Gateway Load Balancing Protocol (GLBP) and Virtual Router Redundancy Protocol (VRRP) do not have well-known identifiers."
    },
    {
       "id":641,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"What is the definition of preemption for HSRP?",
       "choice_a":"It allows the protocol to effectively load-balance per packet.",
       "choice_b":"It watches an upstream interface and fails over when the interface goes down.",
       "choice_c":"It ignores the priorities of the routers and elects an active router by highest IP address.",
       "choice_d":"When a standby router comes online, it allows for a re-election of the active router.",
       "correct_answer":"D",
       "explanation":"Preemption allows for the election process to happen for a newly added HSRP router. If preemption is not enabled, then the newly added HSRP router will become a standby router. HSRP does not load-balance per packet; Gateway Load Balancing Protocol (GLBP) will load-balance per packet. Object tracking effectively watches an upstream interface and recalculates HSRP if the interface fails. HSRP uses both the priority and highest IP address to elect an active router."
    },
    {
       "id":642,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which is a method of configuring HSRP so that traffic is not directed to one router?",
       "choice_a":"Configure version 2 for all HSRP groups.",
       "choice_b":"Configure an HSRP group per VLAN and alternate the priority above 100.",
       "choice_c":"Configure PPPoE on the router interfaces.",
       "choice_d":"Configure all routers in the HSRP as active routers.",
       "correct_answer":"B",
       "explanation":"Hot Standby Router Protocol (HSRP) allows for only one active router per HSRP group. However, you can configure multiple VLANs with HSRP groups. You can then alternate a higher-than-default priority to force an active router per VLAN. This will give you a rudimentary way of balancing traffic. Configuring version 2 for all HSRP groups will not achieve load-balancing. Configuring PPPoE on the router interfaces is an incorrect answer as it will pin a host to a specific interface. You cannot configure all the routers in an HSRP group as active routers."
    },
    {
       "id":643,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which command will allow you to verify the state of the current router for HSRP?",
       "choice_a":"<code>RouterA#show hsrp</code>",
       "choice_b":"<code>RouterA#show ip standby</code>",
       "choice_c":"<code>RouterA#show standby</code>",
       "choice_d":"<code>RouterA#show ip hsrp</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show standby</code> will allow you to verify the state of the current router for HSRP. The command <code>show hsrp</code> is incorrect. The command <code>show ip standby</code> is incorrect. The command <code>show ip hsrp</code> is incorrect."
    },
    {
       "id":644,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"You have just changed the priority on Router A to 150, and it has not become the active router. All other routers have the default priority. What is wrong?",
       "choice_a":"The default priority is 150.",
       "choice_b":"The hold timer is set too high and needs to timeout.",
       "choice_c":"The HSRP group is not set for preemption.",
       "choice_d":"Router A's IP address is too low.",
       "correct_answer":"C",
       "explanation":"The HSRP group is not set for preemption, which is the default behavior for HSRP. You need to enable preemption, which will allow a reelection when the priority is changed or if a new standby router comes online. If preemption is disabled, the active router will have affinity. The default priority for HSRP is 100. The hold timers will have nothing to do with the election of the active router unless there is a failure. Router A\u0027s IP address will not matter if the priority is higher than the other routers (default of 100)."
    },
    {
       "id":645,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which command will allow you to enable preemption for HSRP?",
       "choice_a":"<code>Router(config)#standby 1 preemption</code>",
       "choice_b":"<code>Router(config-if)#standby 1 preemption</code>",
       "choice_c":"<code>Router(config-if)#hsrp 1 preempt</code>",
       "choice_d":"<code>Router(config-if)#standby 1 preempt</code>",
       "correct_answer":"D",
       "explanation":"The command <code>standby 1 preempt</code> will configure HSRP group 1 for preemption. This command must be configured under the interface on which HSRP has been enabled. The command <code>show standby</code> will allow you to verify this. The command <code>standby 1 preemption</code> is incorrect configured in the global configuration prompt or an interface configuration prompt. The command <code>hsrp 1 preempt</code> is incorrect."
    },
    {
       "id":646,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which command will configure VRRP on an interface with an IP address of 10.1.2.3?",
       "choice_a":"<code>Router(config)#vrrp 1 10.1.2.3 gi 0/0</code>",
       "choice_b":"<code>Router(config-if)#vrrp 1 ip 10.1.2.3</code>",
       "choice_c":"<code>Router(config-if)#vrrp 1 10.1.2.3</code>",
       "choice_d":"<code>Router(config-if)#standby 1 10.1.2.3</code><br><code>Router(config-if)#standby 1 vrrp</code>",
       "correct_answer":"B",
       "explanation":"The command <code>vrrp 1 ip 10.1.2.3</code> will configure the interface with VRRP with a virtual IP address of 10.1.2.3. The command <code>vrrp 1 10.1.2.3 gi 0/0</code> is incorrect. The command <code>vrrp 1 10.1.2.3</code> is incorrect. The command <code>standby 1 10.1.2.3</code> and <code>standby 1 vrrp</code> is incorrect."
    },
    {
       "id":647,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Refer to the following exhibit. You are running HSRP on Router A and Router B. You intermittently have ISP outages. What command should you configure to alert HSRP to the outage? <img src='/question_assets/ccna/3_image26.png'></img>",
       "choice_a":"<code>RouterA(config-if)#standby 1 interface tracking serial 0/0/1</code><br><code>RouterB(config-if)#standby 1 interface tracking serial 0/0/1</code>",
       "choice_b":"<code>RouterA(config-if)#standby 1 tracking serial 0/0/1</code><br><code>RouterB(config-if)#standby 1 tracking serial 0/0/1</code>",
       "choice_c":"<code>RouterA(config-if)#standby 1 track serial 0/0/1</code><br><code>RouterB(config-if)#standby 1 track serial 0/0/1</code>",
       "choice_d":"<code>RouterA(config-if)#interface serial 0/0/1</code><br><code>RouterA(config-if)#standby 1 interface tracking</code><br><code>RouterA(config-if)#interface serial 0/0/1</code><br><code>RouterB(config-if)#standby 1 interface tracking</code>",
       "correct_answer":"C",
       "explanation":"Interface tracking is configured on the interface in which the HSRP group has been configured. The command <code>standby 1 track serial 0/0/1</code> tells the HSRP group of 1 to track the status of interface serial 0/0/1. The command <code>standby 1 interface tracking serial 0/0/1</code> is incorrect. The command <code>standby 1 tracking serial 0/0/1</code> is incorrect. The commands <code>interface serial 0/0/1</code> and <code>standby 1 interface tracking</code> are incorrect."
    },
    {
       "id":648,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which command will allow you to see real-time diagnostics of HSRP?",
       "choice_a":"<code>Router#show ip hsrp</code>",
       "choice_b":"<code>Router#debug ip hsrp</code>",
       "choice_c":"<code>Router#debug standby</code>",
       "choice_d":"<code>Router#debug ip standby</code>",
       "correct_answer":"C",
       "explanation":"The command <code>debug standby</code> will allow you to see real-time information from HSRP on the router on which you have entered the command. The command <code>show ip hsrp</code> is incorrect. The command <code>debug ip hsrp</code> is incorrect. The command <code>debug ip standby</code> is incorrect."
    },
    {
       "id":649,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which statement is correct about GLBP?",
       "choice_a":"GLBP allows for per-host load balancing.",
       "choice_b":"The active virtual gateway will respond with a MAC address of the active router.",
       "choice_c":"GLBP allows for per-subnet load balancing.",
       "choice_d":"The virtual router is responsible for responding to tracking requests.",
       "correct_answer":"A",
       "explanation":"GLBP allows for per-host load balancing. It does this by allowing the active virtual router to respond for the virtual IP address. The AVG then hands out the MAC address in the ARP request for one of the active virtual forwarders. It does this in a round-robin fashion. The active virtual gateway will respond with the active virtual forwarder; an active router is a concept used with HSRP. GLBP will not load balance per-subnet; HSRP can be set up with a different HSRP group for each VLAN. The virtual router is not responsible for responding to the tracking requests; the active virtual router is responsible for this task."
    },
    {
       "id":650,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"Which command will allow you to set the hello and hold timers for HSRPv2 to a hello of 200 milliseconds and a hold of 700 milliseconds?",
       "choice_a":"<code>RouterA(config-if)#standby 1 timers msec 200 msec 700</code>",
       "choice_b":"<code>RouterA(config-if)#standby 1 timers 200 msec 700 msec</code>",
       "choice_c":"<code>RouterA(config-if)#standby 1 timers 700 msec 200 msec</code>",
       "choice_d":"<code>RouterA(config-if)#standby 1 timers msec 700 msec 200</code>",
       "correct_answer":"A",
       "explanation":"The command <code>standby 1 timers msec 200 msec 700</code> will set the HSRP group of 1 with a hello timer of 200 milliseconds and a hold timer of 700 milliseconds. This is configured inside of the interface in which the HSRP group was created. The command <code>standby 1 timers 200 msec 700 msec</code> is incorrect. The command <code>standby 1 timers 700 msec 200 msec</code> is incorrect. The command <code>standby 1 timers msec 700 msec 200</code> is incorrect."
    },
    {
       "id":651,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":"",
       "question":"You have four routers configured with HSRP. Four routers—Router A, Router B, Router C, and Router D—are configured with the default priority. You change the priority of Router A to 80, Router B to 100, Router C to 140, and Router D is unchanged. Which router will become the active router?",
       "choice_a":"Router A will become the active router.",
       "choice_b":"Router B will become the active router.",
       "choice_c":"Router C will become the active router.",
       "choice_d":"Router D will become the active router.",
       "correct_answer":"C",
       "explanation":"Router C will become the active router since it has the highest priority. The default priority of HSRP is 100, and therefore, the router with the highest priority will become the active router. It is important to note that nothing will change if preemption is not configured on the routers. Router A, Router B, and Router D all have lower HSRP priorities compared to Router C with a priority of 140."
    },
    {
       "id":652,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":"",
       "question":"Which method will allow you to use RFC 1918 addresses for Internet requests?",
       "choice_a":"CIDR",
       "choice_b":"Classful addressing",
       "choice_c":"NAT",
       "choice_d":"VPN",
       "correct_answer":"C",
       "explanation":"Network address translation (NAT) was created to slow the depletion of Internet addresses. It does this by translating RFC 1918 privatized addresses to one or many public IP addresses. It allows the packets to masquerade as the public IP address on the Internet until it is translated back to the private IP address. Classless Inter-Domain Routing (CIDR) is a notation used to express the network for a host. Classful addressing is the original addressing scheme for the Internet. Virtual private network x (VPNs) are used for remote access."
    },
    {
       "id":653,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":"",
       "question":"In the following exhibit, what is the inside local IP address?<img src='/question_assets/ccna/4_image1.png'></img>",
       "choice_a":"192.168.1.2 Host A",
       "choice_b":"192.168.1.1 Router A Gi0/0",
       "choice_c":"179.43.44.1 Router A S0/0",
       "choice_d":"198.23.53.3 web server",
       "correct_answer":"A",
       "explanation":"The inside local address is the address local to the enterprise (private), and the address is inside the enterprise. The inside local address will almost always be an RCF 1918 address, unless NAT is being used for purposes other than enterprise Internet access. If NAT is used for Internet access, then the inside local address is any host address destined for the Internet through NAT. 192.168.1.1 is the router's interface address used to communicate with inside local hosts during the NAT process. 179.43.44.1 is the inside global address for the NAT process. 198.23.53.3 is the outside global address for the NAT process."
    },
    {
       "id":654,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":4,
       "question":"In the following exhibit, what is the inside global IP address?<img src='/question_assets/ccna/4_image2.png'></img>",
       "choice_a":"192.168.1.2 Host A",
       "choice_b":"192.168.1.1 Router A Gi0/0",
       "choice_c":"179.43.44.1 Router A S0/0",
       "choice_d":"198.23.53.3 web server",
       "correct_answer":"C",
       "explanation":"The inside global address is the address public to the enterprise. The address is inside of or controlled by the enterprise. The inside global address in this case is the public side of the NAT, which is Router A's S0/0 IP address. 192.168.1.2 is the inside local address of the host computer. 192.168.1.1 is the router's interface address used to communicate with inside local hosts during the NAT process. 198.23.53.3 is the outside global address for the NAT process."
    },
    {
       "id":655,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":5,
       "question":"In the following exhibit, what is the outside global IP address?<img src='/question_assets/ccna/4_image3.png'></img>",
       "choice_a":"192.168.1.2 Host A",
       "choice_b":"192.168.1.1 Router A Gi0/0",
       "choice_c":"179.43.44.1 Router A S0/0",
       "choice_d":"198.23.53.3 web server",
       "correct_answer":"D",
       "explanation":"The outside global address is the address public to the enterprise. The address is outside of the enterprise or outside of its control. When using NAT for Internet access, the outside global address is the destination host on the Internet. The outside global address in this exhibit is the web server. 192.168.1.2 is the inside local address of the host computer. 192.168.1.1 is the router's interface address used to communicate with inside local hosts during the NAT process. 179.43.44.1 is the inside global address for the NAT process."
    },
    {
       "id":656,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":1,
       "question":"Which command will allow you to view the NAT translations active on the router?",
       "choice_a":"<code>Router#show ip nat translations</code>",
       "choice_b":"<code>Router#show nat translations</code>",
       "choice_c":"<code>Router#debug ip nat translations</code>",
       "choice_d":"<code>Router#show translations nat</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show ip nat translations</code> will allow you to view the active NAT translations on the router. The command <code>show nat translations</code> is incorrect. The command <code>debug ip nat translations</code> will turn on debugging for NAT. The command <code>show translations nat</code> is incorrect."
    },
    {
       "id":657,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":"",
       "question":"Which command will display an overview of the current number of active NAT translations on the router, as well as other overview information?",
       "choice_a":"<code>Router# show ip nat translations</code>",
       "choice_b":"<code>Router# show ip nat summary</code>",
       "choice_c":"<code>Router# show ip nat status</code>",
       "choice_d":"<code>Router# show ip nat statistics</code>",
       "correct_answer":"D",
       "explanation":"The command <code>show ip nat statistics</code> will display and overview of the number of active NAT translations on the router, as well as other statistical information for the NAT process. In addition, it will provide you with the current inside and outside interfaces. The command <code>show ip nat translations</code> will allow you to view the active NAT translations on the router. The command <code>show ip nat summary</code> is incorrect. The command <code>show ip nat status</code> is incorrect."
    },
    {
       "id":658,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":"",
       "question":"In the following exhibit, which command will configure static NAT for the internal web server?<img src='/question_assets/ccna/4_image4.png'></img>",
       "choice_a":"<code>RouterA(config)#ip nat inside source static 192.168.1.3 179.43.44.1</code>",
       "choice_b":"<code>RouterA(config)#nat source static 192.168.1.3 179.43.44.1</code>",
       "choice_c":"<code>RouterA(config)#ip nat static 192.168.1.3 179.43.44.1</code>",
       "choice_d":"<code>RouterA(config)#ip nat source static 192.168.1.3 179.43.44.1</code>",
       "correct_answer":"A",
       "explanation":"After you define the inside and outside per each respective interface, the command <code>ip nat inside source static 192.168.1.3 179.43.44.1</code> will statically NAT (network address translation) the inside local address of 192.168.1.3 to the inside global address of 179.43.44.1. The command <code>nat source static 192.168.1.3 179.43.44.1</code> is incorrect. The command <code>ip nat static 192.168.1.3 179.43.44.1</code> is incorrect. The command <code>ip nat source static 192.168.1.3 179.43.44.1</code> is incorrect."
    },
    {
       "id":659,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":"",
       "question":"In the following exhibit, the enterprise owns the address block of 179.43.44.0/28. Which command will create a NAT pool for Dynamic NAT?<img src='/question_assets/ccna/4_image5.png'></img>",
       "choice_a":"<code>RouterA(config)#ip nat pool EntPool 179.43.44.0/28</code>",
       "choice_b":"<code>RouterA(config)#ip pool EntPool 179.43.44.2 179.43.44.15 netmask 255.255.255.0</code>",
       "choice_c":"<code>RouterA(config)#ip nat pool EntPool 179.43.44.1 179.43.44.15 netmask 255.255.255.240</code>",
       "choice_d":"<code>RouterA(config)#ip nat pool EntPool 179.43.44.2 179.43.44.15 netmask 255.255.255.0</code>",
       "correct_answer":"D",
       "explanation":"The command <code>ip nat pool EntPool 179.43.44.2 179.43.44.15 netmask 255.255.255.0</code> will configure the pool called EntPool with the range of IP addresses from 179.43.44.2 to 179.43.44.15 and the network mask of /24. The /24 is used in lieu of the /28 because the serial interface is a /24, and therefore, all IP addresses in that network are /24. The command <code>ip nat pool EntPool 179.43.44.0/28</code> is incorrect. The command <code>ip pool EntPool 179.43.44.2 179.43.44.15</code>"
    },
    {
       "id":660,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":"",
       "question":"When configuring dynamic NAT, why must you configure an access list?",
       "choice_a":"The access list allows incoming access from outside global addresses.",
       "choice_b":"The access list allows outgoing access from inside local addresses.",
       "choice_c":"The access list allows outgoing access from outside local addresses.",
       "choice_d":"The access list allows outgoing access from inside global addresses.",
       "correct_answer":"B",
       "explanation":"The access list allows is used to identify to IP addresses that are allowed to pass through the NAT process; these are considered the inside local addresses. The access list does not restrict incoming access from the outside global. The access list does not restrict outgoing access from the outside local. The access list does not restrict outgoing access from the inside global."
    },
    {
       "id":661,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":4,
       "question":"Which command will wipe out all current NAT translations in the NAT table?",
       "choice_a":"<code>Router#no ip nat translation</code>",
       "choice_b":"<code>Router#clear ip nat translation</code>",
       "choice_c":"<code>Router#clear ip nat translation *</code>",
       "choice_d":"<code>Router#clear ip nat</code>",
       "correct_answer":"C",
       "explanation":"The command <code>clear ip nat translation *</code> will clear all IP NAT translations out of the NAT table. The asterisk is used as a wildcard for all addresses. You can alternatively specify a specific inside or outside NAT address. The command <code>no ip nat translation</code> is incorrect. The command <code>clear ip nat translation</code> is incorrect. The command <code>clear ip nat</code> is incorrect."
    },
    {
       "id":662,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":5,
       "question":"Which command will allow you to see real-time network address translations?",
       "choice_a":"<code>Router#show ip translations</code>",
       "choice_b":"<code>Router#debug ip nat</code>",
       "choice_c":"<code>Router#debug ip translations</code>",
       "choice_d":"<code>Router#show ip nat</code>",
       "correct_answer":"B",
       "explanation":"The command <code>debug ip nat</code> will allow you to see real-time NAT translations. When you issue this command, you should know that each NAT translation will log to the screen or logging server and will spike CPU usage. The command <code>show ip translations</code> is incorrect. The command <code>debug ip translations</code> is incorrect. The command <code>show ip nat</code> is incorrect."
    },
    {
       "id":663,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":"",
       "question":"In the following exhibit, which command will configure Port Address Translation?<img src='/question_assets/ccna/4_image6.png'></img>",
       "choice_a":"<code>RouterA(config)#access-list 1 permit 192.168.1.0 0.0.0.255</code><br><code>RouterA(config)#ip nat pool EntPool 179.43.44.1 179.43.44.1</code><br><code>RouterA(config)#ip nat inside source list 1 pool EntPool</code>",
       "choice_b":"<code>RouterA(config)#ip nat pool EntPool 179.43.44.1 179.43.44.1 netmask 255.255.255.0</code><br><code>RouterA(config)#ip nat source pool EntPool</code>",
       "choice_c":"<code>RouterA(config)#access-list 1 permit 192.168.1.0 0.0.0.255</code><br><code>RouterA(config)#ip nat pool EntPool 179.43.44.1 179.43.44.1 netmask 255.255.255.0</code><br><code>RouterA(config)#ip nat inside source list 1 pool EntPool overload</code>",
       "choice_d":"<code>RouterA(config)#access-list 1 permit 192.168.1.0 0.0.0.255</code><br><code>RouterA(config)#ip nat pool EntPool 179.43.44.1 179.43.44.1 netmask 255.255.255.0</code><br><code>RouterA(config)#ip nat inside source list 1 pool EntPool</code>",
       "correct_answer":"C",
       "explanation":"The first command required is <code>access-list 1 permit 192.168.1.0 0.0.0.255,</code> which defines the allowed networks. The next command creates the NAT pool with <code>ip nat pool EntPool 179.43.44.1 179.43.44.1 netmask 255.255.255.0.</code> The last command, <code>ip nat inside source list 1 pool EntPool overload,</code> ties the access list together with the pool and defines PAT with the overload command. All other command configurations are incorrect."
    },
    {
       "id":664,
       "topic_id":4,
       "sub_domain":"4.2 Configure and verify NTP operating in a client and server mode",
       "practice_test_id":"",
       "question":"Which command will allow your router to synchronize with a time source of 129.6.15.28?",
       "choice_a":"<code>Router(config)#ntp server 129.6.15.28</code>",
       "choice_b":"<code>Router#ntp server 129.6.15.28</code>",
       "choice_c":"<code>Router(config)#ntp client 129.6.15.28</code>",
       "choice_d":"<code>Router#ntp client 129.6.15.28</code>",
       "correct_answer":"A",
       "explanation":"The command <code>ntp server 129.6.15.28</code> will configure your router to connect to the server 129.6.15.28 as an NTP source. This command must be entered in global configuration mode. The command <code>ntp server 129.6.15.28</code>entered from the <code>Router#</code> prompt (Privileged Exec mode) is incorrect. The command <code>ntp client 129.6.15.28</code> is incorrect. The command <code>ntp client 129.6.15.28</code> entered from the Router# prompt is incorrect."
    },
    {
       "id":665,
       "topic_id":4,
       "sub_domain":"4.2 Configure and verify NTP operating in a client and server mode",
       "practice_test_id":"",
       "question":"Which command configures the router or switch to trust its internal time clock?",
       "choice_a":"<code>Router(config)#ntp server</code>",
       "choice_b":"<code>Router(config)#ntp master</code>",
       "choice_c":"<code>Router(config)#ntp clock source</code>",
       "choice_d":"<code>Router(config)#ntp trusted</code>",
       "correct_answer":"B",
       "explanation":"The command <code>ntp master</code> configures the router or switch to trust its internal time clock. The command <code>ntp server</code> is incorrect. The command <code>ntp clock source</code> is incorrect. The command <code>ntp trusted</code> is incorrect."
    },
    {
       "id":666,
       "topic_id":4,
       "sub_domain":"4.2 Configure and verify NTP operating in a client and server mode",
       "practice_test_id":"",
       "question":"Which command will allow you to see if the router or switch is using NTP?",
       "choice_a":"<code>Router#show clock detail</code>",
       "choice_b":"<code>Router#show ntp</code>",
       "choice_c":"<code>Router#show time</code>",
       "choice_d":"<code>Router#show time source</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show clock detail</code> will display either <code>no time source or time source is NTP</code> if the router or switch is configured to slave off a server for time. The command <code>show ntp</code> is incorrect. The command <code>show time</code> is incorrect. The command <code>show time source</code> is incorrect."
    },
    {
       "id":667,
       "topic_id":4,
       "sub_domain":"4.2 Configure and verify NTP operating in a client and server mode",
       "practice_test_id":"",
       "question":"Which command will allow you to view the time details from a configured server?",
       "choice_a":"<code>Router#show clock detail</code>",
       "choice_b":"<code>Router#show ntp detail</code>",
       "choice_c":"<code>Router#show ntp associations detail</code>",
       "choice_d":"<code>Router#show ntp skew</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show ntp associations detail</code> will allow you to view the NTP clock details from the master NTP server. The command <code>show clock detail</code> is incorrect. The command <code>show ntp detail</code> is incorrect. The command <code>show ntp skew</code> is incorrect."
    },
    {
       "id":668,
       "topic_id":4,
       "sub_domain":"4.2 Configure and verify NTP operating in a client and server mode",
       "practice_test_id":"",
       "question":"Which protocol and port does NTP use for time synchronization by default?",
       "choice_a":"TCP/161",
       "choice_b":"TCP/123",
       "choice_c":"UDP/69",
       "choice_d":"UDP/123",
       "correct_answer":"D",
       "explanation":"The Network Time Protocol uses UDP port 123 for time synchronization. Simple Network Management Protocol (SNMP) uses TCP/161 to listening for incoming SNMP messages. TCP/123 can be configured for NTP, but it is normally not used by default. UDP/69 is used by Trivial File Transfer (TFTP) for file transfers."
    },
    {
       "id":669,
       "topic_id":4,
       "sub_domain":"4.2 Configure and verify NTP operating in a client and server mode",
       "practice_test_id":"",
       "question":"Which command will help you diagnose if the router or switch is getting an answer back from an NTP server?",
       "choice_a":"<code>Router#show ntp</code>",
       "choice_b":"<code>Router#show ip ntp</code>",
       "choice_c":"<code>Router#debug ntp packets</code>",
       "choice_d":"<code>Router#debug ntp messages</code>",
       "correct_answer":"C",
       "explanation":"The command <code>debug ntp packets</code> will allow you to verify packets received from an NTP server. The command <code>show ntp</code> is incorrect. The command <code>show ip ntp</code> is incorrect. The command <code>debug ntp messages</code> is incorrect."
    },
    {
       "id":670,
       "topic_id":4,
       "sub_domain":"4.2 Configure and verify NTP operating in a client and server mode",
       "practice_test_id":1,
       "question":"Which is a best practice for setting up NTP?",
       "choice_a":"Always configure the time source to a DNS address.",
       "choice_b":"Configure all devices to a public NTP server.",
       "choice_c":"Configure all devices to different NTP servers for redundancy.",
       "choice_d":"Configure all devices as master servers.",
       "correct_answer":"A",
       "explanation":"A best practice is to configure the main router in your network to a known good trusted time source by its DNS address. All devices in your network should then be configured to point to this trusted router. All time sources should pyramid out from the central source of time in your network. Configuring all devices to a public NTP server is not a best practice because multiple firewall entries will need to be configured. Configuring all devices to different NTP servers for redundancy is not a best practice because all devices should synchronize to the same master. Configuring all devices as master servers is not a best practice; only one master should exist."
    },
    {
       "id":671,
       "topic_id":4,
       "sub_domain":"4.2 Configure and verify NTP operating in a client and server mode",
       "practice_test_id":"",
       "question":"Which command will allow you to view the time drift observed by NTP?",
       "choice_a":"<code>Router#show ntp</code>",
       "choice_b":"<code>Router#show ip ntp status</code>",
       "choice_c":"<code>Router#show ntp status</code>",
       "choice_d":"<code>Router#debug ntp drift</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show ntp status</code> will allow you to see the current time source, the precision of the time source, and the drift from your internal time clock. The command <code>show ntp</code> is incorrect. The command <code>show ip ntp status</code> is incorrect. The command <code>debug ntp drift</code> is incorrect."
    },
    {
       "id":672,
       "topic_id":4,
       "sub_domain":"4.2 Configure and verify NTP operating in a client and server mode",
       "practice_test_id":4,
       "question":"Which command sets the time zone of a router for Pacific Standard Time?",
       "choice_a":"<code>Router(config)#clock time zone pacific</code>",
       "choice_b":"<code>Router(config)#clock time zone pst -8 0</code>",
       "choice_c":"<code>Router(config)#time zone pacific</code>",
       "choice_d":"<code>Router(config)#time zone pst -8</code>",
       "correct_answer":"B",
       "explanation":"The command <code>clock time zone pst -8 0</code> will set the time zone to Pacific Standard Time with an offset of -8 from Coordinated Universal Time (UTC) with a minute offset of 0. The command <code>clock time zone pacific</code> is incorrect. The command <code>time zone pacific</code> is incorrect. The command <code>time zone pst -8</code> is incorrect."
    },
    {
       "id":673,
       "topic_id":4,
       "sub_domain":"4.2 Configure and verify NTP operating in a client and server mode",
       "practice_test_id":5,
       "question":"You are configuring NTP on your switch. You want to configure the switch so if any interface fails, NTP will still be available. Which type of interface should you use?",
       "choice_a":"Tunnel interface",
       "choice_b":"NTP interface",
       "choice_c":"Loopback interface",
       "choice_d":"Switched Virtual Interface (SVI)",
       "correct_answer":"C",
       "explanation":"You should configure a loopback interface on the switch with the IP address of the NTP server the NTP clients will use. A tunnel interface is an incorrect answer. An NTP interface is an incorrect answer. Although a Switched Virtual Interface (SVI) would work, it is not active until at least one port is configured with the VLAN. Therefore, the SVI is still tied to a physical interface state.<br></br>Therefore, the SVI is still tied to a physical interface state."
    },
    {
       "id":674,
       "topic_id":4,
       "sub_domain":"4.2 Configure and verify NTP operating in a client and server mode",
       "practice_test_id":"",
       "question":"Which command will configure NTP to use the internal loopback interface?",
       "choice_a":"<code>Switch(config)#ntp source loopback 0</code>",
       "choice_b":"<code>Switch(config)#ntp loopback 0</code>",
       "choice_c":"<code>Switch(config)#ntp master loopback 0</code>",
       "choice_d":"<code>Switch(config)#ntp clock loopback 0</code>",
       "correct_answer":"A",
       "explanation":"The command <code>ntp source loopback 0</code> will configure the NTP service to respond to clients from the source address of the loopback 0 interface. The command <code>ntp loopback 0</code> is incorrect. The command <code>ntp master loopback 0</code> is incorrect. The command <code>ntp clock loopback 0</code> is incorrect."
    },
    {
       "id":675,
       "topic_id":4,
       "sub_domain":"4.2 Configure and verify NTP operating in a client and server mode",
       "practice_test_id":"",
       "question":"Which command will set the router's internal clock to 2:24 August 1, 2019?",
       "choice_a":"<code>Router(config)#clock set 2:24:00 1 august 2019</code>",
       "choice_b":"<code>Router#clock set 2:24:00 1 august 2019</code>",
       "choice_c":"<code>Router(config)#clock set 2:24:00 august 1 2019</code>",
       "choice_d":"<code>Router#clock 2:24:00 1 august 2019</code>",
       "correct_answer":"B",
       "explanation":"The command <code>clock set 2:24:00 1 august 2019</code> will set the clock to 2:24 a.m. (24-hour format) and August 1, 2019. The command <code>clock set 2:24:00 1 august 2019</code> is incorrect when configured from a global configuration prompt. The command <code>clock set 2:24:00 august 1 2019</code> is incorrect. The command <code>clock 2:24:00 1 august 2019</code> is incorrect."
    },
    {
       "id":676,
       "topic_id":4,
       "sub_domain":"4.3 Explain the role of DHCP and DNS within the network",
       "practice_test_id":"",
       "question":"Which statement is correct about reverse lookups?",
       "choice_a":"A reverse lookup is when the request needs to be reversed to another DNS server.",
       "choice_b":"A reverse lookup is the resolution of an IP address to FQDN.",
       "choice_c":"A reverse lookup is when the DNS queried can answer the request without asking another DNS server.",
       "choice_d":"A reverse lookup is the resolution of an FQDN to an IP address.",
       "correct_answer":"B",
       "explanation":"A reverse lookup is when the fully qualified domain name (FQDN) is resolved from an IP address. This is useful when you want to identify an IP address. From the IP address, you can derive the FQDN. A reverse lookup is not when the request needs to be reversed to another DNS server. A reverse lookup is not when the DNS queried can answer the request without asking another DNS server. A reverse lookup is not the resolution of an FQDN to an IP address; it is the resolution of an IP address to an FQDN."
    },
    {
       "id":677,
       "topic_id":4,
       "sub_domain":"4.3 Explain the role of DHCP and DNS within the network",
       "practice_test_id":"",
       "question":"Which record type is used for an IPv4 address mapping to FQDN for DNS queries?",
       "choice_a":"The A record",
       "choice_b":"The C Name record",
       "choice_c":"The PTR record",
       "choice_d":"The AAAA record",
       "correct_answer":"C",
       "explanation":"The PTR, or pointer record, is used to look up IP addresses and return FQDNs that are mapped to them. This is helpful to identify an IP address, and in the case of SSH, it is used to positively identify the host you are connecting to. The A record is used to look up an IP address for a given hostname. The C Name record is used to look up the alias for a given hostname. The AAAA record is used to lookup an IPv6 address for a given hostname."
    },
    {
       "id":678,
       "topic_id":4,
       "sub_domain":"4.3 Explain the role of DHCP and DNS within the network",
       "practice_test_id":"",
       "question":"What gets appended to hostname queries for DNS resolution?",
       "choice_a":"The DNS domain name",
       "choice_b":"The DNS zone",
       "choice_c":"The host header",
       "choice_d":"The hostname PTR record",
       "correct_answer":"A",
       "explanation":"The configured DNS domain name is appended to the hostname query. As an example, if you query a hostname of router a and the configured domain name is network local, the DNS server will see a query for router a network local. The DNS zone is the database of records contained in DNS. <italic>Host header</italic> is a term used with web servers and therefore not relevant to DNS resolution. The hostname PTR record is the reverse DNS record for a given IP address."
    },
    {
       "id":679,
       "topic_id":4,
       "sub_domain":"4.3 Explain the role of DHCP and DNS within the network",
       "practice_test_id":"",
       "question":"Which is the most secure method of name resolution for routers and switches?",
       "choice_a":"DNS",
       "choice_b":"PTR records",
       "choice_c":"Static hostname entries",
       "choice_d":"LLMNR",
       "correct_answer":"C",
       "explanation":"Static hostname entries are the most secure name resolution method for routers and switches because they are configured locally on the device. This is because the switch or router does not need to forward-query a server. However, static hostname entries are not scalable. DNS is not considered as secure as static hostname entries because it is publically accessible. PTR records are reverse DNS records and therefore not relevant to security. Link Local Multicast Name Resolution (LLMNR) is the protocol that the Windows operating system uses for local name queries."
    },
    {
       "id":680,
       "topic_id":4,
       "sub_domain":"4.3 Explain the role of DHCP and DNS within the network",
       "practice_test_id":"",
       "question":"Which type of DNS record holds the IPv4 IP address for a hostname?",
       "choice_a":"The A record",
       "choice_b":"The C Name record",
       "choice_c":"The PTR record",
       "choice_d":"The AAAA record",
       "correct_answer":"A",
       "explanation":"The A record is the DNS record that is queried when you want to resolve a hostname to an IP address. The C Name record is used to look up the alias for a given hostname. The PTR, or pointer record, is used to look up IP addresses and return FQDNs that are mapped to them. The AAAA record is used to lookup an IPv6 address for a given hostname."
    },
    {
       "id":681,
       "topic_id":4,
       "sub_domain":"4.3 Explain the role of DHCP and DNS within the network",
       "practice_test_id":"",
       "question":"What limits the amount of time that a DNS entry is available in the DNS cache?",
       "choice_a":"An A record",
       "choice_b":"TTL",
       "choice_c":"SOA",
       "choice_d":"Default of 5 minutes",
       "correct_answer":"B",
       "explanation":"The time to live, or TTL, limits the amount of time a DNS entry will be available in the DNS cache. The TTL can be defined by the DNS administrator on the entry, or it can be defined in the SOA record as the default TTL. An A record is used to look up an IP address for a given hostname with DNS name resolution. The Start of Authority (SOA) is the first record in a DNZ zone that explains where to find other servers and parameters for zone operation. The TTL does not default to 5 minutes; the default TTL is defined in the SOA record."
    },
    {
       "id":682,
       "topic_id":4,
       "sub_domain":"4.3 Explain the role of DHCP and DNS within the network",
       "practice_test_id":1,
       "question":"Which message is sent from the DHCP client to the DHCP server to confirm the offer of an IP address?",
       "choice_a":"Acknowledgment",
       "choice_b":"Discover",
       "choice_c":"Offer",
       "choice_d":"Request",
       "correct_answer":"D",
       "explanation":"The DHCP acknowledgment message is sent from the DHCP client to the DHCP server to acknowledge that the IP address offered will be used by the client. The Discover message is the first message that is sent by the client to discover a DHCP server on the local network. The Offer message is sent by the DHCP server to offer an IP address lease to the client. The Request message is sent from the client to the DHCP server to confirm the offer of an IP address"
    },
    {
       "id":683,
       "topic_id":4,
       "sub_domain":"4.3 Explain the role of DHCP and DNS within the network",
       "practice_test_id":"",
       "question":"What form of communication does a DHCP client use to initially acquire an IP address?",
       "choice_a":"Layer 3 broadcast",
       "choice_b":"Layer 3 multicast",
       "choice_c":"Layer 3 802.1Q",
       "choice_d":"Layer 3 unicast",
       "correct_answer":"A",
       "explanation":"DHCP uses layer 3 broadcasts by sending packets to 255.255.255.255 for initial DHCP discovery. Layer 3 multicast is not used for DHCP clients. Layer 3 802.1Q is an incorrect answer because 802.1Q is used for switch trunks. Layer 3 unicasts are the form of communication clients use after obtaining an IP address."
    },
    {
       "id":684,
       "topic_id":4,
       "sub_domain":"4.3 Explain the role of DHCP and DNS within the network",
       "practice_test_id":"",
       "question":"At what point of the lease time will the client ask for a renewal of the IP address from the DHCP server?",
       "choice_a":"One-quarter of the lease",
       "choice_b":"One-half of the lease",
       "choice_c":"Seven-eighths of the lease",
       "choice_d":"End of the lease",
       "correct_answer":"B",
       "explanation":"DHCP clients request a renewal of the lease halfway through the lease time of the IP address. One-quarter of the lease is an incorrect answer. Seven-eighths of the lease is called the rebind time, where the client will accept a new IP address from any DHCP server. The end of the lease is when the client must relinquish the IP address."
    },
    {
       "id":685,
       "topic_id":4,
       "sub_domain":"4.3 Explain the role of DHCP and DNS within the network",
       "practice_test_id":"",
       "question":"Which statement is correct about the DHCP process?",
       "choice_a":"The DHCP server is responsible for maintaining the life cycle of an IP address.",
       "choice_b":"DHCP uses multicasting between the client and server.",
       "choice_c":"The DHCP client is responsible for maintaining the life cycle of an IP address.",
       "choice_d":"The DHCP lease is negotiated between client and server.",
       "correct_answer":"C",
       "explanation":"After the initial Discover, Offer, Request, and Acknowledge, it is the client's responsibility to maintain the lease of the IP address. This includes release and renewal. The DHCP server is not responsible for maintaining the life cycle of an IP address. DHCP does not use multicasting between the client and server. The DHCP lease is mandated by the configuration on the DHCP server."
    },
    {
       "id":686,
       "topic_id":4,
       "sub_domain":"4.3 Explain the role of DHCP and DNS within the network",
       "practice_test_id":"",
       "question":"Which transport protocol does DHCP use?",
       "choice_a":"UDP",
       "choice_b":"ICMP",
       "choice_c":"TCP",
       "choice_d":"RARP",
       "correct_answer":"A",
       "explanation":"DHCP uses UDP as a connectionless protocol for the Discover, Offer, Request, and Acknowledge packets. ICMP is used by Ping and Traceroute to verify the response and path of a packet. TCP is not used by DHCP. RARP is not used by DHCP; it is considered an alternate method of assigning an IP address to a client."
    },
    {
       "id":687,
       "topic_id":4,
       "sub_domain":"4.3 Explain the role of DHCP and DNS within the network",
       "practice_test_id":"",
       "question":"What happens when a router or switch detects a duplicate IP address for a DHCP process?",
       "choice_a":"The IP address is still served to the client.",
       "choice_b":"The IP address is removed from the DHCP pool.",
       "choice_c":"The DHCP server will halt.",
       "choice_d":"The DHCP will serve the IP address in the future.",
       "correct_answer":"B",
       "explanation":"When DHCP detects a duplicate IP address in the pool, it will remove the duplicate IP address from the DHCP pool and place it into the conflict table. It will require manual intervention to reserve the IP address. The IP address is placed into a conflict table, and therefore, it is not served to any client. The DHCP server will continue to serve other available IP addresses in the DHCP pool. The duplicate IP address can only be served in the future if it is cleared from the conflict table."
    },
    {
       "id":688,
       "topic_id":4,
       "sub_domain":"4.4 Explain the function of SNMP in network operations",
       "practice_test_id":4,
       "question":"Which version of SNMP offers authentication and encryption?",
       "choice_a":"SNMP version 1",
       "choice_b":"SNMP version 2e",
       "choice_c":"SNMP version 2c",
       "choice_d":"SNMP version 3",
       "correct_answer":"D",
       "explanation":"SNMP version 3 introduced message integrity, authentication, and encryption to the SNMP suite. SNMP version 1 was the first release of SNMP and considered deprecated. SNMP version 2e is not a valid version of SNMP. SNMP version 2c is an amendment of SNMP version 2 that added the SET command and other improvements."
    },
    {
       "id":689,
       "topic_id":4,
       "sub_domain":"4.4 Explain the function of SNMP in network operations",
       "practice_test_id":5,
       "question":"What is the database of variables that SNMP uses to allow for collection of data?",
       "choice_a":"Object identifiers (OIDs)",
       "choice_b":"Management information base",
       "choice_c":"SNMP agent",
       "choice_d":"SNMP communitystring",
       "correct_answer":"B",
       "explanation":"The management information base, or MIB, is a database of variables in which SNMP allows retrieval of information. The attributes in the MIB are the description, variable type, and read-write status. Object identifiers (OIDs) are the addressable counters that are arranged in a hierarchically fashion. The SNMP agent is the software on the client that allows SNMP to collect or pass information. The SNMP community string is used to restrict communications to only the clients or servers that have a matching SNMP community string."
    },
    {
       "id":690,
       "topic_id":4,
       "sub_domain":"4.4 Explain the function of SNMP in network operations",
       "practice_test_id":"",
       "question":"What is the component that an SNMP agent sends information to?",
       "choice_a":"Syslog",
       "choice_b":"Network management station",
       "choice_c":"Object identifier",
       "choice_d":"Management information base",
       "correct_answer":"B",
       "explanation":"The network management station (NMS) is a server to which SNMP is polled back or in which SNMP information is trapped. The NMS can escalate problems via email, text message, or even visual indicators. Examples of NMS systems are Solar winds Orion and Open NMS. The syslog is a logging file where system messages are sent. The object identifier (OID) is used to describe the SNMP counter being requested. The management information base (MIB) is a sort of database of counters that SNMP can use for a specific device."
    },
    {
       "id":691,
       "topic_id":4,
       "sub_domain":"4.4 Explain the function of SNMP in network operations",
       "practice_test_id":1,
       "question":"What type of SNMP message is sent to a network management station when an interface goes down?",
       "choice_a":"Get-request message",
       "choice_b":"Get-response message",
       "choice_c":"Set-request message",
       "choice_d":"Trap message",
       "correct_answer":"D",
       "explanation":"Trap messages are sent from the network device to the SNMP network management station when an event has triggered over a set threshold on the device. An example of an event to be trapped is an interface going down or a restriction by port security. The get-request message is used by an NMS to request information from an SNMP agent. The get-response message is the message sent back from the client to the NMS after a get-request message is received. The set-request message is sent by the NMS to the SNMP client requesting a specific writable counter be set to the specified value."
    },
    {
       "id":692,
       "topic_id":4,
       "sub_domain":"4.4 Explain the function of SNMP in network operations",
       "practice_test_id":"",
       "question":"Which of the following is a hierarchical set of variables that make up the management information base?",
       "choice_a":"Object identigiers (OIDs)",
       "choice_b":"The SNMP community string",
       "choice_c":"The SNMP agent",
       "choice_d":"SNMP messages",
       "correct_answer":"A",
       "explanation":"OIDs are the variables that make up the management information base. Each object has a unique ID in a hierarchical format in the form of a tree. As an example, 1.3.6.1.4.9.2.1.58.0 is the object that holds the router CPU utilization variable. The SNMP community string is used to restrict communications to only the clients or servers that have a matching SNMP community string. The SNMP agent is the software on the client that allows SNMP to collect or pass information. SNMP messages are the data relayed with the various SNMP verb commands, such as, for example, get, set, and inform, to name a few."
    },
    {
       "id":693,
       "topic_id":4,
       "sub_domain":"4.4 Explain the function of SNMP in network operations",
       "practice_test_id":"",
       "question":"What is the difference between trap messages and inform messages for SNMP?",
       "choice_a":"Trap messages are always encrypted.",
       "choice_b":"Inform messages do not use acknowledgments.",
       "choice_c":"Trap messages always use acknowledgments.",
       "choice_d":"Inform messages always use acknowledgments.",
       "correct_answer":"D",
       "explanation":"Inform messages differ from trap messages with respect to acknowledgment. Trap messages employ a best effort delivery utilizing UDP. Inform messages employ acknowledgments; while they use the User Datagram Protocol (UDP), they rely on the Application layer for acknowledgments. Trap messages are not always encrypted and can be sent with plain text. Inform messages use acknowledgments at the Application layer. Trap messages do not use acknowledgments."
    },
    {
       "id":694,
       "topic_id":4,
       "sub_domain":"4.4 Explain the function of SNMP in network operations",
       "practice_test_id":"",
       "question":"Which security method does SNMP version 2c employ?",
       "choice_a":"Encryption",
       "choice_b":"User authentication",
       "choice_c":"Community strings",
       "choice_d":"Message integrity",
       "correct_answer":"C",
       "explanation":"SNMP version 2c is identical to SNMP version 1 with respect to security. Both transmit information in clear text and use the security of community strings to authenticate users for access to information. SNMP version 2c does not employ encryption. SNMP version 2c does not employ user authentication. SNMP version 2c does not employ message integrity."
    },
    {
       "id":695,
       "topic_id":4,
       "sub_domain":"4.4 Explain the function of SNMP in network operations",
       "practice_test_id":4,
       "question":"Which of the following can be used in conjunction with an SNMP agent configuration for added security?",
       "choice_a":"Encrypted communities",
       "choice_b":"Access control lists",
       "choice_c":"SNMP callback security",
       "choice_d":"SHA-256",
       "correct_answer":"B",
       "explanation":"Standard access control lists can be used in conjunction with the SNMP agent configuration. First a standard ACL is created containing the NMS IP. Then, when the <code>snmp-server</code> command is used, it becomes the last argument. For example, a standard ACL of 2 would be added as follows: <code>snmp-server community snmp read only read-only 2.</code> There is no such thing as encrypted communities. There is no such thing as SNMP callback security; callback security is related to PPP. SNMP does not employ SHA-256 as its encryption protocol."
    },
    {
       "id":696,
       "topic_id":4,
       "sub_domain":"4.4 Explain the function of SNMP in network operations",
       "practice_test_id":5,
       "question":"Which command(s) will configure SNMPv2c to trap messages to a network management station in the event of component failure?",
       "choice_a":"<code>Switch(config)#snmp-server 192.168.1.5 version 2c C0mmun1ty</code><br><code>Switch(config)#snmp-server enable traps</code>",
       "choice_b":"<code>Switch(config)#snmp-server host 192.168.1.5 version 2c</code><br><code>Switch(config)#snmp-server enable traps</code>",
       "choice_c":"<code>Switch(config)#snmp-server host 192.168.1.5 version 2c C0mmun1ty</code><br><code>Switch(config)#snmp-server enable traps</code>",
       "choice_d":"<code>Switch(config)#snmp contact trap 192.168.1.5 version 2c</code>",
       "correct_answer":"C",
       "explanation":"The first portion of the command, <code>snmp-server host 192.168.1.5,</code> will configure the SNMP agent to send traps to the host 192.168.1.5. The second portion of the command, <code>version 2c C0mmun1ty,</code> sets the SNMP version to 2c and the community to \u0022C0mmun1ty.\u0022 All of the other command configurations are incorrect."
    },
    {
       "id":697,
       "topic_id":4,
       "sub_domain":"4.4 Explain the function of SNMP in network operations",
       "practice_test_id":"",
       "question":"Which protocol and port number does SNMP use for trap and inform messages to the NMS?",
       "choice_a":"UDP/161",
       "choice_b":"TCP/162",
       "choice_c":"UDP/162",
       "choice_d":"UDP/514",
       "correct_answer":"C",
       "explanation":"SNMP uses UDP port 162 for communication from an SNMP agent to the network management station for trap and inform messages. SNMP agents listen on UDP/161. SNMP does not use TCP for messaging. UDP/514 is used for syslog messaging."
    },
    {
       "id":698,
       "topic_id":4,
       "sub_domain":"4.4 Explain the function of SNMP in network operations",
       "practice_test_id":"",
       "question":"Which command will allow you to verify the network management station that is configured to receive trap notifications?",
       "choice_a":"<code>Switch#show snmp</code>",
       "choice_b":"<code>Switch#show snmp community</code>",
       "choice_c":"<code>Switch#show snmp host</code>",
       "choice_d":"<code>Switch#show snmp notifications</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show snmp host</code> will display the host that is configured to receive notifications of trap or inform messages from the router or switch. The command <code>show snmp</code> is incorrect. The command <code>show snmp community</code> is incorrect. The command <code>show snmp notifications</code> is incorrect."
    },
    {
       "id":699,
       "topic_id":4,
       "sub_domain":"4.4 Explain the function of SNMP in network operations",
       "practice_test_id":"",
       "question":"When you configure SNMPv3 for a restricted OID, what is the first step?",
       "choice_a":"Configuring a group",
       "choice_b":"Configuring a view",
       "choice_c":"Configuring a user",
       "choice_d":"Configuring a community",
       "correct_answer":"B",
       "explanation":"When you begin to configure SNMPv3 for a restricted OID, the first step is configuring a view. The view allows or restricts what the user will have access to. All of the other options come after configuring a view."
    },
    {
       "id":700,
       "topic_id":4,
       "sub_domain":"4.5 Describe the use of syslog features including facilities and levels",
       "practice_test_id":"",
       "question":"Which protocol and port number does syslog use?",
       "choice_a":"UDP/161",
       "choice_b":"TCP/162",
       "choice_c":"UDP/162",
       "choice_d":"UDP/514",
       "correct_answer":"D",
       "explanation":"The router or switch sends syslog messages to the syslog server on port 514 with UDP. SNMP agents listen on UDP/161. SNMP does not use TCP for messaging. SNMP sends traps on UDP/162."
    },
    {
       "id":701,
       "topic_id":4,
       "sub_domain":"4.5 Describe the use of syslog features including facilities and levels",
       "practice_test_id":"",
       "question":"Which command will configure the severity level of syslog events that will be sent to the syslog server for debugging?",
       "choice_a":"<code>Router(config)#syslog debugging</code>",
       "choice_b":"<code>Router(config)#logging debugging</code>",
       "choice_c":"<code>Router(config)#logging trap debugging</code>",
       "choice_d":"<code>Router(config)#log-level debugging</code>",
       "correct_answer":"C",
       "explanation":"The command <code>logging trap debugging</code> will configure syslog events to be sent to the syslog server for the severity levels of debugging(7) through emergency(0). The command <code>syslog debugging</code> is incorrect. The command <code>logging debugging</code> is incorrect. The command <code>log-level debugging</code> is incorrect."
    },
    {
       "id":702,
       "topic_id":4,
       "sub_domain":"4.5 Describe the use of syslog features including facilities and levels",
       "practice_test_id":"",
       "question":"Which command will send all warnings to the syslog server?",
       "choice_a":"<code>Switch(config)#logging server 4</code>",
       "choice_b":"<code>Switch(config)#logging trap 4</code>",
       "choice_c":"<code>Switch(config)#logging trap 5</code>",
       "choice_d":"<code>Switch(config)#logging server 5</code>",
       "correct_answer":"B",
       "explanation":"The command <code>logging trap 4</code> will trap all messages with warnings to the syslog server. The command <code>logging server 4</code> is incorrect. The command <code>logging trap 5</code> is incorrect, as it will send all notice messages. The command <code>logging server 5</code> is incorrect."
    },
    {
       "id":703,
       "topic_id":4,
       "sub_domain":"4.5 Describe the use of syslog features including facilities and levels",
       "practice_test_id":"",
       "question":"Which command will send logging with time stamps rather than sequence numbers?",
       "choice_a":"<code>Switch(config)#logging timestamps log datetime</code>",
       "choice_b":"<code>Switch(config)#logging timestamps datetime</code>",
       "choice_c":"<code>Switch(config)#service datetime timestamps</code>",
       "choice_d":"<code>Switch(config)#service timestamps log datetime</code>",
       "correct_answer":"D",
       "explanation":"The command <code>service timestamps log datetime</code> will configure syslog messages to be logged with the date and time rather than the arbitrary sequence number. The command <code>logging timestamps log datetime</code> is incorrect. The command <code>logging timestamps datetime</code> is incorrect. The command <code>service datetime timestamps</code> is incorrect."
    },
    {
       "id":704,
       "topic_id":4,
       "sub_domain":"4.5 Describe the use of syslog features including facilities and levels",
       "practice_test_id":4,
       "question":"Which command will limit console logging to the severity level of alerts?",
       "choice_a":"<code>Router(config)#logging console 0</code>",
       "choice_b":"<code>Router(config-line)#logging level 0</code>",
       "choice_c":"<code>Router(config)#logging console 7</code>",
       "choice_d":"<code>Router(config-line)#logging level 7</code>",
       "correct_answer":"A",
       "explanation":"The command <code>logging console 0</code> will configure the logging to the console for the severity level of facility 0, which is alerts. The <code>logging</code> command is not configured in the config-line prompt, therefore, both options B and D are incorrect. The command <code>logging console 7</code> is incorrect because it sets the logging level to debug."
    },
    {
       "id":705,
       "topic_id":4,
       "sub_domain":"4.5 Describe the use of syslog features including facilities and levels",
       "practice_test_id":5,
       "question":"Which command will configure logging stored in RAM to include only logs with a severity level of emergencies and alerts?",
       "choice_a":"<code>Switch(config)#logging buffered 1</code>",
       "choice_b":"<code>Switch(config)#logging 1</code>",
       "choice_c":"<code>Switch(config)#logging buffered 2</code>",
       "choice_d":"<code>Switch(config)#logging 2</code>",
       "correct_answer":"A",
       "explanation":"The command <code>logging buffered 1</code> will configure the logs stored in RAM, which is buffered to a severity of 1. This command will include severity levels 1 and 0. The command <code>logging 1</code> is incorrect. The command <code>logging buffered 2</code> will set the logging level to critical events. The command <code>logging 2</code> is incorrect."
    },
    {
       "id":706,
       "topic_id":4,
       "sub_domain":"4.5 Describe the use of syslog features including facilities and levels",
       "practice_test_id":1,
       "question":"Which command will allow you to see the commands you previously entered?",
       "choice_a":"<code>Switch#show commands</code>",
       "choice_b":"<code>Switch#show log</code>",
       "choice_c":"<code>Switch#show history</code>",
       "choice_d":"<code>Switch#show buffer</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show history</code> will show the last commands typed, which are kept in the buffer. The history normally includes the last 10 commands. The command <code>show commands</code> is incorrect. The command <code>show log</code> is incorrect as it will display the logs. The command <code>show buffer</code> is incorrect."
    },
    {
       "id":707,
       "topic_id":4,
       "sub_domain":"4.5 Describe the use of syslog features including facilities and levels",
       "practice_test_id":"",
       "question":"What severity is being logged to in the following exhibit?<img src='/question_assets/ccna/4_image7.png'></img>",
       "choice_a":"Informational (6)",
       "choice_b":"Notifications (5)",
       "choice_c":"Warnings (4)",
       "choice_d":"Debugging (7)",
       "correct_answer":"B",
       "explanation":"Line protocol up/down messages are logged to the notifications (5) severity level. This can be determined by looking up the 5 that appears after the affected component of line protocol in the syslog severity chart. For example, <code>%LINEPROTO-5-UPDOWN</code> specifies the severity level of 5 for the line protocol. All of the other options are incorrect."
    },
    {
       "id":708,
       "topic_id":4,
       "sub_domain":"4.5 Describe the use of syslog features including facilities and levels",
       "practice_test_id":"",
       "question":"You need to check the current CPU utilization on a router. Which command will achieve this?",
       "choice_a":"<code>Router#show cpu</code>",
       "choice_b":"<code>Router#show cpu-stats</code>",
       "choice_c":"<code>Router#show processes</code>",
       "choice_d":"<code>Router#show environment cpu</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show processes</code> will display the utilization of the CPU. The first line of the output is broken down by 5 second utilization, 1 minute utilization, and 5 minute utilization. The command <code>show cpu</code> is incorrect. The command <code>show cpu-stats</code> is incorrect. The command <code>show environment cpu</code> is incorrect."
    },
    {
       "id":709,
       "topic_id":4,
       "sub_domain":"4.5 Describe the use of syslog features including facilities and levels",
       "practice_test_id":"",
       "question":"Which command will direct logging to the internal log space?",
       "choice_a":"<code>Router(config)#logging buffered</code>",
       "choice_b":"<code>Router(config)#logging internal</code>",
       "choice_c":"<code>Router(config)#logging ram</code>",
       "choice_d":"<code>Router(config)#logging console</code>",
       "correct_answer":"A",
       "explanation":"The command <code>logging buffered</code> will direct buffering of log messages to RAM. This command can be undone by using the no directive in front of logging buffered. The command must be entered in global configuration mode. The command <code>logging internal</code> is incorrect. The command <code>logging ram</code> is incorrect. The command <code>logging console</code> is incorrect."
    },
    {
       "id":710,
       "topic_id":4,
       "sub_domain":"4.5 Describe the use of syslog features including facilities and levels",
       "practice_test_id":"",
       "question":"What is the default destination to which Cisco devices send syslog messages?",
       "choice_a":"Broadcasts to a syslog server",
       "choice_b":"Console",
       "choice_c":"TTY",
       "choice_d":"NVRAM",
       "correct_answer":"B",
       "explanation":"By default, all syslog messages are sent to the console of the router or switch. It is recommended to configure a syslog server, because once the router or switch is powered off, the information is lost. Syslog messages are never broadcasted, but they can be directed to a syslog server. Syslog messages can only be sent to the connected TTY if the command <code>terminal monitor</code> is entered. Syslog messages cannot be sent to NVRAM."
    },
    {
       "id":711,
       "topic_id":4,
       "sub_domain":"4.5 Describe the use of syslog features including facilities and levels",
       "practice_test_id":"",
       "question":"What is the default level for syslog facility logging?",
       "choice_a":"Notification (5)",
       "choice_b":"Informational (6)",
       "choice_c":"Warning (4)",
       "choice_d":"Debugging (7)",
       "correct_answer":"D",
       "explanation":"The default syslog facility level is debugging(7). All debugging messages are logged to the internal buffer by default.Notification (5) is not the default level for syslog logging. Informational (6) is not the default level for syslog logging. Warning (4) is not the default level for syslog logging."
    },
    {
       "id":712,
       "topic_id":4,
       "sub_domain":"4.6 Configure and verify DHCP client and relay",
       "practice_test_id":"",
       "question":"Which command will allow you to verify the active DHCP server that has assigned an IP address to the router?",
       "choice_a":"<code>Router#show dhcp lease</code>",
       "choice_b":"<code>Router#show ip dhcp lease</code>",
       "choice_c":"<code>Router#show ip lease</code>",
       "choice_d":"<code>Router#show ip interface</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show dhcp lease</code> will help you verify the IP address configured on the router, the DHCP server that served the lease, and the lease time in seconds. The command <code>show ip dhcp lease</code> is incorrect. The command <code>show ip lease</code> is incorrect. The command <code>show ip interface</code> is incorrect."
    },
    {
       "id":713,
       "topic_id":4,
       "sub_domain":"4.6 Configure and verify DHCP client and relay",
       "practice_test_id":4,
       "question":"Which statement is true about the Offer packet of DHCP?",
       "choice_a":"The layer 3 destination is a unicast to the DHCP client.",
       "choice_b":"The layer 2 destination is the MAC address of the DHCP client.",
       "choice_c":"The layer 2 source is the MAC address of the server.",
       "choice_d":"The layer 3 source is a link-local address of the client.",
       "correct_answer":"C",
       "explanation":"The DHCP Offer packet is a broadcast packet from the DHCP server to the DHCP client. The layer 3 packet and layer 2 frame are both broadcasts. The layer 3 destination to the DHCP client is not a unicast. The layer 2 destination of the Offer packet is a broadcast and therefore not the destination MAC address of the client. Link-local addressing is not used for DHCP."
    },
    {
       "id":714,
       "topic_id":4,
       "sub_domain":"4.6 Configure and verify DHCP client and relay",
       "practice_test_id":5,
       "question":"Which command will configure a DHCP relay agent on an interface to the DHCP server of 10.10.1.101?",
       "choice_a":"<code>Router(config)#ip dhcp server 10.10.1.101</code>",
       "choice_b":"<code>Router(config-if)#ip dhcp server 10.10.1.101</code>",
       "choice_c":"<code>Router(config-if)#ip relay-agent 10.10.1.101</code>",
       "choice_d":"<code>Router(config-if)#ip helper-address 10.10.1.101</code>",
       "correct_answer":"D",
       "explanation":"The command <code>ip helper-address 10.10.1.101</code> will configure the interface to become a DHCP relay agent. This command must be configured on the interface in which you want the DHCP relay agent to listen and respond. The command <code>ip dhcp server 10.10.1.101</code> configured in the global configuration prompt is incorrect. The command <code>ip dhcp server 10.10.1.101</code> configured in the interface configuration prompt is incorrect. The command <code>ip relay-agent 10.10.1.101</code> is incorrect."
    },
    {
       "id":715,
       "topic_id":4,
       "sub_domain":"4.6 Configure and verify DHCP client and relay",
       "practice_test_id":"",
       "question":"Which DHCP field helps a DHCP server decide which scope to serve to the DHCP relay agent?",
       "choice_a":"CIADDR",
       "choice_b":"GIADDR",
       "choice_c":"SIADDR",
       "choice_d":"CHADDR",
       "correct_answer":"B",
       "explanation":"The Gateway Address (GIADDR) field is filled out by the DHCP relay agent before the DHCP packet is sent to the DHCP server. This field helps the DHCP server decide which scope to send an Offer message back for. The CIADDR field is used for the client IP address and not used to determine scope selection. The SIADDR field is used for the server IP address and not used to determine scope selection. The CHADDR is the client hardware address and not used to determine scope selection."
    },
    {
       "id":716,
       "topic_id":4,
       "sub_domain":"4.6 Configure and verify DHCP client and relay",
       "practice_test_id":"",
       "question":"In the following exhibit, what is required on the network to allow Host A to receive an IP address from the existing DHCP server?<img src='/question_assets/ccna/4_image8.png'></img>",
       "choice_a":"A second DHCP server on the Host A network",
       "choice_b":"A DHCP relay agent on Router B interface Gi0/0",
       "choice_c":"A DHCP relay agent on Switch A",
       "choice_d":"A DHCP relay agent on Router A interface Gi0/0",
       "correct_answer":"D",
       "explanation":"A DHCP relay agent installed on Router A interface Gi0/0 will allow clients on Host A's network to obtain IP addressing from DHCP. A second DHCP server on the network where Host A is located will not satisfy the requirement of using the existing DHCP server. A DHCP relay agent on the interface Gi0/0 located on Router B will not help serve IP addresses on the Host A network. A DHCP relay agent cannot be configured on a layer 2 switch."
    },
    {
       "id":717,
       "topic_id":4,
       "sub_domain":"4.6 Configure and verify DHCP client and relay",
       "practice_test_id":1,
       "question":"Which command will allow you to diagnose DHCP relay agent messages on a router or switch?",
       "choice_a":"<code>Router#debug dhcp</code>",
       "choice_b":"<code>Router#show ip dhcp detail</code>",
       "choice_c":"<code>Router#debug ip dhcp server packet</code>",
       "choice_d":"<code>Router#debug ip dhcp</code>",
       "correct_answer":"C",
       "explanation":"The command <code>debug ip dhcp server packet</code> will show the details of a DHCP relay agent conversation. It will detail conversation between the client and router and the router and the DHCP server. The command <code>debug dhcp</code> is incorrect. The command <code>show ip dhcp detail</code> is incorrect. The command <code>debug ip dhcp</code> is incorrect."
    },
    {
       "id":718,
       "topic_id":4,
       "sub_domain":"4.6 Configure and verify DHCP client and relay",
       "practice_test_id":"",
       "question":"What is DHCPv6 used for when a network is configured for Stateless Address Autoconfiguration (SLAAC)?",
       "choice_a":"Stateful configuration of clients for IPv6 addressing",
       "choice_b":"Configuration of clients with the IPv6 network IDs",
       "choice_c":"Configuration of clients with IPv6 options",
       "choice_d":"Stateless configuration of clients for IPv6 addressing",
       "correct_answer":"C",
       "explanation":"Stateless Address Autoconfiguration (SLAAC) allows for the client to learn the network ID and calculate a host ID that is unique. However, SLAAC is lacking the ability to configure options such as DNS time servers, etc. DHCPv6 allows for the configuration of these options when used in conjunction with SLAAC. DHCPv6 configured for SLAAC is not used for stateful configuration of client IPv6 addressing. DHCPv6 configured for SLAAC will not provide network IDs. IPv6 by default provides stateless configuration of clients with IPv6 addressing; DHCPv6 compliments this stateless configuration."
    },
    {
       "id":719,
       "topic_id":4,
       "sub_domain":"4.6 Configure and verify DHCP client and relay",
       "practice_test_id":"",
       "question":"The DHCP server in the network went down. What happens to clients that have obtained IP addresses from the DHCP server?",
       "choice_a":"They lose their IP address immediately.",
       "choice_b":"They lose their IP address after one-half of their lease has expired.",
       "choice_c":"They lose their IP address after seven-eighths of their lease has expired.",
       "choice_d":"They lose their IP address after their entire lease has expired.",
       "correct_answer":"D",
       "explanation":"They will lose their IP after their entire lease has expired. Until the lease expires, they will have functioning IP addresses. Clients will not lose their IP address immediately because the server is only needed for renewals after the initial IP address lease is obtained. The host requests a renewal for the lease at one-half of the lease time, but if a response is not heard, the host will retain its original lease. After seven-eighths of the lease time, the host will attempt to find a new server to rebind the original lease of the IP address. If a rebind does not occur, the IP address will remain active until the end of the lease."
    },
    {
       "id":720,
       "topic_id":4,
       "sub_domain":"4.6 Configure and verify DHCP client and relay",
       "practice_test_id":"",
       "question":"Which statement is correct about stateful DHCPv6?",
       "choice_a":"Stateful DHCPv6 supplies the network ID and host ID.",
       "choice_b":"Stateful DHCPv6 supplies the network ID, host ID, and default router.",
       "choice_c":"Stateful DHCPv6 communicates via broadcasts.",
       "choice_d":"Stateful DHCPv6 works in conjunction with SLAAC.",
       "correct_answer":"A",
       "explanation":"Stateful DHCPv6 supplies the network ID and host ID. The default router is discovered through the Neighbor Discovery Protocol (NDP). Stateful DHCPv6 only supplies the network ID and host ID to the client; the default router is also discovered through the Neighbor Discovery Protocol. IPv6 uses multicasts, not broadcasts, to communicate. Stateful DHCPv6 is a replacement for the process of Stateless Address Autoconfiguration (SLAAC)."
    },
    {
       "id":721,
       "topic_id":4,
       "sub_domain":"4.6 Configure and verify DHCP client and relay",
       "practice_test_id":4,
       "question":"Which command will configure a router interface to obtain its IP address via a stateful DHCPv6?",
       "choice_a":"<code>RouterA(config)#ipv6 address dhcpgi 0/0</code>",
       "choice_b":"<code>RouterA(config-if)#ipv6 address dhcpv6</code>",
       "choice_c":"<code>RouterA(config-if)#ipv6 address dhcp</code>",
       "choice_d":"<code>RouterA(config)#ipv6 address stateless</code>",
       "correct_answer":"C",
       "explanation":"The command <code>ipv6 address dhcp</code> will configure the interface to obtain its IP address via stateful DHCPv6. The command <code>ipv6 address dhcpgi 0/0</code> is incorrect. The command <code>ipv6 address dhcpv6</code> is incorrect. The command <code>ipv6 address stateless</code> is incorrect."
    },
    {
       "id":722,
       "topic_id":4,
       "sub_domain":"4.6 Configure and verify DHCP client and relay",
       "practice_test_id":5,
       "question":"What happens if you delete a current lease on the DHCP server?",
       "choice_a":"The server will contact the client to immediately relinquish the IP address.",
       "choice_b":"The client will immediately renew its lease for the current IP address.",
       "choice_c":"The server will offer the IP address to another node, which will cause a duplicate address.",
       "choice_d":"The server will offer the IP address to another node, at which time the original client will relinquish the IP address.",
       "correct_answer":"C",
       "explanation":"When the lease for a node is deleted on the DHCP server, the DHCP server is free to hand out the lease to another node. This happens independently from the client, as there is no communication from server to client about the lease. The client will retain the IP address until the renewal period, which will cause a duplication of IP addressing. The client is responsible for the management of the lease cycle; therefore, the server has no obligation to contact the client when the lease is deleted. The client will not know to contact the server for a renewal of the lease until the halfwaypoint of the lease cycle. If or when the server issues the lease to another client, the existing client will still maintain the original lease."
    },
    {
       "id":723,
       "topic_id":4,
       "sub_domain":"4.6 Configure and verify DHCP client and relay",
       "practice_test_id":"",
       "question":"What happens at the client when the lease for an IP address reaches seven-eighths of the lease cycle?",
       "choice_a":"The DHCP client will perform a DHCP rebinding.",
       "choice_b":"Nothing. The DHCP client will retain the lease.",
       "choice_c":"The DHCP client will renew its lease.",
       "choice_d":"The DHCP client will relinquish the use of the IP address.",
       "correct_answer":"A",
       "explanation":"At seven-eighths of the lease cycle, the DHCP client will perform a rebinding. The rebinding process means that the original DHCP server was down at the one-half mark of the lease, so now the client will try to rebind with any responding DHCP server. The DHCP client will retain the lease until the end of the lease cycle, but at seven-eighths the client will try to rebind with any listening DHCP server. During the rebind the DHCP client will attempt to renew a new lease with any DHCP server. The DHCP client will not relinquish the IP address until the very end of the lease."
    },
    {
       "id":724,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":"",
       "question":"How do routers classify traffic for QoS?",
       "choice_a":"Access control lists",
       "choice_b":"Layer 2 ASICs",
       "choice_c":"Route tables",
       "choice_d":"Frame filters",
       "correct_answer":"A",
       "explanation":"QoS classifies traffic with access control lists and applies markings to the packets. Layer 2 ASICs help process the QoS but do not classify the QoS for traffic. Route tables are used for routing and therefore have no effect on QoS. Frame filters are used to forward/filter frames to their destination port; they are part of the switching process."
    },
    {
       "id":725,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":"",
       "question":"Which measurement describes the variation of consecutive packet time from source to destination?",
       "choice_a":"Bandwidth",
       "choice_b":"Delay",
       "choice_c":"Jitter",
       "choice_d":"Loss",
       "correct_answer":"C",
       "explanation":"Jitter is the measurement of variation between consecutive packet times from source to destination (one-way delay). For example, if the first packet takes 10 ms and the second, third, and fourth take 10 ms, the jitter, or variance, is 0 ms. The simple calculation is an average of packet times. However, data size has an influence on jitter, so the more accurate calculation is J = J + (D (I - 1 , I) - J) / 16. Bandwidth is the total width of data that can be passed for a specific interval. Delay is the measurement of how long a packet takes to travel from source to destination. Loss is the total amount of packets that are not delivered from source to destination."
    },
    {
       "id":726,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":"",
       "question":"Which is a true statement about the Class of Service field?",
       "choice_a":"The Class of Service field is a layer 3 field.",
       "choice_b":"The Class of Service field is only present in 802.1Q frames.",
       "choice_c":"The Class of Service field is present from end to end of a transmission.",
       "choice_d":"The Class of Service field is 6 bits.",
       "correct_answer":"B",
       "explanation":"The Class of Service field (802.1p) is only found in layer 2 transmissions, specifically only across trunks due to the dependency of 802.1Q. The CoS field is a 3-bit field in the 802.1Q frame type. The CoS field does not need to be present from end to end of a transmission because the transmission can traverse a router. The CoS field is a 3-bit field, not a 6-bit field."
    },
    {
       "id":727,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":"",
       "question":"What is the measurement of packets discarded due to congestion of queues?",
       "choice_a":"Bandwidth",
       "choice_b":"Delay",
       "choice_c":"Jitter",
       "choice_d":"Loss",
       "correct_answer":"D",
       "explanation":"Loss is the measurement of discarded packets. The measurement is a percentage of transmitted packets. For example, if 100 packets are transmitted and 3 packets are dropped, then the loss is 3%. Loss can be attributed to congestions, faulty wiring, EMI, or device queue congestion. Bandwidth is the total width of data that can be passed for a specific interval. Delay is the measurement of how long a packet takes to travel from source to destination. Jitter is the measurement of variation between consecutive packet times from source to destination (one-way delay)."
    },
    {
       "id":728,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":"",
       "question":"Which DSCP marking has the highest priority?",
       "choice_a":"DSCP AF 43",
       "choice_b":"DSCP EF 46",
       "choice_c":"DSCP AF 11",
       "choice_d":"DSCP AF 00",
       "correct_answer":"B",
       "explanation":"The standardized marking of DSCP EF, or Expedite Forwarding, is a decimal equivalent of 46. This marking has the highest priority and should be used for VoIP traffic and video. DSCP AF 43 is an incorrect answer. DSCP AF 11 is an incorrect answer. DSCP AF 00 is an incorrect answer."
    },
    {
       "id":729,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":"",
       "question":"What is the recommended maximum delay VoIP traffic should not exceed?",
       "choice_a":"10 ms",
       "choice_b":"90 ms",
       "choice_c":"150 ms",
       "choice_d":"300 ms",
       "correct_answer":"C",
       "explanation":"The maximum delay that VoIP traffic should not exceed is 150 ms. At 150 ms, you will have call disruption. 10 ms can normally only be achieved on the same LAN; therefore, it is not a recommended maximum. 90ms is the far end of the scale and sometimes seen in WAN communications. 300 ms is roughly one-third of a second and traffic will experience echoes and drops."
    },
    {
       "id":730,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":"",
       "question":"Which QoS queue has priority over all other queues in the scheduler?",
       "choice_a":"CBWFQ",
       "choice_b":"LLQ",
       "choice_c":"FIFO",
       "choice_d":"CIR",
       "correct_answer":"B",
       "explanation":"Low Latency Queuing (LLQ) overrides Class Based Weighted Fair Queuing (CBWFQ). CBWFQ uses a weighted round-robin scheduling of packets. LLQ has priority override when packets come in matching the classification for LLQ. FIFO queues work on a first in, firstout system but do not have a concept of priority. Committed information rate (CIR) is a term used with Frame Relay."
    },
    {
       "id":731,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":"",
       "question":"Which method helps combat queue starvation for QoS queuing?",
       "choice_a":"LLQ",
       "choice_b":"Policing",
       "choice_c":"CBWFQ",
       "choice_d":"FIFO",
       "correct_answer":"B",
       "explanation":"QoS queue starvation occurs when the Low Latency Queuing (LLQ) is given priority over the Class-Based Weighted Fair Queuing. Therefore, policing of the LLQ will help limit queue starvation and allow those queues an equal share of the total output bandwidth. Class-Based Weighted Fair Queuing (CBWFQ) is not a method to combat queue starvation. First in,first out (FIFO) is not a method to combat queue starvation."
    },
    {
       "id":732,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":1,
       "question":"Which statement is correct about shaping of traffic for QoS?",
       "choice_a":"Shaping holds packets in the queue over the configured bit rate to cause delay.",
       "choice_b":"Shaping drops packets over the configured bit rate to cause loss.",
       "choice_c":"Shaping holds packets in the queue over the configured bit rate to cause jitter.",
       "choice_d":"Shaping slows packets in the queue over the configured bit rate to adhere to the speed.",
       "correct_answer":"A",
       "explanation":"Shaping monitors the bit rate of packets. If the bit rate is exceeded for a configured queue, then shaping holds packets over the configured bit rate, causing a delay. Shaping of packets does not drop packets when the bandwidth is over the configured bit rate. Shaping will not use jitter as a control method when the bandwidth is over the configure bit rate. Shaping has no mechanism to control speed, only the rate at which packets are released."
    },
    {
       "id":733,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":"",
       "question":"Which QoS method uses a round-robin scheduler for packet queuing?",
       "choice_a":"LLQ",
       "choice_b":"FIFO",
       "choice_c":"CBWFQ",
       "choice_d":"PQ",
       "correct_answer":"C",
       "explanation":"Class-Based Weighted Fair Queuing, or CBWFQ, is driven by a round-robin scheduler. The queues are weighted for priority in the scheduler and the packets are put into the queues upon classification. Low Latency Queueing (LLQ) does not use a round-robin scheduler. First in,first out (FIFO) does not use a round-robin scheduler. Priority Queueing (PQ) does not use a round-robin scheduler."
    },
    {
       "id":734,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":"",
       "question":"Which statement is correct about policing of traffic for QoS?",
       "choice_a":"Policing holds packets in the queue over the configured bit rate to cause delay.",
       "choice_b":"Policing drops packets over the configured bit rate to cause loss.",
       "choice_c":"Policing holds packets in the queue over the configured bit rate to cause jitter.",
       "choice_d":"Policing slows packets in the queue over the configured bit rate to adhere to the bit rate.",
       "correct_answer":"B",
       "explanation":"Policing monitors the bit rate of packets. If the bit rate is exceeded for a configured queue, then policing drops packets over the configured bit rate, causing loss. In some cases it can be configured to remark the packets. Policing does not hold packets in the queue over the configured bit rate to cause delay. Policing does not hold packets in the queue over the configured bit rate to cause jitter. Policing will not slow packets in the queue over the configured bit rate to adhere to the bit rate."
    },
    {
       "id":735,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":"",
       "question":"Why should QoS policing be implemented?",
       "choice_a":"To help police LAN applications",
       "choice_b":"To maintain a contracted CIR",
       "choice_c":"To help police WAN applications",
       "choice_d":"To maintain a contracted burst rate",
       "correct_answer":"B",
       "explanation":"QoS policing should be implemented to adhere network traffic to a contracted committed information rate(CIR). As an example, if your enterprise contracted a Metro Ethernet connection with an access link of 1 Gb/s and a CIR of 400 Mb/s, you would need to make sure that traffic does not exceed the CIR except for occasional bursts. QoS policing is not used to police LAN applications. QoS policing is not used to police WAN applications. QoS will not help with maintaining a contracted burst rate."
    },
    {
       "id":736,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":"",
       "question":"How do congestion avoidance tools help to prevent tail drop?",
       "choice_a":"When the queue depth is full, a percentage of TCP packets are dropped.",
       "choice_b":"When the queue depth is empty, a percentage of TCP packets are dropped.",
       "choice_c":"When the queue depth is below the minimum threshold, a percentage of TCP packets are dropped.",
       "choice_d":"When the queue depth is above the minimum threshold, a percentage of TCP packets are dropped.",
       "correct_answer":"D",
       "explanation":"When the queue depth is above the minimum threshold, a percentage of TCP packets are dropped. This allows the TCP window to shrink and allows a normal slowdown of TCP transmissions. This is done in hopes that the queue will fall under the minimum threshold and return to normal. Congestion avoidance tools drop all packets when the queue depth is full, but this is a cause of total congestion and not prevention of tail drop. When the queue depth is empty, nothing is dropped. When the queue depth is below the minimum threshold, nothing is dropped since this is optimal."
    },
    {
       "id":737,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":"",
       "question":"If a traffic is marked with AF31 and another traffic pattern is marked with AF41, which statement explains the traffic markings?",
       "choice_a":"AF31 marked traffic has a better queue than AF41 marked traffic.",
       "choice_b":"AF41 marked traffic has a better queue than AF31 marked traffic.",
       "choice_c":"Both AF31 and AF41 marked traffic has an equal queue.",
       "choice_d":"During high congestion, AF41 queues will be dropped and AF31 queues won't.",
       "correct_answer":"B",
       "explanation":"AF41 marked traffic has a better position in the queue than traffic marked AF31. During high congestion times, traffic with lower positions in the queues (AF3x, AF2x, AF1x) would have more chances of being dropped than AF41. AF31 marked traffic is placed in a lower queue than traffic marked with AF41. AF31 and AF41 markings of traffic are not the same. During high congestion, traffic in the AF31 queue will be dropped before the AF 41 queue."
    },
    {
       "id":738,
       "topic_id":4,
       "sub_domain":"4.8 Configure network devices for remote access using SSH",
       "practice_test_id":4,
       "question":"What is required before generating the encryption keys for SSH on a router or switch?",
       "choice_a":"Setting the time and date",
       "choice_b":"Setting the hostname and domain name",
       "choice_c":"Setting the key strength",
       "choice_d":"Setting the key repository",
       "correct_answer":"B",
       "explanation":"The hostname and domain name are required before you attempt to generate the encryption keys for SSH. Although setting the time and date is good practice, it is not required for the generation of SSH encryption keys. Setting the key strength is not required for the generation of SSH encryption keys. Setting the key repository is not required for the generation of SSH encryption keys."
    },
    {
       "id":739,
       "topic_id":4,
       "sub_domain":"4.8 Configure network devices for remote access using SSH",
       "practice_test_id":5,
       "question":"Which command will enable SSH version 2 for logins?",
       "choice_a":"<code>Router(config)#ip ssh version 2</code>",
       "choice_b":"<code>Router(config-line)#version 2</code>",
       "choice_c":"<code>Router(config-ssh)#version 2</code>",
       "choice_d":"<code>Router(config)#ssh version 2</code>",
       "correct_answer":"A",
       "explanation":"The command <code>ip ssh version 2</code> will set your SSH version to 2. This command is to be entered at a global configuration prompt. The command <code>version</code> 2configured in the config-line prompt is incorrect. The command <code>version 2</code> configured in the config-ssh prompt is incorrect as there is no config-ssh prompt. The command <code>sshversion 2</code> is incorrect."
    },
    {
       "id":740,
       "topic_id":4,
       "sub_domain":"4.8 Configure network devices for remote access using SSH",
       "practice_test_id":"",
       "question":"Which command will configure the router or switch to allow SSH as a protocol for management with a fallback of Telnet?",
       "choice_a":"<code>Switch(config)#login ssh telnet</code>",
       "choice_b":"<code>Switch(config-line)#login ssh telnet</code>",
       "choice_c":"<code>Switch(config-line)#transport ssh telnet</code>",
       "choice_d":"<code>Switch(config)#transport ssh telnet</code>",
       "correct_answer":"C",
       "explanation":"The command <code>transport ssh telnet</code> will configure the VTY line to accept SSH as a login protocol and fallback to Telnet. The command <code>login ssh telnet</code> is incorrect. The command <code>login ssh telnet</code> configured in the config-line prompt is incorrect. The command <code>transport ssh telnet</code> configured in the global configuration prompt is incorrect."
    },
    {
       "id":741,
       "topic_id":4,
       "sub_domain":"4.8 Configure network devices for remote access using SSH",
       "practice_test_id":"",
       "question":"Why should Telnet be replaced with SSH?",
       "choice_a":"Telnet has weak encryption.",
       "choice_b":"SSH allows for file copy.",
       "choice_c":"SSH makes it easier to create ACLs for access.",
       "choice_d":"SSH is encrypted.",
       "correct_answer":"D",
       "explanation":"SSH is encrypted and Telnet is in clear text. To keep passwords and configuration safe, SSH should always be used. Telnet has no encryption; therefore it cannot have weak encryption. Although files can be transferred via SSH, replacing Telnet with SSH does not enable this feature. SSH does not make it easier to create ACLs for access."
    },
    {
       "id":742,
       "topic_id":4,
       "sub_domain":"4.8 Configure network devices for remote access using SSH",
       "practice_test_id":"",
       "question":"You have created the SSH encryption keys, but you cannot enable SSH version 2. What is the problem?",
       "choice_a":"The time and date need to be corrected.",
       "choice_b":"The key strength needs to be 768 bits or higher.",
       "choice_c":"The DNS server is not configured.",
       "choice_d":"There is no host record for the switch or router.",
       "correct_answer":"B",
       "explanation":"When you're configuring a switch or router for SSH version 2, the key strength must be at least 768 bits for the modulus. The default is 512 bits, and it is standard practice to double the number to 1024 bits. The time and date do not need to be corrected to enable SSH version 2. The DNS server does not need to be configured for SSH version 2. Host records for the switch or router do not have to be configured for SSH version 2."
    },
    {
       "id":743,
       "topic_id":4,
       "sub_domain":"4.8 Configure network devices for remote access using SSH",
       "practice_test_id":1,
       "question":"Which command will configure a local user for SSH access?",
       "choice_a":"<code>Router(config)#username user1 password Password20!</code>",
       "choice_b":"<code>Router(config)#account user1</code><br><code>Router(config-acct)#password Password20!</code>",
       "choice_c":"<code>Router(config)#user user1 Password20!</code>",
       "choice_d":"<code>Router(config)#user-account user1 password Password20!</code>",
       "correct_answer":"A",
       "explanation":"The command <code>username user1 password Password20!</code> will create a user account called user1 with a password of Password20!. All of the other commands are incorrect."
    },
    {
       "id":744,
       "topic_id":4,
       "sub_domain":"4.8 Configure network devices for remote access using SSH",
       "practice_test_id":"",
       "question":"Which command will generate the encryption keys for SSH?",
       "choice_a":"<code>Router(config)#generate crypto key rsa</code>",
       "choice_b":"<code>Router(config)#crypto key generate rsa</code>",
       "choice_c":"<code>Router(config)#crypto generate key rsa</code>",
       "choice_d":"<code>Router#crypto key generate rsa</code>",
       "correct_answer":"B",
       "explanation":"The command <code>crypto key generate rsa</code> will generate the encryption keys for SSH. You will be asked for the key strength, called the modulus, which should be over 768 bits to support SSH version 2, or you can supply the modulus with the full command of <code>crypto key generate rsa modulus 2048</code>. The command <code>generate crypto key rsa</code> is incorrect. The command <code>crypto generate key rsa</code> entered in the global configuration prompt is incorrect. The command <code>crypto key generate rsa</code> entered in privilege exec mode is incorrect."
    },
    {
       "id":745,
       "topic_id":4,
       "sub_domain":"4.8 Configure network devices for remote access using SSH",
       "practice_test_id":"",
       "question":"You want to turn on local authentication so that a user must supply a username and password when managing the switch. You have created the username and password combinations on the switch. Which command will direct SSH and Telnet to use this authentication model?",
       "choice_a":"<code>Switch(config)#new aaa model</code>",
       "choice_b":"<code>Switch(config)#local authentication</code>",
       "choice_c":"<code>Switch(config-line)#local authentication</code>",
       "choice_d":"<code>Switch(config-line)#login local</code>",
       "correct_answer":"D",
       "explanation":"After configuring the username and password combinations that will be used on the switch or router, you will need to configure the line(s) that will use local authentication. The command used inside of the line is <code>login local.</code> This will apply to all the transport methods configured on the line. The command <code>new aaa mode</code>l is incorrect. The command <code>local authentication</code> entered in global configuration mode is incorrect. The command <code>local authentication</code> entered in the config-line prompt is incorrect."
    },
    {
       "id":746,
       "topic_id":4,
       "sub_domain":"4.8 Configure network devices for remote access using SSH",
       "practice_test_id":4,
       "question":"Which banner will be displayed first when a user connects to a Cisco device via SSH?",
       "choice_a":"MOTD banner",
       "choice_b":"Login banner",
       "choice_c":"Exec banner",
       "choice_d":"Incoming banner",
       "correct_answer":"B",
       "explanation":"The login banner will be displayed during initial connection to a Cisco device via SSH. The MOTD banner will be displayed when a user logs in locally. After a user logs in, the exec banner or incoming banner will be displayed."
    },
    {
       "id":747,
       "topic_id":4,
       "sub_domain":"4.9 Describe the capabilities and function of TFTP/FTP in the network",
       "practice_test_id":5,
       "question":"Which command will restore configuration to the running-config for a device from a server?",
       "choice_a":"<code>Switch#archive tftp: running-config</code>",
       "choice_b":"<code>Switch#restore tftp://192.168.1.2 running-config</code>",
       "choice_c":"<code>Switch#copy tftp: running-config</code>",
       "choice_d":"<code>Switch#copy server: running-config</code>",
       "correct_answer":"C",
       "explanation":"The command <code>copy tftp: running-config</code> will ask for the TFTP server address, source filename, and destination filename. It will then proceed to copy the file over the network from the TFTP server. The command archive tftp: running-config is incorrect. The command restore tftp://192.168.1.2 running-config is incorrect. The command copy server: running-config is incorrect."
    },
    {
       "id":748,
       "topic_id":4,
       "sub_domain":"4.9 Describe the capabilities and function of TFTP/FTP in the network",
       "practice_test_id":"",
       "question":"Which command will begin the upgrade of an IOS from a TFTP server?",
       "choice_a":"<code>Switch#copy tftp flash</code>",
       "choice_b":"<code>Switch#copy tftp ios</code>",
       "choice_c":"<code>Switch#copy tftp nvram</code>",
       "choice_d":"<code>Switch#upgrade tftp flash</code>",
       "correct_answer":"A",
       "explanation":"The command <code>copy tftp flash</code> will begin an interactive upgrade dialog. The dialog will ask for the IP address of the TFTP server, the source filename on the TFTP server, and the destination filename. It will then begin transferring the image. The command <code>copy tftp ios</code> is incorrect. The command <code>copy tftp nvram</code> is incorrect. The command <code>upgrade tftp flash</code> is incorrect."
    },
    {
       "id":749,
       "topic_id":4,
       "sub_domain":"4.9 Describe the capabilities and function of TFTP/FTP in the network",
       "practice_test_id":1,
       "question":"Which command will allow you to boot a router from a TFTP server for the image of <code>c2900-universalk9-mz.SPA.151-4.M4.bin</code> on the TFTP server of 192.168.1.2?",
       "choice_a":"<code>Router#boot tftp://192.168.1.2</code>",
       "choice_b":"<code>Router(config)#boot tftp://192.168.1.2 c2900-universalk9-mz.SPA.151-4.M4.bin</code>",
       "choice_c":"<code>Router(config)#boot system tftp://192.168.1.2 c2900-universalk9-mz.SPA.151-4.M4.bin</code>",
       "choice_d":"<code>Router(config)#boot system c2900-universalk9-mz.SPA.151-4.M4.bin tftp://192.168.1.2</code>",
       "correct_answer":"D",
       "explanation":"The command <code>boot system c2900-universalk9-mz.SPA.151-4.M4.bin tftp://192.168.1.2</code> will configure the router for booting of the image named <code>c2900-universalk9-mz.SPA.151-4.M4.bin</code> from the 192.168.1.2 TFTP server. Under normal circumstances, this should not be used in production environments since the router boot process is dependent upon the availability of the TFTP server. The command <code>boot tftp://192.168.1.2</code> is incorrect. The command <code>boot tftp://192.168.1.2 c2900-universalk9-mz.SPA.151-4.M4.bin</code> is incorrect. The command <code>boot system tftp://192.168.1.2 c2900-universalk9-mz.SPA.151-4.M4.bin</code> is incorrect."
    },
    {
       "id":750,
       "topic_id":4,
       "sub_domain":"4.9 Describe the capabilities and function of TFTP/FTP in the network",
       "practice_test_id":"",
       "question":"You're upgrading the flash memory on a 2900 router with a brand-new flash card. What needs to be done to restore the IOS?",
       "choice_a":"The new flash memory will have a mini-IOS installed. You will need to upgrade it from the mini-IOS.",
       "choice_b":"The router will boot into the ROMMON, and from there you will need to TFTP download the IOS.",
       "choice_c":"Nothing needs to be done because the IOS is not storage on the flash memory card.",
       "choice_d":"Format the flash card with the FAT operating system and copy the IOS image to the card.",
       "correct_answer":"B",
       "explanation":"The IOS is stored on the flash card. Since the flash card is brand-new, nothing is on it. When the router boots, it will not find the IOS and will boot into ROMMON mode. From ROMMON mode, you will configure an IP address, subnet mask, gateway, TFTP server, and image and initiate a TFTP download to flash. Once the IOS is downloaded to flash memory, you can boot the router and verify operations. New flash memory will not contain a mini-IOS installed from the factory. You cannot format the flash card with the FAT file system as the IOS requires its own filesystem to be formatted."
    },
    {
       "id":751,
       "topic_id":4,
       "sub_domain":"4.9 Describe the capabilities and function of TFTP/FTP in the network",
       "practice_test_id":"",
       "question":"Which command(s) are required before you can use an FTP server for backing up configuration? Assume that the username is USER and the password is USERPASS.",
       "choice_a":"<code>Router(config)#ip ftp username USER password USERPASS</code>",
       "choice_b":"<code>Router(config)#ftp USER password USERPASS</code>",
       "choice_c":"<code>Router(config)#ip ftp username USER</code><br><code>Router(config)#ip ftp password USERPASS</code>",
       "choice_d":"<code>Router(config)#username USER password USERPASS</code>",
       "correct_answer":"C",
       "explanation":"The command <code>ip ftp username USER</code> will configure the username USER for FTP connections. The command <code>ip ftp password USERPASS</code> will configure the password USERPASS for FTP connections. The command <code>ip ftp username USER password USERPASS</code> is incorrect. The command <code>ftp USER password USERPASS</code> is incorrect. The command <code>username USER password USERPASS</code> is incorrect."
    },
    {
       "id":752,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":"",
       "question":"Which term describes the area outside of the corporate firewall?",
       "choice_a":"DMZ",
       "choice_b":"Perimeter",
       "choice_c":"Internal",
       "choice_d":"Trusted",
       "correct_answer":"B",
       "explanation":"The perimeter area, or perimeter network, is outside of the corporate firewall. The perimeter area generally holds equipment necessary for routing to the ISP. The demilitarized zone (DMZ) area is in between the perimeter network and the internal network. The internal area is the area or network inside of your organization. A trusted area is an area or network that has a high level of trust; generally, your internal area is a trusted area."
    },
    {
       "id":753,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":"",
       "question":"Which term describes the area accessible to the Internet yet protected by the corporate firewall?",
       "choice_a":"DMZ",
       "choice_b":"Perimeter",
       "choice_c":"Internal",
       "choice_d":"Trusted",
       "correct_answer":"A",
       "explanation":"The demilitarized zone (DMZ) is an area that is protected by the corporate firewall. The DMZ area is in between the perimeter network and the internal network. However, it allows servers such as web servers, email servers, and application servers to be accessible via the Internet. The perimeter area, or perimeter network, is outside of the corporate firewall. The perimeter area generally holds equipment necessary for routing to the ISP. The internal area is the area or network inside of your organization. A trusted area is an area or network that has a high level of trust; generally your internal area is a trusted area."
    },
    {
       "id":754,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":"",
       "question":"Which type of device can prevent an intrusion on your network?",
       "choice_a":"Honey pots",
       "choice_b":"IDS",
       "choice_c":"IPS",
       "choice_d":"HIDS",
       "correct_answer":"C",
       "explanation":"An intrusion prevention system, or IPS, can detect and prevent attacks based on their signature. They are commonly found in firewall systems such as Firepower Threat Defense (FTD) devices. Honey pots are server or network appliances that have been security weakened to attract bad actors so their actions and tactics can be examined. An intrusion detection system(IDS) is a system that can detect an attack based upon a signature. They too are found in firewall systems such as Firepower Threat Defense (FTD) devices. Although similar to an IPS, the IDS will only notify someone in the event of a detection. A host intrusion detection system (HIDS) is an application that runs on a host to detect intrusions. A HIDS is similar to an IDS, but it is all software based and resides on the host it is to protect."
    },
    {
       "id":755,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":"",
       "question":"When dealing with firewalls, the term <italic>trusted network</italic> is used to describe what?",
       "choice_a":"Internal network",
       "choice_b":"The Internet",
       "choice_c":"The DMZ",
       "choice_d":"A network with SSL",
       "correct_answer":"A",
       "explanation":"The internal network is defined by the firewall. Anything protected by the firewall on the internal network is considered to be the trusted network. The Internet is an untrusted network, because it is outside of your control and outside of your organization. The demilitarized zone (DMZ) area is in between the perimeter network and the internal network. A network with Secure Sockets Layer (SSL) encryption is not considered trusted; it is considered encrypted. A network with SSL can travel over an untrusted network such as the Internet."
    },
    {
       "id":756,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":"",
       "question":"Which is a common attack method used to overwhelm services with traffic from multiple Internet sources?",
       "choice_a":"Denial of service",
       "choice_b":"Distributed denial of service",
       "choice_c":"IP address spoofing",
       "choice_d":"Session hijacking",
       "correct_answer":"B",
       "explanation":"Distributed denial of service, or DDoS, is a common attack technique used to deny others of service. It is performed by overwhelming the service with bogus traffic. When it is performed from multiple hosts on the Internet, it is very difficult to prevent and stop. A denial of service (DoS) attack is typically carried out by one source and is relatively easy to mitigate. IP address spoofing is a tactic when the source IP address is spoofed in a packet in an attempt to bypass security. Session hijacking is an attack in which a conversation between two hosts is hijacked by an attacker."
    },
    {
       "id":757,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":"",
       "question":"Which type of device can detect an intrusion on your network?",
       "choice_a":"Honey pots",
       "choice_b":"IDS",
       "choice_c":"IPS",
       "choice_d":"HIDS",
       "correct_answer":"B",
       "explanation":"An intrusion detection system, or IDS, can detect an attack based upon its signature. They are commonly found in firewall systems such as Firepower Threat Defense (FTD). Although similar to an IPS, the IDS will only notify someone in the event of a detection. Honey pots are server or network appliances that have been security weakened to attract bad actors so their actions and tactics can be examined. An intrusion prevention system, or IPS, can detect and prevent attacks based on their signature. They too are commonly found in firewall systems such as Firepower Threat Defense (FTD). A host intrusion detection system (HIDS) is an application that runs on a host to detect intrusions. A HIDS is similar to an IDS, but it is all software based and resides on the host it is to protect."
    },
    {
       "id":758,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":"",
       "question":"Which method can be used to stop ping sweep scans?",
       "choice_a":"Deploying host intrusion detection systems",
       "choice_b":"Deploying network intrusion detection systems",
       "choice_c":"Blocking RFC 1918 addresses at the perimeter",
       "choice_d":"Blocking ICMP echorequests and echoreplies at the perimeter",
       "correct_answer":"D",
       "explanation":"Ping sweep scans are used by attackers to discover hosts on a network. The scan sends a flood of ICMP echo requests to the perimeter network and awaits echo replies. When ICMP is blocked at the perimeter, an attacker would not be able to scan the network via ICMP. Although deploying a host intrusion detection system (HIDS) and intrusion detection systemis a good idea, these systems will only notify you of a ping sweep scan and will not prevent it. Blocking RFC 1918 addresses at the perimeter is also a positive security measure. However, RFC 1918 addresses are not Internet routable, and this measure does not prevent an internal ping sweep scan."
    },
    {
       "id":759,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":4,
       "question":"Which appliance can be used to mitigate denial of service attacks?",
       "choice_a":"Honey pots",
       "choice_b":"IDS",
       "choice_c":"IPS",
       "choice_d":"HIDS",
       "correct_answer":"C",
       "explanation":"An intrusion prevention system (IPS) will help mitigate denial of service attacks. Common features of IPS can be found in the Cisco Adaptive Security Appliance. Honey pots are server or network appliances that have been security weakened to attract bad actors so their actions and tactics can be examined. An intrusion detection system, or IDS, can detect an attack based upon its signature. They are also commonly found in firewall systems such as Firepower Threat Defense (FTD) devices. Although similar to an IPS, the IDS will only notify someone in the event of a detection. A host intrusion detection system (HIDS) is an application that runs on a host to detect intrusions. A HIDS is similar to an IDS, but it is all software based and resides on the host it is to protect."
    },
    {
       "id":760,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":5,
       "question":"Which is a common attack method used to attempt to gain access to a system using a false identity?",
       "choice_a":"Denial of service",
       "choice_b":"Distributed denial of service",
       "choice_c":"IP address spoofing",
       "choice_d":"Session hijacking",
       "correct_answer":"C",
       "explanation":"IP address spoofing is a common attack method used to attempt to gain access to a system by spoofing the originating IP address. A denial of service, or DoS, attack is typically carried out by one source and is relatively easy to mitigate. Distributed denial of service, or DDoS, is a common attack technique used to deny others of service. It is performed by overwhelming the service with bogus traffic. When it is performed from multiple hosts on the Internet, it is very difficult to prevent and stop. Session hijacking is an attack in which a conversation between two hosts is hijacked by an attacker."
    },
    {
       "id":761,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":1,
       "question":"Which method would prevent tampering of data in transit?",
       "choice_a":"Access control lists",
       "choice_b":"Spoofing mitigation",
       "choice_c":"Secure Sockets Layer",
       "choice_d":"Encryption of the data",
       "correct_answer":"C",
       "explanation":"Secure Sockets Layer (SSL) communications offer both encryption and authentication of the data via certificate signing. This would prevent tampering of the data end to end. Access control lists (ACLs) are used to control traffic by either allowing, denying, or logging traffic depending on specific conditions. Spoofing mitigation is the action of inspecting the source IP addresses of a packet to block packets from outside the network spoofing internal addresses. Encryption of the data alone will not prevent tampering; SSL provides encryption and authentication."
    },
    {
       "id":762,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":"",
       "question":"A rouge wireless access point is created with the same SSID as the corporate SSID. The attacker has employees connect to the SSID and watches the information as it's relayed to the original SSID. What type of attack is described here?",
       "choice_a":"Smurf attack",
       "choice_b":"Compromised key attack",
       "choice_c":"Sniffer attack",
       "choice_d":"Man in the middle attack",
       "correct_answer":"D",
       "explanation":"This attack is called a man in the middle attack. The attacker sits in the middle of communications and relays it back while capturing it and possibly modifying it. A Smurf attack is an attack where a number of computers are told to respond to a victim IP address via a spoofed packet. A compromised key attack involves a key pair that has been tampered or copied, such as SSL or SSH key pairs. A sniffer attack is a passive attack where an attacker will collect packets with a network sniffer for later playback or analysis."
    },
    {
       "id":763,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":"",
       "question":"What can you use to protect against spoofing of internal IP addresses on the perimeter of your network?",
       "choice_a":"Access control lists",
       "choice_b":"Intrusion detection systems",
       "choice_c":"Secure Sockets Layer",
       "choice_d":"Host intrusion detection systems",
       "correct_answer":"A",
       "explanation":"Access control lists (ACLs) are an effective way to mitigate spoofing of internal IPs from outside the trusted network. ACLs are used to control traffic by either allowing, denying, or logging traffic depending on specific conditions. An intrusion detection system (IDS) can be used to notify you if it detects an attack, but it will not prevent an attack. Secure Sockets Layer (SSL) communications offer both encryption and authentication of the data via certificate signing. This would prevent tampering of the data end to end, but it will not prevent spoofing. A host intrusion detection system (HIDS) is an application that runs on a host to detect intrusions. A HIDS is similar to an IDS, but it is all software based and resides on the host it is to protect."
    },
    {
       "id":764,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":"",
       "question":"Which is a requirement for the use of DHCP snooping to protect a device?",
       "choice_a":"The device is on a layer 2 switched port on the same VLAN.",
       "choice_b":"The DHCP server is running on the layer 2 switch.",
       "choice_c":"The device is on a layer 3 routed port on the same VLAN.",
       "choice_d":"Configuration of a dedicated IP address for monitoring DHCP transactions.",
       "correct_answer":"A",
       "explanation":"A requirement of DHCP snooping is that the device is on the VLAN that DHCP snooping is monitoring. There is nothing that requires the DHCP server to run on a layer 2 switch. The device that is being protected must be on a layer 2 switched port on the same VLAN and not a layer 3 routed port. DHCP snooping does not require a dedicated IP address to be configured for its operations."
    },
    {
       "id":765,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":"",
       "question":"What attack vector can be used for a man in the middle attack?",
       "choice_a":"DHCP",
       "choice_b":"DNS",
       "choice_c":"Wireless",
       "choice_d":"All of the above",
       "correct_answer":"D",
       "explanation":"Any service that allows the user to create a connection or access to information can be used as an attack vector. In the case of DHCP, the attacker will set the gateway to their IP address. In the case of DNS, the attacker could spoof a request to redirect the traffic. In the case of wireless, the attacker can spoof the Service Set Identifier (SSID)."
    },
    {
       "id":766,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":"",
       "question":"Which attack can be used on a native VLAN?",
       "choice_a":"Double tagging",
       "choice_b":"VLAN traversal",
       "choice_c":"Trunk popping",
       "choice_d":"Denial of service",
       "correct_answer":"A",
       "explanation":"Double tagging is an attack that can be used against the native VLAN. The attacker will tag the native VLAN on a frame and then tag another inside that frame for the VLAN that the attacker intends to compromise. When the switch receives the first frame, it removes the default VLAN tag and forwards it to other switches via a trunk port. When the other switch receives the frame with the second VLAN tag, it forwards it to the VLAN upon which the attacker is targeting the attack. VLAN traversal is not an attack; it is a term to describe a VLAN traversing a trunk link between two switches. Trunk popping is not a valid attack; it is not a term used in networking, and therefore, it is an invalid answer. A denial of service (DoS) attack is an attack in which an attempt to exhaust services resources is launchedto knock a service offline."
    },
    {
       "id":767,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":"",
       "question":"Which command is used to configure the port of a switch as trusted for DHCP snooping?",
       "choice_a":"<code>Switch(config-if)#ip dhcp snooping trust</code>",
       "choice_b":"<code>Switch(config-if)#dhcp snooping trust</code>",
       "choice_c":"<code>Switch(config)#ip dhcp snooping trust interface gi 2/3</code>",
       "choice_d":"<code>Switch(config-if)#ip dhcp trust</code>",
       "correct_answer":"A",
       "explanation":"The command <code>ip dhcp snooping trust</code> will configure the interface as a trusted port. The command <code>dhcp snooping trust</code> is incorrect. The command <code>ip dhcp snooping trust interface gi 2/3</code> is incorrect. The command <code>ip dhcp trust</code> is incorrect."
    },
    {
       "id":768,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":4,
       "question":"Why should you always change the native VLAN?",
       "choice_a":"The native VLAN contains frames from all VLANs.",
       "choice_b":"The native VLAN is configured on all switches for logging.",
       "choice_c":"The native VLAN is the default on all switchports.",
       "choice_d":"The native VLAN provides no encryption.",
       "correct_answer":"C",
       "explanation":"The native VLAN is the default configuration on all switches. It is very possible that a user could be configured by accident for the native VLAN of 1. This would allow management access to switching and routing. The native VLAN will not contain frames from all VLANs. The native VLAN will only contain frames that are placed onto a trunk that have not been tagged. The native VLAN is not configured on all switches for logging; logging can be transmitted over any VLAN. All VLANs provide no encryption, regardless of whetherthey are the native VLAN."
    },
    {
       "id":769,
       "topic_id":5,
       "sub_domain":"5.2 Describe security program elements (user awareness, training, and physical access control)",
       "practice_test_id":5,
       "question":"What can protect users from a phishing attack that is sent via email?",
       "choice_a":"Training",
       "choice_b":"Anti-malware software",
       "choice_c":"Antivirus software",
       "choice_d":"Certificates",
       "correct_answer":"A",
       "explanation":"End user training and vigilance is the best way to protect users from phishing attacks. A phishing attack is an email or sites the looks legitimate and baits the user to enter their credentials. If a user can identify a phishing attempt that looks like a legitimate request, they can protect themselves by ignoring the phishing attempt or deleting it. Anti-malware and antivirus software will not protect you from phishing attacks since they are engineered to protect you from malware or viruses. Certificates can be used internally to sign emails, but external vendors do not normally use certificates to sign emails."
    },
    {
       "id":770,
       "topic_id":5,
       "sub_domain":"5.2 Describe security program elements (user awareness, training, and physical access control)",
       "practice_test_id":"",
       "question":"Your company provides medical data to doctors from a worldwide database. Because of the sensitive nature of the data, it's imperative that authentication be established on each session and be valid only for that session. Which of the following authentication methods provides credentials that are valid only during a specific period of time?",
       "choice_a":"Token",
       "choice_b":"Certificate",
       "choice_c":"Smart card",
       "choice_d":"License",
       "correct_answer":"A",
       "explanation":"A hardware or software token creates a numeric password that is only valid only for a specific amount of time before a new one is displayed. Certificate authentication is not time-limited for a session. Smart card authentication is not time-limited for a session. <italic>License</italic> is a term used with the licensing of software and therefore an incorrect answer."
    },
    {
       "id":771,
       "topic_id":5,
       "sub_domain":"5.2 Describe security program elements (user awareness, training, and physical access control)",
       "practice_test_id":"",
       "question":"A user has brought an email to your attention that is not from his bank, but it looks like his bank's website when he clicks on the link. What is this most likely?",
       "choice_a":"Spam",
       "choice_b":"Password cracking",
       "choice_c":"Phishing",
       "choice_d":"Worm",
       "correct_answer":"C",
       "explanation":"This is most likely a phishing attack aimed at the user. Spam would not have links to a bank website for login. Password cracking is the act of trying several different passwords in an attempt to gain access. A worm is malware that replicates itself and infects other systems."
    },
    {
       "id":772,
       "topic_id":5,
       "sub_domain":"5.2 Describe security program elements (user awareness, training, and physical access control)",
       "practice_test_id":"",
       "question":"What type of filters can be placed over a monitor to prevent the data on the screen from being readable when viewed from the side?",
       "choice_a":"Security",
       "choice_b":"Privacy",
       "choice_c":"Degaussing",
       "choice_d":"Tempered",
       "correct_answer":"B",
       "explanation":"Privacy filters are either film or glass add-ons that are placed over a monitor. They prevent the data on the screen from being readable when viewed from the sides. Security is the overall goal and not the correct answer. Degaussing is associated with magnetic media erasure. Tempered describes a type of glass that does not prevent side viewing."
    },
    {
       "id":773,
       "topic_id":5,
       "sub_domain":"5.2 Describe security program elements (user awareness, training, and physical access control)",
       "practice_test_id":1,
       "question":"Which form of social engineering is nothing more than looking over someone's shoulder while they enter or view sensitive information?",
       "choice_a":"Shoulder surfing",
       "choice_b":"Phishing",
       "choice_c":"Tailgating",
       "choice_d":"Whaling",
       "correct_answer":"A",
       "explanation":"Shoulder surfing involves looking over someone's shoulder as they enter information. Phishing is the act of attempting to steal credentials by sending an email that takes you to a fraudulent login. Tailgating is the act of following a person through an access control point and using their credentials. Whaling is a form of phishing that targets high-profile individuals."
    },
    {
       "id":774,
       "topic_id":5,
       "sub_domain":"5.2 Describe security program elements (user awareness, training, and physical access control)",
       "practice_test_id":"",
       "question":"Several office-level users have administrative privileges on the network. Which of the following is the easiest to implement to immediately add security to the network?",
       "choice_a":"Biometric authentication",
       "choice_b":"Hardware tokens",
       "choice_c":"Active Directory",
       "choice_d":"Least privilege",
       "correct_answer":"D",
       "explanation":"By implementing least privilege and removing the administrative privileges from the office workers, you can easily secure the network. Biometric authentication will secure the network, but it is not easily implemented. Hardware tokens will secure the network, but they are not easily implemented. Active Directory will not add security to the network anymore because it is only a centralized authentication system."
    },
    {
       "id":775,
       "topic_id":5,
       "sub_domain":"5.2 Describe security program elements (user awareness, training, and physical access control)",
       "practice_test_id":"",
       "question":"You need to protect your users from Trojans, viruses, and phishing emails. What should you implement?",
       "choice_a":"Multifactor authentication",
       "choice_b":"Software firewalls",
       "choice_c":"Anti-malwaresoftware",
       "choice_d":"Antivirus software",
       "correct_answer":"C",
       "explanation":"Anti-malware software covers a wide array or of security threats to users, including trojans, viruses, and phishing emails. Multifactor authentication combines two or more single-factor authentication methods to create very secure authentication for users. Software firewalls will not prevent threats such as trojans, viruses, and phishing emails. Antivirus software protects you only from viruses and trojans, not phishing emails."
    },
    {
       "id":776,
       "topic_id":5,
       "sub_domain":"5.2 Describe security program elements (user awareness, training, and physical access control)",
       "practice_test_id":"",
       "question":"What is a method for stopping tailgating?",
       "choice_a":"User authentication",
       "choice_b":"Mantraps",
       "choice_c":"Strong passwords",
       "choice_d":"Change SSIDs",
       "correct_answer":"B",
       "explanation":"Using mantraps (small rooms that limit access to one or a few individuals) is a great way to stop tailgating. User authentication will not prevent or stop tailgating. Strong passwords will not prevent tailgating because tailgating is a physical security problem. Changing SSIDs will not stop tailgating because tailgating does not pertain to wireless."
    },
    {
       "id":777,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"Which command will configure the enable password for a router or switch?",
       "choice_a":"<code>Router(config)#password enable Password20!</code>",
       "choice_b":"<code>Router(config)#enable Password20!</code>",
       "choice_c":"<code>Router(config)#enable secret Password20!</code>",
       "choice_d":"<code>Router(config)#secret enable Password20!</code>",
       "correct_answer":"C",
       "explanation":"The command <code>enable secret Password20!</code> will set the enable password and encrypt the <italic>Password20!</italic> password. The command <code>password enable Password20!</code> is incorrect. The command <code>enable Password20!</code> is incorrect. The command <code>secret enable Password20!</code> is incorrect."
    },
    {
       "id":778,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"You need to set the login password for Telnet. Which command will you type first?",
       "choice_a":"<code>Switch(config)#interface vlan 1</code>",
       "choice_b":"<code>Switch(config)#line console 1</code>",
       "choice_c":"<code>Switch(config)#line aux 1</code>",
       "choice_d":"<code>Switch(config)#line vty 0 5</code>",
       "correct_answer":"D",
       "explanation":"The command <code>line vty 0 5</code> will enter you into the line for the virtual teletype, which is where you configure your Telnet password. The command <code>interface vlan 1</code> is incorrect; this command will set the focus to the switched virtual interface of VLAN 1. The command <code>line console 1</code> is incorrect; this command will set the focus to the console line 1. The command <code>line aux 1</code> is incorrect; this command will set the focus to the auxiliary line 1."
    },
    {
       "id":779,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":4,
       "question":"You have set the enable password using <code>enable password Password20!</code>. However, when you try to get to a privileged exec prompt, the router states that you are using an incorrect password. What is the problem?",
       "choice_a":"You originally entered the wrong password.",
       "choice_b":"The enable secret password is set to something else.",
       "choice_c":"The password <italic>Password20!</italic> contains a special character.",
       "choice_d":"The password is too long and has been truncated.",
       "correct_answer":"B",
       "explanation":"If the enable password is set and the enable secret is set, the enable password will be ignored. Therefore, the enable secret is being used to authenticate the user, and you are typing the wrong password. The command <code>enable password</code> exists for backward compatibility with pre 10.3 IOS and should no longer be used. Although the originally entered password could be wrong, the enable password is ignored. The password <italic>Password20!</italic> contains a special character, but this is encouraged to promote better security. The password <italic>Password20!</italic> is not too long. The maximum length is 64 characters, which can differ from version to version of IOS."
    },
    {
       "id":780,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":5,
       "question":"Which command(s) will set a password and require login for a line?",
       "choice_a":"<code>Router(config-line)#set password Password20!</code> <br><code>Router(config-line)#request login</code>",
       "choice_b":"<code>Router(config-line)#password Password20!</code>",
       "choice_c":"<code>Router(config-line)#password Password20!</code> <br></br><code>Router(config-line)#login</code>",
       "choice_d":"<code>Router(config-line)#login password Password20!</code>",
       "correct_answer":"C",
       "explanation":"The command <code>password Password20!</code> will set the login password to <italic>Password20!</italic>. The sub-command <code>login</code> will require login for the line. The commands <code>set password Password20!</code> and <code>request login</code> are incorrect. The commands of <code>password Password20!</code> and <code>login password</code> are incorrect. The command <code>login password Password20!</code> is incorrect."
    },
    {
       "id":781,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"You Telnet to a switch and receive the error <code>Password required, but none set.[Connection to 192.168.1.1 closed by foreign host].</code> What is the problem?",
       "choice_a":"The enable secret is not set.",
       "choice_b":"The enable password is not set.",
       "choice_c":"The line login password is not set.",
       "choice_d":"The line is administratively down.",
       "correct_answer":"C",
       "explanation":"The VTY line login password is not set when you receive the error <code>Password required, but none set.</code> If the enable secret or enable password was not set, you would just not be able to get to a privileged exec prompt, but you would still be able to get to a user exec prompt. A VTY line cannot be administratively shutdown."
    },
    {
       "id":782,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"What is required before generating the encryption keys for SSH on a router or switch?",
       "choice_a":"Setting the time and date",
       "choice_b":"Setting the hostname and domain name",
       "choice_c":"Setting the key strength",
       "choice_d":"Setting the key repository",
       "correct_answer":"B",
       "explanation":"The hostname and domain name are required before you attempt to generate the encryption keys for SSH. Setting the time and date is recommended but not required for generating the encryption keys for SSH on a router or switch. Setting the key strength is also recommended but not required. The key strength should be set over 768 bits so that SSH version 2 can be used. The key repository does not need to be set; it normally defaults to NVRAM on routers and switches and differs from platform to platform."
    },
    {
       "id":783,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"Which command will enable SSH version 2 for logins?",
       "choice_a":"<code>Router(config)#ip ssh version 2</code>",
       "choice_b":"<code>Router(config-line)#version 2</code>",
       "choice_c":"<code>Router(config-ssh)#version 2</code>",
       "choice_d":"<code>Router(config)#ssh version 2</code>",
       "correct_answer":"A",
       "explanation":"The command <code>ip ssh version 2</code> will set your SSH version to 2. This command is to be entered at a global configuration prompt. The command <code>version 2</code> is incorrect, regardless of where it is configured. The command <code>ssh version 2</code> must be preceded with the <code>ip</code> command."
    },
    {
       "id":784,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"Which command will configure the router or switch to allow SSH as a protocol for management with a fallback of Telnet?",
       "choice_a":"<code>Switch(config)#login ssh telnet</code>",
       "choice_b":"<code>Switch(config-line)#login ssh telnet</code>",
       "choice_c":"<code>Switch(config-line)#transport ssh telnet</code>",
       "choice_d":"<code>Switch(config)#transport ssh telnet</code>",
       "correct_answer":"C",
       "explanation":"The command <code>transport ssh telnet</code> will configure the VTY line to accept SSH as a login protocol and fallback to Telnet. The command <code>login ssh telnet</code> is incorrect regardless of where it is configured. The command <code>transport ssh telnet</code> is incorrect when it is configured from a global configuration prompt."
    },
    {
       "id":785,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"Why should Telnet be replaced with SSH?",
       "choice_a":"Telnet has weak encryption.",
       "choice_b":"SSH allows for file copy.",
       "choice_c":"SSH makes it easier to create ACLs for access.",
       "choice_d":"SSH is encrypted.",
       "correct_answer":"D",
       "explanation":"SSH is encrypted and Telnet is in clear text. To keep passwords and configuration safe, SSH should always be used. Telnet contains no encryption whatsoever, and all usernames, passwords, and commands are sent in clear text. SSH allows for file copy if it is turned on in the IOS, but it is not a main reason to replace Telnet. Telnet and SSH make it equally easy to create ACLs for access."
    },
    {
       "id":786,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"Which command will create and apply an access list to secure router or switch management?",
       "choice_a":"<code>Switch(config)#access-list 1 permit host 192.168.1.5</code><br><code>Switch(config)#interface vlan 1</code><br><code>Switch(config-if)#ip access-group 1 in</code>",
       "choice_b":"<code>Switch(config)#access-list 1 permit host 192.168.1.5</code><br><code>Switch(config)#line vty 0 5</code><br><code>Switch(config-line)#ip access-group 1 in</code>",
       "choice_c":"<code>Switch(config)#access-list 1 permit host 192.168.1.5</code><br><code>Switch(config)#line vty 0 5</code><br><code>Switch(config-line)#ip access-class 1 in</code>",
       "choice_d":"<code>Switch(config)#access-list 1 permit host 192.168.1.5</code><br><code>Switch(config)#ip access-group 1 in</code>",
       "correct_answer":"C",
       "explanation":"You must first create an access list to permit the host that will manage the router or switch with the command <code>access-list 1 permit host 192.168.1.5.</code> Then enter the VTY line in which it will be applied with the command <code>line vty 0 5.</code> Then apply it with the command <code>ip access-class 1 in,</code> which differs from the command <code>ip access-group,</code> which is used on interfaces. All of the other options are incorrect."
    },
    {
       "id":787,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"You have created the SSH encryption keys, but you cannot enable SSH version 2. What is the problem?",
       "choice_a":"The time and date need to be corrected.",
       "choice_b":"The key strength needs to be 768 bits or higher.",
       "choice_c":"The DNS server is not configured.",
       "choice_d":"There is no host record for the switch or router.",
       "correct_answer":"B",
       "explanation":"When you're configuring a switch or router for SSH version 2, the key strength must be at least 768 bits for the modulus. The default is normally 512 bits, and it is standard practice to double the number to 1024 bits. The time and date do not necessarily need to be correct to enable SSH version 2. The DNS server does not need to be configured to enable SSH version 2. DNS and host records are used strictly used for connectivity and will not affect enabling SSH version 2."
    },
    {
       "id":788,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"Which command will configure a local user for SSH access?",
       "choice_a":"<code>Router(config)#username user1 password Password20!</code>",
       "choice_b":"<code>Router(config)#account user1</code><br><code>Router(config-acct)#password Password20!</code>",
       "choice_c":"<code>Router(config)#user user1 Password20!</code>",
       "choice_d":"<code>Router(config)#user-account user1 password Password20!</code>",
       "correct_answer":"A",
       "explanation":"The command <code>username user1 password Password20!</code> will create a user account called <italic>user1</italic> with a password of <italic>Password20!</italic>. The commands <code>account user1</code> and <code>password Password20!</code> are incorrect. The command <code>user user1 Password20!</code> is incorrect. The command <code>user-account user1 password Password20!</code> is incorrect."
    },
    {
       "id":789,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"You configured the password for Telnet access, but when you perform a <code>show running-configuration</code>, the password shows in clear text. Which command should be run?",
       "choice_a":"<code>Router(config)#password encryption</code>",
       "choice_b":"<code>Router(config)#service password-encryption</code>",
       "choice_c":"<code>Router(config)#service encryption</code>",
       "choice_d":"<code>Router(config)#password-encryption service</code>",
       "correct_answer":"B",
       "explanation":"The command <code>service password-encryption</code> should be entered in global config. It should not be kept in the configuration as it will use CPU cycles. So after it is configured, you should perform a <code>show running-config</code> to double-check if the encryption worked and then perform a <code>no service password-encryption</code> to turn it off. The command <code>password encryption</code> is incorrect. The command <code>service encryption</code> is incorrect. The command <code>password-encryption service</code> is incorrect."
    },
    {
       "id":790,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":1,
       "question":"Which command will generate the encryption keys for SSH?",
       "choice_a":"<code>Router(config)#generate crypto key rsa</code>",
       "choice_b":"<code>Router(config)#crypto key generate rsa</code>",
       "choice_c":"<code>Router(config)#crypto generate key rsa</code>",
       "choice_d":"<code>Router#crypto key generate rsa</code>",
       "correct_answer":"B",
       "explanation":"The command <code>crypto key generate rsa</code> will generate the encryption keys for SSH. You will be asked for the key strength, called the modulus, which should be over 768 bits to support SSH version 2. The command <code>generate crypto key rsa</code> is incorrect. The command <code>crypto generate key rsa</code> is incorrect. The command <code>crypto key generate rsa</code> is incorrect when configured from the privileged exec prompt."
    },
    {
       "id":791,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"Which command will disable auto-disconnect for idle privileged exec sessions?",
       "choice_a":"<code>Switch(config-line)#exec-timeout 0 0</code>",
       "choice_b":"<code>Switch(config)#exec-timeout 0</code>",
       "choice_c":"<code>Switch(config-line)#timeout 0 0</code>",
       "choice_d":"<code>Switch(config-line)#no exec-timeout</code>",
       "correct_answer":"A",
       "explanation":"The command <code>exec-timeout 0 0</code> will disable auto-disconnect for idle privileged exec sessions. The command <code>exec-timeout 0</code> is incorrect. The command <code>timeout 0 0</code> is incorrect. The command <code>no exec-timeout</code> is incorrect as it will remove any configured exec-timeout from the configuration."
    },
    {
       "id":792,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":4,
       "question":"In the following exhibit, you have listed all management sessions on the switch. On which line are you connected?<img src='/question_assets/ccna/5_image1.png'></img>",
       "choice_a":"Console 0",
       "choice_b":"VTY 0",
       "choice_c":"VTY 1",
       "choice_d":"VTY 2",
       "correct_answer":"B",
       "explanation":"The line on which you are connected is always preceded by an asterisk. In this example, you are connected to the router via line VTY 0. All other lines are remotely connected for other administrative sessions on the switch."
    },
    {
       "id":793,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":5,
       "question":"You want to turn on local authentication so that a user must supply a username and password when managing the switch. You have created the username and password combinations on the switch. Which command will direct SSH and Telnet to use this authentication model?",
       "choice_a":"<code>Switch(config)#new aaa model</code>",
       "choice_b":"<code>Switch(config)#local authentication</code>",
       "choice_c":"<code>Switch(config-line)#local authentication</code>",
       "choice_d":"<code>Switch(config-line)#login local</code>",
       "correct_answer":"D",
       "explanation":"After configuring the username and password combinations that will be used on the switch or router, you will need to configure the line(s) that will use local authentication. The command used inside of the line is <code>login local.</code> This will apply to all the transport methods configured on the line. The command <code>new aaa model</code> is incorrect. The command <code>local authentication</code> is incorrect regardless of where it is configured."
    },
    {
       "id":794,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"During a recent external security audit, it was determined that your enable password should be secured with SHA-256 scrypt. Which command will change the password strength on the switches and routers?",
       "choice_a":"<code>Switch(config)#enable secret 9</code>",
       "choice_b":"<code>Switch(config)#service password-encryption scrypt</code>",
       "choice_c":"<code>Switch(config)#enable secret algorithm-type scrypt</code>",
       "choice_d":"<code>Switch(config)#enable algorithm-type scrypt secret Password20!</code>",
       "correct_answer":"D",
       "explanation":"The command <code>enable algorithm-type scrypt secret Password20!</code> will change the enable password to <italic>Password20!</italic> and use the scrypt algorithm type. The command <code>enable secret 9</code> is incorrect. The command <code>service password-encryption scrypt</code> is incorrect. The command <code>enable secret algorithm-type scrypt</code> is incorrect."
    },
    {
       "id":795,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"What is the default encryption method for passwords, when you configure a linepassword?",
       "choice_a":"MD5",
       "choice_b":"SHA-128",
       "choice_c":"SHA-256",
       "choice_d":"Clear text",
       "correct_answer":"D",
       "explanation":"The default encryption method for passwords configured for lines is clear text. If you want to encrypt the password, you should use the <code>service password-encryption</code> command. When the command <code>service password-encryption</code> is used, the password will be encrypted with an MD5 hash, otherwise known as a Cisco level 7 encryption. All if the other options are incorrect."
    },
    {
       "id":796,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"You need to change the default idle time before disconnection of privileged exec mode for network administrators. Which command will change it to 30 minutes?",
       "choice_a":"<code>Switch(config)#exec-timeout 30 0</code>",
       "choice_b":"<code>Switch(config-line)#exec-timeout 30 0</code>",
       "choice_c":"<code>Switch(config-line)#exec-timeout 0 30</code>",
       "choice_d":"<code>Switch(config-line)#timeout 30 0</code>",
       "correct_answer":"B",
       "explanation":"The command <code>exec-timeout 30 0</code> will change the idle time to 30 minutes and zero seconds. If a privileged exec session is idle for 30 minutes, the network admin will be disconnected. The command <code>exec-timeout 30 0</code> is incorrect when configured from a global configuration prompt. The command <code>exec-timeout 0 30</code> is incorrect because it will timeout a user after zero minutes and 30 seconds. The command <code>timeout 30 0</code> is incorrect."
    },
    {
       "id":797,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"You need to disconnect a network admin from the switch or router. Which command would you use?",
       "choice_a":"<code>Switch(config)#no enable secret</code>",
       "choice_b":"<code>Switch#no line vty 2</code>",
       "choice_c":"<code>Switch#disconnect line vty 2</code>",
       "choice_d":"<code>Switch#clear line vty 2</code>",
       "correct_answer":"D",
       "explanation":"The command <code>clear line vty 2</code> will disconnect a remote admin connected to the switch. Nothing stops the admin from reconnecting to the switch again. The command <code>no enable secret</code> is incorrect because it will only prevent future enable sessions. The command <code>no line vty 2</code> is incorrect; you cannot negate a physical line. The command <code>disconnect line vty 2</code> is incorrect."
    },
    {
       "id":798,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":"",
       "question":"Which banner can deliver a message only to authenticated users regardless of connection type?",
       "choice_a":"MOTD banner",
       "choice_b":"Login banner",
       "choice_c":"Exec banner",
       "choice_d":"Incoming banner",
       "correct_answer":"C",
       "explanation":"The exec banner will display a message to authenticated users who have successfully logged in, regardless of whether they are connected via Telnet or SSH. The message of the day (MOTD) banner is displayed when a user attempts to login. The login banner is displayed after the MOTD but before initial login. An incoming banner is used for reverse Telnet connections and does not normally apply."
    },
    {
       "id":799,
       "topic_id":5,
       "sub_domain":"5.4 Describe security password policies elements, such as management, complexity, and password alternatives (multifactor authentication, certificates, and biometrics)",
       "practice_test_id":"",
       "question":"Which technology will give selective access to the network based upon authentication?",
       "choice_a":"802.1Q",
       "choice_b":"ACLs",
       "choice_c":"802.1X",
       "choice_d":"Firewall",
       "correct_answer":"C",
       "explanation":"802.1X allows selective access to a network at layer 2. It allows this on the switch because the switch acts as an authenticator to an AAA server, only allowing access after the user or device has been authenticated. 802.1Q is a trunking protocol used for transporting multiple VLANs over a layer 2 connection, and it does not provide authentication. An access control list (ACL) is a condition and action statement used to allow, deny, or log traffic. Firewalls contain ACLs and policies to allow, deny, and log traffic, but normally firewalls will not authenticate traffic."
    },
    {
       "id":800,
       "topic_id":5,
       "sub_domain":"5.4 Describe security password policies elements, such as management, complexity, and password alternatives (multifactor authentication, certificates, and biometrics)",
       "practice_test_id":"",
       "question":"What is the end device that sends credentials for 802.1X called?",
       "choice_a":"Authenticator",
       "choice_b":"Supplicant",
       "choice_c":"AAA server",
       "choice_d":"RADIUS server",
       "correct_answer":"B",
       "explanation":"The end device that sends credentials is called the supplicant. The supplicant is a piece of software in the operating system that supplies the credentials for AAA authentication. The authenticator is the wireless access point (WAP) or switch configured for 802.1X. The AAA server is normally a RADIUS server or TACACS+ server that is configured for 802.1X."
    },
    {
       "id":801,
       "topic_id":5,
       "sub_domain":"5.4 Describe security password policies elements, such as management, complexity, and password alternatives (multifactor authentication, certificates, and biometrics)",
       "practice_test_id":"",
       "question":"What is the switch called in an 802.1X configuration?",
       "choice_a":"Authenticator",
       "choice_b":"Supplicant",
       "choice_c":"AAA server",
       "choice_d":"RADIUS server",
       "correct_answer":"A",
       "explanation":"The switch is responsible for communicating with the supplicant and sending information to the authenticating server. This device is called the authenticator. The end device that sends credentials is called the supplicant. The supplicant is a piece of software in the operating system that supplies the credentials for AAA authentication. The AAA server is normally a RADIUS server or TACACS+ server that is configured for 802.1X."
    },
    {
       "id":802,
       "topic_id":5,
       "sub_domain":"5.4 Describe security password policies elements, such as management, complexity, and password alternatives (multifactor authentication, certificates, and biometrics)",
       "practice_test_id":"",
       "question":"What protocol does the supplicant communicate to the authenticator for 802.1X?",
       "choice_a":"802.1XEAP",
       "choice_b":"UDP",
       "choice_c":"TCP",
       "choice_d":"IP",
       "correct_answer":"A",
       "explanation":"The protocol used to communicate between the supplicants (OS) and the authenticator (switch) is 802.1X, the Extensible Authentication Protocol (EAP). 802.1XEAP is a layer 2 protocol used specifically for authenticating devices to switch ports and wireless. UDP ports 1812 and 1813 arecommonly used between the authenticator and the AAA RADIUS server. TCP is not commonly used with 802.1X. IP is used for logical addressing when an authenticator needs to talk with the AAA RADIUS server."
    },
    {
       "id":803,
       "topic_id":5,
       "sub_domain":"5.4 Describe security password policies elements, such as management, complexity, and password alternatives (multifactor authentication, certificates, and biometrics)",
       "practice_test_id":1,
       "question":"Which protocol is used by 802.1Xfor supplicant to authenticator and authenticator to authentication server?",
       "choice_a":"802.1Xauthentication headers",
       "choice_b":"IPsec",
       "choice_c":"EAP",
       "choice_d":"RADIUS",
       "correct_answer":"C",
       "explanation":"EAP, or Extensible Authentication Protocol, is used for authentication between the supplicant and the authenticator. It is also used inside of the requests to the RADIUS server from the authenticator. The process begins by the EAP frame first being transmitted over the layer 2 connection via EAP over LAN (EAPoL). The switch (authenticator) then sends the EAP message to the RADIUS server encapsulated in a UDP packet for authentication. 802.1X authentication headers are used between the supplicant and the authenticator, such as the switch or wireless access point (WAP). IPsec is not commonly used with 802.1X. The RADIUS server is commonly the AAA authentication server."
    },
    {
       "id":804,
       "topic_id":5,
       "sub_domain":"5.4 Describe security password policies elements, such as management, complexity, and password alternatives (multifactor authentication, certificates, and biometrics)",
       "practice_test_id":4,
       "question":"Which device is the supplicant during the 802.1X authentication process?",
       "choice_a":"The device requesting access",
       "choice_b":"The server that is providing authentication",
       "choice_c":"The device that is controlling access via 802.1X",
       "choice_d":"The device connecting the layer 3 network",
       "correct_answer":"A",
       "explanation":"The device requesting access is the supplicant. The supplicant is built into the operating system in which it is authenticating. The server that is providing authentication is the authentication server, which is commonly the AAA RADIUS server. The device that is controlling the access via the 802.1X protocol is the authenticator. The device connecting the layer 3 network is normally a router or layer 3 switch."
    },
    {
       "id":805,
       "topic_id":5,
       "sub_domain":"5.4 Describe security password policies elements, such as management, complexity, and password alternatives (multifactor authentication, certificates, and biometrics)",
       "practice_test_id":5,
       "question":"A smart card is an example of which type of authentication?",
       "choice_a":"Single-factor authentication",
       "choice_b":"RADIUS authentication",
       "choice_c":"Multifactor authentication",
       "choice_d":"Active Directory authentication",
       "correct_answer":"C",
       "explanation":"A smart card is an example of multifactor authentication because you must have the smart card and know the passphrase that secures the credentials stored on the card. Single-factor authentication would only require having something or knowing something, but not both in this instance. RADIUS authentication requires an authentication server for validating usernames and passwords. Active Directory authentication requires a username and password."
    },
    {
       "id":806,
       "topic_id":5,
       "sub_domain":"5.4 Describe security password policies elements, such as management, complexity, and password alternatives (multifactor authentication, certificates, and biometrics)",
       "practice_test_id":"",
       "question":"You believe that a user's account has been compromised via a password attack. What should have been enforced to prevent this?",
       "choice_a":"Password complexity",
       "choice_b":"Password expiration",
       "choice_c":"Phishing protection",
       "choice_d":"Time restrictions",
       "correct_answer":"A",
       "explanation":"Turning on password complexity would reduce the risk of a password attack. Password expiration would be secondary to password complexity to reduce the risk, since without complexity the user could create a simple password. Phishing protection would not prevent a password attack. Time restrictions would not prevent a password attack."
    },
    {
       "id":807,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":"",
       "question":"Which statement is correct about GRE tunnels?",
       "choice_a":"GRE uses IPsec security.",
       "choice_b":"GRE uses a protocol of 57.",
       "choice_c":"GRE provides per-packet authentication.",
       "choice_d":"GRE provides packet-in-packet encapsulation.",
       "correct_answer":"D",
       "explanation":"Generic Routing Encapsulation (GRE) tunnels provide packet-in-packet encapsulation. It takes the original IP packet and encapsulates it, adding another IP packet for the GRE tunnel. GRE tunnels alone do not provide any encryption. GRE does not use IPsec security by default.It must be configured to use this security protocol inside of the GRE packet; this is commonly called an IPsec security transform. GRE uses a layer 3 IP protocol of 47, not 57. GRE does not provide per-packet authentication; IPsec can provide this service."
    },
    {
       "id":808,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":"",
       "question":"Which tunnel protocol is a Cisco proprietary protocol?",
       "choice_a":"GRE",
       "choice_b":"PPP",
       "choice_c":"IPsec",
       "choice_d":"SSL",
       "correct_answer":"A",
       "explanation":"Generic Routing Encapsulation is a Cisco proprietary standard for encapsulating layer 3 protocols over an IP network, such as the Internet. Point-to-Point Protocol (PPP) is an IEEE standardized protocol for point-to-point links. IP Security (IPsec) is an IEEE standardized protocol for encryption of IP packets. Secure Sockets Layer (SSL) is an IEEE standardized protocol for mutual authentication and encryption between two hosts using certificates."
    },
    {
       "id":809,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":"",
       "question":"Which layer 3 protocol does GRE use?",
       "choice_a":"Protocol 4",
       "choice_b":"Protocol 43",
       "choice_c":"Protocol 47",
       "choice_d":"Protocol 57",
       "correct_answer":"C",
       "explanation":"GRE uses the layer 3 protocol 47, which is the protocol that is stated in the layer 3 header. These protocol numbers are IP layer protocol numbers and should not be confused with TCP/UDP layer 4 port numbers. All of the other options are incorrect."
    },
    {
       "id":810,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":"",
       "question":"In the following exhibit, you are configuring a GRE tunnel. What is wrong with this configuration?<img src='/question_assets/ccna/5_image2.png'></img>",
       "choice_a":"Nothing is wrong with the configuration.",
       "choice_b":"The destination on Router A of the tunnel is incorrect.",
       "choice_c":"The network is unrouteable.",
       "choice_d":"The serial interfaces are on different networks.",
       "correct_answer":"C",
       "explanation":"The network is unrouteable, since interface G0/1 on Router A is configured with a 192.168.1.0/24 network and interface G0/1 on Router B is configured with a 192.168.1.0/24. The route statement that needs to be configured will not pass any traffic since 192.168.1.0/24 is directly configured on both routers. The destination on Router A of the tunnel is correct, but the interface G0/1 on Router B is incorrectly addressed. The serial interfaces are on different addresses but most likely correspond to the IP network in the WAN cloud."
    },
    {
       "id":811,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":"",
       "question":"In the following exhibit, you are configuring a GRE tunnel and need to configure a route statement on Router A. Which is the correct route statement?<img src='/question_assets/ccna/5_image3.png'></img>",
       "choice_a":"<code>Router(config)#ip route 192.168.3.0 255.255.255.0 tunnel 0</code>",
       "choice_b":"<code>Router(config)#ip route 192.168.2.0 255.255.255.0 tunnel 0</code>",
       "choice_c":"<code>Router(config)#ip route 192.168.3.0 255.255.255.0 serial 0/0/1</code>",
       "choice_d":"<code>Router(config)#ip route 192.168.3.0 255.255.255.0 192.168.2.2</code>",
       "correct_answer":"D",
       "explanation":"The correct route statement is <code>ip route 192.168.3.0 255.255.255.0 192.168.2.2,</code> because the network of 192.168.2.0/24 is built between these two routers. The tunnel acts as a routed interface between the routers. The route statement <code>ip route 192.168.3.0 255.255.255.0 tunnel 0</code> is incorrect. The route statement <code>ip route 192.168.2.0 255.255.255.0 tunnel 0</code> is incorrect. The route statement <code>ip route 192.168.3.0 255.255.255.0 serial 0/0/1</code> is incorrect."
    },
    {
       "id":812,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":"",
       "question":"What is the default MTU of a GRE tunnel?",
       "choice_a":"MTU 1476",
       "choice_b":"MTU 1492",
       "choice_c":"MTU 1500",
       "choice_d":"MTU 1528",
       "correct_answer":"A",
       "explanation":"The maximum transmission unit of a GRE tunnel is 1476 because there are 24 bytes of overhead for the GRE header;20 bytes are used by the public IP header and 4 bytes are used for GRE. Ethernet is commonly set to an MTU of 1492 or an MTU of 1500. An 802.1Q packet is commonly set to an MTU of 1528 because of the additional VLAN tagging information."
    },
    {
       "id":813,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":"",
       "question":"Which command will help you verify the source and destination of a GRE tunnel?",
       "choice_a":"<code>Router#show ip tunnel 0</code>",
       "choice_b":"<code>Router#show interface tunnel 0</code>",
       "choice_c":"<code>Router#show ipgre</code>",
       "choice_d":"<code>Router#show ip route</code>",
       "correct_answer":"B",
       "explanation":"The command <code>show interface tunnel 0</code> will show in the output the source and destination of the tunnel. The command <code>show ip tunnel 0</code> is incorrect. The command <code>show ipgre</code> is incorrect. The command <code>show ip route</code> is incorrect."
    },
    {
       "id":814,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":"",
       "question":"In the following exhibit, if you do a traceroute on Router A to a destination of 192.168.3.50, how many hops will show?<img src='/question_assets/ccna/5_image4.png'></img>",
       "choice_a":"One hop",
       "choice_b":"Two hops",
       "choice_c":"Four hops",
       "choice_d":"Zero hops",
       "correct_answer":"A",
       "explanation":"If a traceroute is performed to 192.168.3.50 on Router A, it will show one hop. This is because the 192.168.3.0 network is on the other side of the tunnel interface, which is one hop away. All of the other options are incorrect."
    },
    {
       "id":815,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":"",
       "question":"Refer to the following exhibit. You are configuring a GRE tunnel. However, you cannot ping from Router A to 192.168.3.1. What is the problem?<img src='/question_assets/ccna/5_image5.png'></img>",
       "choice_a":"The tunnel numbers do not match.",
       "choice_b":"The destination on Router A of the tunnel is incorrect.",
       "choice_c":"The routes are wrong.",
       "choice_d":"The serial interfaces do not match.",
       "correct_answer":"C",
       "explanation":"The routes are wrong. They should be set to the destination of the opposite tunnel IP address and not the serial WAN address. The tunnel numbers do not need to match since they are locally significant to the configuration. The destination on Router A of the tunnel is correct because it points to the serial WAN address on Router B. The serial interfaces do not need to match because they are locally significant to the configuration on each router."
    },
    {
       "id":816,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":"",
       "question":"Which protocol helps resolve and direct traffic for DMVPN connections?",
       "choice_a":"HSRP",
       "choice_b":"NHRP",
       "choice_c":"ARP",
       "choice_d":"GRE",
       "correct_answer":"B",
       "explanation":"The Next Hop Router Protocol (NHRP) is responsible for resolving and directing traffic for Dynamic Multipoint VPN (DMVPN) traffic. Hot Standby Router Protocol (HSRP) is a first hop redundancy protocol (FHRP) used to failover to another standby router in the event the active router is offline. Address Resolution Protocol (ARP) is an IP helper protocol to determine the destination MAC address according to a destination IP address. Generic Router Encapsulation (GRE) is a Cisco proprietary standard for encapsulating layer 3 protocols over an IP network, such as the Internet."
    },
    {
       "id":817,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":4,
       "question":"Refer to the following exhibit. You have configured a point-to-point dedicated line between two locations. However, you cannot ping between the two routers. What is the problem?<img src='/question_assets/ccna/5_image6.png'></img>",
       "choice_a":"The interface is administratively shut down.",
       "choice_b":"There is a wiring problem.",
       "choice_c":"There is a protocol mismatch.",
       "choice_d":"There is an IP address mismatch.",
       "correct_answer":"C",
       "explanation":"The problem is a layer 2 problem because both routers are in an UP/DOWN state for the connecting serial interfaces. Router A has a protocol of HDLC configured and Router B has a protocol of PPP configured. The output of the <code>show interface</code> command for both serial 0/0 and serial 0/1 on both routers does not show that the interfaces have been administratively disabled. The output of the <code>show interface</code> command on both routers does not support the theory that a wiring problem exists. If there was an IP address mismatch, the line protocol would still be in a UP state."
    },
    {
       "id":818,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":5,
       "question":"DMVPN is an example of which topology?",
       "choice_a":"Point-to-point",
       "choice_b":"Hub-and-spoke",
       "choice_c":"Full-mesh",
       "choice_d":"Dual-homed",
       "correct_answer":"B",
       "explanation":"Dynamic Multipoint VPN (DMVPN) is an example of a hub-and-spoke or point-to-multipoint topology. All of the satellite connections terminate back to the central location. A single VPN site-to-site connection would be an example of a point-to-point topology. A full-mesh topology is commonly found on the core layer of an enterprise network. A dual-homed topology is commonly found on the WAN of enterprises that have two or more redundant connections to the Internet."
    },
    {
       "id":819,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":1,
       "question":"Which benefit of using a secure VPN allows verification that a packet was not tampered with in transit?",
       "choice_a":"Authentication",
       "choice_b":"Data integrity",
       "choice_c":"Anti-replay",
       "choice_d":"Confidentiality",
       "correct_answer":"B",
       "explanation":"Date integrity is one of the benefits of using a secure VPN protocol. To ensure its integrity, a packet is sealed with a hash that must be calculated to the same hash on the other side when it is received and decrypted. Authentication is a benefit to using a VPN in that both parties are authenticated before network transmission begins. Anti-replay is a byproduct of authentication and data integrity; packets cannot be replayed without authentication between both parties and a rehashing of the packets. Confidentiality is created with any VPN because of the end-to-end encryption."
    },
    {
       "id":820,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":"",
       "question":"Which Cisco technology is often used to create VPN tunnels between sites?",
       "choice_a":"Catalyst switches",
       "choice_b":"Cisco routers",
       "choice_c":"Cisco FTD",
       "choice_d":"Policy-based routing",
       "correct_answer":"C",
       "explanation":"Cisco Firepower Threat Defense (FTD)devices are used to create VPN tunnels between sites. FTD devices run the Cisco FTD software, which allows for firewall, intrusion prevention, and VPNs among other security-related functions. Catalyst switches and Cisco routers are not commonly used to create VPN tunnels between sites. Policy-based routing is a way to selectively route packets depending upon specific criteria."
    },
    {
       "id":821,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":"",
       "question":"You have several remote workers who enter patient information and require a high level of security. Which technology would best suit the connectivity for these workers?",
       "choice_a":"GRE tunnels",
       "choice_b":"Wireless WAN",
       "choice_c":"Client SSL/VPN",
       "choice_d":"Site-to-site VPN",
       "correct_answer":"C",
       "explanation":"Since you have several remote workers who telecommute, the best connectivity option would be client SSL/VPN connectivity. A product called Cisco AnyConnect Secure Mobility Client allows for SSL encryption for VPN tunnels back to the main site. A GRE tunnel is often use for site-to-site connectivity where an IPsec tunnel is also implemented. Wireless WAN can be used to connect clients to the Internet, but the client-to-site connection would be a VPN or SSL connection over the Internet. Site-to-site VPN connections are intended for connecting sites to each other via an encrypted tunnel over the Internet."
    },
    {
       "id":822,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":"",
       "question":"Which protocol does IPsec use to encrypt data packets?",
       "choice_a":"AH",
       "choice_b":"ESP",
       "choice_c":"IKE",
       "choice_d":"ISAKMP",
       "correct_answer":"B",
       "explanation":"IPsec uses the Encapsulating Security Payload (ESP) protocol to encrypt data. The Authentication Headers (AH) protocol is used with IPsec for the integrity of data. Internet Key Exchange (IKE) is used between two IPsec members so they can build a security association (SA). Internet Security Association and Key Management Protocol (ISAKMP) uses IKE to build an SA so that encryption keys can be exchanged in the second phase of encryption."
    },
    {
       "id":823,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":"",
       "question":"What is a benefit of site-to-site IPsec VPNs?",
       "choice_a":"Lower bandwidth requirements",
       "choice_b":"Lower latency",
       "choice_c":"Scalability",
       "choice_d":"Support for multicast",
       "correct_answer":"C",
       "explanation":"Site-to-site IPsec VPNs offer scalability as a benefit. This is because each remote office only needs an Internet connection to create a VPN tunnel back to the main office. There is a certain overhead when using VPN; therefore, higher bandwidth requirements may exist after deploying site-to-site IPsec VPNs. Latency is affected and will be higher due to the level of encryption each packet must undergo as it pass through the site-to-site VPN. Support for multicast is not a common benefit to site-to-site IPsec VPNs."
    },
    {
       "id":824,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"What is the range of a standard access list?",
       "choice_a":"1 to 99",
       "choice_b":"1 to 100",
       "choice_c":"100 to 199",
       "choice_d":"100 to 200",
       "correct_answer":"A",
       "explanation":"Standard access lists are within the range of 1 to 99. Extended access lists are within the range of 100 to 199. All of the other options are incorrect."
    },
    {
       "id":825,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"Which statement is correct about a standard ACL ?",
       "choice_a":"Conditions can be based upon only the destination address.",
       "choice_b":"Conditions can be based upon only the source address and source port.",
       "choice_c":"Conditions can be based upon only the source address.",
       "choice_d":"Conditions can be based upon the source or destination address and source or destination port.",
       "correct_answer":"C",
       "explanation":"Standard access controllists can be based upon only the source address of the packet.Extended access control list conditions can be based on the destination address. When using standard access control list conditions, the source address can solely be used to create a condition, but a source port cannot be defined. Extended access control list conditions allow for combinations of source or destination address and source or destination port."
    },
    {
       "id":826,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"What is the range of an extended access list?",
       "choice_a":"1 to 99",
       "choice_b":"1 to 100",
       "choice_c":"100 to 199",
       "choice_d":"100 to 200",
       "correct_answer":"C",
       "explanation":"Extended access lists are within the range of 100 to 199. Standard access lists are within the range of 1 to 99. All of the other options are incorrect."
    },
    {
       "id":827,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":4,
       "question":"What is at the end of every ACL?",
       "choice_a":"<code>permit any any</code>",
       "choice_b":"<code>deny any any</code>",
       "choice_c":"<code>log all</code>",
       "choice_d":"End of ACL marker",
       "correct_answer":"B",
       "explanation":"At the end of every access list there is a deny any any rule. If a permit is not configured in the access list, the ACL does not serve a purpose. All ACLs must contain at least one permit statement to be considered an actionable ACL. All of the other options are incorrect."
    },
    {
       "id":828,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":5,
       "question":"Which statement is correct about an access control list?",
       "choice_a":"Packets are compared sequentially against each line in an access list, and the last matching condition is the action taken.",
       "choice_b":"Packets are compared sequentially against each line in an access list until a match is made.",
       "choice_c":"Packets are compared, and if no matching rule exists, they are allowed.",
       "choice_d":"At the end of the access control list, there is an implicit allow.",
       "correct_answer":"B",
       "explanation":"When packets are compared to an access control list, they are compared in a sequential order. When the first rule is found to match, the action is acted upon. There is no further rule processing after the first match. There is an explicit <code>deny any any</code> rule at the end of each ACL. Therefore, if none of the conditions matches the packet, it is discarded due to the conditions matching the <code>deny any any</code> rule at the end of the list."
    },
    {
       "id":829,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"What is an advantage of using a standard ACL?",
       "choice_a":"More secure",
       "choice_b":"Less processing overhead",
       "choice_c":"More specific rules",
       "choice_d":"Blocking of applications",
       "correct_answer":"B",
       "explanation":"An advantage to a standard access control list is that they require less processing overhead from the ASIC or CPU (depending on the platform). Since they only inspect layer 3 headers, no further decapsulation is required for layer 4. The level of security is not increased or decreased when using standard access control lists. If a higher level of specificity for the condition is required, then extended access lists should be used. Blocking of specific applications can only be achieved with extended access lists because the source and destination ports can be specified."
    },
    {
       "id":830,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"What is the expanded range of a standard access list?",
       "choice_a":"1000 to 1999",
       "choice_b":"1100 to 1299",
       "choice_c":"1300 to 1999",
       "choice_d":"2000 to 2699",
       "correct_answer":"C",
       "explanation":"The expanded range of a standard access list is 1300 to 1999. The range for an expanded extended access list is 2000 to 2699. All of the other options are incorrect."
    },
    {
       "id":831,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"You need to filter traffic for the 172.16.0.0/12 network. Which wildcard mask would you use?",
       "choice_a":"255.240.0.0",
       "choice_b":"0.0.240.255",
       "choice_c":"0.15.255.255",
       "choice_d":"255.3.0.0",
       "correct_answer":"C",
       "explanation":"A wildcard mask is the opposite of a network mask. The easy way to calculate a wildcard mask is to figure out what the subnet is and deduct 1 for the octet. For example, if the network address is 172.16.0.0/12 (Classless Inter-Domain Routing), or 255.240.0.0 (dotted decimal notation), and each network number is a multiple of 16, the wildcard mask should be 0.15.255.255. 255.240.0.0 is the network mask for the 172.16.0.0/12 network. All of the other options are incorrect."
    },
    {
       "id":832,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"Which command would configure an ACL to block traffic coming from 192.168.1.0/24?",
       "choice_a":"<code>Router(config)#ip access-list 20 192.168.1.0 0.0.0.255</code>",
       "choice_b":"<code>Router(config)#ip access-list 100 192.168.1.0 0.0.0.255</code>",
       "choice_c":"<code>Router(config)#ip access-list 1 192.168.1.0/24</code>",
       "choice_d":"<code>Router(config)#ip access-list 2 192.168.1.0 255.255.255.0</code>",
       "correct_answer":"A",
       "explanation":"The command <code>ip access-list 20 192.168.1.0 0.0.0.255</code> will configure an access list of 20, which is a standard access list. The source address of 192.168.1.0 is wildcard masked with 0.0.0.255. The command <code>ip access-list 100 192.168.1.0 0.0.0.255</code> is incorrect. The command <code>ip access-list 1 192.168.1.0/24</code> is incorrect. The command <code>ip access-list 2 192.168.1.0 255.255.255.0</code> is incorrect."
    },
    {
       "id":833,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":1,
       "question":"If you configure a rule with the address of 0.0.0.0 and wildcard mask of 255.255.255.255, what are you doing?",
       "choice_a":"Defining the broadcast address",
       "choice_b":"Defining no addresses",
       "choice_c":"Defining the network address",
       "choice_d":"Defining all addresses",
       "correct_answer":"D",
       "explanation":"A rule with an address of 0.0.0.0 and wildcard mask of 255.255.255.255 defines all addresses. Effectively, it is another way to specify the \u0022any\u0022 source or destination. All of the other options are incorrect."
    },
    {
       "id":834,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"Which statement is correct about applying ACLs to an interface?",
       "choice_a":"An ACL can be applied in only one direction.",
       "choice_b":"An ACL can be applied only to a single protocol.",
       "choice_c":"An ACL can be applied only to a single port.",
       "choice_d":"All of the above.",
       "correct_answer":"D",
       "explanation":"Access lists can be applied per a port, per a protocol, and per a direction. For example, you could apply only one ACL per the interface of Fa 0/1, per the protocol of IP in the inbound direction."
    },
    {
       "id":835,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"You need to filter an application. Which type of access list will you use to complete the task?",
       "choice_a":"Standard",
       "choice_b":"Extended",
       "choice_c":"Dynamic",
       "choice_d":"Expanded",
       "correct_answer":"B",
       "explanation":"An extended access list allows you to filter traffic by port, which defines an application being used since web traffic is communicated on 80 or 443. A standard access list can only filter by the source IP address. A dynamic ACL is an ACL that is controlled by some dynamic factor such as traffic patterns or time of day. An expanded ACL is not really a type of ACL; it specifies the expanded numbering for standard and extended ACLs."
    },
    {
       "id":836,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"What is the expanded range of an extended access list?",
       "choice_a":"1000 to 1999",
       "choice_b":"1100 to 1299",
       "choice_c":"1300 to 1999",
       "choice_d":"2000 to 2699",
       "correct_answer":"D",
       "explanation":"The expanded range of a standard access list is 2000 to 2699. The expanded range of a standard access list is 1300 to 1999. The other options are incorrect."
    },
    {
       "id":837,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"You need to filter traffic for the 192.168.1.0/25 network. Which wildcard mask would you use?",
       "choice_a":"255.255.255.128",
       "choice_b":"0.0.0.128",
       "choice_c":"0.0.0.127",
       "choice_d":"0.0.0.63",
       "correct_answer":"C",
       "explanation":"A wildcard mask is the opposite of a network mask. The easy way to calculate a wildcard mask is to figure out what the subnet is and deduct 1 for the octet. For example, if the network address is 192.168.1.0/25 (Classless Inter-Domain Routing), or 255.255.255.128 (dotted decimal notation), and each network number is a multiple of 128, the wildcard mask should be 0.0.0.127. The network mask 255.255.255.128 is the network mask used with the 192.168.1.0/25 network. The other options are incorrect."
    },
    {
       "id":838,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"Which type of ACL allows for removing a single entry without removing the entire ACL?",
       "choice_a":"Standard",
       "choice_b":"Dynamic",
       "choice_c":"Extended",
       "choice_d":"Named",
       "correct_answer":"D",
       "explanation":"A named access control list allows for removing and adding entries by their line number. Standard and extended access lists require the entire ACL to be removed and reconfigured if one entry needs to be removed. Dynamic access lists are special access lists that are used with the condition of time or traffic and by default do not allow for per entry editing."
    },
    {
       "id":839,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"Which type of ACL allows you to open a port only after someone has successfully logged into the router?",
       "choice_a":"Standard",
       "choice_b":"Dynamic",
       "choice_c":"Extended",
       "choice_d":"Named",
       "correct_answer":"B",
       "explanation":"Once a successful login is performed at the router, the dynamic access control list is activated. This is also called lock and key security. Standard access lists can execute actions based upon the condition of a source IP address only. Extended access lists can execute actions based upon the condition of a source and destination IP address as well as source and destination port numbers. Named access lists are nothing more than standard or extended access lists and use a name in lieu of a specific number."
    },
    {
       "id":840,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"Which statement configures a standard access list?",
       "choice_a":"<code>Router(config)#access-list 20 deny 172.16.0.0 0.255.255.255</code>",
       "choice_b":"<code>Router(config)#access-list 180 permit udp any 172.16.0.0 0.255.255.255 eq 161</code>",
       "choice_c":"<code>Router(config)#access-list 130 permit permit ip any any</code>",
       "choice_d":"<code>Router(config)#access-list 150 deny any 172.16.0.0 0.255.255.255</code>",
       "correct_answer":"A",
       "explanation":"The statement <code>access-list 20 deny 172.16.0.0 0.255.255.255</code> configures a standard access list for two reasons: The first is that the access list number is 20, which falls within the standard access list range of 1 to 99. The second reason is that you are depicting traffic by source address. The command <code>access-list 180 permit udp any 172.16.0.0 0.255.255.255 eq 161</code> is incorrect. The command <code>access-list 130 permit permit ip any any</code> is incorrect. The command <code>access-list 150 deny any 172.16.0.0 0.255.255.255</code> is incorrect."
    },
    {
       "id":841,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":4,
       "question":"Which statement can be used in lieu of <code>access-list 5 permit 192.168.1.5 0.0.0.0</code>?",
       "choice_a":"<code>Router(config)#access-list 5 permit 192.168.1.5</code>",
       "choice_b":"<code>Router(config)#access-list 5 permit 192.168.1.5/24</code>",
       "choice_c":"<code>Router(config)#access-list 5 permit host 192.168.1.5</code>",
       "choice_d":"<code>Router(config)#access-list 5 permit 192.168.1.0 0.0.0.255</code>",
       "correct_answer":"C",
       "explanation":"The command <code>access-list 5 permit host 192.168.1.5</code> specifies the traffic coming from the host 192.168.1.5. The statement <code>access-list 5 permit 192.168.1.5 0.0.0.0</code> achieves the same thing. The command <code>access-list 5 permit 192.168.1.5</code> is incorrect. The command <code>access-list 5 permit 192.168.1.5/24</code> is incorrect. The command <code>access-list 5 permit 192.168.1.0 0.0.0.255</code> is incorrect."
    },
    {
       "id":842,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":5,
       "question":"Referring to the following exhibit, you need to block traffic from the host 192.168.2.6 to the HR web application server but allow it to get to all other servers and the Internet. Which command(s) will achieve this?<img src='/question_assets/ccna/5_image7.png'></img>",
       "choice_a":"<code>Router(config)#access-list 101 deny tcp host 192.168.2.6 host 192.168.1.3 eq 80</code><br><code>Router(config)#access-list 101 permit any any</code>",
       "choice_b":"<code>Router(config)#access-list 101 deny tcp host 192.168.2.6 host 192.168.1.3 eq 80</code><br><code>Router(config)#access-list 101 permit ip any any</code>",
       "choice_c":"<code>Router(config)#access-list 101 deny host 192.168.2.6 host 192.168.1.3 eq 80</code><br><code>Router(config)#access-list 101 permit any any</code>",
       "choice_d":"<code>Router(config)#access-list 101 deny tcp host 192.168.2.6 host 192.168.1.3 eq 80</code><br><code>Router(config)#access-list 101 permit ip any any eq 80</code>",
       "correct_answer":"B",
       "explanation":"The command <code>access-list 101 deny tcp host 192.168.2.6 host 192.168.1.3 eq 80</code> denies access from the host 192.168.2.3 to the host 192.168.1.6 for port 80. The next command, <code>access-list 101 permit ip any any</code>, allows all IP traffic from any to any. With extended access lists, the protocol needs to be described. The commands <code>access-list 101 deny tcp host 192.168.2.6 host 192.168.1.3 eq 80</code> and <code>access-list 101 permit any any</code> are incorrect. The commands <code>access-list 101 deny host 192.168.2.6 host 192.168.1.3 eq 80</code> and <code>access-list 101 permit any any</code> are incorrect. The commands <code>access-list 101 deny tcp host 192.168.2.6 host 192.168.1.3 eq 80</code> and <code>access-list 101 permit ip any any eq 80</code> are incorrect."
    },
    {
       "id":843,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"Which type of access list limits you to describing traffic by source address?",
       "choice_a":"Extended",
       "choice_b":"Named",
       "choice_c":"Dynamic",
       "choice_d":"Standard",
       "correct_answer":"D",
       "explanation":"Standard access lists only allow you to describe traffic by source address. This helps the processing of the access list because the router or switch does not need to de-capsulate packets further than layer 3. Extended access lists can execute actions based upon the condition of a source and destination IP address as well as source and destination port numbers. Named access lists are nothing more than standard or extended access lists that use a name in lieu of a specific number. Dynamic access lists are ACLs that are triggered off of a specific traffic pattern or a time of day."
    },
    {
       "id":844,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"Which statement will block traffic for a server of 192.168.1.5 for SSH?",
       "choice_a":"<code>Router(config)#access-list 90 deny ip host 192.168.1.5 eq 22</code>",
       "choice_b":"<code>Router(config)#access-list 90 deny tcp any host 192.168.1.5 eq 22</code>",
       "choice_c":"<code>Router(config)#access-list 199 deny tcp host 192.168.1.5 any eq 23</code>",
       "choice_d":"<code>Router(config)#access-list 199 deny tcp any host 192.168.1.5 eq 22</code>",
       "correct_answer":"D",
       "explanation":"The command <code>access-list 199 deny tcp any host 192.168.1.5 eq 22</code> will create an extended access list of 199 and deny TCP communication from any computer to the host of 192.168.1.5 for port 22. The command <code>access-list 90 deny ip host 192.168.1.5 eq 22</code> is incorrect. The command <code>access-list 90 deny tcp any host 192.168.1.5 eq 22</code> is incorrect. The command <code>access-list 199 deny tcp host 192.168.1.5 any eq 23</code> is incorrect."
    },
    {
       "id":845,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"Referring to the following exhibit, you need to block traffic from the host network to the HR web application and allow all traffic to get to the intranet web server. Which type of ACL would you use?<img src='/question_assets/ccna/5_image8.png'></img>",
       "choice_a":"Standard",
       "choice_b":"Dynamic",
       "choice_c":"Extended",
       "choice_d":"Expanded",
       "correct_answer":"C",
       "explanation":"An extended access list is required because you want to block by the destination address of the HR web application server. If you blocked only by source using a standard access list, then all host network traffic would be blocked to all servers. A dynamic access list does not work in this situation because a specific traffic pattern or time of day is not required. Expanded access lists allow for higher numbers to be used with access lists but do not work in this example."
    },
    {
       "id":846,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"Which statement configures a valid access list?",
       "choice_a":"<code>Router(config)#access-list 99 deny tcp host 192.168.2.7 eq 443</code>",
       "choice_b":"<code>Router(config)#access-list 189 deny any host 192.168.1.5 eq 22</code>",
       "choice_c":"<code>Router(config)#access-list 143 permit tcp host 192.168.8.3 eq 80 any</code>",
       "choice_d":"<code>Router(config)#access-list 153 permit any host 192.168.4.5 eq 22</code>",
       "correct_answer":"C",
       "explanation":"The command <code>access-list 143 permit tcp host 192.168.8.3 eq 80 any</code> is a valid statement. All extended access lists that describe a port must also describe the protocol. The command <code>access-list 99 deny tcp host 192.168.2.7 eq 443</code> is incorrect. The command <code>access-list 189 deny any host 192.168.1.5 eq 22</code> is incorrect. The command <code>access-list 153 permit any host 192.168.4.5 eq 22</code> is incorrect."
    },
    {
       "id":847,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"You want to apply an access list of 198 to an interface to filter traffic into the interface. Which command will achieve this?",
       "choice_a":"<code>Router(config)#ip access-list 198 in fast 0/1</code>",
       "choice_b":"<code>Router(config-if)#ip access-list 198 in</code>",
       "choice_c":"<code>Router(config-if)#ip access-class 198 in</code>",
       "choice_d":"<code>Router(config-if)#ip access-group 198 in</code>",
       "correct_answer":"D",
       "explanation":"The command <code>ip access-group 198</code> in will apply access list 198 to the interface in which it is configured in the inbound direction. The command <code>ip access-list 198 in fast 0/1</code> is incorrect. The command <code>ip access-list 198</code> in is incorrect. The command <code>ip access-class 198</code> in is incorrect."
    },
    {
       "id":848,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"Referring to the following exhibit, you want to block the host network from accessing the HR network. Which commands will place the access list on the proper interface to make it effective?<img src='/question_assets/ccna/5_image9.png'></img>",
       "choice_a":"<code>Router(config)#interface gi 0/0</code><br><code>Router(config-if)#ip access-group 2 in</code>",
       "choice_b":"<code>Router(config)#interface gi 0/0</code><br><code>Router(config-if)#ip access-group 2 out</code>",
       "choice_c":"<code>Router(config)#interface gi 0/2</code><br><code>Router(config-if)#ip access-group 2 in</code>",
       "choice_d":"<code>Router(config)#interface gi 0/2</code><br><code>Router(config-if)#ip access-group 2 out</code>",
       "correct_answer":"D",
       "explanation":"The access list must be placed on the Gi0/2 interface outbound. Whenever you are evaluating access list placement, remember that packets are evaluated as they leave the interface, which is outbound. When packets enter the interface, they are evaluated inbound. It is always in the perspective of the router. The commands <code>interface gi 0/0</code> and <code>ip access-group 2</code> in are incorrect because they are applied to the wrong interface. The commands <code>interface gi 0/0</code> and <code>ip access-group 2 out</code> are incorrect because they are applied to the wrong interface. The commands <code>interface gi 0/2</code> and <code>ip access-group 2</code> in are incorrect because they are applied to the wrong direction on the interface."
    },
    {
       "id":849,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"Which command will allow you to see the output in the following exhibit with the line numbers?<img src='/question_assets/ccna/5_image10.png'></img>",
       "choice_a":"<code>Switch#show access-list </code><italic>named_list</italic>",
       "choice_b":"<code>Switch#show ip access-list </code><italic>named_list</italic>",
       "choice_c":"<code>Switch#show running-configuration</code>",
       "choice_d":"<code>Switch#show ip access-list</code>",
       "correct_answer":"D",
       "explanation":"The command <code>show ip access-list</code> will show all access lists with the line numbers. If the command is specific, such as <code>show ip access-list </code><italic>named_list</italic>, you will see the ACL lines but no line numbers. The command <code>show access-list </code><italic>named_list</italic> is incorrect. The command <code>show ip access-list</code> is incorrect. The command <code>show running-configuration</code> is incorrect."
    },
    {
       "id":850,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"Which type of ACL should be placed closest to the source of traffic?",
       "choice_a":"Extended",
       "choice_b":"Standard",
       "choice_c":"Dynamic",
       "choice_d":"Expanded",
       "correct_answer":"A",
       "explanation":"Extended ACLs should always be placed closest to the source of traffic since they are extremely granular. Standard ACLs should always be placed closest to the destination of traffic since they only specify the source IP address. Dynamic ACLs can be placed in either location because they can be standard or extended access lists, with the addition of traffic-based rules or time of day-based rules. An expanded ACL is not really a type of ACL; it specifies the expanded numbering for standard and extended ACLs."
    },
    {
       "id":851,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"Which command will create an extended named access list?",
       "choice_a":"<code>Router(config)#access-list 101 allow host 192.168.1.5 any</code>",
       "choice_b":"<code>Router(config)#ip access-list </code><italic>named_list</italic>",
       "choice_c":"<code>Router(config)#ip access-list extended </code><italic>named_list</italic>",
       "choice_d":"<code>Router(config)#ip access-list 101 </code><italic>named_list</italic>",
       "correct_answer":"C",
       "explanation":"The command <code>ip access-list extended </code><italic>named_list</italic> will create an extended named access list. The command <code>access-list 101 allow host 192.168.1.5 any</code> is incorrect. The command <code>ip access-list </code><italic>named_list</italic> is incorrect. The command <code>ip access-list 101 </code><italic>named_list</italic> is incorrect."
    },
    {
       "id":852,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":"",
       "question":"Which type of ACL should be placed closest to the destination of traffic?",
       "choice_a":"Extended",
       "choice_b":"Standard",
       "choice_c":"Dynamic",
       "choice_d":"Expanded",
       "correct_answer":"B",
       "explanation":"Standard ACLs should always be placed closest to the destination of traffic since they are broad in the traffic they control. Extended ACLs should always be placed closest to the source of traffic since they are extremely granular. Dynamic ACLs can be placed in either location because they can be standard or extended access lists, with the addition of traffic-based rules or time of day-based rules. An expanded ACL is not really a type of ACL; it specifies the expanded numbering for standard and extended ACLs."
    },
    {
       "id":853,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":4,
       "question":"Which command should you start with when trying to diagnose port security issues?",
       "choice_a":"<code>Switch#show port-security</code>",
       "choice_b":"<code>Switch#show mac address-table</code>",
       "choice_c":"<code>Switch#show interface</code>",
       "choice_d":"<code>Switch#show security</code>",
       "correct_answer":"A",
       "explanation":"When you're trying to diagnose port security, the first command should be <code>show port-security</code>. This will detail all of the ports with port security and their expected behavior when port security is violated. The command <code>show mac address-table</code> is incorrect. The command <code>show interface</code> is incorrect. The command <code>show security</code> is incorrect."
    },
    {
       "id":854,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":5,
       "question":"You have configured an access port for a remote office computer. The office has no IT persons on site. You want to stop workers from plugging in a WAP and exposing your company's internal network. Which feature should you configure?",
       "choice_a":"Dynamic VLANs",
       "choice_b":"Port security",
       "choice_c":"ACLs",
       "choice_d":"VLAN pruning",
       "correct_answer":"B",
       "explanation":"Since the remote office has no onsite IT personnel, there is a risk of workers plugging in unauthorized equipment such as a WAP. If port security is implemented, the interface can be secured to allow only the MAC address of the computer to pass; all other traffic can be dropped. Dynamic VLANs will not prevent unauthorized equipment from being plugged into the network, such as a WAP. ACLs can mitigate what is accessible on servers but will not prevent unauthorized equipment from being plugged in. VLAN pruning is a good overall practice to minimize traffic across trunk links, but it does nothing for end device security."
    },
    {
       "id":855,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"Which method can restrict a user from plugging a WAP into a corporate network?",
       "choice_a":"ACL",
       "choice_b":"Port security",
       "choice_c":"Wired Equivalent Privacy",
       "choice_d":"Static MAC addresses",
       "correct_answer":"B",
       "explanation":"Port security can restrict a port to a single device by MAC address. This will effectively make plugging in a wireless access point a non-event for a corporate network. Access control lists cannot restrict a wireless access point from being plugged into the corporate network. Wired Equivalent Privacy (WEP) is a very insecure wireless encryption protocol and will not prevent a wireless access point from being plugged into the corporate network. Static MAC addresses will not stop a wireless access point from being plugged into the corporate network."
    },
    {
       "id":856,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"What does port security use to block unauthorized access?",
       "choice_a":"Source MAC addresses",
       "choice_b":"Destination MAC addresses",
       "choice_c":"Source IP addresses",
       "choice_d":"Destination IP addresses",
       "correct_answer":"A",
       "explanation":"Port security blocks unauthorized access by examining the source address of a network device. The destination MAC address is used for forward filter decisions. The source and destination IP addresses are used by access control lists to filter traffic."
    },
    {
       "id":857,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"Which command will enable port security?",
       "choice_a":"<code>Switch(config)#switchport port-security</code>",
       "choice_b":"<code>Switch(config)#port-security enable</code>",
       "choice_c":"<code>Switch(config-if)#switchport port-security</code>",
       "choice_d":"<code>Switch(config-if)#port-security enable</code>",
       "correct_answer":"C",
       "explanation":"Port security is enabled by configuring the command <code>switchport port-security</code>. This command must be configured on the interface in which you want to enable port security. The command <code>switchport port-security</code> is incorrect when it is configured in a global configuration prompt. The command <code>port-security enable</code> is incorrect regardless of where it is configured."
    },
    {
       "id":858,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"If port security is enabled on an interface, what is the maximum number of MAC addresses allowed by default?",
       "choice_a":"1 MAC address",
       "choice_b":"2 MAC addresses",
       "choice_c":"0 MAC addresses",
       "choice_d":"10 MAC addresses",
       "correct_answer":"A",
       "explanation":"By default, only a single MAC address is allowed on an interface when port security is enabled. All of the other options are incorrect."
    },
    {
       "id":859,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"Which layer of the OSI model does port security use for securing a port?",
       "choice_a":"Layer 0",
       "choice_b":"Layer 1",
       "choice_c":"Layer 2",
       "choice_d":"Layer 3",
       "correct_answer":"C",
       "explanation":"Port security operates at layer 2 by inspecting the source MAC addresses in frames. It allows the configured number of source MAC addresses to be switched into the port and onto the switch processor. All of the other options are incorrect."
    },
    {
       "id":860,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"Why would a network admin choose to configure port security on an interface?",
       "choice_a":"To allow or disallow VLANs",
       "choice_b":"To allow or disallow IP addresses",
       "choice_c":"To prevent unauthorized access by MAC address",
       "choice_d":"To prevent unauthorized access by users",
       "correct_answer":"C",
       "explanation":"Configuring port security helps a network administrator prevent unauthorized access by MAC address. VLANs can be allowed or disallowed only on a trunk link and not on an access link. ACLs can be used to allow or disallow IP addresses. Port security cannot be used to prevent unauthorized access by users."
    },
    {
       "id":861,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":1,
       "question":"Which statement is correct about port security?",
       "choice_a":"Port security works best in mobile environments.",
       "choice_b":"Port security requires a higher amount of memory.",
       "choice_c":"Port security works best in static environments.",
       "choice_d":"Port security always results in admin intervention to reset the port.",
       "correct_answer":"C",
       "explanation":"Port security works best in static environments where there is minimal change to the environment. It does not require any more memory since the results are pulled from the MAC address table. Port security can work in mobile environments, but depending on the configuration, it may become an administrative burden. Port security does not require a higher amount of memory. Port security can be configured so that admin intervention to reset an err-disabled port is not required."
    },
    {
       "id":862,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":4,
       "question":"When configuring port security on a port that contains a VoIP phone with a voice VLAN and a computer connected to the phone, how many MAC addresses must you allow?",
       "choice_a":"1 MAC address",
       "choice_b":"2 MAC addresses",
       "choice_c":"0 MAC addresses",
       "choice_d":"10 MAC addresses",
       "correct_answer":"B",
       "explanation":"Both the computer and the VoIP phone have MAC addresses, and therefore you will need to allow the port to have two MAC addresses, one for the phone to communicate and the other for the computer to communicate on the port. All of the other options are incorrect."
    },
    {
       "id":863,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":5,
       "question":"What is the default action of port security on the interface when the maximum number of MAC addresses is exceeded?",
       "choice_a":"Administrative shutdown",
       "choice_b":"Err-disabled shutdown",
       "choice_c":"Restricted access without logging",
       "choice_d":"Restricted access with logging",
       "correct_answer":"B",
       "explanation":"By default, when port security is configured on a port, the violation method is err-disabled shutdown. Administratively shutdown ports can only be configured by an administrator. You can configure port security to restrict access to a MAC address with and without logging."
    },
    {
       "id":864,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"You are configuring a port for port security and receive the error <code>Command rejected: FastEthernet0/1 is a dynamic port</code>. Which commands will help you configure the port?",
       "choice_a":"<code>SwitchA(config-if)#no switchport dynamic</code><br><code>SwitchA(config-if)#switchport port-security</code>",
       "choice_b":"<code>SwitchA(config-if)#switchport mode access</code><br><code>SwitchA(config-if)#switchport port-security</code>",
       "choice_c":"<code>SwitchA(config-if)#switchport mode access</code><br><code>SwitchA(config-if)#switchportnonnegotiate</code><br><code>SwitchA(config-if)#switchport port-security</code>",
       "choice_d":"<code>SwitchA(config-if)#switchport mode access</code><br><code>SwitchA(config-if)#no dynamic</code><br><code>SwitchA(config-if)#switchport port-security</code>",
       "correct_answer":"C",
       "explanation":"When port security is configured, the port cannot be in dynamic mode for Dynamic Trunking Protocol (DTP) mode. You must configure the port as an access port first, then turn off DTP with the command <code>switchportnonnegotiate</code>. You can then configure switchport security. The commands <code>no switchport dynamic</code> and <code>switchport port-security</code> are incorrect. The commands <code>switchport mode access</code> and <code>switchport port-security</code> are incorrect. The commands <code>switchport mode access, no dynamic,</code> and <code>switchport port-security</code> are incorrect."
    },
    {
       "id":865,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"Which command will allow you to configure two MAC addresses for port security?",
       "choice_a":"<code>SwitchA(config-if)#switchport maximum 2</code>",
       "choice_b":"<code>SwitchA(config-if)#switchport port-security maximum 2</code>",
       "choice_c":"<code>SwitchA(config-if)#port-security maximum 2</code>",
       "choice_d":"<code>SwitchA(config-if)#switchport port-security limit 2</code>",
       "correct_answer":"B",
       "explanation":"The command <code>switchport port-security maximum 2</code> will configure the port with a maximum of two MAC addresses that shall pass through the port. The command <code>switchport maximum 2</code> is incorrect. The command <code>port-security maximum 2</code> is incorrect. The command <code>switchport port-security limit 2</code> is incorrect."
    },
    {
       "id":866,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"Which command will limit devices via port security without disabling the port and logging the restricted device?",
       "choice_a":"<code>Switch(config-if)#switchport port-security violation shutdown</code>",
       "choice_b":"<code>Switch(config-if)#switchport port-security restrict</code>",
       "choice_c":"<code>Switch(config-if)#switchport port-security violation protect</code>",
       "choice_d":"<code>Switch(config-if)#switchport port-security violation restrict</code>",
       "correct_answer":"D",
       "explanation":"The command <code>switchport port-security violation restrict</code> will set the violation mode to restrict. This will drop frames over the maximum number of learned MAC addresses and will log security violations to the counters. The command <code>switchport port-security violation shutdown</code> is incorrect; this is the default mode in which it will enter an err-disabled state upon a violation. The command <code>switchport port-security restrict</code> is incorrect as it is missing the <code>violation</code> argument. The command <code>switchport port-security violation protect</code> is incorrect because it will not increment the security-violation count while it is dropping frames."
    },
    {
       "id":867,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"Which command will allow you to inspect the status of a port that has been configured for port security?",
       "choice_a":"<code>Switch#show running-configuration</code>",
       "choice_b":"<code>Switch#show port-security interface gi 2/13</code>",
       "choice_c":"<code>Switch#show port-security details interface gi 2/13</code>",
       "choice_d":"<code>Switch#show port-security gi 2/13</code>",
       "correct_answer":"B",
       "explanation":"The command <code>show port-security interface gi 2/13</code> will allow you to see a detailed view of an individual port configured for port security. The command <code>show running-configuration</code> is incorrect; it will not show the status of a port, only the configuration. The command <code>show port-security details interface gi 2/13</code> is incorrect. The command <code>show port-security gi 2/13</code> is incorrect."
    },
    {
       "id":868,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"Which command will limit devices via port security and send an SNMP trap notification?",
       "choice_a":"<code>Switch(config-if)#switchport port-security violation shutdown</code>",
       "choice_b":"<code>Switch(config-if)#switchport port-security restrict</code>",
       "choice_c":"<code>Switch(config-if)#switchport port-security violation protect</code>",
       "choice_d":"<code>Switch(config-if)#switchport port-security violation restrict</code>",
       "correct_answer":"A",
       "explanation":"The command <code>switchport port-security violation shutdown</code> puts the interface into the err-disable state immediately and sends an SNMP trap notification to a syslog server. The command <code>switchport port-security restrict</code> is incorrect. The command <code>switchport port-security violation protect</code> is incorrect. The command <code>switchport port-security violation restrict</code> is incorrect."
    },
    {
       "id":869,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"Which command will limit devices via port security without disabling the port and not provide logging for a security violation counter?",
       "choice_a":"<code>Switch(config-if)#switchport port-security violation shutdown</code>",
       "choice_b":"<code>Switch(config-if)#switchport port-security restrict</code>",
       "choice_c":"<code>Switch(config-if)#switchport port-security violation protect</code>",
       "choice_d":"<code>Switch(config-if)#switchport port-security violation restrict</code>",
       "correct_answer":"C",
       "explanation":"The command <code>switchport port-security violation protect</code> will set the violation mode to protect. This will drop frames over the maximum number of learned MAC addresses but will not log security violations to the counters. The command <code>switchport port-security violation shutdown</code> is incorrect. The command <code>switchport port-security restrict</code> is incorrect. The command <code>switchport port-security violation restrict</code> is incorrect."
    },
    {
       "id":870,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"Which command will allow you to see logged security violations for port security?",
       "choice_a":"<code>Switch#show violations</code>",
       "choice_b":"<code>Switch#show port-security violations</code>",
       "choice_c":"<code>Switch#show port-security</code>",
       "choice_d":"<code>Switch#showpsec violations</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show port-security</code> will show all ports that have logged port security violations. The command <code>show violations</code> is incorrect. The command <code>show port-security violations</code> is incorrect. The command <code>show psec violations</code> is incorrect."
    },
    {
       "id":871,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"You have been tasked to secure ports with port security. You need to make sure that only the computers installed can access the network. The computers are installed already. Which type of configuration for port security would require the least amount of administration?",
       "choice_a":"Static port security",
       "choice_b":"Dynamic port security",
       "choice_c":"Sticky port security",
       "choice_d":"Time limit port security",
       "correct_answer":"C",
       "explanation":"When you configure sticky port security, the first MAC address seen by the switch will become bound to the port. Any other MAC addresses will trip the access violation set. Static port security will require you to enter the MAC address of each computer paired with each port. Dynamic port security and time limit port security are not types of port security that can be implemented."
    },
    {
       "id":872,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"Refer to the following exhibit. You received a call that a port is no longer active. The port has port security configured on it. What is the problem?<img src='/question_assets/ccna/5_image11.png'></img>",
       "choice_a":"The port has been administratively shutdown.",
       "choice_b":"The port has an access violation on it.",
       "choice_c":"The port has bad wiring.",
       "choice_d":"The port on the switch is configured as a trunk.",
       "correct_answer":"B",
       "explanation":"The default configuration for port security results in an access violation of shutdown. When a portsecurity violation occurs, the port will be shut down in an err-disable status. Because the port is in an err-disabled state, the exhibit does not support the theory that a port has been administratively shutdown. The exhibit also does not support the theory that the port has bad wiring. You cannot tell from the output in the exhibit that the port is configured as a trunk or access link, but neither will place the port into an err-disabled state."
    },
    {
       "id":873,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"Which command will allow the first MAC address learned on the port to be allowed to only pass traffic on the port via port security?",
       "choice_a":"<code>SwitchA(config-if)#switchport port-security mac-address sticky</code>",
       "choice_b":"<code>SwitchA(config-if)#switchport port-security mac-address dynamic</code>",
       "choice_c":"<code>SwitchA(config-if)#switchport port-security mac-address static</code>",
       "choice_d":"<code>SwitchA(config-if)#switchport port-security mac-address learn</code>",
       "correct_answer":"A",
       "explanation":"The command <code>switchport port-security mac-address sticky</code> will configure the port to learn the first MAC address and allow only the first MAC address to pass traffic. The command <code>switchport port-security mac-address dynamic</code> is incorrect. The command <code>switchport port-security mac-address static</code> is incorrect. The command <code>switchport port-security mac-address learn</code> is incorrect."
    },
    {
       "id":874,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"Refer to the following exhibit. You receive a call that a port on the switch is not working. You determine that a port-security violation has been experienced. Once the violation has been remediated, how will you reset the port so that it functions again?<img src='/question_assets/ccna/5_image12.png'></img>",
       "choice_a":"<code>SwitchA(config-if)#no port-security</code>",
       "choice_b":"<code>SwitchA(config-if)#no shutdown</code>",
       "choice_c":"<code>SwitchA(config-if)#no switchport port-security</code>",
       "choice_d":"<code>SwitchA(config-if)#shutdown</code><br><code>SwitchA(config-if)#no shutdown</code>",
       "correct_answer":"D",
       "explanation":"One way to clear an err-disable status is to issue the <code>shutdown</code> command and then the <code>no shutdown</code> command on the port. This will reset the port so that traffic can flow again. However, if the access violation still exists, then the port will enter an err-disable status again. The command <code>no port-security</code> is incorrect and will not clear the err-disable state. The command <code>no shutdown</code> is incorrect and will not clear the err-disable state. The command <code>no switchport port-security</code> is incorrect and will not clear the err-disable state."
    },
    {
       "id":875,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"Which command will configure the port with only the MAC address you want to allow via port security?",
       "choice_a":"<code>SwitchA(config-if)#switchport port-security mac-address sticky</code>",
       "choice_b":"<code>SwitchA(config-if)#switchport port-security mac-address 0334.56f3.e4e4</code>",
       "choice_c":"<code>SwitchA(config-if)#switchport port-security mac-address static 0334.56f3.e4e4</code>",
       "choice_d":"<code>SwitchA(config-if)#switchport port-security static 0334.56f3.e4e4</code>",
       "correct_answer":"B",
       "explanation":"The command <code>switchport port-security mac-address 0334.56f3.e4e4</code> will configure the interface with a static MAC address of 0334.56f3.e4e4. The command <code>switchport port-security mac-address sticky</code> is incorrect as it will configure itself with the first MAC address learned. The command <code>switchport port-security mac-address static 0334.56f3.e4e4</code> is incorrect. The command <code>switchport port-security static 0334.56f3.e4e4</code> is incorrect."
    },
    {
       "id":876,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":4,
       "question":"Which command is used to see the output in the following exhibit?<img src='/question_assets/ccna/5_image13.png'></img>",
       "choice_a":"<code>Switch#show port-security details</code>",
       "choice_b":"<code>Switch#show mac address-table secure</code>",
       "choice_c":"<code>Switch#show port-security address</code>",
       "choice_d":"<code>Switch#show port-security</code>",
       "correct_answer":"D",
       "explanation":"The command <code>show port-security</code> will show all of the ports that are actively participating in port security. In addition, you can see the maximum number of addresses configured, current addresses, security violations, and action. The command <code>show port-security details</code> is incorrect. The command <code>show mac address-table secure</code> is incorrect. The command <code>show port-security address</code> is incorrect."
    },
    {
       "id":877,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":5,
       "question":"Which command will allow you to globally reset all ports with an err-disable state with minimal disruption?",
       "choice_a":"<code>Switch#clear err-disable</code>",
       "choice_b":"<code>Switch#clearswitchport port-security</code>",
       "choice_c":"<code>Switch#clear port-security violation</code>",
       "choice_d":"<code>Switch(config)#errdisable recovery cause psecure_violation</code>",
       "correct_answer":"D",
       "explanation":"The global config command <code>errdisable recovery cause psecure_violation</code> will reset all ports with an err-disable status. The command <code>clear err-disable</code> is incorrect. The command <code>clear switchport port-security</code> is incorrect. The command <code>clear port-security violation</code> is incorrect."
    },
    {
       "id":878,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":"",
       "question":"You need to verify the sticky MAC addresses learned on a port on the switch. Which command will allow you to verify the addresses learned?",
       "choice_a":"<code>SwitchA#show running-config</code>",
       "choice_b":"<code>SwitchA#show port-security</code>",
       "choice_c":"<code>SwitchA#show port-security details</code>",
       "choice_d":"<code>SwitchA#show port-security status</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show running-config</code> will show you the learned MAC addresses from port security. The command <code>show port-security</code> is incorrect. The command <code>show port-security details</code> is incorrect. The command <code>show port-security status</code> is incorrect."
    },
    {
       "id":879,
       "topic_id":5,
       "sub_domain":"5.8 Differentiate authentication, authorization, and accounting concepts",
       "practice_test_id":"",
       "question":"Which server will centralize authentication for all Cisco routers and switches?",
       "choice_a":"Active Directory server",
       "choice_b":"AAA server",
       "choice_c":"802.1X server",
       "choice_d":"Terminal server",
       "correct_answer":"B",
       "explanation":"The AAA server will centralize authentication for Cisco routers and switches. AAA stands for authentication, authorization, and accounting. It is pronounced \u0022triple A.\u0022 An Active Directory server can be used in conjunction with authentication, but the AAA server will facilitate the authentication. 802.1X is a protocol and not a type of server; therefore, this is incorrect. Terminal servers are servers that extend applications or the server desktop to remote users and have nothing to do with authentication of Cisco routers and switches."
    },
    {
       "id":880,
       "topic_id":5,
       "sub_domain":"5.8 Differentiate authentication, authorization, and accounting concepts",
       "practice_test_id":"",
       "question":"Which protocol and port does RADIUS authentication use?",
       "choice_a":"UDP/1845",
       "choice_b":"UDP/1645",
       "choice_c":"TCP/1645",
       "choice_d":"UDP/1911",
       "correct_answer":"B",
       "explanation":"RADIUS authentication uses the UDP protocol and port 1645 for communications between the switch or router and the AAA server. All of the other options are incorrect."
    },
    {
       "id":881,
       "topic_id":5,
       "sub_domain":"5.8 Differentiate authentication, authorization, and accounting concepts",
       "practice_test_id":1,
       "question":"Which is an authentication protocol for AAA servers to secure Telnet authentication?",
       "choice_a":"802.1X",
       "choice_b":"TACACS+",
       "choice_c":"AD",
       "choice_d":"EAP",
       "correct_answer":"B",
       "explanation":"TACACS+ (Terminal Access Controller Access Control System+) is a protocol used for communications between a switch or router and the AAA server for authenticating users.802.1X is used to secure ports on a switch or access to wireless access points. Active Directory (AD) is a Microsoft directory of computers and users that is used for authentication purposes. Extensible Authentication Protocol (EAP) is a protocol that allows for passwords, certificates, biometrics, and any other extensible method for authentication."
    },
    {
       "id":882,
       "topic_id":5,
       "sub_domain":"5.8 Differentiate authentication, authorization, and accounting concepts",
       "practice_test_id":"",
       "question":"Which command will configure the router to use a TACACS+ server and a backup of local for authentication of logins?",
       "choice_a":"<code>Router(config)#aaa authentication login default group tacacs+ local</code>",
       "choice_b":"<code>Router(config)#authentication login group tacacs+ local</code>",
       "choice_c":"<code>Router(config)#aaa-authentication login default tacacs+ local</code>",
       "choice_d":"<code>Router(config)#aaa authentication login tacacs+ local</code>",
       "correct_answer":"A",
       "explanation":"The command <code>aaa authentication log-in default group tacacs+ local</code> will configure AAA authentication for login using the default list and a group of TACACS+ servers for TACACS+ login first and a backup of local for authentication. The command <code>authentication login group tacacs+ local</code> is incorrect. The command <code>aaa-authentication login default tacacs+ local</code> is incorrect. The command <code>aaa authentication login tacacs+ local</code> is incorrect."
    },
    {
       "id":883,
       "topic_id":5,
       "sub_domain":"5.8 Differentiate authentication, authorization, and accounting concepts",
       "practice_test_id":"",
       "question":"You configured the AAA authentication for login to default local but forgot to create a local AAA user. What will happen when you log out?",
       "choice_a":"The enable secret will work.",
       "choice_b":"The console will still be available.",
       "choice_c":"The router will lock you out.",
       "choice_d":"Nothing, since a username and password have not been set.",
       "correct_answer":"C",
       "explanation":"The router will lock you out since you have not provided a local account to log in with. The password recovery procedure would need to be performed if the configuration was saved. The enable secret will be overridden by the configuration since you configured default local and it will not work. The console will also not be available because the default local was configured. Once the default local is configured, the authentication will be based upon the local AAA configuration; if no user exists, then you will be locked out of the router or switch."
    },
    {
       "id":884,
       "topic_id":5,
       "sub_domain":"5.8 Differentiate authentication, authorization, and accounting concepts",
       "practice_test_id":"",
       "question":"You were routinely looking at logs and found that a security incident occurred. Which type of incident detection is described?",
       "choice_a":"Passive",
       "choice_b":"Active",
       "choice_c":"Proactive",
       "choice_d":"Auditing",
       "correct_answer":"A",
       "explanation":"Routinely looking at a log file and discovering that a security incident occurred is an example of passive detection. Active detection would be if you were actively notified when the incident occurred. Proactive detection is where you find the security incident before it occurred. Auditing is the act of reading through a log file, not detecting an incident."
    },
    {
       "id":885,
       "topic_id":5,
       "sub_domain":"5.8 Differentiate authentication, authorization, and accounting concepts",
       "practice_test_id":"",
       "question":"A RADIUS server is an example of which type of server?",
       "choice_a":"DNS",
       "choice_b":"Email",
       "choice_c":"Proxy",
       "choice_d":"Authentication",
       "correct_answer":"D",
       "explanation":"Remote Authentication Dial-In User Service (RADIUS) servers are authentication servers. DNS servers perform name resolution for clients. Email servers deliver and receive email on the Internet. Proxy servers fetch requests on behalf of clients."
    },
    {
       "id":886,
       "topic_id":5,
       "sub_domain":"5.9 Describe wireless security protocols (WPA, WPA2, and WPA3)",
       "practice_test_id":4,
       "question":"Matilda is interested in securing her SOHO wireless network. What can should she do to be assured that only her devices can join her wireless network?",
       "choice_a":"Enable WPA2",
       "choice_b":"Enable MAC filtering",
       "choice_c":"Enable port security",
       "choice_d":"Disable SSID broadcasts",
       "correct_answer":"B",
       "explanation":"Enabling MAC filtering on the access point will allow the devices that she specifies. Enabling WPA2 encryption will not prevent unauthorized access to the SOHO network. Port Security is enabled on wired network switches to prevent unauthorized access. Disabling the SSID from broadcasting will not prevent unauthorized access."
    },
    {
       "id":887,
       "topic_id":5,
       "sub_domain":"5.9 Describe wireless security protocols (WPA, WPA2, and WPA3)",
       "practice_test_id":5,
       "question":"Which is a requirement of WPA2-Enterprise?",
       "choice_a":"Creation of a PSK",
       "choice_b":"Certificate infrastructure",
       "choice_c":"192-bit key strength",
       "choice_d":"802.11ac",
       "correct_answer":"B",
       "explanation":"A certificate infrastructure is required for WPA2-Enterprise mode. WPA2-Enterprise mode is not compatible with a pre-shared key (PSK) method of security. 192-bit key strength was introduced with WPA3-Enterprise mode. WPA2-Enterprise can be used with any of the 802.11 wireless coverage technologies since it operates independently."
    },
    {
       "id":888,
       "topic_id":5,
       "sub_domain":"5.9 Describe wireless security protocols (WPA, WPA2, and WPA3)",
       "practice_test_id":"",
       "question":"Which mechanism in WPA prevents the altering and replay of data packets?",
       "choice_a":"TKIP",
       "choice_b":"MIC",
       "choice_c":"AES",
       "choice_d":"CRC",
       "correct_answer":"B",
       "explanation":"Message Integrity Check (MIC), also known as Michael, is responsible for the protection of messages by including an integrity check that the other side can verify. Temporal Key Integrity Protocol (TKIP) was used as an encryption protocol for WPA as a quick replacement of Wired Equivalent Privacy (WEP). Advanced Encryption Standard (AES) is an encryption protocol first introduced with WPA2. A cyclic redundancy check (CRC) is a simple calculation to assure that data is not damaged in transit."
    },
    {
       "id":889,
       "topic_id":5,
       "sub_domain":"5.9 Describe wireless security protocols (WPA, WPA2, and WPA3)",
       "practice_test_id":"",
       "question":"Which security mode does WPA3-Enterprise use that offers the highest level of security?",
       "choice_a":"64-bit",
       "choice_b":"128-bit",
       "choice_c":"192-bit",
       "choice_d":"256-bit",
       "correct_answer":"C",
       "explanation":"WPA3-Enterprise offers a 192-bit security mode that uses 192-bit minimum strength security protocols. Although WPA3-Enterprise can use the authentication encryption of 256-bit Galois/Counter Mode Protocol (GCMP-256), it employs 192-bit AES for the encryption and transmission of data, which is where it gets its name from. All of the other options are incorrect."
    },
    {
       "id":890,
       "topic_id":5,
       "sub_domain":"5.9 Describe wireless security protocols (WPA, WPA2, and WPA3)",
       "practice_test_id":1,
       "question":"Which statement is correct about WPA?",
       "choice_a":"WPA was released at the same time as WEP.",
       "choice_b":"WPA was released as a fix for poor coverage.",
       "choice_c":"WPA was released as a fix for poor encryption.",
       "choice_d":"The Wi-Fi Alliance wanted to rebrand WEP with WPA.",
       "correct_answer":"C",
       "explanation":"After the weaknesses in WEP encryption were discovered, the Wi-Fi Alliance rushed the release of the WPA security protocol. The WPA security protocol incorporated the 802.11i standard of TKIP, which allowed for better integrity of 802.11 transmissions. The WPA security protocol was released after the WEP security protocol. The WPA security protocol did not address any problems related to coverage. It was not a rebranding of the WEP security protocol; it was intended to be a replacement."
    },
    {
       "id":891,
       "topic_id":5,
       "sub_domain":"5.9 Describe wireless security protocols (WPA, WPA2, and WPA3)",
       "practice_test_id":4,
       "question":"Which feature does 802.11i add to the WPA security protocol?",
       "choice_a":"The use of certificates",
       "choice_b":"Frame-level encryption",
       "choice_c":"Pre-shared keys",
       "choice_d":"CRC checking",
       "correct_answer":"B",
       "explanation":"The 802.11i standard added the feature of per-frame encryption. The use of certificates and pre-shared keys are features of WPA and not the 802.11i standard. CRC checking is part of the 802.11 standard, and therefore, it was not added with 802.11i or the WPA security protocol."
    },
    {
       "id":892,
       "topic_id":5,
       "sub_domain":"5.9 Describe wireless security protocols (WPA, WPA2, and WPA3)",
       "practice_test_id":5,
       "question":"Which mode of encryption does 802.11i (WPA2) introduce?",
       "choice_a":"RC4",
       "choice_b":"MD5",
       "choice_c":"AES-CCMP",
       "choice_d":"SHA1",
       "correct_answer":"C",
       "explanation":"The 802.11i (WPA2) specification introduced a specific mode of Advanced Encryption Standard (AES) encryption called Counter Mode with Cipher Block Chaining Message Authentication Code Protocol (CCMP). The Rivest Cipher 4 (RC4) algorithm is used by Wired Equivalent Privacy (WEP) and Wi-Fi Protected Access (WPA) as an encryption protocol. Message-Digest algorithm 5 (MD5) and Secure Hash Algorithm 1 (SHA1) are popular hashing algorithms but not related to wireless communications."
    },
    {
       "id":893,
       "topic_id":5,
       "sub_domain":"5.9 Describe wireless security protocols (WPA, WPA2, and WPA3)",
       "practice_test_id":"",
       "question":"Which feature was introduced with WPA3 to enhance security?",
       "choice_a":"Certificate support",
       "choice_b":"Per-frame encryption",
       "choice_c":"SAE authentication",
       "choice_d":"TKIP",
       "correct_answer":"C",
       "explanation":"The WPA3 protocol introduced the feature of Simultaneous Authentication of Equals (SAE) authentication, also known as the Dragonfly handshake. Certificate support, per-frame encryption, and Temporal Key Integrity Protocol (TKIP) were all features introduced with the original WPA standard."
    },
    {
       "id":894,
       "topic_id":5,
       "sub_domain":"5.10 Configure WLAN using WPA2 PSK using the GUI",
       "practice_test_id":"",
       "question":"When configuring WPA2-Enterprise mode on a wireless LAN controller, what must be configured?",
       "choice_a":"NTP server",
       "choice_b":"RADIUS server",
       "choice_c":"PSK",
       "choice_d":"Captive portal",
       "correct_answer":"B",
       "explanation":"When configuring WAP2-Enterprise mode on a wireless LAN controller, you must configure a RADIUS server for authentication of the users or computers joining wireless. Setting a Network Time Protocol server is optional when configuring WPA2-Enterprise. WPA-Personal uses a pre-shared key (PSK), whereas WPA-Enterprise uses a certificate pair for authentication. Captive portals are not required for WPA2-Enterprise because the user or computer should be authenticated by the certificate pair."
    },
    {
       "id":895,
       "topic_id":5,
       "sub_domain":"5.10 Configure WLAN using WPA2 PSK using the GUI",
       "practice_test_id":4,
       "question":"When configuring WPA2, you want to ensure that it does not fall back to the older WPA specification.What parameter should you disable?",
       "choice_a":"802.1X",
       "choice_b":"AES",
       "choice_c":"TKIP",
       "choice_d":"MAC filtering",
       "correct_answer":"C",
       "explanation":"You should disable the Temporal Key Integrity Protocol (TKIP) when configuring WPA2. This will ensure that the WAP and client do not fall back to the older WPA protocol. 802.1X will operate independently from the WPA2 and WPA fallback mechanism. Advanced Encryption Standard (AES) is an encryption protocol that is used in conjunction with WPA2; therefore, it should not be disabled. MAC filtering is not related to WPA or WPA2 and works independently as a security mechanism."
    },
    {
       "id":896,
       "topic_id":5,
       "sub_domain":"5.10 Configure WLAN using WPA2 PSK using the GUI",
       "practice_test_id":5,
       "question":"What is the mechanism that allows for authentication using a symmetrical key with WPA2?",
       "choice_a":"PSK",
       "choice_b":"AES",
       "choice_c":"Certificates",
       "choice_d":"TKIP",
       "correct_answer":"A",
       "explanation":"A pre-shared key (PSK) is the mechanism used for configuring authentication with WPA2 using a symmetrical key. Advanced Encryption Standard (AES) is an encryption protocol that is used in conjunction with WPA2. AES is not used for authentication of hosts. Certificates are used with WPA2-Enterprise; they are asymmetrical keys used for authentication. The Temporal Key Integrity Protocol (TKIP) is used alongside the RC4 protocol to provide encryption for WPA; it is not used for authentication."
    },
    {
       "id":897,
       "topic_id":5,
       "sub_domain":"5.10 Configure WLAN using WPA2 PSK using the GUI",
       "practice_test_id":"",
       "question":"After configuring a WLAN, your users complain that they do not see the SSID. What could be wrong?",
       "choice_a":"SSID beaconing is enabled.",
       "choice_b":"Multicast support is disabled.",
       "choice_c":"Radio Policy is configured to all.",
       "choice_d":"Status is disabled.",
       "correct_answer":"D",
       "explanation":"When the status of a configured WLAN is set to disable or unchecked in the GUI, the SSID will be broadcast and active for clients. SSID beaconing is enabled by default; if it were disabled, the clients would not see the SSID. Multicast support is used for multimedia applications and would not affect the SSID from being seen by clients. The Radio Policy could possibly restrict clients from seeing the SSID depending on what it is set to. However, when it is set to all, there are no restrictions."
    },
    {
       "id":898,
       "topic_id":5,
       "sub_domain":"5.10 Configure WLAN using WPA2 PSK using the GUI",
       "practice_test_id":1,
       "question":"How many pre-shared keys can be configured for a specific WPA2 WLAN?",
       "choice_a":"One PSK (one hex or one ASCII)",
       "choice_b":"Two PSKs (one hex and one ASCII)",
       "choice_c":"Four PSKs (two hex and two ASCII)",
       "choice_d":"Unlimited number of PSKs",
       "correct_answer":"A",
       "explanation":"A single pre-shared key is configured for a WPA2 WLAN. The PSK can be either one hex or one ASCII key, but it cannot be both. If you need multiple keys, then WPA2-Enterprise should be used. Keep in mind that a PSK is symmetrical encryption, whereas WPA2-Enterprise uses certificates and asymmetrical encryption. All of the other options are incorrect."
    },
    {
       "id":899,
       "topic_id":5,
       "sub_domain":"5.10 Configure WLAN using WPA2 PSK using the GUI",
       "practice_test_id":4,
       "question":"You are configuring a WPA2 WLAN.Which security configuration should you use for the highest level of security?",
       "choice_a":"WPA-AES",
       "choice_b":"WPA2-TKIP",
       "choice_c":"WPA2-RC4",
       "choice_d":"WPA2-AES",
       "correct_answer":"D",
       "explanation":"The Wi-Fi Protected Access 2 (WPA2) protocol can be configured with Advanced Encryption Standard (AES) encryption to provide the highest level of security. Wi-Fi Protected Access (WPA) cannot be configured with AES encryption; therefore, this is a wrong answer. WPA2 cannot be configured with Temporal Key Integrity Protocol (TKIP); only WPA uses the RC4 encryption algorithm and TKIP."
    },
    {
       "id":900,
       "topic_id":5,
       "sub_domain":"5.10 Configure WLAN using WPA2 PSK using the GUI",
       "practice_test_id":5,
       "question":"You are setting up a wireless network for a client. Their requirements are to minimize the infrastructure and support the highest security. Which wireless encryption standard should be configured to satisfy the requirements?",
       "choice_a":"WPA-Enterprise",
       "choice_b":"WPA2-Personal",
       "choice_c":"WPA3-Enterprise",
       "choice_d":"WPA-Personal",
       "correct_answer":"B",
       "explanation":"In order to satisfy the requirements of the client, WPA2-Personal should be configured for the wireless network. WPA2-Personal will allow for 128-bit AES-CCMP encryption and work with a pre-shared key to minimize infrastructure. WPA-Enterprise and WPA3-Enterprise require certificate services and an AAA server. WPA-Personal is weaker encryption than WPA2-Personal."
    },
    {
       "id":901,
       "topic_id":5,
       "sub_domain":"5.10 Configure WLAN using WPA2 PSK using the GUI",
       "practice_test_id":"",
       "question":"Which protocol will restrict you from achieving high throughput rates?",
       "choice_a":"AES",
       "choice_b":"TKIP",
       "choice_c":"CCMP",
       "choice_d":"PSK",
       "correct_answer":"B",
       "explanation":"When a WLAN is configured with WPA-TKIP, it will not be able to achieve over 54 Mbps. TheCounter Mode with Cipher Block Chaining Message Authentication Code Protocol (CCMP) is based on of the Advanced Encryption Standard (AES) encryption protocol and will not hinder throughput. Configuring a pre-shared key (PSK) will also not hinder throughput."
    },
    {
       "id":902,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":"",
       "question":"Which is a reason to automate a process for the configuration of several routers?",
       "choice_a":"To increase the possibility for misconfiguration",
       "choice_b":"To createan outcome that can be reproduced",
       "choice_c":"To decrease problems from the new configuration",
       "choice_d":"To allow you to do less work",
       "correct_answer":"B",
       "explanation":"A reason to automate a process for the configuration of several routers is to create a positive outcome that can be reproduced. Automating processes for configuration decreases the possibility for misconfiguration. Automation of configuration does not decrease problems from the new configuration; if anything, it automates the increase of possible problems. Although it might seem like automating a process for configuration allows you to do less work, it is not always the case."
    },
    {
       "id":903,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":"",
       "question":"You need to configure a new static route on the existing 20 routers. Which is the best way to do this?",
       "choice_a":"Copy and paste scripts built in Notepad++ into each router.",
       "choice_b":"Copy and paste scripts built in Excel into each router.",
       "choice_c":"Create a Python script to configure each router.",
       "choice_d":"Work with a partner so that both of you can double-check each other's work and cut the time in half.",
       "correct_answer":"C",
       "explanation":"Creating a Python script to configure each router is the best way to complete this task. You can automate the process and save time since the entry of the route is a repetitious process. Copying and pasting scripts from Notepad++ or Excel into each router will require you to log into each router. Doing this increases the chances of missing a router. You could also work with a partner and start at different ends of the list, but again, this approach introduces the possibility of errors and ties up two technicians."
    },
    {
       "id":904,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":"",
       "question":"Which is the number one motivating factor to use network automation?",
       "choice_a":"Reduce the number of changes to be made",
       "choice_b":"Reduce the complications that arise from changes",
       "choice_c":"Reduce the human error factor",
       "choice_d":"Reduce the planning time for the changes",
       "correct_answer":"C",
       "explanation":"The number one motivating factor to use network automation is to reduce the human error factor when creating bulk changes. Network automation will not reduce the number of changes to be made. As an example, an updated ACL on all the routers will still need to be updated on all the routers.Network automation also does not reduce the complications that arise from changes; it actually increases them. Network automation also increases the planning time for changes. A network automation script can change everything rapidly; if it's wrong, it can even lead to an outage of services."
    },
    {
       "id":905,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":"",
       "question":"What is the term that is used to describe the framework responsible for assisting in network automation?",
       "choice_a":"NetOps",
       "choice_b":"DevOps",
       "choice_c":"SysOps",
       "choice_d":"SecOps",
       "correct_answer":"B",
       "explanation":"The term <italic>DevOps</italic> is used to describe the framework responsible for assisting in network automation. It is usually written in conjunction with network operations, but it is considered a development function using the DevOps framework. The term <italic>NetOps</italic> refers to the network operation team's responsibility. The term <italic>SysOps</italic> is used to describe the control of network systems such as DNS, Active Directory (AD), and DHCP, just to name a few. The term <italic>SecOps</italic> refers to the security operation as it pertains to the network."
    },
    {
       "id":906,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":"",
       "question":"Which management methodology is commonly used by developers for network automation?",
       "choice_a":"Lean and Agile",
       "choice_b":"Waterfall",
       "choice_c":"Kanban",
       "choice_d":"Scrum",
       "correct_answer":"A",
       "explanation":"The management methodology that is commonly used by developers for network automation is Lean and Agile. Agile focuses on an adaptive approach for simultaneous workflows, such as the configuration of a default route on several routers. The Waterfall management methodology is used for projects in a linear process that does not allow for going back to a prior phase. The Kanban management methodology is used to improve existing processes. Scrum is primarily focused on getting more work done quicker."
    },
    {
       "id":907,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":"",
       "question":"After you release a network automation script to production, which step should be completed?",
       "choice_a":"Testing",
       "choice_b":"Building",
       "choice_c":"Planning",
       "choice_d":"Monitoring",
       "correct_answer":"D",
       "explanation":"After a network automation script is released to production, the very next process should be to monitor its effects on the network. This step should already be considered with pre-built metrics so that you can positively conclude its intended function. The testing step should have been done prior to the deployment phase. The building phase is done when you are ready to test a completed configuration change. The planning phase is the first phase before anything is put into motion; it is where you have determined the metrics for the project, which determines if the changes are successful."
    },
    {
       "id":908,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":"",
       "question":"Which element of YAML defines a key-value pair?",
       "choice_a":"Definition",
       "choice_b":"Mapping",
       "choice_c":"Lists",
       "choice_d":"Keys",
       "correct_answer":"B",
       "explanation":"The YAML Ain't Markup Language (YAML) markup language uses mapping to define keys and values as pairs. <italic>Definition</italic> is not a term used with YAML; therefore,option A is an invalid answer. Lists are keys with multiple values in the form of a list. Keys are categories that contain a value in the key-value pair."
    },
    {
       "id":909,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":"",
       "question":"How can you identify that a file is a YAML file?",
       "choice_a":"The file begins with three dashes.",
       "choice_b":"The file begins with a hashbang preprocessor.",
       "choice_c":"The contents are contained between curly brackets.",
       "choice_d":"The contents are contained between square brackets.",
       "correct_answer":"A",
       "explanation":"A YAML file will always begin with three dashes. This is how you know you are working with a YAML file structure. Files that start with a hashbang preprocessor are normally scripts, and the hashbang describes to the operating system which command interpreter to use.A file that has its content contained between curly braces or square braces is normally a JSON file."
    },
    {
       "id":910,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":1,
       "question":"Which structured data format closely resembles HTML?",
       "choice_a":"YAML",
       "choice_b":"JSON",
       "choice_c":"CSV",
       "choice_d":"XML",
       "correct_answer":"D",
       "explanation":"Extensible Markup Language (XML) was adopted from HyperText Markup Language (HTML) as a storage method for systems to interchange data. YAML Ain't Markup Language (YAML) is a whitespace structured file that is also used to store data for the interchange of information. JavaScript Object Notation (JSON) is another structured storage method for data and was originally created for use with JavaScript and gained popularity with other languages. Comma-separated values (CSV) is a flat data storage method that is popular when lists of information must be passed from system to system."
    },
    {
       "id":911,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":"",
       "question":"Which data format is structured by whitespace?",
       "choice_a":"YAML",
       "choice_b":"JSON",
       "choice_c":"XML",
       "choice_d":"CSV",
       "correct_answer":"A",
       "explanation":"YAML Ain't Markup Language (YAML) is a whitespace structured file that is also used to store data for the interchange of information. JavaScript Object Notation (JSON) is structured with curly and square braces. Extensible Markup Language (XML) was adopted from HyperText Markup Language (HTML),which uses opening and closing tags. Comma-separated values (CSV) is a flat data storage method that uses commas to delimit the fields of information held on each line."
    },
    {
       "id":912,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":4,
       "question":"You are creating a network automation script to configure a network device. What should you research to identify what can be controlled with your script?",
       "choice_a":"User interface layout",
       "choice_b":"API reference",
       "choice_c":"Source code of the device",
       "choice_d":"Data storage of the device",
       "correct_answer":"B",
       "explanation":"The application programming interface (API) on the device that is to be controlled through automation should be researched. The API is a method for controlling devices with programmability control; this includes the import and export of information. The user interface layout is more accustomed to users and manual configuration, since programs do not use the user interface. The source code and data storage methods for the device are not normally attainable and do not really get you what you need to control the device."
    },
    {
       "id":913,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":5,
       "question":"You are developing a network automation script that retrieves information. Which interface can you implement that will act similar to an API?",
       "choice_a":"CLI",
       "choice_b":"SNMP",
       "choice_c":"Syslog",
       "choice_d":"SSH",
       "correct_answer":"B",
       "explanation":"The Simple Network Management Protocol (SNMP) was originally created to allow retrieval of information from network devices and can be programmatically controlled, similar to an application programming interface (API). The command-line interface (CLI) is what the user will interface with; therefore, it is considered a type of user interface (UI). Syslog is a method of sending logging information to remote syslog servers. Secure Shell (SSH) is a method for connectivity and not used as an API."
    },
    {
       "id":914,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":"",
       "question":"Which protocol was created as a replacement for SNMP?",
       "choice_a":"NETCONF",
       "choice_b":"Syslog",
       "choice_c":"REST",
       "choice_d":"SSH",
       "correct_answer":"A",
       "explanation":"The NETCONF protocol was created as a replacement for the dated Simple Network Management Protocol (SNMP). Syslog is a system of formatted messages for log file storage, either local or remote via the syslog protocol. Representational state transfer (REST) is a set of constraints used for sending data to and from services. Secure Shell (SSH) is a method of connecting to network devices through a console-based terminal emulator."
    },
    {
       "id":915,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":"",
       "question":"Which protocol uses the YANG data model?",
       "choice_a":"NETCONF",
       "choice_b":"REST",
       "choice_c":"SNMP",
       "choice_d":"YAML",
       "correct_answer":"A",
       "explanation":"The NETCONF protocol was created to interface with network devices over the SSH protocol. Data transferred to and from network devices with the NETCONF protocol must adhere to the Yet Another Next Generation (YANG) data model. Representational state transfer (REST) is a set of constraints used for sending data to and from services. Simple Network Management Protocol (SNMP) is a network management protocol used to retrieve and send information to remote network devices. YAML Ain't Markup Language (YAML) is a markup language used to store and transfer data between applications."
    },
    {
       "id":916,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":"",
       "question":"Which protocol uses an HTTPS transport to configure and retrieve details programmatically?",
       "choice_a":"NETCONF",
       "choice_b":"RESTCONF",
       "choice_c":"SNMP",
       "choice_d":"Syslog",
       "correct_answer":"B",
       "explanation":"The RESTCONF protocol is used with a Hypertext Transfer Protocol Secure (HTTPS) transport protocol. RESTCONF is the successor of NETCONF, which uses SSH for device access. RESTCONF now uses a common transport of HTTPS to send and retrieve information from network devices. Simple Network Management Protocol (SNMP) defines its own standard of information set and retrieval and does not use HTTPS. Syslog is a system of formatted messages for log file storage either local or remote via the syslog protocol."
    },
    {
       "id":917,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":"",
       "question":"Which is a benefit of controller-based networking?",
       "choice_a":"Increased security",
       "choice_b":"Decreased problems",
       "choice_c":"Increased throughput",
       "choice_d":"Increased complexity",
       "correct_answer":"A",
       "explanation":"A benefit of a controller-based networking is increased security. When ACLs and filters are applied, they are applied informally to all nodes that are controlled by the controller. There is not a reduction of problems that can be encountered in a network with the introduction of controller-based networking. Throughput will not increase magically because of the introduction of controller-based networking. Complexity should be reduced with the introduction of controller-based networking because all of the configuration is centralized."
    },
    {
       "id":918,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":"",
       "question":"Which statement is correct about controller-based networking?",
       "choice_a":"Controller-based networking is always in the form of hardware appliances.",
       "choice_b":"Controller-based networking has a logically centralized control plane.",
       "choice_c":"Controller-based networking has a logically centralized data plane.",
       "choice_d":"Controller-based networking uses ASICs to centrally switch frames.",
       "correct_answer":"B",
       "explanation":"Controller-based networking has a logically centralized control plane to centrally control the data plane. The data plane is not centralized because switching and routing of data must be done very fast, usually with the use of application-specific integrated circuits (ASICs). Controller-based networking comes in many different forms, ranging from applications to hardware appliances. Both controller-based network switching and autonomous network switching use ASICs, but controller-based network switches do not centrally switch frames."
    },
    {
       "id":919,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":4,
       "question":"Which term is used with controller-based networking that combines multiple sites to act as one single network?",
       "choice_a":"SDN",
       "choice_b":"SD-WAN",
       "choice_c":"SD-LAN",
       "choice_d":"VPN",
       "correct_answer":"B",
       "explanation":"<italic>Software-Defined Wide Area Network (SD-WAN)</italic> is the term commonly used to describe the combination of multiple sites to act as one single network. Use cases of SD-WAN are disaster recovery and remote office and branch office planning. <italic>software-defined networking (SDN)</italic> is the term used to describe local area network (LAN) controller-based networking. <italic>SD-LAN</italic> is not a term commonly used, and therefore,option C is an invalid answer. A virtual private network (VPN) will allow multiple sites to act as one single network, but it is not centrally controlled with controller-based networking."
    },
    {
       "id":920,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":5,
       "question":"Which is a potential disadvantage with controller-based networking?",
       "choice_a":"Scalability",
       "choice_b":"Security",
       "choice_c":"Maturity",
       "choice_d":"Centralized provisioning",
       "correct_answer":"C",
       "explanation":"Controller-based networking, also known as software-defined networking (SDN), is roughly 15 years old. Many see this maturity as a disadvantage when comparing it to traditional networking equipment that is much older in theory. Scalability, security, and centralized provisioning are advantages to using controller-based networking and far outweigh the disadvantage in the youth of SDN."
    },
    {
       "id":921,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":"",
       "question":"Which elements can be controlled with an SDN controller for an SDN-enabled switch?",
       "choice_a":"CPU utilization",
       "choice_b":"Memory utilization",
       "choice_c":"QoS",
       "choice_d":"Forwarding of traffic",
       "correct_answer":"C",
       "explanation":"Quality of service (QoS) can be directly controlled with an SDN controller. The SDN controller will push programming to the SDN-enabled switch so that the switch can control the flow of traffic.CPU and memory utilization can be reported upon, and arguably programming can be pushed out to alleviate central processing unit (CPU) and memory utilization, but CPU and memory utilization is not directly controlled with an SDN controller. The forwarding of traffic is a responsibility of the data plane, which can be changed by the control plane. However, the SDN controller does not forward packets explicitly; that is the function of the switch."
    },
    {
       "id":922,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":"",
       "question":"Which statement is correct about SDN switches?",
       "choice_a":"All data is centrally switched at the SDN controller.",
       "choice_b":"All SDN switches are stateless with respect to configuration.",
       "choice_c":"All SDN switches are stateful with respect to configuration.",
       "choice_d":"All data flowing through the switch is stateless.",
       "correct_answer":"B",
       "explanation":"All software-defined network (SDN) switches are stateless with respect to their configuration. The configuration is applied from the central controller, and therefore, any configuration contained on the switch does not matter if it is lost during a reboot. Data is not centrally switched at the SDN controller; this would make data transfer too slow and overburden the SDN controller. The data flowing through the switch is not consequential to the SDN controller; some data flows can be stateless, such as UDP, and some can be stateful, such as TCP."
    },
    {
       "id":923,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":"",
       "question":"Which technology allows for the central remote monitoring of network switches and routers?",
       "choice_a":"SNMP",
       "choice_b":"Syslog",
       "choice_c":"SDN",
       "choice_d":"CDP",
       "correct_answer":"A",
       "explanation":"The Simple Network Management Protocol (SNMP) allows for the central monitoring of switches and routers by using traps and polling of network metrics. Syslog is a method of collecting logs for passive analysis after an event has been brought to your attention. Software-defined networking (SDN) allows for the centralized control of switches and routers. The Cisco Discovery Protocol (CDP) is used to discover Cisco devices on the immediate network."
    },
    {
       "id":924,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":"",
       "question":"What is the SNMP component that aggregates all SNMP messages and polled metrics?",
       "choice_a":"Trap",
       "choice_b":"SNMP agent",
       "choice_c":"Syslog server",
       "choice_d":"NMS",
       "correct_answer":"D",
       "explanation":"The Simple Network Management Protocol (SNMP) utilizes a component called the network management station (NMS) to collect all messages and poll metrics from all managed devices. An SNMP trap is a message generated from an SNMP agent installed on a host. An SNMP agent is a piece of software that monitors the operating system and hardware and either reports to the NMS or is polled by the NMS. A syslog server is a centralized server that collects logs for passive analysis of problems."
    },
    {
       "id":925,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":"",
       "question":"Which method for configuration is used with Cisco Prime Infrastructure?",
       "choice_a":"SNMP",
       "choice_b":"CAPWAP",
       "choice_c":"LWAPP",
       "choice_d":"RESTCONF",
       "correct_answer":"A",
       "explanation":"The Simple Network Management Protocol (SNMP) along with Telnet and Secure Shell (SSH) are used to configure network devices with Cisco Prime. Control And Provisioning of Wireless Access Points (CAPWAP) and Lightweight Access Point Protocol (LWAPP) are used with wireless LAN controllers for the configuration of wireless access points. RESTCONF is used with Cisco DNA for network device configuration."
    },
    {
       "id":926,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":1,
       "question":"Which type of architecture is used with controller-based networks?",
       "choice_a":"Three tier",
       "choice_b":"Spine/Leaf",
       "choice_c":"Collapsed core",
       "choice_d":"SAN fabric",
       "correct_answer":"B",
       "explanation":"The Spine/Leaf architecture model has been adopted in controller-based networks. The Leaf switch acts as the access and distribution, and the Spine acts as the core or backbone for the network. The three-tier network model and the collapsed core network model are used with controller-based networking. However, the concepts of the Cisco three-tier model are still applicable, such as the access, distribution, and core concepts as described above. A storage area network (SAN) fabric is not used in a network or controller-based network as it is applicable only to storage area networks."
    },
    {
       "id":927,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":"",
       "question":"Which is a correct statement about Spine/Leaf architecture?",
       "choice_a":"The Leaf switches connect to other Leaf switches.",
       "choice_b":"There is only one Spine switch per network.",
       "choice_c":"Spine switches provide access to hosts.",
       "choice_d":"The Leaf switches never connect to other Leaf switches, only Spine switches.",
       "correct_answer":"D",
       "explanation":"Leaf switches never connect to other Leaf switches; they only connect to Spine switches. There can be many Spine switches per network; they are considered the backbone of the network. Although nothing stops you from connecting a host to a Spine switch, Spine switches should only provide core/backbone services."
    },
    {
       "id":928,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":4,
       "question":"What is the flow of traffic in a Spine/Leaf network?",
       "choice_a":"Leaf to Spine to Leaf",
       "choice_b":"Leaf to Leaf to Spine",
       "choice_c":"Spine to Leaf to Spine",
       "choice_d":"Leaf to Leaf",
       "correct_answer":"A",
       "explanation":"Traffic flow in a Spine/Leaf network flows from the host connected to the Leaf to the Spine, eventually to the destination Leaf and the awaiting host. Leaf switches are connected only to the Spine; therefore, traffic cannot flow from the host to a Leaf to another Leaf directly. Hosts should not be connected to Spine switches, so traffic will not flow from the host to the Spine to a Leaf and then a Spine switch."
    },
    {
       "id":929,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":5,
       "question":"Which current Cisco SDN solution is data center focused?",
       "choice_a":"Cisco APIC-EM",
       "choice_b":"OpenDaylight",
       "choice_c":"Cisco SD-WAN",
       "choice_d":"Cisco ACI",
       "correct_answer":"D",
       "explanation":"The Cisco Application Centric Infrastructure (ACI) software-defined networking (SDN) solution is data center focused to deliver applications to end users. The Cisco Application Policy Infrastructure Controller - Enterprise Module (APIC-EM) is a legacy SDN solution that is not part of Cisco Digital Network Architecture (DNA). OpenDaylight (ODL) is an open platform used for SDN solutions; it is not provided or maintained by Cisco. The Cisco Software Defined - Wide Area Network (SD-WAN) is a scalable SDN solution for networks that operate over several data centers."
    },
    {
       "id":930,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":"",
       "question":"Your company has an application they need remote office/branch office employees to directly access. Which Cisco SDN solution should you implement?",
       "choice_a":"Cisco APIC-EM",
       "choice_b":"Cisco SD-WAN",
       "choice_c":"Cisco Prime Infrastructure",
       "choice_d":"OpenDaylight",
       "correct_answer":"B",
       "explanation":"Cisco Software Defined - Wide Area Network (SD-WAN) is a solution that will allow remote office/branch office (ROBOs) personnel to access cloud-based applications directly. The Cisco Application Policy Infrastructure Controller - Enterprise Module (APIC-EM) is a legacy SDN solution that is not part of Cisco Digital Network Architecture (DNA). Cisco Prime Infrastructure is a legacy management tool for deployment of switches, routers, and wireless. OpenDaylight (ODL) is an open platform used for SDN solutions; it is not provided or maintained by Cisco."
    },
    {
       "id":931,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":"",
       "question":"What is the name of the networking model that incorporates a distribution layer?",
       "choice_a":"Spine/Leaf",
       "choice_b":"Campus",
       "choice_c":"CLOS",
       "choice_d":"SDN",
       "correct_answer":"B",
       "explanation":"The campus networking model is a traditional networking model that is deployed as either a three-tier model with a core, distribution, and access layer or a collapsed core model. In the collapsed core model, the core and distribution layer are the same functional equipment. The Spine/Leaf, also known as the CLOS model, is commonly found in software-defined networking (SDN)."
    },
    {
       "id":932,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":"",
       "question":"Which statement is correct about the  SDN controller?",
       "choice_a":"The SDN controller configures the management plane of network devices.",
       "choice_b":"The SDN controller monitors data plane traffic.",
       "choice_c":"The SDN controller replaces the control plane of the SDN.",
       "choice_d":"The SDN controller complements the control plane of the SDN device.",
       "correct_answer":"C",
       "explanation":"The software-defined network (SDN) controller replaces the control plane on SDN devices. The SDN devices in the network do not contain a control plane locally and instead are controlled by the SDN controller. The SDN controller does not configure the management plane of the network devices; it replaces the management plane of the network devices. The SDN controller does not monitor the data plane of traffic; it only controls the traffic. The SDN controller does not complement the control plane of the SDN device; it replaces the control plane of the SDN device."
    },
    {
       "id":933,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":"",
       "question":"Which platform is Cisco's software-defined network controller offering for enterprise connectivity?",
       "choice_a":"APIC-EM",
       "choice_b":"OpenSDN",
       "choice_c":"OpenStack",
       "choice_d":"OpenDaylight",
       "correct_answer":"A",
       "explanation":"Application Policy Infrastructure Controller -Enterprise Module (APIC-EM) is a Cisco SDN controller. This package is freely downloadable from the Cisco DevNet website as of the writing of this book. It comes with several built-in apps, such as a plug and play module and a path trace module. Many other apps can be built on top of the APIC to extend functionality of the controller. However, the product has been largely replaced with Cisco DNA and is now licensed. Open SDN is an open-source SDN controller platform that utilized the open-source Open Daylight (ODL) protocol. OpenStack is another open-source SDN controller aimed at data centers."
    },
    {
       "id":934,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":4,
       "question":"Which network plane is used for Spanning Tree Protocol (STP)?",
       "choice_a":"Data plane",
       "choice_b":"Control plane",
       "choice_c":"Management plane",
       "choice_d":"Switch plane",
       "correct_answer":"B",
       "explanation":"The control plane refers to any mechanism that controls the data plane. Spanning Tree Protocol (STP) is used to control the data plane by removing redundant links. The data plane is responsible for switching and routing data. Any data that is destined for endpoints is switched or routed on the data plane. The management plane is any mechanism that helps in the management of a router or switch. <italic>Switch plane</italic> is not a term normally used to describe data types; therefore,option D is an invalid answer."
    },
    {
       "id":935,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":5,
       "question":"Which network plane is used by syslog for delivering messages from the router or switch?",
       "choice_a":"Data plane",
       "choice_b":"Control plane",
       "choice_c":"Management plane",
       "choice_d":"Switch plane",
       "correct_answer":"C",
       "explanation":"The management plane is any mechanism that helps in the management of a router or switch. Some of the common mechanisms are SSH and Telnet. However, any mechanism that the router uses for management is considered part of the management plane. The control plane refers to any mechanism that controls the data plane. The data plane is responsible for switching and routing data. Any data that is destined for endpoints is switched or routed on the data plane. <italic>Switch plane</italic> is not a term normally used to describe data types; therefore,option D is an invalid answer."
    },
    {
       "id":936,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":"",
       "question":"When a network packet is routed in a router, which network plane is facilitating the traffic?",
       "choice_a":"Data plane",
       "choice_b":"Control plane",
       "choice_c":"Management plane",
       "choice_d":"Switch plane",
       "correct_answer":"A",
       "explanation":"The data plane is responsible for switching and routing data. Any data that is destined for endpoints is switched or routed on the data plane. For example, when one computer pings another, the ping is switched and routed on the data plane. The control plane refers to any mechanism that controls the data plane. The management plane is any mechanism that helps in the management of a router or switch. <italic>Switch plane</italic> is not a term normally used to describe data types; therefore,option C is an invalid answer."
    },
    {
       "id":937,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":1,
       "question":"On which network plane would a routing protocol perform?",
       "choice_a":"Data plane",
       "choice_b":"Control plane",
       "choice_c":"Management plane",
       "choice_d":"Routing plane",
       "correct_answer":"B",
       "explanation":"Routing protocols such as OSPF and EIGRP would perform their function on the control plane since they are controlling the routing of the data plane. The data plane is responsible for switching and routing data. Any data that is destined for endpoints is switched or routed on the data plane. For example, when one computer pings another, the ping is switched and routed on the data plane. The management plane is any mechanism that helps in the management of a router or switch. <italic>Routing plane</italic> is not a term normally used to describe data types; therefore,option D is an invalid answer."
    },
    {
       "id":938,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":"",
       "question":"On which SDN plane does CDP function?",
       "choice_a":"Data plane",
       "choice_b":"Control plane",
       "choice_c":"Network plane",
       "choice_d":"Management plane",
       "correct_answer":"D",
       "explanation":"The Cisco Discovery Protocol functions on the management plane of the SDN model. It helps with management of the routers and switches and does not directly impact the data plane. The data plane is responsible for switching and routing data. Any data that is destined for endpoints is switched or routed on the data plane. <italic>Network plane</italic> is not a term normally used to describe data types; therefore,option C is an invalid answer. The management plane is any mechanism that helps in the management of a router or switch."
    },
    {
       "id":939,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":"",
       "question":"Which is used for communication directly to the SDN devices in the network?",
       "choice_a":"The northbound interface (NBI)",
       "choice_b":"The southbound interface (SBI)",
       "choice_c":"The core of the controller",
       "choice_d":"Applications hosted on the controller",
       "correct_answer":"B",
       "explanation":"The southbound interface (SBI) directly communicates with the SDN devices. This control is done via several different types of SBI protocols, such as OpenFlow, OpFlex, and CLI (Telnet/SSH). The northbound interface (NBI) is responsible for allowing communication between applications and the core of the controller. The core of the controller is the mechanism that connects the NBI to the SBI. Applications hosted on the controller interface with the NBI."
    },
    {
       "id":940,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":"",
       "question":"What is an application program interface (API)?",
       "choice_a":"An API is a program that allows for data transfer.",
       "choice_b":"An API is a programming language for network programmability.",
       "choice_c":"An API is a programming interface or standard allowing one program to communicate with another program.",
       "choice_d":"An API allows for programs to be virtualized.",
       "correct_answer":"C",
       "explanation":"An application program interface (API) is a method the programmer has created to allow other programs to communicate with their program. The interprogrammability is required when another program wants to share data with the API. Although an API allows data transfer, it is not a program specifically written for the transfer of data. An API is used for network programmability, but it is not a language for network programmability. An API does not allow for a program to be virtualized."
    },
    {
       "id":941,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":4,
       "question":"When an application communicates with an SDN controller, which mechanism does it use to communicate?",
       "choice_a":"The southbound interface (SBI)",
       "choice_b":"The core of the controller",
       "choice_c":"The northbound interface (NBI)",
       "choice_d":"Simple Network Management Protocol (SNMP)",
       "correct_answer":"C",
       "explanation":"The northbound interface (NBI) is responsible for allowing communication between applications and the core of the controller. Applications therefore directly communicate with the core through the northbound interface. The southbound interface (SBI) directly communicates with the SDN devices. The core of the controller is the mechanism that connects the NBI to the SBI. The Simple Network Management Protocol (SNMP) is used for the monitoring and collection of device metrics."
    },
    {
       "id":942,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":5,
       "question":"Which networking plane is responsible for routing of packets to specific destinations?",
       "choice_a":"Control plane",
       "choice_b":"Data plane",
       "choice_c":"Management plane",
       "choice_d":"Routing plane",
       "correct_answer":"B",
       "explanation":"The data plane is responsible for the routing of packets to specific destinations. The control plane would be responsible for the management of the routes for the functional routing of packets. The management plane would be responsible for the management of all functions of the router. There is no such plane called the routing plane; therefore,option D is an invalid answer."
    },
    {
       "id":943,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":"",
       "question":"What is the maximum hop count of fabric switching?",
       "choice_a":"1 hop",
       "choice_b":"3 hops",
       "choice_c":"4 hops",
       "choice_d":"5 hops",
       "correct_answer":"B",
       "explanation":"The maximum hop count on fabric switching is a total of 3 hops. When a host transmits,it will enter a Leaf switch; the Leaf switch will then forward traffic to the Spine switch. The Spine switch will in turn forward traffic to the corresponding Leaf switch and to the destination host. Of course, traffic could be 1 hop away, if both hosts are on the same Leaf switch. However, the maximum hop count is 3 hops."
    },
    {
       "id":944,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":"",
       "question":"Which component of an SDN is where the MTU is set?",
       "choice_a":"Overlay",
       "choice_b":"Tunnel",
       "choice_c":"Leaf",
       "choice_d":"Underlay",
       "correct_answer":"D",
       "explanation":"The underlay is where you will set the maximum transmission unit (MTU). The overlay is where the tunnel or virtual circuit is built using the underlay as the transport. A Leaf switch is a part of the software-defined network (SDN), along with the Spine switch; both need to have the same MTU set."
    },
    {
       "id":945,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":"",
       "question":"You are connecting to a router and configuring ACLs through the web interface.Which plane are you affecting?",
       "choice_a":"Management plane",
       "choice_b":"Configuration plane",
       "choice_c":"Data plane",
       "choice_d":"Control plane",
       "correct_answer":"D",
       "explanation":"When you configure access control lists (ACLs) through any interface, you are affecting the control plane. This is because you are controlling the flow of data with the ACL. You are accessing the router through the management plane when you are connected to either the web interface or the command-line interface (CLI). The data plane is what you are controlling with the control plane. The data plane is the actual flow of information."
    },
    {
       "id":946,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":"",
       "question":"Which WAN technology uses the overlay to connect remote offices?",
       "choice_a":"DMVPN",
       "choice_b":"VXLAN",
       "choice_c":"VLAN",
       "choice_d":"ECMP",
       "correct_answer":"A",
       "explanation":"Dynamic Multipoint Virtual Private Network (DMVPN) is a wide area network (WAN) technology that allows for virtual private networks (VPNs) to be created using the overlay of software-defined networking(SDN). Virtual Extensible LAN (VXLAN)is used to transport virtual local area network (VLAN) traffic over routed connections. Equal-cost multi-path routing (ECMP) is used by Leaf and Spine switches to provide a next-hop packet forwarding decision."
    },
    {
       "id":947,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":"",
       "question":"Which protocol allows for the tunneling of layer 2 traffic over a layer 3 network?",
       "choice_a":"ECMP",
       "choice_b":"DMVPN",
       "choice_c":"VXLAN",
       "choice_d":"EIGRP",
       "correct_answer":"C",
       "explanation":"The Virtual Extensible LAN (VXLAN) protocol is used to create layer 2 tunnels over a layer 3 network. The VXLAN protocol functions by encapsulating layer 2 traffic inside of a layer 3 packet. The Equal Cost Load Balancing Protocol (ECMP) is used by Leaf and Spine switches to provide next-hop packet forwarding decisions. Dynamic Multipoint Virtual Private Network (DMVPN)is a point-to-multipoint VPN technology used for layer 3 connectivity over a wide area network (WAN) connection. The Enhanced Interior Gateway Routing Protocol (EIGRP) is a Cisco proprietary layer 3 routing protocol."
    },
    {
       "id":948,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":4,
       "question":"Which is a protocol used on the management plane?",
       "choice_a":"SNMP",
       "choice_b":"CDP",
       "choice_c":"ICMP",
       "choice_d":"VTP",
       "correct_answer":"A",
       "explanation":"The Simple Network Management Protocol (SNMP) is a protocol used on the management plane. SNMP is used for the management of routers and switches because it can be writeable and allow for configuration. The Cisco Discovery Protocol (CDP) is a control protocol because it communicates port properties via layer 2 frames, such as power requirements. The Internet Control Message Protocol (ICMP) is a control protocol, because it is used to send control messages back to the originating device. The VLAN Trunking Protocol (VTP) is used to communicate the control information of VLANs to other participating switches."
    },
    {
       "id":949,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":5,
       "question":"Which next-hop packet forwarding protocol is used with SDN switching networks?",
       "choice_a":"ECMP",
       "choice_b":"OSPF",
       "choice_c":"MPLS",
       "choice_d":"CLOS",
       "correct_answer":"A",
       "explanation":"The equal-cost multi-path routing (ECMP) packet forwarding protocol is used to calculate next-hop forwarding with SDN switching networks. The Open Shortest Path First (OSPF) protocol is a layer 3 routing protocol and not used with SDN switching networks. The Multiprotocol Label Switching Protocol (MPLS) is a protocol used with MPLS wide area network (WAN) providers and not used with SDN switching networks. The CLOS network is also known as a Leaf/Spine network, but it is the topology and not a next-hop packet forwarding protocol."
    },
    {
       "id":950,
       "topic_id":6,
       "sub_domain":"6.4 Compare traditional campus device management with Cisco DNA Center enabled device management",
       "practice_test_id":"",
       "question":"Which product is a replacement for APIC-EM?",
       "choice_a":"OpenFlow",
       "choice_b":"Cisco Prime Infrastructure",
       "choice_c":"Cisco DNA Center",
       "choice_d":"Cisco SD-WAN",
       "correct_answer":"C",
       "explanation":"The Cisco DNA Center is Cisco's next-generation software-defined network (SDN) controller; it replaces Cisco's Application Policy Infrastructure Controller - Enterprise Module (APIC-EM) platform. OpenFlow is a protocol used to configure software-defined networks. Cisco Prime Infrastructure is a network management software suite, but it does not provide SDN functionality. Cisco Software Defined - Wide Area Network (SD-WAN) is an SDN controller for building WAN connections."
    },
    {
       "id":951,
       "topic_id":6,
       "sub_domain":"6.4 Compare traditional campus device management with Cisco DNA Center enabled device management",
       "practice_test_id":"",
       "question":"Which protocol is not used by the DNA discovery process for reading the inventory of a network device?",
       "choice_a":"SSH",
       "choice_b":"HTTPS",
       "choice_c":"NETCONF",
       "choice_d":"OpenFlow",
       "correct_answer":"D",
       "explanation":"After the Cisco Digital Network Architecture (Cisco DNA)discovery process has found a device, it will use SSH, Telnet, SNMPv2, SNMPv3, HTTP, HTTPS, and NETCONF. The discovery process will not use OpenFlow, since this is a configuration protocol that is mainly used by open platforms."
    },
    {
       "id":952,
       "topic_id":6,
       "sub_domain":"6.4 Compare traditional campus device management with Cisco DNA Center enabled device management",
       "practice_test_id":"",
       "question":"Where would you see the overall health of the network inside of the Cisco DNA Center?",
       "choice_a":"Design",
       "choice_b":"Policy",
       "choice_c":"Assurance",
       "choice_d":"Platform",
       "correct_answer":"C",
       "explanation":"The Assurance section of the Cisco DNA Center allows you to see the overall health of network devices managed by the DNA Center. The Design section allows you to create a hierarchical design of the network with a graphical map. The Policy section allows you to create policies based upon applications, traffic, and IP-based access control lists (ACLs), just to name a few. The Platform section allows you to perform upgrades and search the API catalog."
    },
    {
       "id":953,
       "topic_id":6,
       "sub_domain":"6.4 Compare traditional campus device management with Cisco DNA Center enabled device management",
       "practice_test_id":"",
       "question":"Which Cisco DNA Center feature allows you to template and apply standard configuration such as DNS servers, NTP servers, and AAA servers?",
       "choice_a":"IP-based access control",
       "choice_b":"Plug and Play",
       "choice_c":"Group-based access control",
       "choice_d":"Assurance",
       "correct_answer":"B",
       "explanation":"Plug and Play (PnP) is a feature inside of the Cisco DNA Center that allows you to on-board network devices and apply standard configuration such as DNS servers, NTP servers, and AAA servers, just to name a few. IP-based access control allows us to create a policy based upon access control lists. Group-based access control allows us to use group information populated from the Cisco Identity Services Engine (ISE) to create policies based upon user groups. Assurance is a section in the Cisco DNA Center that allows us to view the health of the network."
    },
    {
       "id":954,
       "topic_id":6,
       "sub_domain":"6.4 Compare traditional campus device management with Cisco DNA Center enabled device management",
       "practice_test_id":1,
       "question":"You want to see how everything is connected at a particular site. Which section contains a tool to obtain this information inside of the Cisco DNA Center?",
       "choice_a":"Provision",
       "choice_b":"Assurance",
       "choice_c":"Platform",
       "choice_d":"Policy",
       "correct_answer":"A",
       "explanation":"Under the Provision section, you can click on the hierarchy item that contains the site; then you will select the topology icon in the result pane. This will allow you to view how everything is connected at a particular site. The Assurance section of the Cisco DNA Center allows you to see the overall health of network devices managed by the DNA Center. The Platform section allows you to perform upgrades and search the API catalog. The Policy section allows you to create policies based upon applications, traffic, and IP-based access control lists (ACLs), just to name a few."
    },
    {
       "id":955,
       "topic_id":6,
       "sub_domain":"6.4 Compare traditional campus device management with Cisco DNA Center enabled device management",
       "practice_test_id":"",
       "question":"You need to add anOSPF area to a number of routers. What is the easiest method to achieve this with the Cisco DNA Center?",
       "choice_a":"IP-based access control",
       "choice_b":"Python",
       "choice_c":"DNA Command Runner",
       "choice_d":"Inventory",
       "correct_answer":"C",
       "explanation":"The easiest method for adding an OSPF area to a group of routers is using the DNA Command Runner tool. With this tool, you can execute a command on a group of devices. IP-based access control allows you to create policies based upon an IP-based access control list. Although Python can be used to add an OSPF area to a group of routers, it is harder to accomplish the task using Python than it is using DNA Command Runner. The Inventory section allows you to see the modules installed in a router or switch, as well as the firmware and IOS versions installed."
    },
    {
       "id":956,
       "topic_id":6,
       "sub_domain":"6.4 Compare traditional campus device management with Cisco DNA Center enabled device management",
       "practice_test_id":"",
       "question":"In which section inside of the Cisco DNA Center can you view and manage inventory of routers, switches, APs, and WLCs?",
       "choice_a":"Provision",
       "choice_b":"Policy",
       "choice_c":"Design",
       "choice_d":"Assurance",
       "correct_answer":"A",
       "explanation":"The Provision section allows you to view and edit the discovered inventory of network devices. The Policy section allows you to create policies based upon applications, traffic, and IP-based access control lists (ACLs), just to name a few. The Design section allows you to create a hierarchical design of the network with a graphical map. The Assurance section of the Cisco DNA Center allows you to see the overall health of network devices managed by the DNA Center."
    },
    {
       "id":957,
       "topic_id":6,
       "sub_domain":"6.4 Compare traditional campus device management with Cisco DNA Center enabled device management",
       "practice_test_id":4,
       "question":"You are developing a Python script that will interact with the Cisco DNA Center. Which section will detail the API that you will need to use?",
       "choice_a":"Design",
       "choice_b":"Policy",
       "choice_c":"Provision",
       "choice_d":"Platform",
       "correct_answer":"D",
       "explanation":"You can see the details of an API for the Cisco DNA Center by using the Platform section, then clicking Developer Toolkit and then APIs in the drop-down. The Design section allows you to create a hierarchical design of the network with a graphical map. The Policy section allows you to create policies based upon applications, traffic, and IP-based access control lists (ACLs), just to name a few. The Provision section allows you to apply configurations to network devices, such as DNS servers, AAA servers, or NTP servers, just to name a few."
    },
    {
       "id":958,
       "topic_id":6,
       "sub_domain":"6.4 Compare traditional campus device management with Cisco DNA Center enabled device management",
       "practice_test_id":5,
       "question":"What is the Cisco DNA Center feature that automates the fabric of the underlay and overlay of the network?",
       "choice_a":"Easy-QOS",
       "choice_b":"SD-Access",
       "choice_c":"System 360",
       "choice_d":"Cisco ISE",
       "correct_answer":"B",
       "explanation":"The Cisco feature Software Defined-Access (SD-Access) is an automated Plug and Play (PnP) solution that automates the underlay and overlay of the fabric. Easy-QOS was a feature in the original Application Policy Infrastructure Controller-Enterprise Module (APIC-EM); it has since been renamed to Application Policies in Cisco DNA Center. The System 360 feature inside of Cisco DNA Center allows you to view all of the settings and health of the controller. The Cisco Identity Services Engine (ISE) is a product that integrates with Cisco DNA Center to provide information about security groups and identity of security principals."
    },
    {
       "id":959,
       "topic_id":6,
       "sub_domain":"6.4 Compare traditional campus device management with Cisco DNA Center enabled device management",
       "practice_test_id":"",
       "question":"Which feature does Cisco Prime Infrastructure provide that Cisco DNA Center cannot provide?",
       "choice_a":"Client coverage heat maps",
       "choice_b":"Client triangulation support",
       "choice_c":"Device configuration backup",
       "choice_d":"Application health",
       "correct_answer":"C",
       "explanation":"Cisco DNA Center cannot provide device configuration backups; that function still requires Cisco Prime Infrastructure. Cisco DNA Center can perform client coverage heat maps, client triangulation, and application health reports."
    },
    {
       "id":960,
       "topic_id":6,
       "sub_domain":"6.4 Compare traditional campus device management with Cisco DNA Center enabled device management",
       "practice_test_id":"",
       "question":"Which method(s) of connectivity must be configured for network discovery inside of the Cisco DNA Center?",
       "choice_a":"SSH",
       "choice_b":"SNMP",
       "choice_c":"Logging",
       "choice_d":"Both A and B",
       "correct_answer":"D",
       "explanation":"In order for network discovery to find new network devices, you must configure a command-line interface (CLI) of SSH or Telnet and Simple Network Management Protocol (SNMP). Logging is not required for network discovery."
    },
    {
       "id":961,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":"",
       "question":"Which protocol is normally used with REST APIs?",
       "choice_a":"SNMP",
       "choice_b":"HTTP",
       "choice_c":"SNTP",
       "choice_d":"SOAP",
       "correct_answer":"B",
       "explanation":"Representational state transfer (REST) APIs normally utilize HyperText Transfer Protocol (HTTP) for moving data. It performs this via a get URI and it receives a response in XML, JSON, or another date transfer language. Although you can encrypt the HTTP traffic with SSL (HTTPS), its core language is still HTTP. Simple Network Management Protocol (SNMP) and Simple Network Time Protocol (SNTP) are not used with REST APIs. Simple Object Access Protocol (SOAP) is considered an alternate technology to REST for API access."
    },
    {
       "id":962,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":"",
       "question":"You are writing a script to pull information from the Cisco DNA Center via the REST-based API. How do you authenticate so that you can communicate with the Cisco DNA Center API?",
       "choice_a":"Pass the username and password in every request.",
       "choice_b":"Send a POST to the API for an authentication token.",
       "choice_c":"Send a GET to the API for an auth token.",
       "choice_d":"Create a public private key pair for the Cisco DNA Center appliance.",
       "correct_answer":"B",
       "explanation":"You will authenticate with Cisco DNA Center by sending a POST request to the API for an authentication token. You can then use the authentication token for all subsequent requests to Cisco DNA Center. You will not pass the username and password; the username and password must be encoded in Base64 to obtain the authentication token. The <code>dna/system/api/v1/auth/token</code> API requires a POST request to obtain the authentication token, not a GET request. The Cisco DNA Center does not use public-private key pairs for API authentication."
    },
    {
       "id":963,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":4,
       "question":"What is the CRUD framework used for?",
       "choice_a":"Memory cleanup",
       "choice_b":"Replacement for REST-based APIs",
       "choice_c":"Data encoding",
       "choice_d":"Data actions",
       "correct_answer":"D",
       "explanation":"The CREATE, READ, UPDATE, DELETE (CRUD) framework describes the various actions that can be performed on data via the REST-based API. Although CRUD sounds like it might cleanup memory, it has nothing to do with memory cleanup. It works in conjunction with REST-based APIs as a framework for the manipulation of data. The Base64 algorithm is used for data encoding, when it is needed."
    },
    {
       "id":964,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":5,
       "question":"Which type of authentication is used for REST-based token requests to the Cisco DNA Center?",
       "choice_a":"Basic",
       "choice_b":"AD integrated",
       "choice_c":"SSL",
       "choice_d":"Pass-through",
       "correct_answer":"A",
       "explanation":"Basic authentication is used for token requests with the Cisco DNA Center. Active Directory (AD) integrated authentication and pass-through authentication are Microsoft-only types of authentication, and the Cisco DNA Center does not support them. Secure Sockets Layer (SSL) is a method of encryption for authentication requests, but it is not an authentication method."
    },
    {
       "id":965,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":1,
       "question":"After you obtain an authentication token, how do you apply it to subsequent actions?",
       "choice_a":"Add it as a variable named X-Auth-Token in the script.",
       "choice_b":"Place it in the header of the request as anX-Auth-Token element.",
       "choice_c":"Pass the token in the URI of subsequent requests.",
       "choice_d":"Perform a POST for the authentication token within 10 seconds of the subsequent request.",
       "correct_answer":"B",
       "explanation":"After the initial POST to obtain the authentication token, it should be placed in the header of subsequent requests as an X-Auth-Token element. You will most likely use a variable to store the token, but a variable by itself is not enough to authenticate subsequent requests. The token is not passed in the URI of subsequent requests. Although performing a POST within 10 seconds of the subsequent request is a good idea, if the token is not placed in the header, it will not authenticate you."
    },
    {
       "id":966,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":"",
       "question":"Which encoding method is used to transmit the username and password to obtain the X-Auth-Token from the Cisco DNA Center?",
       "choice_a":"SSL",
       "choice_b":"AAA",
       "choice_c":"Base64",
       "choice_d":"Basic",
       "correct_answer":"C",
       "explanation":"When you process the POST to obtain the X-Auth-Token from the Cisco DNA Center, you will pass the username and password encoded in Base 64 encoding. Although you will request the X-Auth-Token over Secure Sockets Layer (SSL), it is an encryption protocol and not an encoding method. Authentication, authorization, and accounting (AAA) servicesare a means for authentication and often used with 802.1X; AAA is not an encoding method. When you request an X-Auth-Token, you will request it via basic authentication; this is aHyperText Transfer Protocol (HTTP) method of submitting the username and password and not an encoding method."
    },
    {
       "id":967,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":"",
       "question":"You are creating a script to directly configure a Cisco switch using the YANG data model. Which network API will you use to perform this task?",
       "choice_a":"OpenFlow",
       "choice_b":"RESTCONF",
       "choice_c":"SNMP",
       "choice_d":"REST-based API",
       "correct_answer":"B",
       "explanation":"You will perform this task using the RESTCONF protocol. RESTCONF will encapsulate the YANG data model containing the configuration in a RESTCONF transport protocol. OpenFlow is used with the OpenDayLight Protocol and not commonly used with Cisco switches. The Simple Network Management Protocol (SNMP) does not support the YANG data model. A REST-based API is another API style that switches do not support directly, but Cisco DNA Center does."
    },
    {
       "id":968,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":"",
       "question":"Which is a RESTCONF content type that is used with a RESTCONF request?",
       "choice_a":"application/yang-data+json",
       "choice_b":"application/json",
       "choice_c":"data/json",
       "choice_d":"data/yaml",
       "correct_answer":"A",
       "explanation":"When a request is made with RESTCONF, the data is sent via the HyperText Transfer Protocol (HTTP) using theMultipurpose Internet Mail Extensions (MIME)content type of application/yang-data+json. This MIME type is used because the request is interfacing with an application and the data is encapsulated inside of the Yet Another Next Generation (YANG) data model in the form of JavaScript Object Notation (JSON)."
    },
    {
       "id":969,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":4,
       "question":"You've initiated a REST-based API call to an SDN controller and received a 500 status code. What will most likely fix the problem?",
       "choice_a":"Format your response correctly.",
       "choice_b":"Authenticate to the device first.",
       "choice_c":"Nothing; this code means OK.",
       "choice_d":"Restart the REST-based service.",
       "correct_answer":"D",
       "explanation":"The most likely course of action is to restart the REST-based service, since a 500 status code means that there is an internal server error. If a 400 status code was returned, it would most likely be the formatting of your request. If a 403 status code was returned, it would suggest that you have not authenticated to the software-defined network (SDN) controller or you are not authorized to access the API. A 200 status code means that everything was successful and the request is OK."
    },
    {
       "id":970,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":5,
       "question":"On which interface of the Cisco DNA Center would you most likely use a RESTCONF request?",
       "choice_a":"Northbound interface",
       "choice_b":"Eastbound interface",
       "choice_c":"Westbound interface",
       "choice_d":"Southbound interface",
       "correct_answer":"D",
       "explanation":"RESTCONF requests are used outbound to network devices on the southbound interface of Cisco DNA Center. REST-based APIs are accessible via the northbound interface of the Cisco DNA Center so that programmability can be achieved. The eastbound interface is used for events and notification on the Cisco DNA Center controller. The Westbound interface is used for integration with third-party management products."
    },
    {
       "id":971,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":"",
       "question":"How is a status code passed to the client after a REST-based request has been processed?",
       "choice_a":"HTTP header",
       "choice_b":"HTTP body",
       "choice_c":"Script variable",
       "choice_d":"Script data object",
       "correct_answer":"A",
       "explanation":"The status code is passed back to the client via the HyperText Transfer Protocol (HTTP) header. Web-based browsers do not show HTTP headers, and this is why using a tool such as Postman is recommended. The HTTP body is where the returned data of the request can be found. Script variables are used internally by the script so that data can be loaded into the variable and passed to other procedures within the script. Script data objects are also used internally by the script to load and pass complex data structures called objects."
    },
    {
       "id":972,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":"",
       "question":"You have received a return status code of 201 from an SDN controller after executing an API request via REST. Which CRUD action have you executed, judging by the status code?",
       "choice_a":"POST",
       "choice_b":"GET",
       "choice_c":"PATCH",
       "choice_d":"DELETE",
       "correct_answer":"A",
       "explanation":"A status code of 201 means that the item has been created; normally only a POST command can create a data item. A GET HyperText Transfer Protocol (HTTP) verb will read an item and return a 200 status code. A PATCH HTTP verb will update an existing item and return a 200 status code. A DELETE HTTP verb will delete an item and return a 200 status code."
    },
    {
       "id":973,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":"",
       "question":"Which character signifies the starting point for a series of request query parameters in a URI string?",
       "choice_a":"Backslash",
       "choice_b":"Forward slash",
       "choice_c":"Question mark",
       "choice_d":"Ampersand",
       "correct_answer":"C",
       "explanation":"The question mark signifies the starting point for a series of request query parameters in a Uniform Resource Identifier (URI) string. For example, the URI string might look something like this: <code>https://server/path/api?para1=test1&para2=test2</code>. The backslash is not used in a URI. The forward slash helps delimit the various components of a URI. The ampersand delimits the various request query parameters if there is more than one."
    },
    {
       "id":974,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":4,
       "question":"Which HTTP action verb is used to insert or create a data item?",
       "choice_a":"GET",
       "choice_b":"UPDATE",
       "choice_c":"POST",
       "choice_d":"PUT",
       "correct_answer":"C",
       "explanation":"The HyperText Transfer Protocol (HTTP) action verb POST will insert or create a data item when referencing an application programming interface (API). The HTTP action verb GET will read data from an API. The HTTP action verb UPDATE is not a valid verb; therefore, this is an invalid answer. The HTTP action verb PUT will only replace or update a data item; it will not insert a data item."
    },
    {
       "id":975,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":5,
       "question":"You just sent a request to the SDN controller, and after a little while, the result code came back as a 504 status code. What most likely happened?",
       "choice_a":"The command is missing parameters.",
       "choice_b":"The command has timed out.",
       "choice_c":"The command is restricted.",
       "choice_d":"The service is down.",
       "correct_answer":"B",
       "explanation":"A status code of 504 means that the command that was sent to the server did not return in a timely fashion and timedout. A status code of 400 would depict that the command is missing parameters. If a command is restricted for the authentication supplied, a status code of 403 would be returned. If a service is down or improperly responding, a status code of 500 would be returned."
    },
    {
       "id":976,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"Which function does Ansible, Chef, and Puppet perform in the network?",
       "choice_a":"Network management station",
       "choice_b":"Configuration management",
       "choice_c":"Software-defined networking",
       "choice_d":"Centralized logging",
       "correct_answer":"B",
       "explanation":"Ansible, Chef, and Puppet are configuration management tools. They operate by applying specific configurations to server or network devices. A network management station (NMS) is typically used with the Simple Network Management Protocol (SNMP) to centralize polling of SNMP counters and allow for devices to send alerts. Software-defined networking (SDN) is a method of centralizing the control and management planes of a network so that the network device can focus on the data plane. Centralized logging is used with syslog so that all logs can be sent to a centralized area for analysis."
    },
    {
       "id":977,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"Which configuration management tool uses YAML to store configuration?",
       "choice_a":"Ansible",
       "choice_b":"Cisco DNA Center",
       "choice_c":"Chef",
       "choice_d":"Puppet",
       "correct_answer":"A",
       "explanation":"Ansible uses the YAML Ain't Markup Language (YAML) format to store configuration. The Cisco DNA Center stores configuration internally inside of its database, but many things are exportable via JavaScript Object Notation (JSON). Chef and Puppet both use Embedded Ruby (ERB) templates to store configuration."
    },
    {
       "id":978,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"Which component in an Ansible setup defines the connection information so that Ansible can perform configuration management?",
       "choice_a":"Playbook",
       "choice_b":"Settings",
       "choice_c":"Inventory",
       "choice_d":"Modules",
       "correct_answer":"C",
       "explanation":"The Inventory component defines the various hosts and their connection information in an Ansible setup. The Playbook component defines the script to execute to perform the configuration management. The <code>ansible.cfg</code> file controls the settings for the Ansible server. The Modules component allows Ansible to connect to and understand various systems."
    },
    {
       "id":979,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"Which configuration management tool does not require an agent to apply changes to a Linux-based server?",
       "choice_a":"Ansible",
       "choice_b":"Puppet",
       "choice_c":"Chef",
       "choice_d":"Cisco DNA Center",
       "correct_answer":"A",
       "explanation":"Ansible does not require an agent to apply changes to a Linux-based server or other network device. It uses Secure Shell (SSH) TCP port 22 to apply the configuration. Puppet and Chef both require agents to be installed on the managed hosts. Although Cisco DNA Center is installed on top of a Linux distribution, Cisco DNA Center does not support Linux servers; it is primarily used for the management of Cisco devices. You could certainly create an extensible package to send commands to a Linux box through an SNMP agent, but currently it would need to be developed. Ansible supports Linux-based servers without an agent and without any development for communications."
    },
    {
       "id":980,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"Which Puppet component contains the configuration for the managed hosts?",
       "choice_a":"Manifest",
       "choice_b":"Agent",
       "choice_c":"Class",
       "choice_d":"Module",
       "correct_answer":"A",
       "explanation":"The Manifest component of Puppet contains the configuration for the managed hosts. The Agent component of Puppet is used to apply the configuration from the master server. The Class component is used to organize the configuration inside of the Manifest. The Module component is similar to a Class with the exception that it is used to organize and create tasks for the Manifest component."
    },
    {
       "id":981,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"Which Chef component contains the set of instructions to configure a node?",
       "choice_a":"Cookbook",
       "choice_b":"Crock Pot",
       "choice_c":"Recipe",
       "choice_d":"Chef Node",
       "correct_answer":"C",
       "explanation":"The Recipe component of Chef contains the set of instructions that are carried out to configure a server. The Recipes are collected into the Cookbook component so that the task can be organized and applied to hosts. The Crock Pot component does not exist inside of Chef; therefore, it is an invalid answer. The Chef Node component is a host that is managed by a Chef Server component."
    },
    {
       "id":982,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"Which Chef component collects system state information and reports back to the Chef Server component?",
       "choice_a":"Chef-Client",
       "choice_b":"Chef Workstation",
       "choice_c":"Ohai",
       "choice_d":"Knife",
       "correct_answer":"C",
       "explanation":"The Ohai component is the second of two parts installed on the Chef Node; the first part is the Chef-Client component. Ohai is responsible for monitoring system state information and reporting back to the Chef Server component. If Ohai detects that an attribute of the system state is out of compliance, the system state for that component will be reapplied. The Chef Workstation command-line interface (CLI) component is called the Knife and interacts with the Chef Server to configure tasks when you are creating a Cookbook."
    },
    {
       "id":983,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":1,
       "question":"Which variable is checked to determine the location of the Ansible settings file?",
       "choice_a":"<code>ANSIBLE_SETTINGS</code>",
       "choice_b":"<code>ANSIBLE_CONFIG</code>",
       "choice_c":"<code>ansible_connection</code>",
       "choice_d":"<code>/etc/ansible/hosts</code>",
       "correct_answer":"B",
       "explanation":"The variable <code>ANSIBLE_CONFIG</code> is used to determine the location of the Ansible setting file named <code>ansible.cfg</code>. The variable <code>ANSIBLE_SETTINGS</code> is not used with Ansible and therefore option A is an invalid answer. The <code>ansible_connection</code> variable is used inside of the Inventory file to explain to Ansible how to connect to a remote system. The file <code>/etc/ansible/hosts</code> is not a variable; it specifies the various target nodes, also called the Inventory."
    },
    {
       "id":984,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"Which command will give detailed information on modules in Ansible?",
       "choice_a":"<code>man</code>",
       "choice_b":"<code>cat</code>",
       "choice_c":"<code>ad-hoc</code>",
       "choice_d":"<code>ansible-doc</code>",
       "correct_answer":"D",
       "explanation":"The command <code>ansible-doc</code> will give you detailed information on Ansible modules. The command is followed by the module name to give specific information on a particular module. For example, <code>ansible-doc ios_vlan</code> will display all of the configuration for VLANs on Cisco IOS. The <code>man</code> command will give Linux/Unixmanual information of the command of <code>ansible-doc</code>, but not the individual modules. The <code>cat</code> command is short for concatenate; it allows you to display or create the contents of a file. Ad-hoc is not a command; it is a configuration mode in which you can test commands before they are run network wide."
    },
    {
       "id":985,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"Which Ansible tool will allow you to try commands against a host without making a Playbook?",
       "choice_a":"Knife interface",
       "choice_b":"<code>ansible_playbook</code> command",
       "choice_c":"Ad-hoc interface",
       "choice_d":"Ansible Tower",
       "correct_answer":"C",
       "explanation":"The Ad-hoc interface allows you to try commands against a host without making a Playbook. The Knife interface is a command-line interface (CLI) for the Chef configuration management utility. The <code>ansible_playbook</code> command is used to execute an Ansible playbook. Ansible Tower is a paid version of Ansible supported by Red Hat that adds central management."
    },
    {
       "id":986,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"What are global variables that contain information specific to Puppet called?",
       "choice_a":"Resource",
       "choice_b":"Class",
       "choice_c":"Module",
       "choice_d":"Facts",
       "correct_answer":"D",
       "explanation":"In the Puppet configuration management utility, the term <italic>Facts</italic> describes global variables that contain information that is specific to Puppet. One example of a global variable is the IP address of the Puppet system. A Resource declares a task to be executed and how the task should be executed. The Class component is used to organize the configuration inside of the Manifest. The Module component is similar to a Class with the exception that it is used to organize and create tasks for the Manifest component."
    },
    {
       "id":987,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"Once you have completed a Cookbook for Chef, where do you upload the Cookbook so it is accessible on the Chef Server?",
       "choice_a":"Bookshelf",
       "choice_b":"Chef Workstation",
       "choice_c":"Chef Node",
       "choice_d":"Chef-Client",
       "correct_answer":"A",
       "explanation":"Once you have completed a Cookbook for Chef, you will upload the Cookbook to the Bookshelf located on the Chef Server. This will allow the Chef Server to execute the configuration management contained within the Cookbook. The Chef Workstation is where you manage the Chef Server. The Chef Node is the computer that is controlled by the Chef Server. The Chef Node has the Chef-Client installed, which calls back to the Chef Server for configuration management instructions."
    },
    {
       "id":988,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"Which tool will allow for central management and RBAC and is supported by Red Hat?",
       "choice_a":"Ansible Tower",
       "choice_b":"Chef",
       "choice_c":"Puppet",
       "choice_d":"Ansible",
       "correct_answer":"A",
       "explanation":"Ansible Tower is a paid version of Ansible supported by Red Hat that adds central management. Ansible Tower also allows for role-based access control (RBAC) for the execution of Playbooks. The addition of RBAC adds greater security to Ansible while allowing users a specific role to administer their responsibilities inside of Ansible. All of the other options are incorrect."
    },
    {
       "id":989,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"Which configuration management utility allows for easy configuration of Cisco network devices?",
       "choice_a":"Ansible",
       "choice_b":"Puppet",
       "choice_c":"Chef",
       "choice_d":"Python",
       "correct_answer":"A",
       "explanation":"The Ansible configuration management utility allows for easy configuration of Cisco network devices because it has many modules dedicated to Cisco IOS. Ansible also does not require the installation of an agent, which Puppet and Chef require. Python can be used for configuration management, but it will not allow for periodic checks to make sure that the configuration does not drift."
    },
    {
       "id":990,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"What function does Knife serve in the Chef configuration management utility?",
       "choice_a":"Storage of the Bookshelf",
       "choice_b":"Storage of the configuration of Chef",
       "choice_c":"CLI utility for the management of Chef",
       "choice_d":"Client-side agent",
       "correct_answer":"C",
       "explanation":"The Knife utility is a command-line interface that allows for the management of Chef. The storage of the Bookshelf is contained on the Chef Server. The configuration of Chef is also contained on the Chef Server. The Client-side agent has two parts: Ohai, which checks the current system state of the Chef Node, and the Chef Agent, which talks directly to the Chef Server for execution tasks."
    },
    {
       "id":991,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"Which is a correct statement about configuration management?",
       "choice_a":"IaaS helps maintain configuration over the lifecycle of the host.",
       "choice_b":"Configuration management prevents drift with NTP.",
       "choice_c":"IaC solutions prevent drift with Idempotence.",
       "choice_d":"Configuration management software requires per-host licensing.",
       "correct_answer":"C",
       "explanation":"Configuration management uses Infrastructure as Code (IaC) to prevent drift with the applied theory of Idempotence. Idempotence states that only required changes will be applied to servers that fall outside of the desired system state. Infrastructure as a Service (IaaS) is a cloud model that defines components that can be purchased for a period, such as virtual router, switches, and virtual machines (VMs), just to name a few.Configuration management can install the Network Time Protocol so time does not drift, but NTP will not prevent configuration drift. Configuration management software does not always require per-host licensing. Most configuration management utilities offer a community edition that is free; if you want enterprise features, you can then purchase licensing from the parent company."
    },
    {
       "id":992,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":"",
       "question":"Which configuration management utility is the easiest to setup?",
       "choice_a":"Chef",
       "choice_b":"Puppet",
       "choice_c":"Ansible",
       "choice_d":"Cisco DNA Center",
       "correct_answer":"C",
       "explanation":"Ansible is the easiest configuration management utility to setup as well as use. Chef and Puppet are a bit more involved to setup because they require clients to be installed on the hosts being managed. Cisco DNA Center is not a configuration management utility outside of Cisco devices; therefore,option D is an invalid answer."
    },
    {
       "id":993,
       "topic_id":6,
       "sub_domain":"6.7 Interpret JSON encoded data",
       "practice_test_id":"",
       "question":"Which format must a custom Ansible module be written in?",
       "choice_a":"YAML",
       "choice_b":"CSV",
       "choice_c":"JSON",
       "choice_d":"XML",
       "correct_answer":"C",
       "explanation":"Ansible is installed with a number of modules compiled already. However, if you want to make custom modules, they must be created in JSON format. All of the other options are incorrect."
    },
    {
       "id":994,
       "topic_id":6,
       "sub_domain":"6.7 Interpret JSON encoded data",
       "practice_test_id":"",
       "question":"What is at the beginning of every JSON file that helps you identify the format?",
       "choice_a":"Three dashes",
       "choice_b":"A square bracket",
       "choice_c":"A double quote",
       "choice_d":"A curly bracket",
       "correct_answer":"D",
       "explanation":"JavaScript Object Notation (JSON) always starts with a curly bracket, sometimes called a brace. If the file starts with three dashes, the file is most likely YAML Ain't Markup Language (YAML). A square bracket is found inside of JSON files when more than one key-value pair exists. A double quote is often found at the beginning of each line in a comma-separated values (CSV) file."
    },
    {
       "id":995,
       "topic_id":6,
       "sub_domain":"6.7 Interpret JSON encoded data",
       "practice_test_id":"",
       "question":"You just opened a JSON file, and the key you are looking for has a square bracket. What can be concluded?",
       "choice_a":"The value that follows the square bracket is the value you are looking for.",
       "choice_b":"There are several key-value pairs for the key you need.",
       "choice_c":"The value is after the matching square bracket.",
       "choice_d":"The value is unknown.",
       "correct_answer":"B",
       "explanation":"When a square bracket is in place of a value inside a JavaScript Object Notation (JSON) file, it means there is a series of key-value pairs for the initial value. These key-value pairs are often called collections. All of the other options are incorrect."
    },
    {
       "id":996,
       "topic_id":6,
       "sub_domain":"6.7 Interpret JSON encoded data",
       "practice_test_id":"",
       "question":"In the following exhibit, what is wrong with this JSON file?<img src='/question_assets/ccna/6_image1.png'></img>",
       "choice_a":"The interface of Fa0/1 is capitalized.",
       "choice_b":"The address should have a square bracket.",
       "choice_c":"There is a missing curly bracket.",
       "choice_d":"Nothing is wrong.",
       "correct_answer":"C",
       "explanation":"There is a missing curly bracket that ends the address value. The capitalization of Fa0/1 is fine because it is within double quotes, so therefore it is read literally. The address does not need to have square brackets unless there will be more than one address."
    },
    {
       "id":997,
       "topic_id":6,
       "sub_domain":"6.7 Interpret JSON encoded data",
       "practice_test_id":"",
       "question":"Which is an advantage in using JSON over a CSV file?",
       "choice_a":"Values can be used that contain spaces.",
       "choice_b":"There are multiple values for a particular key.",
       "choice_c":"The files can be read line by line for every value.",
       "choice_d":"Hierarchical structure allows for programmability.",
       "correct_answer":"D",
       "explanation":"JavaScript Object Notation (JSON) allows for a hierarchical structure that allows for programmability; this is somewhat similar to Extensible Markup Language (XML). Both JSON and comma-separated values (CSV) can contain spaces, because the values are enclosed within double quotes. Both JSON and CSV can have multiple values for a particular key. Only CSV can be read line by line; JSON files must be read in entirety."
    },
    {
       "id":998,
       "topic_id":6,
       "sub_domain":"6.7 Interpret JSON encoded data",
       "practice_test_id":"",
       "question":"When you request information from the Cisco DNA Center via a REST-based API, what format is the response in?",
       "choice_a":"JSON",
       "choice_b":"XML",
       "choice_c":"CSV",
       "choice_d":"YAML",
       "correct_answer":"A",
       "explanation":"Cisco DNA Center will return REST-based requests in JavaScript Object Notation (JSON) format. All of the other options are incorrect."
    },
    {
       "id":999,
       "topic_id":6,
       "sub_domain":"6.7 Interpret JSON encoded data",
       "practice_test_id":"",
       "question":"Using the following exhibit, which statement best represents the JSON data?<img src='/question_assets/ccna/6_image2.png'></img>",
       "choice_a":"The interface data is incorrect because it is missing a comma after the routes.",
       "choice_b":"The interface data is incorrect because it is missing a set of square brackets around the second route.",
       "choice_c":"The interface data is incorrect because it contains an illegal underscore character.",
       "choice_d":"Nothing is wrong with the exhibit.",
       "correct_answer":"B",
       "explanation":"The collection of routes contains two individual route statements that are named route (singular). All collections must be contained within square brackets, also called braces. All of the other options are incorrect."
    },
    {
       "id":1000,
       "topic_id":6,
       "sub_domain":"6.7 Interpret JSON encoded data",
       "practice_test_id":"",
       "question":"Using the following exhibit, which statement best represents the JSON data?<img src='/question_assets/ccna/6_image3.png'></img>",
       "choice_a":"The interface data is incorrect because it is missing a comma after <code>defaultgw</code>.",
       "choice_b":"The interface data is incorrect because it is missing a subnetmask for the second IP address.",
       "choice_c":"The interface data is incorrect because it contains an illegal underscore character.",
       "choice_d":"Nothing is wrong with the exhibit.",
       "correct_answer":"D",
       "explanation":"Nothing is wrong with the exhibit. The IP address is defined as a collection of IP addresses using the JSON tag of <code>ipaddress</code>. Although for completeness a second subnet mask should be stated in the JSON data, it may be in the proper format that it is expected. The last comma is not needed in JSON files as it defines the end of the hierarchy. The underscore in a JSON key or value data is not considered an illegal character."
    },
    {
       "id":1001,
       "topic_id":6,
       "sub_domain":"6.7 Interpret JSON encoded data",
       "practice_test_id":"",
       "question":"Using the following exhibit, which statement best represents the JSON data?<img src='/question_assets/ccna/6_image4.png'></img>",
       "choice_a":"The interface data is incorrect because it is missing a comma after <code>defaultgw</code>.",
       "choice_b":"The interface data is incorrect because it is missing a closing square bracket after the list of IP addresses.",
       "choice_c":"The interface data is incorrect because it contains an illegal underscore character.",
       "choice_d":"Nothing is wrong with the exhibit.",
       "correct_answer":"B",
       "explanation":"The JavaScript Object Notation (JSON) data is incorrect because it is missing a closing square bracket after the IP addresses. The last comma is not needed in JSON files as it defines the end of the hierarchy. The underscore in a JSON key or value data is not considered an illegal character."
    },
    {
       "id":1002,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":2,
       "question":"Which device acts like a multiport repeater?",
       "choice_a":"Firewall",
       "choice_b":"Hub",
       "choice_c":"Router",
       "choice_d":"Switch",
       "correct_answer":"B",
       "explanation":"A hub is a multiport repeater. When a hub receives a frame, it will repeat the frame on all other ports, regardless of whether or not the port is the destination host. A firewall is a network device that can protect a network from malicious traffic and/or restrict access. A router is a network device that routes layer 3 packets. A switch is a layer 2 device that creates micro-segmentation."
    },
    {
       "id":1003,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":2,
       "question":"Which benefit does a switch provideto a LAN?",
       "choice_a":"Breaks up broadcast domains",
       "choice_b":"Breaks up collision domains",
       "choice_c":"Forces full-duplex on all ports",
       "choice_d":"Allows for a fast uplink port",
       "correct_answer":"B",
       "explanation":"Switches break up collision domains by allowing micro-segmentation. Switches are set to auto-negotiate duplex and speed by default, and they do not force full-duplex. Routers break up broadcast domains; switches will not break up broadcast domains. Switches also don't always allow for a fast uplink port; it always depends on the type of switch and the application in which it is marketed."
    },
    {
       "id":1004,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":2,
       "question":"When a firewall matches a URI, it is operating at which layer?",
       "choice_a":"Layer 7",
       "choice_b":"Layer 5",
       "choice_c":"Layer 4",
       "choice_d":"Layer 3",
       "correct_answer":"A",
       "explanation":"When a firewall matches a Uniform Resource Identifier (URI), such as a URL, it is operating at layer 7. This is known as a web application firewall, or WAF. Layer 5 communications are session based; one such application that is session based is Structured Query Language (SQL). Layer 4 communications are port based; many basic firewall rules are built to block and allow specific ports. Layer 3 communications are IP address based; many basic firewall rules are also built to block and allow specific IP addresses."
    },
    {
       "id":1005,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":2,
       "question":"Which topology does an autonomous WAP use?",
       "choice_a":"Star topology",
       "choice_b":"Full mesh topology",
       "choice_c":"Partial mesh topology",
       "choice_d":"Hybrid topology",
       "correct_answer":"A",
       "explanation":"An autonomous WAP acts similarly to an access layer switch. However, WAPs normally do not have redundant links back to the distribution switches. So it acts more like a star topology, connecting the Ethernet and wireless clients together. A full mesh topology is often found between the core and distribution layers of the Cisco three-tier design model. A partial mesh topology is often found between the distribution and access layers in the Cisco three-tier design model. A hybrid topology is found in many networks today because one topology does not fit all needs throughout the network."
    },
    {
       "id":1006,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":2,
       "question":"Which is the default encapsulation on a serial connection for Cisco?",
       "choice_a":"MPLS",
       "choice_b":"HDLC",
       "choice_c":"PPP",
       "choice_d":"PPPoE",
       "correct_answer":"B",
       "explanation":"High-Level Data Link Control (HDLC) is the default encapsulation on a serial connection for Cisco.Multiprotocol Label Switching (MPLS) is becoming a popular WAN connectivity method, but it is not an encapsulation method. Point-to-Point Protocol (PPP) is an open standard layer 2 protocol used for point-to-point connections, such as WAN serial connections. Point-to-Point Protocol over Ethernet (PPPoE) is the PPP protocol encapsulated into an Ethernet frame. Its most notable use is in Digital Subscriber Line (DSL) communications, where it is mainly used for its authentication methods."
    },
    {
       "id":1007,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":2,
       "question":"You are connecting a Cisco router to a leased line serial connection. The other side of the connection has non-Cisco equipment. Which protocol should you choose for compatibility?",
       "choice_a":"HDLC",
       "choice_b":"PPP",
       "choice_c":"PPPoE",
       "choice_d":"X.25",
       "correct_answer":"B",
       "explanation":"The Point-to-Point Protocol (PPP) is an open standard. Cisco routers default to the HDLC protocol. However, HDLC is a proprietary standard for Cisco. So PPP should be used for compatibility.Point-to-Point Protocol over Ethernet (PPPoE) is the PPP protocol encapsulated into an Ethernet frame. The X.25 protocol is one of the first WAN protocols for packet switching; it has largely been deprecated for newer protocol such as PPP that offer more features."
    },
    {
       "id":1008,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":2,
       "question":"What is the term used to describe the telephone company's switching office?",
       "choice_a":"Demarcation point",
       "choice_b":"Network edge",
       "choice_c":"Central office",
       "choice_d":"Main data frame",
       "correct_answer":"C",
       "explanation":"The central office, sometimes referred to as the CO, is the local switching office. The CO is where your data lines meet the public network for data and voice. The demarcation point, or demarc as it is also referred to, is the point at which the provider responsibility for wiring and maintenance ends. <italic>Network edge</italic> is not a term typically used for WAN networking; therefore, it is an invalid answer. The main data frame (MDF) describes the location where network equipment is concentrated and connects to external networks."
    },
    {
       "id":1009,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":2,
       "question":"What is the term that defines the access point for the service provider's services?",
       "choice_a":"Demarcation point",
       "choice_b":"Point of presence",
       "choice_c":"Customer edge",
       "choice_d":"Network edge",
       "correct_answer":"B",
       "explanation":"<italic>Point of presence (PoP)</italic> is the term that defines the access point of the provider's services. These services might be Internet, private WAN, or cloud resources. The demarcation point, or demarc as it is also referred to, is the point in which the provider responsibility for wiring and maintenance ends. <italic>Customer edge</italic> is a term often used with Multiprotocol Label Switching (MPLS) WAN terminology to describe the end of the customer's network before a packet enters the MPLS network. <italic>Network edge</italic> is not a term typically used for WAN networking; therefore, it is an invalid answer."
    },
    {
       "id":1010,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":2,
       "question":"You have several VMs in a public cloud. What is a benefit of creating NTP VNF in the public cloud for the VMs?",
       "choice_a":"Better time synchronization",
       "choice_b":"Better response time from the VMs",
       "choice_c":"Lower bandwidth utilization from your premises",
       "choice_d":"Overcoming different time zones",
       "correct_answer":"C",
       "explanation":"Lowering bandwidth between the premises and your virtual machines (VMs) on the public cloud is a direct benefit oflocating aNetwork Time Protocol (NTP) virtual network function (VNF) on the public cloud for VM time synchronization. Using an NTP server regardless of where it is located will yield you precision time. Implementing the NTP VNF in the cloud will not allow for better response time from VMs. An NTP VNF will not overcome different time zones; this is a function of the time offset on the VM."
    },
    {
       "id":1011,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":2,
       "question":"When deciding to move DNS into the cloud for an application on the public cloud, what is the primary decision factor?",
       "choice_a":"Bandwidth",
       "choice_b":"Response time",
       "choice_c":"Proper DNS resolution",
       "choice_d":"The cloud provider's requirements",
       "correct_answer":"A",
       "explanation":"Bandwidth is the primary decision factor for moving the Domain Name System (DNS) closer to the application in the public cloud. However, if the majority of DNS users are on premises, then it should remain on premises for bandwidth reasons. Response time should not increase, since DNS is a lightweight service for looking up resource records. DNS resolution should not be affected when migrating DNS to a public cloud. Although the cloud provider has certain requirements, DNS functionality is relatively the same."
    },
    {
       "id":1012,
       "topic_id":1,
       "sub_domain":"1.5 Compare TCP to UDP",
       "practice_test_id":2,
       "question":"Which protocol is connectionless and contains noflow control?",
       "choice_a":"IP",
       "choice_b":"TCP",
       "choice_c":"UDP",
       "choice_d":"ICMP",
       "correct_answer":"C",
       "explanation":"Flow control is synonymous with the Transport layer of the Open Systems Interconnection (OSI) model. User Datagram Protocol (UDP) operates at the Transport layer, but UDP does not provide flow control for communications. UDP provides a program with a connectionless method of transmitting segments. The Internet Protocol is logical addressing for the routing of information. Transmission Control Protocol (TCP) is a connection-based protocol and maintains a state throughout the transfer of data. The Internet Control Message Protocol (ICMP) is used as an error reporting tool for IP packets as well as a diagnostic protocol for determining path problems."
    },
    {
       "id":1013,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":2,
       "question":"You plug a laptop into a network jack. When you examine the IP address, you see 10.23.2.3, which was not originally configured when you checked prior to plugging it in. What can you conclude?",
       "choice_a":"The network jack is not working.",
       "choice_b":"Your laptop has a static IP address configured.",
       "choice_c":"The network is configured properly.",
       "choice_d":"The DHCP server is down.",
       "correct_answer":"C",
       "explanation":"The network seems to be configured properly. You have received a valid address in the Class A space of the RFC 1918 private address range. The network jack is obviously working because you have been assigned an IP address. The network is configured properly, and no evidence exists to determine it is not configured properly. The DHCP server is obviously working because it assigned you an IP address where there was noprior IP address."
    },
    {
       "id":1014,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":2,
       "question":"Which network does the IP address 192.168.4.38/27 belong to?",
       "choice_a":"192.168.4.8/27 network",
       "choice_b":"192.168.4.16/27 network",
       "choice_c":"192.168.4.32/27 network",
       "choice_d":"192.168.4.64/27 network",
       "correct_answer":"C",
       "explanation":"The network 192.168.4.32/27 has a valid IP address range of 192.168.4.33 to 192.168.4.62. The /27 CIDR notation, or 255.255.255.224 dotted-decimal notation (DDN), defines networks in multiples of 32. Therefore, the address 192.168.4.28/27 is part of the 192.168.4.32/27 network. All of the other options are incorrect."
    },
    {
       "id":1015,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":2,
       "question":"What are stateless DHCPv6 servers used for?",
       "choice_a":"Configuring the default gateway",
       "choice_b":"Configuring the IPv6 address",
       "choice_c":"Configuring the IPv6 prefix length",
       "choice_d":"Configuring the DNS server address",
       "correct_answer":"D",
       "explanation":"Stateless DHCPv6 servers are used to configure DHCP options only. The one option that all clients need is the DNS server. The default gateway and the IPv6 address are configured via the Router Solicitation (RS) and Router Advertisement (RA) packets, when a client starts up in the network. The IPv6 prefix length is fixed to a 64-bit prefix."
    },
    {
       "id":1016,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":2,
       "question":"Which mechanism in IPv6 allows for SLAAC to avoid duplicating an IPv6 address?",
       "choice_a":"NDP (NS/NA)",
       "choice_b":"DAD (NS/NA)",
       "choice_c":"SLAAC (RS/RA)",
       "choice_d":"ARPv6(NS/NA)",
       "correct_answer":"B",
       "explanation":"Duplicate Address Detection, or DAD, uses Neighbor Solicitation and Neighbor Advertisement messages to avoid duplicate addresses when SLAAC is being used.Neighbor Discovery Protocol (NDP) is a protocol that is used to discover neighboring devices in an IPv6 network for layer 2 addressing. Stateless Address Autoconfiguration (SLAAC) is an IPv6 method used to assign the 64-bit network ID to a host. ARPv6 is not a valid protocol; the Address Resolution Protocol (ARP) in IPv4 has been replaced with NDP in IPv6."
    },
    {
       "id":1017,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":2,
       "question":"Which term best describes the IPv6 address of 2202:0ff8:0002:2344:3533:8eff:fe22:ae4c?",
       "choice_a":"Multicast address",
       "choice_b":"EUI-64 address",
       "choice_c":"Anycast address",
       "choice_d":"Link-local address",
       "correct_answer":"B",
       "explanation":"The IPv6 address 2202:0ff8:0002:2344:3533:8eff:fe22:ae4c is an EUI-64 generated address. The host portion of the address is 3533:8eff:fe22:ae4c, the fffe in the middle of it depicts that the address was generated from the MAC address. The MAC address of this host would be 37-33-8e-02-ae-4c. When EUI-64 is used, an ffee is placed in the middle of the MAC address, and then the 7th bit from the left is flipped. This changes the first two hex digits of the MAC address from 35 to 37. Multicast addresses will always start with ff00. Anycast addresses are not visibly different because they are normal addresses with special regional routing statements that direct communications to the closest server. Link-local addresses will always start with fe80."
    },
    {
       "id":1018,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":2,
       "question":"If a switch uses the store and forward method of switching and receives a frame in which its CRC is invalid, what will happen?",
       "choice_a":"The switch will re-create the frame with a new CRC and correct the missing information.",
       "choice_b":"The switch will drop the frame and wait for retransmission of a new frame.",
       "choice_c":"The switch will send back a frame for retransmission of the frame.",
       "choice_d":"The switch will store the frame until a new frame with a matching CRC is received.",
       "correct_answer":"B",
       "explanation":"The store and forward method of switching allows the switch to receive the entire frame and calculate the CRC against the data contained in the frame. If the CRC does not match, the frame is dropped, and the sending node must retransmit after an expiry timer or upper-protocol timer times out. Switches cannot perform error correction from the CRC calculation; they can only detect that there are errors and discard the frame. Switches will never send a frame back; they will discard the frame and wait for retransmission from upper layer protocols. Switches do not store frames for longer than it would take for aforward filter decision to be made."
    },
    {
       "id":1019,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":2,
       "question":"What is the issue with the network in the following exhibit?<img src='/question_assets/ccna/7_image1.png'></img>",
       "choice_a":"STP is not configured and a broadcast storm is occurring.",
       "choice_b":"MAC table thrashing has occurred.",
       "choice_c":"STP is not configured and duplication of unicast frames is occurring.",
       "choice_d":"An STP loop has occurred.",
       "correct_answer":"A",
       "explanation":"In the exhibit, a broadcast storm is occurring due to improper configuration of Spanning Tree Protocol (STP) for loop avoidance. MAC table thrashing could occur due to the loop in the exhibit; however, the exhibit does not show evidence to prove MAC table thrashing is occurring. Although STP is not configured, duplication of unicast frames is not evident in the exhibit. STP is a loop avoidance mechanism; it will not propagate loops."
    },
    {
       "id":1020,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":2,
       "question":"Which command will show the number of entries in a MAC address table?",
       "choice_a":"<code>Switch#show mac address-table</code>",
       "choice_b":"<code>Switch#show mac address-table count</code>",
       "choice_c":"<code>Switch#show mac count</code>",
       "choice_d":"<code>Switch#show cam count</code>",
       "correct_answer":"B",
       "explanation":"The command to show the current MAC address entry count in the MAC address table is <code>show mac address-table count</code>. This command will also show the maximum number of entries the table can hold. The command <code>show mac address-table</code> is incorrect as it will show the contents of the MAC address table in the switch. The command <code>show mac count</code> is incorrect. The command <code>show cam count</code> is incorrect."
    },
    {
       "id":1021,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":2,
       "question":"When a switch receives a frame, what does it use to make a forwarding decision?",
       "choice_a":"Destination MAC address in the frame",
       "choice_b":"Source MAC address in the frame",
       "choice_c":"Source IP address in the frame",
       "choice_d":"Destination IP address in the frame",
       "correct_answer":"A",
       "explanation":"Forward filter decisions are made upon the destination MAC address in the frame. The source MAC address is used for MAC address learning to build the forward/filter table. The source and destination IP address in the frame is no concern of the switch. Only a router would decapsulate the frame further to make routing decisions upon the destination IP address."
    },
    {
       "id":1022,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":2,
       "question":"From the following exhibit, what can you conclude about the computer with the MAC address of 0002.160a.4c37?<img src='/question_assets/ccna/7_image2.png'></img>",
       "choice_a":"The computer is the only device on port Gi0/1.",
       "choice_b":"The computer is on a hub connected to port Gi0/1.",
       "choice_c":"The computer is connected to another switch.",
       "choice_d":"The computer's MAC address has aged out of the table.",
       "correct_answer":"C",
       "explanation":"The computer is on another switch connected via a trunk link since there are multiple VLANs on the interface of Gi0/1. This is also evidence that the computer is not the only device on port Gi0/1. It cannot be concluded that the computer is on a hub connected to port Gi0/1. The computer's MAC address has not aged out of the table yet because it can still be seen in the exhibit."
    },
    {
       "id":1023,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":2,
       "question":"Which type of switchport strips all VLAN information from the frame before it egresses the interface on the switch?",
       "choice_a":"Trunk port",
       "choice_b":"Access port",
       "choice_c":"Voice port",
       "choice_d":"DTP port",
       "correct_answer":"B",
       "explanation":"Access ports strip all VLAN information before the frame egresses the destination interface. The endpoint on an access switchport will never see any of the VLAN information that was associated with the frame. A trunk port will carry the frame along with the VLAN information until it gets to the other side of the trunk link. Voice ports also carry the frame along with VLAN tagging information. A Dynamic Trunking Protocol (DTP) port will form a trunk port to another switch; therefore, it is a trunking protocol, not a switchport type."
    },
    {
       "id":1024,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":2,
       "question":"Which is a correct statement about the output in the following exhibit?<img src='/question_assets/ccna/7_image3.png'></img>",
       "choice_a":"The default native VLAN has been changed.",
       "choice_b":"The encapsulation has been negotiated.",
       "choice_c":"The switch is sending DTP frames.",
       "choice_d":"The adjacent switch is also set to auto for DTP.",
       "correct_answer":"B",
       "explanation":"The switch has negotiated with the adjacent switch to become a trunk and set its trunking protocol to 802.1Q. The letter n in front of 802.1Q specifies it was negotiated. When a switch is set to auto for the Dynamic Trunking Protocol (DTP), it will respond to trunking requests but will not initiate DTP messages. The adjacent switch must be set to desirable since the desirable mode will send DTP messages. The native VLAN does not show it has been changed, since VLAN 1 is the default native VLAN as it is configured in the exhibit. The exhibit does not show evidence that the switch is sending DTP frames. Evidence also does not exist in the exhibit to support the theory that the adjacent switch is also set for auto DTP."
    },
    {
       "id":1025,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":2,
       "question":"You have a switch with several hundred interfaces. You only want to see the running-config for one interface, Gi3/45. Which command will allow you to see the running-config for only Gi3/45?",
       "choice_a":"<code>Switch#show interface gi 3/45</code>",
       "choice_b":"<code>Switch#show running-config | include 3/45</code>",
       "choice_c":"<code>Switch#show running-config interface gi 3/45</code>",
       "choice_d":"<code>Switch#show running gi 3/45</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show running-config interface gi 3/45</code> will show the running-configuration for only interface Gi3/45. The command <code>show interface gi 3/45</code> is incorrect as it will display the interface details for Gi3/45 and not the configuration. The command <code>show running-config | include 3/45</code> is incorrect as it will only display lines matching 3/45. The command <code>show running gi 3/45</code> is incorrect."
    },
    {
       "id":1026,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":2,
       "question":"Which command will display the serial number of the switch?",
       "choice_a":"<code>Switch#show version</code>",
       "choice_b":"<code>Switch#show serial</code>",
       "choice_c":"<code>Switch#show board</code>",
       "choice_d":"<code>Switch#show controller</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show version</code> will display the serial number of the switch or router. This is usually required when calling into support to open a support ticket. The command <code>show serial</code> is incorrect. The command <code>show board</code> is incorrect. The command <code>show controller</code> is incorrect."
    },
    {
       "id":1027,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":2,
       "question":"You have a rather large configuration on a switch. You want to see the running-config, but only after port gi4/45. Which command will achieve this?",
       "choice_a":"<code>Switch#show running-config begin 4/45</code>",
       "choice_b":"<code>Switch#show filter running-config 4/45</code>",
       "choice_c":"<code>Switch#show running-config interface gi 4/45</code>",
       "choice_d":"<code>Switch#show running-config | begin 4/45</code>",
       "correct_answer":"D",
       "explanation":"The command <code>show running-config | begin 4/45</code> will show the running-config and begin when the text <italic>4/45</italic> is found. It is important to note that after the <code>| begin</code>, everything is case sensitive. The command <code>show running-config begin 4/45</code> is incorrect. The command <code>show filter running-config 4/45</code> is incorrect. The command <code>show running-config interface gi 4/45</code> is incorrect as it will only display the running-config for interface Gi4/45."
    },
    {
       "id":1028,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":2,
       "question":"You have neighboring equipment on the switch that is running LLDP. Which command(s) will allow you to see the neighboring equipment's management IP addresses?",
       "choice_a":"<code>Switch(config)#enable lldp</code><br></br><code>Switch(config)#exit</code><br></br><code>Switch#showlldp neighbors detail</code>",
       "choice_b":"<code>Switch(config)#lldp run</code><br></br><code>Switch(config)#exit</code><br></br><code>Switch#showlldp neighbors detail</code>",
       "choice_c":"<code>Switch#showlldp neighbors detail</code>",
       "choice_d":"<code>Switch(config)#enable lldp</code><br></br><code>Switch(config)#exit</code><br></br><code>Switch#showlldp neighbors *</code>",
       "correct_answer":"B",
       "explanation":"By default, Cisco devices do not participate in Link Layer Discovery Protocol (LLDP). The first command that needs to be configured is <code>lldp run</code>, which starts the switch participating in LLDP. You then need to enter the command <code>show lldp neighbors detail</code> in the privileged exec mode prompt, by exiting global configuration mode. This command will show all of the neighboring LLDP devices. The command <code>enable lldp</code> is incorrect and will not enable LLDP. Because LLDP is not enabled by default, the command <code>show lldp neighbors detail</code> by itself will not display anything."
    },
    {
       "id":1029,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":2,
       "question":"You are mapping a network with the use of CDP. On the entry of cs-main.ntw, what is the connection of Gig 0/1 used for in the following exhibit?<img src='/question_assets/ccna/7_image4.png'></img>",
       "choice_a":"The Gig 0/1 interface on es-switch2",
       "choice_b":"The Gig 0/1 interface on cs-main.ntw",
       "choice_c":"The Gig 0/1 interface on es-layer2.ntw",
       "choice_d":"The Gig 0/1 interface on es-switch3.ntw",
       "correct_answer":"A",
       "explanation":"The interface Gig 0/1 is used for the interface of es-switch2, which connects cs-main.ntw via its interface of Gig 0/40. The Gig 0/1 interfaces on cs-main.ntw, es-layer2.ntw, and es-switch3.ntw are not depicted in the exhibit because we are examining the Cisco Discovery Protocol (CDP) on es-switch2."
    },
    {
       "id":1030,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":2,
       "question":"You check the status of the EtherChannel configured on the switch with the <code>show etherchannel</code> command. What can be concluded from the output? Refer to the exhibit below.<img src='/question_assets/ccna/7_image5.png'></img>",
       "choice_a":"The EtherChannel is configured with PAgP.",
       "choice_b":"The EtherChannel is configured with LACP.",
       "choice_c":"The EtherChannel is configured with no control protocol.",
       "choice_d":"The EtherChannel is configured as an access port.",
       "correct_answer":"C",
       "explanation":"The EtherChannel has been configured with no control protocol, which is a result of configuring each side of the EtherChannel with the command <code>channel-group 1 mode on</code>. The exhibit shows no evidence that the EtherChannel is configured with either Port Aggregation Protocol (PAgP) or Link Aggregation Control Protocol (LACP). The exhibit also shows no evidence that the EtherChannel is configured as an access port."
    },
    {
       "id":1031,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":2,
       "question":"You are configuring an EtherChannel between two switches. You check your configuration on the first switch and are ready to configure the second switch. What mode do you need to configure on the other switch? Refer to the following exhibit.<img src='/question_assets/ccna/7_image6.png'></img>",
       "choice_a":"<code>Switch(config-if)#channel-group 1 mode auto</code>",
       "choice_b":"<code>Switch(config-if)#channel-group 1 mode desirable</code>",
       "choice_c":"<code>Switch(config-if)#channel-group 1 mode active</code>",
       "choice_d":"<code>Switch(config-if)#channel-group 1 mode passive</code>",
       "correct_answer":"B",
       "explanation":"Since the auto mode was used on the first switch (Switch A), desirable should be used on the second switch to assure forming of an EtherChannel by using the command <code>channel-group 1 mode desirable</code>. If both sides are set to auto with the command <code>channel-group 1 mode auto</code>, then the EtherChannel will not be built. The commands <code>channel-group 1 mode active</code> and <code>channel-group 1 mode passive</code> are used for Link Aggregation Control Protocol (LACP) configuration."
    },
    {
       "id":1032,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":2,
       "question":"You are configuring an EtherChannel between two switches for trunking. The EtherChannel will not form. You check your configuration on the first switch. What is the problem on the other switch? Refer to the following exhibit.<img src='/question_assets/ccna/7_image7.png'></img>",
       "choice_a":"The other switch is configured as an access link.",
       "choice_b":"The other switch has CDP turned off.",
       "choice_c":"The other switch is configured for active mode.",
       "choice_d":"The other switch is configured for passive mode.",
       "correct_answer":"D",
       "explanation":"If the other switch is set to passive mode, an EtherChannel will not form. The recommended mode for the other side is active mode. The exhibit also shows no evidence that the EtherChannel is configured as an access port. The Cisco Discovery Protocol (CDP) has no effect on an EtherChannel. The EtherChannel has been configured for Link Aggregation Control Protocol (LACP), noted by the <code>channel-group 1 mode passive</code> command."
    },
    {
       "id":1033,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":2,
       "question":"In the following exhibit, Rapid Spanning Tree Protocol (RSTP) is configured. Which interfaces will become the root ports?<img src='/question_assets/ccna/7_image8.png'></img>",
       "choice_a":"Switch B interface Fa1/5 and Gi1/12",
       "choice_b":"Switch A interface Gi1/8 and Switch D interface Fa2/16",
       "choice_c":"Switch A interface Gi1/8, Switch D interface Fa2/16, and Switch C interface Gi1/3",
       "choice_d":"Switch A interface Gi1/2 and Switch D interface Gi1/8",
       "correct_answer":"C",
       "explanation":"Switch B has the lowest MAC address of all of the switches. Therefore, Switch B will become the RSTP root bridge. All ports leading back to Switch B will become the root ports. Switch A interface Gi1/8, Switch D interface Fa2/16, and Switch C interface Gi1/3 will become root ports. All of the other options are incorrect."
    },
    {
       "id":1034,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":2,
       "question":"When you're using 802.1w, which switchport state will always forward traffic?",
       "choice_a":"Disabled",
       "choice_b":"Backup",
       "choice_c":"Designated",
       "choice_d":"Alternate",
       "correct_answer":"C",
       "explanation":"The 802.1w Rapid Spanning Tree Protocol (RSTP) defines that designated switchports always forward traffic. The designated port is a port that is forwarding traffic and is opposite of the root port or blocking port if it is a redundant link. A disabled switchport does not participate in RSTP or the forwarding of traffic. A backup port is a redundant port on the same switch and segment that is placed in a blocking mode in the event the forwarding port is unable to forward traffic. An alternate port is a redundant port on the same segment, but different switches. The alternate port is placed in a blocking mode, and in the event the forwarding port is unable to forward traffic, the alternate port will forward traffic."
    },
    {
       "id":1035,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":2,
       "question":"You want to quickly configure an edge switch so all access ports are in PortFast mode. Which command will achieve this?",
       "choice_a":"<code>SwitchA(config)#spanning-tree portfast default</code>",
       "choice_b":"<code>SwitchA(config)#switchport spanning-tree portfast</code>",
       "choice_c":"<code>SwitchA(config)#spanning-tree portfast enable</code>",
       "choice_d":"<code>SwitchA(config)#spanning-tree portfast</code>",
       "correct_answer":"A",
       "explanation":"The command <code>spanning-tree portfast default</code> will configure all access ports on the switch as PortFast enabled. The command <code>switchport spanning-tree portfast</code> is incorrect. The command <code>spanning-tree portfast enable</code> is incorrect. The command <code>spanning-tree portfast</code> is incorrect."
    },
    {
       "id":1036,
       "topic_id":2,
       "sub_domain":"2.6 Compare Cisco Wireless Architectures and AP modes",
       "practice_test_id":2,
       "question":"Which AP mode allows for RF analysis of the 802.11ac radio spectrum?",
       "choice_a":"Monitor mode",
       "choice_b":"Analysis mode",
       "choice_c":"FlexConnect mode",
       "choice_d":"Local mode",
       "correct_answer":"A",
       "explanation":"Monitor mode can be used for analysis of the radio spectrum. Analysis mode is not a real mode; therefore it is an incorrect answer. FlexConnect mode is a switching mode on the wireless access point in which traffic is switched directly to the intended destination. Local mode is a switching mode on the wireless access point in which all traffic is directed to the wireless controller before being switched to the intended destination."
    },
    {
       "id":1037,
       "topic_id":2,
       "sub_domain":"2.6 Compare Cisco Wireless Architectures and AP modes",
       "practice_test_id":2,
       "question":"You have a small area in a warehouse in which you need wired connectivity to the network. However, wiring cannot be run easily, but there is a direct line of sight for wireless. Which AP feature can be used to connect the area?",
       "choice_a":"Wireless mesh",
       "choice_b":"LightWeight mode",
       "choice_c":"Local mode",
       "choice_d":"WorkGroup Bridge",
       "correct_answer":"D",
       "explanation":"Work Group Bridge mode allows you to connect an AP to another AP via an SSID. The Ethernet connection is then bridged over to allow other wired connections to share the wireless bridge. A wireless mesh is used for wireless coverage where wired APs cannot be installed. LightWeight mode is a wireless AP mode in which the wireless LAN controller controls the AP. Local mode is a switching mode on the wireless access point in which all traffic is directed to the wireless controller before being switched to the intended destination."
    },
    {
       "id":1038,
       "topic_id":2,
       "sub_domain":"2.7 Describe physical infrastructure connections of WLAN components (AP, WLC, access/trunk ports, and LAG)",
       "practice_test_id":2,
       "question":"You need to configure a LAG for a Cisco wireless controller. What should be configured on the EtherChannel to establish a link?",
       "choice_a":"Auto mode",
       "choice_b":"On mode",
       "choice_c":"Desirable mode",
       "choice_d":"Passive mode",
       "correct_answer":"B",
       "explanation":"When an EtherChannel is configured to an \u0022on mode,\u0022 it means that no negotiation protocol will be used to build the EtherChannel. If the mode of auto or desirable is configured on the EtherChannel interfaces, then the EtherChannel will participate in Port Aggregation Protocol (PAgP).If the mode of passive is configured on the EtherChannel interfaces, then the EtherChannel will participate in Link Aggregation Control Protocol (LACP)."
    },
    {
       "id":1039,
       "topic_id":2,
       "sub_domain":"2.8 Describe AP and WLC management access connections (Telnet, SSH, HTTP, HTTPS, console, and TACACS+/RADIUS)",
       "practice_test_id":2,
       "question":"Which is a benefit of using TACACS+ for authentication of users?",
       "choice_a":"It is an open standard.",
       "choice_b":"It sends the passwords of users in clear text.",
       "choice_c":"It supports authenticating a user to a subset of commands.",
       "choice_d":"It supports authenticating a user to a length of time.",
       "correct_answer":"C",
       "explanation":"TACACS+ is a Cisco-defined protocol. One of the useful features it has is that it can authenticate a user and only allow that user to access certain commands on the router or switch. The TACACS+ protocol is not an open standard. The TACACS+ protocol encrypts the passwords for the user but does not support authenticating a user for a specific length of time."
    },
    {
       "id":1040,
       "topic_id":2,
       "sub_domain":"2.8 Describe AP and WLC management access connections (Telnet, SSH, HTTP, HTTPS, console, and TACACS+/RADIUS)",
       "practice_test_id":2,
       "question":"Why should you always provide a second method of local when setting up AAA remote authentication with a router or switch?",
       "choice_a":"To allow for a backdoor.",
       "choice_b":"To provide a backup if the TACACS+ server is down or unreachable.",
       "choice_c":"The local second method is required.",
       "choice_d":"All of the above.",
       "correct_answer":"B",
       "explanation":"The local second method should always be configured. This will ensure that if the router's connection to the AAA server is down, you can still gain access to diagnose or repair.If properly secured, a second method of local authentication does not create a backdoor because it creates a backup of authentication. The local second method is not required, but it is a good idea so that you can login during outages of the AAA server."
    },
    {
       "id":1041,
       "topic_id":2,
       "sub_domain":"2.9 Configure the components of a wireless LAN access for client connectivity using GUI only such as WLAN creation, security settings, QoS profiles, and advanced WLAN settings",
       "practice_test_id":2,
       "question":"You want all guests to register for wireless Internet access before granting them access. What should you implement?",
       "choice_a":"Captive portal",
       "choice_b":"AAA server",
       "choice_c":"ESS",
       "choice_d":"RRM",
       "correct_answer":"A",
       "explanation":"A captive portal will allow you to require all guests to register for wireless Internet access before granting them access. When they connect to the Service Set Identifier (SSID), they will be presented with the captive portal web page. An AAA server is required if you have a list of already established users and want to authenticate them via the AAA server. Extended service set (ESS) is two or more access points covering a common SSID or serving multiple SSIDs. Radio resource management (RRM) is a service on the wireless LAN controller (WLC) that adjusts the radio output and channels used by an ESS."
    },
    {
       "id":1042,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":2,
       "question":"When an IP address is configured on the router's interface, what happens in the routing table?",
       "choice_a":"A route entry is created for the network attached to the IP address on the interface.",
       "choice_b":"A route entry is created for the IP address attached to the interface.",
       "choice_c":"Dynamic routing protocols update all other routers.",
       "choice_d":"All of the above.",
       "correct_answer":"D",
       "explanation":"When an IP address is configured on a router's interface, the network is automatically put into the routing table. The IP address is also added to the routing table. When the routing table changes, this normally tells the routing protocol it should perform an update."
    },
    {
       "id":1043,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":2,
       "question":"In the following exhibit, which interface or IP address will a packet be routed to for a destination address of 192.168.4.56?<img src='/question_assets/ccna/7_image9.png'></img>",
       "choice_a":"Interface Serial 0/0/1",
       "choice_b":"Interface Serial 0/0/0",
       "choice_c":"IP gateway of 192.168.4.1",
       "choice_d":"Interface Serial 0/2/0",
       "correct_answer":"A",
       "explanation":"In the routing table there is a static route for 192.168.4.0/24 via Serial 0/0/1. Interface Serial 0/0/0 has a route of 172.16.0.0/16 configured. The IP gateway of 192.168.4.1 does not appear in the exhibit. Interface Serial 0/2/0 has a route of 10.0.0.0/8 configured."
    },
    {
       "id":1044,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":2,
       "question":"In the following exhibit, which interface or IP address will the packet with a destination of 198.23.34.2 be routed to?<img src='/question_assets/ccna/7_image10.png'></img>",
       "choice_a":"Interface Serial 0/1/1",
       "choice_b":"Interface Serial 0/0/1",
       "choice_c":"Interface Serial 0/2/0",
       "choice_d":"There is no suitable route.",
       "correct_answer":"C",
       "explanation":"The route will exit the Serial 0/2/0 interface, since the gateway of last resort is set to Serial 0/2/0. This statement is identified by the <code>S* 0.0.0.0/0</code> entry. Interface Serial 0/1/1 has a route of 198.23.24.0/24 configured. Interface Serial 0/0/1 has a route of 192.168.1.0/24 configured. Because there is a gateway of last resort configured, any route not specifically in the route table will follow the gateway of last resort."
    },
    {
       "id":1045,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":2,
       "question":"What is the administrative distance of OSPF?",
       "choice_a":90,
       "choice_b":100,
       "choice_c":110,
       "choice_d":120,
       "correct_answer":"C",
       "explanation":"The administrative distance of Open Shortest Path First (OSPF) is 110. The administrative distance of Internal Enhanced Interior Gateway Routing Protocol (EIGRP) is 90. The administrative distance of the legacy routing protocol of Interior Gateway Routing Protocol (IGRP) is 100. The administrative distance of Routing Information Protocol (RIP) is 120."
    },
    {
       "id":1046,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":2,
       "question":"Which command will allow you to see the next advertisement interval for RIPv2?",
       "choice_a":"<code>Router#show ip protocols</code>",
       "choice_b":"<code>Router#show ip rip database</code>",
       "choice_c":"<code>Router#show ip rip</code>",
       "choice_d":"<code>Router#show ip interface</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show ip protocols</code> will display the next interval when RIPv2 advertisements are sent out. The command <code>show ip rip database</code> is incorrect. The command <code>show ip rip</code> is incorrect. The command <code>show ip interface</code> is incorrect."
    },
    {
       "id":1047,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":2,
       "question":"Which command will allow you to inspect RIPv2 advertisements?",
       "choice_a":"<code>Router#show ip protocols</code>",
       "choice_b":"<code>Router#debug rip</code>",
       "choice_c":"<code>Router#show ip rip</code>",
       "choice_d":"<code>Router#debug ip rip</code>",
       "correct_answer":"D",
       "explanation":"The command <code>debug ip rip</code> will allow you to see advertisements in real time. The command <code>show ip protocols</code> is incorrect. The command <code>debug rip</code> is incorrect. The command <code>show ip rip</code> is incorrect."
    },
    {
       "id":1048,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":2,
       "question":"You need to advertise the routes 192.168.1.0/24, 192.168.2.0/24, and 192.168.3.0/24.Assuming RIPv2 is configured,which configuration will achieve this?",
       "choice_a":"<code>Router(config-router)#network 192.168.0.0</code>",
       "choice_b":"<code>Router(config-router)#network 192.168.1.0</code><br></br><code>Router(config-router)#network 192.168.2.0</code><br></br><code>Router(config-router)#network 192.168.3.0</code>",
       "choice_c":"<code>Router(config-router)#network 192.168.0.0/16</code>",
       "choice_d":"<code>Router(config-router)#network 192.168.0.0 0.0.255.255</code>",
       "correct_answer":"B",
       "explanation":"The three Class C networks need to be advertised separately. RIPv2 uses the default class network mask when configuring networks. The command <code>network 192.168.0.0</code> is incorrect as it will not advertise the individual networks of 192.168.1.0, 192.168.2.0, and 192.168.3.0. The command <code>network 192.168.0.0/16</code> is incorrect. The command <code>network 192.168.0.0 0.0.255.255</code> is incorrect."
    },
    {
       "id":1049,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":2,
       "question":"You have RIPv2 configured on an Internet-facing router. Which command will suppress RIPv2 advertisements on the interface link?",
       "choice_a":"<code>Router(config-if)#ip rip passive-interface</code>",
       "choice_b":"<code>Router(config-if)#rip passive-interface</code>",
       "choice_c":"<code>Router(config-router)#passive-interface serial 0/0</code>",
       "choice_d":"<code>Router(config-if)#ip rip suppress-advertisement</code>",
       "correct_answer":"C",
       "explanation":"The command <code>passive-interface serial 0/0</code> configured in the router instance will suppress updates from exiting interface Serial 0/0. The command <code>ip rip passive-interface</code> is incorrect. The command <code>rip passive-interface</code> is incorrect. The command <code>ip rip suppress-advertisement</code> is incorrect."
    },
    {
       "id":1050,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":2,
       "question":"Which is a problem with using RIPv2 in a network?",
       "choice_a":"Complex configuration",
       "choice_b":"Slow convergence",
       "choice_c":"The use of broadcasts",
       "choice_d":"Routing support for classless networks",
       "correct_answer":"B",
       "explanation":"RIPv2 has extremely slow convergence time. This is because the advertisement of routes is every 30 seconds. So a router four hops away potentially could take 120 seconds before discovering the route. Configuration for RIPv2 is rather simple compared to other protocols, such as Open Shortest Path First (OSPF). RIPv2 uses multicasts to send the complete route table to other participating routers; RIPv1 uses broadcasts. The RIPv2 protocol supports classless networks; RIPv1 does not support classless networks."
    },
    {
       "id":1051,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":2,
       "question":"Which technique is used to stop routing loops with RIPv2?",
       "choice_a":"Split horizons",
       "choice_b":"Advertisement intervals",
       "choice_c":"Zoning",
       "choice_d":"Invalid timers",
       "correct_answer":"A",
       "explanation":"Split horizons are used to stop routing loops with RIPv2. Split horizons prevent a router from advertising a route to a router in which the original route was discovered. Advertisement intervals can be adjusted to allow RIPv2 to converge faster. Zoning is not a design concept for RIP; therefore, it is an invalid answer. The invalid timers can be adjusted for faster convergence as well."
    },
    {
       "id":1052,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":2,
       "question":"Which algorithm does RIPv2 use to calculate routes?",
       "choice_a":"Shortest Path First",
       "choice_b":"Dijkstra",
       "choice_c":"Bellman-Ford",
       "choice_d":"DUAL",
       "correct_answer":"C",
       "explanation":"RIPv2 uses the Bellman-Ford algorithm to calculate its metrics. The Open Shortest Path First (OSPF) protocol uses the Shortest Path First algorithm, which is also called the Dijkstra algorithm. Diffusing Update Algorithm (DUAL) is used by Enhanced Interior Gateway Routing Protocol (EIGRP)."
    },
    {
       "id":1053,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":2,
       "question":"Which command will need to be configured for support of discontinuous networks?",
       "choice_a":"<code>Router(config-router)#network discontiguous</code>",
       "choice_b":"<code>Router(config)#network discontiguous</code>",
       "choice_c":"<code>Router(config)#no auto-summary</code>",
       "choice_d":"<code>Router(config-router)#no auto-summary</code>",
       "correct_answer":"D",
       "explanation":"The command <code>no auto-summary</code> will stop the router process of RIPv2 from auto-summarizing network addresses. In a discontiguous network, this is problematic and should be turned off. The command <code>network discontiguous</code> is incorrect, regardless of which prompt it is configured in. The command <code>no auto-summary</code> is incorrect when configured from the global configuration prompt."
    },
    {
       "id":1054,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":2,
       "question":"Which command configures RIPv2 on a router and advertises a network of 192.168.20.0/24?",
       "choice_a":"<code>Router(config)#ip router ripv2</code><br></br><code>Router(config-router)#network 192.168.20.0</code>",
       "choice_b":"<code>Router(config)#router rip</code><br></br><code>Router(config-router)#version 2</code><br></br><code>Router(config-router)#network 192.168.20.0</code>",
       "choice_c":"<code>Router(config)#router rip</code><br></br><code>Router(config-router)#version 2</code><br></br><code>Router(config-router)#network 192.168.20.0 0.0.0.255</code>",
       "choice_d":"<code>Router(config)#ip router rip</code><br></br><code>Router(config-router)#version 2</code><br></br><code>Router(config-router)#network 192.168.20.0 0.0.0.255</code>",
       "correct_answer":"B",
       "explanation":"Configuring RIPv2 begins with configuration of the router instance of RIP via the command <code>router rip</code>. RIPv2 is configured inside of the router instance with the command <code>version 2</code>. Then the network of 192.168.20.0/24 is advertised with the command <code>network 192.168.20.0</code>. All of the other options are incorrect."
    },
    {
       "id":1055,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":2,
       "question":"Which routing technique is best suited for small networks in which the administrator wants control of routing?",
       "choice_a":"OSPF routing",
       "choice_b":"EIGRP routing",
       "choice_c":"Static routing",
       "choice_d":"RIP routing",
       "correct_answer":"C",
       "explanation":"Static routing is best suited for small networks in which there is not a lot of change. It should be chosen when administrators want absolute control over the routing process. Open Shortest Path First (OSPF) is suited for large-scale networks because of its scalability. The Enhanced Interior Gateway Routing Protocol (EIGRP) is also a relatively scalable dynamic routing protocol. The Routing Information Protocol (RIP) is well suited for medium-sized networks to smaller networks, where administrators do not want to control routing."
    },
    {
       "id":1056,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":2,
       "question":"Which command will allow you to verify the IPv6 addresses configured on a router?",
       "choice_a":"<code>Router#show ipv6</code>",
       "choice_b":"<code>Router#show ip interfaces brief</code>",
       "choice_c":"<code>Router#show ipv6 interfaces brief</code>",
       "choice_d":"<code>Router#show ipv6 brief</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show ipv6 interfaces brief</code> will show all of the IPv6 addresses configured for each of the interfaces on the router. The command <code>show ipv6</code> is incorrect. The command <code>show ip interfaces brief</code> is incorrect. The command <code>show ipv6 brief</code> is incorrect."
    },
    {
       "id":1057,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":2,
       "question":"Which command will show you the IPv6 routes in the routing table?",
       "choice_a":"<code>Router#show ipv6 route</code>",
       "choice_b":"<code>Router#show ip route</code>",
       "choice_c":"<code>Router#show ipv6 route summary</code>",
       "choice_d":"<code>Router#show ipv6 route brief</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show ipv6 route</code> will display only the entries in the routing table for IPv6. The command <code>show ip route</code> will only display the entries in the routing table for IPv4. The command <code>show ipv6 route summary</code> is incorrect. The command <code>show ipv6 route brief</code> is incorrect."
    },
    {
       "id":1058,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":2,
       "question":"In the following exhibit, which route statement will need to be added to the routers to allow routing between the networks?<img src='/question_assets/ccna/7_image11.png'></img>",
       "choice_a":"<code>RouterA(config)#ip route 2001:db8:1000/64 serial 0/3/0</code><br></br><code>RouterB(config)#ip route 2001:db8:2000/64 serial 0/3/0</code>",
       "choice_b":"<code>RouterA(config)#ip route 2001:db8:2000::/64 serial 0/3/0</code><br></br><code>RouterB(config)#ip route 2001:db8:1000::/64 serial 0/3/0</code>",
       "choice_c":"<code>RouterA(config)#ipv6 route 2001:db8:2000::/64 serial 0/3/0</code><br></br><code>RouterB(config)#ipv6 route 2001:db8:1000::/64 serial 0/3/0</code>",
       "choice_d":"<code>RouterA(config)#ipv6 route 2001:db8:2000::/64 2001:db8:1500::/64 eui-64</code><br></br><code>RouterB(config)#ipv6 route 2001:db8:1000::/64 2001:db8:1500::/64 eui-64</code>",
       "correct_answer":"C",
       "explanation":"You will need two route statements, one on each router. Each route should point to the far side network through the serial interface. Since the IP address is an IPv6 address, the easier way to configure the routes is to direct the packets to the exit interface of Serial 0/3/0. All of the other options are incorrect because the commands specify either the wrong protocol or the wrong routes."
    },
    {
       "id":1059,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":2,
       "question":"Which command will only show you all of the directly connected routes for IPv6?",
       "choice_a":"<code>Router#show ipv6 interface summary</code>",
       "choice_b":"<code>Router#show ipv6 route connected</code>",
       "choice_c":"<code>Router#show ipv6 interface brief</code>",
       "choice_d":"<code>Router#show ipv6 summary</code>",
       "correct_answer":"B",
       "explanation":"The command <code>show ipv6 route connected</code> will display only the directly connected routes on the router. The command <code>show ipv6 interface summary</code> is incorrect. The command <code>show ipv6 interface brief</code> is incorrect. The command <code>show ipv6 summary</code> is incorrect."
    },
    {
       "id":1060,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":2,
       "question":"In the following exhibit, you need to configure Router B so that hosts on Network B can reach the Internet. Which statement on Router B will allow hosts to reach the Internet?<img src='/question_assets/ccna/7_image12.png'></img>",
       "choice_a":"<code>RouterB(config)#ipv6 route 0.0.0.0 0.0.0.0 serial 0/3/0</code>",
       "choice_b":"<code>RouterB(config)#ipv6 route 2002:ea34:4520:3412::/64 serial 0/3/0</code>",
       "choice_c":"<code>RouterB(config)#ipv6 route ::/0 serial 0/3/0</code>",
       "choice_d":"<code>RouterB(config)#ipv6 route ::/0 2001:db8:1500::/64 eui</code>",
       "correct_answer":"C",
       "explanation":"The route statement <code>ipv6 route ::/0 serial 0/3/0</code> will route any network that is unknown by Router B to Router A via the exit interface of Serial 0/3/0. The command <code>ipv6 route 0.0.0.0 0.0.0.0 serial 0/3/0</code> is incorrect because it mixes IPv4-style IP addresses and the <code>ipv6 route</code> command. The command <code>ipv6 route 2002:ea34:4520:3412::/64 serial 0/3/0</code> is incorrect. The command <code>ipv6 route ::/0 2001:db8:1500::/64 eui</code> is incorrect."
    },
    {
       "id":1061,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":2,
       "question":"In the following exhibit, which route statement will need to be added to the routers to allow routing between the networks?<img src='/question_assets/ccna/7_image13.png'></img>",
       "choice_a":"<code>RouterA(config)#ip route 2001:db8:4/64 ff80::ff:f200:2</code><br></br><code>RouterB(config)#ip route 2001:db8:400/64 ff80::ff:f200:1</code>",
       "choice_b":"<code>RouterA(config)#ip route 2001:db8:400::/64 serial 0/3/0</code><br></br><code>RouterB(config)#ip route 2001:db8:4::/64 serial 0/3/0</code>",
       "choice_c":"<code>RouterA(config)#ipv6 route 2001:db8:400::/64 serial 0/3/0</code><br></br><code>RouterB(config)#ipv6 route 2001:db8:4::/64 serial 0/3/0</code>",
       "choice_d":"<code>RouterA(config)#ipv6 route 2001:db8:4/64 ff80::ff:f200:2</code><br></br><code>RouterB(config)#ipv6 route 2001:db8:400/64 ff80::ff:f200:1</code>",
       "correct_answer":"D",
       "explanation":"You will need two route statements, one on each router. Each route points to the far side network through the gateway in the ff80::/64 network. Router A has a gateway of ff80::ff:f200:2/64 to the 2001:db8:4:/64 network, and Router B has a gateway of ff80::ff:f200:1/64 to the 2001:db8:400/64 network.All other answers are incorrect because the commands specify either the wrong protocol or the wrong routes."
    },
    {
       "id":1062,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":2,
       "question":"Which command will allow you to check basic connectivity at layer 3?",
       "choice_a":"<code>Router#show ip route</code>",
       "choice_b":"<code>Router#ping 192.168.4.1</code>",
       "choice_c":"<code>Router#pathping 192.168.4.1</code>",
       "choice_d":"<code>Router#ip ping 192.168.4.1</code>",
       "correct_answer":"B",
       "explanation":"The <code>ping</code> command will allow basic connectivity testing at layer 3. The command <code>show ip route</code> is incorrect. The command <code>pathping 192.168.4.1</code> is incorrect; the <code>pathping</code> command is only available on Windows operating systems. The command <code>ip ping 192.168.4.1</code> is incorrect; the <code>ip</code> command does not need to be specified."
    },
    {
       "id":1063,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":2,
       "question":"Which command will allow you to see the path on which a packet gets routed to its destination?",
       "choice_a":"<code>Router#show ip route</code>",
       "choice_b":"<code>Router#tracert 192.168.7.56</code>",
       "choice_c":"<code>Router#pathping 192.168.7.56</code>",
       "choice_d":"<code>Router#traceroute 192.168.7.56</code>",
       "correct_answer":"D",
       "explanation":"The command <code>traceroute</code> will allow you to verify the path on which a packet gets routed. The command <code>show ip route</code> is incorrect. The command <code>tracert 192.168.7.56</code> is incorrect; the <code>tracert</code> command is only available on Windows operating systems. The command <code>pathping 192.168.7.56</code> is incorrect; the <code>pathping</code> command is only available on Windows operating systems."
    },
    {
       "id":1064,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":2,
       "question":"In the following exhibit, Router A will not form an adjacency with Router B. What is the problem?<img src='/question_assets/ccna/7_image14.png'></img>",
       "choice_a":"The routers are not in the same network.",
       "choice_b":"The routers have mismatched process IDs.",
       "choice_c":"The routers have passive interfaces.",
       "choice_d":"The hello/dead interval is wrong for serial links.",
       "correct_answer":"C",
       "explanation":"Both routers have passive interfaces for OSPF. In order to fix this, the command <code>no passive-interface serial 0/0</code> would need to be entered. This command would need to be configured in the OSPF router process. The routers are within the same network with a common serial line connecting the routers. The process IDs do not matter and are locally significant to the routers. The hello/dead intervals for both routers match each other."
    },
    {
       "id":1065,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":2,
       "question":"Which command will allow you to see the networks the current router is advertising for OSPF?",
       "choice_a":"<code>Router#show ip protocols</code>",
       "choice_b":"<code>Router#show ip ospf</code>",
       "choice_c":"<code>Router#show ip ospf database</code>",
       "choice_d":"<code>Router#show ip ospf neighbors</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show ip protocols</code> will list the router ID of the current router as well as the networks that are being advertised via OSPF on the current router. The command <code>show ip ospf</code> is incorrect. The command <code>show ip ospf database</code> is incorrect. The command <code>show ip ospf neighbors</code> is incorrect."
    },
    {
       "id":1066,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":2,
       "question":"A client has an IP address of 192.168.1.5/24 and a default gateway of 192.168.1.1. HSRP is in use in the network. Which type of router is the default gateway?",
       "choice_a":"Active router",
       "choice_b":"Standby router",
       "choice_c":"Virtual router",
       "choice_d":"Support router",
       "correct_answer":"C",
       "explanation":"When Hot Standby Router Protocol (HSRP) is used, the default gateway the client is issued is an IP address for the virtual router. The virtual router is not a physical router, but it is mapped to a physical router via HSRP. The active router processes requests for the virtual router IP address by responding to the virtual MAC address associated with the virtual router IP address. The standby router only becomes active if the active router is no longer responding with hello packets for 10 seconds. Support routers are any routers used outside of HSRP to support routing of the network."
    },
    {
       "id":1067,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":2,
       "question":"Which of the following is an advantage to using Port Address Translation?",
       "choice_a":"Lower levels of jitter",
       "choice_b":"Lower levels of packet loss",
       "choice_c":"Flexibility of Internet connections",
       "choice_d":"Lower memory usage than other NAT types",
       "correct_answer":"C",
       "explanation":"The flexibility of Internet connections is usually a driving factor for PAT (NAT Overloading). Memory is significantly higher with PAT, since the source and destination port numbers must be recorded in the NAT table. There is no effect on packet loss, and jitter is marginally affected. Memory usage is actually higher than with other types of NAT because it must account for ports in the NAT table."
    },
    {
       "id":1068,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":2,
       "question":"Which command would you configure on the private network interface for NAT?",
       "choice_a":"<code>Router(config-if)#ip nat outside</code>",
       "choice_b":"<code>Router(config)#ip nat inside gi0/0</code>",
       "choice_c":"<code>Router(config-if)#ip nat private</code>",
       "choice_d":"<code>Router(config-if)#ip nat inside</code>",
       "correct_answer":"D",
       "explanation":"The command to configure the private side of the network interface for NAT is <code>ip nat inside</code>. This command is configured on the interface in which you want to define it as the \u0022inside\u0022 of your network. The configuration of the command <code>ip nat outside</code> is incorrect. The command <code>ip nat inside gi0/0</code> is incorrect. The command <code>ip nat private</code> is incorrect."
    },
    {
       "id":1069,
       "topic_id":4,
       "sub_domain":"4.2 Configure and verify NTP operating in a client and server mode",
       "practice_test_id":2,
       "question":"Why is time synchronization important for routers and switches?",
       "choice_a":"It is important for serialized communication frame alignment.",
       "choice_b":"It is important for quality of service queuing.",
       "choice_c":"It is important for logging accuracy.",
       "choice_d":"It helps delivery of packets via timed queues.",
       "correct_answer":"C",
       "explanation":"Time synchronization is important for logging accuracy. Serial communication frame alignment is timed via DCE clocking and packet queues are timed by how fast they can respond. The serialized communication for frame alignment comes from the DCE side of the link, which provides clocking signals. Time synchronization has no effect on quality of service queuingor the delivery of packets via timed queues."
    },
    {
       "id":1070,
       "topic_id":4,
       "sub_domain":"4.3 Explain the role of DHCP and DNS within the network",
       "practice_test_id":2,
       "question":"Which statement describes FQDNs?",
       "choice_a":"A DNS server always processes the entire FQDN.",
       "choice_b":"FQDNs are always registered with a registrar.",
       "choice_c":"FQDNs are significant from left to right, starting with a period for the root.",
       "choice_d":"FQDNs are significant from right to left, starting with a period for the root.",
       "correct_answer":"D",
       "explanation":"Fully qualified domain names (FQDNs) are significant from right to left, starting with a period to signify the root. The period is normally not visible on the FQDN, but it is processed as the root lookup. A DNS server will not always process the entire FQDN if there is a cached entry for the resource record requested. FQDNs are not always registered with a registrar because organizations used them for authentication and internal purposes. FQDNs are resolved from right to left starting with the root, not left to right."
    },
    {
       "id":1071,
       "topic_id":4,
       "sub_domain":"4.4 Explain the function of SNMP in network operations",
       "practice_test_id":2,
       "question":"Which protocol and port number does SNMP use for polling from the NMS?",
       "choice_a":"UDP/161",
       "choice_b":"TCP/162",
       "choice_c":"UDP/162",
       "choice_d":"UDP/514",
       "correct_answer":"A",
       "explanation":"Simple Network Management Protocol (SNMP) uses UDP port 161 for communication from an SNMP network management station to a network device for information requests. SNMP uses UDP and TCP port 162 for traps and not polling. Syslog uses UDP and TCP port 514 for sending log entries."
    },
    {
       "id":1072,
       "topic_id":4,
       "sub_domain":"4.5 Describe the use of syslog features including facilities and levels",
       "practice_test_id":2,
       "question":"Which command will allow you to verify the syslog server set for logging and the logging level set?",
       "choice_a":"<code>Router#show logging</code>",
       "choice_b":"<code>Router#show syslog</code>",
       "choice_c":"<code>Router#show log-server</code>",
       "choice_d":"<code>Router#show ip logging</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show logging</code> will display the configured syslog server and the current severity level for logs to be sent to the syslog server. The command <code>show syslog</code> is incorrect. The command <code>show log-server</code> is incorrect. The command <code>show ip logging</code> is incorrect."
    },
    {
       "id":1073,
       "topic_id":4,
       "sub_domain":"4.6 Configure and verify DHCP client and relay",
       "practice_test_id":2,
       "question":"Which command will allow you to verify the IP addresses assigned to a router's interface?",
       "choice_a":"<code>Router#show ip dhcp bindings</code>",
       "choice_b":"<code>Router#show ip interface</code>",
       "choice_c":"<code>Router#show ip lease</code>",
       "choice_d":"<code>Router#show ip dhcp lease</code>",
       "correct_answer":"B",
       "explanation":"The command <code>show ip interface</code> will display the IP addresses configured on the router's interfaces. It will detail which are static and which have been allocated through DHCP. The command <code>show ip dhcp bindings</code> is incorrect because it will show the internal table for the local DHCP server. The command <code>show ip lease</code> is incorrect. The command <code>show ip dhcp lease</code> is incorrect."
    },
    {
       "id":1074,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":2,
       "question":"Where should QoS marking be performed?",
       "choice_a":"Closest to the source of the traffic",
       "choice_b":"Closest to the Internet router",
       "choice_c":"On every device in the network",
       "choice_d":"On the core router in the network",
       "correct_answer":"A",
       "explanation":"QoS marking should always be performed closest to the source of the traffic. All switches and routers in the network should be configured to properly prioritize markings of traffic in queues. If it is performed closest to the Internet router, you may not get any effectiveness from the configuration because Internet routers may not process QoS. Not every device in the network needs QoS marking, such as infrastructure services like DHCP and DNS. QoS marking should also not be performed on the core router in the network; a good rule of thumb is don't implement anything on the core router that could slow it down. The act of QoS marking could slow the core router down; already marked packets are fine."
    },
    {
       "id":1075,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":2,
       "question":"Which is a correct statement about device trust boundary for QoS?",
       "choice_a":"The trust boundary should always be an asset IT controls.",
       "choice_b":"The switch should always be set as the trust boundary.",
       "choice_c":"Only routers can create trust boundaries.",
       "choice_d":"Only IP phones can become trust boundaries.",
       "correct_answer":"A",
       "explanation":"A malicious user can mark all of their traffic as high priority. Therefore, a trust boundary must be established by the network administrator. A common trust boundary device is the IP phone, but it is any device that the network administratorcontrols. If the switch is set as a trust boundary, a malicious user could plug in and start marking their packets with a higher than normal QoS. Routers are not the only devices that create trust boundaries, and IP phones are not the only devices that can become trust boundaries."
    },
    {
       "id":1076,
       "topic_id":4,
       "sub_domain":"4.8 Configure network devices for remote access using SSH",
       "practice_test_id":2,
       "question":"Which command needs to be configured to enable the SSH Copy Protocol (SCP)?",
       "choice_a":"<code>Switch(config)#ip ssh server enable</code>",
       "choice_b":"<code>Switch(config)#ip scp server enable</code>",
       "choice_c":"<code>Switch(config)#service scp enable</code>",
       "choice_d":"<code>Switch(config)#service scp-server</code>",
       "correct_answer":"B",
       "explanation":"The command <code>ip scp server enable</code> needs to be configured to enable the SSH Copy Protocol (SCP). This command is entered in the global configuration. The command <code>ip ssh server enable</code> is incorrect. The command <code>service scp enable</code> is incorrect. The command <code>service scp-server</code> is incorrect."
    },
    {
       "id":1077,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":2,
       "question":"What is the attack in which DTP is exploited by a malicious user?",
       "choice_a":"Native VLAN",
       "choice_b":"VLAN hopping",
       "choice_c":"VLAN traversal",
       "choice_d":"Trunk popping",
       "correct_answer":"B",
       "explanation":"VLAN hopping is an attack in which DTP is exploited. The attacker negotiates a trunk with the switch via DTP and can hop from VLAN to VLAN. Native VLAN will carry any frame that is not tagged; the native VLAN should be configured to something other than VLAN 1. <italic>VLAN traversal</italic> and <italic>trunk popping</italic> are not terms used with VLANs, and therefore, they are invalid answers."
    },
    {
       "id":1078,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":2,
       "question":"Which layer 2 protocol has built-in security for WAN connections?",
       "choice_a":"HDLC",
       "choice_b":"PPP",
       "choice_c":"IPsec",
       "choice_d":"Metro Ethernet",
       "correct_answer":"B",
       "explanation":"Point-to-Point Protocol (PPP) is a layer 2 wide area network (WAN) protocol. PPP supports Challenge Handshake Authentication Protocol (CHAP), which secures connections. High-Level Data Link Control (HDLC) is a serial control protocol used on WAN links and it provides no security. The IPsec protocol is a layer 3 security protocol used to encrypt traffic and not a layer 2 protocol. Although Metro Ethernet is built site to site by the service provider, there is no guarantee of security in the form of authentication."
    },
    {
       "id":1079,
       "topic_id":5,
       "sub_domain":"5.2 Describe security program elements (user awareness, training, and physical access control)",
       "practice_test_id":2,
       "question":"Chelsea is worried about the threat of malware on the network. She wants to install software that will detect worms and Trojan horses on every workstation. Which type of software should she install?",
       "choice_a":"Malware",
       "choice_b":"Antivirus",
       "choice_c":"Software firewalls",
       "choice_d":"Spyware",
       "correct_answer":"B",
       "explanation":"Antivirus software is an application that is installed on a system and is used to protect it and to scan workstations for viruses as well as worms and Trojan horses. Malware is malicious software that once installed on a system causes malicious activity. Software firewalls will not detect Trojan horses and worms. Spyware is software that monitors user activity and offers unsolicited pop-up advertisements."
    },
    {
       "id":1080,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":2,
       "question":"Which command will configure the login banner to read \u0022CCNA Routing and Switching\u0022?",
       "choice_a":"<code>Router(config)#login banner CCNA Routing and Switching</code>",
       "choice_b":"<code>Router(config)#banner login CCNA Routing and Switching</code>",
       "choice_c":"<code>Router(config)#banner login ^CCNA Routing and Switching^</code>",
       "choice_d":"<code>Router(config-line)#banner login ^CCNA Routing and Switching^</code>",
       "correct_answer":"C",
       "explanation":"The command <code>banner login ^CCNA Routing and Switching^</code> will configure the login banner to read \u0022CCNA Routing and Switching.\u0022 The marks at the beginning and end of the text are delimiters to mark the beginning and end of the banner. The command <code>login banner CCNA Routing and Switching</code> is incorrect. The command <code>banner login CCNA Routing and Switching</code> is incorrect. The command <code>banner login ^CCNA Routing and Switching^</code> is incorrect when it is configured in the line configuration prompt."
    },
    {
       "id":1081,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":2,
       "question":"You have configured a message of the day (MOTD) banner, but it only shows up after you have logged into the router. What is the problem?",
       "choice_a":"You are connecting via SSH.",
       "choice_b":"You are connecting via Telnet.",
       "choice_c":"You are connecting via the console.",
       "choice_d":"You do not have an enable password set.",
       "correct_answer":"A",
       "explanation":"When a user is connecting to a router via SSH, the MOTD banner is not displayed until after the user has authenticated to the router or switch. A login banner is always displayed pre-login. When connecting with the Telnet protocol, you must specify a login password first. When connecting via the console, the MOTD will not be displayed. The MOTD banner will show before the enable password is entered."
    },
    {
       "id":1082,
       "topic_id":5,
       "sub_domain":"5.4 Describe security password policies elements, such as management, complexity, and password alternatives (multifactor authentication, certificates, and biometrics)",
       "practice_test_id":2,
       "question":"Which mechanism is used to authenticate EAP-TLS during the 802.1x authentication process?",
       "choice_a":"MD5",
       "choice_b":"Certificates",
       "choice_c":"SSH",
       "choice_d":"Passwords",
       "correct_answer":"B",
       "explanation":"EAP-TLS, or Extensible Authentication Protocol/Transport Layer Security, uses certificates to authenticate end devices. It also provides a layer of encryption via the certificate infrastructure. Although EAP can be configured to use MD5 symmetrical authentication, it is not used with TLS. Secure Shell (SSH) and passwords are not used with EAP-TLS."
    },
    {
       "id":1083,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":2,
       "question":"You have been asked to recommend a private WAN technology. All of the remote offices have varied physical connectivity paths. Which private WAN technology should you recommend?",
       "choice_a":"MPLS",
       "choice_b":"Metro Ethernet",
       "choice_c":"PPPoE",
       "choice_d":"GRE tunnels",
       "correct_answer":"A",
       "explanation":"Multiprotocol Label Switching allows for varied access links such as serial leased lines, Frame Relay, Metro Ethernet, and so on. You can leverage the existing connectivity methods to form a private WAN. PPPoE and GRE tunnels are connectivity methods used on top of a WAN technology, so they are invalid answers."
    },
    {
       "id":1084,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":2,
       "question":"Which protocol does IPsec use to check integrity of data packets?",
       "choice_a":"AH",
       "choice_b":"ESP",
       "choice_c":"IKE",
       "choice_d":"ISAKMP",
       "correct_answer":"A",
       "explanation":"IPsec uses the Authentication Header (AH) protocol to check data integrity. This is done by creating a numerical hash of the data via SHA1, SHA2, or MD5 algorithms. The Encapsulating Security Payload (ESP) protocol is part of the IPsec suite of protocols, and it is responsible for encryption of packets. The Internet Security Association and Key Management Protocol (ISAKMP) is part of the Internet Key Exchange (IKE) protocol suite and is responsible for creating a security association between two participating computers in IPsec."
    },
    {
       "id":1085,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":2,
       "question":"If a router has two interfaces and you only use IPv4, how many ACLs can be configured on the router's interfaces?",
       "choice_a":"One",
       "choice_b":"Two",
       "choice_c":"Four",
       "choice_d":"Eight",
       "correct_answer":"C",
       "explanation":"You can have only one access control list (ACL) per direction, per protocol, and per interface. Therefore, each of the two interfaces can have both an inbound and outbound ACL, per the protocol of IPv4. This allows for a total of four ACLs, which can be used to control access through the router. If you added IPv6 to both interfaces, you could apply a total of eight ACLs. All of the other options are incorrect."
    },
    {
       "id":1086,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":2,
       "question":"Which command will achieve the same goal as the command <code>access-list 2 permit host 192.168.2.3?</code>",
       "choice_a":"<code>Router(config)#access-list 2 permit 192.168.2.3 255.255.255.255</code>",
       "choice_b":"<code>Router(config)#access-list 2 permit 192.168.2.3 0.0.0.0</code>",
       "choice_c":"<code>Router(config)#ip access-list 2 permit host 192.168.2.3</code>",
       "choice_d":"<code>Router(config)#access-list 2 permit 192.168.2.3</code>",
       "correct_answer":"B",
       "explanation":"The command <code>access-list 2 permit 192.168.2.3 0.0.0.0</code> will perform the same function as <code>access-list 2 permit host 192.168.2.3</code>. The command configures the host 192.168.2.3 with a bit mask, which will only match the single IP address. Although it can be configured as a bit mask, it should be configured via the host parameter for readability. The command <code>access-list 2 permit 192.168.2.3 255.255.255.255</code> is incorrect. The command <code>ip access-list 2 permit host 192.168.2.3</code> is incorrect. The command <code>access-list 2 permit 192.168.2.3</code> is incorrect."
    },
    {
       "id":1087,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":2,
       "question":"You have just configured DHCP snooping. Which ports should be trusted?",
       "choice_a":"Ports connecting to clients",
       "choice_b":"Ports connecting to web servers",
       "choice_c":"Ports connecting to other switches",
       "choice_d":"Ports connecting to the DNS server",
       "correct_answer":"C",
       "explanation":"Ports that are connecting to trusted infrastructure devices such as routers and switches should be trusted. This is because legitimate DHCP traffic could originate from these ports. You would not want ports connecting to clients to be trusted since this is the purpose of enabling DHCP snooping. Web servers and DNS servers should also not be trusted since they are not facilitating DHCP."
    },
    {
       "id":1088,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":2,
       "question":"Which is a correct statement about how DHCP snooping works?",
       "choice_a":"Untrusted ports allow Discover and Offer messages to be switched.",
       "choice_b":"Untrusted ports drop Discover and Offer messages.",
       "choice_c":"Untrusted ports drop Offer and Acknowledgment messages.",
       "choice_d":"Untrusted ports allow Offer and Acknowledgment messages to be switched.",
       "correct_answer":"C",
       "explanation":"The untrusted ports drop Offer and Acknowledgment DHCP messages. The only device that should offer and acknowledge IP addresses is the DHCP server on a trusted port. The untrusted ports do not allow Offer or Acknowledgement messages but will allow Discover messages. All of the options except C are incorrect."
    },
    {
       "id":1089,
       "topic_id":5,
       "sub_domain":"5.8 Differentiate authentication, authorization, and accounting concepts",
       "practice_test_id":2,
       "question":"Which command will configure the RADIUS server 192.168.1.5 with a secret of aaaauth?",
       "choice_a":"<code>Router(config)#radius host 192.168.1.5 key aaaauth</code>",
       "choice_b":"<code>Router(config)#radius-server host 192.168.1.5 key aaaauth</code>",
       "choice_c":"<code>Router(config)#radius-server 192.168.1.5 key aaaauth</code>",
       "choice_d":"<code>Router(config)#radius-server host 192.168.1.5 secret aaaauth</code>",
       "correct_answer":"B",
       "explanation":"The command <code>radius-server host 192.168.1.5 key aaaauth</code> will configure the radius server 192.168.1.5 with a secret key of aaaauth. The command <code>radius host 192.168.1.5 key aaaauth</code> is incorrect. The command <code>radius-server 192.168.1.5 key aaaauth</code> is incorrect. The command <code>radius-server host 192.168.1.5 secret aaaauth</code> is incorrect."
    },
    {
       "id":1090,
       "topic_id":5,
       "sub_domain":"5.9 Describe wireless security protocols (WPA, WPA2, and WPA3)",
       "practice_test_id":2,
       "question":"Which protocol was released to fix WEP?",
       "choice_a":"WPA",
       "choice_b":"WPA2",
       "choice_c":"WPA3",
       "choice_d":"RC4-TKIP",
       "correct_answer":"A",
       "explanation":"Wi-Fi Protected Access (WPA) was rushed out and released to fix weak security in the Wired Equivalent Privacy (WEP) wireless security protocol. WPA2 was formally released to address weaknesses in the RC4-TKIP security protocol. WPA3 is the newest wireless security protocol to be released and offers the highest level of security for wireless."
    },
    {
       "id":1091,
       "topic_id":5,
       "sub_domain":"5.10 Configure WLAN using WPA2 PSK using the GUI",
       "practice_test_id":2,
       "question":"You are configuring a WLAN and you need to use WPA PSK, but you also need to restrict certain devices. What should you implement to achieve this goal?",
       "choice_a":"Captive portal",
       "choice_b":"RADIUS",
       "choice_c":"MAC filtering",
       "choice_d":"Disable broadcast SSID",
       "correct_answer":"C",
       "explanation":"MAC filtering will allow you to setup a WLAN with Wi-Fi Protected Access (WPA) with a pre-shared key (PSK) and restrict certain devices. A captive portal will not allow you to restrict devices, only capture guests with a web page so they must log in. Although you can restrict a user, you cannot restrict a particular device. A Remote Authentication Dial-In User Service (RADIUS) server works in conjunction with AAA authentication and is not implemented alongside of WPA PSK. Disabling broadcasting of the SSID is security through obscurity and not a sufficient mechanism to restrict devices."
    },
    {
       "id":1092,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":2,
       "question":"An employee has left, and you are required to change the password of 50 routers. What is the quickest way to complete this task?",
       "choice_a":"Creating a script with Python",
       "choice_b":"Creating a script with JSON",
       "choice_c":"Applying a YAML template to the routers",
       "choice_d":"Applying a JSON template to the routers",
       "correct_answer":"A",
       "explanation":"You can speed up the changing of all 50 router passwords with a Python script. JavaScript Object Notation (JSON) is used for input and output of data; although it can be used in conjunction with a script, it by itself is not a script language. You cannot apply YAML Ain't Markup Language (YAML) or JSON templates to routers unless there is another mechanism such as a script that is being used."
    },
    {
       "id":1093,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":2,
       "question":"Which is a negative outcome from automating a configuration change across the enterprise?",
       "choice_a":"Increased odds of typographical errors",
       "choice_b":"Increased odds of configuration conflicts",
       "choice_c":"Increased time spent building configurations",
       "choice_d":"Decreased time spent building configurations",
       "correct_answer":"B",
       "explanation":"A negative outcome from automation of configuration across an enterprise is that you increase the odds of configuration conflicts. You decrease the odds of typographical errors when using automation because redundant commands do not need to be entered. The time spent building configurations should be no more or no less than normal once an automated system is established."
    },
    {
       "id":1094,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":2,
       "question":"You have been given the task of mapping a network. You have several routers and switches that are interconnected. Which Cisco tool will help you map the network?",
       "choice_a":"CDP",
       "choice_b":"Running configuration",
       "choice_c":"OSPF neighbor table",
       "choice_d":"EIGRP neighbor table",
       "correct_answer":"A",
       "explanation":"The Cisco Discovery Protocol (CDP) can be used to map out all of the Cisco devices connected to the network. If you issue the command of <code>show cdp neighbors detail</code> or <code>show cdp entry *</code>, the output will display all of the Cisco devices connected to the switch or router the command is issue from. The running configuration will not display the current devices connected. The Open Shortest Path First (OSPF) or Enhanced Interior Gateway Routing Protocol (EIGRP) protocol will not display the directly connected devices."
    },
    {
       "id":1095,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":2,
       "question":"Which protocol is used with the Southbound interface in the SDN controller?",
       "choice_a":"Python",
       "choice_b":"OpenFlow",
       "choice_c":"REST",
       "choice_d":"JSON",
       "correct_answer":"B",
       "explanation":"The OpenFlow protocol is an open standard used to configure network devices via the Southbound interface of the software defined networking (SDN) controller. Python is a common programming language that is used for the programming of an SDN controller via the Northbound interface of the SDN controller. Representational State Transfer (REST) is an architecture for moving data using the HyperText Transfer Protocol (HTTP). JavaScript Object Notation (JSON) is a data-interchange format used with many different SDN controllers."
    },
    {
       "id":1096,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":2,
       "question":"On which layer does the fabric of software defined network switch packets?",
       "choice_a":"Layer 2",
       "choice_b":"Layer 3",
       "choice_c":"Layer 6",
       "choice_d":"Layer 7",
       "correct_answer":"B",
       "explanation":"The fabric of a software defined network switches packets on layer 3. All of the other options are incorrect."
    },
    {
       "id":1097,
       "topic_id":6,
       "sub_domain":"6.4 Compare traditional campus device management with Cisco DNA Center enabled device management",
       "practice_test_id":2,
       "question":"Where inside of the Cisco DNA Center can you configure the upgrade of IOS for network devices?",
       "choice_a":"Provision",
       "choice_b":"Design",
       "choice_c":"Policy",
       "choice_d":"Assurance",
       "correct_answer":"A",
       "explanation":"You can configure the upgrade of IOS for network devices from the Provision section of the Cisco DNA Center. The Design section allows you to create a hierarchical design of the network, with a graphical map. The Policy section allows you to create policies based upon applications, traffic, and IP-based access control lists (ACLs), just to name a few. The Assurance section of the Cisco DNA Center allows you to see the overall health of network devices managed by DNA Center."
    },
    {
       "id":1098,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":2,
       "question":"You are testing a POST function on a REST-based API and a 401 status code was returned. What does that mean?",
       "choice_a":"The POST was accepted.",
       "choice_b":"The POST was redirected to another URI.",
       "choice_c":"The POST was unauthorized.",
       "choice_d":"The POST was not in the right format.",
       "correct_answer":"C",
       "explanation":"When a status code of 401 is returned, it means that the method was unauthorized. A status code of 200 or 202 means the method was okay or accepted; these are the two most common."
    },
    {
       "id":1099,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":2,
       "question":"Which configuration management mechanism uses Python and YAML as a configuration language?",
       "choice_a":"DSC",
       "choice_b":"Chef",
       "choice_c":"Puppet",
       "choice_d":"Ansible",
       "correct_answer":"D",
       "explanation":"Ansible uses a YAML Ain't Markup Language (YAML) configuration file and can be programmed with Python. Desired State Configuration (DSC) is a Microsoft-centric product that is programmed in PowerShell. Chef uses Domain Specific Language (DSL) with Ruby. Puppet uses DSL with the PuppetDSL language."
    },
    {
       "id":1100,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":2,
       "question":"Which is a requirement for using Ansible for configuration management?",
       "choice_a":"Internet access",
       "choice_b":"Root SSH",
       "choice_c":"Unrestricted firewall",
       "choice_d":"Ruby",
       "correct_answer":"B",
       "explanation":"A requirement for using Ansible for configuration management is root Secure Shell (SSH) access to the remote system. Internet access is only required if you are managing a system across the Internet. An unrestricted firewall is not required because you only need port 22 TCP (SSH) for Ansible to access the remote machine. Ansible is scripted with Python and not Ruby."
    },
    {
       "id":1101,
       "topic_id":6,
       "sub_domain":"6.7 Interpret JSON encoded data",
       "practice_test_id":2,
       "question":"Which command is used to output JSON from the execution of a command on a Cisco router or switch?",
       "choice_a":"<code>show interface status | json-pretty native</code>",
       "choice_b":"<code>json interface status</code>",
       "choice_c":"<code>show interface status | json</code>",
       "choice_d":"<code>show interface status json</code>",
       "correct_answer":"A",
       "explanation":"The command <code>show interface status | json-pretty native</code> is used to convert the output of a command to JSON in a Cisco router or switch. You will enter the command first, such as <code>show interface status,</code> and then pipe the output to the <code>| json-pretty</code> command and specify <code>native</code> formatting. The command <code>json interface status</code> is incorrect. The command <code>show interface status | json</code> is incorrect. The command <code>show interface status json</code> is incorrect."
    },
    {
       "id":1102,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":3,
       "question":"Which device will create broadcast domains and raise effective bandwidth?",
       "choice_a":"Firewall",
       "choice_b":"Hub",
       "choice_c":"Router",
       "choice_d":"Switch",
       "correct_answer":"C",
       "explanation":"A router will stop broadcasts by default. If you add a router to a flat network, which is a single broadcast domain, you effectively raise bandwidth by reducing the number of broadcasts. A firewall is a network device that can protect a network from malicious traffic and/or restrict access. A hub is nothing more than a multiport repeater and does not create broadcast domains. A switch is a layer 2 device that creates micro-segmentation."
    },
    {
       "id":1103,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":3,
       "question":"Which devices create collision domains, raising effective bandwidth?",
       "choice_a":"Firewalls",
       "choice_b":"Hubs",
       "choice_c":"Routers",
       "choice_d":"Switches",
       "correct_answer":"D",
       "explanation":"Switches create collision domains by isolating the possibility of a collision to the segment it is transmitting to or receiving frames from. This in turn raises effective bandwidth for the rest of the segments. A firewall is a network device that can protect a network from malicious traffic and/or restrict access. A hub is nothing more than a multiport repeater and does not create broadcast domains. A router is a network device that routes layer 3 packets."
    },
    {
       "id":1104,
       "topic_id":1,
       "sub_domain":"1.1 Explain the role and function of network components",
       "practice_test_id":3,
       "question":"In which zone should an email server be located?",
       "choice_a":"Inside zone",
       "choice_b":"Outside zone",
       "choice_c":"DNS zone",
       "choice_d":"DMZ",
       "correct_answer":"D",
       "explanation":"Since the email server needs access to the Internet to send and receive mail, it should be placed in the demilitarized zone (DMZ). This will also allow access to internal clients in the inside zone. The inside zone is the private, or internal, network. The outside zone contains access for the public Internet, also called the perimeter or external network. A DNS zone is a database that serves resource records for an FQDN and has nothing to do with firewalls."
    },
    {
       "id":1105,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":3,
       "question":"If you had limited cable access for the distribution switches, which topology would you need to plan for?",
       "choice_a":"Star topology",
       "choice_b":"Full mesh topology",
       "choice_c":"Partial mesh topology",
       "choice_d":"Hybrid topology",
       "correct_answer":"C",
       "explanation":"Generally, office buildings do not have direct runs to each switch closet from the other closets. Although a full mesh is desirable, sometimes only a partial mesh is achievable. Traditional Ethernet-based networks function in a star topology, starting with a switch and connecting each client as a point on the star. A full mesh topology is often found between the core and distribution layers of the Cisco three-tier design model. A hybrid topology is found in many networks today because one topology does not fit all needs throughout the network."
    },
    {
       "id":1106,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":3,
       "question":"Which sub-protocol inside of the PPP suite is responsible for tagging layer 3 protocols so that multiple protocols can be used over a PPP connection?",
       "choice_a":"MPLS",
       "choice_b":"NCP",
       "choice_c":"LCP",
       "choice_d":"PCP",
       "correct_answer":"B",
       "explanation":"The Network Control Protocol (NCP) works at layer 3 tagging the network protocols from end to end when PPP is used. This gives PPP the ability to offer multiprotocol transport. Multiprotocol Label Switching (MPLS) is a routing technique in which the labels on the packets are tagged and packet switched throughout the provider's network. The Link Control Protocol (LCP) is responsible for connection setup, authentication, and header compression, among other things. PCP is not a protocol commonly used, and therefore, it is an invalid answer."
    },
    {
       "id":1107,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":3,
       "question":"Which command will configure PPP on a serial interface?",
       "choice_a":"<code>Router(config-if)#encapsulation ppp</code>",
       "choice_b":"<code>Router(config-if)#protocol ppp</code>",
       "choice_c":"<code>Router(config-if)#ppp enable</code>",
       "choice_d":"<code>Router(config-if)#ppp protocol</code>",
       "correct_answer":"A",
       "explanation":"The command <code>encapsulation ppp</code> configures the serial interface with the Point to Point Protocol (PPP). PPP is an encapsulation protocol. The command <code>protocol ppp</code> is incorrect. The command <code>ppp enable</code> is incorrect. The command <code>ppp protocol</code> is incorrect."
    },
    {
       "id":1108,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":3,
       "question":"What device connects the remote office DSL modem to the telco's PSTN and the Internet?",
       "choice_a":"DSL access multiplier",
       "choice_b":"DSL concentrator",
       "choice_c":"5ESS switch",
       "choice_d":"Digital cross-connect system",
       "correct_answer":"A",
       "explanation":"DSL access multipliers, or DSLAMs, share the local loop with analog phone traffic to intercept communications from the DSL modem. DASLAMs provide the switching of data to the Internet. A DSL concentrator is normally installed at a housing complex or hotel and allows for individual DSL lines to be created. The 5ESS switching system is used for switching plain old telephone system (POTS) calls. A digital cross-connect system is used to connect circuits between the local loop and the provider."
    },
    {
       "id":1109,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":3,
       "question":"When purchasing a Metro Ethernet connection, which option is generally tied to the monthly recurring cost of the connection?",
       "choice_a":"IP addresses used to support the service",
       "choice_b":"Routing protocols used to support the service",
       "choice_c":"The committed information rate on the EVC",
       "choice_d":"The use of QoS",
       "correct_answer":"C",
       "explanation":"The CIR, or committed information rate, is the sustainable speed which the customer can communicate on the Ethernet virtual circuit. This CIR is directly tied to the price of the Monthly Recurring Charge (MRC), since the service provider must dedicate this bandwidth for the customer agreement. The IP addresses and routing protocols used are agreed upon by the connecting parties and not part of the Metro Ethernet connection. The use of Quality of Service (QoS) is agreed upon by the connecting parties as well."
    },
    {
       "id":1110,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":3,
       "question":"Which cloud service is likely to be used for software development?",
       "choice_a":"SaaS",
       "choice_b":"IaaS",
       "choice_c":"PaaS",
       "choice_d":"DRaaS",
       "correct_answer":"C",
       "explanation":"Platform as a Service (PaaS) is commonly used by software developers. It provides a development platform that the software developer can use to create applications. An example of this is a web server with PHP and MySQL, which is hosted in the cloud. Software as a Service (SAAS) is a software product similar to email or social networking software in which you use the software provided as a service. Infrastructure as a Service (IaaS) allows you to rent infrastructure such as virtual machines, virtual networks, or even DNS, just to name a few. Disaster Recovery as a Service (DRaaS) is another popular service; you can rent storage and compute power to facilitate a disaster recovery site."
    },
    {
       "id":1111,
       "topic_id":1,
       "sub_domain":"1.2 Describe characteristics of network topology architectures",
       "practice_test_id":3,
       "question":"You are running several web servers in a cloud with a server load balancer. As demand increases, you add web servers. According to the NIST standard of cloud computing, which feature can you use to increase your compute capability for demand?",
       "choice_a":"Resource pooling",
       "choice_b":"Measured services",
       "choice_c":"Broad network access",
       "choice_d":"Rapid elasticity",
       "correct_answer":"D",
       "explanation":"Rapid elasticity is the ability to add and remove compute capability in the cloud. As demand is needed, compute power can be increased by adding more CPUs or servers. As demand for compute power decreases, CPUs or servers can be removed. Resource pooling is the concept that all of the physical hosts the provider has are pooled together to provide a customer with resources. Measured services is the concept that the provider can determine the amount of computing, network, or storage a customer has used so that they can be billed or a report can be created. Broad network access is the concept that the resources can be accessed from anywhere on the Internet."
    },
    {
       "id":1112,
       "topic_id":1,
       "sub_domain":"1.5 Compare TCP to UDP",
       "practice_test_id":3,
       "question":"Which flags are used during the three-way-handshake process for TCP?",
       "choice_a":"FIN and ACK",
       "choice_b":"SYN and ACK",
       "choice_c":"SYN and FIN",
       "choice_d":"SYN and RDY",
       "correct_answer":"B",
       "explanation":"During the three-way-handshake, Computer A sends a SYN flag along with its receiving window size and initial sequence number. Then Computer B sends a SYN flag and ACK flag along with its receiving window and acknowledgment of the sequence number. Finally, Computer A sends an ACK flag, which acknowledges the synchronization of Computer B's receiving window. Communication begins and is considered to be in an established state. All of the other options are incorrect."
    },
    {
       "id":1113,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":3,
       "question":"Which network is part of the summary route of 172.16.32.0/21?",
       "choice_a":"172.16.64.0/24",
       "choice_b":"172.16.48.0/24",
       "choice_c":"172.16.40.0/24",
       "choice_d":"172.16.38.0/24",
       "correct_answer":"D",
       "explanation":"The summary route of 172.16.32.0/21 contains 172.16.38.0/24 as a valid network route. The /21 CIDR mask defines networks in multiples of 8 in the third octet of the network address. Therefore, the next summary network address is 172.16.40.0/21. All of the other options are incorrect."
    },
    {
       "id":1114,
       "topic_id":1,
       "sub_domain":"1.6 Configure and verify IPv4 addressing and subnetting",
       "practice_test_id":3,
       "question":"Which classification of IP address does 225.34.5.4 belong to?",
       "choice_a":"Class A",
       "choice_b":"Class B",
       "choice_c":"Class C",
       "choice_d":"Class D",
       "correct_answer":"D",
       "explanation":"The IP address 225.34.5.4 is a multicast IP address. Multicast IP addresses are defined as Class D addresses in the range 224.0.0.1 to 239.255.255.254. Class A defines any address with the first octet of 0 to 127. Class B defines any address with the first octet of 128 to 191. Class C defines any address with the first octet of 192 to 223."
    },
    {
       "id":1115,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":3,
       "question":"What is the process of stateful DHCPv6 for IPv6?",
       "choice_a":"Discover, Offer, Request, Acknowledge",
       "choice_b":"Solicit, Advertise, Request, Reply",
       "choice_c":"Neighbor Solicitation, Neighbor Advertisement",
       "choice_d":"Router Solicitation, Router Advertisement",
       "correct_answer":"B",
       "explanation":"Stateful DHCPv6 uses a process similar to DORA for IPv4. However, IPv6 uses multicast in lieu of broadcasts via the DHCPv6 Solicit multicast address. The Discover, Offer, Request, and Acknowledge (DORA) process only happens with IPv4 via broadcasts. Neighbor Solicitation (NS) and Neighbor Advertisement (NA) messages are used with the Neighbor Discovery Protocol (NDP). Router Solicitation (RS) and Router Advertisement (RA) messages are used with Stateless Auto configuration (SLAAC)."
    },
    {
       "id":1116,
       "topic_id":1,
       "sub_domain":"1.8 Configure and verify IPv6 addressing and prefix",
       "practice_test_id":3,
       "question":"When SLAAC is performed on an IPv6 host, which process happens first?",
       "choice_a":"A Router Solicitation message is sent from the client.",
       "choice_b":"A Router Advertisement message is sent from the router.",
       "choice_c":"A link-local address is auto-configured on the client.",
       "choice_d":"DAD is performed on the IPv6 address.",
       "correct_answer":"C",
       "explanation":"Before a host can communicate via an RS packet, it first needs a valid IP address. The first address is a link-local address so that it can send an RS packet and receive an RA packet. The client performs Duplicate Address Detection (DAD) on the link-local address. Then a Router Solicitation (RS) message is sent from the client. A Router Advertisement (RA) message is sent from the router to the client with the network ID. The host portion is then configured and DAD is checked again to make sure that the host does not have a duplicate IP address."
    },
    {
       "id":1117,
       "topic_id":1,
       "sub_domain":"1.9 Compare IPv6 address types",
       "practice_test_id":3,
       "question":"In IPv6, the solicited-node multicast message is used for what?",
       "choice_a":"Discovery of the gateway",
       "choice_b":"Discovery of the network ID",
       "choice_c":"Resolution of the MAC address for an IPv6 address",
       "choice_d":"Capability discovery of neighboring devices",
       "correct_answer":"C",
       "explanation":"In IPv6, the solicited-node multicast message is used for resolution of the MAC address for an IPv6 address. The first 104 bits of the 128-bit IPv6 address is ff02::1:ff, and the last 24 bits comprise the last 24 bits of the IPv6 address that needs to be resolved. The solicited-node multicast message is also used for Duplicate Address Detection (DAD). All of the other options are incorrect."
    },
    {
       "id":1118,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":3,
       "question":"The following exhibit is an Ethernet frame. What is field A in the exhibit?<img src='/question_assets/ccna/8_image1.png'></img>",
       "choice_a":"Source MAC address",
       "choice_b":"Destination MAC address",
       "choice_c":"Type Field",
       "choice_d":"Frame Checking Sequence (FCS)",
       "correct_answer":"B",
       "explanation":"The first field after the preamble and start frame delimiter (SFD) is the destination MAC address. The destination MAC address is always first because switches need to make forwarding decisions upon reading the destination MAC address. The source MAC address is in field B in the exhibit. The type field is in field C in the exhibit, and the frame checking sequence (FCS) is in field E in the exhibit."
    },
    {
       "id":1119,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":3,
       "question":"In the following exhibit, what is field C used for?<img src='/question_assets/ccna/8_image2.png'></img>",
       "choice_a":"The destination MAC address",
       "choice_b":"The next upper-layer protocol to send the information to",
       "choice_c":"The beginning of data, also called the start frame delimiter",
       "choice_d":"The cyclical redundancy checksum value",
       "correct_answer":"B",
       "explanation":"Field C in the exhibit is the type field. The type field is used to define the upper-layer protocol the data belongs to. The destination MAC address in field A of the exhibit is used for forward filter decisions. The 7-byte preamble and start frame delimiter (SFD) of the frame in the exhibit are used to synchronize timing of the data. The frame checking sequence (FCS) is a cyclical redundancy checksum (CRC) value that can be seen in field E of the exhibit."
    },
    {
       "id":1120,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":3,
       "question":"Which command would you use to reset the MAC address table for learned MAC addresses in a switch?",
       "choice_a":"<code>Switch#reset mac address-table</code>",
       "choice_b":"<code>Switch#clear mac-address-table dynamic</code>",
       "choice_c":"<code>Switch#clear mac-address-table</code>",
       "choice_d":"<code>Switch#clear mac table</code>",
       "correct_answer":"B",
       "explanation":"The command used to reset the MAC address table is <code>clear mac-address-table dynamic</code>. The command <code>reset mac address-table</code> is incorrect. The command <code>clear mac-address-table</code> is incorrect. The command <code>clear mac table</code> is incorrect."
    },
    {
       "id":1121,
       "topic_id":1,
       "sub_domain":"1.13 Describe switching concepts",
       "practice_test_id":3,
       "question":"You need to see all of the MAC addresses associated with a single interface. Which command would you use?",
       "choice_a":"<code>Switch>show mac address-table interfaces fast 0/1</code>",
       "choice_b":"<code>Switch>show address-table interfaces fast 0/1</code>",
       "choice_c":"<code>Switch#show mac interfaces fast 0/1</code>",
       "choice_d":"<code>Switch#show address-table fast 0/1</code>",
       "correct_answer":"A",
       "explanation":"The command to see all of the MAC addresses on a single interface is <code>show mac address-table interfaces fast 0/1</code>. This command can be entered in either privileged exec mode or user exec mode. The command <code>show address-table interfaces fast 0/1</code> is incorrect. The command <code>show mac interfaces fast 0/1</code> is incorrect. The command <code>show address-table fast 0/1</code> is incorrect."
    },
    {
       "id":1122,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":3,
       "question":"Which statement is correct about the following exhibit?<img src='/question_assets/ccna/8_image3.png'></img>",
       "choice_a":"The source interface is Fa0/1 with a destination interface of Fa0/2.",
       "choice_b":"The source interface is Fa0/2 with a destination interface of Fa0/1.",
       "choice_c":"The source interface is Fa0/1 with a destination interface of Fa0/2 via VLAN 2.",
       "choice_d":"The source interface is Fa0/1 and VLAN 2 with a destination interface of Fa0/2.",
       "correct_answer":"D",
       "explanation":"The details of the output show that monitor session 1 is configured to capture interface Fa0/1 and VLAN 2 in both directions. The destination interface is Fa 0/2. All of the other options are incorrect."
    },
    {
       "id":1123,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":3,
       "question":"When VLANs are configured in global configuration mode, where are the VLANs stored by default?",
       "choice_a":"In the running configuration or RAM",
       "choice_b":"In the startup configuration or NVRAM",
       "choice_c":"In the <code>vlan.dat</code> on the flash",
       "choice_d":"In the <code>vlan.dat</code> on the NVRAM",
       "correct_answer":"C",
       "explanation":"Under normal circumstances, when VLANs are configured, they are stored in a file separate from the startup or running-configuration. The VLAN database is stored in a file called <code>vlan.dat</code> on the flash. When decommissioning a switch, if you were to erase the configuration of a switch, you would also need to delete the <code>vlan.dat</code>. VLANs are configured in the running configuration when the switch is in VTP transparent mode. The VLAN configuration can then be stored for survivability of reboots in the startup configuration by writing the running configuration to the startup configuration. The <code>vlan.dat</code> file is not stored on the NVRAM; it is always stored on the flash."
    },
    {
       "id":1124,
       "topic_id":2,
       "sub_domain":"2.1 Configure and verify VLANs (normal range) spanning multiple switches",
       "practice_test_id":3,
       "question":"Which command will allow you to configure interfaces Gi1/1 to Gi1/12?",
       "choice_a":"<code>Switch(config)#interface gigabitethernet range 1/1 - 12</code>",
       "choice_b":"<code>Switch(config)#interface range gigabitethernet 1/1 - 12</code>",
       "choice_c":"<code>Switch(config)#interface range gigabitethernet 1/1 1/12</code>",
       "choice_d":"<code>Switch(config)#interface range gigabitethernet range 1/1,12</code>",
       "correct_answer":"B",
       "explanation":"The command <code>interface range gigabitethernet 1/1 - 12</code> will allow you to configure the interfaces Gigabit Ethernet 1/1 to 1/12. The command <code>interface gigabitethernet range 1/1 - 12</code> is incorrect. The command <code>interface range gigabitethernet 1/1 1/12</code> is incorrect. The command <code>interface range gigabitethernet range 1/1,12</code> is incorrect."
    },
    {
       "id":1125,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":3,
       "question":"You have VLAN 10 and VLAN 11 configured on a trunk switchport as allowed. What will happen if you enter the command <code>switchport trunk allowed vlan 12</code> on the trunk interface?",
       "choice_a":"VLAN 12 will be added to the existing allowed VLAN list.",
       "choice_b":"VLANs 1 through 12 will be added to the allowed VLAN list.",
       "choice_c":"The native VLAN will be switched to VLAN 12.",
       "choice_d":"Only VLAN 12 will be on the allowed VLAN list.",
       "correct_answer":"D",
       "explanation":"The command <code>switchport trunk allowed vlan 12</code> will remove all other VLANs and only VLAN 12 will be allowed on the trunk interface. The proper command to add an additional VLAN would be <code>switchport trunk allowed vlan add 12</code>. This command will add a VLAN to the already established list. All of the other options are incorrect."
    },
    {
       "id":1126,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":3,
       "question":"Which protocol assists in synchronizing a VLAN database across multiple Cisco switches?",
       "choice_a":"NTP",
       "choice_b":"IGMP",
       "choice_c":"ISL",
       "choice_d":"VTP",
       "correct_answer":"D",
       "explanation":"The VLAN Trunking Protocol (VTP) assists in synchronizing a VLAN database across all Cisco switches participating in VTP. You must initially configure the VTP domain on the switch that will hold the master database. Then all other switches must be configured as clients and the VTP domain must be configured as well. The Network Time Protocol (NTP) synchronizes time on the switch or router with a known precision source. The Internet Group Management Protocol (IGMP) is used to facilitate multicast snooping on switches by allowing join and leave requests for the multicast group. The Inter-Switch Link (ISL) protocol is a Cisco proprietary protocol for VLAN trunking."
    },
    {
       "id":1127,
       "topic_id":2,
       "sub_domain":"2.2 Configure and verify interswitch connectivity",
       "practice_test_id":3,
       "question":"In the following exhibit, interface Gi 1/1 on both switches is configured as a trunk, between the switches. Which statement is correct about the following exhibit?<img src='/question_assets/ccna/8_image4.png'></img>",
       "choice_a":"The interface Gi1/1, which is connecting the switches, has a wiring fault.",
       "choice_b":"The interface Gi1/1 is operating nominally.",
       "choice_c":"The interface Gi1/1, which is connecting the switches, has the wrong duplex configured.",
       "choice_d":"The two switches have a VLAN mismatch.",
       "correct_answer":"C",
       "explanation":"The two switches have a duplex mismatch. The duplex mismatch is a direct result of statically configuring only one side of the link to full-duplex. Switch A is not participating in port negotiation. Both sides must be configured statically the same or set to auto. There is no evidence of a wiring fault from the exhibit. There is also no evidence that interface Gi1/1 is operating nominally from the exhibit. The two switches could not have a VLAN mismatch because they are both configured as trunk links."
    },
    {
       "id":1128,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":3,
       "question":"You are examining the output of the command <code>show cdp neighbors detail</code>. One of the devices has the capability of S and R. What does this mean?",
       "choice_a":"The device has source route bridge capability.",
       "choice_b":"The device has switch capability.",
       "choice_c":"The device has router capability.",
       "choice_d":"The device has switch and router capability.",
       "correct_answer":"D",
       "explanation":"The device has the capability of both a switch and a router. It is most likely a switch that is performing SVI routing or has routing enabled. If the capability showed a B, the device would have source route bridge capabilities. If either S or R showed as a capability by itself, it would mean the device had switch capability or route capability, respectively."
    },
    {
       "id":1129,
       "topic_id":2,
       "sub_domain":"2.3 Configure and verify Layer 2 discovery protocols (Cisco Discovery Protocol and LLDP)",
       "practice_test_id":3,
       "question":"Your network is connected in a star topology. You are assessing a network upgrade. Which command will help you determine the version of IOS on the switches and routers in your network with the least amount of effort?",
       "choice_a":"<code>Switch#show version</code>",
       "choice_b":"<code>Switch#show running-config</code>",
       "choice_c":"<code>Switch#show cdp neighbors detail</code>",
       "choice_d":"<code>Switch#show lldp neighbors</code>",
       "correct_answer":"C",
       "explanation":"The command <code>show cdp neighbors detail</code> will display all connected switches along with their IP addresses, hostnames, and IOS version. If this command is used from the central switch, you can quickly assess which switches need to be upgraded. The command <code>show version</code> is incorrect. The command <code>show running-config</code> is incorrect. The command <code>show lldp neighbors</code> is incorrect."
    },
    {
       "id":1130,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":3,
       "question":"You have just configured the adjacent side of an Ether Channel from the console and receive the message in the following exhibit. What is the problem?<img src='/question_assets/ccna/8_image5.png'></img>",
       "choice_a":"One of the switches is configured with on mode and the other with desirable mode.",
       "choice_b":"One of the switches is configured with auto mode and the other with desirable mode.",
       "choice_c":"One of the switches is configured with active mode and the other with active mode.",
       "choice_d":"One of the switches is configured with passive mode and the other with passive mode.",
       "correct_answer":"A",
       "explanation":"When one side is configured with on mode, it uses no control protocol. If a control protocol is sensed from the adjacent switch, the port will enter err-disabled mode to protect it from a loop. If one switch was configured with the auto mode and the other switch was configured with desirable mode, a Port Aggregation Protocol (PAgP) Ether Channel link would be formed. If both switches were configured with active mode, then a Link Aggregation Control Protocol (LACP) Ether Channel would be formed. When both switches are configured with passive mode, then LACP would not form an Ether Channel."
    },
    {
       "id":1131,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":3,
       "question":"You have configured the command <code>channel-group 1 mode active</code> on a range of interfaces that will participate in an Ether Channel. Which pseudo interface is created for overall management of the Ether Channel?",
       "choice_a":"<code>ether-channel 1</code>",
       "choice_b":"<code>port-group 1</code>",
       "choice_c":"<code>port-channel 1</code>",
       "choice_d":"<code>channel-group 1</code>",
       "correct_answer":"C",
       "explanation":"When you configure the <code>channel-group 1 mode active</code> command on the first interface, a pseudo interface is created called <code>port-channel 1</code>. All statistics and configuration should be referenced by this interface. All of the other options are incorrect."
    },
    {
       "id":1132,
       "topic_id":2,
       "sub_domain":"2.4 Configure and verify (Layer 2/Layer 3) EtherChannel (LACP)",
       "practice_test_id":3,
       "question":"You are configuring a channel group for two interfaces. You configure the command <code>channel-group 1 mode passive</code>. What must be configured on the other switch to use LACP?",
       "choice_a":"The other switch must be configured with <code>channel-group 1 mode active</code>.",
       "choice_b":"The other switch must be configured with <code>channel-group 1 mode desirable</code>.",
       "choice_c":"The other switch must be configured with <code>channel-group 1 mode on</code>.",
       "choice_d":"The other switch must be configured with <code>channel-group 1 mode auto</code>.",
       "correct_answer":"A",
       "explanation":"The command <code>channel-group 1 mode passive</code> configures the port to be placed in a passive negotiating state. The other switch must be placed into an active negotiating state for LACP to become the control protocol for the channel group. If the other switch is configured with desirable mode, there will be a mismatch and the interface will enter an err-disabled state. If the other switch is configured with on mode, then it will not form an Ether Channel link. If the other switch is configured with auto mode, there will be a mismatch and the interface will enter an err-disabled state."
    },
    {
       "id":1133,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":3,
       "question":"When you connect a device to a switch, the device takes a minute before it is reachable via its IP address. What should be configured to fix this issue so that you can get immediate access to the device?",
       "choice_a":"Turn off auto-negotiation on the interface.",
       "choice_b":"Configure PortFast mode for spanning tree.",
       "choice_c":"Configure BPDU Guard mode for spanning tree.",
       "choice_d":"Turn off port security.",
       "correct_answer":"B",
       "explanation":"The long delay for the device to become active on the interface is the wait time for convergence of Spanning Tree Protocol (STP). If the interface will only connect a device to the port, then the port should be configured with spanning-tree PortFast mode. This will skip the blocking mode during convergence of STP. Turning off auto-negotiation on the interface will not do anything other than statically set the speed and duplex. Configuring BPDU Guard mode for spanning tree is a good idea, but it will not speed up convergence of STP. Turning off port security will not speed up convergence of the STP protocol."
    },
    {
       "id":1134,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":3,
       "question":"You enter the <code>show spanning-tree vlan 100</code> command on a switch. The output shows that all ports on the switch are in designated mode. What can be determined from this?",
       "choice_a":"This switch is connected to a root bridge.",
       "choice_b":"This switch is the root bridge.",
       "choice_c":"This switch is not participating in STP.",
       "choice_d":"This switch is a backup root bridge.",
       "correct_answer":"B",
       "explanation":"When all of the ports on a switch are in designated mode, it means that the switch is the root bridge for the Spanning Tree Protocol (STP). If the switch was connected to a root bridge, you would see the ports as being root ports. The switch is obviously participating in STP because it is displaying a status for the STP port state. The switch is already the root bridge, and it cannot be a backup root bridge as well."
    },
    {
       "id":1135,
       "topic_id":2,
       "sub_domain":"2.5 Describe the need for and basic operations of Rapid PVST+ Spanning Tree Protocol and identify basic operations",
       "practice_test_id":3,
       "question":"You have BPDU Guard configured on an interface. You receive a call that the interface is down. You perform a <code>show interface gi 0/1</code> only to find that the port is in an err-disabled state. What caused the err-disabled state?",
       "choice_a":"A neighboring switch recalculated its STP.",
       "choice_b":"The endpoint device connected to the interface sent a BPDU.",
       "choice_c":"The endpoint device was disconnected for a long period of time.",
       "choice_d":"The interface is transitioning between an up and down state rapidly, called interface flapping.",
       "correct_answer":"B",
       "explanation":"When BPDU Guard is configured on a port, it guards the port from creating a loop. It also guards STP so that the STP calculation of redundant links is not affected by the device connect to the interface. If a BPDU is seen on the interface, the interface will immediately enter into an err-disabled state. The most likely cause was that another switch was plugged into the interface. If a neighboring switch recalculates its Spanning Tree Protocol (STP), it will not affect this switch. If a device is disconnected for a long period of time, the port will not enter into an err-disabled state. Although an interface that is flapping should enter into an err-disabled state, it is not common for this to happen from a flapping port."
    },
    {
       "id":1136,
       "topic_id":2,
       "sub_domain":"2.6 Compare Cisco Wireless Architectures and AP modes",
       "practice_test_id":3,
       "question":"Which AP mode requires all traffic to be centrally switched at the WLC?",
       "choice_a":"Monitor mode",
       "choice_b":"Local mode",
       "choice_c":"Flex Connect mode",
       "choice_d":"Central mode",
       "correct_answer":"B",
       "explanation":"Local mode is a centralized switching mode in which all traffic is first sent to the wireless LAN controller to be centrally switched to its intended destination. Monitor mode can be used for analysis of the radio spectrum. Flex Connect mode is a switching mode on the wireless access point in which traffic is switched directly to the intended destination. Central mode is not a valid mode, and therefore, it is an invalid answer."
    },
    {
       "id":1137,
       "topic_id":2,
       "sub_domain":"2.6 Compare Cisco Wireless Architectures and AP modes",
       "practice_test_id":3,
       "question":"Which AP mode supports location-based services but will not serve clients?",
       "choice_a":"Flex Connect mode",
       "choice_b":"Monitor mode",
       "choice_c":"Local mode",
       "choice_d":"Locate mode",
       "correct_answer":"B",
       "explanation":"Monitor mode will help support location-based services when used with a wireless LAN controller, but it will not serve client requests. Flex Connect mode is a switching mode on the wireless access point in which traffic is switched directly to the intended destination. Local mode is a centralized switching mode in which all traffic is first sent to the wireless LAN controller to be centrally switched to its intended destination. Locate mode is not a valid mode, and therefore, it is an invalid answer."
    },
    {
       "id":1138,
       "topic_id":2,
       "sub_domain":"2.7 Describe physical infrastructure connections of WLAN components (AP, WLC, access/trunk ports, and LAG)",
       "practice_test_id":3,
       "question":"You have configured a LAG consisting of two links for your wireless LAN controller (WLC). What will happen if one of the links fails?",
       "choice_a":"Both links will enter into an err-disabled mode.",
       "choice_b":"The traffic on the failed link will be migrated to the active link.",
       "choice_c":"Both links will enter into an administratively disabled mode.",
       "choice_d":"Only half of the traffic will be sent over the active link.",
       "correct_answer":"B",
       "explanation":"When a link in a Link Aggregation (LAG) fails, the remaining traffic will be migrated over to the active link. No packet loss should be noticed, except for the initial failover. The links will not enter an err-disabled mode or be administratively disabled; this can only happen if there is a mismatch of protocols or the interfaces are shut down manually. All traffic is migrated to the active link, so no degradation should be seen on the active interface unless it is at peak capacity."
    },
    {
       "id":1139,
       "topic_id":2,
       "sub_domain":"2.8 Describe AP and WLC management access connections (Telnet, SSH, HTTP, HTTPS, console, and TACACS+/RADIUS)",
       "practice_test_id":3,
       "question":"Which protocol will encrypt the entire packet from the switch or router to the AAA server?",
       "choice_a":"802.1X",
       "choice_b":"IPsec",
       "choice_c":"RADIUS",
       "choice_d":"TACACS+",
       "correct_answer":"D",
       "explanation":"The TACACS+ protocol will encrypt the entire packet from the switch or router to the AAA server. This is performed with the use of a pre-shared key (PSK) that is configured on both the TACACS+ device and the AAA server. 802.1X will not encrypt the entire packet from the switch or router to the AAA server. IPsec is an open standard for encryption of packets, but it is not commonly used to encrypt the transmission of a switch or router to an AAA server. A Remote Authentication Dial-In User Service (RADIUS) server is an AAA server, and therefore, it is an invalid answer."
    },
    {
       "id":1140,
       "topic_id":2,
       "sub_domain":"2.8 Describe AP and WLC management access connections (Telnet, SSH, HTTP, HTTPS, console, and TACACS+/RADIUS)",
       "practice_test_id":3,
       "question":"Which copy method will encrypt the IOS over the network during an upgrade?",
       "choice_a":"HTTP",
       "choice_b":"TFTP",
       "choice_c":"FTP",
       "choice_d":"SCP",
       "correct_answer":"D",
       "explanation":"The Secure Copy Protocol (SCP) will encrypt the IOS over the network during an upgrade from the client computer. The Hyper Text Transfer Protocol (HTTP) is an unencrypted protocol normally used to transfer web pages across the Internet. The Trivial File Transfer Protocol (TFTP) is an unencrypted protocol for transferring files without any security. TFTP is often used to copy configuration or upgrade firmware on network devices. The File Transfer Protocol (FTP) is a legacy protocol used to transfer files between hosts. FTP operates in clear text and provides no encryption for the file transfers."
    },
    {
       "id":1141,
       "topic_id":2,
       "sub_domain":"2.9 Configure the components of a wireless LAN access for client connectivity using GUI only such as WLAN creation, security settings, QoS profiles, and advanced WLAN settings",
       "practice_test_id":3,
       "question":"When you configure a WLAN, what is the default QoS configured for the WLAN?",
       "choice_a":"Gold",
       "choice_b":"Silver",
       "choice_c":"Bronze",
       "choice_d":"Platinum",
       "correct_answer":"B",
       "explanation":"When you configure a WLAN and use the default QoS settings, the effective QoS is silver. Gold is used for video application on a wireless network. Bronze is the lowest level of traffic for unimportant traffic. Platinum is the highest level of traffic, and it is usually reserved for voice traffic over wireless."
    },
    {
       "id":1142,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":3,
       "question":"You configure Router A in the following exhibit with a route statement to get to Network B. However, you cannot ping a host on Network B. What is the problem?<img src='/question_assets/ccna/8_image6.png'></img>",
       "choice_a":"You must issue the <code>ip routing</code> command.",
       "choice_b":"The host on Network B is misconfigured.",
       "choice_c":"The host on Network A is misconfigured.",
       "choice_d":"You must enter a network route on Router B for Network A.",
       "correct_answer":"D",
       "explanation":"Your packets are most likely making it to the destination host. However, there is no route back to your host on the other network's router. You must enter a network route on Router B to get to Network A. You would not have been able to configure a route if the <code>ip routing</code> command was needed. The hosts on Network A and Network B are most likely not the problem."
    },
    {
       "id":1143,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":3,
       "question":"A router has three routes to the same network: one route from a RIP with a metric of 4, another from OSPF with a metric of 3053092, and another from EIGRP with a metric of 4039043. Which of the three routes will be used for the routing decision?",
       "choice_a":"EIGRP",
       "choice_b":"OSPF",
       "choice_c":"RIP",
       "choice_d":"All of the above",
       "correct_answer":"A",
       "explanation":"Enhanced Interior Gateway Routing Protocol (EIGRP) has the lowest administrative distance of the three protocols. Therefore, regardless of the metric, the lowest AD will always be chosen. All of the other options are incorrect."
    },
    {
       "id":1144,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":3,
       "question":"Why can a route have a destination of an interface rather than an IP address?",
       "choice_a":"Serial interfaces are point-to-point connections.",
       "choice_b":"The router on the other side of an interface routes all traffic discovered.",
       "choice_c":"Routing tables cause the destination address to change.",
       "choice_d":"All of the above.",
       "correct_answer":"A",
       "explanation":"Serial interfaces are point-to-point connections. Any traffic directed down the interface will automatically appear on the adjacent router. Routers will not process traffic normally unless Proxy ARP is configured for the interface. All of the other options are incorrect."
    },
    {
       "id":1145,
       "topic_id":3,
       "sub_domain":"3.1 Interpret the components of routing table",
       "practice_test_id":3,
       "question":"Which command will configure a static route with an administrative distance higher than RIP?",
       "choice_a":"<code>Router(config)#ip route 192.168.2.0 255.255.255.0 192.168.4.1 110</code>",
       "choice_b":"<code>Router(config)#ip route 192.168.2.0 255.255.255.0 192.168.4.1 130</code>",
       "choice_c":"<code>Router(config)#ip route 110 192.168.2.0 255.255.255.0 192.168.4.1</code>",
       "choice_d":"<code>Router(config)#ip route 130 192.168.2.0 255.255.255.0 192.168.4.1</code>",
       "correct_answer":"B",
       "explanation":"The administrative distance can be added to the end of the route statement. Since RIP has an administrative distance of 120, 130 will be chosen if the RIP route is not present. The command <code>ip route 192.168.2.0 255.255.255.0 192.168.4.1 110</code> is incorrect. The command <code>ip route 110 192.168.2.0 255.255.255.0 192.168.4.1</code> is incorrect. The command <code>ip route 130 192.168.2.0 255.255.255.0 192.168.4.1</code> is incorrect."
    },
    {
       "id":1146,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":3,
       "question":"What is the purpose of the RIPv2 hold down timer?",
       "choice_a":"Hold down timers allow for time between when a route becomes invalid and it is flushed from the routing table.",
       "choice_b":"Hold down timers allow for time between when a route has become unreachable and when it can be updated again.",
       "choice_c":"Hold down timers define the time when a route becomes invalid.",
       "choice_d":"Hold down timers define the time when a valid route is present in the routing table.",
       "correct_answer":"B",
       "explanation":"The hold down timer's job is to allow the network to stabilize after a route had become unreachable via an update. This limits the potential problems related to a flapping port and allows RIPv2 to converge route updates in the entire network. The default hold down timer is set to 180 seconds. The flush timer defines the time between when the route becomes invalid and is flushed or deleted from the route table. The default flush timer is set to 240 seconds. The invalid timer defines when a route is declared invalid. The default invalid timer is 180 seconds. The updatetimer is the timer that defines how often multicasts are sent with the complete route table. When the update is multicast to all listening neighbors, the route table will be populated with the new entries. The default updatetimer is 30 seconds."
    },
    {
       "id":1147,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":3,
       "question":"You perform a ping to a host on the network. However, the first packet is dropped. Why did the first packet drop?",
       "choice_a":"The local router dropped the first packet.",
       "choice_b":"The routing table was updating.",
       "choice_c":"The ARP request timed out the ping packet.",
       "choice_d":"The remote router dropped the first packet.",
       "correct_answer":"C",
       "explanation":"The ARP request took time for the ARP reply, and during this time, the ICMP timeout threshold was exceeded. This is common on a router, and the following pings should not time out unless the ARP entry is cleared after its TTL expires. The local router will not drop the first packet, mainly because routers don't normally drop traffic unless instructed to do so. Although the route table could be updating at that moment, it is not probable because this behavior can be replicated. The remote router, like the local router, will not normally drop packets unless instructed to do so."
    },
    {
       "id":1148,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":3,
       "question":"You are configuring RIP for a network and you need to advertise the network. Which command will advertise the route for 203.244.234.0/24?",
       "choice_a":"<code>Router(config-router)#network 203.244.234.0</code>",
       "choice_b":"<code>Router(config-router)#network 203.244.234.0 255.255.255.0</code>",
       "choice_c":"<code>Router(config-router)#network 203.244.234.0 0.0.0.255</code>",
       "choice_d":"<code>Router(config-router)#network 203.244.234.0/24</code>",
       "correct_answer":"A",
       "explanation":"The command <code>network 203.244.234.0</code> will advertise the 203.244.234.0 network. When you're configuring RIP, only the network address needs to be configured with the <code>network</code> command. The command <code>network 203.244.234.0 255.255.255.0</code> is incorrect. The command <code>network 203.244.234.0 0.0.0.255</code> is incorrect. The command <code>network 203.244.234.0/24</code> is incorrect."
    },
    {
       "id":1149,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":3,
       "question":"In the following exhibit, what type of routing is being used?<img src='/question_assets/ccna/8_image7.png'></img>",
       "choice_a":"Default routing",
       "choice_b":"SVI routing",
       "choice_c":"ROAS routing",
       "choice_d":"Stub routing",
       "correct_answer":"C",
       "explanation":"In the exhibit, packets are being sent to the router via a trunk link. A setup where the packets for VLANs are sent to a router for routing between VLANs is called router on a stick (ROAS) routing. Default routing, also known as stub routing, is normally used on stub networks, where all networks are available through the gateway of last resort. Switched virtual interface (SVI) routing is performed on layer 3 switches. A virtual interface is created that will have an IP address and routing capabilities."
    },
    {
       "id":1150,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":3,
       "question":"Which command must be enabled on a switch to enable routing between switched virtual interfaces for VLAN routing?",
       "choice_a":"<code>Switch(config)#ip route svi</code>",
       "choice_b":"<code>Switch(config)#feature svi routing</code>",
       "choice_c":"<code>Switch(config)#svi routing</code>",
       "choice_d":"<code>Switch(config)#ip routing</code>",
       "correct_answer":"D",
       "explanation":"When you want to turn on the layer 3 functionality of a switch, you must configure the command <code>ip routing</code> in global configuration. This is required when you want to create Switched Virtual Interfaces (SVIs) for VLANs and want to route on the switch between the VLANs. This method of routing is much more efficient since the traffic is routed in the ASICs on the switch. The command <code>ip route svi</code> is incorrect. The command <code>feature svi routing</code> is incorrect. The command <code>svi routing</code> is incorrect."
    },
    {
       "id":1151,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":3,
       "question":"In the following exhibit, why do the first and third ARP entries have a dash for their age?<img src='/question_assets/ccna/8_image8.png'></img>",
       "choice_a":"The entries are static ARP entries.",
       "choice_b":"The entries have just been added to the ARP table.",
       "choice_c":"The entries belong to the physical interfaces of the router.",
       "choice_d":"The entries have less than 1 minute before they expire.",
       "correct_answer":"C",
       "explanation":"The entries with the dash in the Age column represent the physical interfaces of the router. If the entries were configured statically, their type would reflect a status of <code>static</code>. Entries that have just been added to the ARP table will have an initial timer set. All entries in the ARP table will be displayed with their remaining time in seconds. Therefore, any entry with less than a minute left before expire will be under 60 seconds."
    },
    {
       "id":1152,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":3,
       "question":"Which field in the IP header is used to prevent a packet from endlessly routing?",
       "choice_a":"Checksum",
       "choice_b":"Flags",
       "choice_c":"TTL",
       "choice_d":"Header length",
       "correct_answer":"C",
       "explanation":"Time to live (TTL) is a field in the IP header that prevents packets from endlessly routing in networks. Each time a packet is routed, the router's responsibility is to decrement the TTL by one. When the TTL reaches zero, the packet is considered unrouteable and dropped. The checksum field is used to check for a damaged packet in transit. The flags field in the IP packet is to signal if the packet has been fragmented. The header length field defines the length of the header of the IP packet."
    },
    {
       "id":1153,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":3,
       "question":"Which packet forwarding method is the fastest and does not directly use the central processing unit (CPU)?",
       "choice_a":"Cisco Express Forwarding (CEF)",
       "choice_b":"Process switching",
       "choice_c":"Fast switching",
       "choice_d":"Expedited forwarding",
       "correct_answer":"A",
       "explanation":"Cisco Express Forwarding (CEF) allows the CPU to initially populate a sort of route cache called the forwarding information base (FIB). Any packets entering the router can be checked against the FIB and routed without the help of the CPU. Process switching and fast switching both use the processor directly to make routing decisions. Expedited forwarding is not a packet routing technique; it is a quality of service (QoS) method and therefore an invalid answer."
    },
    {
       "id":1154,
       "topic_id":3,
       "sub_domain":"3.2 Determine how a router makes a forwarding decision by default",
       "practice_test_id":3,
       "question":"You see a number of IPv6 packets on your network with a destination address of ff02::a. What can be concluded about what is running on your network?",
       "choice_a":"Routing Information Protocol Next Generation (RIPng) is running on the network.",
       "choice_b":"Open Shortest Path First version 3 (OSPFv3) is running on the network.",
       "choice_c":"Enhanced Interior Gateway Routing Protocol (EIGRP) for IPv6 is running on the network.",
       "choice_d":"Stateless Address Auto configuration (SLAAC) is running on the network.",
       "correct_answer":"C",
       "explanation":"The multicast address of ff02::a is the multicast address for IPv6 EIGRP updates. Updates for routers participating in IPv6 EIGRP will be multicast to the IPv6 address of ff02::a. Routing Information Protocol Next Generation (RIPng) uses a multicast address of ff06::9. Open Shortest Path First version 3 (OSPFv3) uses multicast addresses of ff05::5 and ff05::6. Stateless Auto configuration (SLAAC) uses the link-local address that starts with fe80."
    },
    {
       "id":1155,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":3,
       "question":"You ping from a router to another router and receive back <code>!!!!!</code>. What does this mean?",
       "choice_a":"All packets have been dropped.",
       "choice_b":"All packets are successfully acknowledged.",
       "choice_c":"There is congestion in the path.",
       "choice_d":"The packets were received, but after the ICMP timeout.",
       "correct_answer":"B",
       "explanation":"When you see an exclamation mark, it means that the packets were successfully acknowledged on the other side and an ICMP response was received. If you see five periods returned, it means that the packets have never made it back to the router. Congestion in the path will not be visible with the ping command. If the packets are received on the far router but ICMP times out, periods will be displayed."
    },
    {
       "id":1156,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":3,
       "question":"You want to ping a router on your network from interface Serial 0/0 and not the path in the routing table. How can you achieve this?",
       "choice_a":"This cannot be done; packets cannot disregard the routing table.",
       "choice_b":"Enter the interface from the global configuration mode, and ping the remote router.",
       "choice_c":"Enter extended ping, and specify the exit interface.",
       "choice_d":"Configure a temporary route for the router exit interface.",
       "correct_answer":"C",
       "explanation":"The extended ping command allows you to specify a number of parameters such as repeat count, datagram size, and source address or exit interface. There are several other parameters that can be adjusted. You use the extended <code>ping</code> command through the privileged exec prompt and not the global configuration mode. Configuring a temporary route for the router exit interface will affect all traffic on the router."
    },
    {
       "id":1157,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":3,
       "question":"You perform a traceroute to a destination network and receive back several lines of output. On the end of each line are three parameters such as <code>1 192.168.1.1 20 msec 34 msec 67 msec</code>. What do they mean?",
       "choice_a":"They are the three response times of each ICMP request.",
       "choice_b":"They are the minimum, maximum, and average of the ICMP query.",
       "choice_c":"They are the minimum, average, and maximum of the ICMP query.",
       "choice_d":"They are the maximum, average, and minimum of the ICMP query.",
       "correct_answer":"C",
       "explanation":"The three times are the minimum response time, average response time, and maximum response time of the ICMP echo and reply. All other options are incorrect."
    },
    {
       "id":1158,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":3,
       "question":"Which key sequence will cause a break during a network command such as <code>ping</code> or <code>traceroute</code>?",
       "choice_a":"Ctrl+C",
       "choice_b":"Ctrl+4",
       "choice_c":"Ctrl+Shift+6",
       "choice_d":"Ctrl+Shift+1",
       "correct_answer":"C",
       "explanation":"The Ctrl+Shift+6 key sequence will cause a break during a network command such as <code>ping or traceroute</code>. The key sequence of Ctrl+C is incorrect. The key sequence of Ctrl+4 is incorrect. The key sequence of Ctrl+Shift+1 is incorrect."
    },
    {
       "id":1159,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":3,
       "question":"In the following exhibit, Host A suddenly cannot communicate with Host B. Using the <code>ping</code> command, which device will you ping first to diagnose the problem?<img src='/question_assets/ccna/8_image9.png'></img>",
       "choice_a":"Switch A",
       "choice_b":"Router A",
       "choice_c":"Router B",
       "choice_d":"Switch B",
       "correct_answer":"B",
       "explanation":"When you are diagnosing a network connectivity issue, you always start testing the closest IP address. In this case, the default gateway of Router A is the closest IP address. The switches are irrelevant because they are not layer 3 devices that can be tested at layer 3. The fact that it has an IP address and can return a ping means that you can communicate with its management plane. The Internet Control Message Protocol (ICMP) packet will traverse the data plane, also called the forwarding plane. All of the other options are incorrect."
    },
    {
       "id":1160,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":3,
       "question":"Which command can you use to verify that a ping packet is exiting the interface you expect it to exit, which in this example is Gi0/1 with an IP address of 192.168.3.5?",
       "choice_a":"<code>Router#ping 192.168.3.5 Gi 0/1</code>",
       "choice_b":"<code>Router#ping Gi 0/1 192.168.3.5</code>",
       "choice_c":"<code>Router#debug ip packet</code>",
       "choice_d":"<code>Router#debug ip ping</code>",
       "correct_answer":"C",
       "explanation":"The command <code>debug ip packet</code> will turn on debugging for IP packets. The output will display the exit interface that the traffic is taking, to include the source and destination IP addresses. This command should be used with caution because it could create high CPU utilization on the router. It is recommended to be used with an ACL. The command <code>ping 192.168.3.5 Gi 0/1</code> is incorrect. The command <code>ping Gi 0/1 192.168.3.5</code> is incorrect. The command <code>debug ip ping</code> is incorrect."
    },
    {
       "id":1161,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":3,
       "question":"Which is a correct statement about the following exhibit?<img src='/question_assets/ccna/8_image10.png'></img>",
       "choice_a":"The third hop is down.",
       "choice_b":"The third hop is not responding to ICMP requests.",
       "choice_c":"The traceroute never completed.",
       "choice_d":"The third hop is unavailable and packets have been rerouted.",
       "correct_answer":"B",
       "explanation":"The third hop (router) is not responding to ICMP echo requests. The traceroute completes since the fourth hop responded and the user did not need to perform a break on the command. Therefore, it can be concluded that the third hop is not down. The traceroute completes after four hops; only the third hop is not responding with ICMP replies. The exhibit does not show evidence that packets have been rerouted."
    },
    {
       "id":1162,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":3,
       "question":"Which additional feature is available when using an extended ping?",
       "choice_a":"Larger datagram size",
       "choice_b":"Larger repeat counts",
       "choice_c":"Changing the timeout",
       "choice_d":"Source interface or IP address",
       "correct_answer":"D",
       "explanation":"An extended ping allows for the source interface or IP address to be specified. You can access the extended ping by entering the command <code>ping</code> without an IP address and then following the prompt till it asks if you want extended commands. Datagram size, repeat counts, and timeout can be set when using the normal <code>ping</code> command options."
    },
    {
       "id":1163,
       "topic_id":3,
       "sub_domain":"3.3 Configure and verify IPv4 and IPv6 static routing",
       "practice_test_id":3,
       "question":"You want to perform a traceroute with more than three ICMP packets using an extended traceroute. Which attribute will you change to allow for multiple ICMP packets?",
       "choice_a":"Probe count",
       "choice_b":"Numeric display",
       "choice_c":"Maximum time to live",
       "choice_d":"Packet type",
       "correct_answer":"A",
       "explanation":"The probe count attribute must be changed to allow multiple packets to be sent to each hop. The default is three packets. Numeric display defaults to both numbers and symbols for the output. The maximum time to live (TTL) is used to set the number of hops before a ping request is considered unrouteable. Packet type is not an option for an extended traceroute; therefore, this is an invalid answer."
    },
    {
       "id":1164,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":3,
       "question":"Which statement is true of routers in the same area in regard to OSPF?",
       "choice_a":"All routers in the same area have the same neighbor table.",
       "choice_b":"All routers in the same area have the same hello/dead timers.",
       "choice_c":"All routers in the same area have the same topology table.",
       "choice_d":"All routers in the same area have the same process IDs.",
       "correct_answer":"C",
       "explanation":"An area defines a topology inside of the OSPF hierarchy. Since each router in an area calculates its own costs, they all contain the same topological database, or LSDB. It is not true that all the routers in the same area have the same neighbor table. All routers in the same area do not need to share the same hello/dead timers; only their adjacent routers must be configured with matching hello/dead timers. All routers do not need the same process ID since this is a local value to define the process OSPF is running on the local router."
    },
    {
       "id":1165,
       "topic_id":3,
       "sub_domain":"3.4 Configure and verify single area OSPFv2",
       "practice_test_id":3,
       "question":"Which OSPF packets contain link-state and routing information?",
       "choice_a":"Hello packets",
       "choice_b":"LSA packets",
       "choice_c":"LSAck packets",
       "choice_d":"Dead packets",
       "correct_answer":"B",
       "explanation":"Link-State Advertisement (LSA) packets communicate the topology of the local router with other routers in the OSPF area. The information contained in the LSA packet is a summary of links the local router's topology consists of. Hello packets are used to notify adjacent routers that the link is still valid. The Link State Acknowledgment (LSAck) packets verify that an LSA has been received. Dead packets are not a real type of packet because when a link goes down, there will be an absence of Hello packets, tripping the dead time."
    },
    {
       "id":1166,
       "topic_id":3,
       "sub_domain":"3.5 Describe the purpose of first hop redundancy protocol",
       "practice_test_id":3,
       "question":"What option should be configured along with interface tracking that will allow the original router to regain its active status once a failed link is repaired?",
       "choice_a":"Interface tracking resets",
       "choice_b":"Failback option",
       "choice_c":"Preempt option",
       "choice_d":"Priority tracking",
       "correct_answer":"C",
       "explanation":"When interface tracking is turned on and a link that is being tracked fails, the priority of the active router is lowered and an election is forced. This will make the standby router become the active router. However, if the link is repaired, the priority will recover to its normal value, but the current active router will remain the active router. Preemption allows for the value to instantly reelect the original router as the active router. Interface tracking resets, failback options, and priority tracking are not valid options for interface tracking; therefore, these are invalid answers."
    },
    {
       "id":1167,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":3,
       "question":"Which is a disadvantage of using NAT?",
       "choice_a":"Creates switching path delays",
       "choice_b":"Introduces security weaknesses",
       "choice_c":"Requires address renumbering",
       "choice_d":"Increases bandwidth utilization",
       "correct_answer":"A",
       "explanation":"Network Address Translation (NAT) creates packet switching path delay. This is because each address traveling through the NAT process requires lookup time for the translation. NAT does not introduce security weaknesses; it can actually be used to strengthen security since private IP addresses are masqueraded behind a public IP address. NAT is often used so that address renumbering is not required when two networks are merged together with identical IP addressing. NAT does not increase bandwidth utilization at all."
    },
    {
       "id":1168,
       "topic_id":4,
       "sub_domain":"4.1 Configure and verify inside source NAT using static and pools",
       "practice_test_id":3,
       "question":"Which type of NAT is used for one-to-one mapping between local and global addresses?",
       "choice_a":"Dynamic NAT",
       "choice_b":"Static NAT",
       "choice_c":"NAT Overloading",
       "choice_d":"Symmetric NAT",
       "correct_answer":"B",
       "explanation":"Static Network Address Translation (NAT) is a one-to-one mapping between a local (private) and global (public) IP address. This is used for servers, such as web servers and email servers, so that they are Internet reachable. Dynamic NAT creates a dynamic association between local and global addresses for a specific period of time. NAT Overloading, also known as Port Address Translation (PAT), creates a dynamic mapping to a pool of IP addresses or an individual IP address using the source and destination ports of the packet. Symmetric NAT is NAT Overloading where the source port and destination port are mapped to the same matching global source port and destination port."
    },
    {
       "id":1169,
       "topic_id":4,
       "sub_domain":"4.2 Configure and verify NTP operating in a client and server mode",
       "practice_test_id":3,
       "question":"Which protocol helps synchronize time for routers and switches?",
       "choice_a":"SNMP",
       "choice_b":"NTP",
       "choice_c":"Syslog",
       "choice_d":"ICMP",
       "correct_answer":"B",
       "explanation":"The Network Time Protocol (NTP) is used to synchronize time for routers and switches. Simple Network Management Protocol (SNMP) is used to transmit and collect counters on network devices. Syslog is used to transmit and collect messages from network devices. Internet Control Message Protocol (ICMP) is used by many diagnostic tools such as ping and traceroute to communicate round trip time and reachability."
    },
    {
       "id":1170,
       "topic_id":4,
       "sub_domain":"4.3 Explain the role of DHCP and DNS within the network",
       "practice_test_id":3,
       "question":"Which protocol and port number does DNS use for direct queries?",
       "choice_a":"UDP/53",
       "choice_b":"TCP/53",
       "choice_c":"UDP/55",
       "choice_d":"UDP/68",
       "correct_answer":"A",
       "explanation":"Domain Name Services (DNS) direct queries are performed over the UDP protocol to port 53. The queries do not require the TCP setup and teardown because the queries are simple request and reply messages, so UDP is used for direct queries. TCP port 53 is used for DNS zone transfers between DNS servers. UDP port 55 is not used for any popular protocols. UDP port 68 is used with the Dynamic Host Configuration Protocol (DHCP)."
    },
    {
       "id":1171,
       "topic_id":4,
       "sub_domain":"4.4 Explain the function of SNMP in network operations",
       "practice_test_id":3,
       "question":"Which version of SNMP supports the Inform SNMP message?",
       "choice_a":"SNMP version 1",
       "choice_b":"SNMP version v2",
       "choice_c":"SNMP version 2c",
       "choice_d":"SNMP version 3",
       "correct_answer":"C",
       "explanation":"The introduction of SNMP version 2c added the Inform and Get-bulk messages for SNMP. SNMP version 1 was the first release of SNMP, and it did not support Inform and Get-bulk messages. SNMP version 2 was promptly replaced with SNMP version 2c; therefore, it is an invalid answer. SNMP version 3 introduced many new features such as security and encryption, to name a few."
    },
    {
       "id":1172,
       "topic_id":4,
       "sub_domain":"4.5 Describe the use of syslog features including facilities and levels",
       "practice_test_id":3,
       "question":"Which command will configure all event logs to be sent to a syslog server?",
       "choice_a":"<code>Router(config)#logging server 192.168.1.6</code>",
       "choice_b":"<code>Router(config)#logging 192.168.1.6</code>",
       "choice_c":"<code>Router(config)#logging host 192.168.1.6</code>",
       "choice_d":"<code>Router(config)#syslog server 192.168.1.6</code>",
       "correct_answer":"C",
       "explanation":"The command <code>logging host 192.168.1.6</code> will configure all logs to be sent to the syslog server 192.168.1.6. The command <code>logging server 192.168.1.6</code> is incorrect. The command <code>logging 192.168.1.6</code> is incorrect. The command <code>syslog server 192.168.1.6</code> is incorrect."
    },
    {
       "id":1173,
       "topic_id":4,
       "sub_domain":"4.6 Configure and verify DHCP client and relay",
       "practice_test_id":3,
       "question":"Which command will configure a router to use DHCP for IP address assignment?",
       "choice_a":"<code>RouterA(config)#ip address dhcp</code>",
       "choice_b":"<code>RouterA(config-if)#ip address auto</code>",
       "choice_c":"<code>RouterA(config-if)#ip address dhcp</code>",
       "choice_d":"<code>RouterA(config)#ip address auto</code>",
       "correct_answer":"C",
       "explanation":"The command <code>ip address dhcp</code> will configure the router to use DHCP for IP address assignment. This command needs to be issued on the interface in which you want the IP address to be configured, similar to static IP address assignment. The command <code>ip address dhcp</code> is incorrect, when it is configured in the global configuration prompt. The command <code>ip address auto</code> is incorrect, regardless of which prompt it is configured in."
    },
    {
       "id":1174,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":3,
       "question":"Which measurement describes the time a packet takes from source to destination?",
       "choice_a":"Bandwidth",
       "choice_b":"Delay",
       "choice_c":"Jitter",
       "choice_d":"Loss",
       "correct_answer":"B",
       "explanation":"Delay is the time it takes for a packet to travel from source to destination, which is a description of one-way delay. Round-trip delay is the time it takes for the packet to travel from source to destination (one-way delay) plus the time it takes for the destination computer to send the packet back to the originating node to form a round trip. Bandwidth is the measured maximum of throughput for a connection. Jitter is the difference between the delay of packets. Loss is the measurement of packets lost in the transfer of data."
    },
    {
       "id":1175,
       "topic_id":4,
       "sub_domain":"4.7 Explain the forwarding per-hop behavior (PHB) for QoS such as classification, marking, queuing, congestion, policing, shaping",
       "practice_test_id":3,
       "question":"Which layer 3 protocol is used for marking packets with QoS?",
       "choice_a":"DSCP",
       "choice_b":"802.1Q",
       "choice_c":"CoS",
       "choice_d":"QoE",
       "correct_answer":"A",
       "explanation":"The Differentiated Services Code Point (DSCP) is a 6-bit value in the Type of Service (ToS) field of the IP header. The DSCP value defines the importance of packets at layer 3. 802.1Q is a layer 2 trunking protocol that accommodates CoS markings. Class of Service (CoS) is a 3-bit field in an 802.1Q Ethernet frame. <italic>QoE</italic> is not a valid term used with Ethernet and therefore is an invalid answer."
    },
    {
       "id":1176,
       "topic_id":4,
       "sub_domain":"4.8 Configure network devices for remote access using SSH",
       "practice_test_id":3,
       "question":"You have enabled the SCP server on a switch, but when you try to log in it returns \u0022access denied.\u0022 Which command must you configure to allow access to the SCP server if your username was <italic>scpadmin</italic> and your password was <italic>Sybex</italic>?",
       "choice_a":"<code>Switch(config)#ip scp user scpadmin password Sybex</code>",
       "choice_b":"<code>Switch(config)#username scpadmin password Sybex</code>",
       "choice_c":"<code>Switch(config)#username scpadmin privilege-level 15 password Sybex</code>",
       "choice_d":"<code>Switch(config)#ip scp user scpadmin privilege-level 15 password Sybex</code>",
       "correct_answer":"C",
       "explanation":"The command <code>username scpadmin privilege-level 15 password Sybex</code> must be configured. This command will configure a user named scpadmin with a privilege level of 15 (enable access) and a password of <italic>Sybex</italic>. The command <code>ip scp user scpadmin password Sybex</code> is incorrect. The command <code>username scpadmin password Sybex</code> is incorrect. The command <code>ip scp user scpadmin privilege-level 15 password Sybex</code> is incorrect."
    },
    {
       "id":1177,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":3,
       "question":"In a basic VLAN hopping attack, which switch feature do attackers take advantage of?",
       "choice_a":"An open Telnet connection",
       "choice_b":"Automatic encapsulation negotiation",
       "choice_c":"Forwarding of broadcasts",
       "choice_d":"The default automatic trunking configuration",
       "correct_answer":"D",
       "explanation":"An attacker will take advantage of the automatic trunking configuration of Dynamic Trunking Protocol (DTP). This will allow the attacker to create a trunk with the switch and tag packets so that they can hop onto different VLANs. An open Telnet connection can be eavesdropped on since it is in clear text. <italic>Automatic encapsulation negotiation</italic> is not a valid term used with switching; therefore, it is an invalid answer. Forwarding of broadcasts is not really an exploit; it is a function of switching. Routers will stop the forwarding of broadcasts."
    },
    {
       "id":1178,
       "topic_id":5,
       "sub_domain":"5.1 Define key security concepts (threats, vulnerabilities, exploits, and mitigation",
       "practice_test_id":3,
       "question":"Which security mitigation technique can be used to stop a MAC address flooding attack?",
       "choice_a":"ACLs",
       "choice_b":"NAT",
       "choice_c":"Port security",
       "choice_d":"VLAN access control lists (VACLs)",
       "correct_answer":"C",
       "explanation":"Port security can prevent MAC address flooding attacks by restricting the number of MAC addresses associated to an interface. This will prevent the Content Addressable Memory (CAM) from being overrun by bogus entries. Access control lists (ACLs) will allow you to control layer 3 and layer 4 network traffic but are not used to prevent MAC address flooding attacks. Network Address Translation (NAT) is also not used to prevent MAC address flooding attacks. VLAN access control lists (VACLs) can be used to control layer 2, 3, and 4 traffic, but they are not used to prevent MAC address flooding attacks."
    },
    {
       "id":1179,
       "topic_id":5,
       "sub_domain":"5.2 Describe security program elements (user awareness, training, and physical access control)",
       "practice_test_id":3,
       "question":"Which of the following is a recommended physical security method?",
       "choice_a":"Locking doors",
       "choice_b":"Installing antivirus software",
       "choice_c":"Enabling firewalls",
       "choice_d":"Applying directory-level permissions",
       "correct_answer":"A",
       "explanation":"Locking doors is a recommended physical security method. Installing antivirus software is a form of digital protection. Firewalls are considered logical security. Directory-level permissions are considered a form of logical security."
    },
    {
       "id":1180,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":3,
       "question":"You are connected to the console of a switch. As you are configuring the switch, console logging is disrupting your commands and making it hard to configure the switch properly. Which command will allow the console message to still appear but not disrupt what you are typing?",
       "choice_a":"<code>Switch#no logging inline</code>",
       "choice_b":"<code>Switch(config)#logging synchronous</code>",
       "choice_c":"<code>Switch(config-line)#logging synchronous</code>",
       "choice_d":"<code>Switch#logging synchronous</code>",
       "correct_answer":"C",
       "explanation":"The command <code>logging synchronous</code> will configure console logging messages to synchronize with what is being typed so they will not disrupt the user's input. The command must be configured for the line that it will be applied to. The command <code>no logging inline</code> is incorrect. The command <code>logging synchronous</code> is incorrect when configured from a global configuration prompt. The command <code>logging synchronous</code> is incorrect when configured from a privileged exec prompt."
    },
    {
       "id":1181,
       "topic_id":5,
       "sub_domain":"5.3 Configure device access control using local passwords",
       "practice_test_id":3,
       "question":"You have a router that you configured with a password, but you have forgotten the password. You have a copy of a recent configuration, and the password line reads as <code>password 7 06074352EFF6</code>. How can you access the router?",
       "choice_a":"You must call the Cisco Technical Assistance Center to reverse the password.",
       "choice_b":"You need to enter the password <italic>06074352EFF6</italic>.",
       "choice_c":"Log into another router and type <code>decrypt-password 06074352EFF6</code> in privileged exec mode.",
       "choice_d":"Perform a password recovery on the router.",
       "correct_answer":"D",
       "explanation":"Once the password has been forgotten, a password recovery must be performed on the router. Although you have the encrypted password, it cannot be reversed since the configuration now contains a one-way hash of the password. A one-way hash is a form of symmetrical encryption of the password; only the same combination of letters and number will produce the same hash. The Cisco Technical Assistance Center (TAC) cannot reverse the password. The hash cannot be used as the password; only the password can be used, and it is then checked against the hash. There is also no command in the operating system such as <code>decrypt-password 06074352EFF6</code> to decrypt the password."
    },
    {
       "id":1182,
       "topic_id":5,
       "sub_domain":"5.4 Describe security password policies elements, such as management, complexity, and password alternatives (multifactor authentication, certificates, and biometrics)",
       "practice_test_id":3,
       "question":"Which port must be open to the RADIUS or AAA server for authentication from the authenticator?",
       "choice_a":"UDP/49",
       "choice_b":"UDP/1821",
       "choice_c":"UDP/1812",
       "choice_d":"UDP/1813",
       "correct_answer":"C",
       "explanation":"The AAA server listens for requests on UDP port 1812 for authentication of credentials. UDP port 49 is not correct and is not associated with a popular protocol. UDP port 1821 is not correct and is also not associated with a popular protocol. UDP port 1813 is used for AAA servers listening for accounting information."
    },
    {
       "id":1183,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":3,
       "question":"What is a consideration that can restrict GRE tunnel creation?",
       "choice_a":"The tunnel interface number",
       "choice_b":"ACLs on the firewall",
       "choice_c":"Speed of the tunnel",
       "choice_d":"Number of hops between the source and destination",
       "correct_answer":"B",
       "explanation":"ACLs are a major consideration since they are neither TCP nor UDP; they are a layer 3 protocol of their own. The ACL required for the tunnel creation is <code>permit gre {source} {destination}</code>, which would be for a named access list. The tunnel interface number is only locally significant to the router. The adjoining router will never know the tunnel interface number. Speed of the tunnel is not a consideration that can restrict tunnel creation. Generic Routing Encapsulation (GRE) is expressly used to reduce the number of hops between the source and destination. When employed, it allows the remote network to look like it is one hop away, so the number of hops between the source and destination is not a consideration that can restrict tunnel creation."
    },
    {
       "id":1184,
       "topic_id":5,
       "sub_domain":"5.5 Describe remote access and site-to-site VPNs",
       "practice_test_id":3,
       "question":"Which WAN protocol does not support multicast packets?",
       "choice_a":"GRE",
       "choice_b":"IPsec",
       "choice_c":"PPP",
       "choice_d":"MPLS",
       "correct_answer":"B",
       "explanation":"Internet Protocol Security (IPsec) does not support multicast packets. If you require both, you can set up a Generic Routing Encapsulation (GRE) tunnel for the multicast and broadcast traffic, then encrypt only the data over IPsec. However, by itself IPsec does not support multicast or broadcast traffic. The Point-to-Point Protocol (PPP) does not support multicast packets. Multiprotocol Label Switching (MPLS) does not natively support multicast packets."
    },
    {
       "id":1185,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":3,
       "question":"Which command will configure an access list that will deny Telnet access from the 192.168.2.0/24 network and allow all other traffic?",
       "choice_a":"<code>Router(config)#access-list 101 deny tcp 192.168.2.0 0.0.0.255 any eq 23</code><br><code>Router(config)#access-list 101 permit ip any any</code>",
       "choice_b":"<code>Router(config)#access-list 101 deny 192.168.2.0 0.0.0.255 eq 23</code><br><code>Router(config)#access-list 101 permit ip any any</code>",
       "choice_c":"<code>Router(config)#access-list 101 block tcp 192.168.2.0 0.0.0.255 any eq 23</code><br><code>Router(config)#access-list 101 permit ip any any</code>",
       "choice_d":"<code>Router(config)#access-list 101 deny 192.168.2.0 0.0.0.255 any eq 23</code><br><code>Router(config)#access-list 101 permit any any</code>",
       "correct_answer":"A",
       "explanation":"The command <code>access-list 101 deny tcp 192.168.2.0 0.0.0.255 any eq 23</code> will deny TCP traffic from 192.168.2.0/24 to any address with a destination of 23 (Telnet). The command <code>access-list 101 permit ip any any</code> will permit all other traffic. The commands <code>access-list 101 deny 192.168.2.0 0.0.0.255 eq 23</code> and <code>access-list 101 permit ip any any</code> are incorrect; the deny statement is incorrectly formatted. The commands <code>access-list 101 block tcp 192.168.2.0 0.0.0.255 any eq 23</code> and <code>access-list 101 permit ip any any</code> are incorrect; the <code>block</code> argument is not a valid argument. The commands <code>access-list 101 deny 192.168.2.0 0.0.0.255 any eq 23</code> and <code>access-list 101 permit any any</code> are incorrect; the <code>permit any any</code> command does not specify a protocol and therefore is incorrect."
    },
    {
       "id":1186,
       "topic_id":5,
       "sub_domain":"5.6 Configure and verify access control lists",
       "practice_test_id":3,
       "question":"You need to make a modification to a rule in a standard conventional access list. How can you achieve this?",
       "choice_a":"Enter the ACL editor and change the entry.",
       "choice_b":"Remove the entire ACL and add it back with the modification.",
       "choice_c":"Remove the line number and add the new line number back with the modification.",
       "choice_d":"Remove the entry with the <code>no</code> command and add it back.",
       "correct_answer":"B",
       "explanation":"Conventional access lists don't give you the ability to edit a single entry. The entire ACL must be removed and re-added with the correct entry. An alternative to conventional access lists is named access lists. A named access list is referenced by line numbers, which allows for removal and additions of single entries. Unfortunately, the Cisco IOS does not provide an ACL editor for conventional access lists. You can remove the line number and add a new line number back when you use named access lists. However, this functionality is not available for conventional access lists. Conventional access lists can be completely negated with the <code>no</code> command, but you cannot negate a single entry."
    },
    {
       "id":1187,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":3,
       "question":"Which command is used to view the DHCP snooping database?",
       "choice_a":"<code>Switch#show dhcp binding</code>",
       "choice_b":"<code>Switch#show ip dhcp binding</code>",
       "choice_c":"<code>Switch#show ip dhcp snooping database</code>",
       "choice_d":"<code>Switch#show ip dhcp snooping binding</code>",
       "correct_answer":"D",
       "explanation":"The command <code>show ip dhcp snooping binding</code> will display the DHCP snooping database. This database will have entries for the MAC address, IP address, lease time, VLAN, and interface. The command <code>show dhcp binding</code> is incorrect. The command <code>show ip dhcp binding</code> is incorrect. The command <code>show ip dhcp snooping database</code> is incorrect."
    },
    {
       "id":1188,
       "topic_id":5,
       "sub_domain":"5.7 Configure Layer 2 security features (DHCP snooping, dynamic ARP inspection, and port security)",
       "practice_test_id":3,
       "question":"Refer to the following exhibit. What will happen when a computer with a different MAC address connects to the interface?<img src='/question_assets/ccna/8_image11.png'></img>",
       "choice_a":"The computer will not be allowed to communicate, but the port will remain up.",
       "choice_b":"The computer will be allowed to communicate.",
       "choice_c":"The computer will not be allowed to communicate and the port will enter an err-disabled state.",
       "choice_d":"The computer will be allowed to communicate and the access will be logged.",
       "correct_answer":"C",
       "explanation":"The computer will not be allowed to communicate, and the port will enter an err-disabled state. The defaults for port security allow for only one MAC address, and the default violation is shutdown. The violation of shutdown will shut the port down and place it into an err-disabled state, which will require administrative intervention. Port security cannot be configured in a fashion where it only provides logging and does not restrict the violating MAC address (host)."
    },
    {
       "id":1189,
       "topic_id":5,
       "sub_domain":"5.8 Differentiate authentication, authorization, and accounting concepts",
       "practice_test_id":3,
       "question":"Which authentication method will allow an authenticated user to access only certain commands on a router or switch?",
       "choice_a":"TACACS+",
       "choice_b":"AAA",
       "choice_c":"RADIUS",
       "choice_d":"802.1X",
       "correct_answer":"A",
       "explanation":"TACACS+ will allow for authentication of users, and it also provides a method of restricting users to specific commands. This allows for much more granular control of lower-level administrators. Authentication, authorization, and accounting (AAA) servers, also known as Remote Authentication Dial-In User Service (RADIUS) servers, are generally configured to enable access for routers or switches. The 802.1X protocol is not used to authenticate users for management access in routers or switches. The 802.1X protocol is used to control access to layer 2 switched ports."
    },
    {
       "id":1190,
       "topic_id":5,
       "sub_domain":"5.9 Describe wireless security protocols (WPA, WPA2, and WPA3)",
       "practice_test_id":3,
       "question":"You need to implement a wireless authentication system that provides encryption and authentication of user accounts. Which technology would you deploy?",
       "choice_a":"WPA2-PSK",
       "choice_b":"WPA2-EAP",
       "choice_c":"WPA2-LEAP",
       "choice_d":"WPA3-PSK",
       "correct_answer":"C",
       "explanation":"Wi-Fi Protected Access 2 - Lightweight Extensible Authentication Protocol (WPA2-LEAP) is a Cisco proprietary protocol that allows for user accounts to be authenticated via a RADIUS server to Active Directory (AD). WPA2-LEAP will provide both encryption and user authentication. Wi-Fi Protected Access 2 - Pre-Shared Key (WPA2-PSK) and WPA3-PSK will not provide user authentication, since they use a pre-shared key. Wi-Fi Protected Access 2 - Extensible Authentication Protocol (WPA2-EAP) uses certificates to authenticate the computer account connecting to the wireless network."
    },
    {
       "id":1191,
       "topic_id":5,
       "sub_domain":"5.10 Configure WLAN using WPA2 PSK using the GUI",
       "practice_test_id":3,
       "question":"When configuring a WLAN with WPA2 PSK using the GUI of a wireless LAN controller, which parameter policy should be configured for the highest security?",
       "choice_a":"802.1X",
       "choice_b":"WPA2 Policy-AES",
       "choice_c":"WPA Policy",
       "choice_d":"PSK",
       "correct_answer":"B",
       "explanation":"When configuring WPA2 PSK using the GUI of a wireless LAN controller (WLC), you should select the WPA2 Policy-AES for the WPA+WPA2 Parameter policy. This policy will ensure the highest level of security for the WLAN. 802.1X and PSK are authentication key management options and therefore not valid answers. The WPA Policy uses the RC4 encryption algorithm, and thus, it is weaker than the AES encryption protocol."
    },
    {
       "id":1192,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":3,
       "question":"Which is the most important aspect to understand when automating changes across an enterprise?",
       "choice_a":"How to automate the change",
       "choice_b":"The effect of the change",
       "choice_c":"The topology of the network",
       "choice_d":"The connections between the devices",
       "correct_answer":"B",
       "explanation":"The most important aspect to understand when automating a change across an enterprise is the effect of the changes being automated. Although the way the change is to be automated is important, the effects outweigh the method of the change. The topology of the devices and the connection between them are not that important to the automated change unless the topology and connections are being changed through the automation."
    },
    {
       "id":1193,
       "topic_id":6,
       "sub_domain":"6.1 Explain how automation impacts network management",
       "practice_test_id":3,
       "question":"Which is a popular scripting language used to automate changes that also allows for easy readability of the script?",
       "choice_a":"C++",
       "choice_b":"Python",
       "choice_c":"C#",
       "choice_d":"JSON",
       "correct_answer":"B",
       "explanation":"The Python scripting language has been adopted as the most popular language to automate changes in a network. This is mainly due to its support by major providers and easy syntax. Administrators can easily focus on the task at hand and not the nuances of the language. C++ and C# are much more involved because they are considered programming languages and not scripting languages. JavaScript Object Notation (JSON) is not a programming or scripting language; it's a data storage/transfer method used with programming and scripting languages."
    },
    {
       "id":1194,
       "topic_id":6,
       "sub_domain":"6.2 Compare traditional networks with controller-based networking",
       "practice_test_id":3,
       "question":"Which tool allows you to manage all of your Cisco device licensing needs through a single user interface?",
       "choice_a":"Cisco SMART net",
       "choice_b":"Cisco License Manager",
       "choice_c":"Cisco Network Assistant",
       "choice_d":"Cisco Prime Infrastructure",
       "correct_answer":"B",
       "explanation":"The Cisco License Manager (CLM) can be installed on Windows, Solaris, or Linux. It allows for discovery of Cisco devices and inventory of Cisco device licenses and connects to Cisco for access to current and new licenses purchased. The CLM allows for management of the software activation process through its user interface."
    },
    {
       "id":1195,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":3,
       "question":"Which is a protocol found on the overlay of an SDN?",
       "choice_a":"VXLAN",
       "choice_b":"OSPF",
       "choice_c":"Open Flow",
       "choice_d":"JSON",
       "correct_answer":"A",
       "explanation":"The Virtual Extensible LAN (VXLAN) protocol is commonly found on the overlay of a software-defined network (SDN). It allows for the transport of layer 2 frames over a layer 3 network. The Open Shortest Path First (OSPF) protocol is a layer 3 networking protocol commonly found on the underlay of SDN. Open Flow is a protocol that is used for the programming of network devices from the Southbound interface of the SDN controller. JavaScript Object Notation (JSON) is a data-interchange format used with many different SDN controllers."
    },
    {
       "id":1196,
       "topic_id":6,
       "sub_domain":"6.3 Describe controller-based and software defined architectures (overlay, underlay, and fabric)",
       "practice_test_id":3,
       "question":"Which is commonly used with the northbound interface of an SDN controller?",
       "choice_a":"CLOS",
       "choice_b":"OpenFlow",
       "choice_c":"Python",
       "choice_d":"NETCONF",
       "correct_answer":"C",
       "explanation":"The Python programming language is commonly used with the Northbound interface of a software-defined network (SDN) controller. The term <italic>CLOS</italic> describes Spine/Leaf network switching. The Open Flow and NETCONF protocols are commonly used with the Southbound interface of an SDN controller for the programming of SDN devices."
    },
    {
       "id":1197,
       "topic_id":6,
       "sub_domain":"6.4 Compare traditional campus device management with Cisco DNA Center enabled device management",
       "practice_test_id":3,
       "question":"You need to configure some default servers for DNS, AAA, and NTP for device provisioning. Which section in Cisco DNA Center will allow you to configure these defaults?",
       "choice_a":"Design",
       "choice_b":"Discovery",
       "choice_c":"Provision",
       "choice_d":"Platform",
       "correct_answer":"A",
       "explanation":"The Design section allows you to create a hierarchical design of the network with a graphical map. In addition, the Design section also allows you to specify the default servers that will be applied after discovery. The Discovery tool is not a major section of Cisco DNA Center, and it is not used to specify server defaults. The Provision section allows you to view and edit the discovered inventory of network devices. The Policy section allows you to create policies based upon applications, traffic, and IP-based access control lists (ACLs), just to name a few. The Platform section allows you to perform upgrades and search the API catalog."
    },
    {
       "id":1198,
       "topic_id":6,
       "sub_domain":"6.5 Describe characteristics of REST-based APIs (CRUD, HTTP verbs, and data encoding)",
       "practice_test_id":3,
       "question":"Which REST-based HTTP verb is used to update or replace data via the API?",
       "choice_a":"POST",
       "choice_b":"GET",
       "choice_c":"UPDATE",
       "choice_d":"PUT",
       "correct_answer":"D",
       "explanation":"The REST-based HTTP verb PUT is used to update or replace data via the API. The POST verb is used to create data. The GET verb is used to read data. The UPDATE verb does not exist within the CREATE, READ, UPDATE, DELETE (CRUD) framework; therefore, it is an invalid answer."
    },
    {
       "id":1199,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":3,
       "question":"You just finished creating a script that will interface with Cisco DNA Center via the REST-based API. When you run the script, you receive a 400 status code. What is wrong?",
       "choice_a":"Nothing, it is okay.",
       "choice_b":"Forbidden request.",
       "choice_c":"Bad request.",
       "choice_d":"Internal server error.",
       "correct_answer":"C",
       "explanation":"A 400 status code from the REST-based service means that it is a bad request. The data being sent to the REST-based service could be wrong or wrongly formatted. A 200 status code is used to signify that everything is okay and nothing is wrong. A forbidden request will return a 403 status code. On rare occasions, you may receive a 500 status code; this signifies that there is an internal server error."
    },
    {
       "id":1200,
       "topic_id":6,
       "sub_domain":"6.6 Recognize the capabilities of configuration management mechanisms Puppet, Chef, and Ansible",
       "practice_test_id":3,
       "question":"Which programming language is used for creating a Chef recipe to apply configuration management?",
       "choice_a":"Ruby",
       "choice_b":"Python",
       "choice_c":"PowerShell",
       "choice_d":"YAML",
       "correct_answer":"A",
       "explanation":"The Chef configuration management utility uses Ruby as its reference language. Python is used by Ansible as its reference language. PowerShell is used by Microsoft's Desired State Configuration (DSC) as its reference language. YAML Ain't Markup Language (YAML) is not a reference language; it's a mechanism to transfer data and store data in a structured manner."
    },
    {
       "id":1201,
       "topic_id":6,
       "sub_domain":"6.7 Interpret JSON encoded data",
       "practice_test_id":3,
       "question":"Which statement best describes how the JSON file format starts and ends?",
       "choice_a":"A JSON file starts with double quotes and ends with double quotes.",
       "choice_b":"A JSON file starts with single quotes and ends with single quotes.",
       "choice_c":"A JSON file starts with square brackets and ends with square brackets.",
       "choice_d":"A JSON file starts with curly brackets and ends with curly brackets.",
       "correct_answer":"D",
       "explanation":"A JavaScript Object Notation (JSON) file starts with curly brackets and ends with curly brackets, also called braces. Inside of the curly brackets, the keys and values are encapsulated in double quotes. Single quotes are not used for formatting purposes with JSON. Square brackets can signify that more than one key-value pair exists for a specific item."
    }
  ]